var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
const Link = ReactRouterDOM.Link;
const Route = ReactRouterDOM.Route;
const HashRouter = ReactRouterDOM.HashRouter;
const Component = React.Component;
const useState = React.useState;
const useEffect = React.useEffect;
const createRef = React.createRef;
const useRef = React.useRef;
const forwardRef = React.forwardRef;
const useHistory = ReactRouterDOM.useHistory;
let apiURL = window.location.origin + "/api/";
let language = "en";
let words = {};
const settings = {};
const Call = {};
const App = (props) => {
    const [rr, setRefresh] = useState();
    const [inited, setInited] = useState(false);
    const [error, setError] = useState("");
    const [logged, setLogged] = useState(false);
    let initStarted = false;
    if (typeof SysRanger === 'undefined') {
        SysRanger = {};
    }
    else {
        language = SysRanger.language;
    }
    Dialog.init();
    Info.init();
    TT.init();
    function setLanguage(lang) {
        console.log("App.setLanguage:" + lang);
        language = lang;
        SysRanger.language = language;
        setInited(false);
    }
    Call["setLanguage"] = setLanguage;
    Call["refresh"] = refresh;
    function refresh() {
        setRefresh(Utils.timeStamp);
    }
    function initCompleted(completed, err) {
        if (!completed) {
            setError(err);
            return;
        }
        setInited(true);
    }
    function preApp() {
        return (React.createElement(RemoteLoginSystem, null));
    }
    ;
    if (error.length > 0) {
        console.log(error);
        return (React.createElement("div", null, error));
    }
    if (SysRanger.remote) {
        apiURL = SysRanger.remoteAppURL;
        User.super = User.admin = false;
        if (SysRanger.token.length < 10) {
            return preApp();
        }
    }
    if (SysRanger.demo) {
        User.id = 2;
        User.name = "guest";
        User.super = User.admin = false;
        User.type = 1;
    }
    else if (!logged) {
        return (React.createElement(Login, { listener: loginCompleted }));
    }
    Data.admin = User.admin;
    Data.super = User.super;
    if (!inited) {
        InitializeApp(initCompleted);
        License.check();
        return React.createElement("div", null, "...");
    }
    let homePage = Home;
    if (SysRanger.remote && SysRanger.companyCount > 1) {
        homePage = RemoteDashboard;
    }
    function loginCompleted(logged) {
        setLogged(logged);
    }
    ;
    let pw = "calc(100% - 390px)";
    if (Data.hideMenu) {
        pw = "calc(100% - 90px)";
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(Menu, { refresh: rr }),
        React.createElement("div", { style: { width: pw, float: "left" } },
            React.createElement(HashRouter, null,
                React.createElement(ReactRouterDOM.Switch, null,
                    React.createElement(Route, { path: "/", exact: true, component: Home }),
                    React.createElement(Route, { path: "/home", component: Home }),
                    React.createElement(Route, { path: "/dashboard/:type", component: Home }),
                    React.createElement(Route, { path: "/view/:type/:id", component: DashboardView }),
                    React.createElement(Route, { path: "/login", component: homePage }),
                    React.createElement(Route, { path: "/register", component: homePage }),
                    React.createElement(Route, { path: "/forgotpassword", component: homePage }),
                    React.createElement(Route, { path: "/reset", component: homePage }),
                    React.createElement(Route, { path: "/resetpassword/:hash", component: homePage }),
                    React.createElement(Route, { path: "/companies", component: RemoteDashboard }),
                    React.createElement(Route, { path: "/units", component: UnitListTable }),
                    React.createElement(Route, { path: "/systems", component: Systems }),
                    React.createElement(Route, { path: "/groups", component: Groups }),
                    React.createElement(Route, { path: "/add-new-system", component: AddNewSystem }),
                    React.createElement(Route, { path: "/add-new-system-to-group/:gid", component: AddNewSystem }),
                    React.createElement(Route, { path: "/remove-system/:id", component: RemoveSystem }),
                    React.createElement(Route, { path: "/add-new-group", component: AddNewGroup }),
                    React.createElement(Route, { path: "/group/:id", component: Group }),
                    React.createElement(Route, { path: "/add-new-unit/:sid", component: AddNewUnit }),
                    React.createElement(Route, { path: "/mails", component: MailsPage }),
                    React.createElement(Route, { path: "/applicationlogs", component: ServerLogs }),
                    React.createElement(Route, { path: "/probelogs/:id", component: ProbeLogs }),
                    React.createElement(Route, { path: "/passwords", component: Passwords }),
                    React.createElement(Route, { path: "/users", component: Users }),
                    React.createElement(Route, { path: "/userdetails/:id", component: UserDetails }),
                    React.createElement(Route, { path: "/user", component: UserPage }),
                    React.createElement(Route, { path: "/sapreportsettings", component: SAPReportSettingsPage }),
                    React.createElement(Route, { path: "/definitions", component: Definitions }),
                    React.createElement(Route, { path: "/oslist", component: OSListPage }),
                    React.createElement(Route, { path: "/system/:sid", component: System }),
                    React.createElement(Route, { path: "/add-host-to-system/:sid", component: SystemsAddNewHost }),
                    React.createElement(Route, { path: "/add-host-to-system-details/:sid/:hid", component: SystemsAddNewHostDetails }),
                    React.createElement(Route, { path: "/probedetails/:id", component: ProbeDetails }),
                    React.createElement(Route, { path: "/add-new-database/:sid/:hostID/:hostName", component: AddNewDatabase }),
                    React.createElement(Route, { path: "/databases", component: DatabaseList }),
                    React.createElement(Route, { path: "/database/:id", component: DatabaseDetails }),
                    React.createElement(Route, { path: "/database-browser/:id", component: DatabaseBrowser }),
                    React.createElement(Route, { path: "/removedatabase/:id", component: RemoveDatabase }),
                    React.createElement(Route, { path: "/database-components/:id", component: DatabaseComponentsPage }),
                    React.createElement(Route, { path: "/databaseselectquery/:dbid", component: SelectQueryExecuter }),
                    React.createElement(Route, { path: "/database-configuration-parameters/:id", component: DBDetailsHanaConfigurationParametersPage }),
                    React.createElement(Route, { path: "/remove-unit-page/:id", component: RemoveUnit }),
                    React.createElement(Route, { path: "/utils", component: UtilityPage }),
                    React.createElement(Route, { path: "/about", component: About }),
                    React.createElement(Route, { path: "/portscanner", component: PortScanner }),
                    React.createElement(Route, { path: "/networkscanner", component: NetworkScanner }),
                    React.createElement(Route, { path: "/unit-details/:id", component: UnitDetails }),
                    React.createElement(Route, { path: "/host/:id", component: UnitDetails }),
                    React.createElement(Route, { path: "/unit-cpu-details/:id", component: UnitCPUMemoryDetails }),
                    React.createElement(Route, { path: "/unit-file-browser/:id/:mount", component: FileBrowserPage }),
                    React.createElement(Route, { path: "/remove-host-from-system/:hostid/:sid", component: RemoveHostFromSystem }),
                    React.createElement(Route, { path: "/availability-history/:types/:id", component: AvailabilityHistoryPage }),
                    React.createElement(Route, { path: "/port/:hostid/:port", component: HostPort }),
                    React.createElement(Route, { path: "/inventory", component: Inventory }),
                    React.createElement(Route, { path: "/alertreport", component: AlertReport }),
                    React.createElement(Route, { path: "/sapreport", component: SAPReport }),
                    React.createElement(Route, { path: "/company", component: Company }),
                    React.createElement(Route, { path: "/settings", component: SettingsPage }),
                    React.createElement(Route, { path: "/mailsettings", component: MailSettings }),
                    React.createElement(Route, { path: "/addsmtp", component: AddSmtp }),
                    React.createElement(Route, { path: "/editsmtp", component: SmtpEdit }),
                    React.createElement(Route, { path: "/alertsreceiver", component: AlertReceiver }),
                    React.createElement(Route, { path: "/alertthresholds", component: AlertThresholdsPage }),
                    React.createElement(Route, { path: "/hostalertsettings", component: HostAlertSettings }),
                    React.createElement(Route, { path: "/smslist", component: SMSPage }),
                    React.createElement(Route, { path: "/recyclebin", component: RecycleBin }),
                    React.createElement(Route, { path: "/remotemonitoring", component: RemoteMonitoringSettings }),
                    React.createElement(Route, { path: "/screenshots", component: Screenshots }),
                    React.createElement(Route, { path: "/instances", component: InstanceListPage }),
                    React.createElement(Route, { path: "/addinstance/:id/:sid/:host", component: AddInstance }),
                    React.createElement(Route, { path: "/removeinstance/:id", component: RemoveInstance }),
                    React.createElement(Route, { path: "/instance/:id", component: InstanceDetails }),
                    React.createElement(Route, { path: "/instanceports/:id", component: InstancePortsPage }),
                    React.createElement(Route, { path: "/instanceprocesses/:id", component: InstanceProcessesPage }),
                    React.createElement(Route, { path: "/instanceaccesspoints/:id", component: InstanceAccessPointsPage }),
                    React.createElement(Route, { path: "/instancealerts/:id", component: InstanceAlertsPage }),
                    React.createElement(Route, { path: "/instancesystemlogs/:id", component: InstanceSystemLogsPage }),
                    React.createElement(Route, { path: "/instancequeuestatistic/:id", component: InstanceQueueStatisticPage }),
                    React.createElement(Route, { path: "/instancegatewayclients/:id", component: InstanceGatewayClientsPage }),
                    React.createElement(Route, { path: "/instanceworkprocesses/:id", component: InstanceABAPWPTablePage }),
                    React.createElement(Route, { path: "/instanceproperties/:id", component: InstancePropertiesPage }),
                    React.createElement(Route, { path: "/instanceenqueuestatistic/:id", component: InstanceEnqueueStatisticPage }),
                    React.createElement(Route, { path: "/instance_set_sid/:id", component: InstanceSetSIDPage }),
                    React.createElement(Route, { path: "/instancedevelopertraces/:id", component: InstanceDeveloperTracesPage }),
                    React.createElement(Route, { path: "/instanceanalyselogfiles/:id", component: InstanceAnalyseLogFiles }),
                    React.createElement(Route, { path: "/instancejavacomponents/:id", component: JInstanceComponentsPage }),
                    React.createElement(Route, { path: "/instancejavaprocesses/:id", component: JInstanceProcessesPage }),
                    React.createElement(Route, { path: "/instancejavaheap/:id", component: JInstanceHeapInformationPage }),
                    React.createElement(Route, { path: "/instancejavacaches/:id", component: JInstanceCachesPage }),
                    React.createElement(Route, { path: "/instancejavathreads/:id", component: JInstanceThreadsPage }),
                    React.createElement(Route, { path: "/instance-icm/:id", component: InstanceICM }),
                    React.createElement(Route, { path: "/instance-icm-connections/:id", component: InstanceICMConnectionsPage }),
                    React.createElement(Route, { path: "/instance-icm-threads/:id", component: InstanceICMThreadsPage }),
                    React.createElement(Route, { path: "/instance-icm-browser/:id", component: InstanceICMBrowser }),
                    React.createElement(Route, { path: "/instance-icm-cache/:id", component: InstanceICMCachePage }),
                    React.createElement(Route, { path: "/instance-icm-proxy-connections/:id", component: InstanceICMProxyConnectionsPage }),
                    React.createElement(Route, { path: "/systemauditrfc/:sid", component: SystemAuditRFCPage }),
                    React.createElement(Route, { path: "/sapauditalertrules/:sid", component: SAPAuditAlertRulesPage }),
                    React.createElement(Route, { path: "/instanceaudit/:iid", component: InstanceAuditPage }),
                    React.createElement(Route, { path: "/instanceconfigfiles/:id", component: InstanceConfigFilesPage }),
                    React.createElement(Route, { path: "/saprfcbrowser/:id", component: RFCBrowserPage }),
                    React.createElement(Route, { path: "/abapdashboard/:id", component: ABAPDashboard }),
                    React.createElement(Route, { path: "/hostdashboard/:id/:sid", component: HostDashboard }),
                    React.createElement(Route, { path: "/abap-runtime-errors/:dbid", component: ABAPRuntimeErrors }),
                    React.createElement(Route, { path: "/hanadashboard/:dbid/:hid", component: HanaDashboard }),
                    React.createElement(Route, { path: "/hanabackups/:dbid", component: DBHanaBackups }),
                    React.createElement(Route, { path: "/hana-services/:dbid/:dbname", component: DBHanaServicesPage }),
                    React.createElement(Route, { path: "/hana-active-statements/:dbid/:dbname", component: DBHanaActiveStatementsPage }),
                    React.createElement(Route, { path: "/hana-system-overview/:dbid/:dbname", component: DBHanaSystemOverviewPage }),
                    React.createElement(Route, { path: "/hana-backup-summary/:dbid/:dbname", component: DBHanaBackupSummaryPage }),
                    React.createElement(Route, { path: "/hana-licenses/:dbid/:dbname", component: DBHanaLicensesPage }),
                    React.createElement(Route, { path: "/hana-connections/:dbid/:dbname", component: DBHanaConnectionsPage }),
                    React.createElement(Route, { path: "/hana-transactions/:dbid/:dbname", component: DBHanaTransactionsPage }),
                    React.createElement(Route, { path: "/hana-tasks/:dbid/:dbname", component: DBHanaTasksPage }),
                    React.createElement(Route, { path: "/hana-table-locks/:dbid/:dbname", component: DBHanaTableLocksPage }),
                    React.createElement(Route, { path: "/hana-alert-checks/:dbid/:dbname", component: DBHanaAlertChecksPage }),
                    React.createElement(Route, { path: "/hana-current-alerts/:dbid/:dbname", component: DBHanaCurrentAlertsPage }),
                    React.createElement(Route, { path: "/hana-alert-history/:dbid/:dbname", component: DBHanaAlertHistoryPage }),
                    React.createElement(Route, { path: "/instancelogin/:id", component: InstanceAuthorizationPage }),
                    React.createElement(Route, { path: "/hostlogin/:id", component: HostLoginPage }),
                    React.createElement(Route, { path: "/sapscanner", component: SAPScannerPage }),
                    React.createElement(Route, { path: "/alerts", component: HostAlerts }),
                    React.createElement(Route, { path: "/applicationsettings", component: ApplicationSettings }),
                    React.createElement(Route, { path: "/status", component: ApplicationStatus }),
                    React.createElement(Route, { path: "/soaptest", component: SOAPTest }),
                    React.createElement(Route, { path: "/topology", component: TopologyGraph }),
                    React.createElement(Route, { path: "/pingmatrix", component: PingMatrixPage }),
                    React.createElement(Route, { path: "/licensemanager", component: LicenseManager }),
                    React.createElement(Route, { path: "/vcenter/:hostid", component: VCenterPage }),
                    React.createElement(Route, { component: RouteNotFound }))))));
};
let Alerts = {};
const AlertsPanel = (props) => {
    const type = props.type;
    const listener = props.listener;
    const [refreshed, refresh] = useState(0);
    const fn = { exited: false, closed: useRef(false) };
    const filtered = props.filtered;
    fn.exited = fn.closed.current;
    function cleanUp() {
        fn.exited = true;
        fn.closed.current = true;
    }
    useEffect(() => { fn.closed.current = false; updated(); return cleanUp; }, [type, props.params && props.params.update]);
    function updated() {
        console.log("Alerts.Updated:" + Utils.timeStamp());
        console.log(props.params);
        Utils.setState(fn, refresh, Utils.timeStamp());
    }
    function remove(row, data) {
        const message = t("Are you sure you want to remove ?") + "\n\n" + row["m"];
        if (fn.exited)
            return;
        let pdo = Utils.postDataOptions({ op: "remove", hash: row.hash, id: row.id });
        fetch(apiURL + "alerts", pdo).then(res => res.json()).then((result) => {
            if (result.success) {
                Utils.setState(fn, refresh, Utils.timeStamp());
                listener();
            }
            else {
                Info.error(result.error);
            }
        }, (error) => {
            Info.error(error.message);
        });
    }
    function ignore(row, data) {
        const message = t("Are you sure you want to ignore ?") + "\n\n" + row["m"];
        if (!confirm(message))
            return;
        if (fn.exited)
            return;
        let pdo = Utils.postDataOptions({ op: "ignore", hash: row.hash, id: row.id });
        fetch(apiURL + "alerts", pdo).then(res => res.json()).then((result) => {
            if (result.success) {
                Utils.setState(fn, refresh, Utils.timeStamp());
                listener();
            }
            else {
                Info.error(result.error);
            }
        }, (error) => {
            Info.error(error.message);
        });
    }
    function contextMenuAlerts(e, row, data) {
        const content = React.createElement("ul", { className: "lipad20" },
            React.createElement("li", { onClick: () => { ignore(row, data); ContextMenu.close(); } }, "Ignore"),
            React.createElement("li", { onClick: () => { remove(row, data); ContextMenu.close(); } }, "Remove"));
        ContextMenu.show({ event: e, content: content, closeListener: data.closeListener });
    }
    function contextMenuIgnoreds(e, row, data) {
        const content = React.createElement("ul", null,
            React.createElement("li", { onClick: () => { remove(row, data); ContextMenu.close(); } }, "Remove"));
        ContextMenu.show({ event: e, content: content, closeListener: data.closeListener });
    }
    function showDetails(alert) {
        if (fn.exited)
            return;
        const div = React.createElement("div", { style: { textAlign: "left", width: "100%" } },
            React.createElement("table", { style: { width: "100%" }, className: "informationtable" },
                React.createElement("tbody", null,
                    React.createElement("tr", null,
                        React.createElement("td", { width: "100" }, "ID"),
                        React.createElement("td", null, alert.id)),
                    React.createElement("tr", null,
                        React.createElement("td", null, "Type"),
                        React.createElement("td", null, Utils.alertTypeName(alert.type))),
                    React.createElement("tr", null,
                        React.createElement("td", null, "Code"),
                        React.createElement("td", null, alert.code)),
                    React.createElement("tr", null,
                        React.createElement("td", null, "SID"),
                        React.createElement("td", null, alert.sid)),
                    React.createElement("tr", null,
                        React.createElement("td", null, "SCode"),
                        React.createElement("td", null, alert.scode)),
                    React.createElement("tr", null,
                        React.createElement("td", null, "Host ID"),
                        React.createElement("td", null, alert.hostid)),
                    React.createElement("tr", null,
                        React.createElement("td", null, "Host Name"),
                        React.createElement("td", null, alert.hostname)),
                    React.createElement("tr", null,
                        React.createElement("td", null, "IP"),
                        React.createElement("td", null, alert.hostip)),
                    React.createElement("tr", null,
                        React.createElement("td", null, "Instance"),
                        React.createElement("td", null, alert.inr)),
                    React.createElement("tr", null,
                        React.createElement("td", null, "DBID"),
                        React.createElement("td", null, alert.dbid)),
                    React.createElement("tr", null,
                        React.createElement("td", null, "Port"),
                        React.createElement("td", null, alert.port)),
                    React.createElement("tr", null,
                        React.createElement("td", null, "Message"),
                        React.createElement("td", null, alert.message)),
                    React.createElement("tr", null,
                        React.createElement("td", null, "Details"),
                        React.createElement("td", null, alert.details)),
                    React.createElement("tr", null,
                        React.createElement("td", null, "Info"),
                        React.createElement("td", null, alert.info)),
                    React.createElement("tr", null,
                        React.createElement("td", null, "Exception"),
                        React.createElement("td", null, Utils.nl2List(alert.exceptionmessage))),
                    React.createElement("tr", null,
                        React.createElement("td", null, "Stack Trace"),
                        React.createElement("td", null, Utils.nl2List(alert.stacktrace))),
                    React.createElement("tr", null,
                        React.createElement("td", null, "Trace File"),
                        React.createElement("td", null, alert.tracefile)),
                    React.createElement("tr", null,
                        React.createElement("td", null, "Created"),
                        React.createElement("td", null, Utils.toDate(alert.createtime))),
                    React.createElement("tr", null,
                        React.createElement("td", null, "Event time"),
                        React.createElement("td", null, Utils.toDate(alert.eventtime))),
                    React.createElement("tr", null,
                        React.createElement("td", null, "Status changed"),
                        React.createElement("td", null, Utils.toDate(alert.statuschangetime))),
                    React.createElement("tr", null,
                        React.createElement("td", null, "Mail sent"),
                        React.createElement("td", null, Utils.toDate(alert.mailsent))),
                    React.createElement("tr", null,
                        React.createElement("td", null, "Mail created"),
                        React.createElement("td", null, Utils.toDate(alert.mailcreated))),
                    React.createElement("tr", null,
                        React.createElement("td", null, "SMS"),
                        React.createElement("td", null, Utils.toDate(alert.smssent))),
                    React.createElement("tr", null,
                        React.createElement("td", null, "Notified"),
                        React.createElement("td", null, Utils.toDate(alert.notified))),
                    React.createElement("tr", null,
                        React.createElement("td", null, "Ignored"),
                        React.createElement("td", null, Utils.toDate(alert.ignored))),
                    React.createElement("tr", null,
                        React.createElement("td", null, "Hash"),
                        React.createElement("td", null, alert.hash)),
                    React.createElement("tr", null,
                        React.createElement("td", null, "Last activity"),
                        React.createElement("td", null, Utils.toDate(alert.lastactivity))))));
        Dialog.show({ content: div, render: true });
    }
    ;
    function details(row, data) {
        if (fn.exited)
            return;
        let pdo = Utils.postDataOptions({ op: "details", id: row.id });
        fetch(apiURL + "alerts", pdo).then(res => res.json()).then((result) => {
            if (result.success && result.alerts.length > 0) {
                showDetails(result.alerts[0]);
            }
            else {
                Info.error(result.error);
            }
        }, (error) => {
            Info.error(error.message);
        });
    }
    ;
    function hostClicked(row, data) {
    }
    ;
    function clearAlerts() {
        const message = t("Are you sure you want to clear all inactive alerts ?");
        if (!confirm(message))
            return;
        if (fn.closed.current)
            return;
        let pdo = Utils.postDataOptions({ op: "clear" });
        fetch(apiURL + "alerts", pdo).then(res => res.json()).then((result) => {
            if (result.success) {
                Utils.setState(fn, refresh, Utils.timeStamp());
                listener();
                Call.refresh();
            }
            else {
                Info.error(result.error);
            }
        }, (error) => {
            Info.error(error.message);
        });
    }
    function clearIgnored() {
        const message = t("Are you sure you want to clear all ignored alerts ?");
        if (!confirm(message))
            return;
        if (fn.closed.current)
            return;
        let pdo = Utils.postDataOptions({ op: "clear-ignoreds" });
        fetch(apiURL + "alerts", pdo).then(res => res.json()).then((result) => {
            if (result.success) {
                Utils.setState(fn, refresh, true);
                listener();
            }
            else {
                Info.error(result.error);
            }
        }, (error) => {
            Info.error(error.message);
        });
    }
    let ctx = null;
    if (type == "alerts") {
        ctx = contextMenuAlerts;
    }
    else if (type == "ignoreds") {
        ctx = contextMenuIgnoreds;
    }
    const vars = props.params || {};
    vars.op = type;
    function mailIcon(val) {
        if (val < 0)
            return React.createElement("img", { src: "/images/icons/ic_do_not_disturb_alt_24px.svg", type: "svg", style: { width: "20px", opacity: 0.4 } });
        if (val < 1)
            return "";
        return React.createElement("img", { src: "/images/icons/mail1.svg", type: "svg", style: { width: "20px" } });
    }
    function smsIcon(val) {
        if (val < 0)
            return React.createElement("img", { src: "/images/icons/ic_do_not_disturb_alt_24px.svg", type: "svg", style: { width: "20px", opacity: 0.4 } });
        if (val < 1)
            return "";
        return React.createElement("img", { src: "/images/icons/sms1.svg", type: "svg", style: { width: "20px" } });
    }
    function callIcon(val) {
        if (val < 0)
            return React.createElement("img", { src: "/images/icons/ic_do_not_disturb_alt_24px.svg", type: "svg", style: { width: "20px", opacity: 0.4 } });
        if (val < 1)
            return "";
        return React.createElement("img", { src: "/images/icons/ic_phone_24px.svg", type: "svg", style: { width: "20px" } });
    }
    function lastActivityColumnColor(row) {
        if (!row.ac)
            return Colors.text;
        return Utils.alertColor(row.t);
    }
    function lastActivity(row) {
        if (row.ac) {
            if (UserSettings.getBoolean("alert_show_active_seconds")) {
                return t("Active") + " (" + Utils.timePastShort(row.las) + ")";
            }
            return t("Active");
        }
        return Utils.minutesPast(row.las);
    }
    function groupNames(gids) {
        if (!gids)
            return "";
        let list = "";
        const parts = gids.split(",");
        for (let i = 0; i < parts.length; i++) {
            list += Data.groupCode(parts[i]) + ",";
        }
        return list;
    }
    function mailTooltip(row) {
        Request.send({
            url: apiURL + "notifications",
            params: { op: "alertmails", aid: row.id },
            success: (json) => {
                let list = "";
                for (let i = 0; i < json.rows.length; i++) {
                    list += json.rows[i].mail_to + "<br/>";
                }
                TT.show(list);
            }
        });
    }
    function smsTooltip(row) {
        Request.send({
            url: apiURL + "notifications",
            params: { op: "alertsms", aid: row.id },
            success: (json) => {
                let list = "";
                for (let i = 0; i < json.rows.length; i++) {
                    list += json.rows[i].phonenumber + "<br/>";
                }
                TT.show(list);
            }
        });
    }
    function callTooltip(row) {
        Request.send({
            url: apiURL + "notifications",
            params: { op: "alertcalls", aid: row.id },
            success: (json) => {
                let list = "";
                for (let i = 0; i < json.rows.length; i++) {
                    list += json.rows[i].phonenumber + "<br/>";
                }
                TT.show(list);
            }
        });
    }
    let tableData = {
        defaultSortField: "las",
        direction: "ascending",
        id: "alertable_" + type,
        update: refreshed,
        loader: {
            refresh: 5000,
            url: apiURL + "alerts",
            variables: vars,
            array: "alerts"
        },
        rowContextMenu: ctx,
        headers: [
            UserSettings.getBoolean("alerts_show_id") && { name: "ID", field: "id", pale: true },
            { name: "Type", field: "t", colorRule: (row) => Utils.alertColor(row.t), format: Utils.alertTypeName },
            { name: "GR", field: "gids", pale: true, rowFormat: (row) => groupNames(row.gids) },
            { name: "SID", field: "scode", pale: true },
            { name: "Host", field: "hn", color: Colors.text, filter: {}, onClick: (row, data) => { Utils.go(null, "#hostdashboard/" + row.hid + "/0"); }, removed: (row) => row.hex !== true },
            { name: "Message", field: "m", onClick: details, filter: {}, colorRule: (row) => Utils.alertColor(row.t), tooltip: (row) => row.m + "\n" + row.details + "\n" + row.info },
            { name: "Details", field: "details", showTooltip: true, showBox: true, pale: true, noCrop: true, filter: {}, tooltip: (row) => row.details + "\n" + row.info },
            { name: "INr", field: "nr", center: true, pale: true, onClick: (row, data) => { Utils.go(null, "#instance/" + row.inid); } },
            { name: "Event time", field: "et", format: Utils.toDate, width: "160px", pale: true, tooltip: (row) => Utils.toDate(row.et) },
            type == "removeds" && { name: "Last activity", field: "la", format: Utils.toDate, width: "80px", pale: true, formattedTooltip: true },
            type == "removeds" && { name: "Removed", field: "rm", format: Utils.toDate, width: "80px", pale: true, formattedTooltip: true },
            type == "removeds" && { name: "User", field: "rby", pale: true, filter: {} },
            type != "removeds" && {
                name: "Last activity",
                field: "las",
                rowFormat: lastActivity,
                width: "120px",
                tooltip: (row) => Utils.toDate(row.la),
                colorRule: (row) => lastActivityColumnColor(row)
            },
            { name: "M", field: "ms", title: "Mail", nopadding: true, format: mailIcon, width: "20px", pale: true, tooltipLoader: mailTooltip },
            { name: "S", field: "sms", title: "SMS", nopadding: true, format: smsIcon, width: "20px", pale: true, tooltipLoader: smsTooltip },
            { name: "C", field: "cas", title: "Call", nopadding: true, format: callIcon, width: "20px", pale: true, tooltipLoader: callTooltip },
            User.admin && type == "alerts" && { name: "Ignore", field: "id", onClick: ignore, width: "40px", icon: "ic_do_not_disturb_alt_24px.svg" },
            (User.admin && type == "alerts" || type == "ignoreds") && { name: "Remove", field: "id", onClick: remove, width: "40px", icon: "remove.svg" },
        ]
    };
    return (React.createElement("div", { id: "alerts_panel_" + type },
        type == "alerts" && User.admin && !filtered && React.createElement("a", { key: "button_clear_all_alerts", style: { float: "right", marginRight: "15px" }, onClick: clearAlerts }, t("Clear")),
        type == "ignoreds" && User.admin && !filtered && React.createElement("a", { key: "button_clear_all_ignored", style: { float: "right", marginRight: "15px" }, onClick: clearIgnored }, t("Clear")),
        React.createElement(Table, { key: "table_alerts_" + type + "_" + refreshed, data: tableData })));
};
const AlertReceiverPanel = (props) => {
    const fn = { closed: useRef(false) };
    const [info, setInfo] = useState(null);
    const [r, refresh] = useState(null);
    const inputSMSNumbers = useRef();
    const inputCallNumbers = useRef();
    const inputMailSender = useRef();
    const inputMailReceiver = useRef();
    const inputSMSHours = {};
    const inputCallHours = {};
    const GID = props.gid;
    function cleanUp() {
        fn.closed.current = true;
    }
    useEffect(() => { fn.closed.current = false; loadData(); return cleanUp; }, [GID]);
    function loadData() {
        if (fn.closed.current)
            return;
        Request.send({ caller: fn, url: apiURL + "alertsettings", params: { op: "getgrouptarget", gid: GID },
            success: (json) => {
                Utils.setState(fn, setInfo, json);
                Utils.setState(fn, refresh, Utils.timeStamp());
            }
        });
    }
    ;
    function update() {
        Request.send({
            caller: fn,
            url: apiURL + "alertsettings",
            params: {
                op: "setgrouptarget",
                gid: GID,
                from: inputMailSender.current.value,
                to: inputMailReceiver.current.value,
                sms: inputSMSNumbers.current.value,
                smshours: inputSMSHours.get(),
                call: inputCallNumbers.current.value,
                callhours: inputCallHours.get()
            },
            message: "Updated"
        });
    }
    ;
    function testMail() {
        Request.send({ caller: fn, url: apiURL + "smtpsettings", params: { op: "sendtestmessage" },
            message: "Successfull"
        });
    }
    function testSMSNumbers() {
        Request.send({ caller: fn, url: apiURL + "sms", params: { op: "testsms", numbers: inputSMSNumbers.current.value },
            success: (json) => {
                for (var i = 0; i < json.sms.length; i++) {
                    const sms = json.sms[i];
                    if (sms.error) {
                        Info.error(sms.number + ":" + sms.error);
                    }
                    else {
                        Info.success(sms.number + " SMS OK");
                    }
                }
            }
        });
    }
    function testCallNumbers() {
        Request.send({ caller: fn, url: apiURL + "sms", params: { op: "testcall", numbers: inputCallNumbers.current.value },
            success: (json) => {
                for (var i = 0; i < json.calls.length; i++) {
                    const call = json.calls[i];
                    if (call.error) {
                        Info.error(call.number + ":" + call.error);
                    }
                    else {
                        Info.success(call.number + " Call OK");
                    }
                }
            }
        });
    }
    console.log(info);
    return (React.createElement("div", { id: 'panel_alert_receiver' },
        React.createElement("span", null, t("Please provide mail address and phone numbers to be notified for alerts.")),
        React.createElement("span", null, t(" You can define multiple values using comma(,) between.")),
        React.createElement("span", null, t(" You can define hours(0-24) for receiving alerts. You will not be disturbed outside this range.")),
        React.createElement("table", { className: "informationtable" },
            React.createElement("thead", null,
                React.createElement("tr", null,
                    React.createElement("td", { width: "120" }),
                    React.createElement("td", { width: "400" }),
                    React.createElement("td", { width: "120" }),
                    React.createElement("td", { width: "90" }),
                    React.createElement("td", { width: "90" }),
                    React.createElement("td", { width: "60" }))),
            React.createElement("tbody", null,
                React.createElement("tr", null,
                    React.createElement("td", null, "Group"),
                    React.createElement("td", null,
                        Data.groupCode(GID),
                        " ")),
                React.createElement("tr", null,
                    React.createElement("td", null, t("Mail From")),
                    React.createElement("td", null, info && React.createElement("input", { ref: inputMailSender, type: "text", placeholder: t("Sender mail address"), defaultValue: info.from })),
                    React.createElement("td", null)),
                React.createElement("tr", null,
                    React.createElement("td", null, t("Mail To")),
                    React.createElement("td", null, info && React.createElement("input", { ref: inputMailReceiver, type: "text", placeholder: t("Receiver mail address"), defaultValue: info.to })),
                    React.createElement("td", null),
                    React.createElement("td", null,
                        React.createElement("button", { onClick: testMail }, "Test"))),
                React.createElement("tr", null,
                    React.createElement("td", null, t("SMS Numbers")),
                    React.createElement("td", null, info && React.createElement("input", { ref: inputSMSNumbers, type: "text", placeholder: t("SMS Numbers"), defaultValue: info.sms })),
                    React.createElement("td", null, info && React.createElement(HourRange, { rf: inputSMSHours, hours: info.smshours, id: "hourssms" })),
                    React.createElement("td", null,
                        React.createElement("button", { onClick: testSMSNumbers }, "Test"))),
                React.createElement("tr", null,
                    React.createElement("td", null, t("Call Numbers")),
                    React.createElement("td", null, info && React.createElement("input", { ref: inputCallNumbers, type: "text", placeholder: t("Call Numbers"), defaultValue: info.call })),
                    React.createElement("td", null, info && React.createElement(HourRange, { rf: inputCallHours, hours: info.callhours, id: "hourscall" })),
                    React.createElement("td", null,
                        React.createElement("button", { onClick: testCallNumbers }, "Test"))),
                React.createElement("tr", null,
                    React.createElement("td", null, "  "),
                    React.createElement("td", null,
                        React.createElement("button", { onClick: update }, t("Update"))))))));
};
const AlertReceiver = (props) => {
    const fn = { closed: useRef(false) };
    const [groupSelectBox, setGroupSelectBox] = useState(null);
    const [GID, setGID] = useState(0);
    useEffect(() => { fn.closed.current = false; loadData(); return cleanUp; }, []);
    function loadData() {
        if (fn.closed.current)
            return;
        Request.send({
            url: apiURL + "groups",
            params: { op: "list" },
            success: groupsLoaded
        });
    }
    ;
    function groupsLoaded(json) {
        if (!json.success)
            return;
        const options = [];
        options.push({ val: 0, label: "Default" });
        for (let i = 0; i < json.groups.length; i++) {
            const group = json.groups[i];
            options.push({ val: group.id, label: group.cd + " " + group.nm });
        }
        const combo = React.createElement(Combo, { id: 'group_list', listener: groupChanged, options: options });
        Utils.setState(fn, setGroupSelectBox, combo);
    }
    ;
    function groupChanged(combo) {
        console.log(combo);
        Utils.setState(fn, setGID, combo.get());
    }
    function cleanUp() {
        fn.closed.current = true;
    }
    function back(e) {
        e.preventDefault();
        cleanUp();
        Utils.goBack(props.history, "/#alerts");
    }
    return (React.createElement("div", { id: 'page' },
        React.createElement(Header, { back: back, title: t("Set alert receiver") }),
        React.createElement("br", null),
        groupSelectBox,
        React.createElement("div", { className: "panel flexmargin" },
            React.createElement(AlertReceiverPanel, { key: "arp_" + GID, gid: GID }))));
};
const AlertData = {
    "43": { order: 900, type: "long", min: "-1", max: "200", name: "CPU 1 min usage (%)", description: "Create an alert when 1 minute of average CPU usage is above the specified threshold" },
    "10": { order: 1000, type: "long", min: "-1", max: "200", name: "CPU 5 min usage (%)", description: "Create an alert when 5 minutes of average CPU usage is above the specified threshold" },
    "31": { order: 2000, type: "long", min: "-1", max: "200", name: "CPU hourly usage (%)", description: "Create an alert when 1 hour of everage CPU usage is above the specified threshold" },
    "11": { order: 3000, type: "long", min: "-1", max: "200", name: "Physical memory usage (%)" },
    "30": { order: 4000, type: "long", min: "-1", max: "200", name: "Swap memory usage (%)" },
    "12": { order: 5000, type: "long", min: "-1", max: "200", name: "Disk usage (%)" },
    "25": { order: 6000, type: "long", min: "-1", max: "200", name: "Database data usage (%)", description: "" },
    "26": { order: 7000, type: "long", min: "-1", max: "200", name: "Database log usage (%)", description: "" },
    "14": { order: 100000, type: "long", min: "-1", max: "864000000", multiply: 60000, name: "Host is not reachable (minutes)", description: "Ping is not successfully sent to host" },
    "19": { order: 101000, type: "long", min: "-1", max: "864000000", multiply: 60000, name: "Probe disconnected (minutes)", description: "Probe is lost connection with monitoring server" },
    "13": { order: 102000, type: "long", min: "-1", max: "864000000", multiply: 60000, name: "Service stopped (minutes)" },
    "20": { order: 102100, type: "long", min: "-1", max: "864000000", multiply: 60000, name: "Service can not be started (minutes)", description: "When probe is not successfull to restart a specified service" },
    "24": { order: 103000, type: "long", min: "-1", max: "864000000", multiply: 60000, name: "Database system user disconnected (minutes)" },
    "28": { order: 104000, type: "long", min: "-1", max: "864000000", multiply: 60000, name: "Database tenant user disconnected (minutes)" },
    "16": { order: 105000, type: "long", min: "-1", max: "864000000", multiply: 60000, name: "SAP Instance status error (minutes)", description: "SAP Instance status error is thrown when one of the processes of the instance is not running" },
    "27": { order: 106000, type: "long", min: "-1", max: "864000000", multiply: 60000, name: "Database is not reachable (minutes)", description: "Database port is not reachable" },
    "29": { order: 107000, type: "long", min: "-1", max: "864000000", multiply: 60000, name: "Database status error (minutes)", description: "SAP informs the database is not running" },
    "32": { order: 108000, type: "long", min: "-1", max: "10000", name: "Host Uptime (days)", description: "Create an alert when a host is not restarted for specified amount of time" },
    "17": { order: 109000, type: "long", min: "-1", max: "864000000", multiply: 60000, name: "Host port is not reachable (minutes)", description: "If a specific port is added for checking and if the port is not reachable" },
    "18": { order: 110000, type: "long", min: "-1", max: "864000000", multiply: 60000, name: "Probe is rejected (minutes)", description: "Probe is trying to connect to monitoring server, but sending undefined host name" },
    "33": { order: 111000, type: "long", min: "-1", max: "864000000", multiply: 60000, name: "Disk is not writable (minutes)", description: "Create alert when probe is not successfull on write test." },
    "64": { order: 130000, type: "long", min: "-1", max: "200", name: "ABAP Workprocess stopped (%)", description: "Create alert when ratio of stopped workprocesses to all workprocesses exceeds specified threshold." },
    "38": { order: 131000, type: "long", min: "-1", max: "864000000", multiply: 60, name: "ABAP Workprocess execution duration (minutes)", description: "Create an alert when a job takes too much time." },
    "39": { order: 132000, type: "long", min: "-1", max: "864000000", multiply: 60000, name: "ABAP Workprocess queue is full (minutes)", description: "Create alert when there is no free workprocess left in a group (DIA,BTC,UPD...)" },
    "40": { order: 133000, type: "long", min: "-1000", max: "1000", name: "OS Support remaining months", description: "Create alert when the operating system's official extended support end date approaches" },
    "41": { order: 200000, type: "long", min: "-1", max: "864000000", multiply: 60000, name: "vCenter Disconnection(minutes)", description: "Create alert when connection between vCenter is lost." },
    "42": { order: 210000, type: "long", min: "-1", max: "864000000", multiply: 60000, name: "Scheduled task failed(minutes)", description: "Create alert when a specific scheduled task is failed." },
    "44": { order: 500000, type: "long", min: "-1", max: "864000000", multiply: 60000, name: "Old server version(minutes)", description: "Create alert when there is a new server update available." },
    "45": { order: 501000, type: "long", min: "-1", max: "864000000", multiply: 60000, name: "Old probe version (minutes)", description: "Create alert when there is a new probe update available." },
    "47": { order: 600000, type: "long", min: "-1", max: "864000000", multiply: 60000, name: "RFC is not connected (minutes)", description: "Create alert when RFC connection to sap system is lost." },
    "49": { order: 600010, type: "long", min: "-1", max: "1", name: "SAP-Cancelled non-periodic sap job" },
    "50": { order: 600020, type: "long", min: "-1", max: "1", name: "SAP-Cannot read sm37 jobs" },
    "51": { order: 600030, type: "long", min: "-1", max: "864000000", multiply: 60, name: "SAP-Max job excecution time (minutes)" },
    "52": { order: 600040, type: "long", min: "-1", max: "1", name: "SAP-Overlapped jobs" },
    "53": { order: 600050, type: "long", min: "-1", max: "864000000", multiply: 60, name: "SAP-Job delay (minutes)" },
    "54": { order: 600060, type: "long", min: "-1", max: "200", name: "SAP periodic jobs daily cancel rate (%)" },
    "55": { order: 600070, type: "long", min: "-1", max: "100000", name: "SAP-Cancelled job count" },
    "56": { order: 600080, type: "long", min: "-1", max: "100000", name: "SAP-ABAP daily runtime error count" },
    "57": { order: 600200, type: "long", min: "-1", max: "864000000", multiply: 60000, name: "Cannot check ICM via RFC (minutes)" },
    "58": { order: 600201, type: "long", min: "-1", max: "864000000", multiply: 60000, name: "ICM is not running (minutes)" },
    "59": { order: 600202, type: "long", min: "-1", max: "100000", name: "SAP-Mail error count" },
    "60": { order: 600204, type: "long", min: "-1", max: "100000", name: "SAP-Daily update error count" },
    "71": { order: 600304, type: "long", min: "-1", max: "864000000", multiply: 60000 },
    "72": { order: 600304, type: "long", min: "-1", max: "864000000", multiply: 60000 },
    "73": { order: 600304, type: "long", min: "-1", max: "864000000", multiply: 60000 },
    "74": { order: 600304, type: "long", min: "-1", max: "864000000", multiply: 60000 },
    "75": { order: 600304, type: "long", min: "-1", max: "864000000", multiply: 60000 },
    "76": { order: 600304, type: "long", min: "-1", max: "864000000", multiply: 60000 },
    "90": { order: 600400, type: "long", min: "-1", max: "864000000", multiply: 60 },
    "91": { order: 600401, type: "long", min: "-1", max: "864000000", multiply: 60 },
    "92": { order: 600402, type: "long", min: "-1", max: "864000000", multiply: 60 },
    "93": { order: 600403, type: "long", min: "-1", max: "864000000", multiply: 60 },
    "94": { order: 600404, type: "long", min: "-1", max: "864000000", multiply: 60 },
    "95": { order: 600405, type: "long", min: "-1", max: "864000000", multiply: 60 },
    "96": { order: 600406, type: "long", min: "-1", max: "864000000", multiply: 60 },
    "220": { order: 700000, type: "long", min: "-1", max: "864000000", multiply: 60000 },
    "221": { order: 700001, type: "long", min: "-1", max: "864000000", multiply: 60000 },
};
const AlertThresholds = (props) => {
    const [divDetails, setDivDetails] = useState(null);
    const fn = { closed: useRef(false) };
    const [refreshing, setRefreshing] = useState(1);
    function cleanUp() {
        fn.closed.current = true;
    }
    function back(e) { e.preventDefault(); cleanUp(); Utils.goBack(props.history, "/#alertsettings"); }
    useEffect(() => { fn.closed.current = false; loadData(); return cleanUp; }, [refreshing]);
    function loadData() {
        if (fn.closed.current)
            return;
        console.log("load Data");
        const pdo = Utils.postDataOptions({ op: "list" });
        fetch(apiURL + "alertsettings", pdo).then(res => res.json()).then((result) => {
            Utils.setState(fn, setDivDetails, parse(result));
        }, (error) => {
            Utils.setState(fn, setDivDetails, Utils.error(error.message));
        });
    }
    ;
    function update(params) {
        if (fn.closed.current)
            return;
        const values = [
            document.getElementById("input_" + params.ikey + "_info").value,
            document.getElementById("input_" + params.ikey + "_warning").value,
            document.getElementById("input_" + params.ikey + "_critical").value,
            document.getElementById("input_" + params.ikey + "_fatal").value
        ];
        for (let i = 0; i < values.length; i++) {
            if (params.multiply && values[i] > 0) {
                values[i] *= params.multiply;
            }
        }
        const pdo = Utils.postDataOptions({ op: "setthresholds", code: params.code, type: params.severity,
            info: values[0],
            warning: values[1],
            critical: values[2],
            fatal: values[3],
            datatype: params.datatype, min: params.min, max: params.max });
        const message = params.name + " changed";
        fetch(apiURL + "alertsettings", pdo).then(res => res.json()).then((result) => {
            if (result.success) {
                Info.success(message);
            }
            else {
                Info.error(result.error);
            }
            if (params.periodkey.length > 10) {
                updatePeriod(params);
            }
            else if (result.success) {
                setTimeout(reload, 100);
            }
        }, (error) => {
            Info.error(error.message);
        });
    }
    ;
    function reload() {
        Utils.setState(fn, setRefreshing, Utils.timeStamp());
    }
    function updatePeriod(params) {
        Debugger.print("UpdatePeriod Key:" + params.periodkey);
        const period = parseInt(document.getElementById(params.periodinputid).value) * 1000;
        if (!period || isNaN(period) || period < 5000 || period > 604800000) {
            Info.error("Period must be between 5 and 600.000");
            setTimeout(reload, 100);
            return;
        }
        Request.send({
            url: apiURL + "settings",
            params: {
                op: "set",
                name: params.periodkey,
                value: period,
                type: "long",
                min: 5000,
                max: 600000000
            },
            listener: (json) => {
                if (!json.success) {
                    Info.error(json.error);
                }
                setTimeout(reload, 100);
            }
        });
    }
    function updateNotification(params) {
        if (fn.closed.current)
            return;
        const pdo = Utils.postDataOptions({ op: "set", code: params.code, type: params.field, value: params.value, datatype: "long", min: 0, max: 1 });
        const message = params.name + " " + params.field + " = " + (params.value ? "true" : "false");
        fetch(apiURL + "alertsettings", pdo).then(res => res.json()).then((result) => {
            if (result.success) {
                Info.success(message);
                setTimeout(loadData, 100);
            }
            else {
                Info.error(result.error);
                loadData();
                Utils.setState(fn, setRefreshing, Utils.timeStamp());
            }
        }, (error) => {
            Info.error(error.message);
        });
    }
    ;
    function parse(json) {
        if (!json.success) {
            return Utils.error(json.error);
        }
        const trs = [];
        const types = [
            { key: "info", style: { background: "#aaa" } },
            { key: "warning", style: { background: Colors.yellow } },
            { key: "critical", style: { background: Colors.orange } },
            { key: "fatal", style: { background: Colors.red } }
        ];
        const settings = json.settings;
        for (let i = 0; i < settings.length; i++) {
            const setting = settings[i];
            const param = AlertData[setting.code] || { order: 1000 + i };
            setting.order = param.order;
        }
        settings.sort((a, b) => {
            if (a.group > b.group)
                return 1;
            if (a.group < b.group)
                return -1;
            a.order - b.order;
        });
        for (let i = 0; i < settings.length; i++) {
            const setting = settings[i];
            const param = AlertData[setting.code] || {};
            const params = { title: "" };
            if (!param.name)
                param.name = setting.name;
            params.type = param.type || "long";
            params.min = param.min || -1;
            params.max = param.max || 100000000;
            params.title = param.name + " Min:" + (param.multiply ? Math.floor(params.min / param.multiply) : params.min) + " Max:" + (param.multiply ? params.max / param.multiply : params.max);
            let info = setting.info;
            let warning = setting.warning;
            let critical = setting.critical;
            let fatal = setting.fatal;
            if (param.multiply) {
                if (info > 0)
                    info /= param.multiply;
                if (warning > 0)
                    warning /= param.multiply;
                if (critical > 0)
                    critical /= param.multiply;
                if (fatal > 0)
                    fatal /= param.multiply;
            }
            const tds = [];
            const skey = "set_" + i;
            for (let t = 0; t < types.length; t++) {
                const type = types[t];
                let value = setting[type.key];
                let def = setting["d" + type.key];
                if (param.multiply) {
                    if (value > 0)
                        value /= param.multiply;
                    if (def > 0)
                        def /= param.multiply;
                }
                const style = { background: type.style.background,
                    width: "50px",
                    color: "#111",
                    fontWeight: "bold",
                    margin: 0,
                    marginLeft: "3px",
                };
                const divStyle = { paddingTop: "2px", paddingBottom: "2px", border: "1px solid transparent" };
                let title = "";
                if (def != value) {
                    divStyle.border = "1px solid " + (Data.darkTheme ? "#EE0000" : "#EE0000");
                    title = "Default value:" + def;
                }
                const td = React.createElement("td", { key: "tp_" + i + "_" + t },
                    React.createElement("div", { style: divStyle, code: setting.code, info: setting.info, warning: setting.warning, def: setting["d" + type.key], multiply: param.multiply },
                        React.createElement("input", { title: title, type: "text", id: "input_" + skey + "_" + type.key, defaultValue: value, style: style })));
                tds.push(td);
            }
            const periodInputID = "input_period_" + setting.periodkey + "_" + i;
            const name = param.name || setting.name;
            const style = { width: "50px" };
            if (setting.perioddefault !== setting.period)
                style.border = "1px solid " + (Data.darkTheme ? "#EE0000" : "#EE0000");
            const tr = React.createElement("tr", { key: "appp_" + i, className: "hoverable_tr" },
                React.createElement("td", null, setting.group),
                React.createElement("td", { name: setting.name, title: param.description },
                    name,
                    " "),
                React.createElement("td", null, setting.periodkey.length > 10 &&
                    React.createElement("input", { key: setting.periodkey + "_" + refreshing, type: "text", id: periodInputID, style: style, defaultValue: (setting.period / 1000), title: Utils.timePast(setting.period / 1000) + "\n" + param.name + " control period.\nDefault:" + (setting.perioddefault / 1000) })),
                tds,
                React.createElement("td", null,
                    React.createElement(IconButton, { type: "update", size: "25", code: setting.code, datatype: params.type, ikey: skey, name: param.name, min: params.min, max: params.max, multiply: param.multiply, onClick: update, title: params.title, periodkey: setting.periodkey, periodinputid: periodInputID })),
                React.createElement("td", null,
                    React.createElement(IconButton, { type: "mail", size: "25", code: setting.code, field: "sendmail", datatype: "long", name: param.name + " Send Mail", value: setting.mail ? 0 : 1, class: setting.mail ? "svg_green" : "svg_red", onClick: updateNotification })),
                React.createElement("td", null,
                    React.createElement(IconButton, { type: "sms", size: "25", code: setting.code, field: "sendsms", datatype: "long", name: param.name + " Send SMS", value: setting.sms ? 0 : 1, class: setting.sms ? "svg_green" : "svg_red", onClick: updateNotification })),
                React.createElement("td", null,
                    React.createElement(IconButton, { type: "call", size: "25", code: setting.code, field: "sendcall", datatype: "long", name: param.name + " Voice Call", value: setting.call ? 0 : 1, class: setting.call ? "svg_green" : "svg_red", onClick: updateNotification })),
                React.createElement("td", { title: param.description }, param.description &&
                    React.createElement("img", { type: "svg", style: { width: "22px" }, src: "images/icons/info.svg", title: param.description })));
            trs.push(tr);
        }
        const div = React.createElement("table", { className: "nobordertable" },
            React.createElement("thead", null,
                React.createElement("tr", { style: { fontWeight: "bold" } },
                    React.createElement("td", { width: "50" }, "Group"),
                    React.createElement("td", { width: "400" }, "Threshold"),
                    React.createElement("td", { width: "100" }, "Period"),
                    React.createElement("td", { width: "70" }, "Info"),
                    React.createElement("td", { width: "70" }, "Warning"),
                    React.createElement("td", { width: "70" }, "Critical"),
                    React.createElement("td", { width: "70" }, "Fatal"),
                    React.createElement("td", { width: "60" }, " "),
                    React.createElement("td", { width: "30", title: "Send Mail" }, "M"),
                    React.createElement("td", { width: "30", title: "Send SMS" }, "S"),
                    React.createElement("td", { width: "30", title: "Make Phone Call" }, "C"),
                    React.createElement("td", { width: "30" }),
                    React.createElement("td", null))),
            React.createElement("tbody", null, trs));
        return div;
    }
    return (React.createElement("div", { id: 'panel_alert_thresholds' }, divDetails));
};
const AlertThresholdsPage = (props) => {
    function back(e) {
        e.preventDefault();
        Utils.goBack(props.history, "/#alerts");
    }
    return (React.createElement("div", { id: 'page' },
        React.createElement(Header, { back: back, title: t("Set alert thresholds") }),
        React.createElement(AlertThresholds, null),
        React.createElement("br", null),
        React.createElement("h3", null, "Timeout parameters"),
        React.createElement(ApplicationParameters, null)));
};
const HostAlertSettings = (props) => {
    const [divPage, setDivPage] = useState(null);
    const fn = { closed: useRef(false) };
    const timeoutID = "hostmaintenancesettings";
    function cleanUp() {
        fn.closed.current = true;
        Timeouts.clearAll(timeoutID);
    }
    function back(e) { e.preventDefault(); cleanUp(); Utils.goBack(props.history); }
    useEffect(() => { fn.closed.current = false; loadData(); return cleanUp; }, []);
    function loadData() {
        Timeouts.clearAll(timeoutID);
        if (fn.closed.current)
            return;
        let pdo = Utils.postDataOptions({ op: "maintenancelist" });
        fetch(apiURL + "hosts", pdo).then(res => res.json()).then((result) => {
            Utils.setState(fn, setDivPage, parse(result));
        }, (error) => {
            Utils.setState(fn, setDivPage, Utils.error(error.message));
        }).then(() => {
            Timeouts.add(timeoutID, setTimeout(loadData, 5000));
        });
    }
    ;
    function formatOS(row) {
        return React.createElement("div", null,
            Utils.OSIconSVG(row.os),
            React.createElement("span", { style: { marginLeft: "5px" } }, row.osname));
    }
    function update() {
        Timeouts.clearAll(timeoutID);
        setTimeout(loadData, 10);
    }
    function checkBoxClicked(e) {
        e.preventDefault();
        e.stopPropagation();
        const chk = e.currentTarget;
        const hid = chk.getAttribute('hid');
        Request.send({ caller: fn,
            url: apiURL + "hosts",
            params: { op: "setmaintenance", id: hid, value: chk.checked ? 1 : 0 },
            listener: update
        });
    }
    function sendIconClicked(props) {
        const type = props.type;
        const value = props.value ? 0 : 1;
        const hid = props.hid;
        Request.send({
            caller: fn,
            url: apiURL + "hosts",
            params: { op: "setalertsend", id: hid, value: value, type: type },
            listener: update
        });
    }
    function mailIcon(row) { return React.createElement(IconButton, { onClick: sendIconClicked, hid: row.id, value: row.sm, size: "20", type: "0", icon: "mail1.svg", class: row.sm ? "svg_green" : "svg_red" }); }
    function smsIcon(row) { return React.createElement(IconButton, { onClick: sendIconClicked, hid: row.id, value: row.ss, size: "20", type: "1", icon: "sms1.svg", class: row.ss ? "svg_green" : "svg_red" }); }
    function callIcon(row) { return React.createElement(IconButton, { onClick: sendIconClicked, hid: row.id, value: row.sc, size: "20", type: "2", icon: "ic_phone_24px.svg", class: row.sc ? "svg_green" : "svg_red" }); }
    function smsHours(row) {
        return React.createElement(HourRange, { hours: row.sh, hid: row.id, listener: smsHourChanged });
    }
    function callHours(row) {
        return React.createElement(HourRange, { hours: row.ch, hid: row.id, listener: callHourChanged });
    }
    function callHourChanged(range) {
        const hid = range.props.hid;
        const hours = range.get();
        Request.send({
            caller: fn,
            url: apiURL + "hosts",
            params: { op: "setalerthours", id: hid, value: hours, type: "call" },
            listener: update
        });
    }
    function smsHourChanged(range) {
        const hid = range.props.hid;
        const hours = range.get();
        Request.send({
            caller: fn,
            url: apiURL + "hosts",
            params: { op: "setalerthours", id: hid, value: hours, type: "sms" },
            listener: update
        });
    }
    function parse(json) {
        if (!json.success) {
            return Utils.error(json.error);
        }
        const hosts = json.hosts;
        for (let i = 0; i < hosts.length; i++) {
            const host = hosts[i];
            host.checked = host.mtm;
            host.chk = React.createElement("input", { type: "checkbox", checked: host.checked, onChange: checkBoxClicked, hid: host.id });
        }
        const tableData = {
            defaultSortField: "id",
            id: "hostmaintenance",
            headers: [
                { name: "MM", field: "checked", html: "chk", width: "40px", title: "Maintenance Mode" },
                { name: "Name", field: "name", filter: {} },
                { name: "Description", field: "alias", filter: {} },
                { name: "IP", field: "ip", filter: {} },
                { name: "TA", field: "ta", title: "Total Alerts" },
                { name: "AA", field: "aa", title: "Active Alerts" },
                { name: "M", field: "sm", rowFormat: mailIcon, title: "Send mail", tooltipText: "Send mail", nopadding: true, width: 30 },
                { name: "S", field: "ss", rowFormat: smsIcon, title: "Send SMS", tooltipText: "Send SMS", nopadding: true, width: 30 },
                { name: "C", field: "sc", rowFormat: callIcon, title: "Make phone call", tooltipText: "Make phone call", nopadding: true, width: 30 },
                { name: "SMS Hours", field: "sh", rowFormat: smsHours, title: "SMS Hours", tooltipText: "SMS Hours", nopadding: true, width: 120 },
                { name: "Call Hours", field: "ch", rowFormat: callHours, title: "Call Hours", tooltipText: "Call Hours", nopadding: true, width: 120 },
                { name: "OS", field: "osname", rowFormat: formatOS },
                { name: "CPU", field: "cpu", format: Utils.percentage, right: true, width: "60px" },
                { name: "Probe", field: "connected", format: Utils.onOffEmpty, center: true, width: "40px" },
                { name: "PV", field: "pv", title: "Probe version", right: true },
                { name: "Type", field: "machine", format: Utils.machineType, right: true, width: "60px" }
            ],
            rows: hosts
        };
        return React.createElement(Table, { data: tableData });
    }
    return (React.createElement("div", { id: 'page' },
        React.createElement(Header, { back: back, title: t("Host Alert Settings") }),
        React.createElement("div", { className: "panel flexmargin" },
            "When a host is in maintenance mode, any alerts from this host will be ignored.",
            divPage)));
};
const MailErrors = (props) => {
    const [divPage, setDivPage] = useState(null);
    const fn = { closed: useRef(false) };
    const timeoutID = "mailerrors";
    function cleanUp() {
        fn.closed.current = true;
        Timeouts.clearAll(timeoutID);
    }
    useEffect(() => { fn.closed.current = false; loadData(); return cleanUp; }, [props]);
    function loadData() {
        Timeouts.clearAll(timeoutID);
        if (fn.closed.current)
            return;
        let pdo = Utils.postDataOptions({ op: "mailerrors" });
        fetch(apiURL + "notifications", pdo).then(res => res.json()).then((result) => {
            Utils.setState(fn, setDivPage, parse(result));
        }, (error) => {
            Utils.setState(fn, setDivPage, Utils.error(error.message));
        }).then(() => {
            Timeouts.add(timeoutID, setTimeout(loadData, 10000));
        });
    }
    ;
    function parse(json) {
        if (!json.success) {
            return Utils.error(json.error);
        }
        const tableData = {
            defaultSortField: "id",
            id: "tablemailerrors",
            headers: [
                { name: "Time", field: "tm", format: Utils.toDate },
                { name: "To", field: "to" },
                { name: "Error", field: "er" },
            ],
            rows: json.errors
        };
        return React.createElement(Table, { data: tableData });
    }
    return (React.createElement("div", { id: 'mail_errors_panel' }, divPage));
};
const NotificationAlerts = (props) => {
    const [divPage, setDivPage] = useState(null);
    const fn = { closed: useRef(false) };
    const NID = props.nid;
    function cleanUp() {
        fn.closed.current = true;
    }
    useEffect(() => { fn.closed.current = false; loadData(); return cleanUp; }, [NID]);
    function loadData() {
        if (fn.closed.current)
            return;
        let pdo = Utils.postDataOptions({ op: "alerts", nid: NID, type: props.type });
        fetch(apiURL + "notifications", pdo).then(res => res.json()).then((result) => {
            Utils.setState(fn, setDivPage, parse(result));
        }, (error) => {
            Utils.setState(fn, setDivPage, Utils.error(error.message));
        });
    }
    ;
    function parse(json) {
        if (!json.success) {
            return Utils.error(json.error);
        }
        const tableData = {
            defaultSortField: "id",
            id: "notificationalerts",
            headers: [
                { name: "Host", field: "hn" },
                { name: "Message", field: "message" },
                { name: "Details", field: "details" }
            ],
            rows: json.rows
        };
        return React.createElement(Table, { data: tableData });
    }
    return (React.createElement("div", { id: 'panel_notification_alerts' }, divPage));
};
const Notifications = (props) => {
    const fn = { closed: useRef(false) };
    function cleanUp() {
        fn.closed.current = true;
    }
    function back(e) { e.preventDefault(); cleanUp(); Utils.goBack(props.history); }
    return (React.createElement("div", { id: 'page' },
        React.createElement(Header, { back: back, title: t("Alert Notifications") }),
        React.createElement(Tabs, { default: null, id: "tabs_alert_notifications", key: "tabs_alert_notifications" },
            React.createElement(Tab, { key: 'smslist', name: 'smslist', label: 'SMS' },
                "   ",
                React.createElement(SMSList, null),
                " "))));
};
const SMSErrors = (props) => {
    const [divPage, setDivPage] = useState(null);
    const fn = { closed: useRef(false) };
    const timeoutID = "smserrors";
    function cleanUp() {
        fn.closed.current = true;
        Timeouts.clearAll(timeoutID);
    }
    useEffect(() => { fn.closed.current = false; loadData(); return cleanUp; }, [props]);
    function loadData() {
        Timeouts.clearAll(timeoutID);
        if (fn.closed.current)
            return;
        let pdo = Utils.postDataOptions({ op: "smserrors" });
        fetch(apiURL + "notifications", pdo).then(res => res.json()).then((result) => {
            Utils.setState(fn, setDivPage, parse(result));
        }, (error) => {
            Utils.setState(fn, setDivPage, Utils.error(error.message));
        }).then(() => {
            Timeouts.add(timeoutID, setTimeout(loadData, 10000));
        });
    }
    ;
    function type(val) {
        switch (val) {
            case 2: return "Call";
        }
        return "SMS";
    }
    function parse(json) {
        if (!json.success) {
            return Utils.error(json.error);
        }
        const tableData = {
            defaultSortField: "id",
            id: "tablesmserrors",
            headers: [
                { name: "Type", field: "ty", format: type },
                { name: "Time", field: "tm", format: Utils.toDate },
                { name: "Number", field: "pn" },
                { name: "Error", field: "er" },
            ],
            rows: json.errors
        };
        return React.createElement(Table, { data: tableData });
    }
    return (React.createElement("div", { id: 'sms_errors_panel' }, divPage));
};
const SMSList = (props) => {
    const [divPage, setDivPage] = useState(null);
    const fn = { closed: useRef(false) };
    const timeoutID = "smslist";
    function cleanUp() {
        fn.closed.current = true;
        Timeouts.clearAll(timeoutID);
    }
    useEffect(() => { fn.closed.current = false; loadData(); return cleanUp; }, []);
    function loadData() {
        Timeouts.clearAll(timeoutID);
        if (fn.closed.current)
            return;
        let pdo = Utils.postDataOptions({ op: "list" });
        fetch(apiURL + "sms", pdo).then(res => res.json()).then((result) => {
            Utils.setState(fn, setDivPage, parse(result));
        }, (error) => {
            Utils.setState(fn, setDivPage, Utils.error(error.message));
        }).then(() => {
            Timeouts.add(timeoutID, setTimeout(loadData, 10000));
        });
    }
    ;
    function type(val) {
        switch (val) {
            case 2: return "Call";
        }
        return "SMS";
    }
    function showAlerts(row, data) {
        const nid = row.id;
        const div = React.createElement(NotificationAlerts, { type: "sms", nid: nid });
        Dialog.show({ content: div, render: true });
    }
    function parse(json) {
        if (!json.success) {
            return Utils.error(json.error);
        }
        const tableData = {
            defaultSortField: "tm",
            direction: "descendent",
            id: "smslist",
            headers: [
                { name: "Type", field: "t", format: type },
                { name: "Time", field: "tm", format: Utils.toDate },
                { name: "Number", field: "pn", filter: {} },
                { name: "Message", field: "msg", filter: {} },
                { name: "Alerts", field: "alerts", onClick: showAlerts, icon: "logs.svg" },
            ],
            rows: json.list
        };
        return React.createElement(Table, { data: tableData });
    }
    return (React.createElement("div", { id: 'sms_list_panel' }, divPage));
};
const SMSPage = (props) => {
    const fn = { closed: useRef(false) };
    function cleanUp() {
        fn.closed.current = true;
    }
    function back(e) { e.preventDefault(); cleanUp(); Utils.goBack(props.history); }
    return (React.createElement("div", { id: 'page' },
        React.createElement(Header, { back: back, title: t("SMS/Calls") }),
        React.createElement(Tabs, { default: null, id: "tabs_alert_notifications", key: "tabs_alert_notifications" },
            React.createElement(Tab, { key: 'smslist', name: 'smslist', label: 'SMS' },
                "   ",
                React.createElement(SMSList, null),
                " "),
            React.createElement(Tab, { key: 'smserrors', name: 'smserrors', label: 'Errors' },
                "   ",
                React.createElement(SMSErrors, null),
                " "))));
};
const InitializeApp = (initCompleted) => {
    function start() {
        if (SysRanger.remote) {
        }
        Debugger.print("AppInitialize.start");
        Data.debug = Utils.urlContains("debug");
        const url = apiURL + "settings";
        let pdo = Utils.postDataOptions({ op: "getall" });
        fetch(url, pdo).then(res => res.json()).then((result) => {
            const rows = result.rows;
            for (var key in rows) {
                const setting = rows[key];
                Settings.put(setting);
            }
            if (settings["maintenance"]) {
                Data.maintenance = settings["maintenance"] == "true";
            }
            if (SysRanger.demo) {
                applyUserSettings();
                readLanguage(UserSettings.get("language"));
            }
            else {
                readUserSettings();
            }
        }, (error) => {
            console.log(error);
            initCompleted(false, "Error while loading settings");
        });
    }
    ;
    function readUserSettings() {
        UserSettings.readAll((success) => {
            if (!success) {
                return initCompleted(false, "Error while loading usersettings");
            }
            applyUserSettings();
            readLanguage(UserSettings.get("language"));
        });
    }
    function applyUserSettings() {
        const style = UserSettings.get("stylesheet");
        if (style == "style_light.css") {
            Theme.set("light");
        }
        else {
            Theme.set("dark");
        }
    }
    function readLanguage(lan) {
        if (!lan)
            lan = "en";
        language = lan;
        SysRanger.language = lan;
        Debugger.print("AppInitialize.Language:" + lan);
        const languageURL = "assets/language/" + language + ".json?v=" + (new Date().getTime());
        fetch(languageURL).then(res => res.json()).then((result) => {
            words = result;
            completed();
        }, (error) => {
            initCompleted(false, "Error while loading language file:" + languageURL);
        });
    }
    ;
    function completed() {
        initCompleted(true, "");
    }
    ;
    start();
};
const Colors = {
    green: "#73bf69",
    red: "#f2495c",
    orange: "#ff9830",
    yellow: "#fff899",
    warning: "#db8f23",
    lightRed: "#ff9191",
    lightGreen: "#a3ff9e",
    darkGreen: "#159923",
    darkYellow: "#dbde09",
    gray: "#828282",
    text: "#404040",
    blue: "#4287f5",
    graphBlue: "#03adfd",
    lightBlue: "#00d5ff",
    background: "#111217",
    cellBorder: "#2e3136"
};
const AvailabilityHistoryPage = (props) => {
    const [divPage, setDivPage] = useState(null);
    const fn = { closed: useRef(false) };
    const types = props.match.params.types.split("-");
    const id = props.match.params.id;
    function cleanUp() {
        fn.closed.current = true;
    }
    useEffect(() => { fn.closed.current = false; loadData(); return cleanUp; }, []);
    function loadData() {
        if (fn.closed.current)
            return;
        let pdo = Utils.postDataOptions({ op: "item", "type": types[0], "id": id });
        fetch(apiURL + "info", pdo).then(res => res.json()).then((result) => {
            Utils.setState(fn, setDivPage, parse(result));
        }, (error) => {
            Utils.setState(fn, setDivPage, Utils.error(error.message));
        });
    }
    function parse(json) {
        if (!json.success) {
            return Utils.error(json.error);
        }
        const rows = [];
        for (var prop in json) {
            if (json.hasOwnProperty(prop) && prop != "success") {
                rows.push(React.createElement("tr", { key: "ii_" + prop },
                    React.createElement("td", null, prop),
                    React.createElement("td", null, json[prop])));
            }
        }
        const graphs = [];
        for (let i = 0; i < types.length; i++) {
            const type = types[i];
            const panel = React.createElement("div", { key: "dgr_" + id + "_" + type, className: "panel flexmargin" },
                React.createElement(AvailabilityGroup, { key: "agroup_" + id + "_" + type, id: id, type: type, height: "200" }));
            graphs.push(panel);
        }
        const div = React.createElement(React.Fragment, null,
            React.createElement("div", { className: "panel flexmargin" },
                React.createElement("table", { key: "availability_info_table" },
                    React.createElement("tbody", null, rows))),
            graphs);
        return div;
    }
    function back() { Utils.goBack(props.history, "/#units"); }
    return (React.createElement("div", { id: 'page' },
        React.createElement(Header, { back: back, title: t("Availability History") }),
        divPage));
};
const AvailabilityLog = (props) => {
    const fn = { closed: useRef(false) };
    const [refreshing, setRefreshing] = useState(0);
    const type = props.type;
    const id = props.id;
    let refreshTimeout = 0;
    const logID = "al_" + id + "_" + type;
    const [divDetails, setDivDetails] = useState(null);
    const tableHeight = props.height || 400;
    function cleanUp() {
        fn.closed.current = true;
        clearTimeout(refreshTimeout);
    }
    function init() {
        fn.closed.current = false;
        loadData();
    }
    useEffect(() => { init(); return cleanUp; }, [logID]);
    function loadData() {
        if (fn.closed.current)
            return;
        let pdo = Utils.postDataOptions({ op: "change", type: type, id: id });
        Utils.setState(fn, setRefreshing, Utils.timeStamp());
        fetch(apiURL + "availability", pdo).then(res => res.json()).then((result) => {
            Utils.setState(fn, setDivDetails, parse(result));
            Utils.setState(fn, setRefreshing, Utils.timeStamp());
        }, (error) => {
            return Utils.setState(fn, setDivDetails, error.message);
        }).then(() => {
            if (fn.closed.current)
                return;
            setTimeout(() => Utils.setState(fn, setRefreshing, false), 1000);
            refreshTimeout = setTimeout(loadData, 10000);
        });
    }
    ;
    function parse(json) {
        if (!json.success) {
            return Utils.error(json.error);
        }
        const rows = [];
        for (let i = 0; i < json.values.length; i += 3) {
            const status = json.values[i];
            const start = json.values[i + 1];
            const end = json.values[i + 2];
            const duration = end - start;
            const imageSRC = status ? "/images/icons/png/circle_green.png" : "/images/icons/png/circle_red.png";
            const style = {};
            if (status)
                style.opacity = 0.8;
            style.color = status ? Colors.green : Colors.red;
            const row = React.createElement("tr", { key: logID + "_row_" + start },
                React.createElement("td", { style: style }, Utils.toDateMS(start)),
                React.createElement("td", null,
                    React.createElement("img", { key: "img_av_log_status_" + start, src: imageSRC, width: "14" })),
                React.createElement("td", { align: "right", style: style }, Utils.timePastWithDays(duration)));
            rows.push(row);
        }
        return React.createElement("div", { style: { height: tableHeight + "px", paddingRight: "20px", width: "420px", overflow: "auto" } },
            React.createElement("table", null,
                React.createElement("thead", null,
                    React.createElement("tr", null,
                        React.createElement("th", { width: "160" },
                            t("Date"),
                            " "),
                        React.createElement("th", { width: "20" }),
                        React.createElement("th", { align: "right" },
                            t("Duration"),
                            " "))),
                React.createElement("tbody", null, rows)));
    }
    ;
    const divID = "div_availability_log" + logID;
    return (React.createElement("div", { id: divID, key: divID },
        React.createElement("div", { className: "update_animation_box" }, refreshing && Utils.updating()),
        divDetails));
};
const AvailabilityGroup = (props) => {
    const id = props.id;
    const type = props.type;
    const height = props.height || 300;
    return (React.createElement("div", { key: "agr_con_" + id + "_" + type },
        React.createElement("div", { style: { float: "left" }, key: "agr_ag_" + id + "_" + type },
            React.createElement(AvailabilityHistory, { key: "ag_" + id + "_" + type, id: id, type: type, height: height })),
        React.createElement("div", { style: { float: "right", paddingRight: "30px" }, key: "agr_log_" + id + "_" + type },
            React.createElement(AvailabilityLog, { key: "al_" + id + "_" + type, id: id, type: type, height: height }))));
};
const Checkbox = (_a) => {
    var { label, checked, onChange } = _a, props = __rest(_a, ["label", "checked", "onChange"]);
    return (React.createElement("div", { style: Object.assign({ display: "inline" }, props.css) },
        React.createElement("label", null,
            React.createElement("input", Object.assign({ type: "checkbox", checked: checked, onChange: onChange }, props)),
            React.createElement("span", null, label))));
};
const Checkbox2 = React.forwardRef((props, ref) => {
    return (React.createElement("label", null,
        React.createElement("input", Object.assign({ type: "checkbox" }, props, { ref: ref })),
        React.createElement("span", null, props.label)));
});
const Checkbox3 = (props) => {
    return (React.createElement("label", null,
        React.createElement("input", Object.assign({ type: "checkbox" }, props)),
        React.createElement("span", null, props.label)));
};
const Combo = (props) => {
    const refSelect = useRef(null);
    const ref = props.rf;
    const id = props.id || "combo";
    const holder = {};
    holder.props = props;
    if (ref) {
        ref.get = get;
    }
    function get() {
        return refSelect.current.value;
    }
    holder.get = get;
    function changed() {
        if (!props.listener)
            return;
        props.listener(holder);
    }
    function options() {
        const options = [];
        for (let i = 0; i < props.options.length; i++) {
            const option = props.options[i];
            options.push(React.createElement("option", { key: "op_" + id + "_" + i, value: option.val }, option.label));
        }
        return options;
    }
    function list() {
        const style = {};
        const select = React.createElement("select", { ref: refSelect, onChange: changed, style: style }, options("hr1"));
        return select;
    }
    return (React.createElement(React.Fragment, null, list()));
};
const Container = (props) => {
    const [show, setShow] = useState(false);
    const component = props.component;
    function toggle() {
        setShow(!show);
    }
    return (React.createElement("div", { id: "component_container_" + Utils.key },
        React.createElement("div", { style: {}, className: "componentcontainerheader", onClick: toggle },
            React.createElement("span", { style: { float: "left" } }, props.title),
            React.createElement("img", { height: "20", type: "svg", src: show ? "images/icons/arrow_up.svg" : "images/icons/arrow_down.svg", style: { display: "block", marginLeft: "10px", float: "left" } })),
        React.createElement("div", { style: { clear: "both", height: "12px" } }),
        show && component));
};
const ContextMenu = {
    menu: null,
    closeListener: null,
    visible: false,
    init: function () {
        this.menu = document.createElement("div");
        this.menu.style.display = "none";
        this.menu.classList.add("context");
        document.body.appendChild(this.menu);
        document.addEventListener("mousedown", ContextMenu.mouseDown);
        document.addEventListener('scroll', ContextMenu.scroll);
    },
    scroll: function () {
        if (ContextMenu.visible) {
            ContextMenu.close();
        }
    },
    mouseDown: function (e) {
        if (!ContextMenu.visible)
            return;
        const box = document.querySelector(".context");
        if (!box) {
            return;
        }
        if (box.contains(e.target)) {
            return;
        }
        ContextMenu.close();
    },
    close: function () {
        this.menu.style.display = "none";
        this.visible = false;
        if (this.closeListener) {
            this.closeListener();
        }
    },
    show(data) {
        const event = data.event;
        event.preventDefault();
        event.stopPropagation();
        const menu = this.menu;
        if (data.closeListener) {
            this.closeListener = data.closeListener;
        }
        menu.style.display = "block";
        while (menu.firstChild) {
            menu.firstChild.remove();
        }
        const div = document.createElement("div");
        ReactDOM.render(data.content, div);
        menu.appendChild(div);
        const screenW = window.innerWidth;
        const screenH = window.innerHeight;
        const menuW = this.menu.offsetWidth;
        const menuH = this.menu.offsetHeight;
        let x = event.clientX + 10;
        let y = event.clientY + 10;
        if (x + menuW > screenW)
            x = x - menuW - 20;
        if (y + menuH > screenH)
            y = y - menuH - 20;
        if (x < 0)
            x = 0;
        if (y < 0)
            y = 0;
        if (x > screenW)
            x = screenW - menuW;
        if (y > screenH)
            y = screenH - menuH;
        menu.style.left = x + "px";
        menu.style.top = y + "px";
        this.visible = true;
    },
};
const DateRange = (props) => {
    let inputStart = useRef(null);
    let inputEnd = useRef(null);
    const fn = props.fn;
    function startChanged() {
        if (!props.listener)
            return;
        props.listener(fn);
    }
    function endChanged() {
        if (!props.listener)
            return;
        props.listener(fn);
    }
    fn.startSAPDate = function () {
        let date = inputStart.current.value + "";
        date = date.replaceAll("-", "");
        return date;
    };
    fn.endSAPDate = function () {
        let date = inputEnd.current.value + "";
        date = date.replaceAll("-", "");
        return date;
    };
    fn.startMS = function () {
        const dt = new Date(inputStart.current.value);
        return dt.getTime();
    };
    fn.endMS = function () {
        const dt = new Date(inputEnd.current.value);
        return dt.getTime();
    };
    fn.inited = true;
    return (React.createElement(React.Fragment, null,
        React.createElement("span", null, t("Range")),
        React.createElement("input", { type: "date", onChange: startChanged, defaultValue: Utils.ISOFormatDay(props.start ? new Date(props.start) : new Date()), ref: inputStart }),
        React.createElement("span", null, "-"),
        React.createElement("input", { type: "date", onChange: endChanged, defaultValue: Utils.ISOFormatDay(new Date()), ref: inputEnd })));
};
const DateTimeRange = (props) => {
    let inputStart = useRef(null);
    let inputEnd = useRef(null);
    const fn = props.fn;
    function startChanged() {
        if (!props.listener)
            return;
        props.listener(fn);
    }
    function endChanged() {
        if (!props.listener)
            return;
        props.listener(fn);
    }
    fn.startSAPDate = function () {
        let date = inputStart.current.value + "";
        date = date.replaceAll("-", "");
        date = date.replaceAll("T", "");
        date = date.replaceAll(":", "");
        date += "00";
        return date;
    };
    fn.endSAPDate = function () {
        let date = inputEnd.current.value + "";
        date = date.replaceAll("-", "");
        date = date.replaceAll("T", "");
        date = date.replaceAll(":", "");
        date += "00";
        return date;
    };
    fn.startMS = function () {
        const dt = new Date(inputStart.current.value);
        return dt.getTime();
    };
    fn.endMS = function () {
        const dt = new Date(inputEnd.current.value);
        return dt.getTime();
    };
    fn.inited = true;
    let start = null;
    if (props.start) {
        start = props.start;
    }
    else {
        const d = new Date();
        start = new Date();
        start.setDate(d.getDate() - 1);
    }
    let end = props.end || new Date();
    start = new Date(start.getTime() - (start.getTimezoneOffset() * 60000));
    end = new Date(end.getTime() - (end.getTimezoneOffset() * 60000));
    console.log("DateTimeRange Start:" + start.toString());
    start = start.toISOString().substring(0, 16);
    end = end.toISOString().substring(0, 16);
    return (React.createElement(React.Fragment, null,
        React.createElement("span", null, t("Range")),
        React.createElement("input", { type: "datetime-local", onChange: startChanged, defaultValue: start, ref: inputStart }),
        React.createElement("span", null, "-"),
        React.createElement("input", { type: "datetime-local", onChange: endChanged, defaultValue: end, ref: inputEnd })));
};
const Dialog = {
    name: "",
    data: {},
    init: function () {
        document.addEventListener("mousedown", Dialog.mouseDown);
    },
    mouseDown: function (e) {
        if (e.target.classList.contains("dialogclose")) {
            return Dialog.close();
        }
        const box = document.querySelector(".dialog");
        if (!box)
            return;
        if (box.contains(e.target)) {
            return;
        }
        if (e.target.classList.contains("modal")) {
            return;
        }
        Dialog.close();
    },
    close: function (initial) {
        let elements = document.getElementsByClassName("dialogbox");
        if (elements) {
            while (elements.length > 0) {
                const element = elements[0];
                ReactDOM.unmountComponentAtNode(element);
                element.remove();
            }
        }
        elements = document.getElementsByClassName("dialogboxcontainer");
        if (elements) {
            while (elements.length > 0) {
                const element = elements[0];
                element.remove();
            }
        }
        elements = document.getElementsByClassName("dialogbackground");
        if (elements) {
            while (elements.length > 0) {
                const element = elements[0];
                element.remove();
            }
        }
        if (!initial && Dialog.data.closed) {
            Dialog.data.closed();
        }
        Dialog.data = {};
        return false;
    },
    information: function (data) {
        Dialog.show(data);
    },
    error: function (data) {
        data.error = true;
        Dialog.show(data);
    },
    show: function (data) {
        Dialog.name = data.name;
        Dialog.close(true);
        Dialog.data = data;
        const w = window.innerWidth;
        const h = window.innerHeight;
        let bw = w * 0.8;
        let bh = h * 0.8;
        if (data.width && data.width < bw) {
            bw = data.width;
        }
        if (data.height && data.height < bh) {
            bh = data.height;
        }
        const bx = (w - bw) / 2;
        const by = (h - bh) / 2;
        const style = {
            width: bw + "px",
            height: bh + "px",
            top: by + "px",
            left: bx + "px"
        };
        let imageSRC = "/images/icons/info.svg";
        if (data.error) {
            imageSRC = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iMjRweCIgdmlld0JveD0iMCAwIDI0IDI0IiB3aWR0aD0iMjRweCIgZmlsbD0iIzAwMDAwMCI+PHBhdGggZD0iTTAgMGgyNHYyNEgweiIgZmlsbD0ibm9uZSIvPjxwYXRoIGQ9Ik0xMiAyQzYuNDcgMiAyIDYuNDcgMiAxMnM0LjQ3IDEwIDEwIDEwIDEwLTQuNDcgMTAtMTBTMTcuNTMgMiAxMiAyem01IDEzLjU5TDE1LjU5IDE3IDEyIDEzLjQxIDguNDEgMTcgNyAxNS41OSAxMC41OSAxMiA3IDguNDEgOC40MSA3IDEyIDEwLjU5IDE1LjU5IDcgMTcgOC40MSAxMy40MSAxMiAxNyAxNS41OXoiLz48L3N2Zz4=";
        }
        const imageClass = Data.darkTheme ? "lighticon" : "";
        const box = document.createElement('div');
        const panel = document.createElement("div");
        box.classList.add("dialogbox");
        const container = document.createElement('div');
        container.classList.add("dialogboxcontainer");
        if (!data.hideOverflow) {
            container.style["overflow"] = "auto";
        }
        for (const property in style) {
            panel.style[property] = style[property];
        }
        panel.classList.add("dialog");
        if (data.content) {
            if (data.render) {
                ReactDOM.render(data.content, box);
            }
            else {
                box.innerHTML = data.content;
            }
        }
        else {
            box.innerHTML = "<div style='text-align:center;'>     <img class='" + imageClass + "' style='opacity:0.6' src='" + imageSRC + "' width=100/> </div> " +
                " <div  style='text-align:center;'>  " + t(data.message) + "</div>";
        }
        const background = document.createElement("div");
        container.style["height"] = "calc(100% - 50px)";
        background.classList.add("dialogbackground");
        if (data.modal) {
            background.classList.add("modal");
        }
        const title = data.title || "";
        const closeButton = document.createElement("div");
        closeButton.innerHTML = "<div class='dialogheader'>  <div style='float:left'>" + title + "</div>  <div style='float:right;' class='dialogclose'>&#x2715;</div> </div>";
        container.append(box);
        panel.appendChild(closeButton);
        panel.appendChild(container);
        background.appendChild(panel);
        document.body.appendChild(background);
        return panel;
    }
};
const ExcelExport = function (_data) {
    const that = this;
    this.data = _data;
    this.init = function () {
        const content = React.createElement("div", null,
            React.createElement("button", { onClick: this.start }, "Export"));
        const data = { title: "Export Options", content: content, render: true, width: 150, height: 100 };
        Dialog.show(data);
    };
    this.start = function () {
        const html = that.getTable(that.data.id);
        that.export(html, that.data.name);
    };
    this.getTable = function (tableID) {
        var table = document.getElementById(tableID);
        var html = "<table border=\"1\">";
        const rows = table.rows;
        for (var i = 0; i < rows.length; i++) {
            const cells = rows[i].cells;
            let row = i > 0 ? "<tr>" : "<tr bgcolor=\"#87AFC6\">";
            for (var c = 0; c < cells.length; c++) {
                const cell = cells[c];
                if (cell.className == "noexport")
                    continue;
                row += "<td>" + cell.innerHTML + "</td>";
            }
            row += "</tr>";
            html += row;
        }
        html += "</table>";
        html = html.replaceAll("<br>", '<br style="mso-data-placement:same-cell;" />');
        html = html.replaceAll("<button>", "");
        html = html.replaceAll("</button>", "");
        html = html.replaceAll(/<a[^>]*>|<\/a>/g, "");
        html = encodeURIComponent(html);
        return html;
    };
    this.export = function (tableHTML, filename = '') {
        var downloadLink;
        var dataType = 'application/vnd.ms-excel';
        const ts = Utils.timeStamp();
        filename += "_" + ts + ".xls";
        downloadLink = document.createElement("a");
        document.body.appendChild(downloadLink);
        if (navigator.msSaveOrOpenBlob) {
            var blob = new Blob(['\ufeff', tableHTML], {
                type: dataType
            });
            navigator.msSaveOrOpenBlob(blob, filename);
        }
        else {
            downloadLink.href = 'data:' + dataType + ', ' + tableHTML;
            downloadLink.download = filename;
            downloadLink.click();
        }
        Dialog.close();
    };
    this.init();
};
String.prototype.replaceAll = String.prototype.replaceAll || function (string, replaced) {
    return this.replace(new RegExp(string, 'g'), replaced);
};
String.prototype.startsWith || (String.prototype.startsWith = function (word) {
    return this.lastIndexOf(word, 0) === 0;
});
String.prototype.endsWith || (String.prototype.endsWith = function (word) {
    return this.indexOf(word, this.length - word.length) !== -1;
});
Number.prototype.fixed0 = function () {
    const num = Number(this);
    if (isNaN(num))
        return "0";
    return num.toLocaleString("tr-TR", { maximumFractionDigits: 0 });
};
CanvasRenderingContext2D.prototype.rr = function (type, x, y, w, h, r) {
    if (w < 2 * r)
        r = w / 2;
    if (h < 2 * r)
        r = h / 2;
    this.beginPath();
    this.moveTo(x + r, y);
    this.arcTo(x + w, y, x + w, y + h, r);
    this.arcTo(x + w, y + h, x, y + h, r);
    this.arcTo(x, y + h, x, y, r);
    this.arcTo(x, y, x + w, y, r);
    if (type == "fill") {
        this.fill();
    }
    else {
        this.stroke();
    }
    this.closePath();
    return this;
};
const FontSelector = (props) => {
    const [font, setFont] = useState("Roboto");
    function cleanUp() {
    }
    function fontSelected(event) {
        const f = event.target.value;
        document.body.style.fontFamily = f + ",sans-serif";
        setFont(f);
    }
    return (React.createElement("select", { onChange: fontSelected, value: font },
        React.createElement("option", { value: "Roboto" }, "Roboto"),
        React.createElement("option", { value: "Rubik" }, "Rubik"),
        React.createElement("option", { value: "Titillium Web" }, "Titillium Web"),
        React.createElement("option", { value: "Montserrat" }, "Montserrat"),
        React.createElement("option", { value: "Poppins" }, "Poppins"),
        React.createElement("option", { value: "Dosis" }, "Dosis"),
        React.createElement("option", { value: "Trebuchet MS" }, "Trebuchet MS"),
        React.createElement("option", { value: "sans-serif" }, "sans-serif")));
};
const FreeList = (props) => {
    const data = props.data;
    const id = data.id;
    const [sorting, setSorting] = useState({ field: data.defaultSortField, previous: "", direction: "" });
    function sort(rows, sortedField) {
        if (sortedField !== "") {
            rows.sort((a, b) => {
                if (a[sortedField] < b[sortedField]) {
                    return sorting.direction === 'ascending' ? -1 : 1;
                }
                if (a[sortedField] > b[sortedField]) {
                    return sorting.direction === 'ascending' ? 1 : -1;
                }
                return 0;
            });
        }
    }
    function itemClicked(item) {
        if (!data.onClick)
            return;
        data.onClick(item, data);
    }
    ;
    let i = 0;
    const items = data.items;
    const list = [];
    const sortingEnabled = !data.nosorting;
    if (sortingEnabled) {
        sort(items, sorting.field);
    }
    for (i = 0; i < items.length; i++) {
        const item = items[i];
        const name = item[data.field];
        const listItem = React.createElement("div", { key: "fli_" + name, className: "freelistitem", item: item, onClick: (e) => { itemClicked(item); } },
            " ",
            name);
        list.push(listItem);
    }
    let headerInfo = null;
    if (data.total) {
        headerInfo = React.createElement("div", null,
            React.createElement("span", { style: { marginRight: "10px" } },
                t("Total"),
                " : ",
                data.total),
            React.createElement("span", { style: { marginRight: "10px" } },
                t("Displaying"),
                " : ",
                data.start + 1,
                " - ",
                data.finish),
            React.createElement("br", null),
            React.createElement("br", null));
    }
    return React.createElement("div", { style: { overflow: "auto", marginTop: "20px", paddingBottom: "20px", width: "100%" } },
        headerInfo,
        list);
};
const HourRange = (props) => {
    const inputStart = useRef(null);
    const inputEnd = useRef(null);
    const ref = props.rf;
    const holder = {};
    holder.props = props;
    if (ref) {
        ref.get = get;
    }
    function get() {
        return inputStart.current.value + "-" + inputEnd.current.value;
    }
    holder.get = get;
    function options(id) {
        const options = [];
        options.push(React.createElement("option", { key: "opd_" + id, value: "." }));
        for (let i = 0; i <= 24; i++) {
            const val = i < 10 ? "0" + i : i;
            options.push(React.createElement("option", { key: "op_" + id + "_" + i, value: i }, val));
        }
        return options;
    }
    function changed() {
        if (!props.listener)
            return;
        props.listener(holder);
    }
    function getSelects() {
        let hours = [".", "."];
        if (props.hours) {
            hours = props.hours.split("-");
        }
        if (hours.length < 1)
            hours = [".", "."];
        const selects = [];
        const style = { width: "50px" };
        selects.push(React.createElement("select", { ref: inputStart, onChange: changed, key: "hr1" + props.id, id: "hr1_" + props.id, defaultValue: hours[0], style: style }, options("hr1")));
        selects.push(React.createElement("select", { ref: inputEnd, onChange: changed, key: "hr2" + props.id, id: "hr2_" + props.id, defaultValue: hours[1], style: style }, options("hr2")));
        const div = selects;
        return div;
    }
    return (React.createElement(React.Fragment, null, getSelects()));
};
const IconButton = (props) => {
    let path = "";
    let title = props.title;
    if (props.icon) {
        path = "/images/icons/" + props.icon;
    }
    if (!path)
        parseType();
    function parseType() {
        switch (props.type) {
            case "update":
                path = "/images/icons/save1.svg";
                title = props.title || t("Save");
                break;
            case "add":
                path = "/images/icons/ic_add_box_24px.svg";
                title = props.title || t("Add");
                break;
            case "remove":
                path = "/images/icons/remove2.svg";
                title = props.title || t("Remove");
                break;
            case "settings":
                path = "/images/icons/settings.svg";
                title = props.title || t("Settings");
                break;
            case "mail":
                path = "/images/icons/mail1.svg";
                title = props.title || t("Send Mail");
                break;
            case "sms":
                path = "/images/icons/sms1.svg";
                title = props.title || t("Send SMS");
                break;
            case "call":
                path = "/images/icons/ic_phone_24px.svg";
                title = props.title || t("Voice Call");
                break;
            case "viewsettings":
                path = "/images/icons/eye.svg";
                title = props.title || t("View Settings");
                break;
        }
    }
    function onClick() {
        props.onClick(props);
    }
    const style = props.style || {};
    style.lineHeight = "28px";
    style.verticalAlign = "middle";
    if (!props.style || !props.style.height) {
        style.height = "28px";
    }
    if (props.size) {
        style.width = props.size + "px";
        style.height = props.size + "px";
    }
    let cls = props.class || "";
    if (!cls.includes("svg_")) {
        cls += " lighticon ";
    }
    return (React.createElement("img", { className: "imagebutton " + cls, style: style, src: path, onClick: onClick, title: title }));
};
const IconSelector = (props) => {
    const data = props.data;
    const [open, setOpen] = useState(false);
    const [value, setValue] = useState(data.value);
    const id = data.id;
    const fn = { closed: useRef(false) };
    function clicked(evt) {
        Debugger.print("IconSelector Clicked");
        setOpen(true);
    }
    function cleanUp() {
        fn.closed.current = true;
        document.removeEventListener("mousedown", mouseDown);
    }
    function init() {
        document.addEventListener("mousedown", mouseDown);
    }
    function mouseDown(e) {
        const box = document.querySelector(".iconselector");
        if (!box || box.contains(e.target)) {
            return;
        }
        setOpen(false);
    }
    useEffect(() => { init(); return cleanUp; }, []);
    let list = null;
    function iconClicked(e) {
        e.preventDefault();
        e.stopPropagation();
        const v = e.currentTarget.getAttribute('value');
        Debugger.print("Icon Selected" + v);
        setValue(v);
        data.listener(v);
        setOpen(false);
    }
    if (open) {
        const icons = [];
        for (let i = 1; i < 10; i++) {
            icons.push(React.createElement("img", { key: "icon_selector_" + id + "_" + i, src: "images/icons/icon" + i + ".svg", width: "50", height: "50", style: { float: "left",
                    margin: "10px"
                }, onClick: iconClicked, value: i, className: "svg_white hoverable image" }));
        }
        list = React.createElement("div", { style: { position: "fixed",
                zIndex: 100,
                background: "#505050",
                width: "310px",
                height: "220px",
                overflow: "auto",
                padding: "10px"
            }, className: "iconselector" }, icons);
    }
    return (React.createElement("div", { style: { padding: "20px" }, title: t("Change icon") },
        React.createElement("img", { src: "images/icons/icon" + value + ".svg", onClick: clicked, className: "svg_white hoverable", width: "50", height: "50" }),
        list));
};
const Info = {
    boxes: [],
    inited: false,
    updated: false,
    duration: 5000,
    init: function () {
        if (Info.inited)
            return;
        const panel = document.createElement('div');
        panel.id = "errorpanel";
        document.body.appendChild(panel);
        Info.inited = true;
        document.addEventListener("mousedown", Info.mouseDown);
        setInterval(Info.tick, Info.duration);
    },
    tick: function () {
        if (Info.boxes.length < 1)
            return;
        const box = Info.boxes[0];
        if (Date.now() - Info.duration < box.getAttribute("time"))
            return;
        Info.boxes.shift();
        box.remove();
    },
    mouseDown: function (e) {
        if (!e.target.classList.contains("errorboxclosebutton")) {
            return;
        }
        const button = e.target;
        const bid = button.getAttribute("bid");
        Debugger.print("Info.BoxID:" + bid);
        for (var i = 0; i < Info.boxes.length; i++) {
            const box = Info.boxes[i];
            if (box.getAttribute("bid") == bid) {
                box.remove();
                Info.boxes.splice(i, 1);
                Info.updated = true;
                return;
            }
        }
    },
    error: function (data) {
        if (!data.message)
            data = { message: data };
        data.message = t(data.message);
        data.type = "error";
        Info.add(data);
    },
    success: function (data) {
        if (!data.message)
            data = { message: data };
        data.message = t(data.message);
        data.type = "success";
        Info.add(data);
    },
    info: function (data) {
        if (!data.message)
            data = { message: data };
        data.message = t(data.message);
        if (!data.type)
            data.type = "info";
        Info.add(data);
    },
    add: function (data) {
        const panel = document.getElementById("errorpanel");
        const box = document.createElement('div');
        box.classList.add("errorbox");
        if (data.type == "success") {
            box.style.backgroundColor = "rgba(122, 255, 158,0.8)";
        }
        else if (data.type == "info") {
            box.style.backgroundColor = "rgba(240,240,240,0.8)";
        }
        const button = document.createElement('div');
        button.classList.add("errorboxclosebutton");
        const boxID = Utils.id();
        button.setAttribute("bid", boxID);
        box.appendChild(button);
        const span = document.createElement('span');
        span.classList.add("errorboxtext");
        const txt = document.createTextNode(data.message);
        span.appendChild(txt);
        box.appendChild(span);
        box.setAttribute("bid", boxID);
        panel.appendChild(box);
        box.setAttribute("time", Date.now());
        Info.boxes.push(box);
        Info.updated = true;
    }
};
const t = function (key, params) {
    if (params == undefined) {
        const text = words[key];
        if (text == undefined)
            return key;
        return text;
    }
    let text = words[key];
    if (text == undefined)
        text = key;
    for (const p in params) {
        const param = params[p];
        text = text.replace("{{" + p + "}}", param);
    }
    return text;
};
const LanguageSelector = (props) => {
    const [selectedLanguage, setSelectedLanguage] = useState("en");
    function cleanUp() {
    }
    useEffect(() => { init(); return cleanUp; }, []);
    function init() {
    }
    ;
    function setLanguage(event) {
        language = event.target.value;
        SysRanger.language = language;
        if (SysRanger.remote) {
            RemoteSettings.save("language", language);
        }
        UserSettings.set("language", language);
        Call.setLanguage(language);
        setSelectedLanguage(language);
    }
    return (React.createElement("select", { onChange: setLanguage, value: SysRanger.language },
        React.createElement("option", { value: "en" }, "EN"),
        React.createElement("option", { value: "tr" }, "TR")));
};
const Post = function (data) {
    if (!data.url)
        return Info.error("Incorrect Post URL");
    if (!data.fn)
        return Info.error("Post doesn't have fn");
    if (!data.data)
        return Info.error("Post doesn't have data");
    if (data.fn.closed.current)
        return;
    let pdo = Utils.postDataOptions(data.data);
    fetch(data.url, pdo).then(res => res.json()).then((json) => {
        if (json.success) {
            if (data.success) {
                data.success(json);
            }
            if (data.refresh)
                Call.refresh();
            if (data.message)
                Info.success(data.message);
        }
        else {
            Info.error(json.error);
        }
    }, (error) => {
        Info.error(error.message);
    });
};
const SRHistoryController = (props) => {
    if (SRHistory.props != props) {
        SRHistory.props = props;
        SRHistory.run++;
        SRHistory.previous = window.location;
    }
    console.log("Data RUN:" + (SRHistory.run++) + " Previous:" + SRHistory.previous);
    return null;
};
const SRHistory = {
    run: 0,
    props: {},
    previous: null
};
const Status = (props) => {
    const [div, setDiv] = useState(React.createElement("div", null, "Hello"));
    const fn = { closed: useRef(false) };
    const data = props.data;
    let refreshTimeout = 0;
    function cleanUp() {
        fn.closed.current = true;
        clearTimeout(refreshTimeout);
    }
    useEffect(() => { fn.closed.current = false; load(); return cleanUp; }, [props.data]);
    function load() {
        if (fn.closed.current)
            return;
        clearTimeout(refreshTimeout);
        if (!data) {
            return Utils.setState(fn, setDiv, null);
        }
        if (data.success) {
            Utils.setState(fn, setDiv, React.createElement("div", null, data.success));
        }
        else {
            Utils.setState(fn, setDiv, React.createElement("div", { style: { color: Colors.red } }, data.error));
        }
        clearTimeout(refreshTimeout);
        refreshTimeout = setTimeout(clear, 30000);
    }
    function clear() {
        return Utils.setState(fn, setDiv, null);
    }
    return (React.createElement("div", null, div));
};
const TableFilters = {};
const TableSorting = {};
const Table = (props) => {
    const id = props.data.id;
    const [refreshing, setRefreshing] = useState(false);
    const [u, update] = useState(0);
    const [selectedRow, setSelectedRow] = useState(null);
    const [error, setError] = useState(false);
    const [data, setData] = useState(props.data);
    const [pagination, setPagination] = useState({ page: 0, start: 0, length: UserSettings.get("table_display_rows_" + id) ? UserSettings.get("table_display_rows_" + id) : Data.visibleRows });
    const refLength = createRef();
    const fn = { exited: false, closed: useRef(false) };
    fn.exited = fn.closed.current;
    function cleanUp() {
        fn.exited = true;
        fn.closed.current = true;
    }
    let recreate = props;
    if (props.data.loader) {
        recreate = id;
    }
    useEffect(() => {
        fn.closed.current = false;
        if (props.data.loader) {
            console.log("Table Props Changed. Loading...");
            loadData();
        }
        else {
            setData(props.data);
        }
        return cleanUp;
    }, [recreate]);
    function setSortingField(e) {
        e.preventDefault();
        const sorting = getSorting();
        const currentField = sorting.field;
        const newField = e.currentTarget.getAttribute('data-field');
        let direction = "ascending";
        if (currentField === newField) {
            direction = sorting.direction == "ascending" ? "descenting" : "ascending";
        }
        TableSorting[id] = { field: newField, direction: direction };
        Utils.setState(fn, setRefreshing, Utils.timeStamp());
    }
    function getSorting() {
        let sorting = TableSorting[id];
        if (!sorting) {
            sorting = { field: data.defaultSortField, direction: data.direction ? data.direction : "ascending" };
            TableSorting[id] = sorting;
        }
        return sorting;
    }
    function sort(rows, sortedField, direction) {
        if (!sortedField) {
            return;
        }
        rows.sort((a, b) => {
            if (a[sortedField] < b[sortedField]) {
                return direction === 'ascending' ? -1 : 1;
            }
            if (a[sortedField] > b[sortedField]) {
                return direction === 'ascending' ? 1 : -1;
            }
            return 0;
        });
    }
    function cellClicked(e) {
        e.preventDefault();
        const rowIndex = e.currentTarget.getAttribute('ri');
        const field = e.currentTarget.getAttribute('field');
        const value = data.rows[rowIndex][field];
        const content = React.createElement("textarea", { defaultValue: value, style: { width: "calc(100% - 10px)", height: "calc(100% - 10px)" } });
        Dialog.show({ content: content, render: true });
    }
    function filterInputChanged(e) {
        const input = e.target;
        const value = input.value;
        const field = input.getAttribute("data-field");
        if (!TableFilters[id])
            TableFilters[id] = {};
        TableFilters[id][field] = value;
        if (data) {
            parse(data);
            Utils.setState(fn, setRefreshing, Utils.random());
        }
    }
    function parse(data) {
        if (data.loader) {
            if (!data.success && data.error) {
                return Utils.error(data.error);
            }
        }
        if (!data.rows)
            return;
        let i = 0;
        const trs = [];
        const ths = [];
        const tfs = [];
        let rows = data.rows;
        if (!Array.isArray(rows))
            rows = [];
        const sortingEnabled = !data.nosorting;
        let filtered = false;
        const sorting = getSorting();
        if (sortingEnabled) {
            sort(rows, sorting.field, sorting.direction);
        }
        for (i = 0; i < data.headers.length; i++) {
            const header = data.headers[i];
            if (!header)
                continue;
            const style = {};
            if (header.field == sorting.field) {
                style.textDecoration = "underline";
            }
            if (header.right) {
                style.textAlign = "right";
            }
            const fieldSortable = !header.noSort;
            const clsName = sortingEnabled && fieldSortable ? "clickable" : "";
            const clickFn = sortingEnabled && fieldSortable ? setSortingField : null;
            const th = React.createElement("th", { key: id + "_th_" + i, title: t(header.title), className: clsName, onClick: clickFn, "data-field": header.field, style: style }, t(header.name));
            ths.push(th);
            let filterInput = null;
            if (header.filter) {
                filtered = true;
                const filterValue = TableFilters[id] && TableFilters[id][header.field] ? TableFilters[id][header.field] : "";
                filterInput = React.createElement("input", { type: "text", "data-field": header.field, className: "table_column_filter_input", onChange: filterInputChanged, value: filterValue, style: { width: "calc(100% - 20px)" } });
            }
            tfs.push(React.createElement("th", { style: { padding: "0px", border: "none", background: "none" }, key: id + "_tf_" + i }, filterInput));
        }
        if (!data.rowHeight) {
            data.rowHeight = "25px";
        }
        const rowids = {};
        for (i = 0; i < rows.length; i++) {
            const row = rows[i];
            const tds = [];
            let skipRow = false;
            for (let h = 0; h < data.headers.length; h++) {
                const header = data.headers[h];
                if (!header)
                    continue;
                const style = { overflow: "hidden", marginLeft: "5px", marginRight: "5px" };
                let value = header.field ? row[header.field] : header.value;
                if (header.number) {
                    value = "" + (i + 1);
                    header.width = "40px";
                    style.opacity = 0.6;
                    row.index = i + 1;
                }
                if (header.value)
                    value = header.value;
                if (header.valueFunction) {
                    value = header.valueFunction(row);
                    if (header.field)
                        row[header.field] = value;
                }
                if (header.filter &&
                    TableFilters[id] &&
                    TableFilters[id][header.field] &&
                    String(value).toUpperCase().indexOf((TableFilters[id][header.field]).toUpperCase()) < 0) {
                    skipRow = true;
                    break;
                }
                let tooltipText = header.tooltipText || null;
                const cellStyle = {};
                if (data.overlineremoved && row.rm) {
                    cellStyle.textDecoration = "line-through";
                }
                style.maxWidth = header.maxWidth || "100%";
                if (header.colors && header.colors[value]) {
                    style.color = header.colors[value];
                }
                if (header.removed && typeof header.removed === 'function' && header.removed(row)) {
                    cellStyle.textDecoration = "line-through";
                }
                if (header.colorRule) {
                    const c = header.colorRule(row);
                    if (c)
                        style.color = c;
                }
                if (header.colorFunction) {
                    const c = header.colorFunction(value);
                    if (c)
                        style.color = c;
                }
                if (header.color) {
                    style.color = header.color;
                }
                if (data.rowHeight && !header.multiline && !data.multiline) {
                    style.height = data.rowHeight;
                }
                if (header.height) {
                    style.height = header.height;
                }
                if (header.backgrounds && header.backgrounds[value]) {
                    cellStyle.background = header.backgrounds[value];
                }
                if (header.backgroundRule) {
                    cellStyle.background = header.backgroundRule(value);
                }
                const unformatted = value;
                if (header.format) {
                    value = header.format(value);
                }
                if (header.hideZero && value == 0) {
                    value = "";
                }
                if (header.center) {
                    style.textAlign = "center";
                }
                if (header.right) {
                    style.textAlign = "right";
                }
                let cropped = value;
                let onClick = Utils.noOp;
                if (value && value.length > 50 && !header.noCrop && !data.noCrop && !header.format && !header.html) {
                    cropped = value.substring(0, 50) + "...";
                    tooltipText = unformatted;
                    onClick = cellClicked;
                }
                if (header.showBox) {
                    onClick = cellClicked;
                }
                if (header.rowFormat) {
                    cropped = header.rowFormat(row);
                }
                if (header.onClick) {
                    if (header.icon) {
                        cropped = React.createElement("img", { src: "images/icons/" + header.icon, style: { cursor: "pointer", width: "20px" }, type: "svg" });
                        tooltipText = header.name;
                        style.textAlign = "center";
                        style.padding = "0px";
                        cellStyle.padding = "0px";
                    }
                    cropped = React.createElement("a", { href: "#", style: style, onClick: (e) => { e.preventDefault(); header.onClick(row, data); } }, cropped);
                    onClick = Utils.noOp;
                }
                if ((data.pale && (!header.emphasize)) || header.pale) {
                    style.opacity = 0.7;
                }
                if (header.type == "button") {
                    onClick = Utils.noOp;
                    const st = { padding: "1px" };
                    if (header.width)
                        st.width = header.width;
                    cellStyle.padding = "0px";
                    style.padding = "0px";
                    cropped = React.createElement("button", { style: st, onClick: (e) => { e.preventDefault(); header.onClick(row, data); } }, t(header.label || header.name));
                }
                if (header.html) {
                    onClick = Utils.noOp;
                    cropped = row[header.html];
                }
                if (header.tooltip) {
                    tooltipText = header.tooltip(row);
                }
                else if (!tooltipText) {
                    tooltipText = unformatted + "";
                }
                if (header.bar) {
                    onClick = Utils.noOp;
                    const st = { padding: "1px" };
                    const bar = header.bar;
                    if (header.width)
                        st.width = header.width;
                    cellStyle.padding = "0px";
                    style.padding = "0px";
                    cropped = React.createElement(ProgressBar, { data: { width: bar.width, value: value, id: "td_pb_" + i + "_" + h, notitle: true }, id: "td_pb_" + i + "_" + h });
                }
                if (header.width) {
                    style.width = header.width;
                    cellStyle.width = header.width;
                }
                if (data.nopadding || header.nopadding) {
                    cellStyle.padding = "0px";
                    style.padding = "0px";
                }
                if (header.multiline) {
                    let lines = cropped.split('\n');
                    let ln = 0;
                    cropped = lines.map((line) => React.createElement("div", { key: "ml_" + (ln++) }, line));
                }
                else {
                }
                if (header.formattedTooltip) {
                    tooltipText = cropped;
                }
                if (header.type == "progressbar") {
                    if (value < 0) {
                        cropped = "";
                    }
                    else {
                        cropped = React.createElement("div", { style: { width: "100%", color: "black", background: "#909090" } },
                            React.createElement("div", { style: { width: value + "%", background: value == 100 ? "#00FF00" : "#73c5ff" } }, value + " %"));
                    }
                }
                if (header.hide && header.hide(row)) {
                    cropped = "";
                }
                if (header.tooltipLoader)
                    tooltipText = null;
                let div = cropped;
                if (cropped !== "" && cropped !== " " && !data.nostyle) {
                    div = React.createElement("div", { className: "tddiv", style: style, ri: i, field: header.field, onClick: onClick, title: tooltipText, onMouseOver: header.tooltipLoader ? (e) => { TT.mouseOver(e, row); header.tooltipLoader(row); } : null, onMouseLeave: header.tooltipLoader ? TT.mouseOut : null }, cropped);
                }
                const td = React.createElement("td", { style: cellStyle, key: id + "_td_" + i + "_" + h }, div);
                tds.push(td);
            }
            if (skipRow)
                continue;
            let rowID = "tr_" + id + "_" + (row.id ? row.id : i);
            if (rowids[rowID])
                rowID += "_" + i;
            rowids[rowID] = true;
            const className = rowID == selectedRow ? "selected" : null;
            let rowStyle = {};
            if (data.rowStyle) {
                rowStyle = data.rowStyle(row);
            }
            const tableRow = React.createElement("tr", { style: rowStyle, key: rowID, id: rowID, className: className, onClick: () => selectRow(rowID), onContextMenu: data.rowContextMenu ? (e) => { rowContextMenu(e, row, data, rowID); return false; } : null }, tds);
            trs.push(tableRow);
            if (data.maxRows && i > data.maxRows)
                break;
        }
        function rowContextMenu(e, row, data, rowID) {
            e.preventDefault();
            e.stopPropagation();
            data.closeListener = () => {
                selectRow(null);
            };
            data.rowContextMenu(e, row, data);
            selectRow(rowID);
        }
        ;
        function selectRow(rowID) {
            Utils.setState(fn, setSelectedRow, rowID);
        }
        return React.createElement("table", { style: { width: "calc(100% - 2px)" }, key: id, id: "table_" + id, className: data.class },
            React.createElement("thead", null,
                filtered && React.createElement("tr", { key: id + "_filterrow" }, tfs),
                React.createElement("tr", { key: id + "_headerrow" }, ths)),
            React.createElement("tbody", { key: id + "_body" },
                trs,
                data.loader &&
                    React.createElement("tr", null,
                        React.createElement("td", { colSpan: "100", style: { border: "none" } },
                            React.createElement("a", { onClick: previousPage, style: { marginRight: "10px" } }, t("Previous")),
                            React.createElement("a", { onClick: nextPage }, t("Next"))))));
    }
    function loadData() {
        Timeouts.clearAll(id);
        if (fn.closed.current)
            return;
        const loader = data.loader;
        const variables = loader.variables;
        variables.start = pagination.start;
        variables.length = pagination.length;
        const pdo = Utils.postDataOptions(variables);
        Utils.setState(fn, setRefreshing, true);
        fetch(loader.url, pdo).then(res => res.json()).then((result) => {
            if (loader.listener) {
                loader.listener(result);
            }
            if (!result.success) {
                return Utils.setState(fn, setError, result.error);
            }
            data.total = result.total;
            data.start = result.start;
            data.end = result.end;
            data.tableRefreshTime = Utils.timeStamp();
            data.success = true;
            data.rows = result[loader.array];
            Utils.setState(fn, setData, data);
            Utils.setState(fn, setError, null);
            Utils.setState(fn, update, Utils.timeStamp());
        }, (error) => {
            return Utils.setState(fn, setError, Utils.error(error.message));
        }).then(() => {
            if (fn.closed.current)
                return;
            setTimeout(() => Utils.setState(fn, setRefreshing, false), Data.updateAnimationDisplayTime);
            Timeouts.add(id, setTimeout(loadData, data.loader.refresh ? data.loader.refresh : 10000));
        });
    }
    function previousPage() {
        const rows = pagination;
        let start = rows.start - Utils.toInt(rows.length);
        if (start < 0)
            start = 0;
        rows.start = start;
        rows.page = Utils.toInt(rows.start / rows.length);
        Utils.setState(fn, setPagination, rows);
        loadData();
    }
    function nextPage() {
        const rows = pagination;
        let start = rows.start + Utils.toInt(rows.length);
        if (start > data.total)
            start = rows.start;
        rows.start = start;
        rows.page = Utils.toInt(rows.start / rows.length);
        Utils.setState(fn, setPagination, rows);
        console.log(rows);
        loadData();
    }
    function getLengthSelect() {
        return React.createElement("select", { value: pagination.length, onChange: lengthChanged, ref: refLength },
            React.createElement("option", { value: "10" }, "10"),
            React.createElement("option", { value: "20" }, "20"),
            React.createElement("option", { value: "50" }, "50"),
            React.createElement("option", { value: "100" }, "100"),
            React.createElement("option", { value: "1000" }, "1000"));
    }
    function lengthChanged(e) {
        const rows = pagination;
        rows.length = e.target.value;
        if (rows.start + rows.length > data.total)
            rows.start = 0;
        rows.page = Utils.toInt(rows.start / rows.length);
        Utils.setState(fn, setPagination, rows);
        UserSettings.set("table_display_rows_" + id, rows.length);
        loadData();
    }
    function pageChanged(e) {
        const rows = pagination;
        rows.page = e.target.value;
        rows.start = rows.page * rows.length;
        Utils.setState(fn, setPagination, rows);
        loadData();
    }
    function getPageSelect() {
        const rows = pagination;
        const pages = Utils.toInt(data.total / rows.length);
        const options = [];
        const currentPage = rows.page;
        let def = currentPage;
        let increment = 1;
        if (pages > 1000) {
            increment = 100;
        }
        else if (pages > 250) {
            increment = 10;
        }
        else if (pages > 50) {
            increment = 2;
        }
        for (let i = 0; i < pages + 1; i += increment) {
            options.push(React.createElement("option", { key: "option_table_page_" + i, value: i }, i + 1));
            if (i <= currentPage)
                def = i;
        }
        return React.createElement("select", { value: def, onChange: pageChanged }, options);
    }
    let headerInfo = null;
    if (data.total) {
        headerInfo = React.createElement("div", { style: { clear: "both" } },
            data.loader && React.createElement("div", { className: "update_animation_box", style: { float: "right", marginRight: "10px", marginTop: "5px" } }, refreshing && Utils.updating()),
            React.createElement("span", { style: { marginRight: "10px", float: "left", paddingTop: "8px" } },
                t("Total"),
                " : ",
                data.total),
            React.createElement("span", { style: { marginRight: "30px", float: "left", paddingTop: "8px" } },
                t("Displaying"),
                " : ",
                data.start + 1,
                " - ",
                data.finish || data.end),
            data.loader &&
                React.createElement("div", { style: { float: "left" } },
                    getLengthSelect(),
                    React.createElement("span", { key: "span_padding_" + id, style: { paddingLeft: "20px" } }),
                    getPageSelect()));
    }
    const table = data ? parse(data) : null;
    return React.createElement("div", { className: "table_container", style: { overflow: "auto", paddingBottom: "5px", width: "100%", height: "calc(100% - 50px)" } },
        props.data.information && props.data.information,
        headerInfo,
        data.loader && data.tableRefreshTime && data.showLastUpdate && React.createElement("span", { className: "smallInfo" }, t("Last update time") + " : " + Utils.toDate(data.tableRefreshTime)),
        error && Utils.error(error),
        table);
};
const Tabs = (props) => {
    const id = props.id;
    const [currentTab, setTab] = useState(Data.tabs[id] ? Data.tabs[id] : props.default);
    function cleanUp() { }
    useEffect(() => { init(); return cleanUp; }, []);
    function init() {
        setTab(currentTab);
    }
    ;
    function onHeaderClick(e) {
        e.preventDefault();
        const tab = e.currentTarget.getAttribute('tab');
        setTab(tab);
        if (id) {
            Data.tabs[id] = tab;
        }
        if (props.listener) {
            props.listener(tab);
        }
    }
    const headers = [];
    let content = React.createElement("div", null);
    let tabSelected = false;
    React.Children.forEach(props.children, (child) => {
        if (!child)
            return;
        const tab = child.props.name;
        let cls = "tab_header";
        let select = false;
        if (tab == currentTab) {
            select = true;
        }
        else {
            if (!currentTab && !tabSelected) {
                select = true;
            }
        }
        if (select) {
            tabSelected = true;
            cls += "  selected";
            if (child.props.children) {
                content = child.props.children;
            }
        }
        const header = React.createElement("div", { key: "th_" + tab, className: cls, tab: tab, onClick: onHeaderClick }, t(child.props.label));
        headers.push(header);
    });
    if (!tabSelected && props.default) {
        setTab(props.default);
    }
    return (React.createElement("div", { key: "tabs_div" },
        headers,
        React.createElement("div", { className: "clear" }),
        React.createElement("div", { className: "tab_content_container" }, content)));
};
const Tab = (props) => {
    return (React.createElement("div", { key: "tab_" + props.key }));
};
const Timeouts = {
    timeouts: {},
    add: function (id, timeout) {
        Timeouts.clearAll(id);
        if (!this.timeouts.hasOwnProperty(id)) {
            this.timeouts[id] = [];
        }
        this.timeouts[id].push(timeout);
    },
    clearAll: function (id) {
        if (!this.timeouts.hasOwnProperty(id))
            return;
        const list = this.timeouts[id];
        for (let i = 0; i < list.length; i++) {
            clearTimeout(list[i]);
        }
    }
};
const Tooltip = (props) => {
    const [rnd, refresh] = useState({ show: 0, x: 0, y: 0, render: 0 });
    function mouseOver(e) {
        e.stopPropagation();
        const pos = position(e);
        refresh({ show: true, render: Utils.timeStamp(), x: pos.x, y: pos.y });
    }
    ;
    function mouseOut(e) {
        e.stopPropagation();
        refresh({ show: false, render: Utils.timeStamp(), x: 0, y: 0 });
    }
    function mouseMove(e) {
        e.stopPropagation();
        if (!rnd.show)
            return;
        const pos = position(e);
        refresh({ show: true, render: Utils.timeStamp(), x: pos.x, y: pos.y });
    }
    function position(e) {
        return { x: e.clientX + 5, y: e.clientY + 5 };
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { onMouseOver: mouseOver, onMouseLeave: mouseOut, onMouseMove: mouseMove, style: { display: "inline" } },
            props.content,
            React.createElement("div", { style: { display: "inline" } }, " *")),
        rnd.show > 0 &&
            React.createElement("div", { style: {
                    background: "#303030",
                    border: "1px solid #0273b5",
                    position: "fixed",
                    left: rnd.x,
                    top: rnd.y
                } },
                props.title &&
                    React.createElement("div", { style: { padding: "10px", color: "#0273b5", borderBottom: "1px solid #0273b5", marginBottom: "5px" } },
                        props.title,
                        "  "),
                React.createElement("div", { style: { padding: "10px" } }, props.children))));
};
const TT = {};
TT.x = 0;
TT.y = 0;
TT.text = "Loading...";
TT.loader = null;
TT.div = null;
TT.visible = false;
TT.element = null;
TT.init = function () {
    document.addEventListener("mousedown", TT.documentDown);
    document.addEventListener("mousemove", TT.documentMove);
    document.addEventListener("mouseout", TT.documentOut);
    TT.div = document.createElement("div");
    TT.div.classList.add("tooltipbox");
    TT.div.style["background"] = "#444";
    TT.div.style["border"] = "1px solid #888";
    TT.div.style.display = 'none';
    document.body.appendChild(TT.div);
};
TT.documentDown = function () {
    if (!TT.visible)
        return;
    TT.hide();
};
TT.mouseOver = function (e, data) {
    e.stopPropagation();
    TT.x = e.clientX + 5;
    TT.y = e.clientY + 5;
    TT.element = e.target;
    if (TT.loader)
        TT.loader(e, data);
};
TT.mouseOut = function (e) {
    if (!TT.visible)
        return;
    e.stopPropagation();
    TT.hide();
},
    TT.documentOut = function (e) {
        if (!TT.visible)
            return;
        TT.hide();
    },
    TT.documentMove = function (e) {
        if (!TT.visible)
            return;
        if (TT.element == null)
            return;
        if (e.target != TT.element) {
            TT.hide();
        }
    },
    TT.show = function (text) {
        TT.div.style["left"] = TT.x + "px";
        TT.div.style["top"] = TT.y + "px";
        TT.div.innerHTML = text;
        TT.div.style.display = 'block';
        TT.visible = true;
    };
TT.hide = function () {
    TT.div.style.display = 'none';
    TT.visible = false;
};
const Tree = (props) => {
    const data = props.data;
    const [carets, setCarets] = useState({});
    const [selected, setSelected] = useState(null);
    const maxChars = data.maxChars | 30;
    function itemClicked(e, item) {
        console.log("Key:" + item.key);
        const span = e.currentTarget;
        const isLeaf = span.getAttribute('leaf');
        const link = item.link;
        if (item.onClick) {
            item.onClick(item);
        }
        setSelected(item.key);
        if (isLeaf == "true") {
            if (data.leafListener) {
                data.leafListener(item);
            }
            return;
        }
    }
    function caretDown(e, item) {
        const caret = e.currentTarget;
        const li = caret.parentElement;
        const nested = li.querySelector(".nested");
        if (nested != null) {
            nested.classList.toggle("active");
        }
        carets[item.key] = caret.classList.toggle("caret-down");
        setCarets(carets);
    }
    function countClicked(item) {
        if (!data.countListener)
            return;
        data.countListener(item);
    }
    ;
    function getTree() {
        const root = data.root;
        const json = data.json;
        json.key = "root";
        const items = json.map(node => {
            node.parent = json;
            node.key = "root_" + node.n;
            const caretDown = carets[node.key] ? "active" : "";
            return React.createElement(ListItem, { item: node, active: caretDown, key: node.n });
        });
        if (!root) {
            return React.createElement("ul", { className: "tree" }, items);
        }
        return React.createElement("ul", { className: "tree" },
            React.createElement("li", null,
                React.createElement("span", { className: "caret", onClick: itemClicked }, root.name),
                React.createElement("ul", { className: "nested active", style: { paddingLeft: "20px" } }, items)));
    }
    ;
    function ListItem({ item, active }) {
        let children = null;
        item.key = item.parent.key + "_" + item.n;
        if (item.c && item.c.length) {
            children = (React.createElement("ul", { className: "nested " + active, style: { paddingLeft: "10px" } }, item.c.map(i => {
                i.parent = item;
                i.key = item.key + "_" + i.n;
                const caretDown = carets[i.key] ? "active" : "";
                return React.createElement(ListItem, { item: i, active: caretDown, key: i.n });
            })));
        }
        let title = null;
        let style = { paddingLeft: "5px" };
        const titleStyle = {};
        let icon = null;
        let leaf = false;
        let titleClass = "";
        if (item.opacity) {
            style.opacity = item.opacity;
        }
        if (selected && selected == item.key) {
            titleClass = " selected ";
        }
        if (data.icon) {
            icon = data.icon(item);
        }
        if (item.i) {
            let cls = Data.darkTheme && Utils.endsWith(item.i, "svg") ? "lighticon" : "";
            if (item.imageClass) {
                cls = item.imageClass;
            }
            icon = React.createElement("img", { className: cls, key: "ti_" + item.n, src: "images/icons/" + item.i, width: "24", style: { marginBottom: "-6px", paddingRight: "4px" } });
        }
        let label = item.label || item.n;
        if ((typeof label == "string") && label.length > maxChars)
            label = label.substring(0, maxChars);
        let titleText = [icon, label];
        let additionalItems = [React.createElement("span", { key: "tai_" + item.n }, "\u00A0")];
        if (item.link) {
            titleText = [React.createElement("a", { key: "tta_" + item.n, className: "nostyle treelink", href: item.link },
                    icon,
                    label)];
        }
        if (item.items) {
            for (let i = 0; i < item.items.length; i++) {
                const it = item.items[i];
                additionalItems.push(it);
            }
        }
        let tooltipText = item.n;
        if (data.tooltip) {
            tooltipText = data.tooltip(item);
        }
        if (item.tooltip) {
            tooltipText = item.tooltip(item);
        }
        if (item.tooltipText) {
            tooltipText = item.tooltipText;
        }
        if (item.titleOpacity) {
            titleStyle["opacity"] = 0.7;
            ;
        }
        const clicked = (e) => itemClicked(e, item);
        if (children) {
            title = [React.createElement("span", { key: "caret_" + item.n, className: "caret " + (active == "active" ? "caret-down" : ""), onClick: (e) => caretDown(e, item) })];
            title.push(React.createElement("span", { key: "it_" + item.name, onClick: clicked, title: tooltipText, style: titleStyle }, titleText));
            if (item.action) {
                title.push(React.createElement("span", { style: { float: "right" }, key: "ac_" + item.n },
                    " ",
                    React.createElement("img", { className: Data.darkTheme && Utils.endsWith(item.action.icon, "svg") ? "lighticon" : "", src: "images/icons/" + item.action.icon, width: "20", onClick: (e) => item.action.onClick(item) }),
                    "         "));
            }
            if (item.count && data.showCount && item.count > data.showCount) {
                title.push(React.createElement("span", { className: "treeChildCount", key: "count_" + item.n, title: "Show All", onClick: () => countClicked(item) },
                    "(" + item.count,
                    React.createElement("img", { src: "/images/icons/ic_more_horiz_24px_narrow.svg", width: "24", style: { opacity: 0.6 } }),
                    ")"));
            }
        }
        else {
            style.paddingLeft = "5px";
            title = React.createElement("span", { className: "leaf", leaf: "true", onClick: clicked, title: tooltipText, style: titleStyle }, titleText);
            leaf = true;
        }
        return (React.createElement("li", { style: style, className: titleClass, onContextMenu: item.contextMenu ? (e) => { contextMenu({ e: e, item: item }); return false; } : null },
            title,
            additionalItems.length > 1 && additionalItems,
            children));
    }
    ;
    function contextMenu(data) {
        data.e.preventDefault();
        data.e.stopPropagation();
        data.item.contextMenu(data);
    }
    const tree = getTree();
    return (React.createElement("div", { style: { paddingLeft: "20px" } }, tree));
};
const ABAPDashboard = (props) => {
    const instanceID = props.match.params.id;
    const [dashboard, setDashboard] = useState({ loaded: false, error: "", id: instanceID });
    const fn = { closed: useRef(false) };
    const timeoutID = "abapdashboard_";
    function cleanUp() {
        fn.closed.current = true;
        Timeouts.clearAll(timeoutID);
    }
    useEffect(() => {
        fn.closed.current = false;
        loadData();
        return cleanUp;
    }, [instanceID]);
    function loadData() {
        Timeouts.clearAll(timeoutID);
        if (fn.closed.current)
            return;
        let pdo = Utils.postDataOptions({ op: "abapdashboard", id: instanceID });
        fetch(apiURL + "sapdashboard", pdo).then(res => res.json()).then((result) => {
            result.loaded = true;
            if (result.success) {
                Utils.setState(fn, setDashboard, result);
            }
            else {
                Utils.setState(fn, setDashboard, { loaded: true, error: result.error });
            }
        }, (error) => {
            Utils.setState(fn, setDashboard, { loaded: true, error: error.message });
        }).then(() => {
            if (fn.closed.current)
                return;
            Timeouts.add(timeoutID, setTimeout(loadData, 5000));
        });
    }
    function wpUnit(val) {
        return val;
    }
    function getPage() {
        if (!dashboard.loaded)
            return null;
        if (dashboard.error) {
            return Utils.error(dashboard.error);
        }
        const wpcs = [];
        if (dashboard["wpcs.ukn"])
            wpcs.push({ value: dashboard["wpcs.ukn"], color: Colors.gray, text: "Unknown", unit: wpUnit });
        if (dashboard["wpcs.dia"])
            wpcs.push({ value: dashboard["wpcs.dia"], color: Colors.green, text: "Dialog", unit: wpUnit });
        if (dashboard["wpcs.btc"])
            wpcs.push({ value: dashboard["wpcs.btc"], color: Colors.red, text: "Background", unit: wpUnit });
        if (dashboard["wpcs.upd"])
            wpcs.push({ value: dashboard["wpcs.upd"], color: Colors.yellow, text: "Update", unit: wpUnit });
        if (dashboard["wpcs.upd2"])
            wpcs.push({ value: dashboard["wpcs.upd2"], color: Colors.orange, text: "Update2", unit: wpUnit });
        if (dashboard["wpcs.sp0"])
            wpcs.push({ value: dashboard["wpcs.sp0"], color: Colors.lightBlue, text: "Spool", unit: wpUnit });
        if (dashboard["wpcs.enq"])
            wpcs.push({ value: dashboard["wpcs.enq"], color: Colors.blue, text: "Enque", unit: wpUnit });
        const page = React.createElement("div", { className: "panelcontainer" },
            React.createElement("div", { className: "panel flexmargin", style: { width: "285px", height: "204px" } },
                React.createElement("div", { className: "panel_title" }, "CPU"),
                React.createElement(Gauge2, { data: { size: 280,
                        value: dashboard["cpu.percentage"],
                        text: Utils.toInt(dashboard["cpu.percentage"]) + " %",
                        limits: { warning: dashboard["cpu.warning"],
                            critical: dashboard["cpu.critical"],
                            fatal: dashboard["cpu.fatal"],
                            total: 100
                        }
                    } })),
            React.createElement("div", { className: "panel flexmargin", style: { width: "285px", height: "204px" } },
                React.createElement("div", { className: "panel_title" }, "Memory"),
                React.createElement(Gauge2, { data: { size: 280,
                        value: dashboard["memory.percentage"],
                        text: Utils.toInt(dashboard["memory.percentage"]) + " %",
                        limits: { warning: dashboard["memory.warning"],
                            critical: dashboard["memory.critical"],
                            fatal: dashboard["memory.fatal"],
                            total: 100
                        }
                    } })),
            React.createElement("div", { className: "panel flexmargin", style: { width: "600px", height: "205px", textAlign: "left" } },
                React.createElement("div", { className: "panel_title" }, "Workprocesses"),
                wpcs.length > 0 &&
                    React.createElement(Pie, { key: "pie_wpcs_" + instanceID.id, data: {
                            unit: wpUnit,
                            lineWidth: 60,
                            size: 180,
                            showInfo: true,
                            items: wpcs
                        } })),
            React.createElement("div", { className: "clear" }));
        return page;
    }
    function back(e) {
        e.preventDefault();
        cleanUp();
        Utils.goBack(props.history);
    }
    let title = t("ABAP Dashboard");
    if (dashboard["i.name"]) {
        title += " : " + dashboard["i.system"] + " > " + dashboard["i.name"];
    }
    return (React.createElement("div", { id: 'page' },
        React.createElement(Header, { back: back, title: title }),
        getPage(),
        React.createElement(WPTableStats, { instanceid: instanceID }),
        React.createElement("div", { style: { clear: "both", height: "30px" } }),
        React.createElement(InstanceABAPWPTable, { instanceID: instanceID }),
        React.createElement("div", { style: { clear: "both", height: "30px" } })));
};
const Dashboard1 = (props) => {
    const [divDashboard, setDivDashboard] = useState(null);
    const [refreshing, setRefreshing] = useState(true);
    const fn = { closed: useRef(false) };
    const timeOutID = "dashboard1";
    function cleanUp() {
        fn.closed.current = true;
        Timeouts.clearAll(timeOutID);
    }
    useEffect(() => { fn.closed.current = false; loadData(); return cleanUp; }, [props]);
    function loadData() {
        Timeouts.clearAll(timeOutID);
        if (fn.closed.current)
            return;
        Utils.setState(fn, setRefreshing, true);
        let pdo = Utils.postDataOptions({ op: "list",
            basic: Data.dashboardBasicMode });
        fetch(apiURL + "dashboard", pdo).then(res => res.json()).then((result) => {
            Utils.setState(fn, setDivDashboard, parse(result));
        }, (error) => {
            Utils.setState(fn, setDivDashboard, Utils.error(error.message));
        }).then(() => {
            if (fn.closed.current)
                return;
            setTimeout(() => Utils.setState(fn, setRefreshing, false), 1000);
            Timeouts.add(timeOutID, setTimeout(loadData, 5000));
        });
    }
    ;
    function reset() {
        Timeouts.clearAll(timeOutID);
        loadData();
    }
    function parse(json) {
        if (!json.success) {
            return Utils.error(json.error);
        }
        const data = { groups: {}, systems: {}, hosts: {}, instances: {}, databases: {}, advanced: json.advanced };
        let i = 0;
        for (i = 0; i < json.systems.length; i++) {
            const system = json.systems[i];
            system.instances = [];
            system.hosts = [];
            system.databases = [];
            data.systems[system.id] = system;
        }
        for (i = 0; i < json.groups.length; i++) {
            const group = json.groups[i];
            group.systems = [];
            group.instances = [];
            group.hosts = [];
            group.databases = [];
            data.groups[group.id] = group;
        }
        for (i = 0; i < json.hosts.length; i++) {
            const host = json.hosts[i];
            host.instances = [];
            host.databases = [];
            data.hosts[host.id] = host;
        }
        for (i = 0; i < json.instances.length; i++) {
            const instance = json.instances[i];
            data.instances[instance.id] = instance;
            instance.host = data.hosts[instance.hid];
            instance.host.instances.push(instance);
            instance.system = data.systems[instance.sid];
            instance.system.instances.push(instance);
        }
        for (let i = 0; i < json.databases.length; i++) {
            const database = json.databases[i];
            data.databases[database.id] = database;
            database.host = data.hosts[database.hid];
            if (database.host) {
                database.host.databases.push(database);
            }
            database.system = data.systems[database.sid];
            if (database.system) {
                database.system.databases.push(database);
            }
        }
        const divs = [];
        const vals = [];
        if (!Utils.isEmpty(data.groups)) {
            vals.push({ label: "Groups", divs: parseGroups(data) });
        }
        vals.push({ label: "Systems", divs: parseSystems(data) });
        if (!Utils.isEmpty(data.hosts)) {
            vals.push({ label: "Hosts", divs: parseUnits(data) });
        }
        if (!Utils.isEmpty(data.instances)) {
            vals.push({ label: "SAP Instances", divs: parseInstances(data) });
        }
        if (!Utils.isEmpty(data.databases)) {
            vals.push({ label: "Databases", divs: parseDatabases(data) });
        }
        for (var v = 0; v < vals.length; v++) {
            const val = vals[v];
            divs.push(React.createElement("div", { key: "dsbt_" + v, className: "h2", style: { marginBottom: "20px" } }, t(val.label)));
            divs.push(React.createElement("div", { key: "dsbd_" + v },
                " ",
                val.divs));
            divs.push(React.createElement("div", { key: "dsbc_" + v, className: "clear" }));
        }
        if (!Utils.isEmpty(data.hosts)) {
            divs.push(React.createElement("div", { key: "hhostmatrix_title", className: "h2", style: { marginBottom: "20px" } }, t("Host Matrix")));
            divs.push(React.createElement("div", { key: "hostgraph" },
                " ",
                React.createElement(HostGraph, { size: "300" }),
                "    "));
        }
        return React.createElement("div", null,
            React.createElement("span", { className: "pale" },
                t("Last Update Time"),
                " :  ",
                Utils.date()),
            React.createElement("br", null),
            divs);
    }
    function parseGroups(json) {
        const groups = [];
        for (const key in json.groups) {
            const group = json.groups[key];
            const style = { minHeight: json.advanced ? "25px" : "20px" };
            style.background = Utils.alertColor2(group.mat);
            let title = "";
            const alerts = group.aa > 0 && React.createElement("a", { href: "#/alerts/?gid=" + group.id, title: "Alerts", className: "dashboard_alert_box", style: { color: "#cc0000" } },
                " ",
                group.aa,
                " ");
            const div = React.createElement("div", { style: style, key: "s_" + group.id, className: "dashboard_box", title: title },
                React.createElement("a", { href: "#view/group/" + group.id, className: "nostyle bold" },
                    group.cd,
                    " (",
                    group.nm,
                    ")"),
                alerts,
                group.pc > 0 &&
                    React.createElement("div", { style: { float: "right", marginRight: "-7px", marginTop: "-8px", opacity: "0.8" }, title: group.pc == 1 ? t("Probes are connected") : t("Probes are not connected") }, group.pc == 1 ?
                        React.createElement("img", { width: "14", src: "images/icons/png/circle_green.png", style: { opacity: 0.4 } }) :
                        React.createElement("img", { className: "blink", width: "14", src: "images/icons/png/circle_red.png" })));
            groups.push(div);
        }
        return React.createElement("div", null, groups);
    }
    ;
    function parseSystems(json) {
        const systems = [];
        for (const key in json.systems) {
            const system = json.systems[key];
            const style = { minHeight: json.advanced ? "70px" : "20px" };
            style.background = Utils.alertColor2(system.mat);
            let title = "";
            for (let sh = 0; sh < system.hostids.length; sh++) {
                const hid = system.hostids[sh];
                const host = json.hosts[hid];
                if (!host)
                    continue;
                title += host.n + "\n";
            }
            const instanceDivs = json.advanced ? getInstances(system) : null;
            const alerts = system.aa > 0 && React.createElement("a", { href: "#/alerts/?sid=" + system.id, title: "Alerts", className: "dashboard_alert_box", style: { color: "#cc0000" } },
                " ",
                system.aa,
                " ");
            const div = React.createElement("div", { style: style, key: "s_" + system.id, className: "dashboard_box", title: title },
                React.createElement("a", { href: "#view/system/" + system.id, className: "textColor nostyle bold" },
                    system.code,
                    " (",
                    system.name,
                    ")"),
                alerts,
                system.hostids.length > 0 && system.pc > 0 &&
                    React.createElement("div", { style: { float: "right", marginRight: "-7px", marginTop: "-8px", opacity: "0.8" }, title: system.pc == 1 ? t("Probes are connected") : t("Probes are not connected") }, system.pc == 1 ?
                        React.createElement("img", { width: "14", src: "images/icons/png/circle_green.png", style: { opacity: 0.4 } }) :
                        React.createElement("img", { className: "blink", width: "14", src: "images/icons/png/circle_red.png" })),
                React.createElement("div", null,
                    "     ",
                    instanceDivs));
            systems.push(div);
        }
        if (systems.length < 1) {
            systems.push(React.createElement("div", { key: "add_new_system" },
                " Firstly you need to create a system. Then define hosts inside.  Please  ",
                React.createElement("a", { href: "#add-new-system" }, "click here to create a system  "),
                "  "));
        }
        return React.createElement("div", null, systems);
    }
    ;
    function parseUnits(json) {
        const advanced = json.advanced;
        const divHosts = [];
        for (const key in json.hosts) {
            const host = json.hosts[key];
            const style = { minHeight: advanced ? "90px" : "20px", textAlign: "left" };
            const cpu = { cpu: host.cpu, memory: host.mem, id: host.ip };
            style.background = Utils.alertColor2(host.mat);
            if (!host.ok) {
                cpu.cpu = -1;
                cpu.memory = 0;
            }
            if (cpu.cpu == "-")
                cpu.cpu = -1;
            if (cpu.memory == "-")
                cpu.memory = 0;
            const instanceDivs = advanced ? getInstances(host) : null;
            const alerts = host.aa > 0 && React.createElement("a", { href: "#/alerts/?hid=" + host.id, title: "Alerts", className: "dashboard_alert_box", style: { color: "#cc0000" } },
                " ",
                host.aa,
                " ");
            const div = React.createElement("div", { key: "host_" + host.id, className: "dashboard_box", style: style },
                React.createElement("a", { href: "#unit-details/" + host.id, key: "h_" + host.ip, className: "textColor nostyle bold" },
                    React.createElement("div", { style: { float: "left" }, title: host.a },
                        "  ",
                        host.n,
                        " (",
                        host.ip,
                        ") ")),
                alerts,
                host.pc > 0 &&
                    React.createElement("div", { style: { float: "right", marginRight: "-7px", marginTop: "-8px", opacity: "0.8" }, title: host.pc == 1 ? t("Probe is connected") : t("Probe is not connected") }, host.pc == 1 ?
                        React.createElement("img", { width: "14", src: "images/icons/png/circle_green.png", style: { opacity: 0.4 } }) :
                        React.createElement("img", { className: "blink", width: "14", src: "images/icons/png/circle_red.png" })),
                React.createElement("div", { className: "clear" }),
                advanced && React.createElement(CPUMemoryLine, { data: cpu }),
                React.createElement("div", null,
                    "     ",
                    instanceDivs));
            divHosts.push(div);
        }
        return React.createElement("div", null, divHosts);
    }
    ;
    function parseInstances(json) {
        const divs = [];
        for (const key in json.instances) {
            const instance = json.instances[key];
            const style = {};
            style.background = Utils.alertColor2(instance.mat);
            const host = json.hosts[instance.hid];
            const alerts = instance.aa > 0 && React.createElement("a", { href: "#/alerts/?inid=" + instance.id, title: "Alerts", className: "dashboard_alert_box", style: { color: "#cc0000" } },
                " ",
                instance.aa,
                " ");
            const div = React.createElement("div", { className: "dashboard_box", style: style, key: "i_" + instance.id },
                React.createElement("a", { href: "#instance/" + instance.id, key: "ins_" + instance.id, className: "textColor nostyle bold", title: t("Name") + ":" + instance.n + "\n" + t("System") + ":" + instance.scode + "\n" + t("Host") + ":" + (host ? host.n + " (" + host.ip + ")" : "") },
                    instance.scode,
                    " - ",
                    instance.nr,
                    " (",
                    instance.n,
                    ")"),
                instance.pc > 0 &&
                    React.createElement("div", { style: { float: "right", marginRight: "-7px", marginTop: "-8px", opacity: "0.8" }, title: instance.pc == 1 ? t("Probe is connected") : t("Probe is not connected") }, instance.pc == 1 ?
                        React.createElement("img", { width: "14", src: "images/icons/png/circle_green.png", style: { opacity: 0.4 } }) :
                        React.createElement("img", { className: "blink", width: "14", src: "images/icons/png/circle_red.png" })),
                alerts);
            divs.push(div);
        }
        return React.createElement("div", null, divs);
    }
    function parseDatabases(json) {
        const advanced = json.advanced;
        const divDatabases = [];
        for (const key in json.databases) {
            const database = json.databases[key];
            const style = { minHeight: json.advanced ? "60px" : "20px" };
            style.background = Utils.alertColor2(database.mat);
            const alerts = database.aa > 0 && React.createElement("a", { href: "#/alerts/?dbid=" + database.id, title: "Alerts", className: "dashboard_alert_box", style: { color: "#cc0000" } },
                " ",
                database.aa,
                " ");
            const div = React.createElement("div", { style: style, key: "db_" + database.id, className: "dashboard_box" },
                React.createElement("a", { href: "#database/" + database.id, key: "db" + database.id, className: "textColor nostyle bold", title: database.alias },
                    database.name,
                    " (",
                    database.tn,
                    ")"),
                alerts,
                database.pc > 0 &&
                    React.createElement("div", { style: { float: "right", marginRight: "-7px", marginTop: "-8px", opacity: "0.8" }, title: database.pc == 1 ? t("Probe is connected") : t("Probe is not connected") }, database.pc == 1 ?
                        React.createElement("img", { width: "14", src: "images/icons/png/circle_green.png", style: { opacity: 0.4 } }) :
                        React.createElement("img", { className: "blink", width: "14", src: "images/icons/png/circle_red.png" })),
                advanced &&
                    React.createElement("div", { key: "dbspace_line" + database.id, style: { height: "30px", width: "100%" } },
                        React.createElement("div", { style: { width: (database.dpct < 1 ? 1 : database.dpct) + "%", height: "10px", background: "#999", marginTop: "5px" }, title: "Data used:" + Math.floor(database.dpct) + " %" }, " "),
                        React.createElement("div", { style: { width: (database.lpct < 1 ? 1 : database.lpct) + "%", height: "10px", background: "#999", marginTop: "5px" }, title: "Log used:" + Math.floor(database.lpct) + " %" }, " ")));
            divDatabases.push(div);
        }
        return React.createElement("div", null, divDatabases);
    }
    ;
    function getInstances(item) {
        const divs = [];
        for (let i = 0; i < item.instances.length; i++) {
            const instance = item.instances[i];
            const background = Utils.alertColor2(instance.mat);
            let title = "Instance:" + instance.n;
            if (instance.host) {
                title += "\nHost:" + instance.host.a + " - " + instance.host.n + " [" + instance.host.ip + "]";
            }
            divs.push(React.createElement("div", { key: "ii_" + item.id + "_" + instance.id, title: title, style: { background: background, float: "left", padding: "4px", marginRight: "5px" } },
                instance.n,
                " "));
        }
        for (let d = 0; d < item.databases.length; d++) {
            const database = item.databases[d];
            const background = Utils.alertColor2(database.mat);
            let title = database.name + " (" + database.tn + ")";
            if (database.host) {
                title += "\nHost:" + database.host.a + " - " + database.host.n + " [" + database.host.ip + "]";
            }
            divs.push(React.createElement("div", { key: "id_" + item.id + "_" + database.id, title: title, style: { background: background, float: "left", padding: "4px", marginRight: "5px" } }, database.name));
        }
        return divs;
    }
    function switchMode() {
        Data.dashboardBasicMode = !Data.dashboardBasicMode;
        reset();
    }
    return (React.createElement("div", { id: 'panel_dashboard_1' },
        React.createElement(IconButton, { icon: "graph2.svg", onClick: switchMode, style: { float: "right", marginLeft: "10px" }, title: "Advanced" }),
        divDashboard,
        React.createElement("div", { className: "clear" })));
};
const DashboardView = (props) => {
    const [r, refresh] = useState(0);
    const fn = { closed: useRef(false) };
    const itemType = props.match.params.type;
    const itemID = props.match.params.id;
    function cleanUp() {
        fn.closed.current = true;
    }
    function back(e) {
        e.preventDefault();
        cleanUp();
        Utils.goBack(props.history);
    }
    useEffect(() => { fn.closed.current = false; init(); return cleanUp; }, [props]);
    function init() {
        Utils.setState(fn, refresh, Utils.timeStamp());
    }
    let view = null;
    let title = "";
    switch (itemType) {
        case "group":
            view = React.createElement(ViewGroup, { gid: itemID });
            title = "Systems";
            break;
        case "system":
            view = React.createElement(ViewSystem, { sid: itemID });
            title = "Hosts";
            break;
        case "host":
            view = React.createElement(ViewHost, { shid: itemID });
            title = "Instances";
            break;
        default: view = React.createElement("div", null, "Incorrect url parameters ");
    }
    return (React.createElement("div", { id: 'page' },
        React.createElement(Header, { back: back, title: t("View") + " " + title }),
        view));
};
const HostGraph = (props) => {
    const [divContent, setContent] = useState(null);
    const fn = { closed: useRef(false) };
    let refreshTimeout = 0;
    function cleanUp() {
        fn.closed.current = true;
        clearTimeout(refreshTimeout);
    }
    useEffect(() => { fn.closed.current = false; loadData(); return cleanUp; }, [props]);
    function loadData() {
        if (fn.closed.current)
            return;
        let pdo = Utils.postDataOptions({ op: "reachablehosts" });
        fetch(apiURL + "dashboard", pdo).then(res => res.json()).then((result) => {
            Utils.setState(fn, setContent, parse(result));
        }, (error) => {
            Utils.setState(fn, setContent, Utils.error(error.message));
        }).then(() => {
            if (fn.closed.current)
                return;
            refreshTimeout = setTimeout(loadData, 10000);
        });
    }
    ;
    function parse(json) {
        if (!json.success) {
            return Utils.error(json.error);
        }
        const items = [];
        const green = "rgba(0, 255, 89, 0.5)";
        const red = "rgba(255, 0, 0, 0.5)";
        const yellow = "rgba(225, 220, 0, 0.5)";
        for (let i = 0; i < json.hosts.length; i++) {
            const host = json.hosts[i];
            host.color = host.ok ? green : red;
            if (host.ok && host.aa > 0) {
                host.color = yellow;
            }
            host.infos = [{ label: "Name", value: host.nm },
                { label: "Description", value: host.al },
                { label: "IP", value: host.ip },
                { label: "Alerts", value: host.aa }
            ];
            items.push(host);
        }
        console.log("ostHraph Refresh");
        return React.createElement(StatusBoxes, { data: { size: 200, items: items } });
    }
    return (React.createElement("div", { id: 'panel_host_graph' }, divContent));
};
const ViewGroup = (props) => {
    const [divDashboard, setDivDashboard] = useState(null);
    const [refreshing, setRefreshing] = useState(true);
    const fn = { closed: useRef(false) };
    let refreshTimeout = 0;
    const backgroundGreen = "rgba(0, 255, 89, 0.2)";
    const backgroundRed = "rgba(255, 0, 0, 0.2)";
    const backgroundYellow = "rgba(225, 230, 0, 0.2)";
    const gid = props.gid;
    function cleanUp() {
        fn.closed.current = true;
        clearTimeout(refreshTimeout);
    }
    useEffect(() => { fn.closed.current = false; init(); return cleanUp; }, [props]);
    function init() {
        loadData();
    }
    function loadData() {
        if (fn.closed.current)
            return;
        Utils.setState(fn, setRefreshing, true);
        let pdo = Utils.postDataOptions({ op: "systems", gid: gid });
        fetch(apiURL + "dashboard", pdo).then(res => res.json()).then((result) => {
            Utils.setState(fn, setDivDashboard, parse(result));
        }, (error) => {
            Utils.setState(fn, setDivDashboard, Utils.error(error.message));
        }).then(() => {
            if (fn.closed.current)
                return;
            setTimeout(() => Utils.setState(fn, setRefreshing, false), 1000);
            refreshTimeout = setTimeout(loadData, 10000);
        });
    }
    ;
    function parse(json) {
        if (!json.success) {
            return Utils.error(json.error);
        }
        History.dashboard.group = { index: 1, name: json.cd, link: "view/group/" + gid, title: json.nm };
        History.remove("dashboard", "host,system");
        json.systems.sort((a, b) => {
            return a.do - b.do;
        });
        const systems = [];
        for (const key in json.systems) {
            const system = json.systems[key];
            const style = { minHeight: json.advanced ? "60px" : "20px" };
            style.background = Utils.alertColor2(system.mat);
            const title = "";
            const alerts = system.aa > 0 && React.createElement("a", { href: "#/alerts/?sid=" + system.id, title: "Alerts", className: "dashboard_alert_box", style: { color: "#cc0000" } },
                " ",
                system.aa,
                " ");
            const div = React.createElement("div", { style: style, key: "s_" + system.id, className: "dashboard_box", title: title },
                system.cc ? React.createElement("a", { href: "#view/system/" + system.id, className: "textColor nostyle bold" },
                    system.cd,
                    " (",
                    system.nm,
                    ")") :
                    React.createElement("span", { className: "textColor nostyle bold" },
                        system.cd,
                        " (",
                        system.nm,
                        ")"),
                alerts,
                system.pc > 0 &&
                    React.createElement("div", { style: { float: "right", marginRight: "-7px", marginTop: "-8px", opacity: "0.8" }, title: system.pc == 1 ? t("Probes are connected") : t("Probes are not connected") }, system.pc == 1 ?
                        React.createElement("img", { width: "14", src: "images/icons/png/circle_green.png", style: { opacity: 0.4 } }) :
                        React.createElement("img", { className: "blink", width: "14", src: "images/icons/png/circle_red.png" })));
            systems.push(div);
        }
        return React.createElement("div", null,
            React.createElement("h2", null,
                json.cd,
                " - ",
                json.nm,
                " "),
            systems);
    }
    return (React.createElement("div", { id: 'panel_view_group' },
        History.links("dashboard"),
        divDashboard));
};
const ViewHost = (props) => {
    const [divDashboard, setDivDashboard] = useState(null);
    const [refreshing, setRefreshing] = useState(true);
    const fn = { closed: useRef(false) };
    let refreshTimeout = 0;
    const backgroundGreen = "rgba(0, 255, 89, 0.2)";
    const backgroundRed = "rgba(255, 0, 0, 0.2)";
    const backgroundYellow = "rgba(225, 230, 0, 0.2)";
    const shid = props.shid;
    function cleanUp() {
        fn.closed.current = true;
        clearTimeout(refreshTimeout);
    }
    useEffect(() => { fn.closed.current = false; loadData(); return cleanUp; }, [props]);
    function loadData() {
        if (fn.closed.current)
            return;
        Utils.setState(fn, setRefreshing, true);
        const parts = shid.split("-");
        if (parts.length < 2)
            return Utils.setState(fn, setDivDashboard, Utils.error("Incorrect parameters"));
        const sid = parts[0];
        const hid = parts[1];
        let pdo = Utils.postDataOptions({ op: "hostchildren", sid: sid, hid: hid });
        fetch(apiURL + "dashboard", pdo).then(res => res.json()).then((result) => {
            Utils.setState(fn, setDivDashboard, parse(result));
        }, (error) => {
            Utils.setState(fn, setDivDashboard, Utils.error(error.message));
        }).then(() => {
            if (fn.closed.current)
                return;
            setTimeout(() => Utils.setState(fn, setRefreshing, false), 1000);
            refreshTimeout = setTimeout(loadData, 10000);
        });
    }
    ;
    function parse(json) {
        if (!json.success) {
            return Utils.error(json.error);
        }
        History.dashboard.host = { index: 3, name: json.hcd, link: "view/host/" + shid, title: json.scd + " " + json.hnm };
        const instances = parseInstances(json);
        const databases = parseDatabases(json);
        return React.createElement("div", null,
            React.createElement("h2", null,
                json.scd,
                " - ",
                json.snm,
                " /  ",
                json.hcd,
                " - ",
                json.hnm,
                "  "),
            React.createElement("h2", null, "Instances "),
            instances,
            React.createElement("div", { className: "clear" }),
            React.createElement("h2", null, "Databases "),
            databases);
    }
    function parseInstances(json) {
        const divs = [];
        for (const key in json.instances) {
            const instance = json.instances[key];
            const style = {};
            style.background = Utils.alertColor2(instance.mat);
            const alerts = instance.aa > 0 && React.createElement("a", { href: "#/alerts/?inid=" + instance.id, title: "Alerts", className: "dashboard_alert_box", style: { color: "#cc0000" } },
                " ",
                instance.aa,
                " ");
            const div = React.createElement("div", { style: style, key: "i_" + instance.id, className: "dashboard_box" },
                React.createElement("a", { href: "#instance/" + instance.id, key: "ins_" + instance.id, className: "textColor nostyle bold" },
                    json.scd,
                    " - ",
                    instance.cd,
                    " (",
                    instance.nm,
                    ")"),
                alerts,
                instance.pc > 0 &&
                    React.createElement("div", { style: { float: "right", marginRight: "-7px", marginTop: "-8px", opacity: "0.8" }, title: instance.pc == 1 ? t("Probe is connected") : t("Probe is not connected") }, instance.pc == 1 ?
                        React.createElement("img", { width: "14", src: "images/icons/png/circle_green.png", style: { opacity: 0.4 } }) :
                        React.createElement("img", { className: "blink", width: "14", src: "images/icons/png/circle_red.png" })));
            divs.push(div);
        }
        return React.createElement("div", null, divs);
    }
    function parseDatabases(json) {
        const divDatabases = [];
        for (const key in json.databases) {
            const database = json.databases[key];
            const style = {};
            style.background = Utils.alertColor2(database.mat);
            const alerts = database.aa > 0 && React.createElement("a", { href: "#/alerts/?dbid=" + database.id, title: "Alerts", className: "dashboard_alert_box", style: { color: "#cc0000" } },
                " ",
                database.aa,
                " ");
            const div = React.createElement("div", { style: style, key: "db_" + database.id, className: "dashboard_box" },
                React.createElement("a", { href: "#database/" + database.id, key: "db" + database.id, className: "textColor nostyle bold", title: database.nm },
                    database.cd,
                    " (",
                    database.tn,
                    ")"),
                alerts,
                database.pc > 0 &&
                    React.createElement("div", { style: { float: "right", marginRight: "-7px", marginTop: "-8px", opacity: "0.8" }, title: database.pc == 1 ? t("Probe is connected") : t("Probe is not connected") }, database.pc == 1 ?
                        React.createElement("img", { width: "14", src: "images/icons/png/circle_green.png", style: { opacity: 0.4 } }) :
                        React.createElement("img", { className: "blink", width: "14", src: "images/icons/png/circle_red.png" })));
            divDatabases.push(div);
        }
        return React.createElement("div", null, divDatabases);
    }
    ;
    return (React.createElement("div", { id: 'panel_view_group' },
        History.links("dashboard"),
        divDashboard));
};
const ViewSystem = (props) => {
    const [divDashboard, setDivDashboard] = useState(null);
    const [refreshing, setRefreshing] = useState(true);
    const fn = { closed: useRef(false) };
    let refreshTimeout = 0;
    const backgroundGreen = "rgba(0, 255, 89, 0.2)";
    const backgroundRed = "rgba(255, 0, 0, 0.2)";
    const backgroundYellow = "rgba(225, 230, 0, 0.2)";
    const sid = props.sid;
    function cleanUp() {
        fn.closed.current = true;
        clearTimeout(refreshTimeout);
    }
    useEffect(() => { fn.closed.current = false; loadData(); return cleanUp; }, [props]);
    function loadData() {
        if (fn.closed.current)
            return;
        Utils.setState(fn, setRefreshing, true);
        let pdo = Utils.postDataOptions({ op: "hosts", sid: sid });
        fetch(apiURL + "dashboard", pdo).then(res => res.json()).then((result) => {
            Utils.setState(fn, setDivDashboard, parse(result));
        }, (error) => {
            Utils.setState(fn, setDivDashboard, Utils.error(error.message));
        }).then(() => {
            if (fn.closed.current)
                return;
            setTimeout(() => Utils.setState(fn, setRefreshing, false), 1000);
            refreshTimeout = setTimeout(loadData, 10000);
        });
    }
    ;
    function parse(json) {
        if (!json.success) {
            return Utils.error(json.error);
        }
        History.dashboard.system = { index: 2, name: json.cd, link: "view/system/" + sid, title: json.nm };
        History.remove("dashboard", "host");
        const hosts = [];
        for (let i = 0; i < json.hosts.length; i++) {
            const host = json.hosts[i];
            const style = {};
            style.background = Utils.alertColor2(host.mat);
            const title = "";
            const alerts = host.aa > 0 && React.createElement("a", { href: "#/alerts/?hid=" + host.id, title: "Alerts", className: "dashboard_alert_box", style: { color: "#cc0000" } },
                " ",
                host.aa,
                " ");
            const div = React.createElement("div", { style: style, key: "s_" + host.id, className: "dashboard_box", title: title },
                host.cc ? React.createElement("a", { href: "#view/host/" + sid + "-" + host.id, className: "textColor nostyle bold" },
                    host.cd,
                    " (",
                    host.nm,
                    ")") :
                    React.createElement("span", { className: "textColor nostyle bold" },
                        host.cd,
                        " (",
                        host.nm,
                        ")"),
                alerts,
                host.pc > 0 &&
                    React.createElement("div", { style: { float: "right", marginRight: "-7px", marginTop: "-8px", opacity: "0.8" }, title: host.pc == 1 ? t("Probes are connected") : t("Probes are not connected") }, host.pc == 1 ?
                        React.createElement("img", { width: "14", src: "images/icons/png/circle_green.png", style: { opacity: 0.4 } }) :
                        React.createElement("img", { className: "blink", width: "14", src: "images/icons/png/circle_red.png" })));
            hosts.push(div);
        }
        if (User.admin) {
            hosts.push(React.createElement("div", { key: "add_new_host", style: { marginTop: "50px" }, className: "clear" },
                "  Please ",
                React.createElement("a", { href: "#add-new-unit/" + sid }, "click here to add a new host"),
                " "));
        }
        return React.createElement("div", null,
            React.createElement("h2", null,
                json.cd,
                " - ",
                json.nm,
                " "),
            hosts);
    }
    return (React.createElement("div", { id: 'panel_view_group' },
        History.links("dashboard"),
        divDashboard));
};
const Data = {
    cpu: {},
    theme: "dark",
    darkTheme: true,
    dark: true,
    iconDir: "/images/icons",
    methods: {},
    admin: false,
    userID: 0,
    maintenance: false,
    debug: false,
    alertCount: 0,
    version: "",
    visibleRows: 20,
    updateAnimationDisplayTime: 1000,
    tabs: {},
    accordion: {},
    logged: false,
    dashboardBasicMode: true,
    groups: {},
    systems: {},
    hosts: {},
    hideMenu: false,
    systemCode: function (sid) {
        if (!Data.systems[sid])
            return sid;
        return Data.systems[sid].code;
    },
    groupCode: function (gid) {
        if (gid == 0)
            return "Default";
        if (!Data.groups[gid])
            return gid || "";
        return Data.groups[gid].code;
    },
    updates: {},
    graph: {},
    r3: [],
    data: {},
    set: function (key, value) {
        Data.data[key] = value;
    },
    get: function (key) {
        if (!Data.data[key])
            return "";
        return Data.data[key];
    },
    getBoolean: function (key) {
        if (!Data.data[key])
            return false;
        return true;
    }
};
const Options = {};
const AddNewDatabase = (props) => {
    const [fields, setFields] = useState({ type: DBType.HANA, name: "", alias: "", nr: "", port: 0,
        user: "", pass: "", osuser: "", ospassword: "" });
    const [errors, setErrors] = useState({});
    const [testResult, setTestResult] = useState(null);
    const [testing, setTesting] = useState(false);
    const [error, setError] = useState(null);
    const required = ["name", "nr"];
    const hostID = props.match.params.hostID;
    const SID = props.match.params.sid;
    const hostName = props.match.params.hostName;
    const isHana = fields["type"] == "hdb";
    const fn = { exited: false };
    function cleanUp() {
        fn.exited = true;
    }
    function handleValidation() {
        const errors = {};
        let formIsValid = true;
        for (let i = 0; i < required.length; i++) {
            const field = required[i];
            if (field == "nr" && fields["type"] != "hdb")
                continue;
            console.log(fields);
            if (fields[field] == "" || fields[field].length < 1) {
                formIsValid = false;
                errors[field] = "Required field";
            }
        }
        Utils.setState(fn, setErrors, errors);
        return formIsValid;
    }
    function back(e) { e.preventDefault(); cleanUp(); Utils.goBack(props.history, "#databases"); }
    function submit() {
        if (!handleValidation())
            return;
        const list = fields;
        if (list["type"] !== "hdb")
            list["nr"] = "";
        const options = Object.assign(Object.assign({}, list), { op: "add", sid: SID, hostid: hostID });
        const pdo = Utils.postDataOptions(options);
        fetch(apiURL + "databases", pdo)
            .then(response => response.json())
            .then((result) => {
            if (result.success) {
                return Utils.go(props.history, "/#home");
            }
            if (result.error) {
                Utils.setState(fn, setError, result.error);
                if (result.field) {
                    Utils.setState(fn, setErrors, { [result.field]: result.error });
                }
            }
        }, (error) => {
            Utils.setState(fn, setError, error.message);
        });
    }
    function testConnection(e) {
        e.preventDefault();
        const options = Object.assign(Object.assign({}, fields), { op: "test", sid: SID, hostid: hostID });
        const pdo = Utils.postDataOptions(options);
        Utils.setState(fn, setTesting, true);
        fetch(apiURL + "databases", pdo)
            .then(response => response.json())
            .then((result) => {
            if (result.success) {
                Utils.setState(fn, setTestResult, parseComponents(result));
                Utils.setState(fn, setErrors, {});
            }
            else {
                Utils.setState(fn, setTestResult, result.error);
                if (result.field) {
                    Utils.setState(fn, setErrors, { [result.field]: result.error });
                }
                else {
                    Utils.setState(fn, setErrors, {});
                }
            }
        }, (error) => {
            Utils.setState(fn, setTestResult, error.message);
        }).then(() => { Utils.setState(fn, setTesting, false); });
    }
    function parseComponents(json) {
        const rows = [];
        for (let p = 0; p < json.properties.length; p++) {
            const property = json.properties[p];
            const row = React.createElement("tr", { key: "dbtest_tr_prop" + p },
                React.createElement("td", null, property.key),
                React.createElement("td", null, property.value));
            rows.push(row);
        }
        for (let c = 0; c < json.components.length; c++) {
            const component = json.components[c];
            for (let cp = 0; cp < component.properties.length; cp++) {
                const property = component.properties[cp];
                const row = React.createElement("tr", { key: "dbtest_tr_" + c + "_" + cp },
                    React.createElement("td", null, property.key),
                    React.createElement("td", null, property.value));
                rows.push(row);
            }
        }
        const statusError = !json.statusText || json.statusText.startsWith("Error");
        return React.createElement("table", null,
            React.createElement("tbody", null,
                React.createElement("tr", { key: "tbtest_tr_success" },
                    React.createElement("td", null, "Test is completed "),
                    React.createElement("td", null, Utils.date())),
                React.createElement("tr", { key: "tbtest_tr_status" },
                    React.createElement("td", null, "Status"),
                    React.createElement("td", { style: { color: statusError ? Colors.red : Colors.green } }, json.statusText)),
                React.createElement("tr", { key: "tbtest_tr_connection" },
                    React.createElement("td", null, "Connection "),
                    React.createElement("td", { style: { color: json.healthy == "Healthy" ? Colors.green : Colors.red } }, json.healthy)),
                React.createElement("tr", { key: "tbtest_tr_propertystatus" },
                    React.createElement("td", null, "Properties "),
                    React.createElement("td", { style: { color: json.propertyStatus == "OK" ? Colors.green : Colors.red } }, json.propertyStatus)),
                rows));
    }
    function handleChange(e) {
        const field = e.currentTarget.getAttribute('field');
        const value = e.target.type === "checkbox" ? e.target.checked : e.target.value;
        Utils.setState(fn, setFields, Object.assign(Object.assign({}, fields), { [field]: value }));
    }
    const comboTypeOptions = [];
    const selectedType = fields["type"];
    const dblist = [DBType.HANA,
        DBType.ASE,
        DBType.ORACLE,
        DBType.MSSQL,
        DBType.MYSQL,
        DBType.SQLITE];
    for (var i = 0; i < dblist.length; i++) {
        const type = dblist[i];
        const db = DatabaseNames[type];
        const name = db.name;
        const option = React.createElement("option", { key: "so_" + type, value: type }, name);
        comboTypeOptions.push(option);
    }
    const comboType = React.createElement("select", { field: "type", onChange: handleChange, value: selectedType }, comboTypeOptions);
    return (React.createElement("div", { id: "page" },
        React.createElement(Header, { back: back, title: t("Add new database") }),
        React.createElement("div", { className: "col-md-6" },
            React.createElement("table", { className: "nobordertable" },
                React.createElement("tbody", null,
                    React.createElement("tr", null,
                        React.createElement("td", null, "SID"),
                        React.createElement("td", null, Data.systemCode(SID)),
                        React.createElement("td", null)),
                    React.createElement("tr", null,
                        React.createElement("td", null, t("Host")),
                        React.createElement("td", null, hostName),
                        React.createElement("td", null)),
                    React.createElement("tr", null,
                        React.createElement("td", null, t("Database Type")),
                        React.createElement("td", null, comboType),
                        React.createElement("td", { style: { color: "red" } }, t(errors["type"]))),
                    React.createElement("tr", null,
                        React.createElement("td", null,
                            t("Name"),
                            "(*)"),
                        React.createElement("td", null,
                            React.createElement("input", { type: "text", size: "30", placeholder: t("Name"), field: "name", onChange: handleChange, value: fields["name"] })),
                        React.createElement("td", { style: { color: "red" } }, t(errors["name"]))),
                    React.createElement("tr", null,
                        React.createElement("td", null, t("Description")),
                        React.createElement("td", null,
                            React.createElement("input", { type: "text", size: "30", placeholder: t("Description"), field: "alias", onChange: handleChange, value: fields["alias"] })),
                        React.createElement("td", { style: { color: "red" } }, t(errors["alias"]))),
                    React.createElement("tr", null,
                        React.createElement("td", null, t("Database port")),
                        React.createElement("td", null,
                            React.createElement("input", { type: "text", size: "30", placeholder: t("Port"), field: "port", onChange: handleChange, value: fields["port"] })),
                        React.createElement("td", { style: { color: "red" } }, t(errors["port"]))),
                    isHana &&
                        React.createElement("tr", { id: 'input_instance_number' },
                            React.createElement("td", null,
                                t("Instance number"),
                                "(*)"),
                            React.createElement("td", null,
                                React.createElement("input", { type: "text", size: "30", placeholder: t("Instance number"), field: "nr", onChange: handleChange, value: fields["nr"] })),
                            React.createElement("td", { style: { color: "red" } }, t(errors["nr"]))),
                    React.createElement("tr", { id: 'input_database_user' },
                        React.createElement("td", null, t("Monitoring user")),
                        React.createElement("td", null,
                            React.createElement("input", { type: "text", size: "30", placeholder: t("Monitoring user"), field: "user", autoComplete: "new-password", onChange: handleChange, value: fields["user"], title: "Database user with monitoring role and with only 'select' permission" })),
                        React.createElement("td", { style: { color: "red" } }, t(errors["user"]))),
                    React.createElement("tr", { id: 'input_database_password' },
                        React.createElement("td", null, t("Monitoring password")),
                        React.createElement("td", null,
                            React.createElement("input", { type: "password", autoComplete: "new-password", size: "30", placeholder: t("Monitoring password"), field: "pass", onChange: handleChange, value: fields["pass"] })),
                        React.createElement("td", { style: { color: "red" } }, t(errors["pass"]))),
                    React.createElement("tr", { id: 'input_os_user' },
                        React.createElement("td", { title: t("Operating system user") }, t("OS User")),
                        React.createElement("td", null,
                            React.createElement("input", { type: "text", size: "30", placeholder: t("OS User"), field: "osuser", onChange: handleChange, value: fields["osuser"], title: t("Operating system user") })),
                        React.createElement("td", { style: { color: "red" } }, t(errors["osuser"]))),
                    React.createElement("tr", { id: 'input_os_password' },
                        React.createElement("td", { title: t("Operating system user password") }, t("OS Password")),
                        React.createElement("td", null,
                            React.createElement("input", { type: "password", size: "30", placeholder: t("OS Password"), field: "ospassword", onChange: handleChange, value: fields["ospassword"], title: t("Operating system user password") })),
                        React.createElement("td", { style: { color: "red" } }, t(errors["ospassword"]))))),
            React.createElement("br", null),
            React.createElement("button", { id: "test", onClick: testConnection, disabled: testing, "data-animation": testing }, t("Test")),
            React.createElement("button", { id: "submit", value: "Submit", onClick: submit }, t("Add")),
            React.createElement("button", { onClick: back }, t("Cancel")),
            React.createElement("div", null,
                error ? React.createElement("div", { style: { color: "red" } }, t(error)) : null,
                React.createElement("br", null),
                testResult ? React.createElement("div", null,
                    React.createElement("span", null, Utils.date()),
                    React.createElement("br", null),
                    testResult) : null)),
        React.createElement("span", null, "SysRanger Requires a monitoring user account with monitoring role. This user will only have 'select' permission on monitoring related tables. ")));
};
const DatabaseBrowser = (props) => {
    const url = apiURL + "databasebrowser";
    const [divTable, setDivTable] = useState(null);
    const [tab, setTab] = useState("table");
    const [divData, setDivData] = useState(null);
    const [divTree, setDivTree] = useState(null);
    const fn = { exited: false };
    function cleanUp() {
        fn.exited = true;
    }
    useEffect(() => { receiveTreeData(); return cleanUp; }, []);
    function loadingTree() {
        Utils.setState(fn, setDivTree, Utils.loading());
    }
    function getTree(json) {
        if (!json.databases) {
            return "Cannot connect to database";
        }
        const data = {
            json: json.databases,
            root: { name: t("Databases") },
            showCount: 10,
            countListener: tableCountClicked,
            leafListener: treeLeafClicked,
            maxChars: 200
        };
        return React.createElement(Tree, { data: data });
    }
    ;
    function receiveTreeData() {
        if (fn.exited)
            return;
        loadingTree();
        let pdo = Utils.postDataOptions({ dbid: props.match.params.id, op: "gettree" });
        fetch(url, pdo).then(res => res.json()).then((result) => {
            Utils.setState(fn, setDivTree, getTree(result));
            console.log(result);
        }, (error) => {
            console.log(error);
            Utils.setState(fn, setDivTree, Utils.error(error.message));
        });
    }
    ;
    function tableCountClicked(item) {
        const type = item.t;
        const schema = item.parent.n;
        const catalog = item.parent.parent.n;
        listTables(catalog, schema, type);
        setTab("table");
    }
    ;
    function treeLeafClicked(item) {
        console.log(item);
        const table = item.n;
        const schema = item.parent.parent.n;
        const catalog = item.parent.parent.parent.n;
        console.log(item);
        receiveTableData(catalog, schema, table);
    }
    function listTables(catalog, schema, type) {
        if (fn.exited)
            return;
        const pdo = Utils.postDataOptions({ dbid: props.match.params.id,
            op: "listtables",
            catalog: catalog, schema: schema, type: type
        });
        fetch(url, pdo).then(res => res.json()).then((result) => {
            Utils.setState(fn, setDivTable, getTableList(result));
            console.log(result);
        }, (error) => {
            console.log(error);
            Utils.setState(fn, setDivTable, Utils.error(error.message));
        });
    }
    function getTableList(tables) {
        let rows = [];
        if (!tables || !tables.tables) {
            return null;
        }
        rows = tables.tables;
        const info = {
            defaultSortField: "n",
            id: "dbt",
            headers: [
                { name: "Table", field: "n", onClick: tableClicked }
            ],
            onClick: tableClicked,
            field: "n",
            items: rows,
            rows: rows,
            total: tables.total,
            start: tables.start,
            finish: tables.finish,
            json: tables
        };
        console.log(info);
        return React.createElement(FreeList, { data: info });
    }
    function receiveTableData(catalog, schema, table) {
        let pdo = Utils.postDataOptions({ dbid: props.match.params.id,
            op: "listdata",
            catalog: catalog,
            schema: schema,
            table: table
        });
        fetch(url, pdo).then(res => res.json()).then((result) => {
            console.log(result);
            if (result.success) {
                Utils.setState(fn, setDivData, getDataTable(result));
            }
            else {
                const message = "Can't read : " + table + " Cause:" + result.error;
                Utils.setState(fn, setDivData, Utils.error(message));
            }
        }, (error) => {
            Utils.setState(fn, setDivData, Utils.error(error.message));
        }).then(() => { setTab("data"); });
    }
    ;
    function tableClicked(row, data) {
        const json = data.json;
        Debugger.print("Table Clicked:" + row.n);
        if (fn.exited)
            return;
        receiveTableData(json.catalog, json.schema, row.n);
    }
    function getDataTable(data) {
        if (!data || !data.columns)
            return React.createElement("div", null, "No data yet !");
        const metas = data.columns;
        const rows = data.rows;
        const sort = metas[0].name;
        const info = { id: "dbd", rows: rows, defaultSortField: sort };
        const headers = [];
        for (const key in metas) {
            const meta = metas[key];
            const label = meta.label.length > 0 ? meta.label : meta.name;
            const header = {
                name: label,
                field: meta.name
            };
            headers.push(header);
        }
        info.headers = headers;
        console.log(info);
        return React.createElement(Table, { data: info });
    }
    function back() { Utils.goBack(props.history); }
    let panel = React.createElement("div", null);
    if (tab == "table") {
        panel = divTable;
    }
    else if (tab == "data") {
        panel = divData;
    }
    return (React.createElement("div", { id: 'page' },
        React.createElement(Header, { back: back, title: t("Database Browser") }),
        React.createElement("div", null,
            React.createElement("a", { style: { float: "right" }, href: "#removedatabase/" + props.match.params.id },
                " ",
                t("Remove"),
                " "),
            React.createElement("div", { style: { width: "100%" } },
                React.createElement("div", { style: { width: "30%", marginRight: "20px", float: "left", overflowX: "auto", overflowY: "hidden", minHeight: "200px" } }, divTree),
                React.createElement("div", { style: { width: "calc(70% - 30px)", float: "left", height: "calc(100vh - 150px)" } }, panel)))));
};
const DatabaseComponents = (props) => {
    const [divDetails, setDivDetails] = useState(null);
    const [refreshing, setRefreshing] = useState(true);
    const fn = { closed: useRef(false) };
    const dbID = props.id;
    let refreshTimeout = 0;
    function cleanUp() {
        fn.closed.current = true;
        clearTimeout(refreshTimeout);
    }
    useEffect(() => { fn.closed.current = false; loadData(); return cleanUp; }, [props.id]);
    function loadData() {
        if (fn.closed.current)
            return;
        Utils.setState(fn, setRefreshing, true);
        let pdo = Utils.postDataOptions({ "op": "components", id: dbID });
        fetch(apiURL + "databases", pdo).then(res => res.json()).then((result) => {
            Utils.setState(fn, setDivDetails, parse(result));
        }, (error) => {
            Utils.setState(fn, setDivDetails, Utils.error(error.message));
        }).then(() => {
            if (fn.closed.current)
                return;
            setTimeout(() => Utils.setState(fn, setRefreshing, false), 1000);
            refreshTimeout = setTimeout(loadData, 10000);
        });
    }
    ;
    function statusColor(row) {
        return row.status == "SAPHostControl-DB-RUNNING" ? Colors.green : Colors.red;
    }
    function parse(json) {
        if (!json.success) {
            return Utils.error(json.error);
        }
        const data = {
            defaultSortField: "name",
            id: "dbct",
            headers: [
                { name: "Name", field: "name", colorRule: statusColor },
                { name: "Description", field: "description" },
                { name: "Status", field: "status", colorRule: statusColor },
                { name: "Status description", field: "statusdescription" }
            ],
            rows: json.components
        };
        return React.createElement(Table, { data: data });
    }
    return (React.createElement("div", { id: 'panel_database_components' },
        React.createElement("div", { className: "update_animation_box" }, refreshing && Utils.updating()),
        divDetails));
};
const DatabaseComponentsPage = (props) => {
    const dbID = props.match.params.id;
    function back(e) {
        e.preventDefault();
        Utils.goBack(props.history, "/#dashboard");
    }
    return (React.createElement("div", { id: 'page' },
        React.createElement(Header, { back: back, title: t("Database Components") }),
        React.createElement(DatabaseComponents, { id: dbID })));
};
const DatabaseDetails = (props) => {
    const [data, setData] = useState(null);
    const fn = { exited: false };
    const dbID = props.match.params.id;
    const timeoutID = "to_dbdetails_" + dbID;
    const isHana = data && data.type == DBType.HANA;
    function cleanUp() {
        fn.exited = true;
        Timeouts.clearAll(timeoutID);
    }
    function back(e) {
        e.preventDefault();
        cleanUp();
        Utils.goBack(props.history, "#/databases");
    }
    useEffect(() => { fn.loadData(); return cleanUp; }, [props]);
    fn.loadData = function () {
        if (fn.exited)
            return;
        let pdo = Utils.postDataOptions({ op: "get", id: dbID });
        fetch(apiURL + "databases", pdo).then(res => res.json()).then((result) => {
            Utils.setState(fn, setData, result);
        }, (error) => {
            return Utils.setState(fn, setData, { success: false, error: error.message });
        }).then(() => {
            if (fn.exited)
                return;
            Timeouts.add(timeoutID, setTimeout(fn.loadData, 5000));
        });
    };
    function statusColor(status) {
        return Utils.contains(status, "RUNNING") ? Colors.green : Colors.red;
    }
    ;
    function tabClicked(tab) {
        Debugger.print("DatabaseDetails.tabClicked:" + tab);
    }
    ;
    function parseData(database) {
        if (!database)
            return null;
        if (!database.success) {
            return Utils.error(database.error);
        }
        const sizePCT = (database.used / database.size) * 100;
        const logPCT = (database.logused / database.log) * 100;
        const tracePCT = (database.traceused / database.tracetotal) * 100;
        const memoryPCT = (database.memorytotal / database.memoryhost) * 100;
        const div = React.createElement("div", null,
            React.createElement("table", { key: "db_details_" + dbID },
                React.createElement("tbody", null,
                    React.createElement("tr", null,
                        React.createElement("td", null, t("Host")),
                        React.createElement("td", null,
                            database.scode,
                            " -  ",
                            database.hostname)),
                    React.createElement("tr", null,
                        React.createElement("td", null, "Port"),
                        React.createElement("td", null,
                            React.createElement("a", { style: { color: Utils.onOffColor(database.reachable) }, href: "#/availability-history/" + AvailabilityType.DATABASE_PING + "/" + dbID, title: t("Click to see history") },
                                database.port,
                                " ",
                                database.pingstatus))),
                    React.createElement("tr", null,
                        React.createElement("td", null, t("Healthy")),
                        React.createElement("td", null,
                            React.createElement("a", { style: { color: Utils.onOffColor(database.healthy) }, href: "#/availability-history/6-5-4/" + dbID, title: t("Click to see history") }, Utils.yesno(database.healthy)))),
                    React.createElement("tr", null,
                        React.createElement("td", null, t("Status")),
                        React.createElement("td", null,
                            React.createElement("a", { style: { color: statusColor(database.status) }, href: "#/availability-history/" + AvailabilityType.DATABASE_STATUS + "/" + dbID, title: t("Click to see history") }, t(Database.getStatus(database.status))))),
                    React.createElement("tr", null,
                        React.createElement("td", { style: { color: database.size < 1 || sizePCT > 90 ? Colors.red : Colors.text } },
                            t("Data"),
                            " GB"),
                        React.createElement("td", null,
                            React.createElement(ProgressBar3, { data: {
                                    val1: Utils.GB(database.file), val2: Utils.GB(database.used), total: Utils.GB(database.size),
                                    title: t("Volume Size / Disk Usage / Disk Total (GB)")
                                } }))),
                    React.createElement("tr", null,
                        React.createElement("td", { style: { color: database.log < 1 || logPCT > 90 ? Colors.red : Colors.text } },
                            t("Log"),
                            " GB"),
                        React.createElement("td", null,
                            React.createElement(ProgressBar3, { data: { val1: Utils.GB(database.logfile), val2: Utils.GB(database.logused), total: Utils.GB(database.log),
                                    title: t("Volume Size / Disk Usage / Disk Total (GB)")
                                } }))),
                    React.createElement("tr", null,
                        React.createElement("td", { style: { color: database.tracetotal < 1 || tracePCT > 90 ? Colors.red : Colors.text } },
                            t("Trace"),
                            " GB"),
                        React.createElement("td", null,
                            React.createElement(ProgressBar3, { data: { val1: Utils.GB(database.tracefile), val2: Utils.GB(database.traceused), total: Utils.GB(database.tracetotal),
                                    title: t("Volume Size / Disk Usage / Disk Total (GB)")
                                } }))),
                    isHana &&
                        React.createElement("tr", null,
                            React.createElement("td", { style: { color: database.memorytotal < 1 || memoryPCT > 90 ? Colors.red : Colors.text } },
                                t("Memory"),
                                " GB"),
                            React.createElement("td", null,
                                React.createElement(ProgressBar3, { data: { val1: Utils.GB(database.memoryprocessnonshared), val2: Utils.GB(database.memorytotal), total: Utils.GB(database.memoryhost),
                                        title: t("Database Resident / Total Resident / Physical Memory (GB)")
                                    } }))),
                    isHana &&
                        React.createElement("tr", null,
                            React.createElement("td", { style: { color: database.cputotal > 50 ? Colors.red : Colors.text } },
                                t("CPU"),
                                " %"),
                            React.createElement("td", null,
                                React.createElement(ProgressBar3, { data: { val1: database.cpu, val2: database.cputotal, total: 100, threshold: 50,
                                        title: t("Database CPU / Total CPU / Max (%)")
                                    } }))),
                    React.createElement("tr", null,
                        React.createElement("td", null, t("License")),
                        React.createElement("td", { style: { color: database.licensevalid ? Colors.text : Colors.red } },
                            database.license,
                            "  ")),
                    React.createElement("tr", null,
                        React.createElement("td", null, t("DB user connection")),
                        React.createElement("td", { style: { color: Utils.onOffColor(database.connected) } },
                            React.createElement(Tooltip, { key: "tt_dbconnection", content: React.createElement("a", { href: "#/availability-history/4/" + dbID }, Utils.yesno(database.connected)), title: "Database user connection status" },
                                database.connectionstatus,
                                database.connected &&
                                    React.createElement("div", null, database.user + " is connected to database"),
                                "Click to see history"))),
                    React.createElement("tr", null,
                        React.createElement("td", null, t("Last activity")),
                        React.createElement("td", null, Utils.toDate(database.lastactivity))),
                    React.createElement("tr", null,
                        React.createElement("td", null, t("Instance number")),
                        React.createElement("td", null, database.nr)),
                    React.createElement("tr", null,
                        React.createElement("td", null, t("DB User")),
                        React.createElement("td", null, database.user)),
                    React.createElement("tr", null,
                        React.createElement("td", { title: t("Operating system user") }, t("OS User")),
                        React.createElement("td", { title: t("Operating system user") }, database.osuser)))),
            React.createElement("div", { className: "space20" }));
        return div;
    }
    ;
    const divDetails = parseData(data);
    const title = data && data.name + " (" + data.alias + " )" + " - " + data.typename;
    return (React.createElement("div", { id: 'page' },
        React.createElement(Header, { back: back, title: t("Database overview") + " " + title }),
        divDetails,
        React.createElement(Tabs, { default: "database_properties", key: 'database_tabs', listener: tabClicked },
            React.createElement(Tab, { key: 'database_properties', name: 'database_properties', label: 'Properties' },
                "        ",
                React.createElement(DatabaseProperties, { id: dbID }),
                " "),
            User.admin && data && React.createElement(Tab, { key: "database_options_tab", name: 'database_options', label: 'Options' },
                "        ",
                React.createElement(DatabaseOptions, { database: data, parent: fn, id: dbID }),
                " ")),
        React.createElement("br", null)));
};
const DatabaseList = (props) => {
    const url = apiURL + "databases";
    const [divDetails, setDivDetails] = useState(null);
    const [refreshing, setRefreshing] = useState(false);
    const fn = { exited: false };
    let refreshTimeout = 0;
    function cleanUp() {
        fn.exited = true;
        clearTimeout(refreshTimeout);
    }
    useEffect(() => { loadData(); return cleanUp; }, []);
    function loadData() {
        if (fn.exited)
            return;
        Utils.setState(fn, setRefreshing, true);
        let pdo = Utils.postDataOptions({ op: "list" });
        fetch(url, pdo).then(res => res.json()).then((result) => {
            Utils.setState(fn, setDivDetails, parse(result));
        }, (error) => {
            return Utils.setState(fn, setDivDetails, Utils.error(error.message));
        }).then(() => {
            if (fn.exited)
                return;
            setTimeout(() => Utils.setState(fn, setRefreshing, false), 1000);
            refreshTimeout = setTimeout(loadData, 5000);
        });
    }
    ;
    function onRowClick(row, data) {
        props.history.push({
            pathname: '/database/' + row.id,
            state: { from: props.location.pathname }
        });
    }
    function parse(json) {
        if (!json.success) {
            return Utils.error(json.error);
        }
        const data = {
            defaultSortField: "name",
            id: "dbt",
            headers: [
                { name: "Name", field: "name", onClick: onRowClick },
                { name: "Description", field: "alias" },
                { name: "Type", field: "typename" },
                { name: "SID", field: "scode" },
                { name: "Host", field: "hostname" },
                { name: "Port", field: "port", colorRule: (row) => Utils.onOffColor(row.reachable) },
                { name: "Healthy", field: "healthy", format: Utils.yesno },
                { name: "Status", field: "status", showTooltip: true, format: Database.getStatus, colorRule: statusColor },
                { name: "Data", field: "dpc", bar: { width: 100, name: "" },
                    tooltip: (row) => {
                        return row.dpc + " % \n" + Utils.bytesToUnit(row.dau) + " / " + Utils.bytesToUnit(row.das);
                    }
                },
                { name: "Log", field: "lpc", bar: { width: 100, name: "" },
                    tooltip: (row) => {
                        return row.lpc + " % \n" + Utils.bytesToUnit(row.lou) + " / " + Utils.bytesToUnit(row.los);
                    }
                },
                { name: "User", field: "user" },
                { name: "OS User", field: "osuser", title: t("Operating system user") },
                { name: "Last activity", field: "lastactivity", format: Utils.toDate }
            ],
            rows: json.databases
        };
        return React.createElement(Table, { data: data });
    }
    ;
    function statusColor(row) {
        return Utils.contains(row.status, "RUNNING") ? Colors.green : Colors.red;
    }
    ;
    function back(e) { e.preventDefault(); cleanUp(); Utils.goBack(props.history, "#"); }
    return (React.createElement("div", { id: 'page' },
        React.createElement(Header, { back: back, title: t("Databases") }),
        React.createElement("div", { className: "update_animation_box" }, refreshing ? Utils.updating() : null),
        divDetails));
};
const DatabaseLogin = (props) => {
    const database = props.database;
    const [updating, setUpdating] = useState(false);
    const [error, setError] = useState(null);
    const fn = { exited: false };
    const dbID = props.id;
    const inputUser = useRef();
    const inputPassword = useRef();
    function cleanUp() {
        fn.exited = true;
    }
    useEffect(() => { return cleanUp; }, [props.id]);
    function submit() {
        if (fn.exited)
            return;
        let pdo = Utils.postDataOptions({ user: inputUser.current.value, password: inputPassword.current.value, op: "setlogin", id: dbID });
        Utils.setState(fn, setUpdating, true);
        fetch(apiURL + "databases", pdo).then(res => res.json()).then((result) => {
            if (result.success) {
                Info.success(t("Updated"));
                Utils.setState(fn, setUpdating, false);
                return Utils.go(props.history, "/#database/" + dbID);
            }
            Utils.setState(fn, setUpdating, false);
            Utils.setState(fn, setError, result.error);
            if (props.parent && props.parent.loadData) {
                props.parent.loadData();
            }
        }, (error) => {
            Utils.setState(fn, setUpdating, false);
            return Utils.setState(fn, setError, error.message);
        });
    }
    ;
    return (React.createElement("div", { id: 'panel_database_login' },
        React.createElement("table", { className: "nobordertable" },
            React.createElement("tbody", null,
                React.createElement("tr", { id: 'input_user' },
                    React.createElement("td", { width: "250", title: t("Monitoring user") }, t("Monitoring user")),
                    React.createElement("td", null,
                        React.createElement("input", { type: "text", ref: inputUser, size: "30", placeholder: t("Monitoring user"), key: "dbl_" + database.user + dbID, defaultValue: database.user }))),
                React.createElement("tr", { id: 'input_password' },
                    React.createElement("td", { title: t("Monitoring password") }, t("Monitoring password")),
                    React.createElement("td", null,
                        React.createElement("input", { type: "password", ref: inputPassword, size: "30", placeholder: t("Monitoring password"), defaultValue: "", key: "ddl_" + database.user + dbID }))),
                React.createElement("tr", null,
                    React.createElement("td", null),
                    React.createElement("td", null, User.admin && React.createElement("button", { disabled: updating, onClick: submit },
                        updating && Utils.updating(),
                        t("Update")))))),
        React.createElement("br", null),
        error && React.createElement("div", { style: { color: "red" } }, t(error)),
        React.createElement("br", null)));
};
const DatabaseOptions = (props) => {
    const [status, setStatus] = useState(null);
    const [updating, setUpdating] = useState(false);
    const database = props.database;
    const fn = { exited: false };
    const dbID = props.id;
    let inputDescription = createRef();
    let inputPort = createRef();
    function cleanUp() {
        fn.exited = true;
    }
    useEffect(() => { return cleanUp; }, [dbID]);
    function callOperation(op) {
        if (fn.exited)
            return;
        if (!confirm("Are you sure you want to " + op + " database ?"))
            return;
        let pdo = Utils.postDataOptions({ op: op, id: dbID });
        Utils.setState(fn, setUpdating, true);
        fetch(apiURL + "databases", pdo).then(res => res.json()).then((result) => {
            if (result.success) {
                Utils.setState(fn, setStatus, Utils.nl2List(Utils.date() + "\n" + result.message));
            }
            else {
                Utils.setState(fn, setStatus, "ERROR:" + result.error);
            }
            Utils.setState(fn, setUpdating, false);
            if (props.parent && props.parent.loadData) {
                props.parent.loadData();
            }
        }, (error) => {
            Utils.setState(fn, setUpdating, false);
            return Utils.setState(fn, setStatus, Utils.error(error.message));
        });
    }
    ;
    function updateDescription() {
        if (fn.exited)
            return;
        const description = inputDescription.current.value;
        let pdo = Utils.postDataOptions({ op: "setdescription", id: dbID, description: description });
        fetch(apiURL + "databases", pdo).then(res => res.json()).then((result) => {
            if (result.success) {
                Call.refresh();
                Info.success("Successfull");
            }
            else {
                Info.error(result.error);
            }
        }, (error) => {
            Info.error(error.message);
        });
    }
    function updatePort() {
        if (fn.exited)
            return;
        const port = inputPort.current.value;
        let pdo = Utils.postDataOptions({ op: "setport", id: dbID, port: port });
        fetch(apiURL + "databases", pdo).then(res => res.json()).then((result) => {
            if (result.success) {
                Call.refresh();
                Info.success("Successfull");
            }
            else {
                Info.error(result.error);
            }
        }, (error) => {
            Info.error(error.message);
        });
    }
    if (!database)
        return null;
    console.log("DatabaseOptions ID:" + dbID + " / " + database.id + "   --" + database.alias);
    return (React.createElement("div", { id: "panel_database_options_" + dbID },
        React.createElement("br", null),
        t("Description"),
        ":",
        React.createElement("input", { type: "text", ref: inputDescription, key: "pdoid_" + database.alias, defaultValue: database.alias }),
        User.admin ? React.createElement("button", { onClick: updateDescription }, t("Update")) : null,
        React.createElement("br", null),
        "Port:",
        React.createElement("input", { type: "text", ref: inputPort, key: "pdoip_" + database.port, defaultValue: database.port }),
        User.admin && React.createElement("button", { onClick: updatePort }, t("Update")),
        React.createElement("br", null),
        React.createElement("br", null),
        User.admin && React.createElement("button", { disabled: updating, onClick: () => callOperation("start") },
            updating && Utils.updating(),
            t("Start")),
        User.admin && React.createElement("button", { disabled: updating, onClick: () => callOperation("stop") },
            updating && Utils.updating(),
            " ",
            t("Stop")),
        React.createElement("br", null),
        User.admin ? React.createElement("a", { className: "linkbutton", href: "#removedatabase/" + dbID }, t("Remove database")) : "",
        React.createElement("br", null),
        status,
        React.createElement("br", null),
        " ",
        React.createElement("br", null),
        " ",
        React.createElement("br", null),
        React.createElement(DatabaseOSLogin, { database: database, id: dbID }),
        React.createElement("br", null),
        React.createElement(DatabaseLogin, { database: database, id: dbID }),
        React.createElement("br", null)));
};
const DatabaseOSLogin = (props) => {
    const database = props.database;
    const [updating, setUpdating] = useState(false);
    const [error, setError] = useState(null);
    const fn = { exited: false };
    const dbID = props.id;
    const inputUser = useRef();
    const inputPassword = useRef();
    console.log("DatabaseOSLOgin ID:" + database.id);
    function cleanUp() {
        fn.exited = true;
    }
    useEffect(() => { return cleanUp; }, [props.id]);
    function submit() {
        if (fn.exited)
            return;
        let pdo = Utils.postDataOptions({ osuser: inputUser.current.value, ospassword: inputPassword.current.value, op: "setoslogin", id: dbID });
        Utils.setState(fn, setUpdating, true);
        fetch(apiURL + "databases", pdo).then(res => res.json()).then((result) => {
            if (result.success) {
                Info.success(t("Updated"));
                Utils.setState(fn, setUpdating, false);
                return Utils.go(props.history, "/#database/" + dbID);
            }
            Utils.setState(fn, setUpdating, false);
            Utils.setState(fn, setError, result.error);
            if (props.parent && props.parent.loadData) {
                props.parent.loadData();
            }
        }, (error) => {
            Utils.setState(fn, setUpdating, false);
            return Utils.setState(fn, setError, error.message);
        });
    }
    ;
    return (React.createElement("div", { id: 'panel_database_oslogin' },
        React.createElement("table", { className: "nobordertable" },
            React.createElement("tbody", null,
                React.createElement("tr", { id: 'input_os_user' },
                    React.createElement("td", { width: "250", title: t("Operating system user") }, t("Operating system user")),
                    React.createElement("td", null,
                        React.createElement("input", { type: "text", size: "30", ref: inputUser, placeholder: t("Operating system user"), key: "dbosliosu_" + database.osuser, defaultValue: database.osuser, title: t("Operating system user") }))),
                React.createElement("tr", { id: 'input_os_password' },
                    React.createElement("td", { title: t("Operating system user password") }, t("Operating system user password")),
                    React.createElement("td", null,
                        React.createElement("input", { type: "password", size: "30", ref: inputPassword, placeholder: t("Operating system user password"), defaultValue: "", key: "dbosliosp_" + database.osuser + dbID, title: t("Operating system user password") }))),
                React.createElement("tr", null,
                    React.createElement("td", null),
                    React.createElement("td", null, User.admin && React.createElement("button", { disabled: updating, onClick: submit },
                        updating && Utils.updating(),
                        t("Update")))))),
        React.createElement("br", null),
        error && React.createElement("div", { style: { color: "red" } }, t(error)),
        React.createElement("br", null)));
};
const DatabaseProperties = (props) => {
    const [divDetails, setDivDetails] = useState(null);
    const [refreshing, setRefreshing] = useState(false);
    const fn = { exited: false };
    let refreshTimeout = 0;
    const dbID = props.id;
    function cleanUp() {
        fn.exited = true;
        clearTimeout(refreshTimeout);
    }
    useEffect(() => { init(); loadData(); return cleanUp; }, [props.id]);
    function init() {
        Utils.setState(fn, setDivDetails, null);
    }
    function loadData() {
        if (fn.exited)
            return;
        let pdo = Utils.postDataOptions({ op: "properties", id: dbID });
        Utils.setState(fn, setRefreshing, true);
        fetch(apiURL + "databases", pdo).then(res => res.json()).then((result) => {
            Utils.setState(fn, setDivDetails, parseData(result));
        }, (error) => {
            return Utils.setState(fn, setDivDetails, error.message);
        }).then(() => {
            if (fn.exited)
                return;
            setTimeout(() => Utils.setState(fn, setRefreshing, false), 1000);
            refreshTimeout = setTimeout(loadData, 10000);
        });
    }
    ;
    function parseData(json) {
        if (!json.success) {
            return Utils.error(json.error);
        }
        const rows = [];
        for (let p = 0; p < json.properties.length; p++) {
            const property = json.properties[p];
            const row = React.createElement("tr", { key: "dbprops_tr_prop" + p },
                React.createElement("td", null, property.key),
                React.createElement("td", null, property.value));
            rows.push(row);
        }
        rows.push(React.createElement("tr", { key: "dbport" },
            React.createElement("td", null, "Port"),
            React.createElement("td", null, json.port)));
        rows.push(React.createElement("tr", { key: "dbportfound" },
            React.createElement("td", null, "Port found"),
            React.createElement("td", null, json.foundport)));
        for (let c = 0; c < json.components.length; c++) {
            const component = json.components[c];
            const statusColor = component.status == "SAPHostControl-DB-RUNNING" ? Colors.green : Colors.red;
            rows.push(React.createElement("tr", { key: "dbprops_tr_empty_" + c },
                React.createElement("td", { colSpan: "2" })));
            rows.push(React.createElement("tr", { key: "dbprops_tr_status_" + c },
                React.createElement("td", null, "Status"),
                React.createElement("td", { style: { color: statusColor } }, component.status)));
            for (let cp = 0; cp < component.properties.length; cp++) {
                const property = component.properties[cp];
                const row = React.createElement("tr", { key: "dbprops_tr_" + c + "_" + cp },
                    React.createElement("td", null, property.key),
                    React.createElement("td", null, property.value));
                rows.push(row);
            }
        }
        return React.createElement("table", null,
            React.createElement("tbody", null,
                React.createElement("tr", { key: "dbprops_tr_success" },
                    React.createElement("td", null,
                        t("Date"),
                        " "),
                    React.createElement("td", null, Utils.date())),
                rows));
    }
    ;
    return (React.createElement("div", { id: 'panel_database_properties' },
        React.createElement("div", { className: "update_animation_box" }, refreshing ? Utils.updating() : null),
        divDetails,
        React.createElement("br", null)));
};
const DatabaseSubs = (props) => {
    const [divDetails, setDivDetails] = useState(null);
    const [refreshing, setRefreshing] = useState(false);
    const dbID = props.dbid;
    const fn = { closed: useRef(false) };
    let refreshTimeout = 0;
    function cleanUp() {
        fn.closed.current = true;
        clearTimeout(refreshTimeout);
    }
    useEffect(() => { loadData(); return cleanUp; }, [props.dbid]);
    function loadData() {
        if (fn.closed.current)
            return;
        const options = { op: "subusages", dbid: dbID };
        const pdo = Utils.postDataOptions(options);
        Utils.setState(fn, setRefreshing, true);
        fetch(apiURL + "databases", pdo).then(res => res.json()).then((result) => {
            Utils.setState(fn, setDivDetails, parse(result));
        }, (error) => {
            return Utils.setState(fn, setDivDetails, Utils.error(error.message));
        }).then(() => {
            if (fn.closed.current)
                return;
            setTimeout(() => Utils.setState(fn, setRefreshing, false), 1000);
            refreshTimeout = setTimeout(loadData, 10000);
        });
    }
    function parse(json) {
        if (!json.success) {
            return Utils.error(json.error);
        }
        const table = {
            id: "tdsubs",
            defaultSortField: "size",
            headers: [
                { name: "id", field: "id" },
                { name: "Name", field: "name" },
                { name: "Size", field: "size", format: Utils.bytesToUnit },
                { name: "Used", field: "used", format: Utils.bytesToUnit },
                { name: "Log", field: "log", format: Utils.bytesToUnit },
                { name: "Log used", field: "logused", format: Utils.bytesToUnit }
            ],
            rows: json.databases
        };
        return React.createElement(Table, { data: table });
    }
    return (React.createElement("div", { id: 'panel_database_sub_usages' },
        React.createElement("div", { className: "update_animation_box" }, refreshing && Utils.updating()),
        divDetails));
};
const DatabaseTables = (props) => {
    const [divDetails, setDivDetails] = useState(null);
    const [refreshing, setRefreshing] = useState(false);
    const fn = { exited: false };
    let refreshTimeout = 0;
    const dbID = props.id;
    function cleanUp() {
        fn.exited = true;
        clearTimeout(refreshTimeout);
    }
    useEffect(() => { loadData(); return cleanUp; }, [props.id]);
    function loadData() {
        if (fn.exited)
            return;
        let pdo = Utils.postDataOptions({ op: "properties", id: dbID });
        Utils.setState(fn, setRefreshing, true);
        fetch(apiURL + "databases", pdo).then(res => res.json()).then((result) => {
            Utils.setState(fn, setDivDetails, parseData(result));
        }, (error) => {
            return Utils.setState(fn, setDivDetails, error.message);
        }).then(() => {
            if (fn.exited)
                return;
            setTimeout(() => Utils.setState(fn, setRefreshing, false), 1000);
            refreshTimeout = setTimeout(loadData, 10000);
        });
    }
    ;
    function propertyStatusColor(value) {
        if (value.includes("is running")) {
            return Colors.green;
        }
        else if (value.includes("is not running")) {
            return Colors.red;
        }
        return null;
    }
    function parseData(json) {
        if (!json.success) {
            return Utils.error(json.error);
        }
        const rows = [];
        for (let p = 0; p < json.properties.length; p++) {
            const property = json.properties[p];
            const row = React.createElement("tr", { key: "dbprops_tr_prop" + p },
                React.createElement("td", null, property.key),
                React.createElement("td", null, property.value));
            rows.push(row);
        }
        rows.push(React.createElement("tr", { key: "dbport" },
            React.createElement("td", null, "Port"),
            React.createElement("td", null, json.port)));
        rows.push(React.createElement("tr", { key: "dbportfound" },
            React.createElement("td", null, "Port found"),
            React.createElement("td", null, json.foundport)));
        for (let c = 0; c < json.components.length; c++) {
            const component = json.components[c];
            rows.push(React.createElement("tr", { key: "dbprops_tr_empty_" + c },
                React.createElement("td", { colSpan: "2" })));
            rows.push(React.createElement("tr", { key: "dbprops_tr_status_" + c },
                React.createElement("td", null, "Status"),
                React.createElement("td", null, component.status)));
            for (let cp = 0; cp < component.properties.length; cp++) {
                const property = component.properties[cp];
                const row = React.createElement("tr", { key: "dbprops_tr_" + c + "_" + cp },
                    React.createElement("td", null, property.key),
                    React.createElement("td", { style: { color: propertyStatusColor(property.value) } }, property.value));
                rows.push(row);
            }
        }
        return React.createElement("table", null,
            React.createElement("tbody", null,
                React.createElement("tr", { key: "dbprops_tr_success" },
                    React.createElement("td", null,
                        t("Date"),
                        " "),
                    React.createElement("td", null, Utils.date())),
                rows));
    }
    ;
    return (React.createElement("div", { id: 'panel_database_properties' },
        React.createElement("div", { className: "update_animation_box" }, refreshing ? Utils.updating() : null),
        divDetails,
        React.createElement("br", null)));
};
const DBDetailsHanaActiveStatements = (props) => {
    const dbID = props.id;
    const fn = { closed: useRef(false) };
    const [content, setContent] = useState("Loading...");
    const [r, refresh] = useState(null);
    const timeoutID = "dbdhas_" + dbID;
    function init() {
        fn.closed.current = false;
        loadData();
    }
    function cleanUp() {
        fn.closed.current = true;
        Timeouts.clearAll(timeoutID);
    }
    useEffect(() => { init(); return cleanUp; }, [props.id]);
    function loadData() {
        Timeouts.clearAll(timeoutID);
        if (fn.closed.current)
            return;
        let pdo = Utils.postDataOptions({ dbid: dbID, op: "activestatements" });
        fetch(apiURL + "hana", pdo).then(res => res.json()).then((result) => {
            if (result.success) {
                Utils.setState(fn, setContent, parseData(result));
            }
            else {
                Utils.setState(fn, setContent, Utils.error(result.error));
            }
        }, (error) => {
            Utils.setState(fn, setContent, Utils.error(error.message));
        }).then(() => {
            if (fn.closed.current)
                return;
            Timeouts.add(timeoutID, setTimeout(loadData, 10000));
        });
    }
    function parseData(json) {
        const data = {
            defaultSortField: "SECTION",
            id: timeoutID + "_t",
            class: "nobordertable",
            pale: true,
            headers: [
                { name: "HOST", field: "HOST" },
                { name: "PORT", field: "PORT" },
                { name: "CONNECTION_ID", field: "CONNECTION_ID" },
                { name: "STATEMENT_ID", field: "STATEMENT_ID", emphasize: true },
                { name: "STATEMENT_STATUS", field: "STATEMENT_STATUS", emphasize: true },
                { name: "COMPILED_TIME", field: "COMPILED_TIME" },
                { name: "LAST_EXECUTED_TIME", field: "LAST_EXECUTED_TIME" },
                { name: "LAST_ACTION_TIME", field: "LAST_ACTION_TIME" },
                { name: "STMT", field: "STMT" },
                { name: "ALLOCATED_MEMORY_SIZE", field: "ALLOCATED_MEMORY_SIZE" },
                { name: "USED_MEMORY_SIZE", field: "USED_MEMORY_SIZE" },
                { name: "EXECUTION_COUNT", field: "EXECUTION_COUNT" },
                { name: "APP", field: "APP", emphasize: true },
                { name: "APP_USER", field: "APP_USER", emphasize: true },
                { name: "CLIENT_IP", field: "CLIENT_IP" },
                { name: "CLIENT_HOST", field: "CLIENT_HOST", emphasize: true },
                { name: "CLIENT_USER", field: "CLIENT_USER" },
                { name: "CONNECTION_STATUS", field: "CONNECTION_STATUS" }
            ],
            rows: json.rows
        };
        return React.createElement("div", null,
            React.createElement("div", null,
                " ",
                Utils.lastUpdated()),
            React.createElement(Table, { key: timeoutID + "_tk", data: data }));
    }
    ;
    return React.createElement("div", null, content);
};
const DBHanaActiveStatementsPage = (props) => {
    const dbID = props.match.params.dbid;
    const dbName = props.match.params.dbname;
    function back(e) { e.preventDefault(); Utils.goBack(props.history, "#database/" + dbID); }
    return (React.createElement("div", { id: "page" },
        React.createElement(Header, { back: back, title: t("Hana Active Statements") + " " + dbName }),
        React.createElement(DBDetailsHanaActiveStatements, { id: dbID })));
};
const DBDetailsHanaBackupSummary = (props) => {
    const dbID = props.id;
    const fn = { closed: useRef(false), show: useRef(false) };
    const [content, setContent] = useState(null);
    const [r, refresh] = useState(null);
    const timeoutID = "dbdhbs_" + dbID;
    function init() {
        fn.closed.current = false;
        loadData();
    }
    function cleanUp() {
        fn.closed.current = true;
        Timeouts.clearAll(timeoutID);
    }
    useEffect(() => { init(); return cleanUp; }, [props.id]);
    function loadData() {
        Timeouts.clearAll(timeoutID);
        if (fn.closed.current)
            return;
        let pdo = Utils.postDataOptions({ dbid: dbID, op: "backupsummary" });
        fetch(apiURL + "hana", pdo).then(res => res.json()).then((result) => {
            if (result.success) {
                Utils.setState(fn, setContent, parseData(result));
            }
            else {
                Utils.setState(fn, setContent, Utils.error(result.error));
            }
        }, (error) => {
            Utils.setState(fn, setContent, Utils.error(error.message));
        }).then(() => {
            if (fn.closed.current)
                return;
            Timeouts.add(timeoutID, setTimeout(loadData, 10000));
        });
    }
    function parseData(json) {
        const tableCatalog = {
            defaultSortField: "ENTRY_TYPE_NAME",
            id: "ddhbs",
            class: "nobordertable",
            pale: true,
            headers: [
                { name: "Type", field: "ENTRY_TYPE_NAME", emphasize: true },
                { name: "ID", field: "BACKUP_ID" },
                { name: "Start", field: "SYS_START_TIME" },
                { name: "End", field: "SYS_END_TIME" },
                { name: "State", field: "STATE_NAME", emphasize: true },
                { name: "Message", field: "MESSAGE", emphasize: true },
                { name: "Comment", field: "COMMENT" },
                { name: "Source", field: "SOURCE_DATABASE_NAME" }
            ],
            rows: json.catalog
        };
        const tableEstimation = {
            defaultSortField: "HOST",
            id: "ddhbest",
            class: "nobordertable",
            pale: true,
            headers: [
                { name: "Host", field: "HOST" },
                { name: "Port", field: "PORT" },
                { name: "Service", field: "SERVICE_NAME", emphasize: true },
                { name: "Type", field: "ENTRY_TYPE_NAME", emphasize: true },
                { name: "Estimated Size", field: "ESTIMATED_SIZE", format: Utils.bytesToUnit, width: 100, emphasize: true }
            ],
            rows: json.estimations
        };
        return React.createElement("div", null,
            React.createElement("div", null,
                " ",
                Utils.lastUpdated()),
            React.createElement("h3", null, "Backups"),
            React.createElement(Table, { key: "ddhbst", data: tableCatalog }),
            React.createElement("h3", null, "Backup Estimations"),
            React.createElement(Table, { key: "ddhbestt", data: tableEstimation }));
    }
    ;
    return React.createElement("div", null, content);
};
const DBHanaBackupSummaryPage = (props) => {
    const dbID = props.match.params.dbid;
    const dbName = props.match.params.dbname;
    function back(e) { e.preventDefault(); Utils.goBack(props.history, "#database/" + dbID); }
    return (React.createElement("div", { id: "page" },
        React.createElement(Header, { back: back, title: t("Hana Backup Summary") + " " + dbName }),
        React.createElement(DBDetailsHanaBackupSummary, { id: dbID })));
};
const DBDetailsHanaConfigurationParameters = (props) => {
    const dbID = props.id;
    const fn = { closed: useRef(false) };
    const [content, setContent] = useState("Loading...");
    function init() {
        fn.closed.current = false;
    }
    function cleanUp() {
        fn.closed.current = true;
    }
    useEffect(() => { init(); loadData(); return cleanUp; }, [dbID]);
    function loadData() {
        if (fn.closed.current)
            return;
        let pdo = Utils.postDataOptions({ dbid: dbID, op: "configurationparameters" });
        fetch(apiURL + "hana", pdo).then(res => res.json()).then((result) => {
            Utils.setState(fn, setContent, parse(result));
        }, (error) => {
            Utils.setState(fn, setContent, Utils.error(error.message));
        });
    }
    function parse(json) {
        if (!json.success) {
            return Utils.error(json.error);
        }
        const data = {
            defaultSortField: "F",
            id: "table_hana_configuration_parameters",
            nosorting: true,
            class: "nobordertable",
            headers: [
                { name: "File", field: "F", filter: {} },
                { name: "Section", field: "S", filter: {} },
                { name: "Key", field: "K", filter: {} },
                { name: "Value", field: "V", filter: {} },
                { name: "Description", field: "D", filter: {} }
            ],
            rows: json.rows
        };
        return React.createElement("div", null,
            json.dbname,
            " - ",
            json.dbalias,
            React.createElement(Table, { key: "table_hana_configuration_parameters", data: data }));
    }
    ;
    return (React.createElement("div", { id: "panel_hana_configuration_parameters" }, content));
};
const DBDetailsHanaConfigurationParametersPage = (props) => {
    const dbID = props.match.params.id;
    function back(e) {
        e.preventDefault();
        Utils.goBack(props.history, "#/database/" + dbID);
    }
    return (React.createElement("div", { id: 'page' },
        React.createElement(Header, { back: back, title: t("Database Configuration Parameters") }),
        React.createElement(DBDetailsHanaConfigurationParameters, { id: dbID })));
};
const DBDetailsHanaConnections = (props) => {
    const dbID = props.id;
    const fn = { closed: useRef(false), show: useRef(false) };
    const [content, setContent] = useState(null);
    const [r, refresh] = useState(null);
    const timeoutID = "dbdhc_" + dbID;
    function init() {
        fn.closed.current = false;
        loadData();
    }
    function cleanUp() {
        fn.closed.current = true;
        Timeouts.clearAll(timeoutID);
    }
    useEffect(() => { init(); return cleanUp; }, [props.id]);
    function loadData() {
        Timeouts.clearAll(timeoutID);
        if (fn.closed.current)
            return;
        let pdo = Utils.postDataOptions({ dbid: dbID, op: "connections" });
        fetch(apiURL + "hana", pdo).then(res => res.json()).then((result) => {
            if (result.success) {
                Utils.setState(fn, setContent, parseData(result));
            }
            else {
                Utils.setState(fn, setContent, Utils.error(result.error));
            }
        }, (error) => {
            Utils.setState(fn, setContent, Utils.error(error.message));
        }).then(() => {
            if (fn.closed.current)
                return;
            Timeouts.add(timeoutID, setTimeout(loadData, 10000));
        });
    }
    function parseData(json) {
        const data = {
            defaultSortField: "SECTION",
            id: timeoutID + "_t",
            class: "nobordertable",
            pale: true,
            headers: [
                { name: "HOST", field: "HOST" },
                { name: "PORT", field: "PORT" },
                { name: "CONNECTION", field: "CONNECTION_ID", emphasize: true },
                { name: "STATUS", field: "CONNECTION_STATUS" },
                { name: "CLIENT_HOST", field: "CLIENT_HOST", emphasize: true },
                { name: "USER_NAME", field: "USER_NAME" },
                { name: "APP", field: "APP", emphasize: true },
                { name: "APP_USER", field: "APP_USER", emphasize: true },
                { name: "TR", field: "TRANSACTION_ID", title: "Transaction" },
                { name: "START_TIME", field: "START_TIME" },
                { name: "SENT", field: "SENT_MESSAGE_SIZE", format: Utils.bytesToUnit },
                { name: "RECEIVED", field: "RECEIVED_MESSAGE_SIZE", format: Utils.bytesToUnit },
            ],
            rows: json.rows
        };
        return React.createElement("div", null,
            React.createElement("div", null,
                " ",
                Utils.lastUpdated()),
            React.createElement(Table, { key: timeoutID + "_tk", data: data }));
    }
    ;
    return React.createElement("div", null, content);
};
const DBHanaConnectionsPage = (props) => {
    const dbID = props.match.params.dbid;
    const dbName = props.match.params.dbname;
    function back(e) { e.preventDefault(); Utils.goBack(props.history, "#database/" + dbID); }
    return (React.createElement("div", { id: "page" },
        React.createElement(Header, { back: back, title: t("Hana Connections") + " " + dbName }),
        React.createElement(DBDetailsHanaConnections, { id: dbID })));
};
const DBDetailsHanaLicences = (props) => {
    const dbID = props.id;
    const fn = { closed: useRef(false), show: useRef(false) };
    const [content, setContent] = useState(null);
    const [r, refresh] = useState(null);
    const timeoutID = "dbdhl_" + dbID;
    function init() {
        fn.closed.current = false;
        loadData();
    }
    function cleanUp() {
        fn.closed.current = true;
        Timeouts.clearAll(timeoutID);
    }
    useEffect(() => { init(); return cleanUp; }, [props.id]);
    function loadData() {
        Timeouts.clearAll(timeoutID);
        if (fn.closed.current)
            return;
        let pdo = Utils.postDataOptions({ dbid: dbID, op: "licences" });
        fetch(apiURL + "hana", pdo).then(res => res.json()).then((result) => {
            if (result.success) {
                Utils.setState(fn, setContent, parseData(result));
            }
            else {
                Utils.setState(fn, setContent, Utils.error(result.error));
            }
        }, (error) => {
            Utils.setState(fn, setContent, Utils.error(error.message));
        }).then(() => {
            if (fn.closed.current)
                return;
            Timeouts.add(timeoutID, setTimeout(loadData, 10000));
        });
    }
    function parseData(json) {
        const data = {
            defaultSortField: "HOST",
            id: "ddhst",
            class: "nobordertable",
            pale: true,
            headers: [
                { name: "HARDWARE_KEY", field: "HARDWARE_KEY" },
                { name: "SYSTEM_ID", field: "SYSTEM_ID" },
                { name: "PRODUCT_DESCRIPTION", field: "PRODUCT_DESCRIPTION", emphasize: true },
                { name: "VALID", field: "VALID", emphasize: true },
                { name: "START_DATE", field: "START_DATE" },
                { name: "EXPIRATION_DATE", field: "EXPIRATION_DATE", emphasize: true },
                { name: "LAST_SUCCESSFUL_CHECK", field: "LAST_SUCCESSFUL_CHECK" },
                { name: "PERMANENT", field: "PERMANENT" },
                { name: "INSTALL_NO", field: "INSTALL_NO" },
                { name: "SYSTEM_NO", field: "SYSTEM_NO" },
                { name: "PRODUCT_LIMIT", field: "PRODUCT_LIMIT" },
                { name: "PRODUCT_LIMIT_DESCRIPTION", field: "PRODUCT_LIMIT_DESCRIPTION" },
                { name: "PRODUCT_USAGE", field: "PRODUCT_USAGE" },
                { name: "PRODUCT_NAME", field: "PRODUCT_NAME" },
                { name: "ENFORCED", field: "ENFORCED" },
                { name: "LOCKED_DOWN", field: "LOCKED_DOWN" },
                { name: "IS_DATABASE_LOCAL", field: "IS_DATABASE_LOCAL" },
                { name: "FIRST_INSTALLATION_TIME", field: "FIRST_INSTALLATION_TIME" }
            ],
            rows: json.rows
        };
        return React.createElement("div", null,
            React.createElement("div", null,
                " ",
                Utils.lastUpdated()),
            React.createElement(Table, { key: "ddhlict", data: data }));
    }
    ;
    return React.createElement("div", null, content);
};
const DBHanaLicensesPage = (props) => {
    const dbID = props.match.params.dbid;
    const dbName = props.match.params.dbname;
    function back(e) { e.preventDefault(); Utils.goBack(props.history, "#database/" + dbID); }
    return (React.createElement("div", { id: "page" },
        React.createElement(Header, { back: back, title: t("Hana Licenses") + " " + dbName }),
        React.createElement(DBDetailsHanaLicences, { id: dbID })));
};
const DBDetailsHanaSystemOverview = (props) => {
    const dbID = props.id;
    const fn = { closed: useRef(false), show: useRef(false) };
    const [content, setContent] = useState("Loading...");
    const [r, refresh] = useState(null);
    const timeoutID = "dbdhso_" + dbID;
    function init() {
        fn.closed.current = false;
        loadData();
    }
    function cleanUp() {
        fn.closed.current = true;
        Timeouts.clearAll(timeoutID);
    }
    useEffect(() => { init(); return cleanUp; }, [props.id]);
    function loadData() {
        Timeouts.clearAll(timeoutID);
        if (fn.closed.current)
            return;
        let pdo = Utils.postDataOptions({ dbid: dbID, op: "systemoverview" });
        fetch(apiURL + "hana", pdo).then(res => res.json()).then((result) => {
            if (result.success) {
                Utils.setState(fn, setContent, parseData(result));
            }
            else {
                Utils.setState(fn, setContent, Utils.error(result.error));
            }
        }, (error) => {
            Utils.setState(fn, setContent, Utils.error(error.message));
        }).then(() => {
            if (fn.closed.current)
                return;
            Timeouts.add(timeoutID, setTimeout(loadData, 10000));
        });
    }
    function parseData(json) {
        const data = {
            defaultSortField: "SECTION",
            id: timeoutID + "_t",
            class: "nobordertable",
            headers: [
                { name: "SECTION", field: "SECTION" },
                { name: "NAME", field: "NAME" },
                { name: "STATUS", field: "STATUS" },
                { name: "VALUE", field: "VALUE" }
            ],
            rows: json.rows
        };
        return React.createElement("div", null,
            React.createElement("div", null,
                " ",
                Utils.lastUpdated()),
            React.createElement(Table, { key: timeoutID + "_tk", data: data }));
    }
    ;
    return React.createElement("div", null, content);
};
const DBHanaSystemOverviewPage = (props) => {
    const dbID = props.match.params.dbid;
    const dbName = props.match.params.dbname;
    function back(e) { e.preventDefault(); Utils.goBack(props.history, "#database/" + dbID); }
    return (React.createElement("div", { id: "page" },
        React.createElement(Header, { back: back, title: t("Hana System Overview") + " " + dbName }),
        React.createElement(DBDetailsHanaSystemOverview, { id: dbID })));
};
const DBDetailsHanaTableLocks = (props) => {
    const dbID = props.id;
    const fn = { closed: useRef(false) };
    const [content, setContent] = useState(null);
    const [r, refresh] = useState(null);
    const timeoutID = "dbdhtablelocks_" + dbID;
    function init() {
        fn.closed.current = false;
        loadData();
    }
    function cleanUp() {
        fn.closed.current = true;
        Timeouts.clearAll(timeoutID);
    }
    useEffect(() => { init(); return cleanUp; }, [props.id]);
    function loadData() {
        Timeouts.clearAll(timeoutID);
        if (fn.closed.current)
            return;
        let pdo = Utils.postDataOptions({ dbid: dbID, op: "tablelocks" });
        fetch(apiURL + "hana", pdo).then(res => res.json()).then((result) => {
            if (result.success) {
                Utils.setState(fn, setContent, parseData(result));
            }
            else {
                Utils.setState(fn, setContent, Utils.error(result.error));
            }
        }, (error) => {
            Utils.setState(fn, setContent, Utils.error(error.message));
        }).then(() => {
            if (fn.closed.current)
                return;
            Timeouts.add(timeoutID, setTimeout(loadData, 10000));
        });
    }
    function parseData(json) {
        const data = {
            defaultSortField: "ACQUIRED_TIME",
            id: timeoutID + "_t",
            class: "nobordertable",
            pale: true,
            headers: [
                { name: "HOST", field: "HOST" },
                { name: "PORT", field: "PORT" },
                { name: "ACQUIRED_TIME", field: "ACQUIRED_TIME" },
                { name: "SCHEMA_NAME", field: "SCHEMA_NAME" },
                { name: "TABLE_NAME", field: "TABLE_NAME" },
                { name: "OBJECT_TYPE", field: "OBJECT_TYPE" },
                { name: "LOCK_MODE", field: "LOCK_MODE" },
                { name: "LOCK_OWNER_TRANSACTION_ID", field: "LOCK_OWNER_TRANSACTION_ID" },
                { name: "LOCK_OWNER_UPDATE_TRANSACTION_ID", field: "LOCK_OWNER_UPDATE_TRANSACTION_ID" }
            ],
            rows: json.rows
        };
        return React.createElement("div", null,
            React.createElement("div", null,
                " ",
                Utils.lastUpdated()),
            json.rows.length < 1 && Utils.error("No records"),
            React.createElement(Table, { key: timeoutID + "_tk", data: data }));
    }
    ;
    return React.createElement("div", null, content);
};
const DBHanaTableLocksPage = (props) => {
    const dbID = props.match.params.dbid;
    const dbName = props.match.params.dbname;
    function back(e) { e.preventDefault(); Utils.goBack(props.history, "#database/" + dbID); }
    return (React.createElement("div", { id: "page" },
        React.createElement(Header, { back: back, title: t("Hana Table Locks") + " " + dbName }),
        React.createElement(DBDetailsHanaTableLocks, { id: dbID })));
};
const DBDetailsHanaTasks = (props) => {
    const dbID = props.id;
    const fn = { closed: useRef(false), show: useRef(false) };
    const [content, setContent] = useState(null);
    const [r, refresh] = useState(null);
    const timeoutID = "dbdhtask_" + dbID;
    function init() {
        fn.closed.current = false;
        loadData();
    }
    function cleanUp() {
        fn.closed.current = true;
        Timeouts.clearAll(timeoutID);
    }
    useEffect(() => { init(); return cleanUp; }, [props.id]);
    function loadData() {
        Timeouts.clearAll(timeoutID);
        if (fn.closed.current)
            return;
        let pdo = Utils.postDataOptions({ dbid: dbID, op: "tasks" });
        fetch(apiURL + "hana", pdo).then(res => res.json()).then((result) => {
            if (result.success) {
                Utils.setState(fn, setContent, parseData(result));
            }
            else {
                Utils.setState(fn, setContent, Utils.error(result.error));
            }
        }, (error) => {
            Utils.setState(fn, setContent, Utils.error(error.message));
        }).then(() => {
            if (fn.closed.current)
                return;
            Timeouts.add(timeoutID, setTimeout(loadData, 10000));
        });
    }
    function parseData(json) {
        const data = {
            defaultSortField: "SECTION",
            id: timeoutID + "_t",
            class: "nobordertable",
            pale: true,
            headers: [
                { name: "TASK_NAME", field: "TASK_NAME", emphasize: true },
                { name: "STATUS", field: "STATUS", emphasize: true },
                { name: "DURATION", field: "DURATION" },
                { name: "TOTAL_PROGRESS_PERCENT", field: "TOTAL_PROGRESS_PERCENT", emphasize: true },
                { name: "CURRENT_OPERATION", field: "CURRENT_OPERATION" },
                { name: "START_TIME", field: "START_TIME" },
                { name: "END_TIME", field: "END_TIME" },
                { name: "HOST", field: "HOST" },
                { name: "PORT", field: "PORT" },
                { name: "CONNECTION", field: "CONNECTION_ID" },
                { name: "SCHEMA_NAME", field: "SCHEMA_NAME" },
                { name: "IS_ASYNC", field: "IS_ASYNC" },
                { name: "TR", field: "TRANSACTION_ID", title: "Transaction" },
                { name: "USER_NAME", field: "USER_NAME" },
                { name: "APPLICATION_USER_NAME", field: "APPLICATION_USER_NAME" },
                { name: "HAS_SIDE_EFFECTS", field: "HAS_SIDE_EFFECTS" },
            ],
            rows: json.rows
        };
        return React.createElement("div", null,
            React.createElement("div", null,
                " ",
                Utils.lastUpdated()),
            json.rows.length < 1 && Utils.error("No records"),
            React.createElement(Table, { key: timeoutID + "_tk", data: data }));
    }
    ;
    return React.createElement("div", null, content);
};
const DBHanaTasksPage = (props) => {
    const dbID = props.match.params.dbid;
    const dbName = props.match.params.dbname;
    function back(e) { e.preventDefault(); Utils.goBack(props.history, "#database/" + dbID); }
    return (React.createElement("div", { id: "page" },
        React.createElement(Header, { back: back, title: t("Hana Tasks") + " " + dbName }),
        React.createElement(DBDetailsHanaTasks, { id: dbID })));
};
const DBDetailsHanaTransactions = (props) => {
    const dbID = props.id;
    const fn = { closed: useRef(false), show: useRef(false) };
    const [content, setContent] = useState(null);
    const [r, refresh] = useState(null);
    const timeoutID = "dbdht_" + dbID;
    function init() {
        fn.closed.current = false;
        loadData();
    }
    function cleanUp() {
        fn.closed.current = true;
        Timeouts.clearAll(timeoutID);
    }
    useEffect(() => { init(); return cleanUp; }, [props.id]);
    function loadData() {
        Timeouts.clearAll(timeoutID);
        if (fn.closed.current)
            return;
        let pdo = Utils.postDataOptions({ dbid: dbID, op: "transactions" });
        fetch(apiURL + "hana", pdo).then(res => res.json()).then((result) => {
            if (result.success) {
                Utils.setState(fn, setContent, parseData(result));
            }
            else {
                Utils.setState(fn, setContent, Utils.error(result.error));
            }
        }, (error) => {
            Utils.setState(fn, setContent, Utils.error(error.message));
        }).then(() => {
            if (fn.closed.current)
                return;
            Timeouts.add(timeoutID, setTimeout(loadData, 10000));
        });
    }
    function parseData(json) {
        const data = {
            defaultSortField: "SECTION",
            id: timeoutID + "_t",
            class: "nobordertable",
            pale: true,
            headers: [
                { name: "HOST", field: "HOST" },
                { name: "PORT", field: "PORT" },
                { name: "CONNECTION", field: "CONNECTION_ID" },
                { name: "TR", field: "TRANSACTION_ID", title: "Transaction", emphasize: true },
                { name: "TRANSACTION_STATUS", field: "TRANSACTION_STATUS", emphasize: true },
                { name: "TRANSACTION_TYPE", field: "TRANSACTION_TYPE", emphasize: true },
                { name: "CLIENT_HOST", field: "CLIENT_HOST", emphasize: true },
                { name: "USER_NAME", field: "USER_NAME" },
                { name: "APP", field: "APP", emphasize: true },
                { name: "APP_USER", field: "APP_USER", emphasize: true },
                { name: "START_TIME", field: "START_TIME" },
                { name: "END_TIME", field: "END_TIME" },
                { name: "CONNECTION_STATUS", field: "CONNECTION_STATUS" }
            ],
            rows: json.rows
        };
        return React.createElement("div", null,
            React.createElement("div", null,
                " ",
                Utils.lastUpdated()),
            React.createElement(Table, { key: timeoutID + "_tk", data: data }));
    }
    ;
    return React.createElement("div", null, content);
};
const DBHanaTransactionsPage = (props) => {
    const dbID = props.match.params.dbid;
    const dbName = props.match.params.dbname;
    function back(e) { e.preventDefault(); Utils.goBack(props.history, "#database/" + dbID); }
    return (React.createElement("div", { id: "page" },
        React.createElement(Header, { back: back, title: t("Hana Transactions") + " " + dbName }),
        React.createElement(DBDetailsHanaTransactions, { id: dbID })));
};
const DBDetailsHanaUsers = (props) => {
    const dbID = props.id;
    const fn = { closed: useRef(false), show: useRef(false) };
    const [content, setContent] = useState(null);
    const [r, refresh] = useState(null);
    const timeoutID = "dbdhusers_" + dbID;
    const accordionID = "dbdhusersa_" + dbID;
    if (fn.show.current) {
        Debugger.print("DBDetailsHanaUsers.alive:" + Utils.timeStamp() + " ID:" + dbID);
    }
    function init() {
        fn.closed.current = false;
        if (Data.accordion[accordionID]) {
            fn.show.current = true;
            loadData();
        }
    }
    function cleanUp() {
        fn.closed.current = true;
        Timeouts.clearAll(timeoutID);
    }
    useEffect(() => { init(); return cleanUp; }, [props.id]);
    function loadData() {
        Timeouts.clearAll(timeoutID);
        if (fn.closed.current)
            return;
        if (!fn.show.current) {
            return;
        }
        let pdo = Utils.postDataOptions({ dbid: dbID, op: "users" });
        fetch(apiURL + "hana", pdo).then(res => res.json()).then((result) => {
            if (result.success) {
                Utils.setState(fn, setContent, parseData(result));
            }
            else {
                Utils.setState(fn, setContent, Utils.error(result.error));
            }
        }, (error) => {
            Utils.setState(fn, setContent, Utils.error(error.message));
        }).then(() => {
            if (fn.closed.current)
                return;
            Timeouts.add(timeoutID, setTimeout(loadData, 10000));
        });
    }
    function headerClicked() {
        if (fn.show.current) {
            fn.show.current = false;
            Data.accordion[accordionID] = false;
            Utils.setState(fn, refresh, Utils.timeStamp());
        }
        else {
            fn.show.current = true;
            Data.accordion[accordionID] = true;
            loadData();
        }
    }
    ;
    function parseData(json) {
        const headers = [];
        for (let i = 0; i < json.columns.length; i++) {
            const column = json.columns[i];
            const header = { name: column.label, field: column.label };
            headers.push(header);
        }
        const data = {
            defaultSortField: "CREATE_TIME",
            id: timeoutID + "_t",
            class: "nobordertable",
            pale: true,
            headers: headers,
            rows: json.rows
        };
        return React.createElement("div", null,
            React.createElement("div", null,
                " ",
                Utils.lastUpdated()),
            json.rows.length < 1 && Utils.error("No records"),
            React.createElement(Table, { key: timeoutID + "_tk", data: data }));
    }
    ;
    const headerSelected = Data.accordion[accordionID] ? "selected" : "";
    return (React.createElement("div", { className: "accordion_panel" },
        React.createElement("div", { className: "accordion_header " + headerSelected, onClick: headerClicked }, " Users"),
        fn.show.current && React.createElement("div", { className: "accordion_content" }, content)));
};
const DBHanaAlertChecks = (props) => {
    const dbID = props.id;
    const fn = { closed: useRef(false) };
    const [content, setContent] = useState(null);
    const timeoutID = "dbdhtablealertchecks_" + dbID;
    function init() {
        fn.closed.current = false;
        loadData();
    }
    function cleanUp() {
        fn.closed.current = true;
        Timeouts.clearAll(timeoutID);
    }
    useEffect(() => { init(); return cleanUp; }, [props.id]);
    function loadData() {
        Timeouts.clearAll(timeoutID);
        if (fn.closed.current)
            return;
        let pdo = Utils.postDataOptions({ dbid: dbID, op: "alertchecks" });
        fetch(apiURL + "hana", pdo).then(res => res.json()).then((result) => {
            if (result.success) {
                Utils.setState(fn, setContent, parseData(result));
            }
            else {
                Utils.setState(fn, setContent, Utils.error(result.error));
            }
        }, (error) => {
            Utils.setState(fn, setContent, Utils.error(error.message));
        }).then(() => {
            if (fn.closed.current)
                return;
            Timeouts.add(timeoutID, setTimeout(loadData, 10000));
        });
    }
    function severity(val) {
        if (val > 3)
            return React.createElement("span", { style: { color: Colors.red } }, "High");
        if (val > 2)
            return React.createElement("span", { style: { color: Colors.orange } }, " Medium");
        if (val > 1)
            return React.createElement("span", { style: { color: Colors.yellow } }, " Low");
        if (val > 0)
            return "Info";
        return "";
    }
    function nameColor(row) {
        const rating = row.ALERT_LAST_CHECK_RATING;
        if (rating > 3)
            return React.createElement("span", { style: { color: Colors.red } },
                row.ALERT_NAME,
                " ");
        if (rating > 2)
            return React.createElement("span", { style: { color: Colors.orange } },
                row.ALERT_NAME,
                " ");
        if (rating > 1)
            return React.createElement("span", { style: { color: Colors.yellow } },
                row.ALERT_NAME,
                " ");
        return row.ALERT_NAME;
    }
    function parseData(json) {
        const data = {
            id: timeoutID + "_t",
            class: "nobordertable",
            pale: true,
            headers: [
                { name: "ID", field: "ALERT_ID" },
                { name: "Name", field: "ALERT_NAME", emphasize: true, rowFormat: nameColor },
                { name: "Description", field: "ALERT_DESCRIPTION" },
                { name: "Last Check", field: "ALERT_LAST_CHECK_TIMESTAMP" },
                { name: "Severity", field: "ALERT_LAST_CHECK_RATING", format: severity },
                { name: "Interval", field: "INTERVAL" }
            ],
            rows: json.rows
        };
        return React.createElement("div", null,
            React.createElement("div", null,
                " ",
                Utils.lastUpdated()),
            React.createElement(Table, { key: timeoutID + "_tk", data: data }));
    }
    ;
    return React.createElement("div", null, content);
};
const DBHanaAlertChecksPage = (props) => {
    const dbID = props.match.params.dbid;
    const dbName = props.match.params.dbname;
    function back(e) { e.preventDefault(); Utils.goBack(props.history, "#database/" + dbID); }
    return (React.createElement("div", { id: "page" },
        React.createElement(Header, { back: back, title: t("Hana Alert Checks") + " " + dbName }),
        React.createElement(DBHanaAlertChecks, { id: dbID })));
};
const DBHanaAlertHistory = (props) => {
    const dbID = props.id;
    const fn = { closed: useRef(false) };
    const [content, setContent] = useState(null);
    const timeoutID = "dbdhalerthistory_" + dbID;
    const refSelect = useRef(null);
    function init() {
        fn.closed.current = false;
        loadData();
    }
    function cleanUp() {
        fn.closed.current = true;
        Timeouts.clearAll(timeoutID);
    }
    useEffect(() => { init(); return cleanUp; }, [props.id]);
    function loadData() {
        Timeouts.clearAll(timeoutID);
        if (fn.closed.current)
            return;
        let seconds = 0;
        if (refSelect.current)
            seconds = refSelect.current.value;
        let pdo = Utils.postDataOptions({ dbid: dbID, op: "alerthistory", seconds: seconds });
        fetch(apiURL + "hana", pdo).then(res => res.json()).then((result) => {
            if (result.success) {
                Utils.setState(fn, setContent, parseData(result));
            }
            else {
                Utils.setState(fn, setContent, Utils.error(result.error));
            }
        }, (error) => {
            Utils.setState(fn, setContent, Utils.error(error.message));
        }).then(() => {
            if (fn.closed.current)
                return;
            Timeouts.add(timeoutID, setTimeout(loadData, 10000));
        });
    }
    function severity(val) {
        if (val > 3)
            return React.createElement("span", { style: { color: Colors.red } }, "High");
        if (val > 2)
            return React.createElement("span", { style: { color: Colors.orange } }, " Medium");
        if (val > 1)
            return React.createElement("span", { style: { color: Colors.yellow } }, " Low");
        if (val > 0)
            return "Info";
        return "";
    }
    function nameColor(row) {
        const rating = row.ALERT_RATING;
        const name = row.ALERT_DETAILS;
        if (rating > 3)
            return React.createElement("span", { style: { color: Colors.red } },
                name,
                " ");
        if (rating > 2)
            return React.createElement("span", { style: { color: Colors.orange } },
                nameE,
                " ");
        if (rating > 1)
            return React.createElement("span", { style: { color: Colors.yellow } },
                name,
                " ");
        return name;
    }
    function dateSelected() {
        Timeouts.clearAll(timeoutID);
        Timeouts.add(timeoutID, setTimeout(loadData, 10));
    }
    function parseData(json) {
        const data = {
            id: timeoutID + "_t",
            class: "nobordertable",
            pale: true,
            headers: [
                { name: "ID", field: "ALERT_ID" },
                { name: "Description", field: "ALERT_DETAILS", emphasize: true, rowFormat: nameColor },
                { name: "Priority", field: "ALERT_RATING", format: severity },
                { name: "Time", field: "ALERT_TIMESTAMP", width: "200px" }
            ],
            rows: json.rows
        };
        const count = json.rows.length;
        const select = React.createElement("select", { ref: refSelect, onChange: dateSelected },
            React.createElement("option", { value: "7200" }, "Last 2 hours"),
            React.createElement("option", { value: "21600" }, "Last 6 hours"),
            React.createElement("option", { value: "86400" }, "Last 24 hours"),
            React.createElement("option", { value: "604800" }, "Last 7 days"));
        return React.createElement("div", null,
            React.createElement("div", null,
                " ",
                Utils.lastUpdated()),
            React.createElement("br", null),
            select,
            React.createElement("br", null),
            React.createElement("br", null),
            count,
            " records ",
            React.createElement("br", null),
            React.createElement("br", null),
            React.createElement(Table, { key: timeoutID + "_tk", data: data }));
    }
    ;
    return React.createElement("div", null, content);
};
const DBHanaAlertHistoryPage = (props) => {
    const dbID = props.match.params.dbid;
    const dbName = props.match.params.dbname;
    function back(e) { e.preventDefault(); Utils.goBack(props.history, "#database/" + dbID); }
    return (React.createElement("div", { id: "page" },
        React.createElement(Header, { back: back, title: t("Hana Alert History") + " " + dbName }),
        React.createElement(DBHanaAlertHistory, { id: dbID })));
};
const DBHanaBackups = (props) => {
    const dbID = props.match.params.dbid;
    const fn = { closed: useRef(false), show: useRef(false) };
    const [error, setError] = useState(null);
    const [database, setDatabase] = useState({ name: "", estimations: [], backups: [] });
    const [r, refresh] = useState(null);
    const timeoutID = "dbhbs_" + dbID;
    console.log(database);
    useEffect(() => { init(); return cleanUp; }, [dbID]);
    function init() {
        fn.closed.current = false;
        getInfo();
        loadData();
    }
    function back(e) { e.preventDefault(); Utils.goBack(props.history, "#databases"); }
    function cleanUp() {
        fn.closed.current = true;
        Timeouts.clearAll(timeoutID);
    }
    function getInfo() {
        Request.send({
            caller: fn,
            url: apiURL + "hana",
            params: { dbid: dbID, op: "backupsizeestimation" },
            success: (json) => {
                database.name = json.name;
                database.estimations = json.estimations;
                refresh(Utils.timeStamp());
            }
        });
    }
    ;
    function loadData() {
        Timeouts.clearAll(timeoutID);
        if (fn.closed.current)
            return;
        let pdo = Utils.postDataOptions({ dbid: dbID, op: "backups" });
        fetch(apiURL + "hana", pdo).then(res => res.json()).then((result) => {
            if (result.success) {
                database.backups = result.backups;
                refresh(Utils.timeStamp());
            }
            else {
                Utils.setState(fn, setError, Utils.error(result.error));
            }
        }, (error) => {
            Utils.setState(fn, setError, Utils.error(error.message));
        }).then(() => {
            if (fn.closed.current)
                return;
            Timeouts.add(timeoutID, setTimeout(loadData, 10000));
        });
    }
    function getPage() {
        if (error)
            return error;
        const tableCatalog = {
            defaultSortField: "ENTRY_TYPE_NAME",
            id: "ddhbs",
            class: "nobordertable",
            pale: true,
            headers: [
                { name: "Type", field: "ENTRY_TYPE_NAME", emphasize: true },
                { name: "ID", field: "BACKUP_ID" },
                { name: "Start", field: "SYS_START_TIME" },
                { name: "End", field: "SYS_END_TIME" },
                { name: "State", field: "STATE_NAME", emphasize: true },
                { name: "Serv,ce", field: "SERVICE_TYPE_NAME" },
                { name: "Size", field: "BACKUP_SIZE", format: Utils.bytesToUnit },
                { name: "Message", field: "MESSAGE", emphasize: true },
                { name: "Comment", field: "COMMENT" },
                { name: "Source", field: "SOURCE_DATABASE_NAME" },
                { name: "Path", field: "DESTINATION_PATH" },
            ],
            rows: database.backups
        };
        const tableEstimation = {
            defaultSortField: "HOST",
            id: "ddhbest",
            class: "nobordertable",
            pale: true,
            headers: [
                { name: "Host", field: "HOST" },
                { name: "Port", field: "PORT" },
                { name: "Service", field: "SERVICE_NAME", emphasize: true },
                { name: "Type", field: "ENTRY_TYPE_NAME", emphasize: true },
                { name: "Estimated Size", field: "ESTIMATED_SIZE", format: Utils.bytesToUnit, width: 100, emphasize: true }
            ],
            rows: database.estimations
        };
        return React.createElement("div", null,
            React.createElement("div", null,
                " ",
                Utils.lastUpdated()),
            React.createElement("div", { className: "panel  flexmargin " },
                React.createElement("div", { className: "panel_title" }, "Backups"),
                React.createElement(Table, { key: "ddhbst", data: tableCatalog })),
            React.createElement("div", { className: "panel  flexmargin " },
                React.createElement("div", { className: "panel_title" }, "Backup Estimations"),
                React.createElement(Table, { key: "ddhbst", data: tableEstimation })));
    }
    ;
    return (React.createElement("div", { id: "page" },
        React.createElement(Header, { back: back, title: t("Hana Backup") + " " + database.name }),
        getPage()));
};
const DBHanaCurrentAlerts = (props) => {
    const dbID = props.id;
    const fn = { closed: useRef(false) };
    const [content, setContent] = useState(null);
    const timeoutID = "dbdhcurrentalerts_" + dbID;
    function init() {
        fn.closed.current = false;
        loadData();
    }
    function cleanUp() {
        fn.closed.current = true;
        Timeouts.clearAll(timeoutID);
    }
    useEffect(() => { init(); return cleanUp; }, [props.id]);
    function loadData() {
        Timeouts.clearAll(timeoutID);
        if (fn.closed.current)
            return;
        let pdo = Utils.postDataOptions({ dbid: dbID, op: "currentalerts" });
        fetch(apiURL + "hana", pdo).then(res => res.json()).then((result) => {
            if (result.success) {
                Utils.setState(fn, setContent, parseData(result));
            }
            else {
                Utils.setState(fn, setContent, Utils.error(result.error));
            }
        }, (error) => {
            Utils.setState(fn, setContent, Utils.error(error.message));
        }).then(() => {
            if (fn.closed.current)
                return;
            Timeouts.add(timeoutID, setTimeout(loadData, 5000));
        });
    }
    function severity(val) {
        if (val > 3)
            return React.createElement("span", { style: { color: Colors.red } }, "High");
        if (val > 2)
            return React.createElement("span", { style: { color: Colors.orange } }, " Medium");
        if (val > 1)
            return React.createElement("span", { style: { color: Colors.yellow } }, " Low");
        if (val > 0)
            return "Info";
        return "";
    }
    function nameColor(row) {
        const rating = row.ALERT_RATING;
        const name = row.ALERT_DETAILS;
        if (rating > 3)
            return React.createElement("span", { style: { color: Colors.red } },
                name,
                " ");
        if (rating > 2)
            return React.createElement("span", { style: { color: Colors.orange } },
                name,
                " ");
        if (rating > 1)
            return React.createElement("span", { style: { color: Colors.yellow } },
                name,
                " ");
        return name;
    }
    function parseData(json) {
        const data = {
            id: timeoutID + "_t",
            class: "nobordertable",
            pale: true,
            headers: [
                { name: "ID", field: "ALERT_ID" },
                { name: "Description", field: "ALERT_DETAILS", emphasize: true, rowFormat: nameColor },
                { name: "Name", field: "ALERT_NAME" },
                { name: "Details", field: "ALERT_DESCRIPTION" },
                { name: "Priority", field: "ALERT_RATING", format: severity },
                { name: "Time", field: "ALERT_TIMESTAMP" },
                { name: "User Action", field: "ALERT_USERACTION" }
            ],
            rows: json.rows
        };
        return React.createElement("div", null,
            React.createElement("div", null,
                " ",
                Utils.lastUpdated()),
            React.createElement(Table, { key: timeoutID + "_tk", data: data }));
    }
    ;
    return React.createElement("div", null, content);
};
const DBHanaCurrentAlertsPage = (props) => {
    const dbID = props.match.params.dbid;
    const dbName = props.match.params.dbname;
    function back(e) { e.preventDefault(); Utils.goBack(props.history, "#database/" + dbID); }
    return (React.createElement("div", { id: "page" },
        React.createElement(Header, { back: back, title: t("Hana Current Alerts") + " " + dbName }),
        React.createElement(DBHanaCurrentAlerts, { id: dbID })));
};
const DBHanaServices = (props) => {
    const dbID = props.id;
    const fn = { closed: useRef(false) };
    const [content, setContent] = useState(null);
    const timeoutID = "dbdhsm_" + dbID;
    function cleanUp() {
        fn.closed.current = true;
        Timeouts.clearAll(timeoutID);
    }
    useEffect(() => { fn.closed.current = false; loadData(); return cleanUp; }, [props.id]);
    function loadData() {
        Timeouts.clearAll(timeoutID);
        if (fn.closed.current)
            return;
        let pdo = Utils.postDataOptions({ dbid: dbID, op: "servicememory" });
        fetch(apiURL + "hana", pdo).then(res => res.json()).then((result) => {
            if (result.success) {
                Utils.setState(fn, setContent, parseData(result));
            }
            else {
                Utils.setState(fn, setContent, Utils.error(result.error));
            }
        }, (error) => {
            Utils.setState(fn, setContent, Utils.error(error.message));
        }).then(() => {
            if (fn.closed.current)
                return;
            Timeouts.add(timeoutID, setTimeout(loadData, 10000));
        });
    }
    function parseData(json) {
        const data = {
            defaultSortField: "HOST",
            id: "ddhst",
            class: "nobordertable",
            pale: true,
            headers: [
                { name: "Active", field: "ACTIVE_STATUS", emphasize: true },
                { name: "Host", field: "HOST" },
                { name: "Port", field: "PORT" },
                { name: "Service", field: "SERVICE_NAME", emphasize: true },
                { name: "Process ID", field: "PROCESS_ID" },
                { name: "Start Time", field: "START_TIME", width: "200px" },
                { name: "Free Memory", field: "FREE_MEMORY_SIZE", format: Utils.bytesToUnit, width: 100 },
                { name: "Physical Memory", field: "PHYSICAL_MEMORY_SIZE", format: Utils.bytesToUnit, width: 100, emphasize: true },
                { name: "Logical Memory", field: "LOGICAL_MEMORY_SIZE", format: Utils.bytesToUnit, width: 100 },
                { name: "Total Used", field: "TOTAL_MEMORY_USED_SIZE", format: Utils.bytesToUnit, width: 100 },
                { name: "EFFECTIVE_ALLOCATION_LIMIT", field: "EFFECTIVE_ALLOCATION_LIMIT", format: Utils.bytesToUnit },
                { name: "CODE_SIZE", field: "CODE_SIZE", format: Utils.bytesToUnit },
                { name: "COMPACTORS_ALLOCATED_SIZE", field: "COMPACTORS_ALLOCATED_SIZE", format: Utils.bytesToUnit },
                { name: "COMPACTORS_FREEABLE_SIZE", field: "COMPACTORS_FREEABLE_SIZE", format: Utils.bytesToUnit },
                { name: "FRAGMENTED_MEMORY_SIZE", field: "FRAGMENTED_MEMORY_SIZE", format: Utils.bytesToUnit },
                { name: "HEAP_MEMORY_ALLOCATED_SIZE", field: "HEAP_MEMORY_ALLOCATED_SIZE", format: Utils.bytesToUnit },
                { name: "HEAP_MEMORY_USED_SIZE", field: "HEAP_MEMORY_USED_SIZE", format: Utils.bytesToUnit },
                { name: "SHARED_MEMORY_ALLOCATED_SIZE", field: "SHARED_MEMORY_ALLOCATED_SIZE", format: Utils.bytesToUnit },
                { name: "SHARED_MEMORY_USED_SIZE", field: "SHARED_MEMORY_USED_SIZE", format: Utils.bytesToUnit },
                { name: "VIRTUAL_ADDRESS_SPACE_TOTAL_SIZE", field: "VIRTUAL_ADDRESS_SPACE_TOTAL_SIZE", format: Utils.bytesToUnit },
                { name: "VIRTUAL_ADDRESS_SPACE_USED_SIZE", field: "VIRTUAL_ADDRESS_SPACE_USED_SIZE", format: Utils.bytesToUnit },
                { name: "PERSISTENT_MEMORY_FILE_SIZE", field: "PERSISTENT_MEMORY_FILE_SIZE", format: Utils.bytesToUnit },
                { name: "PERSISTENT_MEMORY_MAPPED_SIZE", field: "PERSISTENT_MEMORY_MAPPED_SIZE", format: Utils.bytesToUnit },
                { name: "FAST_RESTART_MEMORY_FILE_SIZE", field: "FAST_RESTART_MEMORY_FILE_SIZE", format: Utils.bytesToUnit },
                { name: "FAST_RESTART_MEMORY_MAPPED_SIZE", field: "FAST_RESTART_MEMORY_MAPPED_SIZE", format: Utils.bytesToUnit }
            ],
            rows: json.rows
        };
        return React.createElement("div", null,
            React.createElement("div", null,
                " ",
                Utils.lastUpdated()),
            React.createElement(Table, { key: "ddhstt", data: data }));
    }
    ;
    return React.createElement("div", null, content);
};
const DBHanaServicesPage = (props) => {
    const dbID = props.match.params.dbid;
    const dbName = props.match.params.dbname;
    function back(e) { e.preventDefault(); Utils.goBack(props.history, "#database/" + dbID); }
    return (React.createElement("div", { id: "page" },
        React.createElement(Header, { back: back, title: t("Hana Services") + " " + dbName }),
        React.createElement(DBHanaServices, { id: dbID })));
};
const HanaDashboard = (props) => {
    const dbID = props.match.params.dbid;
    const unitID = props.match.params.hid;
    const [database, setDatabase] = useState({ loaded: false, error: "", id: dbID, machine: 1 });
    const fn = { closed: useRef(false) };
    const timeoutID = "hanadashboard";
    function cleanUp() {
        fn.closed.current = true;
        Timeouts.clearAll(timeoutID);
    }
    function back(e) { e.preventDefault(); cleanUp(); Utils.goBack(props.history); }
    useEffect(() => {
        fn.closed.current = false;
        loadData();
        return cleanUp;
    }, [dbID]);
    function loadData() {
        Timeouts.clearAll(timeoutID);
        if (fn.closed.current)
            return;
        let pdo = Utils.postDataOptions({ op: "dashboard", id: dbID });
        fetch(apiURL + "hana", pdo).then(res => res.json()).then((result) => {
            result.loaded = true;
            if (result.success) {
                Utils.setState(fn, setDatabase, result);
            }
            else {
                Utils.setState(fn, setDatabase, { loaded: true, error: result.error });
            }
        }, (error) => {
            Utils.setState(fn, setDatabase, { loaded: true, error: error.message });
        }).then(() => {
            if (fn.closed.current)
                return;
            Timeouts.add(timeoutID, setTimeout(loadData, 5000));
        });
    }
    function getPage() {
        if (!database.loaded)
            return null;
        if (database.error) {
            return Utils.error(database.error);
        }
        const page = React.createElement("div", { className: "panelcontainer" },
            React.createElement("div", { className: "panel  flexmargin nopadding", style: { width: "200px" } },
                React.createElement("div", { className: "panel_title" }, "Connection"),
                React.createElement("div", { className: "valuebox", style: { height: "50px", lineHeight: "50px" } }, database.connected ? "Connected" : "No")),
            React.createElement("div", { className: "panel  flexmargin nopadding", style: { width: "200px" } },
                React.createElement("div", { className: "panel_title" }, "Health"),
                React.createElement("div", { className: "valuebox", style: { height: "50px", lineHeight: "50px" } }, database.healthy ? "Running" : "No")),
            React.createElement("div", { className: "panel  flexmargin nopadding", style: { width: "200px" } },
                React.createElement("div", { className: "panel_title" }, "Port"),
                React.createElement("div", { className: "valuebox", style: { height: "50px", lineHeight: "50px" } }, database.port)),
            React.createElement("div", { className: "panel  flexmargin nopadding", style: { width: "200px" } },
                React.createElement("div", { className: "panel_title" }, "Data"),
                React.createElement("div", { className: "valuebox", style: { height: "50px", lineHeight: "50px" } }, Utils.bytesToUnit(database.size))),
            React.createElement("div", { className: "panel  flexmargin nopadding", style: { width: "200px" } },
                React.createElement("div", { className: "panel_title" }, "Log"),
                React.createElement("div", { className: "valuebox", style: { height: "50px", lineHeight: "50px" } }, Utils.bytesToUnit(database.log))),
            React.createElement("div", { className: "clear" }, " "),
            React.createElement("div", { className: "panel flexmargin", style: { width: "180px", textAlign: "left", height: "262px" } },
                React.createElement("div", { className: "panel_title" }, "Memory"),
                React.createElement(Pie, { key: "pie_hana_mem_" + database.id, data: {
                        lineWidth: 40,
                        size: 150,
                        showInfo: true,
                        vertical: true,
                        items: [
                            { value: database.memoryprocessnonshared, color: Colors.orange, text: "Used" },
                            { value: database.memorytotal - database.memoryprocessnonshared, color: Colors.yellow, text: "Allocated" },
                            { value: database.memoryhost - database.memorytotal, color: Colors.green, text: "Free" },
                        ]
                    } })),
            React.createElement("div", { className: "panel flexmargin", style: { width: "180px", textAlign: "left", height: "262px" } },
                React.createElement("div", { className: "panel_title" }, "Data"),
                React.createElement(Pie, { key: "pie_hana_mem_" + database.id, data: {
                        lineWidth: 40,
                        size: 150,
                        showInfo: true,
                        vertical: true,
                        items: [
                            { value: database.file, color: Colors.orange, text: "Used" },
                            { value: database.used - database.file, color: Colors.yellow, text: "Allocated" },
                            { value: database.size - database.used, color: Colors.green, text: "Free" },
                        ]
                    } })),
            React.createElement("div", { className: "panel flexmargin", style: { width: "180px", textAlign: "left", height: "262px" } },
                React.createElement("div", { className: "panel_title" }, "Log"),
                React.createElement(Pie, { key: "pie_hana_mem_" + database.id, data: {
                        lineWidth: 40,
                        size: 150,
                        showInfo: true,
                        vertical: true,
                        items: [
                            { value: database.logfile, color: Colors.orange, text: "Used" },
                            { value: database.logused - database.logfile, color: Colors.yellow, text: "Allocated" },
                            { value: database.log - database.logused, color: Colors.green, text: "Free" },
                        ]
                    } })),
            React.createElement("div", { className: "panel flexmargin", style: { width: "180px", textAlign: "left", height: "262px" } },
                React.createElement("div", { className: "panel_title" }, "Trace"),
                React.createElement(Pie, { key: "pie_hana_mem_" + database.id, data: {
                        lineWidth: 40,
                        size: 150,
                        showInfo: true,
                        vertical: true,
                        items: [
                            { value: database.tracefile, color: Colors.orange, text: "Used" },
                            { value: database.traceused - database.tracefile, color: Colors.yellow, text: "Allocated" },
                            { value: database.tracetotal - database.traceused, color: Colors.green, text: "Free" },
                        ]
                    } })),
            React.createElement("div", { className: "panel flexmargin", style: { width: "180px", textAlign: "left", height: "262px" } },
                React.createElement("div", { className: "panel_title" }, "CPU Cores"),
                React.createElement(Pie, { key: "pie_hana_mem_" + database.id, data: {
                        lineWidth: 40,
                        size: 150,
                        showInfo: true,
                        vertical: true,
                        unit: (value) => value + " %",
                        items: [
                            { value: database.cpu, color: Colors.orange, text: "Used" },
                            { value: database.cputotal - database.cpu, color: Colors.yellow, text: "Allocated" },
                            { value: 100 - database.cputotal, color: Colors.blue, text: "Free" },
                        ]
                    } })),
            React.createElement("div", { className: "clear" }),
            React.createElement("div", { className: "panel flexmargin", style: { width: "495px", height: "205px", textAlign: "left" } },
                React.createElement("div", { className: "panel_title" }, "CPU Load"),
                React.createElement(CPUShortHistoryGraph, { key: "shgcpu_" + unitID, hostID: unitID, width: "495", height: "180" })),
            React.createElement("div", { className: "panel flexmargin", style: { width: "495px", height: "205px", textAlign: "left" } },
                React.createElement("div", { className: "panel_title" }, "Memory Load"),
                React.createElement(MemoryShortHistoryGraph, { key: "shgmem_" + unitID, hostID: unitID, width: "495", height: "180" })),
            React.createElement("div", { className: "clear" }, " "),
            React.createElement("div", { className: "panel flexmargin", style: { width: "1020px", textAlign: "left", height: "205px" } },
                React.createElement("div", { className: "panel_title" }, "Connection"),
                React.createElement(AvailabilityHistory, { key: "ahdb_" + database.id + "_connection", width: "1020", id: dbID, type: AvailabilityType.DATABASE_CONNECTION })),
            React.createElement("div", { className: "panel flexmargin", style: { width: "1020px", textAlign: "left", height: "205px" } },
                React.createElement("div", { className: "panel_title" }, "Ping"),
                React.createElement(AvailabilityHistory, { key: "ahdb_" + database.id + "_ping", width: "1020", id: dbID, type: AvailabilityType.DATABASE_PING })),
            React.createElement("div", { className: "panel flexmargin", style: { width: "1020px", textAlign: "left", height: "205px" } },
                React.createElement("div", { className: "panel_title" }, "Status"),
                React.createElement(AvailabilityHistory, { key: "ahdb_" + database.id + "_status", width: "1020", id: dbID, type: AvailabilityType.DATABASE_STATUS })));
        return page;
    }
    return (React.createElement("div", { id: 'page' },
        React.createElement(Header, { back: back, title: t("Hana Dashboard") + " [" + database["name"] + " - " + database.alias + "]" }),
        getPage()));
};
const RemoveDatabase = (props) => {
    const [error, setError] = useState(null);
    const [divDetails, setDivDetails] = useState(null);
    const fn = { exited: false };
    const dbID = props.match.params.id;
    let dbName = "";
    function cleanUp() {
        fn.exited = true;
    }
    function back(e) { e.preventDefault(); Utils.goBack(props.history, "#databases"); }
    useEffect(() => { getData(); return cleanUp; }, [props]);
    function getData() {
        const options = { op: "get", id: dbID };
        const pdo = Utils.postDataOptions(options);
        fetch(apiURL + "databases", pdo)
            .then(response => response.json())
            .then((result) => {
            Utils.setState(fn, setDivDetails, parse(result));
        }, (error) => {
            return Utils.setState(fn, setDivDetails, Utils.error(error.message));
        });
    }
    ;
    function parse(database) {
        if (!database.success) {
            return Utils.error("Cannot get database information");
        }
        dbName = database.name;
        return React.createElement("div", null,
            React.createElement("table", { className: "nobordertable" },
                React.createElement("tbody", null,
                    React.createElement("tr", null,
                        React.createElement("td", null, "SID"),
                        React.createElement("td", null, database.scode)),
                    React.createElement("tr", null,
                        React.createElement("td", null, t("Host")),
                        React.createElement("td", null, database.hostname)),
                    React.createElement("tr", null,
                        React.createElement("td", null, t("Type")),
                        React.createElement("td", null, database.typename)),
                    React.createElement("tr", null,
                        React.createElement("td", null, t("Name")),
                        React.createElement("td", null, database.name)),
                    React.createElement("tr", null,
                        React.createElement("td", null, t("Description")),
                        React.createElement("td", null, database.alias)),
                    React.createElement("tr", null,
                        React.createElement("td", null, "Port"),
                        React.createElement("td", null, database.port)),
                    React.createElement("tr", null,
                        React.createElement("td", null, t("Ping")),
                        React.createElement("td", null,
                            database.ping,
                            " ms")),
                    React.createElement("tr", null,
                        React.createElement("td", null, t("Healthy")),
                        React.createElement("td", null, Utils.yesno(database.healthy))),
                    React.createElement("tr", null,
                        React.createElement("td", null, t("Last activity")),
                        React.createElement("td", null, Utils.toDate(database.lastactivity))),
                    React.createElement("tr", null,
                        React.createElement("td", null, t("Instance number")),
                        React.createElement("td", null, database.nr)),
                    React.createElement("tr", null,
                        React.createElement("td", null, t("User")),
                        React.createElement("td", null, database.user)),
                    React.createElement("tr", null,
                        React.createElement("td", { title: t("Operating system user") }, t("OS User")),
                        React.createElement("td", { title: t("Operating system user") }, database.osuser)))),
            React.createElement("button", { className: "critical", onClick: remove },
                " ",
                t("Remove")),
            React.createElement("button", { className: "btn btn-lg pro", onClick: back },
                " ",
                t("Cancel")));
    }
    ;
    function remove(e) {
        e.preventDefault();
        const message = t("Are you sure you want to remove ?") + " : " + dbName;
        if (!confirm(message)) {
            return;
        }
        const options = { op: "remove", id: dbID };
        const pdo = Utils.postDataOptions(options);
        fetch(apiURL + "databases", pdo)
            .then(response => response.json())
            .then((result) => {
            if (result.success) {
                Call.refresh();
                Utils.go(props.history, "/#home");
            }
        }, (error) => {
            Utils.setState(fn, setError, error.message);
        });
    }
    ;
    return (React.createElement("div", { id: "page" },
        React.createElement(Header, { back: back, title: t("Remove database"), critical: true }),
        React.createElement("div", null,
            divDetails,
            error ? Utils.error(error) : "")));
};
const SelectQueryExecuter = (props) => {
    const [div, setDiv] = useState(null);
    const [submitting, setSubmitting] = useState(false);
    const dbID = props.match.params.dbid;
    const ref = useRef(null);
    const fn = { closed: useRef(false) };
    function back(e) {
        e.preventDefault();
        Utils.goBack(props.history, "/#database/" + dbID);
    }
    function submit(e) {
        e.preventDefault();
        if (fn.closed.current)
            return;
        const options = { op: "executeselect", dbid: dbID, query: ref.current.value };
        const pdo = Utils.postDataOptions(options);
        Utils.setState(fn, setSubmitting, true);
        fetch(apiURL + "databases", pdo).then(res => res.json()).then((result) => {
            Utils.setState(fn, setDiv, parse(result));
            Utils.setState(fn, setSubmitting, false);
        }, (error) => {
            Utils.setState(fn, setSubmitting, false);
            return Utils.setState(fn, setDiv, Utils.error(error.message));
        });
    }
    function parse(json) {
        if (!json.success || !json.columns) {
            return Utils.error(json.error);
        }
        const headers = [];
        for (let i = 0; i < json.columns.length; i++) {
            const column = json.columns[i];
            headers.push({ name: column, field: column });
        }
        const table = {
            id: "tsle",
            headers: headers,
            rows: json.rows
        };
        return React.createElement(Table, { data: table });
    }
    return (React.createElement("div", { id: 'page' },
        React.createElement(Header, { back: back, title: t("Select Query Executer") }),
        React.createElement("textarea", { ref: ref, style: { width: "100%", background: "white", color: "black" }, rows: "10" }),
        React.createElement("br", null),
        submitting ?
            React.createElement("div", { className: "update_animation_box" }, Utils.updating())
            :
                React.createElement("button", { id: "submit", onClick: submit, disabled: submitting, "data-animation": submitting }, "Execute"),
        div));
};
const Debugger = {
    print: function (str) {
        console.log(str);
    }
};
const AvailabilityType = {
    NONE: 0,
    SYSTEM: 1,
    HOST_PING: 2,
    INSTANCE_STATUS: 3,
    DATABASE_CONNECTION: 4,
    DATABASE_STATUS: 5,
    DATABASE_PING: 6,
    PORT: 7,
    SERVICE: 8
};
const AvailabilityHistory = (props) => {
    const canvasDOMGraph = useRef(null);
    const [error, setError] = useState(null);
    const [tt, refreshTT] = useState({ show: 0, style: null, render: 0, alert: null });
    const [u, update] = useState(0);
    const [AvailabilityHistoryData, setData] = useState({ selectedTime: 0, start: 0, end: 0, data: [], alerts: {} });
    const fn = { closed: useRef(false) };
    const type = props.type;
    const id = props.id;
    const graphID = "a_" + id + "_" + type;
    const rowHeight = 14;
    const canvasWidth = props.width || 600;
    const panelHeight = props.height || 500;
    function cleanUp() {
        fn.closed.current = true;
        Data.graph[graphID] = {};
        AvailabilityHistoryData.data = [];
        AvailabilityHistoryData.alerts = {};
    }
    function init() {
        fn.closed.current = false;
        Data.graph[graphID] = {};
        AvailabilityHistoryData.data = [];
        loadData();
    }
    useEffect(() => { init(); return cleanUp; }, [graphID]);
    function loadData() {
        if (fn.closed.current)
            return;
        let pdo = Utils.postDataOptions({ op: "graph", type: type, id: id, start: AvailabilityHistoryData.selectedTime });
        fetch(apiURL + "availability", pdo).then(res => res.json()).then((result) => {
            if (result.success) {
                parse(result);
                Utils.setState(fn, setError, null);
                Utils.setState(fn, update, Utils.timeStamp());
            }
            else {
                Data.graph[graphID] = {};
                AvailabilityHistoryData.data = [];
                Utils.setState(fn, setError, result.error);
                draw();
            }
        }, (error) => {
            Utils.setState(fn, setError, error.message);
        });
    }
    ;
    function parse(json) {
        const stats = json.values;
        const st = [];
        for (let i = 0; i < stats.length; i += 3) {
            const time = stats[i];
            const status = stats[i + 1];
            const alert = stats[i + 2];
            st.push({ t: time, s: status, a: alert });
        }
        AvailabilityHistoryData.start = json.start;
        AvailabilityHistoryData.end = json.end;
        AvailabilityHistoryData.data = st;
        draw();
    }
    function getAlert(id) {
        if (fn.closed.current)
            return;
        if (AvailabilityHistoryData.alerts[id] && !AvailabilityHistoryData.alerts[id].error)
            return;
        AvailabilityHistoryData.alerts[id] = { error: false };
        let pdo = Utils.postDataOptions({ op: "basic", id: id });
        fetch(apiURL + "alerts", pdo).then(res => res.json()).then((result) => {
            if (result.success) {
                AvailabilityHistoryData.alerts[result.id] = {
                    id: result.id,
                    message: result.message,
                    details: result.details,
                    lastactivity: result.lastactivity
                };
            }
            else {
                AvailabilityHistoryData.alerts[id].error = true;
                Debugger.print(result.error);
            }
        }, (error) => {
            AvailabilityHistoryData.alerts[id].error = true;
            Debugger.print(error.message);
        }).then(() => Utils.setState(fn, update, Utils.timeStamp()));
    }
    function draw() {
        const stats = AvailabilityHistoryData.data;
        if (canvasDOMGraph == null || canvasDOMGraph.current == null)
            return;
        if (fn.closed.current)
            return;
        const canvas = canvasDOMGraph.current;
        const ctx = canvas.getContext("2d");
        const canvasH = canvas.height;
        const canvasW = canvas.width;
        const green = Colors.green;
        let x = 0;
        ctx.clearRect(0, 0, canvasW, canvasH);
        ctx.lineWidth = 1;
        if (!Data.graph[graphID])
            Data.graph[graphID] = {};
        let row = -1;
        for (let i = 0; i < stats.length; i++) {
            if (fn.closed.current)
                return;
            const stat = stats[i];
            if (i % (canvasWidth - 5) == 0) {
                row++;
                x = 0;
            }
            ctx.strokeStyle = stat.s == 1 ? green : "#FF0000";
            if (tt.stat && stat == tt.stat) {
                ctx.strokeStyle = "#0000FF";
            }
            const y2 = (row * rowHeight) + rowHeight - 2;
            const y1 = row * rowHeight;
            stat.x = x;
            stat.r = row;
            Data.graph[graphID][row + "_" + x] = stat;
            ctx.beginPath();
            ctx.moveTo(x, y2);
            ctx.lineTo(x, y1);
            ctx.stroke();
            x++;
        }
    }
    function mouseOver(e) {
        e.stopPropagation();
        const pos = tooltipPosition(e);
        if (!pos)
            return;
        if (pos.stat && pos.stat.a > 0)
            getAlert(pos.stat.a);
        refreshTT({ show: true, render: Utils.timeStamp(), style: pos.style, stat: pos.stat });
    }
    ;
    function mouseOut(e) {
        e.stopPropagation();
        refreshTT({ show: false, render: Utils.timeStamp(), style: null, stat: null });
    }
    function mouseMove(e) {
        e.stopPropagation();
        if (!tt.show)
            return;
        const pos = tooltipPosition(e);
        if (!pos)
            return;
        if (pos.stat && pos.stat.a > 0)
            getAlert(pos.stat.a);
        refreshTT({ show: true, render: Utils.timeStamp(), style: pos.style, stat: pos.stat });
    }
    function tooltipPosition(e) {
        const sx = e.nativeEvent.offsetX;
        const sy = e.nativeEvent.offsetY;
        const ww = Utils.width();
        const wh = Utils.height();
        const row = Math.floor(sy / rowHeight);
        const graph = Data.graph[graphID];
        if (!graph)
            return false;
        const stat = graph[row + "_" + sx];
        const width = stat && stat.a ? 400 : 200;
        const height = stat && stat.a ? 200 : 100;
        const mx = e.clientX;
        const my = e.clientY;
        const style = {
            background: "#303030",
            border: "1px solid #0273b5",
            position: "fixed",
            width: width + "px"
        };
        if (mx > ww - width) {
            style.right = 5;
        }
        else {
            style.left = mx + 5;
        }
        if (my > wh - height) {
            style.bottom = wh - my + 5;
        }
        else {
            style.top = my + 5;
        }
        return { style: style, stat: stat };
    }
    function getDateSelect() {
        const today = new Date();
        const options = [];
        for (let i = 0; i < 30; i++) {
            let day = new Date();
            day.setDate(today.getDate() - i);
            day = new Date(day.setHours(0, 0, 0, 0));
            const label = day.getFullYear() + "-"
                + ("0" + (day.getMonth() + 1)).slice(-2) + "-"
                + ("0" + day.getDate()).slice(-2);
            const value = day.getTime();
            options.push(React.createElement("option", { key: "ahds_" + type + "_" + id + "_" + i, value: value }, label));
        }
        const select = React.createElement("select", { onChange: dateSelected }, options);
        return select;
    }
    function dateSelected(event) {
        const value = event.target.value;
        AvailabilityHistoryData.selectedTime = value;
        init();
    }
    let alert = null;
    if (tt.show > 0 && tt.stat && tt.stat.a) {
        alert = AvailabilityHistoryData.alerts[tt.stat.a];
    }
    let typeStr = "--";
    switch (parseInt(type)) {
        case AvailabilityType.HOST_PING:
            typeStr = "Host Ping";
            break;
        case AvailabilityType.DATABASE_CONNECTION:
            typeStr = "Database Connection";
            break;
        case AvailabilityType.INSTANCE_STATUS:
            typeStr = "Instance Status";
            break;
        case AvailabilityType.DATABASE_STATUS:
            typeStr = "Database Status";
            break;
        case AvailabilityType.DATABASE_PING:
            typeStr = "Database Ping";
            break;
        case AvailabilityType.PORT:
            typeStr = "Port Ping";
            break;
        case AvailabilityType.SERVICE:
            typeStr = "Service Availability";
            break;
        case AvailabilityType.SCHEMA_CONNECTION:
            typeStr = "Database Schema Connection";
            break;
    }
    const showInfo = !props.hideInfo;
    return (React.createElement("div", { id: "panel_availability_history_graph" },
        error &&
            React.createElement("div", null,
                " ",
                error,
                " "),
        showInfo &&
            React.createElement("div", { style: { height: "24px" } },
                React.createElement("div", { style: { float: "left", marginRight: "20px", marginTop: "14px" } }, typeStr),
                AvailabilityHistoryData.start > 0 &&
                    React.createElement("div", { style: { float: "left", marginTop: "14px" } },
                        Utils.toDay(AvailabilityHistoryData.start),
                        " -",
                        Utils.toDay(AvailabilityHistoryData.end)),
                React.createElement("div", { style: { float: "right" } }, getDateSelect())),
        React.createElement("div", null,
            React.createElement("canvas", { ref: canvasDOMGraph, height: panelHeight, width: canvasWidth, onMouseOver: mouseOver, onMouseLeave: mouseOut, onMouseMove: mouseMove })),
        tt.show > 0 && tt.stat &&
            React.createElement("div", { style: tt.style },
                React.createElement("div", { style: { padding: "10px" } },
                    Utils.available(tt.stat.s),
                    " ",
                    React.createElement("br", null),
                    Utils.toDate(tt.stat.t * 1000),
                    React.createElement("br", null),
                    tt.stat.a > 0 && React.createElement("span", null,
                        "Alert:",
                        tt.stat.a),
                    alert && alert.id &&
                        React.createElement("div", null,
                            alert.message,
                            React.createElement("br", null),
                            alert.details,
                            React.createElement("br", null))))));
};
const Bar1 = (props) => {
    const canvasDOM = useRef(null);
    const data = props.data;
    const barWidth = data.width || 300;
    const barHeight = data.height || 24;
    const title = data.title || null;
    function cleanUp() {
    }
    useEffect(() => { draw(); return cleanUp; }, []);
    function draw() {
        if (canvasDOM == null || canvasDOM.current == null)
            return;
        const canvas = canvasDOM.current;
        const ctx = canvas.getContext("2d");
        const ch = barHeight;
        const cw = barWidth - 50;
        let value = data.value;
        const text = data.text == undefined ? data.value : data.text;
        const yellow = "#fff899";
        const green = "#73bf69";
        const red = "#f2495c";
        const orange = "#ff9830";
        const bw = 8;
        const tbc = Math.ceil(cw / bw);
        const bc = Math.ceil((value / 100) * tbc);
        if (value < 0)
            value = 0;
        if (value > 100)
            value = 100;
        ctx.clearRect(0, 0, cw, ch);
        let bColor = green;
        const limits = [];
        if (data.limits) {
            limits.push({ color: green, limit: data.limits.warning });
            limits.push({ color: yellow, limit: data.limits.critical });
            limits.push({ color: orange, limit: data.limits.fatal });
            limits.push({ color: red, limit: 100 });
        }
        else {
            limits.push({ color: green, limit: 100 });
        }
        const boxes = [];
        var i = 0;
        for (var i = 0; i < tbc; i++) {
            const box = { x: i * bw };
            box.p = (box.x / cw) * 100;
            for (var c = 0; c < limits.length; c++) {
                const limit = limits[c];
                if (box.p < limit.limit) {
                    bColor = limit.color;
                    box.limit = limit.limit;
                    break;
                }
            }
            box.color = bColor;
            boxes.push(box);
        }
        var tColor = green;
        for (i = 0; i < bc; i++) {
            const box = boxes[i];
            ctx.fillStyle = box.color;
            ctx.rr("fill", box.x + 1, 0, bw - 2, ch, 2);
            tColor = box.color;
        }
        ctx.fillStyle = tColor;
        ctx.font = "15px Arial";
        ctx.fillText(text, cw + 8, 18);
        ctx.globalAlpha = 0.15;
        for (var k = i; k < boxes.length; k++) {
            const box = boxes[k];
            ctx.fillStyle = box.color;
            ctx.rr("fill", box.x + 1, 0, bw - 2, ch, 2);
        }
    }
    return React.createElement("canvas", { ref: canvasDOM, width: barWidth, height: barHeight, title: title, style: { marginBottom: "2px" } });
};
const CPUShortHistoryGraph = (props) => {
    const hostID = props.hostID;
    const width = props.width;
    const height = props.height;
    const [error, setError] = useState(null);
    const [render, setRender] = useState(0);
    const averages = props.averages ? true : false;
    const [stats, setStats] = useState({ time: 0, groups: [], render: 0 });
    const fn = { closed: useRef(false) };
    let refreshTimeout = 0;
    function cleanUp() {
        fn.closed.current = true;
        clearTimeout(refreshTimeout);
    }
    function init() {
        fn.closed.current = false;
        loadData();
    }
    useEffect(() => { init(); return cleanUp; }, []);
    function loadData() {
        if (fn.closed.current)
            return;
        let pdo = Utils.postDataOptions({ id: hostID, op: "cpumemoryshorthistory", start: stats.time, averages: averages });
        fetch(apiURL + "unit", pdo).then(res => res.json()).then((result) => {
            if (result.success) {
                parseData(result);
                Utils.setState(fn, setError, null);
            }
            else {
                Utils.setState(fn, setError, result.error);
            }
        }, (error) => {
            Utils.setState(fn, setError, error.message);
        }).then(() => {
            if (fn.closed.current)
                return;
            refreshTimeout = setTimeout(loadData, 5000);
        });
    }
    function parseData(json) {
        if (!json.history)
            return;
        const st = stats;
        if (st.groups.length < 1) {
            st.groups = [{ values: [], color: "#03adfd", fill: true }];
            if (averages) {
                st.groups.push({ values: [], color: Colors.yellow, fill: false });
                st.groups.push({ values: [], color: Colors.red, fill: false });
            }
        }
        for (let i = json.history.length - 1; i >= 0; --i) {
            const stat = json.history[i];
            st.groups[0].values.push(stat.c);
            if (averages) {
                st.groups[1].values.push(stat.c5m);
                st.groups[2].values.push(stat.c1h);
            }
        }
        if (st.groups[0].values.length > 200) {
            const len = st.groups[0].length - 200;
            for (let i = 0; i < st.groups.length; i++) {
                st.groups[i].values.splice(0, len);
            }
        }
        st.time = json.last;
        st.render = Utils.timeStamp();
        Utils.setState(fn, setStats, st);
        Utils.setState(fn, setRender, Utils.timeStamp());
    }
    return (React.createElement(LineGraph, { data: { width: width, height: height, groups: stats.groups } }));
};
const Gauge = (props) => {
    const canvasDOM = useRef(null);
    const data = props.data;
    const size = data.size ? data.size : 200;
    const lineWidth = data.lineWidth ? data.lineWidth : 10;
    function cleanUp() {
    }
    useEffect(() => { draw(); return cleanUp; }, []);
    function draw() {
        if (canvasDOM == null || canvasDOM.current == null)
            return;
        const canvas = canvasDOM.current;
        const ctx = canvas.getContext("2d");
        const cH = size;
        const cW = size;
        let center = cW / 2;
        const radius = ((cW / 2) - (lineWidth / 2)) - 1;
        const percentage = data.value;
        const text = data.text == undefined ? data.value : data.text;
        const yellow = "#fff899";
        const green = "#73bf69";
        const red = "#f2495c";
        const orange = "#ff9830";
        const levels = [{ color: green, value: 0 }];
        ctx.clearRect(0, 0, cW, cH);
        let pColor = green;
        if (data.limits) {
            levels[0].value = data.limits.warning;
            levels.push({ color: yellow, value: data.limits.critical });
            levels.push({ color: orange, value: data.limits.fatal });
            levels.push({ color: red, value: 100 });
            if (percentage > data.limits.fatal) {
                pColor = red;
            }
            else if (percentage > data.limits.critical) {
                pColor = orange;
            }
            else if (percentage > data.limits.warning) {
                pColor = yellow;
            }
        }
        else {
            levels.push({ green, value: 100 });
        }
        let lastend = Math.PI;
        ctx.lineWidth = 3;
        ctx.globalAlpha = 0.8;
        for (let i = 0; i < levels.length; i++) {
            const item = levels[i];
            const value = item.value;
            ctx.strokeStyle = item.color;
            ctx.beginPath();
            const end = Math.PI * (1 + (value / 100));
            ctx.arc(center, center, radius, lastend, end, false);
            ctx.stroke();
            lastend = end;
        }
        ctx.strokeStyle = "#333";
        ctx.beginPath();
        ctx.lineWidth = lineWidth;
        ctx.arc(center, center, radius - 15, Math.P, Math.PI * 2, false);
        ctx.stroke();
        ctx.globalAlpha = 1;
        ctx.strokeStyle = pColor;
        ctx.beginPath();
        ctx.lineWidth = 30;
        ctx.arc(center, center, radius - 18, Math.PI, Math.PI * (1 + (percentage / 100)), false);
        ctx.stroke();
        ctx.lineWidth = lineWidth;
        ctx.fillStyle = pColor;
        ctx.font = "20px Arial";
        ctx.fillText(text, center - 15, center - 5);
    }
    draw();
    return React.createElement("canvas", { ref: canvasDOM, width: size, height: size / 2 });
};
const Gauge2 = (props) => {
    const canvasDOM = useRef(null);
    const data = props.data;
    const size = data.size ? data.size : 200;
    const lineWidth = data.lineWidth ? data.lineWidth : 30;
    function cleanUp() {
    }
    useEffect(() => { draw(); return cleanUp; }, []);
    function draw() {
        if (canvasDOM == null || canvasDOM.current == null)
            return;
        const canvas = canvasDOM.current;
        const ctx = canvas.getContext("2d");
        const cH = size;
        const cW = size;
        let center = cW / 2;
        const radius = ((cW / 2) - (lineWidth / 6)) - 1;
        const percentage = Math.round(data.value);
        const text = data.text == undefined ? percentage : data.text;
        const yellow = "#fff899";
        const green = "#73bf69";
        const red = "#f2495c";
        const orange = "#ff9830";
        const levels = [{ color: green, value: 0 }];
        ctx.clearRect(0, 0, cW, cH);
        let pColor = green;
        if (data.limits) {
            levels[0].value = data.limits.warning;
            levels.push({ color: yellow, value: data.limits.critical });
            levels.push({ color: orange, value: data.limits.fatal });
            levels.push({ color: red, value: 100 });
            if (percentage > data.limits.fatal) {
                pColor = red;
            }
            else if (percentage > data.limits.critical) {
                pColor = orange;
            }
            else if (percentage > data.limits.warning) {
                pColor = yellow;
            }
        }
        else {
            levels.push({ green, value: 100 });
        }
        const st = Math.PI * 0.95;
        const en = Math.PI * 2.05;
        const bw = en - st;
        let lastend = st;
        ctx.lineWidth = 3;
        ctx.globalAlpha = 0.8;
        for (let i = 0; i < levels.length; i++) {
            const item = levels[i];
            const value = item.value;
            ctx.strokeStyle = item.color;
            ctx.beginPath();
            const end = st + (bw * (value / 100));
            ctx.arc(center, center, radius + 4, lastend, end, false);
            ctx.stroke();
            lastend = end;
        }
        ctx.strokeStyle = Data.dark ? "#333" : "#ccc";
        ctx.beginPath();
        ctx.lineWidth = lineWidth;
        ctx.arc(center, center, radius - 15, st, en, false);
        ctx.stroke();
        ctx.globalAlpha = 1;
        ctx.strokeStyle = pColor;
        ctx.beginPath();
        ctx.lineWidth = lineWidth;
        ctx.arc(center, center, radius - 15, st, st + (bw * (percentage / 100)), false);
        ctx.stroke();
        ctx.fillStyle = pColor;
        ctx.font = "15px Arial";
        const len = (text + "").length;
        ctx.fillText(text, center - (len * 4), center + 4);
    }
    draw();
    return React.createElement("canvas", { ref: canvasDOM, width: size, height: size * 0.6 });
};
const LineGraph = (props) => {
    const canvasDOM = useRef(null);
    const data = props.data;
    const width = data.width || 500;
    const height = data.height || 200;
    function draw() {
        if (canvasDOM == null || canvasDOM.current == null)
            return;
        const canvas = canvasDOM.current;
        const ctx = canvas.getContext("2d");
        const gS = 20;
        const gW = width - gS;
        let groups = data.groups;
        if (data.values)
            groups = [{ color: "#03adfd", values: data.values, fill: true }];
        let x = gS, ix = 1;
        ctx.clearRect(0, 0, width, height);
        for (let i = groups.length - 1; i >= 0; i--) {
            const group = groups[i];
            let values = group.values;
            const color = group.color;
            const fill = group.fill;
            let start = 0;
            if (gW < values.length)
                start = values.length - gW;
            x = gS;
            ctx.beginPath();
            ctx.lineWidth = 1;
            ctx.strokeStyle = color;
            if (fill)
                ctx.fillStyle = color;
            ix = gW / (values.length - start);
            ctx.moveTo(x, height + 1);
            for (let i = start; i < values.length; i++) {
                const y = height - ((values[i] / 100) * height);
                ctx.lineTo(x, y);
                x += ix;
            }
            ctx.lineTo(x - ix, height + 1);
            ctx.closePath();
            if (fill)
                ctx.globalAlpha = 0.1;
            if (fill)
                ctx.fill();
            ctx.globalAlpha = 0.6;
            ctx.stroke();
        }
        ctx.clearRect(gS - 1, 0, 2, height);
        ctx.clearRect(x - ix - 1, 0, 20, height);
        ctx.beginPath();
        ctx.lineWidth = 0.2;
        ctx.strokeStyle = Data.darkTheme ? "#bbb" : "#111";
        ctx.globalAlpha = 0.6;
        for (let i = 0; i <= 5; i++) {
            const y = i * (height / 5);
            ctx.moveTo(gS, y);
            ctx.lineTo(width, y);
        }
        const verDivWidth = 50;
        const vercount = Math.ceil(gW / verDivWidth);
        x = gS;
        for (var i = 0; i < vercount; i++) {
            ctx.moveTo(x, 0);
            ctx.lineTo(x, height);
            x += verDivWidth;
        }
        ctx.stroke();
        ctx.globalAlpha = 1;
        for (let i = 1; i <= 5; i++) {
            const y = i * (height / 5);
            ctx.fillStyle = Data.darkTheme ? "#a5a5a5" : "#777";
            ctx.fillText((5 - i) * 20, 5, y - 4);
        }
    }
    draw();
    let info = null;
    if (data.groups && data.groups.length > 0 && data.groups[0].name) {
        const divs = [];
        for (let i = 0; i < data.groups.length; i++) {
            const group = data.groups[i];
            const div = React.createElement("div", { key: "ginfo_" + i, style: { float: "left", marginRight: "10px" } },
                React.createElement("div", { style: { background: group.color, width: "12px", height: "12px", display: "inline-block", marginRight: "5px" }, title: group.title }),
                React.createElement("span", { title: group.title }, group.name));
            divs.push(div);
        }
        info = React.createElement("div", { style: { paddingTop: "6px", marginLeft: "20px" } },
            " ",
            divs);
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("canvas", { ref: canvasDOM, width: width, height: height }),
        info));
};
const MemoryShortHistoryGraph = (props) => {
    const hostID = props.hostID;
    const width = props.width;
    const height = props.height;
    const [error, setError] = useState(null);
    const [render, setRender] = useState(0);
    const [stats, setStats] = useState({ time: 0, history: [], render: 0 });
    const fn = { closed: useRef(false) };
    let refreshTimeout = 0;
    function cleanUp() {
        fn.closed.current = true;
        clearTimeout(refreshTimeout);
    }
    function init() {
        fn.closed.current = false;
        loadData();
    }
    useEffect(() => { init(); return cleanUp; }, []);
    function loadData() {
        if (fn.closed.current)
            return;
        let pdo = Utils.postDataOptions({ id: hostID, op: "cpumemoryshorthistory", start: stats.time });
        fetch(apiURL + "unit", pdo).then(res => res.json()).then((result) => {
            if (result.success) {
                parseData(result);
                Utils.setState(fn, setError, null);
            }
            else {
                Utils.setState(fn, setError, result.error);
            }
        }, (error) => {
            Utils.setState(fn, setError, error.message);
        }).then(() => {
            if (fn.closed.current)
                return;
            refreshTimeout = setTimeout(loadData, 5000);
        });
    }
    function parseData(json) {
        if (!json.history)
            return;
        const st = stats;
        for (let i = json.history.length - 1; i >= 0; --i) {
            const stat = json.history[i];
            st.history.push(stat.m);
        }
        if (st.history.length > 200) {
            const len = st.history.length - 200;
            st.history.splice(0, len);
        }
        st.time = json.last;
        st.render = Utils.timeStamp();
        Utils.setState(fn, setStats, st);
        Utils.setState(fn, setRender, Utils.timeStamp());
    }
    return (React.createElement(LineGraph, { data: { width: width, height: height, values: stats.history } }));
};
const Pie = (props) => {
    const canvasDOM = useRef(null);
    const data = props.data;
    const size = data.size ? data.size : 200;
    const lineWidth = data.lineWidth ? data.lineWidth : 10;
    const showInfo = props.data.showInfo || false;
    function cleanUp() {
    }
    useEffect(() => { draw(); return cleanUp; }, []);
    function draw() {
        if (canvasDOM == null || canvasDOM.current == null)
            return;
        const canvas = canvasDOM.current;
        const ctx = canvas.getContext("2d");
        const cH = size;
        const cW = size;
        let center = cW / 2;
        let total = 0;
        let lastend = 0;
        const items = data.items;
        const radius = ((cW / 2) - (lineWidth / 2)) - 1;
        const percentage = data.percentage || "";
        for (let i = 0; i < items.length; i++) {
            const item = items[i];
            total += item.value;
        }
        ctx.clearRect(0, 0, cW, cH);
        const color = items[0].color;
        ctx.strokeStyle = color;
        ctx.beginPath();
        ctx.lineWidth = lineWidth - 3;
        ctx.arc(center, center, radius + 1, 0, 360, false);
        ctx.stroke();
        ctx.lineWidth = lineWidth;
        for (let i = 0; i < items.length; i++) {
            const item = items[i];
            const value = item.value;
            let percentage = value / total;
            let color = item.color;
            if (total < 1) {
                percentage = 100;
                color = "#dedede";
            }
            ctx.strokeStyle = color;
            ctx.beginPath();
            ctx.arc(center, center, radius, lastend, lastend + (Math.PI * 2 * percentage), false);
            ctx.stroke();
            lastend += Math.PI * 2 * percentage;
        }
        if (percentage) {
            ctx.fillStyle = "#aaa";
            ctx.font = "14px Arial";
            ctx.fillText(percentage, center - 15, center + 5);
        }
    }
    draw();
    if (!showInfo)
        return React.createElement("canvas", { style: { float: "left" }, key: "pie_canvas", ref: canvasDOM, width: size, height: size });
    const divs = [];
    const items = data.items;
    let total = 0;
    const unit = data.unit || Utils.bytesToUnit;
    for (let i = 0; i < items.length; i++) {
        const item = items[i];
        total += item.value;
        const div = React.createElement("div", { key: "pie_item_" + i, style: { display: "block", clear: "both", height: "20px" } },
            React.createElement("div", { style: { float: "left", width: "14px", height: "14px", background: item.color } }, " "),
            React.createElement("div", { style: { float: "left", marginLeft: "5px" } },
                item.text,
                "   "),
            React.createElement("div", { style: { float: "right", marginLeft: "20px" } },
                "  ",
                unit(item.value),
                "   "));
        divs.push(div);
    }
    const div = React.createElement("div", { key: "pie_item_total", style: { display: "block", clear: "both" } },
        React.createElement("div", { style: { float: "left", width: "14px", height: "14px" } }, " "),
        React.createElement("div", { style: { float: "left", marginLeft: "5px" } }, " Total "),
        React.createElement("div", { style: { float: "right", marginLeft: "20px" } },
            "  ",
            unit(total),
            "   "));
    divs.push(div);
    const style = { float: "left", marginLeft: "15px", paddingTop: "10px", fontSize: "14px" };
    const canvasStyle = { float: "left", width: size + "px" };
    const canvasContainerStyle = { textAlign: "center", width: "100%", display: "block" };
    if (data.vertical) {
        style.marginLeft = "0";
        style.width = "100%";
        style.display = "inline-block";
        canvasStyle.float = "none";
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { style: canvasContainerStyle },
            React.createElement("canvas", { style: canvasStyle, key: "pie_canvas", ref: canvasDOM, width: size, height: size })),
        React.createElement("div", { key: "pie_items", style: style }, divs)));
};
const PiePanel = (props) => {
};
const ProgressBar = (props) => {
    const containerID = "pb_con_" + props.id;
    function draw(data) {
        const percentage = Math.floor(data.value);
        const w = data.width ? data.width + "px" : "100%";
        const h = data.height ? data.height + "px" : "30px";
        const title = data.notitle ? null : data.name + " " + Math.floor(data.value) + " %" + "\n" + data.title;
        const color1 = data.color1 || "#3bed09";
        const color2 = data.color2 || "#ff1919";
        const suffix = data.suffix ? React.createElement("span", { style: { float: "right", marginRight: "20px" } }, data.suffix) : "";
        let cw = data.width | 100;
        if (!data.width) {
            const container = document.getElementById(containerID);
            cw = container ? container.offsetWidth : 1000;
        }
        const gradientColor = "linear-gradient(to right," + color1 + "," + color2 + ")";
        const containerStyle = { position: "relative", width: w, height: h, marginBottom: "4px" };
        const barStyle = { backgroundImage: gradientColor,
            backgroundSize: cw + "px 100%",
            height: "100%",
            width: (data.value) + "%",
            transition: "all 0.1s",
            opacity: 0.5
        };
        const div = React.createElement("div", { className: "progress_bar_background", key: "pergraph" + data.id, id: containerID, style: containerStyle, title: title },
            React.createElement("div", { style: barStyle }),
            React.createElement("div", { style: { position: "absolute", left: 5, top: 0, width: "100%" } },
                percentage,
                " %  ",
                suffix));
        return div;
    }
    ;
    const div = draw(props.data);
    return div;
};
const ProgressBar3 = (props) => {
    const containerID = "pb3_con_" + props.id;
    function draw(data) {
        const w = data.width ? data.width + "px" : "100%";
        const h = data.height ? data.height + "px" : "20px";
        let color1 = "#40704a";
        let color2 = "#5f996b";
        const threshold = data.threshold || 90;
        const per1 = (data.val1 / data.total) * 100;
        const per2 = (data.val2 / data.total) * 100;
        if (per1 > threshold) {
            color1 = "#704040";
        }
        if (per2 > threshold) {
            color2 = "#995f5f";
        }
        const title = data.title || "";
        let cw = data.width || 100;
        if (!data.width) {
            const container = document.getElementById(containerID);
            cw = container ? container.offsetWidth : 1000;
        }
        const containerStyle = { position: "relative", width: w, height: h, border: "1px solid #555", color: "#eee" };
        const bar1Style = {
            background: color1,
            height: "100%",
            width: (per1) + "%",
            transition: "all 0.1s",
            position: "absolute"
        };
        const bar2Style = {
            background: color2,
            height: "100%",
            width: (per2) + "%",
            transition: "all 0.1s",
            position: "absolute"
        };
        const text = data.text || data.val1 + " / " + data.val2;
        const div = React.createElement("div", { className: "progress_bar3_background", key: "pergraph3" + data.id, id: containerID, style: containerStyle, title: title },
            React.createElement("div", { style: bar2Style }),
            React.createElement("div", { style: bar1Style }),
            React.createElement("div", { style: { position: "absolute", left: 5, top: -3 } }, text),
            React.createElement("div", { style: { position: "absolute", right: 5, top: -3 } }, data.total));
        return div;
    }
    ;
    const div = draw(props.data);
    return div;
};
const R3TransGraph = (props) => {
    const hostID = props.hostID;
    const [error, setError] = useState(null);
    const [tt, refreshTT] = useState({ show: 0, x: 0, y: 0, render: 0, sx: 0 });
    const [last, setLast] = useState();
    const [data, setdata] = useState({});
    const lastRef = useRef(last);
    lastRef.current = last;
    const canvasDOMGraph = useRef(null);
    const fn = { closed: useRef(false) };
    let refreshTimeout = 0;
    function cleanUp() {
        fn.closed.current = true;
        clearTimeout(refreshTimeout);
        Data.graph[hostID] = {};
        Data.r3 = [];
    }
    function init() {
        Debugger.print("r3TransGraph.init:" + hostID);
        fn.closed.current = false;
        Data.graph[hostID] = {};
        setLast();
        Data.r3 = [];
        loadData();
    }
    useEffect(() => { init(); return cleanUp; }, [hostID]);
    function parseData(json) {
        const st = Data.r3;
        const first = Data.r3.length < 1;
        for (let i = 0; i < json.stats.length; i++) {
            const stat = json.stats[i];
            if (first) {
                st.push(stat);
            }
            else {
                st.unshift(stat);
            }
        }
        const last = { time: json.lasttime,
            duration: json.lastduration,
            status: json.laststatus,
            success: json.lastsuccess,
            result: json.lastresult,
            hostid: json.hostid,
            hostname: json.hostname,
            hostalias: json.hostalias
        };
        Utils.setState(fn, setLast, last);
        Data.r3 = st;
        Debugger.print("R3TransGraph.parseData:" + hostID + " Len:" + Data.r3.length);
    }
    function loadData() {
        if (fn.closed.current)
            return;
        let lastTime = 0;
        if (lastRef.current)
            lastTime = lastRef.current.time;
        let pdo = Utils.postDataOptions({ hostid: hostID, op: "r3graph", mapop: "map", time: lastTime });
        fetch(apiURL + "hosts", pdo).then(res => res.json()).then((result) => {
            if (result.success) {
                parseData(result);
                Utils.setState(fn, setError, null);
            }
            else {
                Utils.setState(fn, setError, result.error);
            }
        }, (error) => {
            Utils.setState(fn, setError, error.message);
        }).then(() => {
            if (fn.closed.current)
                return;
            refreshTimeout = setTimeout(loadData, 10000);
        });
    }
    function draw() {
        if (Data.r3.length < 1)
            return;
        if (canvasDOMGraph == null || canvasDOMGraph.current == null)
            return;
        if (fn.closed.current)
            return;
        const canvas = canvasDOMGraph.current;
        canvas.width = 2000;
        const ctx = canvas.getContext("2d");
        const canvasH = canvas.height;
        const canvasW = canvas.width;
        let x = 0;
        ctx.clearRect(0, 0, canvasW, canvasH);
        ctx.lineWidth = 1;
        if (!Data.graph[hostID])
            Data.graph[hostID] = {};
        for (let i = Data.r3.length - 1; i > 0; i--) {
            if (fn.closed.current)
                return;
            const stat = Data.r3[i];
            let duration = stat.d || 1000;
            let h = (duration / 10000) * canvasH;
            if (h > canvasH)
                h = canvasH;
            ctx.strokeStyle = stat.s == 1 ? "#00FF00" : "#FF0000";
            if (tt.stat && stat == tt.stat) {
                ctx.strokeStyle = "#FFFFFF";
                h = canvasH;
            }
            const y2 = canvasH;
            const y1 = canvasH - h;
            stat.x = x;
            Data.graph[hostID][x] = stat;
            ctx.beginPath();
            ctx.moveTo(x, y2);
            ctx.lineTo(x, y1);
            ctx.stroke();
            x++;
        }
    }
    function mouseOver(e) {
        e.stopPropagation();
        const pos = tooltipPosition(e);
        refreshTT({ show: true, render: Utils.timeStamp(), x: pos.x, y: pos.y, sx: pos.sx, stat: pos.stat });
    }
    ;
    function mouseOut(e) {
        e.stopPropagation();
        refreshTT({ show: false, render: Utils.timeStamp(), x: 0, y: 0, sx: 0, stat: null });
    }
    function mouseMove(e) {
        e.stopPropagation();
        if (!tt.show)
            return;
        const pos = tooltipPosition(e);
        refreshTT({ show: true, render: Utils.timeStamp(), x: pos.x, y: pos.y, sx: pos.sx, stat: pos.stat });
    }
    function tooltipPosition(e) {
        const sx = e.nativeEvent.offsetX;
        const stat = Data.graph[hostID][sx];
        getResult(stat);
        return { x: e.clientX + 5, y: e.clientY + 5, sx: sx, stat: stat };
    }
    function getResult(stat) {
        if (fn.closed.current)
            return;
        if (!stat || !stat.t)
            return;
        data.rTime = stat.t;
        clearTimeout(data.rTimeout);
        data.rTimeout = setTimeout(loadResult, 500);
    }
    function loadResult() {
        if (fn.closed.current)
            return;
        let pdo = Utils.postDataOptions({ hostid: hostID, op: "r3graph", mapop: "getresult", time: data.rTime });
        fetch(apiURL + "hosts", pdo).then(res => res.json()).then((result) => {
            if (result.success) {
                data.r = { time: result.time, output: result.output };
            }
        }, (error) => {
            console.log(error.message);
        });
    }
    draw();
    const style = {};
    if (Data.darkTheme) {
        style.background = "#020202";
        style.border = "1px solid #111";
    }
    else {
        style.background = "#f3f3f3";
        style.border = "1px solid #dedede";
    }
    return (React.createElement(React.Fragment, null,
        error &&
            React.createElement("div", null,
                " ",
                error,
                " "),
        last &&
            React.createElement("div", { style: { paddingBottom: "10px" } },
                React.createElement("div", { key: "r3ci" },
                    "Host:",
                    last.hostname,
                    " ( ",
                    last.hostalias,
                    ")"),
                React.createElement("div", { key: "r3cs" },
                    "Current Status:",
                    Utils.R3Status(last.status),
                    " , ",
                    last.result)),
        React.createElement("div", { style: { width: "100%" } },
            React.createElement("canvas", { ref: canvasDOMGraph, height: "200", width: "2000", title: props.title, style: style, onMouseOver: mouseOver, onMouseLeave: mouseOut, onMouseMove: mouseMove })),
        tt.show > 0 && tt.stat &&
            React.createElement("div", { style: {
                    background: "#303030",
                    color: "#dedede",
                    border: "1px solid #0273b5",
                    position: "fixed",
                    left: tt.x,
                    top: tt.y
                } },
                React.createElement("div", { style: { padding: "10px" } },
                    tt.stat.d,
                    " ms",
                    React.createElement("br", null),
                    Utils.toDate(tt.stat.t * 1000)),
                data.r && data.r.time == tt.stat.t &&
                    React.createElement("div", null,
                        data.r.output,
                        "  "))));
};
const StatusBoxes = (props) => {
    const canvasDOM = useRef(null);
    const data = props.data;
    const size = data.size ? data.size : 200;
    const [tt, refreshTT] = useState({ show: 0, x: 0, y: 0, render: 0, sx: 0 });
    const rows = Math.ceil(Math.sqrt(data.items.length));
    const boxSize = (size / rows);
    function cleanUp() {
    }
    useEffect(() => { draw(); return cleanUp; }, [props]);
    function draw() {
        if (canvasDOM == null || canvasDOM.current == null)
            return;
        console.log("StatusBox Draw");
        const items = data.items;
        const canvas = canvasDOM.current;
        const ctx = canvas.getContext("2d");
        const cH = size;
        const cW = size;
        ctx.clearRect(0, 0, cW, cH);
        let row = 0;
        let col = 0;
        console.log("StatusBoxes:" + items.length + " Rows:" + rows);
        const bs = boxSize;
        for (let i = 0; i < items.length; i++) {
            const item = items[i];
            const x = col * bs;
            const y = row * bs;
            ctx.fillStyle = item.color;
            ctx.beginPath();
            ctx.roundRect(x, y, bs - 2, bs - 2, 2);
            ctx.fill();
            if (rows < 4) {
                ctx.fillStyle = "black";
                ctx.font = "12px Arial";
                ctx.fillText(item.nm, x, y + 10);
            }
            col++;
            if (col >= rows) {
                row++;
                col = 0;
            }
            ;
        }
    }
    function mouseOver(e) {
        e.stopPropagation();
        const pos = tooltipPosition(e);
        refreshTT({ show: true, render: Utils.timeStamp(), x: pos.x, y: pos.y, sx: pos.sx, stat: pos.stat });
    }
    ;
    function mouseOut(e) {
        e.stopPropagation();
        refreshTT({ show: false, render: Utils.timeStamp(), x: 0, y: 0, sx: 0, stat: null });
    }
    function mouseMove(e) {
        e.stopPropagation();
        if (!tt.show)
            return;
        const pos = tooltipPosition(e);
        refreshTT({ show: true, render: Utils.timeStamp(), x: pos.x, y: pos.y, stat: pos.stat });
    }
    function tooltipPosition(e) {
        const sx = e.nativeEvent.offsetX;
        const sy = e.nativeEvent.offsetY;
        const col = Math.floor(sx / boxSize);
        const row = Math.floor(sy / boxSize);
        let index = (row * rows) + col;
        const stat = data.items[index];
        return { x: e.clientX + 5, y: e.clientY + 5, stat: stat };
    }
    function getValues(infos) {
        let output = [];
        for (let i = 0; i < infos.length; i++) {
            const info = infos[i];
            const div = React.createElement("div", { key: "sb_tt_line_" + i }, info.label + ":" + info.value);
            output.push(div);
        }
        return output;
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("canvas", { ref: canvasDOM, width: size, height: size, onMouseOver: mouseOver, onMouseLeave: mouseOut, onMouseMove: mouseMove }),
        tt.show > 0 && tt.stat && tt.stat.infos &&
            React.createElement("div", { style: {
                    background: "#303030",
                    color: "#dedede",
                    border: "1px solid #0273b5",
                    position: "fixed",
                    left: tt.x,
                    top: tt.y
                } },
                React.createElement("div", { style: { padding: "10px" } }, getValues(tt.stat.infos)))));
};
const VerticalBarGraph = (props) => {
    const canvasDOM = useRef(null);
    const data = props.data;
    const gW = data.width || 300;
    const gH = data.height || 200;
    const title = data.title || null;
    const [graph, setGraph] = useState({ bw: 10, hovered: -1 });
    function cleanUp() { }
    useEffect(() => { draw(); return cleanUp; }, []);
    function draw() {
        if (canvasDOM == null || canvasDOM.current == null) {
            Debugger.print("VerticalBarGraph.Canvas is not read");
            return;
        }
        Debugger.print("VerticalBarGraph.draw-" + Utils.timeStamp());
        const canvas = canvasDOM.current;
        const ctx = canvas.getContext("2d");
        const LW = 50;
        const ch = gH;
        const cw = gW - LW;
        const yellow = "#fff899";
        const green = "#73bf69";
        const red = "#f2495c";
        const orange = "#ff9830";
        const items = data.items;
        const bw = cw / items.length;
        graph.bw = bw;
        let min = 4444444444444444444;
        let max = -44444444444444444;
        for (let i = 0; i < items.length; i++) {
            const item = items[i];
            if (item.value < min)
                min = item.value;
            if (item.value > max)
                max = item.value;
        }
        ctx.clearRect(0, 0, gW, gH);
        ctx.fillStyle = "#909090";
        ctx.font = "12px Arial";
        for (let i = 1; i <= 5; i++) {
            const val = Math.floor(max * (i / 5));
            const y = ch - ((ch / 5) * (i));
            ctx.fillText(val, 0, y + 11);
        }
        for (let i = 0; i < items.length; i++) {
            if (graph.hovered == i) {
                ctx.fillStyle = "#73bf69";
            }
            else {
                ctx.fillStyle = "#76a0e3";
            }
            const item = items[i];
            const x = LW + (i * bw);
            const y = (item.value / max) * ch;
            const bh = ch - y;
            ctx.fillRect(x + 1, ch - y, bw - 2, ch);
        }
        ctx.beginPath();
        ctx.lineWidth = 0.2;
        ctx.strokeStyle = Data.darkTheme ? "#bbb" : "#111";
        ctx.globalAlpha = 0.6;
        for (let i = 0; i <= 5; i++) {
            const y = i * (ch / 5);
            ctx.moveTo(50, y);
            ctx.lineTo(cw + 50, y);
        }
        const verDivWidth = 50;
        const vercount = Math.ceil(cw / verDivWidth);
        let x = 50;
        for (var i = 0; i <= vercount; i++) {
            ctx.moveTo(x, 0);
            ctx.lineTo(x, ch);
            x += verDivWidth;
        }
        ctx.stroke();
        ctx.globalAlpha = 1;
    }
    function mouseOver(e) {
        e.stopPropagation();
    }
    function mouseOut(e) {
        e.stopPropagation();
        TT.hide();
        graph.hovered = -1;
        draw();
    }
    function mouseMove(e) {
        e.stopPropagation();
        let cx = e.nativeEvent.offsetX;
        let cy = e.nativeEvent.offsetY;
        let barindex = Math.floor((cx - 50) / graph.bw);
        if (barindex < 0 || barindex > data.items.length) {
            TT.hide();
            graph.hovered = -1;
            draw();
            return;
        }
        const bar = data.items[barindex];
        const redraw = graph.hovered != barindex;
        graph.hovered = barindex;
        TT.mouseOver(e);
        let text = bar.tt ? bar.tt : bar.value + "<br/>" + bar.label;
        TT.show(text);
        if (redraw)
            draw();
    }
    return (React.createElement(React.Fragment, null,
        title && React.createElement("div", { style: { height: "40px" } }, title),
        React.createElement("canvas", { ref: canvasDOM, width: gW, height: gH, onMouseOver: mouseOver, onMouseLeave: mouseOut, onMouseMove: mouseMove, style: { marginBottom: "2px" } })));
};
const AddNewGroup = (props) => {
    const fn = { closed: useRef(false) };
    const inputCode = useRef();
    const inputName = useRef();
    function back(e) { e.preventDefault(); cleanUp(); Utils.goBack(props.history); }
    function cleanUp() {
        fn.closed.current = true;
    }
    function add() {
        const code = inputCode.current.value;
        Request.send({
            caller: fn,
            url: apiURL + "groups",
            params: { op: "add", code: code, name: inputName.current.value },
            message: code + " is added",
            success: (json) => {
                Utils.go(props.history, "/group/" + json.id);
            }
        });
    }
    return (React.createElement("div", { id: 'page' },
        React.createElement(Header, { back: back, title: t("Add new group") }),
        React.createElement("div", null,
            t("Name"),
            ":",
            React.createElement("input", { type: "text", ref: inputCode }),
            t("Description"),
            ":",
            React.createElement("input", { type: "text", ref: inputName }),
            React.createElement("button", { onClick: add }, t("Add")))));
};
const Group = (props) => {
    const fn = { closed: useRef(false) };
    const inputCode = useRef();
    const inputName = useRef();
    const selectSystems = useRef();
    const groupID = props.match.params.id;
    const [data, setData] = useState({ name: "", code: "", gid: 0 });
    const [systems, setSystems] = useState({ systems: null });
    function cleanUp() {
        fn.closed.current = true;
    }
    function back(e) { e.preventDefault(); cleanUp(); Utils.goBack(props.history); }
    useEffect(() => { fn.closed.current = false; init(); return cleanUp; }, [groupID]);
    function init() {
        loadSystems();
        loadData();
    }
    function loadData() {
        if (fn.closed.current)
            return;
        Request.send({
            caller: fn,
            url: apiURL + "groups",
            params: { op: "get", gid: groupID },
            listener: (json) => parse(json)
        });
    }
    ;
    function loadSystems() {
        if (fn.closed.current)
            return;
        Request.send({
            caller: fn,
            url: apiURL + "groups",
            params: { op: "systems", gid: groupID },
            success: (json) => {
                Utils.setState(fn, setSystems, json);
            }
        });
    }
    function setContent(content) {
        const container = document.getElementById('groupsystemlist');
        ReactDOM.unmountComponentAtNode(container);
        while (container.firstChild) {
            const element = container.lastChild;
            element.remove();
        }
        ReactDOM.render(content, container);
        return container;
    }
    function parse(json) {
        if (!json.success) {
            return setContent(Utils.error(json.error));
        }
        if (!json || !json.systems) {
            return setContent(Utils.error("Error"));
        }
        Utils.setState(fn, setData, { code: json.cd, name: json.nm, gid: groupID });
        const divs = [];
        let systems = json.systems;
        console.log("Before Sort", systems);
        systems.sort((a, b) => {
            return a.do - b.do;
        });
        console.log("After sort", systems);
        for (let i = 0; i < systems.length; i++) {
            const system = systems[i];
            const style = { width: "400px", height: "30px", cursor: "move" };
            const div = React.createElement("div", { gsid: system.id, key: "gsd_" + i, className: "list-group-item hoverable_div", style: style },
                React.createElement("span", { style: { float: "left" } },
                    " \t",
                    system.cd,
                    " - ",
                    system.nm,
                    " "),
                User.admin && React.createElement(IconButton, { type: "remove", sid: system.id, scode: system.cd, sname: system.nm, onClick: removeSystem, style: { float: "right" } }));
            divs.push(div);
        }
        const container = setContent(divs);
        if (User.admin) {
            Sortable.create(container, { onEnd: dragEnd });
        }
    }
    function dragEnd(evt) {
        const children = evt.to.children;
        let sortList = "";
        for (var i = 0; i < children.length; i++) {
            const child = children[i];
            const sid = child.getAttribute("gsid");
            sortList += sid + "-";
        }
        Request.send({
            caller: fn,
            url: apiURL + "systems",
            params: { op: "systemdisplayorder", list: sortList },
            success: () => {
                Menu.refresh();
            }
        });
    }
    function update() {
        const code = inputCode.current.value;
        Request.send({
            caller: fn,
            url: apiURL + "groups",
            params: { op: "update", code: code, name: inputName.current.value, gid: groupID },
            message: code + " is updated",
            success: () => Menu.refresh()
        });
    }
    function addSystem() {
        if (fn.closed.current)
            return;
        const options = selectSystems.current.options;
        const option = options[options.selectedIndex];
        const sid = Utils.toInt(option.attributes.val.value);
        if (sid < 1) {
            return Info.error("Please select a system from list");
        }
        Request.send({
            caller: fn,
            url: apiURL + "groups",
            params: { op: "addsystem", gid: groupID, sid: sid },
            success: () => {
                loadData();
                Menu.refresh();
            }
        });
    }
    function removeSystem(props) {
        if (fn.closed.current)
            return;
        if (!confirm("Are you sure you want to remove this system ?\n" + props.scode + " " + props.sname))
            return;
        const sid = props.sid;
        Request.send({
            caller: fn,
            url: apiURL + "groups",
            params: { op: "removesystem", gid: groupID, sid: sid },
            success: () => {
                loadData();
                Menu.refresh();
            }
        });
    }
    function remove() {
        if (fn.closed.current)
            return;
        if (!confirm("Are you sure you want to remove this group ?"))
            return;
        Request.send({
            caller: fn,
            url: apiURL + "groups",
            params: { op: "remove", gid: groupID },
            success: () => {
                Utils.go(props.history, "/#home");
            }
        });
    }
    function comboSystems() {
        const list = systems.systems;
        const options = [React.createElement("option", { key: "c_def", val: "0" }, " Select System ")];
        for (let i = 0; i < list.length; i++) {
            const system = list[i];
            options.push(React.createElement("option", { key: "c_" + i, val: system.id },
                system.cd,
                " - ",
                system.nm,
                " "));
        }
        return React.createElement("div", null,
            React.createElement("span", { style: { display: "inline-block", width: "60px" } },
                t("System"),
                ": "),
            React.createElement("select", { style: { width: "182px" }, ref: selectSystems },
                " ",
                options,
                " "),
            React.createElement(IconButton, { type: "add", onClick: addSystem }));
    }
    const inputStyle = {};
    if (!User.admin)
        inputStyle.border = "none";
    return (React.createElement("div", { id: 'page' },
        React.createElement(Header, { back: back, title: t("Group") + " [" + data.code + "]:" + data.name }),
        data.name && data.gid == groupID &&
            React.createElement("div", null,
                React.createElement("span", { style: { display: "inline-block", width: "100px" } },
                    t("Name"),
                    ": "),
                React.createElement("input", { id: "txtcode_" + groupID, key: "txtcode_" + groupID, type: "text", ref: inputCode, defaultValue: data.code, style: inputStyle }),
                User.admin && React.createElement(IconButton, { type: "update", onClick: update }),
                React.createElement("br", null),
                React.createElement("span", { style: { display: "inline-block", width: "100px" } },
                    t("Description"),
                    ": "),
                React.createElement("input", { key: "txtname_" + groupID, type: "text", ref: inputName, defaultValue: data.name, style: inputStyle }),
                User.admin && React.createElement(IconButton, { type: "update", onClick: update }),
                React.createElement("br", null)),
        Data.super && systems.systems && comboSystems(),
        React.createElement("br", null),
        t("Systems"),
        React.createElement("br", null),
        React.createElement("br", null),
        React.createElement("div", { id: 'groupsystemlist' }),
        React.createElement("br", null),
        React.createElement("br", null),
        Data.super && React.createElement("button", { onClick: remove },
            t("Remove this group"),
            " ")));
};
const GroupEdit = (props) => {
    const fn = { closed: useRef(false) };
    const inputCode = useRef();
    const inputName = useRef();
    const selectSystems = useRef();
    const groupID = props.gid;
    const [data, setData] = useState({ name: "", code: "" });
    const [systems, setSystems] = useState({ systems: null });
    function cleanUp() {
        fn.closed.current = true;
    }
    useEffect(() => { fn.closed.current = false; init(); return cleanUp; }, []);
    function init() {
        loadSystems();
        loadData();
    }
    function loadData() {
        if (fn.closed.current)
            return;
        Request.send({
            caller: fn,
            url: apiURL + "groups",
            params: { op: "get", gid: groupID },
            listener: (json) => parse(json)
        });
    }
    ;
    function loadSystems() {
        if (fn.closed.current)
            return;
        Request.send({
            caller: fn,
            url: apiURL + "groups",
            params: { op: "systems", gid: groupID },
            success: (json) => {
                Utils.setState(fn, setSystems, json);
            }
        });
    }
    function setContent(content) {
        const container = document.getElementById('groupsystemlist');
        ReactDOM.render(content, container);
        return container;
    }
    function parse(json) {
        if (!json.success) {
            return setContent(Utils.error(json.error));
        }
        if (!json || !json.systems) {
            return setContent(Utils.error("Error"));
        }
        Utils.setState(fn, setData, { code: json.cd, name: json.nm });
        const divs = [];
        let systems = json.systems;
        systems.sort((a, b) => {
            return a.do - b.do;
        });
        for (let i = 0; i < systems.length; i++) {
            const system = systems[i];
            const style = { width: "100%", height: "30px" };
            const div = React.createElement("div", { gsid: system.id, key: "gsd_" + i, className: "list-group-item", style: style },
                React.createElement("span", { style: { float: "left" } },
                    " \t",
                    system.cd,
                    " - ",
                    system.nm,
                    " "),
                React.createElement(IconButton, { type: "remove", sid: system.id, scode: system.cd, sname: system.nm, onClick: removeSystem, style: { float: "right" } }));
            divs.push(div);
        }
        const container = setContent(divs);
        var sortable = Sortable.create(container, { onEnd: dragEnd });
    }
    function dragEnd(evt) {
        const children = evt.to.children;
        let sortList = "";
        for (var i = 0; i < children.length; i++) {
            const child = children[i];
            const sid = child.getAttribute("gsid");
            sortList += sid + "-";
        }
        Request.send({
            caller: fn,
            url: apiURL + "systems",
            params: { op: "systemdisplayorder", list: sortList }
        });
    }
    function update() {
        const code = inputCode.current.value;
        Request.send({
            caller: fn,
            url: apiURL + "groups",
            params: { op: "update", code: code, name: inputName.current.value, gid: groupID },
            message: code + " is updated"
        });
    }
    function addSystem() {
        if (fn.closed.current)
            return;
        const options = selectSystems.current.options;
        const option = options[options.selectedIndex];
        const sid = Utils.toInt(option.attributes.val.value);
        if (sid < 1) {
            return Info.error("Please select a system from list");
        }
        Request.send({
            caller: fn,
            url: apiURL + "groups",
            params: { op: "addsystem", gid: groupID, sid: sid },
            success: () => loadData()
        });
    }
    function removeSystem(props) {
        if (fn.closed.current)
            return;
        const sid = props.sid;
        Request.send({
            caller: fn,
            url: apiURL + "groups",
            params: { op: "removesystem", gid: groupID, sid: sid },
            success: () => loadData()
        });
    }
    function remove() {
        if (fn.closed.current)
            return;
        Request.send({
            caller: fn,
            url: apiURL + "groups",
            params: { op: "remove", gid: groupID },
            success: () => Dialog.close()
        });
    }
    function comboSystems() {
        const list = systems.systems;
        const options = [React.createElement("option", { key: "c_def", val: "0" }, " Select System ")];
        for (let i = 0; i < list.length; i++) {
            const system = list[i];
            options.push(React.createElement("option", { key: "c_" + i, val: system.id },
                system.cd,
                " - ",
                system.nm,
                " "));
        }
        return React.createElement("div", null,
            React.createElement("span", { style: { display: "inline-block", width: "60px" } },
                t("System"),
                ": "),
            React.createElement("select", { style: { width: "182px" }, ref: selectSystems },
                " ",
                options,
                " "),
            React.createElement(IconButton, { type: "add", onClick: addSystem }));
    }
    return (React.createElement("div", { id: 'panel_group_edit', style: { textAlign: "left" } },
        data.name &&
            React.createElement("div", null,
                React.createElement("span", { style: { display: "inline-block", width: "60px" } },
                    t("Name"),
                    ": "),
                React.createElement("input", { type: "text", ref: inputCode, defaultValue: data.code }),
                React.createElement(IconButton, { type: "update", onClick: update }),
                React.createElement("br", null),
                React.createElement("span", { style: { display: "inline-block", width: "60px" } },
                    t("Description"),
                    ": "),
                React.createElement("input", { type: "text", ref: inputName, defaultValue: data.name }),
                React.createElement(IconButton, { type: "update", onClick: update }),
                React.createElement("br", null)),
        systems.systems && comboSystems(),
        React.createElement("br", null),
        t("Systems"),
        React.createElement("br", null),
        React.createElement("br", null),
        React.createElement("div", { id: 'groupsystemlist' }),
        React.createElement("button", { onClick: remove },
            t("Remove this group"),
            " ")));
};
const Groups = (props) => {
    const fn = { closed: useRef(false) };
    function back(e) { e.preventDefault(); cleanUp(); Utils.goBack(props.history); }
    function cleanUp() {
        fn.closed.current = true;
    }
    useEffect(() => { fn.closed.current = false; loadData(); return cleanUp; }, []);
    function loadData() {
        if (fn.closed.current)
            return;
        setContent(Utils.loading());
        Request.send({
            caller: fn,
            url: apiURL + "groups",
            params: { op: "listall" },
            listener: (json) => parse(json)
        });
    }
    ;
    function setContent(content) {
        const container = document.getElementById('grouplist');
        ReactDOM.render(content, container);
        return container;
    }
    function parse(json) {
        if (!json.success) {
            return setContent(Utils.error(json.error));
        }
        if (!json || !json.groups) {
            return setContent(Utils.error("Error"));
        }
        const divs = [];
        let groups = json.groups;
        groups.sort((a, b) => {
            return a.do - b.do;
        });
        for (let i = 0; i < groups.length; i++) {
            const group = groups[i];
            const style = { minHeight: "60px", margin: "10px", marginLeft: "0", float: "left" };
            const systems = group.systems;
            const sdivs = [];
            systems.sort((a, b) => {
                return a.do - b.do;
            });
            for (let s = 0; s < systems.length; s++) {
                const system = systems[s];
                const div = React.createElement("div", { key: "grs_" + i + "_" + s, title: system.nm }, system.cd);
                sdivs.push(div);
            }
            const div = React.createElement("div", { gid: group.id, key: "gd_" + i, className: "list-group-item", style: style },
                React.createElement("div", { className: "paleborder windowheader", style: { height: "30px" } },
                    React.createElement("span", { className: "noselect", style: { display: "inline-block", marginLeft: "10px", marginRight: "10px", paddingTop: "5px", fontWeight: "bold", cursor: "move" }, title: group.nm },
                        group.cd,
                        " (",
                        group.nm,
                        ")"),
                    React.createElement("a", { href: "#group/" + group.id },
                        React.createElement("img", { className: "imagebutton", type: "svg", style: { width: "18px", float: "right" }, src: "/images/icons/settings.svg", title: t("Edit") }))),
                React.createElement("div", { style: { margin: "10px" } }, sdivs));
            divs.push(div);
        }
        const container = setContent(divs);
        if (User.admin)
            Sortable.create(container, { onEnd: dragEnd });
    }
    function dragEnd(evt) {
        const children = evt.to.children;
        let sortList = "";
        for (var i = 0; i < children.length; i++) {
            const child = children[i];
            const sid = child.getAttribute("gid");
            sortList += sid + "-";
        }
        Request.send({
            caller: fn,
            url: apiURL + "groups",
            params: { op: "setdisplayorder", list: sortList }
        });
    }
    return (React.createElement("div", { id: 'page' },
        React.createElement(Header, { back: back, title: t("Groups") }),
        User.admin && t("Drag boxes to change display order"),
        React.createElement("div", { id: 'grouplist' })));
};
const Header = (props) => {
    let pw = "calc(100% - 380px)";
    if (Data.hideMenu) {
        pw = "calc(100% - 80px)";
    }
    const style = { width: pw };
    if (props.critical) {
        style.background = "#730800";
    }
    const updating = props.updating && Utils.updating();
    return (React.createElement("div", { id: "header", style: style, className: "noprint" },
        React.createElement("div", { className: "headerback", onClick: props.back, title: t("Return Back") },
            React.createElement("img", { src: "/images/icons/arrow_left_black.svg", width: "20", style: { filter: "invert(1)" } })),
        React.createElement("div", { style: { paddingTop: "2px", float: "left" } }, props.title),
        React.createElement("div", { style: { float: "right" } }, props.children),
        React.createElement("div", { style: { float: "right", width: "30px", height: "30px", paddingTop: "7px" } }, updating)));
};
const History = {
    dashboard: { root: { index: 0, link: "#/dashboard", name: "Dashboard" } },
    links: function (key) {
        const links = [];
        const map = History[key];
        console.log(map);
        let first = true;
        for (let key in map) {
            if (!map.hasOwnProperty(key))
                continue;
            const obj = map[key];
            if (!first)
                links.push(React.createElement("span", { key: "sp_" + obj.index }, " > "));
            links.push(React.createElement("a", { key: "ah_" + obj.index, title: obj.title || "", href: "#/" + obj.link }, obj.name));
            first = false;
        }
        return React.createElement("div", null, links);
    },
    remove: function (key1, key2) {
        const parts = key2.split(",");
        for (let i = 0; i < parts.length; i++) {
            const k = parts[i];
            delete History[key1][k];
        }
    }
};
const Home = (props) => {
    const fn = { closed: useRef(false) };
    const [r, refresh] = useState(0);
    const propsType = Utils.toInt(props.match.params.type);
    const settingsType = UserSettings.getInt("dashboard");
    const type = propsType || settingsType;
    function cleanUp() {
        fn.closed.current = true;
    }
    useEffect(() => { fn.closed.current = false; init(); return cleanUp; }, [props]);
    function init() {
        UserSettings.set("dashboard", type);
        Utils.setState(fn, refresh, Utils.timeStamp());
    }
    function back(e) {
        e.preventDefault();
        cleanUp();
        Utils.goBack(props.history);
    }
    return (React.createElement("div", { id: 'page' },
        React.createElement(Header, { back: back, title: t("Dashboard") }),
        React.createElement(Dashboard1, null)));
};
const AddNewUnit = (props) => {
    const [error, setError] = useState(null);
    const [hostAvailable, setHostAvailable] = useState(false);
    const fn = { exited: false };
    const inputName = useRef("");
    const inputAlias = useRef("");
    const inputIP = useRef("");
    const inputMachine = useRef(0);
    const inputOSType = useRef(0);
    const inputEnvironment = useRef(0);
    console.log(props);
    const SID = props.match.params.sid;
    function back(e) { e.preventDefault(); cleanUp(); Utils.goBack(props.history, "/#units"); }
    function cleanUp() {
        fn.exited = true;
    }
    function add() {
        const options = {
            name: inputName.current.value,
            alias: inputAlias.current.value,
            ip: inputIP.current.value,
            machine: inputMachine.current.value,
            ostype: inputOSType.current.value,
            environment: inputEnvironment.current.value,
            op: "add",
            sid: SID
        };
        const pdo = Utils.postDataOptions(options);
        fetch(apiURL + "hosts/", pdo)
            .then(response => response.json())
            .then((result) => {
            console.log(result);
            if (result.success) {
                return Utils.go(props.history, "/#home");
            }
            if (result.error) {
                setError(Utils.error(result.error));
            }
        }, (error) => {
            setError(Utils.error(error.message));
        });
    }
    function checkHost() {
        const options = {
            name: inputName.current.value,
            alias: inputAlias.current.value,
            ip: inputIP.current.value,
            op: "checkadd",
            sid: SID
        };
        const pdo = Utils.postDataOptions(options);
        fetch(apiURL + "hosts/", pdo)
            .then(response => response.json())
            .then((result) => {
            console.log(result);
            if (result.success) {
                inputIP.current.value = result.ip;
                setError(null);
                setHostAvailable(true);
            }
            else {
                setError(Utils.error(result.error));
            }
        }, (error) => {
            setError(Utils.error(error.message));
        });
    }
    const scode = Data.systemCode(SID);
    return (React.createElement("div", { id: "page" },
        React.createElement(Header, { back: back, title: t("Add new host") + " " + (scode && "[" + scode + "]") }),
        React.createElement("div", null,
            React.createElement("div", { className: "col-md-6" },
                React.createElement("table", { className: "nobordertable" },
                    React.createElement("tbody", null,
                        React.createElement("tr", null,
                            React.createElement("td", null,
                                t("Hostname"),
                                Utils.required()),
                            React.createElement("td", null,
                                React.createElement("input", { ref: inputName, type: "text", size: "30", field: "name", placeholder: t("Name") })),
                            React.createElement("td", null,
                                React.createElement("button", { onClick: checkHost },
                                    " ",
                                    t("Find"),
                                    " "))),
                        React.createElement("tr", null,
                            React.createElement("td", null, "IP"),
                            React.createElement("td", null,
                                React.createElement("input", { ref: inputIP, type: "text", size: "30", field: "ip", placeholder: t("IP") }))),
                        React.createElement("tr", null,
                            React.createElement("td", null, t("Description")),
                            React.createElement("td", null,
                                React.createElement("input", { ref: inputAlias, type: "text", size: "30", field: "alias", placeholder: t("Description") })),
                            React.createElement("td", null)),
                        React.createElement("tr", null,
                            React.createElement("td", null, t("Type")),
                            React.createElement("td", null,
                                React.createElement("select", { ref: inputMachine, field: "machine" },
                                    React.createElement("option", { value: "0" }, t("Unknown")),
                                    React.createElement("option", { value: "1" }, t("Physical Computer")),
                                    React.createElement("option", { value: "2" }, t("Virtual Computer")),
                                    React.createElement("option", { value: "3" }, t("Network Device")),
                                    React.createElement("option", { value: "4" }, t("VMWare VCenter")))),
                            React.createElement("td", null)),
                        React.createElement("tr", null,
                            React.createElement("td", null, t("Operating System")),
                            React.createElement("td", null,
                                React.createElement("select", { ref: inputOSType, field: "ostype" },
                                    React.createElement("option", { value: "0" }, t("Unknown")),
                                    React.createElement("option", { value: "1" }, "Windows"),
                                    React.createElement("option", { value: "2" }, "Linux"),
                                    React.createElement("option", { value: "3" }, "Unix"))),
                            React.createElement("td", null)),
                        React.createElement("tr", null,
                            React.createElement("td", null, t("Environment")),
                            React.createElement("td", null,
                                React.createElement("select", { ref: inputEnvironment, field: "environment" },
                                    React.createElement("option", { value: "0" }, t("Unknown")),
                                    React.createElement("option", { value: "1" }, "Development"),
                                    React.createElement("option", { value: "2" }, "Production"),
                                    React.createElement("option", { value: "3" }, "Demo"),
                                    React.createElement("option", { value: "4" }, "Staging"),
                                    React.createElement("option", { value: "5" }, "QA/Test"))),
                            React.createElement("td", null)))),
                React.createElement("div", { className: "space40" }),
                React.createElement("button", { id: "submit", value: "Submit", onClick: add, disabled: !hostAvailable }, t("Add")),
                React.createElement("button", { onClick: back }, t("Cancel")),
                React.createElement("div", null,
                    " ",
                    error),
                React.createElement("br", null),
                React.createElement("a", { href: "#add-host-to-system/" + SID }, t("Select from existing hosts"))))));
};
const CPUGraph = (props) => {
    const canvasDOMGraph = useRef(null);
    const data = props.data;
    const id = props.id;
    function draw(data) {
        if (!data.success) {
            return;
        }
        if (canvasDOMGraph == null || canvasDOMGraph.current == null)
            return;
        const canvas = canvasDOMGraph.current;
        canvas.width = canvas.parentElement.clientWidth;
        const limit = 100;
        const ctx = canvas.getContext("2d");
        const canvasH = canvas.height;
        const canvasW = canvas.width;
        const step = canvasW / limit;
        if (!Data.cpu[id]) {
            Data.cpu[id] = [];
        }
        const cpu = Data.cpu[id];
        if (data.push !== false) {
            cpu.push(data.cpu);
        }
        if (cpu.length > limit) {
            cpu.shift();
        }
        let x = canvasW - (cpu.length * step);
        ctx.clearRect(0, 0, canvasW, canvasH);
        ctx.beginPath();
        ctx.lineWidth = 0;
        ctx.strokeStyle = Data.darkTheme ? "#080808" : "#fefefe";
        for (let i = 1; i <= 10; i++) {
            const y = i * (canvasH / 10);
            ctx.moveTo(0, y);
            ctx.lineTo(canvasW, y);
            if (!data.hideNumbers) {
                ctx.fillStyle = "#a5a5a5";
                ctx.fillText((10 - i) * 10, 5, y - 4);
            }
        }
        ctx.stroke();
        ctx.beginPath();
        ctx.lineWidth = 2;
        ctx.strokeStyle = "#0000ff";
        let values = "";
        for (let i = 0; i < cpu.length; i++) {
            const val = cpu[i];
            const y = canvasH - ((val / 100) * canvasH);
            ctx.lineTo(x, y);
            ctx.moveTo(x, y);
            x += step;
            values += val.toFixed(0) + "-";
        }
        ctx.stroke();
    }
    draw(data);
    const style = {};
    if (Data.darkTheme) {
        style.background = "#020202";
        style.border = "1px solid #111";
    }
    else {
        style.background = "#f3f3f3";
        style.border = "1px solid #dedede";
    }
    const height = data.height ? data.height : 300;
    const width = data.width ? data.width : "100%";
    return (React.createElement("div", { style: { width: width } },
        React.createElement("canvas", { ref: canvasDOMGraph, height: height, width: "100%", title: props.title, style: style })));
};
const CPUMemory = (props) => {
    const [state, setState] = useState({});
    const canvasDOM = useRef(null);
    let data = props.data;
    let timeOut = 0;
    let exited = false;
    function cleanUp() {
        console.log("CPUMemory.cleanUp timeOut:" + timeOut);
        exited = true;
        clearTimeout(timeOut);
    }
    useEffect(() => { if (data.auto) {
        loadData();
    } return cleanUp; }, []);
    function draw(data) {
        if (canvasDOM == null || canvasDOM.current == null)
            return;
        const canvas = canvasDOM.current;
        const ctx = canvas.getContext("2d");
        const canvasH = canvas.height;
        const canvasW = canvas.width;
        ctx.clearRect(0, 0, canvasW, canvasH);
        if (!data.success) {
            return;
        }
        const cw = (canvas.width / 2) - 10;
        const ch = canvas.height - 30;
        const bh = ((data.cpu / 100) * ch);
        let mem = data["memory.used"] / data["memory.total"];
        if (isNaN(mem))
            mem = 0;
        const memPercentage = Math.round(mem * 100);
        const mh = (mem) * ch;
        let cRect = { x: 0, y: ch - bh, width: cw, height: bh };
        let mRect = { x: cw + 10, y: ch - mh, width: cw, height: mh };
        let cpu = Math.round(data.cpu);
        let color = "#66ff8f";
        let memColor = "";
        if (data.cpu > 50) {
            color = "#ff4a4a";
        }
        if (memPercentage > 80) {
            memColor = "#ff4a4a";
        }
        if (!data.success) {
            color = "#dedede";
            cpu = "";
            cRect = { x: 5, y: 5, width: cw, height: ch };
        }
        ctx.beginPath();
        ctx.fillStyle = color;
        ctx.fillRect(cRect.x, cRect.y, cRect.width, cRect.height);
        ctx.fillStyle = memColor;
        ctx.fillRect(mRect.x, mRect.y, mRect.width, mRect.height);
        ctx.fillStyle = "#666";
        ctx.font = "14px Arial";
        ctx.fillText(cpu, (cw / 2) - 6, ch - 10);
        ctx.fillText(memPercentage, mRect.x + (cw / 2) - 6, ch - 10);
        ctx.fillStyle = "#a5a5a5";
        ctx.fillText("CPU", (cw / 2) - 15, ch + 15);
        ctx.fillText("Mem", mRect.x + (cw / 2) - 15, ch + 15);
    }
    function loadData() {
        if (exited)
            return;
        let unitid = props.id;
        if (!unitid) {
            return setState({ success: false, error: { message: "Unit is not found" } });
        }
        let pdo = Utils.postDataOptions({ id: unitid, op: "cpumemory" });
        fetch(apiURL + "unit", pdo).then(res => res.json()).then((result) => {
            setState(result);
            timeOut = setTimeout(() => { loadData(); }, 2000);
        }, (error) => {
            setState({ success: false, error: error.message });
            timeOut = setTimeout(() => { loadData(); }, 10000);
        });
    }
    if (data.auto) {
        if (state.error) {
            console.log(state.error);
            draw(state);
        }
        else {
            data = state;
            draw(data);
        }
    }
    else {
        draw(data);
    }
    const used = data["memory.used"];
    const total = data["memory.total"];
    const title = "CPU : " + Math.floor(data["cpu"]) + "%\n" + "Memory : " + Utils.bytesToUnit(used) + " / " + Utils.bytesToUnit(total) +
        "\nClick to see CPU details";
    return (React.createElement("div", { id: 'cpumemory', unitid: props.id, style: { width: "120px", margin: "10px", cursor: "pointer" }, onClick: props.onClick },
        React.createElement("canvas", { ref: canvasDOM, width: 120, height: 120, title: title })));
};
const CPUMemoryDetails = (props) => {
    const [data, setData] = useState({});
    const [error, setError] = useState(null);
    const hostID = props.id;
    const fn = { closed: useRef(false) };
    let refreshTimeout = 0;
    function cleanUp() {
        fn.closed.current = true;
        clearTimeout(refreshTimeout);
    }
    useEffect(() => { fn.closed.current = false; loadData(); return cleanUp; }, []);
    function loadData() {
        if (fn.closed.current)
            return;
        let pdo = Utils.postDataOptions({ id: hostID, op: "cpumemory" });
        fetch(apiURL + "unit", pdo).then(res => res.json()).then((result) => {
            if (result.success) {
                Utils.setState(fn, setData, result);
                Utils.setState(fn, setError, null);
            }
            else {
                Utils.setState(fn, setData, null);
                Utils.setState(fn, setError, result.error);
            }
        }, (error) => {
            Utils.setState(fn, setError, Utils.error(error.message));
        }).then(() => {
            if (fn.closed.current)
                return;
            refreshTimeout = setTimeout(loadData, 2000);
        });
    }
    if (error) {
        return Utils.error(error);
    }
    if (!data)
        return React.createElement("div", null,
            " ",
            t("Loading..."),
            " ");
    let cpu = 0;
    let mem = 0;
    if (data) {
        mem = data["memory.used"] / data["memory.total"];
        cpu = data["cpu"];
        if (isNaN(mem))
            mem = 0;
    }
    const memPercentage = Math.round(mem * 100);
    return (React.createElement("div", { id: 'cpumemorydetails', style: { margin: "10px" } },
        React.createElement(ProgressBar, { id: "pb_cpu_" + hostID, data: { value: cpu, name: "CPU", mid: 30, high: 60, height: 20 } }),
        React.createElement(ProgressBar, { id: "pb_ram_" + hostID, data: { value: memPercentage, name: "Memory", mid: 80, high: 90, height: 20 } }),
        React.createElement(CPUGraph, { id: "cpu_graph_" + hostID, key: "cpu_graph_" + hostID, data: data, title: "CPU : " + Utils.percentage(data["cpu"]) + "\n" + "Memory : " + Utils.bytesToUnit(data["memory.available"]) + " / " + Utils.bytesToUnit(data["memory.total"]) }),
        React.createElement("div", { style: { clear: "both", textAlign: "center", color: "#606060" } },
            React.createElement(HostCores, { hostid: hostID }))));
};
const CPUMemoryHistoryGraph = (props) => {
    const hostID = props.hostID;
    const [stats, setStats] = useState({ time: 0, history: [], render: 0 });
    const [error, setError] = useState(null);
    const [render, setRender] = useState(0);
    const [tt, refreshTT] = useState({ show: 0, x: 0, y: 0, render: 0, sx: 0 });
    const canvasDOMGraph = useRef(null);
    const fn = { closed: useRef(false) };
    const size = 1280;
    let start = 0;
    let refreshTimeout = 0;
    function cleanUp() {
        fn.closed.current = true;
        clearTimeout(refreshTimeout);
    }
    function init() {
        fn.closed.current = false;
        loadData();
    }
    useEffect(() => { init(); return cleanUp; }, []);
    function parseData(json) {
        if (!json.history)
            return;
        const st = stats;
        for (let i = json.history.length - 1; i >= 0; --i) {
            const stat = json.history[i];
            stat.date = Utils.toDate(stat.t);
            st.history.push(stat);
        }
        st.time = json.last;
        st.render = Utils.timeStamp();
        Utils.setState(fn, setStats, st);
        Utils.setState(fn, setRender, Utils.timeStamp());
        console.log("Stats set:" + json.history.length);
    }
    function loadData() {
        if (fn.closed.current)
            return;
        let pdo = Utils.postDataOptions({ id: hostID, op: "cpumemoryhistory", start: stats.time });
        fetch(apiURL + "unit", pdo).then(res => res.json()).then((result) => {
            if (result.success) {
                parseData(result);
                Utils.setState(fn, setError, null);
            }
            else {
                Utils.setState(fn, setError, result.error);
            }
        }, (error) => {
            Utils.setState(fn, setError, error.message);
        }).then(() => {
            if (fn.closed.current)
                return;
            refreshTimeout = setTimeout(loadData, 5000);
        });
    }
    function draw() {
        if (canvasDOMGraph == null || canvasDOMGraph.current == null)
            return;
        const canvas = canvasDOMGraph.current;
        canvas.width = size + 50;
        const ctx = canvas.getContext("2d");
        const canvasH = 200;
        const canvasW = canvas.width;
        let x = 20;
        ctx.clearRect(0, 0, canvasW, canvasH);
        start = 0;
        if (size < stats.history.length)
            start = stats.history.length - size;
        ctx.beginPath();
        ctx.lineWidth = 0;
        ctx.strokeStyle = Data.darkTheme ? "#080808" : "#fefefe";
        for (let i = 1; i <= 10; i++) {
            const y = i * (canvasH / 10);
            ctx.moveTo(0, y);
            ctx.lineTo(canvasW, y);
            ctx.fillStyle = "#a5a5a5";
            ctx.fillText((10 - i) * 10, 5, y - 4);
        }
        ctx.stroke();
        ctx.beginPath();
        ctx.lineWidth = 2;
        ctx.strokeStyle = "rgba(0, 180, 0,0.5)";
        x = 20;
        for (let i = start; i < stats.history.length; i++) {
            const stat = stats.history[i];
            const y = canvasH - ((stat.s / 100) * canvasH);
            ctx.lineTo(x, y);
            ctx.moveTo(x, y);
            x++;
        }
        ctx.stroke();
        ctx.beginPath();
        ctx.strokeStyle = "#b08309";
        x = 20;
        for (let i = start; i < stats.history.length; i++) {
            const stat = stats.history[i];
            const y = canvasH - ((stat.m / 100) * canvasH);
            ctx.lineTo(x, y);
            ctx.moveTo(x, y);
            x++;
        }
        ctx.stroke();
        x = 20;
        ctx.beginPath();
        ctx.lineWidth = 2;
        ctx.strokeStyle = "#0000ff";
        for (let i = start; i < stats.history.length; i++) {
            const stat = stats.history[i];
            const y = canvasH - ((stat.c / 100) * canvasH);
            ctx.lineTo(x, y);
            ctx.moveTo(x, y);
            x++;
        }
        ctx.stroke();
    }
    function mouseOver(e) {
        e.stopPropagation();
        const pos = tooltipPosition(e);
        refreshTT({ show: true, render: Utils.timeStamp(), x: pos.x, y: pos.y, sx: pos.sx, stat: pos.stat });
    }
    ;
    function mouseOut(e) {
        e.stopPropagation();
        refreshTT({ show: false, render: Utils.timeStamp(), x: 0, y: 0, sx: 0, stat: null });
    }
    function mouseMove(e) {
        e.stopPropagation();
        if (!tt.show)
            return;
        const pos = tooltipPosition(e);
        refreshTT({ show: true, render: Utils.timeStamp(), x: pos.x, y: pos.y, sx: pos.sx, stat: pos.stat });
    }
    function tooltipPosition(e) {
        const sx = e.nativeEvent.offsetX - 20;
        let stat = null;
        if (sx >= 0 && stats.history.length > sx) {
            stat = stats.history[sx + start];
        }
        return { x: e.clientX + 5, y: e.clientY + 5, sx: sx, stat: stat };
    }
    if (stats.history.length < 1)
        return React.createElement("div", null, " Loading... ");
    draw();
    const style = {};
    if (Data.darkTheme) {
        style.background = "#020202";
        style.border = "1px solid #111";
    }
    else {
        style.background = "#f3f3f3";
        style.border = "1px solid #dedede";
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { style: { width: "100%" } },
            React.createElement("canvas", { ref: canvasDOMGraph, height: "200", width: size, style: style, onMouseOver: mouseOver, onMouseLeave: mouseOut, onMouseMove: mouseMove })),
        React.createElement("div", { style: { paddingTop: "10px" } },
            React.createElement("div", { style: { background: "#0000ff", width: "16px", height: "16px", float: "left" } }),
            React.createElement("div", { style: { float: "left", paddingLeft: "10px", paddingRight: "10px" } }, " CPU"),
            React.createElement("div", { style: { background: "#b08309", width: "16px", height: "16px", float: "left" } }),
            React.createElement("div", { style: { float: "left", paddingLeft: "10px", paddingRight: "10px" } }, " Memory"),
            React.createElement("div", { style: { background: "rgba(0, 180, 0,0.5)", width: "16px", height: "16px", float: "left" } }),
            React.createElement("div", { style: { float: "left", paddingLeft: "10px", paddingRight: "10px" } }, " Swap")),
        tt.show > 0 && tt.stat &&
            React.createElement("div", { style: {
                    background: "#303030",
                    color: "#dedede",
                    border: "1px solid #0273b5",
                    position: "fixed",
                    left: tt.x,
                    top: tt.y
                } },
                React.createElement("div", { style: { padding: "10px" } },
                    "CPU:",
                    tt.stat.c,
                    " %",
                    React.createElement("br", null),
                    "Memory:",
                    tt.stat.m,
                    " %",
                    React.createElement("br", null),
                    "Swap:",
                    tt.stat.s,
                    " %",
                    React.createElement("br", null),
                    Utils.toDate(tt.stat.t)))));
};
const CPUMemoryLine = (props) => {
    const fn = { exited: false };
    function cleanUp() {
        fn.exited = true;
    }
    function draw(data) {
        const w = data.w ? data.w + "px" : "100%";
        const title = "CPU:" + Math.floor(data.cpu) + "%\nMemory:" + Math.floor(data.memory) + "%";
        const cpuColor = data.cpu > 50 ? "#ff4a4a" : "#bababa";
        const memoryColor = data.memory > 80 ? "#ff4a4a" : "#bababa";
        const div = React.createElement("div", { key: "cpuline_" + data.id, style: { width: w, height: "40px" }, title: title },
            React.createElement("div", { style: { width: (data.cpu + 1) + "%", height: "10px", borderBottom: "5px solid " + cpuColor } }),
            React.createElement("div", { style: { width: data.memory + "%", height: "10px", borderBottom: "5px solid " + memoryColor } }));
        return div;
    }
    ;
    const div = draw(props.data);
    return div;
};
const FileBrowser = (props) => {
    const url = apiURL + "unitbrowser";
    const [state, setState] = useState({});
    const [currentFolder, setCurrentFolder] = useState(props.folder);
    const [sorting, setSorting] = useState({ field: "name", previous: "", direction: "ascending" });
    const fn = { exited: false, seperator: "\\" };
    function cleanUp() {
        fn.exited = true;
    }
    console.log("FileBrowser currentFolder:" + currentFolder);
    useEffect(() => { browse(props.folder); return cleanUp; }, []);
    function browse(folder) {
        if (fn.exited)
            return;
        const drive = props.drive;
        if (!drive || folder == undefined) {
            return setState({ success: false, error: { message: "Location is not found:" + drive + " " + folder } });
        }
        let pdo = Utils.postDataOptions({ id: props.id, drive: drive, folder: folder });
        fetch(url, pdo).then(res => res.json()).then((result) => {
            if (result.success && result.seperator) {
                fn.seperator = result.seperator;
            }
            setCurrentFolder(result.folder);
            setState(result);
            console.log(result);
        }, (error) => {
            setState({ success: false, error });
        });
    }
    function setSortingField(e) {
        e.preventDefault();
        const currentField = sorting.field;
        const newField = e.currentTarget.getAttribute('data-field');
        let direction = "ascending";
        if (currentField === newField) {
            direction = sorting.direction == "ascending" ? "descenting" : "ascending";
        }
        setSorting({ field: newField, previous: currentField, direction: direction });
    }
    function sort(rows, sortedField) {
        if (sortedField === "")
            return;
        rows.sort((val1, val2) => {
            const a = val1[sortedField];
            const b = val2[sortedField];
            let res = 0;
            if (isNaN(a)) {
                res = a.localeCompare(b, undefined, { sensitivity: 'base' });
            }
            else {
                res = a < b ? -1 : (a > b) ? 1 : 0;
            }
            if (sorting.direction !== "ascending")
                res *= -1;
            return res;
        });
    }
    function getCrumps() {
        let crumps = [];
        if (!data.folder) {
            return React.createElement("span", { className: "clickable", onClick: () => browse(""), key: "fbf_root_default", style: { float: "left" } },
                "  ",
                "[root]",
                "   ");
        }
        const folders = data.folder.split(fn.seperator);
        let path = "";
        for (var k in folders) {
            let folder = folders[k];
            if (folder == "") {
                folder = "[root]";
            }
            else {
                path += fn.seperator + folder;
            }
            const callPath = path;
            const crump = React.createElement("span", { className: "clickable", onClick: () => browse(callPath), key: "fbf_" + path, style: { float: "left" } },
                "  ",
                folder,
                " ");
            const seperator = React.createElement("span", { style: { float: "left", marginLeft: "5px", marginRight: "5px" }, key: "fbs_" + path },
                " ",
                fn.seperator);
            crumps.push(crump);
            crumps.push(seperator);
        }
        return crumps;
    }
    function onItemClick(file) {
        const type = file.t;
        if (type == FileType.FILE) {
            return;
        }
        const folder = currentFolder + fn.seperator + file.name;
        browse(folder);
    }
    var data = {};
    if (state.error) {
        console.log(state.error);
    }
    else {
        data = state;
    }
    console.log("FileBrowser State");
    console.log(data);
    const files = data.files;
    if (files) {
        sort(files, sorting.field);
        sort(files, "t");
    }
    const rows = [];
    let c = 0;
    for (var key in files) {
        const file = files[key];
        const type = file["t"];
        let color = "#ff9090";
        c++;
        let size = "";
        let icon = null;
        let lastModified = file["lm"];
        if (lastModified < 1) {
            lastModified = "";
        }
        else {
            const date = new Date(lastModified);
            lastModified = date.toLocaleDateString('en-GB', { timeZone: 'UTC' }) + " " + date.toLocaleTimeString('en-GB', { timeZone: 'UTC' });
        }
        if (type == FileType.FILE) {
            size = Utils.bytesToUnit(file["size"]);
            color = "#90ff90";
            icon = React.createElement("img", { src: 'images/icons/file.svg', width: "20" });
        }
        else {
            icon = React.createElement("img", { src: 'images/icons/folder.svg', width: "20" });
        }
        const row = React.createElement("tr", { key: "filerow_" + c },
            React.createElement("td", null,
                React.createElement("div", { className: "clickable", file: file, onClick: () => onItemClick(file) },
                    icon,
                    file["name"],
                    " "),
                "  "),
            React.createElement("td", null,
                "  ",
                size,
                "     "),
            React.createElement("td", { style: { color: "#989898" } },
                "  ",
                lastModified,
                "     "));
        rows.push(row);
    }
    const table = React.createElement("table", { className: "browser" },
        React.createElement("thead", null,
            React.createElement("tr", null,
                React.createElement("th", { className: "clickable", onClick: setSortingField, "data-field": "name" }, t("Name")),
                React.createElement("th", { className: "clickable", onClick: setSortingField, "data-field": "size" }, t("Size")),
                React.createElement("th", { className: "clickable", onClick: setSortingField, "data-field": "lm" }, t("Last Modified")))),
        React.createElement("tbody", null, rows));
    const browser = React.createElement("div", null,
        data.drive,
        React.createElement("br", null),
        React.createElement("div", { style: { marginTop: "10px", paddingBottom: "10px" } }, getCrumps()),
        " ",
        React.createElement("br", null),
        table);
    return (React.createElement("div", { id: 'browser' }, browser));
};
const FileBrowserPage = (props) => {
    function back() { Utils.goBack(props.history); }
    function error(message) {
        const div = React.createElement("div", null, message);
        return div;
    }
    ;
    function getPage() {
        const params = props.match.params;
        const unitid = params.id;
        const drive = atob(params.mount);
        if (!unitid) {
            return error("Unit id is not found");
        }
        if (!drive) {
            return error("No drive specified");
        }
        const browser = React.createElement(FileBrowser, { id: unitid, drive: drive, folder: "" });
        return browser;
    }
    const page = getPage();
    return (React.createElement("div", { id: 'page' },
        React.createElement(Header, { back: back, title: t("File Browser") }),
        page));
};
const HostAlertOptions = (props) => {
    const [divPage, setDivPage] = useState(null);
    const hostID = props.hostID;
    const fn = { closed: useRef(false) };
    function cleanUp() {
        fn.closed.current = true;
    }
    useEffect(() => { fn.closed.current = false; init(); return cleanUp; }, [props]);
    function init() {
        console.log(UserSettings.settings);
    }
    ;
    function onCheckBoxClick(e) {
        const checked = e.target.checked;
        const key = e.target.getAttribute("skey");
        UserSettings.set(key, checked);
    }
    return (React.createElement("div", { id: 'panel_host_alert_settings' },
        React.createElement(Checkbox3, { label: "Show IP Addresses", defaultChecked: UserSettings.getBoolean("host_alert_show_ips"), skey: "host_alert_show_ips", onChange: onCheckBoxClick }),
        React.createElement("br", null),
        React.createElement(Checkbox3, { label: "Blink Colors", defaultChecked: UserSettings.getBoolean("host_alert_blink"), skey: "host_alert_blink", onChange: onCheckBoxClick }),
        React.createElement("br", null),
        User.developer && React.createElement("div", null,
            React.createElement(Checkbox3, { label: "Show seconds", defaultChecked: UserSettings.getBoolean("alert_show_active_seconds"), skey: "alert_show_active_seconds", onChange: onCheckBoxClick })),
        User.developer && React.createElement("div", null,
            React.createElement(Checkbox3, { label: "Show ID", defaultChecked: UserSettings.getBoolean("alerts_show_id"), skey: "alerts_show_id", onChange: onCheckBoxClick }))));
};
const codeGroups = {
    sapwp: { name: "ABAP WP", description: "ABAP Workprocess alerts" },
    sapjob: { name: "SAP-Job", description: "SAP Job related alerts" }
};
const HostAlerts = (props) => {
    const fn = { closed: useRef(false) };
    const [summary, setSummary] = useState({
        data: { alerts: 0, removed: 0, ignored: 0 },
        counts: [0, 0, 0, 0, 0]
    });
    const [divPage, setDivPage] = useState(null);
    const timeOutID = "halerts";
    const timeOutIDReset = "halertsrest";
    const [filtered, setFiltered] = useState(false);
    const [tt, setTT] = useState({ show: false, id: 0, x: 0, y: 0, render: 0, alert: { id: -1 } });
    const [rr, refresh] = useState(0);
    function cleanUp() {
        fn.closed.current = true;
        Timeouts.clearAll(timeOutID);
    }
    useEffect(() => { fn.closed.current = false; init(); return cleanUp; }, [props]);
    function init() {
        Alerts = {};
        Timeouts.clearAll(timeOutID);
        Timeouts.clearAll(timeOutIDReset);
        const urlParameters = new URLSearchParams(props.location.search);
        const f = urlParameters.size > 0;
        setFiltered(f);
        if (f) {
            Timeouts.add(timeOutIDReset, setTimeout(clearFilter, 20000));
        }
        load();
    }
    function clearFilter() {
        Timeouts.clearAll(timeOutIDReset);
        if (fn.closed.current)
            return;
        Utils.go(props.history, "/alerts");
    }
    function load() {
        Timeouts.clearAll(timeOutID);
        if (fn.closed.current)
            return;
        const active = UserSettings.getBoolean("host_alert_show_old_alerts") ? 0 : 1;
        let pdo = Utils.postDataOptions({ op: "hostalerts", active: active });
        fetch(apiURL + "alerts", pdo).then(res => res.json()).then((result) => {
            if (result.success) {
                summary.data.alerts = result.summary.alerts;
                summary.data.removed = result.summary.removed;
                summary.data.ignored = result.summary.ignored;
                summary.counts = result.counts;
            }
            Utils.setState(fn, setDivPage, parse(result));
        }, (error) => {
            Utils.setState(fn, setDivPage, parse({ success: false, error: error.message }));
        }).then(() => {
            if (fn.closed.current)
                return;
            Timeouts.add(timeOutID, setTimeout(load, 5000));
        });
    }
    function mouseOver(e) {
        e.stopPropagation();
        tt.x = e.clientX + 5;
        tt.y = e.clientY + 5;
        tt.render = Utils.timeStamp();
        tt.show = true;
        tt.id = e.target.getAttribute("aid");
        if (Alerts[tt.id]) {
            tt.alert = Alerts[tt.id];
            refresh(tt.render);
        }
        else {
            loadAlert(tt.id);
        }
    }
    ;
    function mouseOut(e) {
        e.stopPropagation();
        if (!tt.show)
            return;
        tt.show = false;
        tt.render = Utils.timeStamp();
        refresh(tt.render);
    }
    function loadAlert(id) {
        Request.send({
            url: apiURL + "alerts",
            params: { op: "get", id: id },
            success: (json) => {
                Alerts[tt.id] = json;
                tt.alert = json;
                refresh(Utils.timeStamp());
            }
        });
    }
    function alertImage(alert) {
        let src = "/images/icons/png/circle_white.png";
        switch (alert.type) {
            case 1:
                src = "/images/icons/png/circle_gray.png";
                break;
            case 2:
                src = "/images/icons/png/circle_yellow.png";
                break;
            case 3:
                src = "/images/icons/png/circle_orange.png";
                break;
            case 4:
                src = "/images/icons/png/circle_red.png";
                break;
        }
        return React.createElement("img", { key: alert.key + "_" + alert.id, src: src, width: "14", aid: alert.id, onMouseOver: mouseOver, onMouseLeave: mouseOut });
    }
    function parse(json) {
        if (!json.success) {
            return Utils.error(json.error);
        }
        const columns = {};
        const groups = json.groups;
        for (let i = 0; i < groups.length; i++) {
            const group = groups[i];
            group.columns = {};
            group.maxAlertType = 0;
            const alerts = group.alerts;
            for (let j = 0; j < alerts.length; j++) {
                const alert = alerts[j];
                const cg = alert.gc;
                if (!group.columns[cg])
                    group.columns[cg] = [];
                group.columns[cg].push({ type: alert.tp, code: alert.cd, id: alert.id });
                columns[cg] = true;
                if (alert.tp > group.maxAlertType)
                    group.maxAlertType = alert.tp;
            }
        }
        const ths = [];
        ths.push(React.createElement("th", { key: "hath_nm", style: { background: "none", border: "none" } }, "Source"));
        for (let key in columns) {
            let name = key;
            let title = "";
            const cg = codeGroups[key];
            if (cg) {
                name = cg.name;
                title = cg.description;
            }
            else {
                name = key.charAt(0).toUpperCase() + key.slice(1);
            }
            ths.push(React.createElement("th", { key: "hath_" + key, title: title },
                " ",
                React.createElement("div", { style: { width: "80px", textAlign: "center" } },
                    " ",
                    name,
                    " "),
                " "));
        }
        const blink = UserSettings.getBoolean("host_alert_blink");
        const rows = [];
        const showIP = UserSettings.getBoolean("host_alert_show_ips");
        groups.sort((a, b) => {
            return b.maxAlertType - a.maxAlertType;
        });
        for (let i = 0; i < groups.length; i++) {
            const group = groups[i];
            const tds = [];
            let maxType = 0;
            for (let code in columns) {
                const alerts = group.columns[code];
                let circles = [];
                if (alerts) {
                    for (let a = 0; a < alerts.length; a++) {
                        const alert = alerts[a];
                        alert.key = group.key;
                        if (alert.type > maxType)
                            maxType = alert.type;
                        circles.push(alertImage(alert));
                    }
                }
                const td = React.createElement("td", { key: "hatd_" + group.key + "_" + code, align: "middle" }, circles);
                tds.push(td);
            }
            const cls = blink ? "blink" : "";
            let name = group.nm;
            if (showIP && group.ip)
                name += " (" + group.ip + ")";
            let sourceLink = "/hostdashboard/" + group.hid + "/0";
            if (group.it == 1) {
                sourceLink = "/system/" + group.sid;
                const system = Data.systems[group.sid];
                if (system)
                    name += " (" + system.nm + ")";
            }
            const htd = React.createElement("td", { className: cls, key: "hatd_" + group.key + "_nm", style: { color: "#333", fontWeight: "bold", padding: "0" } },
                React.createElement("div", { onClick: () => Utils.go(props.history, sourceLink), style: {
                        background: Utils.alertColor(maxType),
                        padding: "4px",
                        paddingRight: "10px",
                        paddingLeft: "10px",
                        borderRadius: "2px",
                        marginTop: "2px",
                        marginBottom: "2px",
                        cursor: "pointer"
                    } }, name));
            tds.unshift(htd);
            const row = React.createElement("tr", { key: "alg_" + group.key, style: { borderBottom: "1px solid #333" } }, tds);
            rows.push(row);
        }
        const div = React.createElement("div", { className: "panel", style: { textAlign: "center" } },
            React.createElement("div", { style: { display: "inline-block" } }, rows.length > 0 &&
                React.createElement("table", { className: "", style: { whiteSpace: "nowrap" } },
                    React.createElement("thead", null,
                        React.createElement("tr", null, ths)),
                    React.createElement("tbody", null, rows))));
        return div;
    }
    function back(e) {
        e.preventDefault();
        cleanUp();
        Utils.goBack(props.history, "/#");
    }
    function update() {
        Timeouts.clearAll(timeOutID);
        Timeouts.add(timeOutID, setTimeout(load, 100));
    }
    ;
    function settings() {
        const content = React.createElement(HostAlertOptions, null);
        const data = { title: "View Settings : Alert Page", content: content, render: true, width: 300, height: 200, closed: update };
        Dialog.show(data);
    }
    const urlParameters = new URLSearchParams(props.location.search);
    const params = { update: "" };
    if (urlParameters) {
        if (urlParameters.get("gid")) {
            params["gid"] = urlParameters.get("gid");
        }
        if (urlParameters.get("sid")) {
            params["sid"] = urlParameters.get("sid");
        }
        if (urlParameters.get("hid")) {
            params["hid"] = urlParameters.get("hid");
        }
        if (urlParameters.get("inid")) {
            params["inid"] = urlParameters.get("inid");
        }
        if (urlParameters.get("dbid")) {
            params["dbid"] = urlParameters.get("dbid");
        }
        params.update += params["gid"] || "";
        params.update += params["sid"] || "";
        params.update += params["hid"] || "";
        params.update += params["inid"] || "";
        params.update += params["dbid"] || "";
    }
    params.hideinfo = UserSettings.getBoolean("alerts_hide_info");
    params.update += params.hideinfo;
    const sum = summary.data;
    const types = [];
    for (let i = 0; i < summary.counts.length; i++) {
        const count = summary.counts[i];
        if (count < 1)
            continue;
        const box = React.createElement("div", { key: "atc_" + i, style: {
                width: "30px",
                height: "24px",
                paddingTop: "2px",
                float: "right",
                marginRight: "5px",
                color: "black",
                fontSize: "18px",
                textAlign: "center",
                display: "inline-block",
                borderRadius: "2px",
                backgroundColor: Utils.alertColor(i)
            } }, count);
        types.push(box);
    }
    return (React.createElement("div", { id: 'page' },
        React.createElement(Header, { back: back, title: t("Alerts") },
            React.createElement(IconButton, { type: "viewsettings", title: t("View Settings"), onClick: settings, style: { float: "right", marginLeft: "10px" } }),
            React.createElement("div", { style: { float: "right" } }, types)),
        Data.maintenance &&
            React.createElement("div", { style: { position: "relative" } },
                React.createElement("img", { className: "blink svg_yellow", src: "images/icons/maintenance.svg", width: "28", title: t("Maintenance mode") }),
                React.createElement("span", { style: { color: Colors.yellow, position: "absolute", top: "6px", marginLeft: "5px" } }, "SysRanger is in maintenance mode. No alert will be generated until maintenance mode is deactivated.")),
        License.remaining < 20 &&
            React.createElement("div", { style: { position: "relative" } },
                React.createElement("img", { className: "blink svg_yellow", src: "images/icons/alert1.svg", width: "28", title: t("License warning") }),
                React.createElement("span", { style: { color: Colors.yellow, position: "absolute", top: "6px", marginLeft: "5px" } },
                    "SysRanger ",
                    License.demo ? "demo " : "",
                    "license will expire in ",
                    License.remaining,
                    " days.")),
        divPage,
        tt.show && tt.alert.id == tt.id &&
            React.createElement("div", { style: {
                    background: "#303030",
                    color: Utils.alertColor(tt.alert.type),
                    border: "1px solid #555",
                    position: "fixed",
                    left: tt.x,
                    top: tt.y,
                    minHeight: "20px",
                    minWidth: "40px"
                } },
                React.createElement("div", { style: { padding: "10px" } },
                    tt.alert.message,
                    React.createElement("br", null),
                    tt.alert.details,
                    tt.alert.info && React.createElement("div", null, tt.alert.info))),
        React.createElement("div", { className: "panel" },
            React.createElement(Tabs, { default: "alerts", id: "alert_tabs", key: 'alert_tabs' },
                React.createElement(Tab, { key: 'alerts', name: 'alerts', label: t("Alerts") + (sum.alerts > 0 ? " (" + sum.alerts + ")" : "") },
                    React.createElement(AlertsPanel, { key: "alerts_alerts", params: params, type: "alerts", listener: update, filtered: filtered })),
                React.createElement(Tab, { key: 'ignoreds', name: 'ignoreds', label: t("Ignored") + (sum.ignored > 0 ? " (" + sum.ignored + ")" : "") },
                    React.createElement(AlertsPanel, { key: "alerts_ignoreds", type: "ignoreds", listener: update, filtered: filtered })),
                React.createElement(Tab, { key: 'removeds', name: 'removeds', label: t("History") + (sum.removed > 0 ? " (" + sum.removed + ")" : "") },
                    React.createElement(AlertsPanel, { key: "alerts_removeds", type: "removeds", listener: update, filtered: filtered }))))));
};
const HostApplications = (props) => {
    const [divPage, setDivPage] = useState(null);
    const hostID = props.hostID;
    const fn = { closed: useRef(false) };
    let refreshTimeout = 0;
    function cleanUp() {
        fn.closed.current = true;
        clearTimeout(refreshTimeout);
        console.log("HospApplications.cleanUp");
    }
    console.log("HostApplications");
    useEffect(() => { fn.closed.current = false; loadData(); return cleanUp; }, [hostID]);
    function loadData() {
        console.log("HostApplications.loadData");
        if (fn.closed.current)
            return;
        let pdo = Utils.postDataOptions({ id: hostID });
        fetch(apiURL + "hostapplications", pdo).then(res => res.json()).then((result) => {
            Utils.setState(fn, setDivPage, parse(result));
        }, (error) => {
            Utils.setState(fn, setDivPage, Utils.error(error.message));
        });
    }
    ;
    function parse(json) {
        if (!json.success) {
            return Utils.error(json.error);
        }
        const apps = json.apps;
        apps.sort();
        const items = [];
        for (var i = 0; i < apps.length; i++) {
            const app = apps[i];
            const div = React.createElement("div", { key: "app_" + i, style: { padding: "5px" } },
                app,
                " ");
            items.push(div);
        }
        return React.createElement("div", { style: { textAlign: "left" } }, items);
    }
    return (React.createElement("div", { id: 'panel_host_applications' }, divPage));
};
const HostConnections = (props) => {
    const [divDetails, setDivDetails] = useState(null);
    const [refreshing, setRefreshing] = useState(true);
    let refreshTimeout = 0;
    const hostID = props.hostID;
    const fn = { closed: useRef(false) };
    function cleanUp() {
        fn.closed.current = true;
        clearTimeout(refreshTimeout);
    }
    useEffect(() => { fn.closed.current = false; loadData(); return cleanUp; }, [hostID]);
    function loadData() {
        if (fn.closed.current)
            return;
        Utils.setState(fn, setRefreshing, true);
        let pdo = Utils.postDataOptions({ op: "connections", hostid: hostID });
        fetch(apiURL + "hosts", pdo).then(res => res.json()).then((result) => {
            Utils.setState(fn, setDivDetails, parse(result));
        }, (error) => {
            Utils.setState(fn, setDivDetails, Utils.error(error.message));
        }).then(() => {
            if (fn.closed.current)
                return;
            setTimeout(() => Utils.setState(fn, setRefreshing, false), 1000);
            refreshTimeout = setTimeout(loadData, 10000);
        });
    }
    ;
    function onPIDClick(row, data) {
        if (fn.closed.current)
            return;
        const div = React.createElement(ProcessDetails, { hostID: hostID, processID: row.pid });
        Dialog.show({ content: div, render: true, title: t("Process Details") });
    }
    function parse(json) {
        if (!json.success) {
            return Utils.error(json.error);
        }
        const connections = json["connections"];
        const data = {
            defaultSortField: "lp",
            direction: "ascending",
            id: "table_hostconnections",
            headers: [
                { name: "Local Port", field: "lp", width: "70px", filter: {} },
                { name: "Remote Port", field: "fp", width: "70px", filter: {} },
                { name: "State", field: "st", width: "120px", filter: {} },
                { name: "PID", field: "pid", width: "70px", filter: {}, onClick: onPIDClick },
                { name: "Process", field: "pn", filter: {} },
                { name: "Remote Address", field: "fa", filter: {} },
                { name: "Type", width: "50px", field: "t", filter: {} }
            ],
            rows: connections
        };
        return React.createElement(Table, { data: data });
    }
    return (React.createElement("div", { id: 'panel_host_connections' },
        React.createElement("div", { className: "update_animation_box" }, refreshing && Utils.updating()),
        divDetails));
};
const HostCores = (props) => {
    const unitID = props.hostid;
    const fn = { closed: useRef(false) };
    const timeoutID = "hostcores";
    const [content, setContent] = useState(null);
    function cleanUp() {
        fn.closed.current = true;
        Timeouts.clearAll(timeoutID);
    }
    useEffect(() => {
        fn.closed.current = false;
        loadData();
        return cleanUp;
    }, [unitID]);
    function loadData() {
        Timeouts.clearAll(timeoutID);
        if (fn.closed.current)
            return;
        Request.send({
            caller: fn,
            url: apiURL + "unit",
            params: { op: "cores", id: unitID },
            listener: (json) => Utils.setState(fn, setContent, parse(json)),
            then: () => Timeouts.add(timeoutID, setTimeout(loadData, 5000))
        });
    }
    function parse(json) {
        if (!json.success) {
            return Utils.error(json.error);
        }
        const divs = [];
        for (let i = 0; i < json.cores.length; i++) {
            const core = json.cores[i];
            const color = core > 60 ? "#ff0000" : "#0977ab";
            const cb = "#111";
            const gradient = `linear-gradient(to top, ${color} 0%,   ${color} ${core}%, ${cb} ${core}%, ${cb} 100%   )`;
            const title = core + " (" + (i + 1) + ")";
            const div = React.createElement("div", { key: "c_" + i, style: {
                    margin: "0 5px 5px 0",
                    float: "left",
                    width: "50px",
                    height: "50px",
                    color: "#bbb",
                    borderRadius: "2px"
                }, title: title },
                core,
                "%");
            divs.push(div);
        }
        return React.createElement("div", { style: { display: "inline-block", margin: "auto" } }, divs);
    }
    return (React.createElement("div", { id: 'panel_host_cores' }, content));
};
const HostDashboard = (props) => {
    const unitID = props.match.params.id;
    const SID = props.match.params.sid;
    const [host, setHost] = useState({ loaded: false, error: "", id: unitID, machine: 1 });
    const fn = { closed: useRef(false) };
    const timeoutID = "hostdashboard_";
    function cleanUp() {
        fn.closed.current = true;
        Timeouts.clearAll(timeoutID);
    }
    function back(e) { e.preventDefault(); cleanUp(); Utils.goBack(props.history); }
    useEffect(() => {
        fn.closed.current = false;
        loadData();
        return cleanUp;
    }, [unitID]);
    function loadData() {
        Timeouts.clearAll(timeoutID);
        if (fn.closed.current)
            return;
        let pdo = Utils.postDataOptions({ op: "dashboard", id: unitID });
        fetch(apiURL + "unit", pdo).then(res => res.json()).then((result) => {
            result.loaded = true;
            if (result.success) {
                Utils.setState(fn, setHost, result);
            }
            else {
                Utils.setState(fn, setHost, { loaded: true, error: result.error });
            }
        }, (error) => {
            Utils.setState(fn, setHost, { loaded: true, error: error.message });
        }).then(() => {
            if (fn.closed.current)
                return;
            Timeouts.add(timeoutID, setTimeout(loadData, 5000));
        });
    }
    function getPage() {
        if (!host.loaded)
            return null;
        if (host.error) {
            return Utils.error(host.error);
        }
        const page = React.createElement("div", { className: "panelcontainer" },
            React.createElement("div", { className: "panel  flexmargin", style: { width: "180px", marginRight: "10px" } },
                React.createElement("div", { className: "panel_title" }, "Uptime"),
                React.createElement("div", { className: "valuebox", style: { background: Colors.yellow, color: "#666" } }, Utils.timePastMinutesMS(host.uptime)),
                React.createElement("div", { className: "panel_title", style: { paddingTop: "10px" } }, "Processes"),
                React.createElement("div", { className: "valuebox", style: { background: "#0977ab" } }, host.processcount)),
            React.createElement("div", { className: "panel flexmargin", style: { width: "150px", height: "124px" } },
                React.createElement("div", { className: "panel_title" }, "CPU"),
                React.createElement(Gauge2, { data: { size: 150,
                        value: host["cpu.percentage"],
                        text: Utils.toInt(host["cpu.percentage"]) + " %",
                        limits: { warning: host["cpu.warning"],
                            critical: host["cpu.critical"],
                            fatal: host["cpu.fatal"],
                            total: 100
                        }
                    } })),
            React.createElement("div", { className: "panel flexmargin", style: { width: "150px", height: "124px" } },
                React.createElement("div", { className: "panel_title" }, "Memory"),
                React.createElement(Gauge2, { data: { size: 150,
                        value: host["memory.percentage"],
                        text: Utils.toInt(host["memory.percentage"]) + " %",
                        limits: { warning: host["memory.warning"],
                            critical: host["memory.critical"],
                            fatal: host["memory.fatal"],
                            total: 100
                        }
                    } })),
            React.createElement("div", { className: "panel flexmargin", style: { width: "150px", height: "124px" } },
                React.createElement("div", { className: "panel_title" }, "Swap"),
                React.createElement(Gauge2, { data: { size: 150,
                        value: host["swap.percentage"],
                        text: Utils.toInt(host["swap.percentage"]) + " %",
                        limits: { warning: host["swap.warning"],
                            critical: host["swap.critical"],
                            fatal: host["swap.fatal"],
                            total: 100
                        }
                    } })),
            React.createElement("div", { className: "panel flexmargin", style: { height: "124px", width: "405px" } },
                React.createElement("div", { className: "panel_title" }, "Alerts"),
                React.createElement("div", { style: { fontWeight: "bold", color: "#555" } },
                    React.createElement("div", { className: "valuebox", style: { paddingTop: "10px", float: "left", fontSize: "60px", marginRight: "5px", width: "90px", height: "90px",
                            background: host["alerts.fatal"] > 0 ? Colors.red : "none" } }, host["alerts.fatal"] || ""),
                    React.createElement("div", { className: "valuebox", style: { paddingTop: "10px", float: "left", fontSize: "60px", marginRight: "5px", width: "100px", height: "90px",
                            background: host["alerts.critical"] > 0 ? Colors.orange : "none" } }, host["alerts.critical"] || ""),
                    React.createElement("div", { className: "valuebox", style: { paddingTop: "10px", float: "left", fontSize: "60px", marginRight: "5px", width: "100px", height: "90px",
                            background: host["alerts.warning"] > 0 ? Colors.yellow : "none",
                            color: host["alerts.warning"] > 0 ? "#888" : "!important"
                        } }, host["alerts.warning"] || ""),
                    React.createElement("div", { className: "valuebox", style: { paddingTop: "10px", float: "left", fontSize: "60px", width: "100px", height: "90px",
                            background: host["alerts.info"] > 0 ? Colors.gray : "none" } }, host["alerts.info"] || ""))),
            React.createElement("div", { className: "clear" }),
            React.createElement("div", { className: "panel flexmargin", style: { width: "362px", height: "205px", textAlign: "left" } },
                React.createElement("div", { className: "panel_title" }, "CPU Load"),
                React.createElement(CPUShortHistoryGraph, { key: "shgcpu_" + host.id, hostID: unitID, width: "362", height: "180", averages: true })),
            React.createElement("div", { className: "panel flexmargin", style: { width: "330px", height: "205px", textAlign: "left" } },
                React.createElement("div", { className: "panel_title" }, "Memory Load"),
                React.createElement(MemoryShortHistoryGraph, { key: "shgmem_" + host.id, hostID: unitID, width: "331", height: "180" })),
            React.createElement("div", { className: "panel flexmargin", style: { width: "405px", height: "205px", textAlign: "left" } },
                React.createElement("div", { className: "panel_title" }, "Memory Utilization"),
                React.createElement(Pie, { key: "memu_" + host.id, data: {
                        lineWidth: 60,
                        size: 180,
                        showInfo: true,
                        items: [
                            { value: host["memory.available"], color: Colors.green, text: "Physical Free" },
                            { value: host["memory.used"], color: Colors.red, text: "Physical Used" },
                            { value: host["swap.available"], color: Colors.yellow, text: "Swap Free" },
                            { value: host["swap.used"], color: Colors.orange, text: "Swap Used" }
                        ]
                    } })),
            React.createElement("div", { className: "clear" }),
            React.createElement("div", { className: "panel flexmargin", style: { width: "362px", height: "205px", textAlign: "left" } },
                React.createElement("div", { className: "panel_title" }, "Disks"),
                stores(host.stores, 360)),
            React.createElement("div", { className: "panel flexmargin", style: { width: "766px", textAlign: "left", height: "205px" } },
                React.createElement("div", { className: "panel_title" }, "Ping History"),
                React.createElement(AvailabilityHistory, { key: "ag_" + host.id + "_ping", width: "766", id: unitID, type: AvailabilityType.HOST_PING })),
            React.createElement("div", { className: "clear" }),
            React.createElement("div", { className: "panel flexmargin", style: { width: "1158px", textAlign: "center" } },
                React.createElement("div", { className: "panel_title" }, "CPU Cores"),
                React.createElement(HostCores, { hostid: unitID })));
        return page;
    }
    function stores(stores, w) {
        const divs = [];
        for (let i = 0; i < stores.length; i++) {
            const store = stores[i];
            const percentage = Utils.toInt((store.used / store.size) * 100);
            const title = store.name + "\nDescription:\t" + store.desc +
                (store.fs ? "\nSystem:\t" + store.fs : "") +
                (store.label ? "\nLabel:\t" + store.label : "") +
                (store.mp ? "\nMount:\t" + store.mp : "" +
                    "\nUsed:" + store.used +
                    "\nTotal:" + store.total);
            const name = store.mp;
            const div = React.createElement("div", { key: "pb_bar1_store_container_" + i },
                React.createElement("div", { style: { marginBottom: "2px" } },
                    " ",
                    name),
                React.createElement(Bar1, { key: "bar1_store_" + i, data: {
                        width: w,
                        value: percentage,
                        text: percentage + " %",
                        title: title,
                        limits: {
                            warning: host["disk.warning"],
                            critical: host["disk.critical"],
                            fatal: host["disk.fatal"]
                        }
                    } }));
            divs.push(div);
        }
        return divs;
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { id: 'page' },
            React.createElement(Header, { back: back, title: t("Host Dashboard") + "[" + host["name"] + "-" + host["alias"] + "]" }),
            getPage())));
};
const HostDisks = (props) => {
    const [divDetails, setDivDetails] = useState(null);
    const [refreshing, setRefreshing] = useState(true);
    const fn = { closed: useRef(false) };
    let refreshTimeout = 0;
    const hostID = props.hostID;
    function cleanUp() {
        fn.closed.current = true;
        clearTimeout(refreshTimeout);
    }
    useEffect(() => { fn.closed.current = false; loadData(); return cleanUp; }, [hostID]);
    function loadData() {
        if (fn.closed.current)
            return;
        Utils.setState(fn, setRefreshing, true);
        let pdo = Utils.postDataOptions({ id: hostID });
        fetch(apiURL + "unitdisks", pdo).then(res => res.json()).then((result) => {
            Utils.setState(fn, setDivDetails, parse(result));
        }, (error) => {
            Utils.setState(fn, setDivDetails, Utils.error(error.message));
        }).then(() => {
            if (fn.closed.current)
                return;
            setTimeout(() => Utils.setState(fn, setRefreshing, false), 1000);
            refreshTimeout = setTimeout(loadData, 10000);
        });
    }
    ;
    function parse(data) {
        const stores = data["stores"];
        if (stores.length < 1 && data.disks.length < 1) {
            return "No disk information";
        }
        Utils.sort(stores, "name");
        const divs = [];
        for (let i = 0; i < stores.length; i++) {
            const store = stores[i];
            const name = store.name;
            const description = store["desc"] || "";
            if (description == "CD-ROM") {
                continue;
            }
            const total = store["size"];
            const UUID = store["UUID"];
            const used = store["used"];
            const totalStr = Utils.bytesToUnit(total);
            const usedStr = Utils.bytesToUnit(used);
            const mountPoint = store["mp"] || "";
            const fileSystem = store["fs"] || "";
            const path = description == "Network drive" ? store["v"] : "";
            const label = store["label"];
            const title = name + "\nDescription:\t" + description +
                (fileSystem ? "\nSystem:\t" + fileSystem : "") +
                (label ? "\nLabel:\t" + label : "") +
                (path ? "\nPath:\t" + path : "") +
                (mountPoint ? "\nMount:\t" + mountPoint : "");
            const percentage = Math.round(((used) / total) * 100);
            const color = Utils.thresholdColor(percentage, data.info, data.warning, data.critical, data.fatal);
            const pieData = {
                size: 120,
                lineWidth: 20,
                vertical: true,
                items: [
                    { value: used, color: color },
                    { value: total - used, color: "#444" },
                ], percentage: percentage + " % "
            };
            const writableWarning = store["w"] ? null : React.createElement("div", { style: { position: "absolute", top: "5px", right: "3px" } },
                React.createElement("img", { src: Data.iconDir + "/png/alert_red.png", width: "16", title: "Disk is not writable" }));
            const mp = btoa(mountPoint);
            const div = React.createElement("div", { key: "disk_" + i, className: "panel flexmargin", title: title, style: { width: "180px", height: "200px", textAlign: "center" } },
                React.createElement("div", { style: { width: "120px", display: "inline-block" } }, store["probe"] ?
                    React.createElement("a", { href: "#unit-file-browser/" + hostID + "/" + mp },
                        React.createElement(Pie, { data: pieData, key: "pie_" + name }))
                    :
                        React.createElement(Pie, { data: pieData, key: "pie_" + name })),
                React.createElement("div", { className: "clear space10" }),
                usedStr,
                "  / ",
                totalStr,
                "     ",
                React.createElement("br", null),
                store["name"],
                " ",
                label && React.createElement("div", null, label),
                writableWarning);
            divs.push(div);
        }
        const tableDisks = {
            defaultSortField: "nm",
            direction: "ascending",
            id: "hostdisks_" + hostID,
            headers: [
                { name: "Name", field: "nm" },
                { name: "Model", field: "md" },
                { name: "Size", field: "sz", format: Utils.bytesToUnit, right: true, width: 100 },
                { name: "Reads", field: "rd", right: true, format: Utils.number, width: 100 },
                { name: "Writes", field: "wr", right: true, format: Utils.number, width: 100 },
                { name: "Read Bytes", field: "rb", format: Utils.bytesToUnit, right: true, width: 100 },
                { name: "Write Bytes", field: "wb", format: Utils.bytesToUnit, right: true, width: 100 },
                { name: "Serial", field: "sr" },
            ],
            rows: data.disks
        };
        const panel = React.createElement("div", null,
            React.createElement("div", { key: "host_stores", style: { textAlign: "center", color: "#929292" } }, divs),
            React.createElement("div", { key: "host_disks_clear", className: "clear", style: { height: "30px" } }),
            React.createElement("div", { key: "host_disks" },
                React.createElement(Table, { data: tableDisks })));
        return panel;
    }
    return (React.createElement("div", { id: 'panel_host_disks' },
        React.createElement("div", { className: "update_animation_box" }, refreshing && Utils.updating()),
        divDetails));
};
const HostEventsPanel = (props) => {
    const fn = { closed: useRef(false) };
    const [divDetails, setDivDetails] = useState(null);
    const [refreshing, setRefreshing] = useState(true);
    const type = props.type;
    const hostID = props.hostID;
    const id = hostID + "_" + type;
    const timeoutID = "hostevents_" + id;
    function cleanUp() {
        console.log("HostEvents.Cleanup:" + type);
        fn.closed.current = true;
        Timeouts.clearAll(timeoutID);
    }
    useEffect(() => { fn.closed.current = false; loadData(); return cleanUp; }, [id]);
    function loadData() {
        if (fn.closed.current)
            return;
        Timeouts.clearAll(timeoutID);
        Utils.setState(fn, setRefreshing, true);
        let pdo = Utils.postDataOptions({ id: hostID, op: type, length: 100, start: 0 });
        fetch(apiURL + "eventviewer", pdo).then(res => res.json()).then((result) => {
            Utils.setState(fn, setDivDetails, parse(result));
        }, (error) => {
            Utils.setState(fn, setDivDetails, Utils.error(error.message));
        }).then(() => {
            if (fn.closed.current)
                return;
            Timeouts.add(timeoutID, setTimeout(loadData, 10000));
            setTimeout(() => Utils.setState(fn, setRefreshing, false), 1000);
        });
    }
    ;
    function parse(json) {
        if (!json.success) {
            return Utils.error(json.error);
        }
        const info = {
            defaultSortField: "id",
            id: "evt_" + id,
            direction: "descending",
            headers: [
                { name: "Type", field: "type", format: Utils.windowsEventType },
                { name: "Time", field: "time", format: Utils.toDateMS },
                { name: "Record", field: "id" },
                { name: "Event", field: "eventID" },
                { name: "Source", field: "source" },
                { name: "Messae", field: "m" },
            ],
            field: "id",
            items: json.records,
            rows: json.records,
            total: json.total,
            start: json.start,
            finish: json.end,
            json: json
        };
        return React.createElement(Table, { data: info });
    }
    return (React.createElement("div", { id: "panel_host_events_" + id },
        React.createElement("div", { className: "update_animation_box" }, refreshing && Utils.updating()),
        divDetails));
};
const HostEvents = (props) => {
    const hostID = props.hostID;
    return (React.createElement("div", { id: 'panel_host_events' },
        React.createElement(Tabs, { default: null, id: "tabs_host_events", key: 'tabs_host_events_' + hostID },
            React.createElement(Tab, { key: 'application', name: 'application', label: 'Application' },
                "   ",
                React.createElement(HostEventsPanel, { hostID: hostID, type: "Application" }),
                "     "),
            React.createElement(Tab, { key: 'system', name: 'system', label: 'System' },
                "   ",
                React.createElement(HostEventsPanel, { hostID: hostID, type: "System" }),
                "     "),
            React.createElement(Tab, { key: 'security', name: 'security', label: 'Security' },
                "   ",
                React.createElement(HostEventsPanel, { hostID: hostID, type: "Security" }),
                "     "))));
};
const HostHardwareInformation = (props) => {
    const [divDetails, setDivDetails] = useState(null);
    const [refreshing, setRefreshing] = useState(true);
    const fn = { closed: useRef(false) };
    let refreshTimeout = 0;
    const hostID = props.hostID;
    function cleanUp() {
        fn.closed.current = true;
        clearTimeout(refreshTimeout);
    }
    useEffect(() => { fn.closed.current = false; loadData(); return cleanUp; }, [hostID]);
    function loadData() {
        if (fn.closed.current)
            return;
        Utils.setState(fn, setRefreshing, true);
        let pdo = Utils.postDataOptions({ id: hostID });
        fetch(apiURL + "unithardwareinfo", pdo).then(res => res.json()).then((result) => {
            Utils.setState(fn, setDivDetails, parse(result));
        }, (error) => {
            Utils.setState(fn, setDivDetails, Utils.error(error.message));
        }).then(() => {
            if (fn.closed.current)
                return;
            setTimeout(() => Utils.setState(fn, setRefreshing, false), 1000);
            refreshTimeout = setTimeout(loadData, 10000);
        });
    }
    ;
    function parse(hi) {
        const div = React.createElement("div", null,
            React.createElement("table", { className: "informationtable" },
                React.createElement("tbody", null,
                    React.createElement("tr", null,
                        React.createElement("td", null, "   Operating System:"),
                        React.createElement("td", null,
                            hi["os.all"],
                            "  ")),
                    React.createElement("tr", null,
                        React.createElement("td", null, "   memory.available:"),
                        React.createElement("td", null,
                            hi["memory.available"],
                            "  ")),
                    React.createElement("tr", null,
                        React.createElement("td", null, "   memory.total:"),
                        React.createElement("td", null,
                            hi["memory.total"],
                            "  ")),
                    React.createElement("tr", null,
                        React.createElement("td", null, "   swap.pages.in:"),
                        React.createElement("td", null,
                            hi["swap.pages.in"],
                            "  ")),
                    React.createElement("tr", null,
                        React.createElement("td", null, "   swap.total:"),
                        React.createElement("td", null,
                            hi["swap.total"],
                            "  ")),
                    React.createElement("tr", null,
                        React.createElement("td", null, "   swap.used:"),
                        React.createElement("td", null,
                            hi["swap.used"],
                            "  ")),
                    React.createElement("tr", null,
                        React.createElement("td", null, "   swap.virtual.max:"),
                        React.createElement("td", null,
                            hi["swap.virtual.max"],
                            "  ")),
                    React.createElement("tr", null,
                        React.createElement("td", null, "   swap.virtual.used:"),
                        React.createElement("td", null,
                            hi["swap.virtual.used"],
                            "  ")),
                    React.createElement("tr", null,
                        React.createElement("td", null, "  cpu.identifier.name:"),
                        React.createElement("td", null,
                            hi["cpu.identifier.name"],
                            "  ")),
                    React.createElement("tr", null,
                        React.createElement("td", null, "   cpu.identifier.all:"),
                        React.createElement("td", null,
                            hi["cpu.identifier.all"],
                            "  ")),
                    React.createElement("tr", null,
                        React.createElement("td", null, "   cpu.identifier.vendor:"),
                        React.createElement("td", null,
                            hi["cpu.identifier.vendor"],
                            "  ")),
                    React.createElement("tr", null,
                        React.createElement("td", null, "   cpu.identifier.vendor.frequency:"),
                        React.createElement("td", null,
                            hi["cpu.identifier.vendor.frequency"],
                            "  ")),
                    React.createElement("tr", null,
                        React.createElement("td", null, "   cpu.load:"),
                        React.createElement("td", null,
                            hi["cpu.load"],
                            "  ")),
                    React.createElement("tr", null,
                        React.createElement("td", null, "   cpu.max.frequency:"),
                        React.createElement("td", null,
                            hi["cpu.max.frequency"],
                            "  ")),
                    React.createElement("tr", null,
                        React.createElement("td", null, "   cpu.physical.package.count:"),
                        React.createElement("td", null,
                            hi["cpu.physical.package.count"],
                            "  ")),
                    React.createElement("tr", null,
                        React.createElement("td", null, "   cpu.physical.processor.count:"),
                        React.createElement("td", null,
                            hi["cpu.physical.processor.count"],
                            "  ")),
                    React.createElement("tr", null,
                        React.createElement("td", null, "   cpu.logical.processor.count:"),
                        React.createElement("td", null,
                            hi["cpu.logical.processor.count"],
                            "  ")),
                    React.createElement("tr", null,
                        React.createElement("td", null, "   cpu.identifier.microarchitecture:"),
                        React.createElement("td", null,
                            hi["cpu.identifier.microarchitecture"],
                            "  ")),
                    React.createElement("tr", null,
                        React.createElement("td", null, "   Firmware Manufacturer"),
                        React.createElement("td", null,
                            hi["firmware.manufacturer"],
                            "  ")),
                    React.createElement("tr", null,
                        React.createElement("td", null, "   Firmware Name"),
                        React.createElement("td", null,
                            hi["firmware.name"],
                            "  ")),
                    React.createElement("tr", null,
                        React.createElement("td", null, "   Firmware Version"),
                        React.createElement("td", null,
                            hi["firmware.version"],
                            "  ")),
                    React.createElement("tr", null,
                        React.createElement("td", null, "   Firmware Description"),
                        React.createElement("td", null,
                            hi["firmware.description"],
                            "  ")),
                    React.createElement("tr", null,
                        React.createElement("td", null, "   Firmware Date"),
                        React.createElement("td", null,
                            hi["firmware.releasedate"],
                            "  ")))));
        return div;
    }
    return (React.createElement("div", { id: 'panel_host_hardware' },
        React.createElement("div", { className: "update_animation_box" }, refreshing && Utils.updating()),
        divDetails));
};
const HostInformation = (props) => {
    const [divDetails, setDivDetails] = useState(null);
    const [refreshing, setRefreshing] = useState(true);
    const fn = { closed: useRef(false) };
    let refreshTimeout = 0;
    const hostID = props.hostID;
    function cleanUp() {
        fn.closed.current = true;
        clearTimeout(refreshTimeout);
    }
    useEffect(() => { fn.closed.current = false; loadData(); return cleanUp; }, [hostID]);
    function loadData() {
        if (fn.closed.current)
            return;
        Utils.setState(fn, setRefreshing, true);
        let pdo = Utils.postDataOptions({ op: "info", id: hostID });
        fetch(apiURL + "hosts", pdo).then(res => res.json()).then((result) => {
            Utils.setState(fn, setDivDetails, parse(result));
        }, (error) => {
            Utils.setState(fn, setDivDetails, Utils.error(error.message));
        }).then(() => {
            if (fn.closed.current)
                return;
            setTimeout(() => Utils.setState(fn, setRefreshing, false), 1000);
            refreshTimeout = setTimeout(loadData, 10000);
        });
    }
    ;
    function parse(data) {
        const div = React.createElement("div", null,
            React.createElement("table", { className: "informationtable" },
                React.createElement("tbody", null,
                    React.createElement("tr", null,
                        React.createElement("td", null, t("Name")),
                        React.createElement("td", null,
                            data["name"],
                            " - ",
                            data["alias"])),
                    React.createElement("tr", null,
                        React.createElement("td", null, t("Healthy")),
                        React.createElement("td", null,
                            Utils.yesno(data["healhty"]),
                            " ")),
                    React.createElement("tr", null,
                        React.createElement("td", null, t("Reachable")),
                        React.createElement("td", null, Utils.yesno(data["reachable"]))),
                    React.createElement("tr", null,
                        React.createElement("td", null, t("Probe is connected")),
                        React.createElement("td", null,
                            Utils.yesno(data["probeConnected"]),
                            " ")),
                    React.createElement("tr", null,
                        React.createElement("td", null, t("Probe version")),
                        React.createElement("td", null,
                            data["probeversion"],
                            " ")),
                    React.createElement("tr", null,
                        React.createElement("td", null, t("Ping")),
                        React.createElement("td", null, data["ping"])),
                    React.createElement("tr", null,
                        React.createElement("td", null, t("Last activity")),
                        React.createElement("td", null, Utils.toDate(data["lastActivity"]))),
                    React.createElement("tr", null,
                        React.createElement("td", null, t("Type")),
                        React.createElement("td", null, Utils.machineType(data["machine"]))),
                    React.createElement("tr", null,
                        React.createElement("td", null, t("Uptime")),
                        React.createElement("td", null, Utils.timePastMinutesMS(data["uptime"]))),
                    React.createElement("tr", null,
                        React.createElement("td", null, t("Boot")),
                        React.createElement("td", null, Utils.toDate(data["boot"]))),
                    React.createElement("tr", null,
                        React.createElement("td", null, t("OS")),
                        React.createElement("td", null,
                            data["os"],
                            "  ",
                            data["osTitle"])),
                    React.createElement("tr", null,
                        React.createElement("td", null, t("CPU")),
                        React.createElement("td", null, Utils.percentage(data["cpu"]))),
                    React.createElement("tr", null,
                        React.createElement("td", null, t("Physical memory")),
                        React.createElement("td", null,
                            Utils.percentage(data["memory"]),
                            "  \u00A0 \u00A0 [ \u00A0",
                            Utils.bytesToUnit(data["memory.used"]),
                            "\u00A0/ \u00A0",
                            Utils.bytesToUnit(data["memory.total"]),
                            "  \u00A0 ]")),
                    React.createElement("tr", null,
                        React.createElement("td", null, t("Swap memory")),
                        React.createElement("td", null,
                            Utils.percentage(data["swap"]),
                            "  \u00A0 \u00A0 [ \u00A0",
                            Utils.bytesToUnit(data["swap.used"]),
                            "\u00A0/ \u00A0",
                            Utils.bytesToUnit(data["swap.total"]),
                            "  \u00A0 ]")),
                    React.createElement("tr", null,
                        React.createElement("td", null, t("OS user")),
                        React.createElement("td", null, data["osUser"])))));
        return div;
    }
    ;
    return (React.createElement("div", { id: 'panel_host_information' },
        React.createElement("div", { className: "update_animation_box" }, refreshing && Utils.updating()),
        divDetails));
};
const HostJavaInformation = (props) => {
    const [divDetails, setDivDetails] = useState(null);
    const [refreshing, setRefreshing] = useState(true);
    const fn = { closed: useRef(false) };
    let refreshTimeout = 0;
    const hostID = props.hostID;
    function cleanUp() {
        fn.closed.current = true;
        clearTimeout(refreshTimeout);
    }
    useEffect(() => { fn.closed.current = false; loadData(); return cleanUp; }, [hostID]);
    function loadData() {
        if (fn.closed.current)
            return;
        Utils.setState(fn, setRefreshing, true);
        let pdo = Utils.postDataOptions({ id: hostID });
        fetch(apiURL + "unitsysteminfo", pdo).then(res => res.json()).then((result) => {
            Utils.setState(fn, setDivDetails, parse(result));
        }, (error) => {
            Utils.setState(fn, setDivDetails, Utils.error(error.message));
        }).then(() => {
            if (fn.closed.current)
                return;
            setTimeout(() => Utils.setState(fn, setRefreshing, false), 1000);
            refreshTimeout = setTimeout(loadData, 10000);
        });
    }
    ;
    function parse(data) {
        const trs = [];
        for (const key in data) {
            const value = data[key];
            const tr = React.createElement("tr", { key: "tr_" + key },
                React.createElement("td", null, key),
                React.createElement("td", null, value));
            trs.push(tr);
        }
        const div = React.createElement("div", null,
            React.createElement("table", { className: "informationtable" },
                React.createElement("tbody", null, trs)));
        return div;
    }
    ;
    return (React.createElement("div", { id: 'panel_host_java_information' },
        React.createElement("div", { className: "update_animation_box" }, refreshing && Utils.updating()),
        divDetails));
};
const HostLoginPage = (props) => {
    const hostID = props.match.params.id;
    function back(e) {
        e.preventDefault();
        Utils.goBack(props.history, "/#host/" + hostID);
    }
    return (React.createElement("div", { id: 'page' },
        React.createElement("h1", null,
            React.createElement("a", { className: "back", onClick: back, title: t("Return Back") }, "  "),
            t("Set Host OS credentials")),
        React.createElement(HostLogin, { hostID: hostID, data: { redirect: true } })));
};
const HostLogin = (props) => {
    const [fields, setFields] = useState({ user: "", password: "" });
    const [errors, setErrors] = useState({});
    const [error, setError] = useState(null);
    const [host, setHost] = useState({});
    const [updating, setUpdating] = useState(false);
    const required = ["user", "password"];
    const hostID = props.hostID;
    const fn = { closed: useRef(false) };
    function cleanUp() {
        fn.closed.current = true;
    }
    useEffect(() => { fn.closed.current = false; loadData(); return cleanUp; }, [hostID]);
    function loadData() {
        if (fn.closed.current)
            return;
        let pdo = Utils.postDataOptions({ op: "get", hostid: hostID });
        fetch(apiURL + "hosts", pdo).then(res => res.json()).then((result) => {
            if (result.success) {
                Utils.setState(fn, setHost, result);
                setFields(Object.assign(Object.assign({}, fields), { user: result.osuser }));
            }
        }, (error) => {
            console.log("HostLogin.error", error.message);
            Utils.setState(fn, setUpdating, false);
        }).then(() => {
            Utils.setState(fn, setUpdating, false);
        });
    }
    ;
    function handleValidation() {
        const errors = {};
        let formIsValid = true;
        for (let i = 0; i < required.length; i++) {
            const field = required[i];
            if (!fields[field] || fields[field].length < 1) {
                formIsValid = false;
                errors[field] = "Required field";
            }
        }
        setErrors(errors);
        return formIsValid;
    }
    function handleChange(e) {
        const field = e.currentTarget.getAttribute('field');
        const value = e.target.type === "checkbox" ? e.target.checked : e.target.value;
        setFields(Object.assign(Object.assign({}, fields), { [field]: value }));
    }
    function reload() {
        if (props.data && props.data.redirect) {
            Utils.go(props.history, "#unit-details/" + hostID);
            return;
        }
        Utils.setState(fn, setUpdating, false);
        Call.refresh();
    }
    function submit() {
        if (fn.closed.current)
            return;
        if (!handleValidation())
            return;
        const options = Object.assign(Object.assign({}, fields), { op: "setoslogin", id: hostID });
        const pdo = Utils.postDataOptions(options);
        Utils.setState(fn, setUpdating, true);
        fetch(apiURL + "hosts", pdo).then(res => res.json()).then((result) => {
            if (result.success) {
                alert("OK");
                return reload();
            }
            else {
                if (result.field) {
                    setErrors({ [result.field]: result.error });
                }
                Utils.setState(fn, setError, Utils.error(result.error));
                Utils.setState(fn, setUpdating, false);
            }
        }, (error) => {
            Utils.setState(fn, setUpdating, false);
            return Utils.setState(fn, setError, Utils.error(error.message));
        });
    }
    function getForm() {
        const buttonsubmit = updating ? React.createElement("div", { className: "update_animation_box" }, Utils.updating())
            : React.createElement("button", { className: "btn btn-lg pro", id: "submit", value: "Submit", onClick: submit }, t("Login"));
        return React.createElement("div", { style: { paddingTop: "20px" } },
            React.createElement("div", { className: "col-md-6" },
                React.createElement("fieldset", null,
                    React.createElement("table", { className: "nobordertable" },
                        React.createElement("tbody", null,
                            React.createElement("tr", null,
                                React.createElement("td", null, t("User")),
                                React.createElement("td", null,
                                    React.createElement("input", { type: "text", size: "30", placeholder: "<sid>adm", field: "user", autoComplete: "new-password", onChange: handleChange, value: fields["user"] || "" })),
                                React.createElement("td", { style: { color: "red" } }, t(errors["user"]))),
                            React.createElement("tr", null,
                                React.createElement("td", null, t("Password")),
                                React.createElement("td", null,
                                    React.createElement("input", { type: "password", size: "30", placeholder: t("Password"), field: "password", autoComplete: "new-password", onChange: handleChange, value: fields["password"] || "" })),
                                React.createElement("td", { style: { color: "red" } }, t(errors["password"])))))),
                React.createElement("fieldset", null, buttonsubmit),
                React.createElement("div", null, status)));
    }
    let status = null;
    if (error) {
        status = React.createElement("div", { style: { color: "red" } }, t(error));
    }
    let form = getForm();
    return (React.createElement("div", { id: 'panel_host_login' },
        React.createElement("span", null,
            t("Please provide operating system username and password to reach required data"),
            " (sapadm)"),
        "  ",
        React.createElement("br", null),
        host &&
            React.createElement("span", null,
                host.name,
                " - ",
                host.alias,
                " - ",
                host.ip,
                "  - ",
                t("User"),
                ":",
                host.osuser),
        form));
};
const HostOptions = (props) => {
    const [host, setHost] = useState(null);
    const [error, setError] = useState(null);
    const fn = { closed: useRef(false) };
    const hostID = props.id;
    let inputHostAlias = createRef();
    let inputHostName = createRef();
    let inputHostIP = createRef();
    let inputMachine = createRef(0);
    let inputOSType = createRef(0);
    let inputEnvironment = createRef(0);
    function cleanUp() {
        fn.closed.current = true;
    }
    useEffect(() => { fn.closed.current = false; loadData(); return cleanUp; }, [hostID]);
    function loadData() {
        if (fn.closed.current)
            return;
        let pdo = Utils.postDataOptions({ op: "info", id: hostID });
        fetch(apiURL + "hosts", pdo).then(res => res.json()).then((result) => {
            if (result.success) {
                Utils.setState(fn, setHost, result);
            }
            else {
                Utils.setState(fn, setError, result.error);
            }
        }, (error) => {
            return Utils.setState(fn, setError, error.message);
        });
    }
    function updateHostAlias() {
        if (fn.closed.current)
            return;
        const alias = inputHostAlias.current.value;
        let pdo = Utils.postDataOptions({ op: "updatehostalias", hostid: hostID, alias: alias });
        fetch(apiURL + "hosts", pdo).then(res => res.json()).then((result) => {
            if (result.success) {
                Call.refresh();
                alert("Successfull");
            }
        }, (error) => {
            console.log(error.message);
        });
    }
    function updateHostName() {
        if (fn.closed.current)
            return;
        const hostName = inputHostName.current.value;
        if (!confirm("Hostname will be changed to:" + hostName)) {
            return;
        }
        Request.send({ caller: fn, url: apiURL + "hosts", params: { op: "updatehostname", hostid: hostID, name: hostName },
            refresh: true,
            message: "Hostname is changed to " + hostName
        });
    }
    function updateHostIP() {
        if (fn.closed.current)
            return;
        const ip = inputHostIP.current.value;
        if (!confirm("IP will be changed to:" + ip)) {
            return;
        }
        Request.send({ caller: fn, url: apiURL + "hosts", params: { op: "updatehostip", hostid: hostID, ip: ip },
            refresh: true,
            message: "IP is changed to " + ip
        });
    }
    function updateMachineType() {
        if (fn.closed.current)
            return;
        let pdo = Utils.postDataOptions({ op: "updatemachinetype", hostid: hostID, machine: inputMachine.current.value });
        fetch(apiURL + "hosts", pdo).then(res => res.json()).then((result) => {
            if (result.success) {
                Call.refresh();
                Info.success("Successfull");
            }
            else {
                Info.error(result.error);
            }
        }, (error) => {
            Info.error(error.message);
        });
    }
    function updateOSType() {
        if (fn.closed.current)
            return;
        let pdo = Utils.postDataOptions({ op: "setos", id: hostID, type: inputOSType.current.value });
        fetch(apiURL + "hosts", pdo).then(res => res.json()).then((result) => {
            if (result.success) {
                Call.refresh();
                Info.success("Successfull");
            }
            else {
                Info.error(result.error);
            }
        }, (error) => {
            Info.error(error.message);
        });
    }
    function updateEnvironment() {
        if (fn.closed.current)
            return;
        let pdo = Utils.postDataOptions({ op: "updateenvironment", hostid: hostID, environment: inputEnvironment.current.value });
        fetch(apiURL + "hosts", pdo).then(res => res.json()).then((result) => {
            if (result.success) {
                Call.refresh();
                Info.success("Successfull");
            }
            else {
                Info.error(result.error);
            }
        }, (error) => {
            Info.error(error.message);
        });
    }
    function setCheckDiskWrite(e) {
        const value = e.target.checked;
        Settings.set({ key: "checkdiskwrite", value: value, probeid: hostID }, function (result) {
            if (result.error) {
                Info.error(result.error);
            }
            else {
                Info.success("Setting is saved");
            }
        });
    }
    const probeConnected = host && host["probeConnected"];
    const checkDiskWrite = Settings.getBoolean({ key: "checkdiskwrite", probeid: hostID });
    if (error) {
        return Utils.error(error);
    }
    if (!host) {
        return Utils.loading();
    }
    return (React.createElement("div", { id: 'panel_host_options' },
        React.createElement("table", { className: "informationtable" },
            React.createElement("tbody", null,
                React.createElement("tr", null,
                    React.createElement("td", { width: "250" }, t("OS user")),
                    React.createElement("td", { width: "250" }, host.osUser),
                    React.createElement("td", null, User.admin && React.createElement("a", { href: "#hostlogin/" + hostID },
                        " ",
                        t("Set OS credentials"),
                        " "))),
                React.createElement("tr", null,
                    React.createElement("td", null,
                        t("Description"),
                        " "),
                    React.createElement("td", null, React.createElement("input", { type: "text", ref: inputHostAlias, id: "inputHostAlias", defaultValue: host.alias })),
                    React.createElement("td", null, User.admin && React.createElement("button", { onClick: updateHostAlias }, t("Update")))),
                React.createElement("tr", null,
                    React.createElement("td", null,
                        t("Host name"),
                        " "),
                    React.createElement("td", null, React.createElement("input", { type: "text", ref: inputHostName, id: "inputHostName", defaultValue: host.name })),
                    React.createElement("td", null, User.admin && React.createElement("button", { onClick: updateHostName }, t("Update")))),
                React.createElement("tr", null,
                    React.createElement("td", null,
                        t("IP"),
                        " "),
                    React.createElement("td", null, React.createElement("input", { type: "text", ref: inputHostIP, id: "inputHostIP", defaultValue: host.ip })),
                    React.createElement("td", null, User.admin && React.createElement("button", { onClick: updateHostIP }, t("Update")))),
                React.createElement("tr", null,
                    React.createElement("td", null, t("Type")),
                    React.createElement("td", null,
                        React.createElement("select", { ref: inputMachine, field: "machine", defaultValue: host.machine },
                            React.createElement("option", { value: "0" }, t("Unknown")),
                            React.createElement("option", { value: "1" }, t("Physical Computer")),
                            React.createElement("option", { value: "2" }, t("Virtual Computer")),
                            React.createElement("option", { value: "3" }, t("Network Device")),
                            React.createElement("option", { value: "4" }, t("VMWare VCenter")))),
                    React.createElement("td", null, User.admin && React.createElement("button", { onClick: updateMachineType }, t("Update")))),
                React.createElement("tr", null,
                    React.createElement("td", null,
                        t("Operating System"),
                        "  "),
                    React.createElement("td", null,
                        React.createElement("select", { ref: inputOSType, field: "ostype", defaultValue: host.osType },
                            React.createElement("option", { value: "0" }, t("Unknown")),
                            React.createElement("option", { value: "1" }, "Windows"),
                            React.createElement("option", { value: "2" }, "Linux"),
                            React.createElement("option", { value: "3" }, "Unix"))),
                    React.createElement("td", null, User.admin && React.createElement("button", { onClick: updateOSType }, t("Update")))),
                React.createElement("tr", null,
                    React.createElement("td", null,
                        t("Environment"),
                        "  "),
                    React.createElement("td", null,
                        React.createElement("select", { ref: inputEnvironment, field: "environment", defaultValue: host.env },
                            React.createElement("option", { value: "0" }, t("Unknown")),
                            React.createElement("option", { value: "1" }, "Development"),
                            React.createElement("option", { value: "2" }, "Production"),
                            React.createElement("option", { value: "3" }, "Demo"),
                            React.createElement("option", { value: "4" }, "Staging"),
                            React.createElement("option", { value: "5" }, "QA/Test"))),
                    React.createElement("td", null, User.admin && React.createElement("button", { onClick: updateEnvironment }, t("Update")))),
                React.createElement("tr", null,
                    React.createElement("td", null,
                        t("Check disk write"),
                        " "),
                    React.createElement("td", null, User.admin && React.createElement("div", null,
                        React.createElement("input", { type: "checkbox", id: "hostcheckdiskwrite_" + hostID, checked: checkDiskWrite, onChange: setCheckDiskWrite }),
                        React.createElement("label", { htmlFor: "hostcheckdiskwrite_" + hostID }, t("Active")))),
                    React.createElement("td", null)),
                host && host.probeexist &&
                    React.createElement("tr", null,
                        React.createElement("td", null,
                            " ",
                            t("Probe"),
                            " "),
                        React.createElement("td", null,
                            " ",
                            React.createElement("a", { href: "#probedetails/" + hostID },
                                t("Probe details"),
                                " "),
                            " "),
                        React.createElement("td", null)),
                User.admin && probeConnected &&
                    React.createElement("tr", null,
                        React.createElement("td", null, t("Update probe version")),
                        React.createElement("td", null,
                            React.createElement(ProbeUpdater, { id: hostID })),
                        React.createElement("td", null))))));
};
const HostPort = (props) => {
    const [divPage, setDivPage] = useState(null);
    const fn = { closed: useRef(false) };
    const hostID = props.match.params.hostid;
    const hostPort = props.match.params.port;
    function cleanUp() {
        fn.closed.current = true;
    }
    useEffect(() => { fn.closed.current = false; loadData(); return cleanUp; }, [hostID]);
    function loadData() {
        if (fn.closed.current)
            return;
        let pdo = Utils.postDataOptions({ op: "port", hostid: hostID, port: hostPort });
        fetch(apiURL + "hosts", pdo).then(res => res.json()).then((result) => {
            Utils.setState(fn, setDivPage, parseData(result));
        }, (error) => {
            return Utils.setState(fn, setDivPage, Utils.error(error.message));
        });
    }
    function parseData(json) {
        if (fn.closed.current)
            return;
        if (!json.success) {
            return Utils.error(json.error);
        }
        const div = React.createElement("div", null,
            React.createElement("table", null,
                React.createElement("tbody", null,
                    React.createElement("tr", null,
                        React.createElement("td", null, "Host"),
                        React.createElement("td", null, json.hostname),
                        React.createElement("td", null, json.hostalias)),
                    React.createElement("tr", null,
                        React.createElement("td", null, "Port"),
                        React.createElement("td", null, json.port),
                        React.createElement("td", null, json.name)),
                    React.createElement("tr", null,
                        React.createElement("td", null, "Ping"),
                        React.createElement("td", null,
                            json.ping,
                            " ms"),
                        React.createElement("td", null)),
                    React.createElement("tr", null,
                        React.createElement("td", null, "Scanned"),
                        React.createElement("td", null, Utils.toDate(json.lastscan)),
                        React.createElement("td", null)))),
            React.createElement(AvailabilityHistory, { key: "ahg_" + json.id + "_" + AvailabilityType.PORT, id: json.id, type: AvailabilityType.PORT }),
            React.createElement(AvailabilityLog, { key: "ahl_" + json.id + "_" + AvailabilityType.PORT, id: json.id, type: AvailabilityType.PORT }));
        return div;
    }
    ;
    function remove() {
        if (fn.closed.current)
            return;
        const message = t("Are you sure to remove this port ?");
        if (!confirm(message)) {
            return;
        }
        let pdo = Utils.postDataOptions({ op: "removeport", hostid: hostID, port: hostPort });
        fetch(apiURL + "hosts", pdo).then(res => res.json()).then((result) => {
            if (result.success) {
                alert("Successfull");
                Utils.goBack(props.history, "#unit-details/" + hostID);
            }
            else {
                alert(result.error);
            }
        }, (error) => {
            alert(error.message);
        });
    }
    function back(e) { e.preventDefault(); Utils.goBack(props.history, "#unit-details/" + hostID); }
    return (React.createElement("div", { id: "page" },
        React.createElement(Header, { back: back, title: t("Port details") }),
        React.createElement("div", null,
            divPage,
            React.createElement("br", null),
            React.createElement("a", { onClick: remove, title: 'Remove this port' },
                "  ",
                t("Remove")))));
};
const HostPorts = (props) => {
    const [divPorts, setDivPorts] = useState(null);
    const [refreshing, setRefreshing] = useState(true);
    const [lastPort, setLastPort] = useState(0);
    const fn = { closed: useRef(false) };
    let refreshTimeout = 0;
    const hostID = props.hostID;
    let inputNumber = createRef(0);
    let inputName = createRef(0);
    function cleanUp() {
        fn.closed.current = true;
        clearTimeout(refreshTimeout);
    }
    useEffect(() => { fn.closed.current = false; loadData(); return cleanUp; }, [hostID]);
    function loadData() {
        if (fn.closed.current)
            return;
        let pdo = Utils.postDataOptions({ op: "ports", hostid: hostID });
        Utils.setState(fn, setRefreshing, true);
        fetch(apiURL + "hosts", pdo).then(res => res.json()).then((result) => {
            Utils.setState(fn, setDivPorts, parseData(result));
        }, (error) => {
            return Utils.setState(fn, setDivPorts, Utils.error(error.message));
        }).then(() => {
            if (fn.closed.current)
                return;
            setTimeout(() => Utils.setState(fn, setRefreshing, false), 1000);
            refreshTimeout = setTimeout(loadData, 10000);
        });
    }
    function reload() {
        clearTimeout(refreshTimeout);
        loadData();
    }
    function portNumber(port) {
        if (port.t == 1) {
            return port.number;
        }
        return React.createElement("a", { href: "#port/" + hostID + "/" + port.number },
            " ",
            port.number,
            " ");
    }
    function parseData(data) {
        if (fn.closed.current)
            return;
        if (!data.success) {
            return Utils.error(data.error);
        }
        Utils.setState(fn, setLastPort, data.lastscannedport);
        if (data.ports.length < 1) {
            return React.createElement("div", null,
                React.createElement("span", null, "Please add port for scanning."),
                React.createElement("br", null),
                React.createElement("br", null));
        }
        const table = {
            defaultSortField: "number",
            direction: "ascending",
            id: "hostports_" + hostID,
            headers: [
                { name: "Port", field: "number", rowFormat: portNumber },
                { name: "Name", field: "name" },
                { name: "Open", field: "open", format: Utils.onOff },
                { name: "Ping", field: "ping" },
                { name: "Scanned", field: "scanned", format: Utils.toDate },
            ],
            field: "port",
            rows: data.ports
        };
        const div = React.createElement("div", null,
            t("Ports"),
            " ; ",
            React.createElement("br", null),
            " ",
            React.createElement("br", null),
            React.createElement(Table, { data: table }),
            React.createElement("div", null,
                " ",
                t("Last scanned port"),
                ": ",
                data.lastscannedport,
                " "));
        return div;
    }
    ;
    function addPort() {
        Debugger.print("Add new port");
        console.log(fn);
        if (fn.closed.current)
            return;
        const port = inputNumber.current.value;
        const name = inputName.current.value;
        let pdo = Utils.postDataOptions({ op: "addport", hostid: hostID, port: port, name: name });
        fetch(apiURL + "hosts", pdo).then(res => res.json()).then((result) => {
            if (result.success) {
                reload();
                alert("Successfull");
            }
            else {
                alert(result.error);
            }
        }, (error) => {
            alert(error.message);
        });
    }
    const refreshAnimation = refreshing ? Utils.updating() : null;
    return (React.createElement("div", { id: 'panel_host_ports' },
        React.createElement("div", { className: "update_animation_box" }, refreshAnimation),
        divPorts,
        React.createElement("br", null),
        React.createElement("br", null),
        React.createElement("br", null),
        React.createElement("br", null),
        User.admin && React.createElement("div", null,
            React.createElement("span", null,
                " ",
                t("Port"),
                ":"),
            React.createElement("input", { type: "text", ref: inputNumber, id: "inputPortNumber" }),
            React.createElement("span", null,
                t("Name"),
                ":"),
            React.createElement("input", { type: "text", ref: inputName, id: "inputPortName" }),
            React.createElement("button", { onClick: addPort }, t("Add New Port"))),
        React.createElement("br", null),
        t("Last scanned port"),
        ":",
        lastPort));
};
const HostProcesses = (props) => {
    const [divDetails, setDivDetails] = useState(null);
    const [refreshing, setRefreshing] = useState(true);
    let refreshTimeout = 0;
    const hostID = props.hostID;
    const fn = { closed: useRef(false) };
    function cleanUp() {
        fn.closed.current = true;
        clearTimeout(refreshTimeout);
    }
    useEffect(() => { fn.closed.current = false; loadData(); return cleanUp; }, [hostID]);
    function loadData() {
        if (fn.closed.current)
            return;
        Utils.setState(fn, setRefreshing, true);
        let pdo = Utils.postDataOptions({ id: hostID, op: "list" });
        fetch(apiURL + "unitprocessinfo", pdo).then(res => res.json()).then((result) => {
            Utils.setState(fn, setDivDetails, parse(result));
        }, (error) => {
            Utils.setState(fn, setDivDetails, Utils.error(error.message));
        }).then(() => {
            if (fn.closed.current)
                return;
            setTimeout(() => Utils.setState(fn, setRefreshing, false), 1000);
            refreshTimeout = setTimeout(loadData, 10000);
        });
    }
    ;
    function onPIDClick(row, data) {
        if (fn.closed.current)
            return;
        const div = React.createElement(ProcessDetails, { hostID: hostID, processID: row.id });
        Dialog.show({ content: div, render: true, title: t("Process Details") });
    }
    function parse(pi) {
        if (fn.closed.current)
            return;
        if (!pi.success) {
            return Utils.error(pi.error);
        }
        const processes = pi["processes"];
        const isCPUString = processes.length > 0 && typeof processes[0]["cpu"] == "string";
        const counts = {};
        for (var i = 0; i < processes.length; i++) {
            const process = processes[i];
            if (!counts[process.s]) {
                counts[process.s] = 1;
            }
            else {
                counts[process.s]++;
            }
            if (isCPUString) {
                process.cpu = parseFloat(process.cpu);
            }
        }
        const data = {
            defaultSortField: "cpu",
            direction: "descending",
            id: "pt",
            headers: [
                { name: "ID", field: "id", onClick: onPIDClick, filter: {} },
                { name: "Name", field: "n", "width": "250px", filter: {} },
                { name: "CPU", field: "cpu", format: Utils.percentage },
                { name: "Memory", field: "m", format: Utils.bytesToUnit },
                { name: "Virtual", field: "v", format: Utils.bytesToUnit },
                { name: "Parent", field: "pn", filter: {} },
                { name: "Threads", field: "tc" },
                { name: "State", field: "s", filter: {} },
                { name: "User", field: "u", filter: {} },
                { name: "Uptime", field: "ut", format: Utils.timePastMinutesMS },
            ],
            rows: processes
        };
        let report = "";
        for (var status in counts) {
            if (!counts.hasOwnProperty(status))
                continue;
            const count = counts[status];
            report += status + "=" + count + " ";
        }
        return (React.createElement("div", null,
            React.createElement("span", null,
                "Total:",
                processes.length,
                ",  ",
                report,
                " "),
            React.createElement(Table, { data: data })));
    }
    return (React.createElement("div", { id: 'panel_host_processes' },
        React.createElement("div", { className: "update_animation_box" }, refreshing && Utils.updating()),
        divDetails));
};
const HostSAPInformation = (props) => {
    const [div, setDiv] = useState(null);
    const [refreshing, setRefreshing] = useState(true);
    const fn = { exited: false };
    let refreshTimeout = 0;
    const hostID = props.hostID;
    function cleanUp() {
        fn.exited = true;
        clearTimeout(refreshTimeout);
    }
    useEffect(() => { setDiv(null); loadData(); return cleanUp; }, [hostID]);
    function loadData() {
        if (fn.exited)
            return;
        let pdo = Utils.postDataOptions({ op: "sapinfo", hostid: hostID });
        Utils.setState(fn, setRefreshing, true);
        fetch(apiURL + "hosts", pdo).then(res => res.json()).then((result) => {
            Utils.setState(fn, setDiv, parseData(result));
            if (fn.exited)
                return;
            setTimeout(() => Utils.setState(fn, setRefreshing, false), 1000);
            refreshTimeout = setTimeout(loadData, 10000);
        }, (error) => {
            return Utils.setState(fn, setDiv, error.message);
        });
    }
    function parseData(json) {
        if (json.instanceError == "Unauthorized") {
            return React.createElement(HostLogin, { hostID: hostID });
        }
        const instances = parseInstances(json);
        const databases = parseDatabases(json);
        const div = React.createElement("div", null,
            React.createElement("h4", null, t("SAP Instances")),
            instances,
            React.createElement("h4", null, t("Databases")),
            databases);
        return div;
    }
    ;
    function parseInstances(json) {
        if (json.instanceError) {
            return Utils.error(json.instanceError + " " + json.url);
        }
        const tableInstances = {
            defaultSortField: "id",
            id: "hsi_instances",
            headers: [
                { name: "SID", field: "sid" },
                { name: "Number", field: "nr" },
                { name: "Host", field: "host" },
                { name: "SAP Version", field: "sapversion", width: "100%" }
            ],
            rows: json.instances
        };
        return React.createElement(Table, { data: tableInstances });
    }
    function parseDatabases(json) {
        const databases = json.databases;
        if (json.databaseError) {
            return Utils.error(json.databaseError + " " + json.url);
        }
        const rows = [];
        for (let i = 0; i < databases.length; i++) {
            const database = databases[i];
            const row = { name: database.name };
            let properties = "Status:" + database.status + "\n";
            for (let p = 0; p < database.properties.length; p++) {
                const property = database.properties[p];
                properties += property.key + ":" + property.value + "\n";
            }
            properties += "\nComponents\n";
            for (let c = 0; c < database.components.length; c++) {
                const component = database.components[c];
                for (let cp = 0; cp < component.properties.length; cp++) {
                    const property = component.properties[cp];
                    properties += property.key + ":" + property.value + "\n";
                }
            }
            row.properties = properties;
            rows.push(row);
        }
        const table = {
            defaultSortField: "name",
            id: "hsi_database",
            headers: [
                { name: "Name", field: "name" },
                { name: "Properties", field: "properties", width: "100%", maxWidth: "100%", noCrop: true, multiline: true, height: "150px", showTooltip: true, showBox: true }
            ],
            rows: rows
        };
        return React.createElement(Table, { data: table });
    }
    const refreshAnimation = refreshing ? Utils.updating() : null;
    return (React.createElement("div", { id: 'panel_host_sap_info' },
        React.createElement("div", { className: "update_animation_box" }, refreshAnimation),
        div));
};
const HostServices = (props) => {
    const [divDetails, setDivDetails] = useState(null);
    const [refreshing, setRefreshing] = useState(true);
    let refreshTimeout = 0;
    const hostID = props.hostID;
    const fn = { closed: useRef(false) };
    function cleanUp() {
        fn.closed.current = true;
        clearTimeout(refreshTimeout);
    }
    useEffect(() => { fn.closed.current = false; loadData(); return cleanUp; }, [hostID]);
    function loadData() {
        if (fn.closed.current)
            return;
        Utils.setState(fn, setRefreshing, true);
        let pdo = Utils.postDataOptions({ id: hostID, op: "list" });
        fetch(apiURL + "unitservices", pdo).then(res => res.json()).then((result) => {
            Utils.setState(fn, setDivDetails, parse(result));
        }, (error) => {
            Utils.setState(fn, setDivDetails, Utils.error(error.message));
        }).then(() => {
            if (fn.closed.current)
                return;
            setTimeout(() => Utils.setState(fn, setRefreshing, false), 1000);
            refreshTimeout = setTimeout(loadData, 10000);
        });
    }
    ;
    function onPIDClick(row) {
        if (fn.closed.current)
            return;
        const div = React.createElement(ProcessDetails, { hostID: hostID, processID: row.pid });
        Dialog.show({ content: div, render: true, title: t("Process Details") });
    }
    function onServiceClick(row) {
        if (fn.closed.current)
            return;
        const div = React.createElement(ServiceDetails, { hostID: hostID, serviceName: row.nm });
        Dialog.show({ content: div, render: true, title: t("Service Details"), width: 400, height: 400 });
    }
    function parse(json) {
        if (fn.closed.current)
            return;
        if (!json.success) {
            return Utils.error(json.error);
        }
        const services = json["services"];
        const data = {
            defaultSortField: "nm",
            id: "st",
            headers: [
                { name: "#", number: true },
                { name: "Name", field: "nm", filter: {}, onClick: onServiceClick },
                { name: "State", field: "st", format: Utils.status },
                { name: "PID", field: "pid", filter: {}, title: "Process ID", hideZero: true, onClick: onPIDClick },
                { name: "Process", field: "pn", filter: {}, title: "Process Name", onClick: onPIDClick },
                { name: "Alarm", field: "ca", title: t("Create alarm when service is not running"), format: Utils.onOrEmpty },
                { name: "Restart", field: "as", title: t("Automatically restart when service is not running"), format: Utils.onOrEmpty }
            ],
            rows: services
        };
        return React.createElement(Table, { data: data });
    }
    return (React.createElement("div", { id: 'panel_host_services' },
        React.createElement("div", { className: "update_animation_box" }, refreshing && Utils.updating()),
        divDetails));
};
const PingMatrix = (props) => {
    const [divDetails, setDivDetails] = useState(null);
    const [refreshing, setRefreshing] = useState(true);
    const fn = { closed: useRef(false) };
    let refreshTimeout = 0;
    function cleanUp() {
        fn.closed.current = true;
        clearTimeout(refreshTimeout);
    }
    function back(e) {
        e.preventDefault();
        cleanUp();
        Utils.goBack(props.history, "/#dashboard");
    }
    useEffect(() => { fn.closed.current = false; loadData(); return cleanUp; }, [props.id]);
    function loadData() {
        if (fn.closed.current)
            return;
        Utils.setState(fn, setRefreshing, true);
        let pdo = Utils.postDataOptions({ "op": "pingmatrix" });
        fetch(apiURL + "hosts", pdo).then(res => res.json()).then((result) => {
            Utils.setState(fn, setDivDetails, parse(result));
        }, (error) => {
            Utils.setState(fn, setDivDetails, Utils.error(error.message));
        }).then(() => {
            if (fn.closed.current)
                return;
            setTimeout(() => Utils.setState(fn, setRefreshing, false), 1000);
            refreshTimeout = setTimeout(loadData, 10000);
        });
    }
    ;
    function parse(json) {
        Data.updates["pingmatrix"] = Utils.date();
        const trs = [];
        const ths = [];
        const red = "#700606";
        const green = "#3a5e05";
        const yellow = "#d4ca1c";
        ths.push(React.createElement("th", { key: "empty" }));
        for (let i = 0; i < json.hosts.length; i++) {
            const host = json.hosts[i];
            const tds = [];
            ths.push(React.createElement("th", { key: "th_" + host.id, style: { fontWeight: "normal" } }, host.n));
            tds.push(React.createElement("td", { key: "ch_" + i, style: { paddingRight: "10px" } }, host.n));
            for (let p = 0; p < host.pings.length; p++) {
                const ping = host.pings[p];
                const style = { height: "30px", lineHeight: "30px", color: "#aaa", overflow: "hidden", textAlign: "center", border: "1px solid #020202", padding: "2px", background: ping < 0 ? red : ping > 100 ? yellow : green };
                const title = (ping >= 0 ? ping + " ms\n" : null);
                tds.push(React.createElement("td", { title: title, key: "c_" + host.id + "_" + p, style: style }, ping < 0 ? "" : ping));
            }
            trs.push(React.createElement("tr", { style: {}, key: "row_" + host.id }, tds));
        }
        return React.createElement("table", { className: "vertical_table_header informationtable", style: { width: "inherit" } },
            React.createElement("thead", null,
                React.createElement("tr", null, ths)),
            React.createElement("tbody", null, trs));
    }
    return (React.createElement("div", { id: 'panel_ping_matrix' },
        React.createElement("span", { className: "pale" },
            t("Last update time"),
            " :  ",
            Data.updates["pingmatrix"]),
        React.createElement("div", { className: "update_animation_box" }, refreshing && Utils.updating()),
        divDetails));
};
const PingMatrixPage = (props) => {
    function back(e) {
        e.preventDefault();
        Utils.goBack(props.history, "/#dashboard");
    }
    return (React.createElement("div", { id: 'page' },
        React.createElement(Header, { back: back, title: t("Ping Matrix") }),
        React.createElement(PingMatrix, { id: "pagepingmatrix" })));
};
const ProbeLogs = (props) => {
    const [host, setHost] = useState({ name: "" });
    const hostID = props.match.params.id;
    const fn = { closed: useRef(false) };
    function cleanUp() {
        fn.closed.current = true;
    }
    function back(e) {
        e.preventDefault();
        cleanUp();
        Utils.goBack(props.history);
    }
    useEffect(() => { fn.closed.current = false; loadData(); return cleanUp; }, [hostID]);
    function loadData() {
        let pdo = Utils.postDataOptions({ hostid: hostID, op: "get" });
        fetch(apiURL + "hosts", pdo).then(res => res.json()).then((json) => {
            if (json.success) {
                Utils.setState(fn, setHost, json);
            }
            else {
                Info.error(json.error);
            }
        }, (error) => {
            Info.error(error.message);
        });
    }
    ;
    return (React.createElement("div", { id: 'page' },
        React.createElement(Header, { back: back, title: t("Probe Logs") + " " + host.name }),
        React.createElement(LogViewer, { id: "probelogs", data: { url: apiURL + "hosts", params: { hostid: hostID, limit: 20 } } })));
};
const ProbeUpdater = (props) => {
    const [status, setStatus] = useState(null);
    const fn = { closed: useRef(false) };
    let refreshTimeout = 0;
    const probeID = props.id;
    function cleanUp() {
        fn.closed.current = true;
        clearTimeout(refreshTimeout);
    }
    function update() {
        if (!confirm("Are you sure you want to update probe version ?")) {
            return;
        }
        if (fn.closed.current)
            return;
        let pdo = Utils.postDataOptions({ op: "updateprobe", id: probeID });
        fetch(apiURL + "hosts", pdo).then(res => res.json()).then((result) => {
            if (result.success) {
                Utils.setState(fn, setStatus, "Started");
            }
            else {
                Utils.setState(fn, setStatus, result.error);
            }
        }, (error) => {
            Utils.setState(fn, setStatus, error.message);
        });
    }
    return (React.createElement("div", { id: 'panel_probe_update_' + probeID },
        React.createElement("button", { onClick: update },
            " ",
            t("Update")),
        React.createElement("div", { id: "div_probe_update_status_" + probeID }, status)));
};
const ProbeUpdaterIcon = (props) => {
    const [status, setStatus] = useState({ text: "", status: 0 });
    const fn = { closed: useRef(false) };
    const probeID = props.id;
    const hostName = props.name;
    const [lastUpdateRequestTime, setLastUpdateRequestTime] = useState(0);
    function cleanUp() {
        fn.closed.current = true;
    }
    useEffect(() => { fn.closed.current = false; return cleanUp; }, [probeID]);
    function update() {
        const time = Utils.timeStamp();
        if (time - lastUpdateRequestTime < Time.minute) {
            Info.info("You need to wait until update is finished");
            return;
        }
        setLastUpdateRequestTime(time);
        Utils.setState(fn, setStatus, { text: "...", status: 1 });
        if (fn.closed.current)
            return;
        let pdo = Utils.postDataOptions({ op: "updateprobe", id: probeID });
        fetch(apiURL + "hosts", pdo).then(res => res.json()).then((result) => {
            if (result.success) {
                Utils.setState(fn, setStatus, { text: "OK", status: 2 });
                Info.success("Update Started:" + hostName);
            }
            else {
                Utils.setState(fn, setStatus, { text: result.error, status: 3 });
                Info.error(result.error + " [" + hostName + "]");
            }
        }, (error) => {
            Utils.setState(fn, setStatus, { text: error.message, status: 3 });
            Info.error(error.message + " [" + hostName + "]");
        });
    }
    let item = null;
    if (status.status < 1) {
        item = React.createElement("img", { className: "imagebutton", type: "svg", style: { width: "22px" }, src: "/images/icons/refresh4.svg", onClick: update, title: t("Update Probe") });
    }
    else {
        if (status.status == 3) {
            item = React.createElement("span", { style: { color: Colors.red }, title: status.text + " [" + hostName + "]" }, " ERR ");
        }
        else {
            item = React.createElement("span", { style: { color: Colors.green }, title: status.text + " [" + hostName + "]" },
                status.text,
                " ");
        }
    }
    return (React.createElement("div", { id: 'panel_probe_update_' + probeID }, item));
};
const ProcessDetails = (props) => {
    const [divPage, setDivPage] = useState("Loading...");
    const [refreshing, setRefreshing] = useState(true);
    const fn = { closed: useRef(false) };
    let refreshTimeout = 0;
    const processID = props.processID;
    const hostID = props.hostID;
    useEffect(() => { fn.closed.current = false; loadData(); return cleanUp; }, [processID]);
    function cleanUp() {
        fn.closed.current = true;
        clearTimeout(refreshTimeout);
    }
    function loadData() {
        if (fn.closed.current)
            return;
        Utils.setState(fn, setRefreshing, true);
        let pdo = Utils.postDataOptions({ hostid: hostID, op: "details", processid: processID });
        fetch(apiURL + "unitprocessinfo", pdo).then(res => res.json()).then((result) => {
            Utils.setState(fn, setDivPage, parse(result));
        }, (error) => {
            Utils.setState(fn, setDivPage, Utils.error(error.message));
        }).then(() => {
            if (fn.closed.current)
                return;
            setTimeout(() => Utils.setState(fn, setRefreshing, false), 1000);
            refreshTimeout = setTimeout(loadData, 10000);
        });
    }
    ;
    function parse(json) {
        if (!json.success) {
            return Utils.error(json.error);
        }
        let cnns = null;
        if (json.connections.length) {
            const data = {
                defaultSortField: "lp",
                direction: "ascending",
                id: "process_connection_table",
                headers: [
                    { name: "Local Port", field: "lp", width: "70px" },
                    { name: "Remote Port", field: "fp", width: "70px" },
                    { name: "State", field: "st", width: "120px" },
                    { name: "Remote Address", field: "fa" },
                    { name: "Type", width: "50px", field: "t" }
                ],
                rows: json.connections
            };
            cnns = React.createElement(Table, { data: data });
        }
        const div = React.createElement("div", null,
            React.createElement("table", { key: "t_process_details_", className: "nobordertable informationtable" },
                React.createElement("tbody", null,
                    React.createElement("tr", null,
                        React.createElement("td", { width: "200" }, t("ID")),
                        React.createElement("td", null, json.pid)),
                    React.createElement("tr", null,
                        React.createElement("td", null, t("Name")),
                        React.createElement("td", null,
                            json.name,
                            " (",
                            json.bits,
                            " bit)  ")),
                    React.createElement("tr", null,
                        React.createElement("td", null, t("Status")),
                        React.createElement("td", null, json.s)),
                    React.createElement("tr", null,
                        React.createElement("td", null, t("User")),
                        React.createElement("td", null, json.u)),
                    React.createElement("tr", null,
                        React.createElement("td", null, t("Memory")),
                        React.createElement("td", null, Utils.bytesToUnit(json.m))),
                    React.createElement("tr", null,
                        React.createElement("td", null, t("Swap")),
                        React.createElement("td", null, Utils.bytesToUnit(json.v))),
                    React.createElement("tr", null,
                        React.createElement("td", null, t("Bytes Read")),
                        React.createElement("td", null, Utils.bytesToUnit(json.bytesread))),
                    React.createElement("tr", null,
                        React.createElement("td", null, t("Bytes Written")),
                        React.createElement("td", null, Utils.bytesToUnit(json.byteswritten))),
                    React.createElement("tr", null,
                        React.createElement("td", null, t("Path")),
                        React.createElement("td", null, json.path)),
                    React.createElement("tr", null,
                        React.createElement("td", null, t("Working Directory")),
                        React.createElement("td", null, json.wd)),
                    React.createElement("tr", null,
                        React.createElement("td", null, t("Group")),
                        React.createElement("td", null, json.group)),
                    React.createElement("tr", null,
                        React.createElement("td", null, t("Parent")),
                        React.createElement("td", null, json.ppid)),
                    React.createElement("tr", null,
                        React.createElement("td", null, t("Priority")),
                        React.createElement("td", null, json.priority)),
                    React.createElement("tr", null,
                        React.createElement("td", null, t("Start Time")),
                        React.createElement("td", null, Utils.toDate(json.start))),
                    React.createElement("tr", null,
                        React.createElement("td", null, t("Uptime")),
                        React.createElement("td", null, Utils.minutesPast(json.uptime / 1000))),
                    React.createElement("tr", null,
                        React.createElement("td", null, t("Thread Count")),
                        React.createElement("td", null, json.tc)),
                    React.createElement("tr", null,
                        React.createElement("td", null, t("Arguments")),
                        React.createElement("td", null, json.arguments)),
                    React.createElement("tr", null,
                        React.createElement("td", null, t("Command Line")),
                        React.createElement("td", null, json.commandline)))),
            cnns);
        return div;
    }
    return (React.createElement("div", { id: 'panel_host_processes' },
        React.createElement("div", { className: "update_animation_box" }, refreshing && Utils.updating()),
        divPage));
};
const RemoveHostFromSystem = (props) => {
    const [div, setDiv] = useState(null);
    const fn = { exited: false };
    const hostID = props.match.params.hostid;
    const SID = props.match.params.sid;
    function cleanUp() { fn.exited = true; }
    function back(e) { e.preventDefault(); Utils.goBack(props.history, "#system/" + SID); }
    useEffect(() => { getHost(); return cleanUp; }, [props]);
    function getHost() {
        const options = { op: "gethost", hostid: hostID };
        const pdo = Utils.postDataOptions(options);
        fetch(apiURL + "systems", pdo)
            .then(response => response.json())
            .then((result) => {
            Utils.setState(fn, setDiv, parseHost(result));
        }, (error) => {
            Utils.setState(fn, setDiv, Utils.error(error.message));
        });
    }
    ;
    function parseHost(data) {
        if (!data.success) {
            return Utils.setState(fn, setDiv, Utils.error(data.error));
        }
        const div = React.createElement("div", null,
            "SID:",
            data.sids,
            React.createElement("br", null),
            "Host:",
            data.name,
            " ",
            React.createElement("br", null),
            "Name:",
            data.alias,
            " ",
            React.createElement("br", null),
            "IP:",
            data.ip,
            React.createElement("br", null),
            "Last Activity : ",
            Utils.toDate(data.lastActivity),
            "  ",
            React.createElement("br", null),
            React.createElement("br", null),
            t("Are you sure you want to remove host [{{host}}] from system [{{system}}] ?", { host: data.name, system: SID }),
            React.createElement("br", null),
            React.createElement("br", null),
            React.createElement("button", { className: "critical", onClick: remove },
                " ",
                t("Remove")),
            React.createElement("button", { className: "btn btn-lg pro", onClick: back },
                " ",
                t("Cancel")));
        return div;
    }
    function remove(e) {
        e.preventDefault();
        const message = t("Are you sure you want to remove ?");
        if (!confirm(message)) {
            return;
        }
        const options = { op: "removehostfromsystem", hostid: hostID, sid: SID };
        const pdo = Utils.postDataOptions(options);
        fetch(apiURL + "systems", pdo)
            .then(response => response.json())
            .then((result) => {
            console.log(result);
            if (result.success) {
                Call.refresh();
                Utils.goBack(props.history, "#system/" + SID);
                return;
            }
            if (result.error) {
                Utils.setState(fn, setDiv, Utils.error(result.error));
            }
        }, (error) => {
            Utils.setState(fn, setDiv, Utils.error(error.message));
        });
    }
    ;
    return (React.createElement("div", { id: "page" },
        React.createElement(Header, { back: back, title: t("Remove host from system"), critical: true }),
        React.createElement("div", null, div)));
};
const RemoveUnit = (props) => {
    const [div, setDiv] = useState(null);
    const fn = { exited: false };
    function cleanUp() { fn.exited = true; }
    useEffect(() => { loadData(); return cleanUp; }, []);
    function loadData() {
        let unitid = props.match.params.id;
        if (!unitid) {
            return Utils.setState(fn, setDiv, Utils.error("Unit is not found"));
        }
        let pdo = Utils.postDataOptions({ hostid: unitid, op: "get" });
        fetch(apiURL + "hosts", pdo).then(res => res.json()).then((result) => {
            Utils.setState(fn, setDiv, fillDiv(result));
        }, (error) => {
            Utils.setState(fn, setDiv, Utils.error(error.message));
        });
    }
    ;
    function fillDiv(host) {
        if (!host.success) {
            return Utils.error(host.error);
        }
        if (host["removed"]) {
            return Utils.error("Unit is removed");
        }
        const d = [
            React.createElement("table", { key: "unit_props" },
                React.createElement("tbody", null,
                    React.createElement("tr", null,
                        React.createElement("td", null, t("Name")),
                        React.createElement("td", null, host["name"])),
                    React.createElement("tr", null,
                        React.createElement("td", null, "IP"),
                        React.createElement("td", null, host["ip"])))),
            React.createElement("div", { key: "unit_props_space", className: "space20" }),
            React.createElement("button", { key: "button_remove_unit", onClick: remove, className: "critical" }, t("Remove"))
        ];
        Debugger.print("RemoveUnit.fillDiv Completed");
        return d;
    }
    function remove() {
        const message = t("Are you sure to remove this host ?");
        if (!confirm(message)) {
            return;
        }
        let unitid = props.match.params.id;
        let pdo = Utils.postDataOptions({ op: "remove", id: unitid });
        fetch(apiURL + "hosts", pdo)
            .then(response => response.json())
            .then((result) => {
            if (result.success) {
                return Utils.go(props.history, "/#home");
            }
            else {
                Utils.setState(fn, setDiv, Utils.error(result.error));
            }
        }, (error) => {
            Utils.setState(fn, setDiv, Utils.error(error.message));
        });
    }
    function cancel() {
        Utils.goBack(props.history);
    }
    return (React.createElement("div", { id: 'page' },
        React.createElement(Header, { back: cancel, title: t("Remove host"), critical: true }),
        div,
        React.createElement("button", { onClick: cancel }, t("Cancel")),
        React.createElement("div", { className: "clear" })));
};
const ScheduledTaskList = (props) => {
    const fn = { closed: useRef(false) };
    const [divTasks, setDivTasks] = useState(null);
    const [refreshing, setRefreshing] = useState(true);
    const hostID = props.hostID;
    function cleanUp() {
        fn.closed.current = true;
    }
    useEffect(() => { fn.closed.current = false; loadData(); return cleanUp; }, [hostID]);
    function loadData() {
        if (fn.closed.current)
            return;
        Utils.setState(fn, setRefreshing, true);
        Request.send({
            caller: fn,
            url: apiURL + "scheduledtasks",
            params: { op: "tasks", id: hostID, root: true },
            listener: (json) => Utils.setState(fn, setDivTasks, parseTasks(json))
        });
    }
    ;
    function formatState(val) {
        switch (val) {
            case "1": return React.createElement("span", { style: { color: Colors.red } }, "Disabled");
            case "2": return React.createElement("span", { style: { color: Colors.yellow } }, "Queued");
            case "3": return "Ready";
            case "4": return React.createElement("span", { style: { color: Colors.green } }, "Running");
        }
        return "Unknown";
    }
    function parseTasks(json) {
        setTimeout(() => Utils.setState(fn, setRefreshing, false), 1000);
        if (!json.success) {
            return Utils.error(json.error);
        }
        const tasks = json.tasks;
        for (let i = 0; i < tasks.length; i++) {
            const task = tasks[i];
            task.checked = task.sel ? 1 : 0;
            task.nm = task.pt + task.nm;
            task.chk = React.createElement("input", { type: "checkbox", checked: task.checked, onChange: checkBoxClicked, tn: task.nm });
            task.selected = task.checked ? "Create alert" : "";
        }
        const info = {
            defaultSortField: "id",
            id: "schtasks_" + hostID,
            direction: "descending",
            headers: [
                { name: "", field: "checked", html: "chk", width: "40px" },
                { name: "Selected", field: "selected", width: "100px" },
                { name: "Name", field: "nm" },
                { name: "Status", field: "st", format: formatState },
            ],
            rows: tasks
        };
        return React.createElement(Table, { data: info });
    }
    function checkBoxClicked(e) {
        e.preventDefault();
        e.stopPropagation();
        const chk = e.currentTarget;
        const taskName = chk.getAttribute('tn');
        Request.send({
            caller: fn,
            url: apiURL + "scheduledtasks",
            params: { hostid: hostID, root: true, op: chk.checked ? "add" : "remove", name: taskName },
            listener: (json) => {
                setTimeout(loadData, 10);
            }
        });
    }
    return (React.createElement("div", { id: "panel_host_scheduled_tasks_" + hostID },
        React.createElement("div", { className: "update_animation_box" }, refreshing && Utils.updating()),
        "Please select the tasks that you want SysRanger to create alarm when the task fails.",
        divTasks));
};
const ScheduledTaskEvents = (props) => {
    const fn = { closed: useRef(false) };
    const [divEvents, setDivEvents] = useState(null);
    const [refreshing, setRefreshing] = useState(true);
    const hostID = props.hostID;
    function cleanUp() {
        fn.closed.current = true;
    }
    useEffect(() => { fn.closed.current = false; loadData(); return cleanUp; }, [hostID]);
    function loadData() {
        if (fn.closed.current)
            return;
        Utils.setState(fn, setRefreshing, true);
        Request.send({
            caller: fn,
            url: apiURL + "scheduledtasks",
            params: { op: "events",
                id: hostID,
                all: Data.getBoolean("displayallevents_" + hostID)
            },
            listener: (json) => Utils.setState(fn, setDivEvents, parseEvents(json)),
            then: () => setTimeout(loadData, 10000)
        });
    }
    ;
    function formatLevel(val) {
        switch (val) {
            case "1": return React.createElement("span", { style: { color: Colors.orange } }, "Critical");
            case "2": return React.createElement("span", { style: { color: Colors.red } }, "Error");
            case "3": return React.createElement("span", { style: { color: Colors.yellow } }, "Warning");
            case "4": return "Information";
            case "5": return "Verbose";
        }
        return "Unknown";
    }
    function setDisplayAllEvents(e) {
        Data.set("displayallevents_" + hostID, e.target.checked);
        setTimeout(loadData, 100);
    }
    function parseEvents(json) {
        setTimeout(() => Utils.setState(fn, setRefreshing, false), 1000);
        if (!json.success) {
            return Utils.error(json.error);
        }
        const info = {
            defaultSortField: "id",
            id: "schtaskevents_" + hostID,
            direction: "descending",
            headers: [
                { name: "Level", field: "lvl", format: formatLevel },
                { name: "Name", field: "tn" },
                { name: "Action", field: "an" },
                { name: "Time", field: "tm", format: Utils.toDate },
                { name: "Category", field: "cat" },
                { name: "Record ID", field: "rid" },
                { name: "Event ID", field: "eid" },
            ],
            rows: json.events
        };
        return React.createElement(Table, { data: info });
    }
    return (React.createElement("div", { id: "panel_host_scheduled_task_events_" + hostID },
        React.createElement("div", { className: "update_animation_box" }, refreshing && Utils.updating()),
        "You need to enable \"All Tasks History\" from Windows TaskScheduler's settings.",
        React.createElement("div", { style: { float: "right" } },
            React.createElement("input", { type: "checkbox", id: "chk_display_all_events", defaultChecked: Data.getBoolean("displayallevents_" + hostID), onChange: setDisplayAllEvents }),
            React.createElement("label", { htmlFor: "chk_display_all_events" }, t("Display All")),
            " ",
            React.createElement("br", null)),
        divEvents));
};
const ScheduledTasks = (props) => {
    const hostID = props.hostID;
    return (React.createElement("div", { id: 'panel_host_scheduled_tasks' },
        React.createElement(Tabs, { default: null, id: "tabs_scheduled_tasks", key: 'tabs_scheduled_tasks_' + hostID },
            React.createElement(Tab, { key: 'tasks', name: 'tasks', label: 'Tasks' },
                "   ",
                React.createElement(ScheduledTaskList, { hostID: hostID }),
                "     "),
            React.createElement(Tab, { key: 'events', name: 'events', label: 'Events' },
                "   ",
                React.createElement(ScheduledTaskEvents, { hostID: hostID }),
                "     "))));
};
const Screenshot = (props) => {
    const [screenshot, setScreenshot] = useState(null);
    const url = apiURL + "screenshot";
    const fn = { closed: useRef(false) };
    let refreshTimeout = 0;
    const hostID = props.unitid;
    function cleanUp() {
        fn.closed.current = true;
        clearTimeout(refreshTimeout);
    }
    useEffect(() => { getScreenshot(); return cleanUp; }, [hostID]);
    function getScreenshot() {
        if (fn.closed.current)
            return;
        let pdo = Utils.postDataOptions({ id: props.unitid, size: props.size });
        fetch(url, pdo).then(res => res.json()).then((result) => {
            Utils.setState(fn, setScreenshot, parse(result));
        }, (error) => {
            Utils.setState(fn, setScreenshot, parse({ error: error.message, success: false }));
        }).then(() => {
            if (fn.closed.current)
                return;
            refreshTimeout = setTimeout(getScreenshot, 10000);
        });
    }
    ;
    function parse(json) {
        let img = null;
        if (!json.success) {
            img = React.createElement("img", { src: "/images/noimage.jpg", width: props.size, title: json.error });
        }
        else {
            img = React.createElement("img", { src: "data:image/jpeg;base64," + json.image });
        }
        return React.createElement("div", { style: { height: props.size + "px" } },
            " ",
            img,
            " ");
    }
    function getDiv(content) {
        return React.createElement("div", null, content);
    }
    return (React.createElement("div", { key: "screenshot_" + hostID }, screenshot));
};
const Screenshots = (props) => {
    const [divDetails, setDivDetails] = useState(null);
    const fn = { closed: useRef(false) };
    function cleanUp() {
        fn.closed.current = true;
    }
    useEffect(() => { fn.closed.current = false; loadData(); return cleanUp; }, []);
    function loadData() {
        if (fn.closed.current)
            return;
        let pdo = Utils.postDataOptions({ op: "basiclist" });
        fetch(apiURL + "hosts", pdo).then(res => res.json()).then((result) => {
            Utils.setState(fn, setDivDetails, parse(result));
        }, (error) => {
            Utils.setState(fn, setDivDetails, Utils.error(error.message));
        });
    }
    function parse(json) {
        if (!json.success) {
            return Utils.error(json.error);
        }
        const screenshots = [];
        const style = { padding: "10px 10px 10px 0px", float: "left", width: "220px", height: "220px" };
        for (var i = 0; i < json.hosts.length; i++) {
            const host = json.hosts[i];
            const screenshot = React.createElement("div", { key: "sscont_" + host.id, style: style },
                React.createElement(Screenshot, { unitid: host.id, size: "200", key: "ss_" + host.id }),
                host["name"]);
            screenshots.push(screenshot);
        }
        return screenshots;
    }
    function back() { cleanUp(); Utils.goBack(props.history, "/#units"); }
    return (React.createElement("div", { id: 'page' },
        React.createElement(Header, { back: back, title: t("Screenshots") }),
        divDetails));
};
const ServiceDetails = (props) => {
    const [divDetails, setDivDetails] = useState(null);
    const hostID = props.hostID;
    const serviceName = props.serviceName;
    const panelID = hostID + "_" + Utils.hash(serviceName);
    const fn = { closed: useRef(false) };
    function cleanUp() {
        fn.closed.current = true;
    }
    useEffect(() => { fn.closed.current = false; loadData(); return cleanUp; }, [hostID, serviceName]);
    function loadData() {
        if (fn.closed.current)
            return;
        let pdo = Utils.postDataOptions({ hostid: hostID, op: "info", servicename: serviceName });
        fetch(apiURL + "unitservices", pdo).then(res => res.json()).then((result) => {
            Utils.setState(fn, setDivDetails, parse(result));
        }, (error) => {
            Utils.setState(fn, setDivDetails, Utils.error(error.message));
        });
    }
    ;
    function parse(json) {
        if (fn.closed.current)
            return;
        if (!json.success) {
            return Utils.error(json.error);
        }
        const adminMenu = User.admin && React.createElement("div", null,
            React.createElement("button", { onClick: onStartClick }, t("Start")),
            React.createElement("br", null),
            React.createElement("button", { onClick: onStopClick }, t("Stop")),
            React.createElement("br", null),
            React.createElement(Checkbox, { label: "Create Alarm", checked: json.ca, onChange: createAlarm, id: "service_ca_" + panelID, key: "service_ca_" + panelID }),
            React.createElement("br", null),
            React.createElement(Checkbox, { label: "Keep Alive", checked: json.as, onChange: keepAlive, id: "service_as_" + panelID, key: "service_as_" + panelID }),
            React.createElement("br", null));
        const div = React.createElement("div", null,
            React.createElement("table", { key: "t_service_details_" + panelID, className: "nobordertable informationtable" },
                React.createElement("tbody", null,
                    React.createElement("tr", null,
                        React.createElement("td", { width: "200" }, t("Name")),
                        React.createElement("td", null, json.name)),
                    React.createElement("tr", null,
                        React.createElement("td", null, t("Process ID")),
                        React.createElement("td", null, json.pid)),
                    React.createElement("tr", null,
                        React.createElement("td", null, t("Status")),
                        React.createElement("td", null, Utils.onOff(json.status))),
                    React.createElement("tr", null,
                        React.createElement("td", null, t("Process Name")),
                        React.createElement("td", null, json.pn)))),
            adminMenu);
        return div;
    }
    function createAlarm(e) {
        console.log(e);
        const alarm = e.target.checked;
        if (fn.closed.current)
            return;
        let pdo = Utils.postDataOptions({ hostid: hostID, op: "setalarm", "servicename": serviceName, alarm: alarm });
        fetch(apiURL + "unitservices", pdo).then(res => res.json()).then((result) => {
            if (result.success) {
                Info.success(t("Alarm is set for service") + ":" + serviceName);
            }
            else {
                Info.error(result.error);
            }
        }, (error) => {
            Info.error(error.message);
        }).then(() => {
            if (fn.closed.current)
                return;
            Dialog.close();
        });
    }
    function keepAlive(e) {
        console.log(e);
        const autostart = e.target.checked;
        if (fn.closed.current)
            return;
        let pdo = Utils.postDataOptions({ hostid: hostID, op: "setautostart", "servicename": serviceName, autostart: autostart });
        fetch(apiURL + "unitservices", pdo).then(res => res.json()).then((result) => {
            if (result.success) {
                Info.success(t("Keep Alive is set for service") + ":" + serviceName);
            }
            else {
                Info.error(result.error);
            }
        }, (error) => {
            Info.error(error.message);
        }).then(() => {
            if (fn.closed.current)
                return;
            Dialog.close();
        });
    }
    function onStartClick() {
        if (!confirm(t("Are you sure to start this service ?") + "\n" + serviceName)) {
            return;
        }
        Info.info("Starting " + serviceName);
        if (fn.closed.current)
            return;
        let pdo = Utils.postDataOptions({ hostid: hostID, op: "start", "servicename": serviceName });
        fetch(apiURL + "unitservices", pdo).then(res => res.json()).then((result) => {
            if (result.success) {
                if (!result.message)
                    return Info.error("Not supported");
                Info.success(result.message);
            }
            else {
                Info.error(result.error);
            }
        }, (error) => {
            Info.error(error.message);
        }).then(() => {
            if (fn.closed.current)
                return;
            Dialog.close();
        });
    }
    ;
    function onStopClick() {
        if (!confirm(t("Are you sure to stop this service ?") + "\n" + serviceName)) {
            return;
        }
        Info.info("Stopping " + serviceName);
        if (fn.closed.current)
            return;
        let pdo = Utils.postDataOptions({ hostid: hostID, op: "stop", "servicename": serviceName });
        fetch(apiURL + "unitservices", pdo).then(res => res.json()).then((result) => {
            if (result.success) {
                if (!result.message)
                    return Info.error("Not supported");
                Info.success(result.message);
            }
            else {
                Info.error(result.error);
            }
        }, (error) => {
            Info.error(error.message);
        }).then(() => {
            if (fn.closed.current)
                return;
            Dialog.close();
        });
    }
    ;
    return (React.createElement("div", { id: 'panel_host_service_details' }, divDetails));
};
const SystemsAddNewHost = (props) => {
    const url = apiURL + "systems";
    const [divSystem, setDivSystem] = useState(null);
    const SID = props.match.params.sid;
    const fn = { exited: false };
    function back() { cleanUp(); Utils.goBack(props.history); }
    function cleanUp() {
        fn.exited = true;
    }
    useEffect(() => { getData(); return cleanUp; }, []);
    function getData() {
        if (fn.exited)
            return;
        Utils.setState(fn, setDivSystem, Utils.loading());
        let pdo = Utils.postDataOptions({ op: "gethostlistforsystem", sid: SID });
        fetch(url, pdo).then(res => res.json()).then((result) => {
            parseSystem(result);
        }, (error) => {
            console.log(error);
            Utils.setState(fn, setDivSystem, Utils.error(error.message));
        });
    }
    ;
    function noHostAvailable() {
        const div = React.createElement("div", null, t("No host available."));
        return Utils.setState(fn, setDivSystem, div);
    }
    function rowClicked(host) {
        if (fn.exited)
            return;
        Utils.go(props.history, "/add-host-to-system-details/" + SID + "/" + host.id);
    }
    function groupNames(gids) {
        let list = "";
        const parts = gids.split(",");
        for (let i = 0; i < parts.length; i++) {
            list += Data.groupCode(parts[i]) + ",";
        }
        return list;
    }
    function parseSystem(data) {
        if (!data || !data.success) {
            return Utils.setState(fn, setDivSystem, Utils.error(data.error));
        }
        if (data.hosts.length < 1) {
            return noHostAvailable();
        }
        const tableData = {
            defaultSortField: "gids",
            id: "sht",
            headers: [
                { name: "Host", field: "name", onClick: rowClicked, filter: {} },
                { name: "IP", field: "ip", filter: {} },
                { name: "Description", field: "alias", filter: {} },
                { name: "Systems", field: "sys", filter: {} },
                { name: "Groups", field: "gids", rowFormat: (row) => groupNames(row.gids) },
            ],
            rows: data.hosts,
            json: data
        };
        const table = React.createElement(Table, { data: tableData });
        Utils.setState(fn, setDivSystem, table);
    }
    const scode = Data.systemCode(SID);
    return (React.createElement("div", { id: 'page' },
        React.createElement(Header, { back: back, title: t("Assign host to system ") + " " + (scode && "[" + scode + "]") }),
        React.createElement("br", null),
        React.createElement("br", null),
        t("Please select a host to add for system [{{system}}]", { system: scode }),
        divSystem,
        React.createElement("br", null),
        " ",
        React.createElement("br", null),
        React.createElement("span", { style: { paddingRight: "20px" } }, "If your host is not listed, you can add the host manually."),
        React.createElement("a", { href: "#add-new-unit/" + SID, className: "linkbutton" },
            " ",
            t("Add new Host"))));
};
const SystemsAddNewHostDetails = (props) => {
    const [host, setHost] = useState(null);
    const SID = props.match.params.sid;
    const HID = props.match.params.hid;
    const inputDescription = useRef();
    const fn = { closed: useRef(false) };
    function back() { cleanUp(); Utils.goBack(props.history); }
    function cleanUp() {
        fn.closed.current = true;
    }
    useEffect(() => { fn.closed.current = false; loadData(); return cleanUp; }, []);
    function loadData() {
        if (fn.closed.current)
            return;
        Request.send({
            caller: fn,
            url: apiURL + "hosts",
            params: { op: "info", id: HID },
            success: (json) => {
                Utils.setState(fn, setHost, json);
            }
        });
    }
    ;
    function add() {
        if (fn.closed.current)
            return;
        Request.send({
            caller: fn,
            url: apiURL + "systems",
            params: { op: "addhosttosystem", hostid: HID, sid: SID, description: inputDescription.current.value },
            success: (json) => {
                Call.refresh();
                props.history.push("/system/" + SID);
            }
        });
    }
    function details() {
        if (!host)
            return null;
        const div = React.createElement("div", null,
            React.createElement("table", { className: "nobordertable" },
                React.createElement("tbody", null,
                    React.createElement("tr", null,
                        React.createElement("td", null, "System:"),
                        React.createElement("td", null,
                            Data.systemCode(SID),
                            " ")),
                    React.createElement("tr", null,
                        React.createElement("td", null, "Host name:"),
                        React.createElement("td", null, host.name)),
                    React.createElement("tr", null,
                        React.createElement("td", null, "IP:"),
                        React.createElement("td", null,
                            host.ip,
                            " ")),
                    React.createElement("tr", null,
                        React.createElement("td", null, "Description:"),
                        React.createElement("td", null,
                            React.createElement("input", { type: "text", ref: inputDescription, defaultValue: host.alias }),
                            "   ")))),
            React.createElement("button", { onClick: add }, "Complete"));
        return div;
    }
    const scode = Data.systemCode(SID);
    return (React.createElement("div", { id: 'page' },
        React.createElement(Header, { back: back, title: t("Assign host to system ") + " " + (scode && "[" + scode + "]") }),
        React.createElement("br", null),
        React.createElement("br", null),
        t("Please check details and add this host to system [{{system}}]", { system: scode }),
        details()));
};
const TopologyItem = function (id) {
    const that = this;
    this.id = id;
    this.x = 0;
    this.y = 0;
    this.x2 = 100;
    this.y2 = 100;
    this.width = 100;
    this.height = 100;
    this.dragging = false;
    this.host = null;
    this.draggable = true;
    this.hovered = false;
    this.dragOffset = { x: 0, y: 0 };
    this.move = function (x, y) {
        that.x = x;
        that.y = y;
        that.x2 = that.x + that.width;
        that.y2 = that.y + that.height;
    };
};
const Topology = function () {
    const that = this;
    this.images = {};
    this.items = {};
    this.tooltip = null;
    this.data = null;
    this.drag = null;
    this.connections = {};
    this.init = function () {
        this.loadImages();
    };
    this.loadImages = function () {
        const list = ["host.png", "host_on.png", "host_off.png",
            "os_win.png", "os_linux.png"
        ];
        for (var i = 0; i < list.length; i++) {
            const item = list[i];
            this.images[item] = { loaded: false, image: null };
        }
        const time = Date.now();
        for (let key in this.images) {
            const obj = this.images[key];
            var image = new Image();
            image.dt = obj;
            image.onload = function () {
                this.dt.loaded = true;
                this.dt.image = this;
            };
            image.src = 'images/topology/' + key + "?v=" + time;
        }
    };
    this.parse = function (data) {
        that.data = data;
        if (!data.hosts)
            return "No host defined";
        for (var i = 0; i < data.hosts.length; i++) {
            const host = data.hosts[i];
            const loader = host.h ? that.images["host_on.png"] : that.images["host_off.png"];
            const item = that.items[host.id] || (new TopologyItem(host.id));
            that.items[item.id] = item;
            item.loader = loader;
            item.host = host;
            item.width = 100;
            item.height = 120;
            if (!item.dragging) {
                item.move(host.x, host.y);
            }
        }
        for (var i = 0; i < data.connections.length; i++) {
            const connection = data.connections[i];
            const id = connection.from + "|" + connection.to;
            that.connections[id] = connection;
        }
    };
    this.releaseItems = function () {
        if (that.drag) {
            that.drag.dragging = false;
        }
        that.drag = null;
    };
    this.osImage = function (type) {
        switch (type) {
            case 1: return that.images["os_win.png"];
            case 2: return that.images["os_linux.png"];
        }
        return null;
    };
    this.init();
};
const Graphics = {
    topology: new Topology()
};
const TopologyGraph = (props) => {
    const canvasDOMGraph = useRef(null);
    const [refreshing, setRefreshing] = useState(true);
    const [error, setError] = useState(null);
    const fn = { closed: useRef(false) };
    let refreshTimeout = 0;
    const textColor = "#a2a2a2";
    const topology = Graphics.topology;
    function cleanUp() {
        fn.closed.current = true;
        clearTimeout(refreshTimeout);
    }
    function back(e) { e.preventDefault(); cleanUp(); Utils.goBack(props.history); }
    useEffect(() => { fn.closed.current = false; init(); loadData(); return cleanUp; }, []);
    function loadData() {
        if (fn.closed.current)
            return;
        Utils.setState(fn, setRefreshing, true);
        let pdo = Utils.postDataOptions({ op: "map" });
        fetch(apiURL + "topology", pdo).then(res => res.json()).then((result) => {
            topology.parse(result);
        }, (error) => {
            Utils.setState(fn, setError, Utils.error(error.message));
        }).then(() => {
            if (fn.closed.current)
                return;
            setTimeout(() => Utils.setState(fn, setRefreshing, false), 1000);
            refreshTimeout = setTimeout(loadData, 10000);
        });
    }
    ;
    function update() {
        if (fn.closed.current)
            return;
        let pdo = Utils.postDataOptions({ op: "update" });
        fetch(apiURL + "topology", pdo).then(res => res.json()).then((result) => {
            Debugger.print("TopologyGraph.update");
            Debugger.print(result);
        }, (error) => {
            Utils.setState(fn, setError, Utils.error(error.message));
        });
    }
    ;
    function init() {
        const canvas = document.getElementById('topology_canvas');
        canvas.onmousedown = mouseDown;
        canvas.onmouseup = mouseUp;
        canvas.onmousemove = mouseMove;
        update();
    }
    function mouseDown(e) {
        e.preventDefault();
        e.stopPropagation();
        const canvas = document.getElementById('topology_canvas');
        const BB = canvas.getBoundingClientRect();
        const offsetX = BB.left;
        const offsetY = BB.top;
        var mx = parseInt(e.clientX - offsetX);
        var my = parseInt(e.clientY - offsetY);
        let found = null;
        for (let key in topology.items) {
            const item = topology.items[key];
            item.hovered = false;
            if (mx > item.x && mx < item.x2 && my > item.y && my < item.y2) {
                found = item;
                item.dragOffset.x = mx - item.x;
                item.dragOffset.y = my - item.y;
            }
        }
        found.dragging = true;
        topology.drag = found;
    }
    function drag(data) {
        data.item.move(data.x - data.item.dragOffset.x, data.y - data.item.dragOffset.y);
        draw();
    }
    function mouseMove(e) {
        e.preventDefault();
        e.stopPropagation();
        const canvas = document.getElementById('topology_canvas');
        const BB = canvas.getBoundingClientRect();
        const offsetX = BB.left;
        const offsetY = BB.top;
        var mx = parseInt(e.clientX - offsetX);
        var my = parseInt(e.clientY - offsetY);
        if (topology.drag) {
            return drag({ item: topology.drag, x: mx, y: my });
        }
        let found = null;
        for (let key in topology.items) {
            const item = topology.items[key];
            item.hovered = false;
            if (mx > item.x && mx < item.x2 && my > item.y && my < item.y2) {
                found = true;
                const tt = "Name:" + item.host.n + "\n" +
                    "Alias:" + item.host.a + "\n" +
                    "IP:" + item.host.ip + "\n" +
                    "Ping:" + item.host.p + "\n" +
                    "Probe:" + (item.host.pc ? "Connected" : "-");
                topology.tooltip = {
                    x: item.x2 + 5, y: item.y,
                    text: tt
                };
                found = item;
            }
        }
        if (!found) {
            topology.tooltip = null;
        }
        else {
            found.hovered = true;
        }
        draw();
    }
    function mouseUp(e) {
        e.preventDefault();
        e.stopPropagation();
        dragCompleted();
        topology.releaseItems();
    }
    function dragCompleted() {
        if (!topology.drag)
            return;
        if (fn.closed.current)
            return;
        Request.send({
            caller: fn,
            url: apiURL + "topology",
            params: { op: "drag",
                id: topology.drag.id,
                x: topology.drag.x,
                y: topology.drag.y
            },
            listener: (result) => {
                if (result.error) {
                    console.log("Error while dragging");
                }
                else {
                    const item = topology.items[result.id];
                    if (item) {
                        item.move(result.x, result.y);
                    }
                }
            }
        });
    }
    function draw() {
        const items = topology.items;
        const canvas = document.getElementById('topology_canvas');
        if (!canvas)
            return;
        const cH = canvas.height;
        const cW = canvas.width;
        const ctx = canvas.getContext('2d');
        ctx.clearRect(0, 0, cW, cH);
        ctx.font = ctx.font.replace(/\d+px/, "12px");
        const size = 100;
        for (let key in topology.connections) {
            const connection = topology.connections[key];
            const from = items[connection.from];
            const to = items[connection.to];
            if (!from || !to)
                continue;
            ctx.strokeStyle = "#00aa00";
            ctx.beginPath();
            ctx.moveTo(from.x + 50, from.y + 50);
            ctx.lineTo(to.x + 50, to.y + 50);
            ctx.stroke();
        }
        for (let key in items) {
            const item = items[key];
            const x = item.x;
            const y = item.y;
            const host = item.host;
            if (item.loader.loaded) {
                ctx.drawImage(item.loader.image, x, y, size, size);
            }
            const osImage = topology.osImage(host.os);
            if (osImage && osImage.loaded) {
                ctx.drawImage(osImage.image, x + 23, y + 40, 25, 25);
            }
            ctx.fillStyle = textColor;
            const txt = host.n;
            let tW = ctx.measureText(txt).width;
            const tX = (size - tW) / 2;
            ctx.fillText(txt, x + tX, y + size + 10);
            if (topology.tooltip && !topology.drag) {
                drawTooltip(ctx);
            }
            if (host.r) {
                ctx.fillStyle = "#00ff00";
            }
            else {
                ctx.fillStyle = "#ff0000";
            }
            ctx.beginPath();
            ctx.arc(x + size - 10, y + 10, 3, 0, 2 * Math.PI, false);
            ctx.fill();
            if (host.pc) {
                ctx.fillStyle = "#00ff00";
            }
            else {
                ctx.fillStyle = "#ff0000";
            }
            ctx.beginPath();
            ctx.arc(x + size - 10, y + 20, 3, 0, 2 * Math.PI, false);
            ctx.fill();
            if (item.hovered) {
                ctx.strokeStyle = "#676767";
                ctx.strokeRect(item.x, item.y, item.width, item.height);
            }
        }
    }
    function drawTooltip(ctx) {
        const tt = topology.tooltip;
        const txtTooltip = tt.text;
        const lines = txtTooltip.split(/\r?\n/);
        const th = 15;
        let maxW = 0;
        let tY = 20;
        const ttlist = [];
        for (let k = 0; k < lines.length; k++) {
            const line = lines[k];
            const tW = ctx.measureText(line).width;
            if (tW > maxW)
                maxW = tW;
            ttlist.push({ text: line, x: tt.x + 10, y: tt.y + tY });
            tY += th;
        }
        ctx.fillStyle = "#dedede";
        ctx.fillRect(tt.x, tt.y, maxW + 20, tY - 5);
        ctx.fillStyle = "#343434";
        for (let k = 0; k < ttlist.length; k++) {
            const txt = ttlist[k];
            ctx.fillText(txt.text, txt.x, txt.y);
        }
    }
    draw();
    return (React.createElement("div", { id: 'page' },
        React.createElement(Header, { back: back, title: t("Network Map") }),
        React.createElement("div", { className: "update_animation_box" }, refreshing && Utils.updating()),
        error && Utils.error(error),
        React.createElement("canvas", { ref: canvasDOMGraph, id: 'topology_canvas', width: "2000", height: "2000" })));
};
const UnitCPUMemoryDetails = (props) => {
    const fn = { closed: useRef(false) };
    const hostID = props.match.params.id;
    const [host, setHost] = useState({ id: hostID, machine: 1 });
    function cleanUp() {
        fn.closed.current = true;
    }
    useEffect(() => { loadData(); return cleanUp; }, [hostID]);
    function loadData() {
        if (fn.closed.current)
            return;
        let pdo = Utils.postDataOptions({ hostid: hostID, op: "get" });
        fetch(apiURL + "hosts", pdo).then(res => res.json()).then((result) => {
            Utils.setState(fn, setHost, result);
        }, (error) => {
            Utils.setState(fn, setHost, { success: false, error: error.message });
        });
    }
    function back() { cleanUp(); Utils.goBack(props.history, "/#"); }
    const title = host ? (host["name"] + " " + host["alias"] + " " + host["ip"]) : "";
    return (React.createElement("div", { id: 'page' },
        React.createElement(Header, { back: back, title: t("CPU") + " " + title }),
        host && !host.success && React.createElement("div", null, "Utils.error(host.error)"),
        React.createElement(CPUMemoryDetails, { id: hostID }),
        React.createElement(CPUMemoryHistoryGraph, { hostID: hostID })));
};
const UnitDetails = (props) => {
    const unitID = props.match.params.id;
    const [host, setHost] = useState({ id: unitID, machine: 1 });
    const [ping, setPing] = useState(null);
    const [error, setError] = useState(null);
    const fn = { closed: useRef(false) };
    const timeoutID = "unitdetails";
    function cleanUp() {
        Debugger.print("UnitDetails.cleanup");
        fn.closed.current = true;
        Timeouts.clearAll(timeoutID);
    }
    useEffect(() => {
        fn.closed.current = false;
        loadData();
        return cleanUp;
    }, [unitID]);
    function loadData() {
        if (fn.closed.current)
            return;
        let pdo = Utils.postDataOptions({ op: "get", hostid: unitID });
        fetch(apiURL + "hosts", pdo).then(res => res.json()).then((result) => {
            if (result.success) {
                Utils.setState(fn, setError, null);
                Utils.setState(fn, setHost, result);
                fn.sendPingRequest();
            }
            else if (result.removed) {
                Utils.setState(fn, setError, Utils.error("Host is removed"));
            }
            else {
                Utils.setState(fn, setError, result.error);
            }
        }, (error) => {
            Utils.setState(fn, setError, Utils.error(error.message));
        });
    }
    fn.sendPingRequest = function () {
        if (fn.closed.current)
            return;
        Timeouts.clearAll(timeoutID);
        let pdo = Utils.postDataOptions({ op: "ping", id: unitID });
        fetch(apiURL + "unit", pdo).then(res => res.json()).then((result) => {
            if (result.success) {
                Utils.setState(fn, setPing, result);
            }
            else {
                Utils.setState(fn, setPing, null);
            }
        }, (error) => {
            Utils.setState(fn, setPing, null);
            console.log(error.message);
        }).then(() => {
            if (fn.closed.current)
                return;
            Timeouts.add(timeoutID, setTimeout(fn.sendPingRequest, 2000));
        });
    };
    function tabClicked(tab) {
        Debugger.print("UnitDetails.tabClicked:" + tab);
    }
    ;
    function back() { cleanUp(); Utils.goBack(props.history, "/#"); }
    function CPUDetails(e) {
        console.log("CPUMemory clicked");
        e.preventDefault();
        const id = e.currentTarget.getAttribute('unitid');
        props.history.push({
            pathname: '#unit-cpu-details/' + id,
            state: { from: props.location.pathname }
        });
    }
    function graphs() {
        if (fn.closed.current)
            return;
        const cpu = ping && ping.cpu || 0;
        const memory = ping && ping.memory || 0;
        return React.createElement("div", null,
            React.createElement("a", { href: "/#unit-cpu-details/" + unitID },
                React.createElement(ProgressBar, { id: "pb_cpu_" + unitID, data: { value: cpu, name: "CPU", title: "Click to see details", mid: 30, high: 60, height: 20 } })),
            React.createElement("a", { href: "/#unit-cpu-details/" + unitID },
                React.createElement(ProgressBar, { id: "pb_ram_" + unitID, data: { value: memory, name: "Memory", title: "Click to see details", mid: 80, high: 90, height: 20 } })));
    }
    if (error) {
        return error;
    }
    const probeConnected = ping && ping.probeConnected;
    const reachable = ping && ping.reachable;
    const pingTitle = t(reachable ? "Ping " + ping.ping + " ms" : "Not reachable") + "\n" + t("Click to see history");
    const pingBox = React.createElement("a", { href: "#/availability-history/" + AvailabilityType.HOST_PING + "/" + unitID, title: pingTitle, title: pingTitle, style: { fontSize: "12px" } },
        React.createElement("div", { style: { background: reachable ? Colors.green : Colors.red,
                width: "22px", height: "22px", float: "right", color: "black",
                paddingTop: "6px",
                textAlign: "center"
            } }, ping && ping.ping));
    const probeBox = React.createElement("div", { title: t(probeConnected ? "Probe is connected" : "Probe is not connected"), style: { background: probeConnected ? Colors.green : Colors.red,
            width: "22px", height: "22px", float: "right", fontSize: "12px", color: "black",
            paddingTop: "6px",
            marginLeft: "5px",
            textAlign: "center"
        } });
    const isDevice = host["machine"] == 3;
    return (React.createElement("div", { id: 'page' },
        React.createElement(Header, { back: back, title: t("Host Details") + " [" + host.name + " - " + host.alias + "]" },
            probeBox,
            "  ",
            pingBox),
        React.createElement("div", { className: "clear" }),
        React.createElement("div", null,
            graphs(),
            React.createElement("div", { className: "clear" }),
            React.createElement(Tabs, { default: null, id: "tabs_host_details", key: 'tabs_host_details_' + unitID, listener: tabClicked },
                React.createElement(Tab, { key: 'system', name: 'system', label: 'System' },
                    "   ",
                    React.createElement(HostInformation, { hostID: unitID }),
                    "                    "),
                probeConnected && React.createElement(Tab, { key: 'hardware', name: 'hardware', label: 'Hardware' },
                    "     ",
                    React.createElement(HostHardwareInformation, { hostID: unitID }),
                    "     "),
                !isDevice && React.createElement(Tab, { key: 'disks', name: 'disks', label: 'Disks' },
                    "                    ",
                    React.createElement(HostDisks, { hostID: unitID }),
                    "             "),
                !isDevice && React.createElement(Tab, { key: 'processes', name: 'processes', label: 'Processes' },
                    "  ",
                    React.createElement(HostProcesses, { hostID: unitID }),
                    "               "),
                probeConnected && React.createElement(Tab, { key: 'services', name: 'services', label: 'Services' },
                    "     ",
                    React.createElement(HostServices, { hostID: unitID }),
                    "                "),
                probeConnected && host && host.ostype == OSType.Windows && React.createElement(Tab, { key: 'eventviewer', name: 'eventviewer', label: 'Events' },
                    React.createElement(HostEvents, { hostID: unitID })),
                probeConnected && host && host.ostype == OSType.Windows && React.createElement(Tab, { key: 'taskscheduler', name: 'taskscheduler', label: 'Tasks' },
                    React.createElement(ScheduledTasks, { hostID: unitID })),
                probeConnected && React.createElement(Tab, { key: 'connections', name: 'connections', label: 'Connections' },
                    "     ",
                    React.createElement(HostConnections, { hostID: unitID }),
                    "       "),
                React.createElement(Tab, { key: 'availaibility', name: 'availibility', label: 'Availibility' },
                    React.createElement("div", { style: { height: "400px" } },
                        React.createElement(AvailabilityGroup, { key: "agroup_" + unitID, id: unitID, type: AvailabilityType.HOST_PING, height: "300" }))),
                host.programs && React.createElement(Tab, { key: 'hostapplications', name: 'hostapplications', label: 'Applications' },
                    "            ",
                    React.createElement(HostApplications, { hostID: unitID }),
                    "  "),
                probeConnected && host.hassap && React.createElement(Tab, { key: 'r3trans', name: 'r3trans', label: 'R3Trans' },
                    "       ",
                    React.createElement(R3TransGraph, { hostID: unitID }),
                    " "),
                React.createElement(Tab, { key: 'ports', name: 'ports', label: 'Ports' },
                    "       ",
                    React.createElement(HostPorts, { hostID: unitID }),
                    " "),
                User.admin && React.createElement(Tab, { key: 'hostoptions', name: 'hostoptions', label: 'Options' },
                    "            ",
                    React.createElement(HostOptions, { id: unitID }))))));
};
const AddInstance = (props) => {
    const url = apiURL + "instances";
    const [errors, setErrors] = useState({});
    const [error, setError] = useState(null);
    const required = ["nr"];
    const fn = { exited: false };
    const hostID = props.match.params.id;
    const SID = props.match.params.sid;
    const hostName = props.match.params.host;
    const [fields, setFields] = useState({ nr: "", name: "", sid: SID });
    function cleanUp() {
        fn.exited = true;
    }
    function getForm() {
        return React.createElement("div", null,
            React.createElement("div", { className: "col-md-6" },
                React.createElement("fieldset", null,
                    React.createElement("table", { className: "nobordertable" },
                        React.createElement("tbody", null,
                            React.createElement("tr", null,
                                React.createElement("td", null, t("SID")),
                                React.createElement("td", null, Data.systemCode(SID)),
                                React.createElement("td", { style: { color: "red" } }, t(errors["sid"]))),
                            React.createElement("tr", null,
                                React.createElement("td", null, t("Host")),
                                React.createElement("td", null, hostName),
                                React.createElement("td", { style: { color: "red" } })),
                            React.createElement("tr", null,
                                React.createElement("td", null, t("Instance number")),
                                React.createElement("td", null,
                                    React.createElement("input", { type: "text", size: "30", placeholder: t("Instance number"), field: "nr", onChange: handleChange, value: fields["nr"] })),
                                React.createElement("td", { style: { color: "red" } }, t(errors["nr"]))),
                            React.createElement("tr", null,
                                React.createElement("td", null, t("Description")),
                                React.createElement("td", null,
                                    React.createElement("input", { type: "text", size: "30", placeholder: t("Description"), field: "name", onChange: handleChange, value: fields["name"] })),
                                React.createElement("td", { style: { color: "red" } }, t(errors["name"])))))),
                React.createElement("div", { className: "space40" }),
                React.createElement("fieldset", null,
                    React.createElement("button", { className: "btn btn-lg pro", id: "submit", value: "Submit", onClick: submit }, t("Add")),
                    React.createElement("button", { className: "btn btn-lg pro", onClick: back }, t("Cancel")))));
    }
    function handleValidation() {
        const errors = {};
        let formIsValid = true;
        for (let i = 0; i < required.length; i++) {
            const field = required[i];
            if (!fields[field] || fields[field].length < 1) {
                formIsValid = false;
                errors[field] = "Required field";
            }
        }
        setErrors(errors);
        return formIsValid;
    }
    function back(e) {
        e.preventDefault();
        cleanUp();
        Utils.goBack(props.history);
    }
    function submit() {
        if (!handleValidation())
            return;
        const options = Object.assign(Object.assign({}, fields), { op: "add", "hostid": hostID, sid: SID });
        const pdo = Utils.postDataOptions(options);
        fetch(url, pdo)
            .then(response => response.json())
            .then((result) => {
            console.log(result);
            if (result.success) {
                Call.refresh();
                const url = "/instance/" + result.id;
                return Utils.go(props.history, url);
            }
            if (result.error) {
                Utils.setState(fn, setError, result.error);
                if (result.field) {
                    Utis.setState(fn, setErrors, { [result.field]: result.error });
                }
            }
        }, (error) => {
            Utils.setState(fn, setError, error.message);
        });
    }
    function handleChange(e) {
        const field = e.currentTarget.getAttribute('field');
        const value = e.target.type === "checkbox" ? e.target.checked : e.target.value;
        Utils.setState(fn, setFields, Object.assign(Object.assign({}, fields), { [field]: value }));
    }
    let status = null;
    if (error) {
        status = React.createElement("div", { style: { color: "red" } }, t(error));
    }
    return (React.createElement("div", { id: 'page' },
        React.createElement(Header, { back: back, title: t("Add instance") }),
        t("instance_number_description"),
        React.createElement("br", null),
        React.createElement("br", null),
        React.createElement("br", null),
        getForm(),
        status));
};
const Audit = (props) => {
    const [divDetails, setDivDetails] = useState(null);
    const [data, setData] = useState({ logs: [] });
    const [r, refresh] = useState(false);
    const fn = { closed: useRef(false) };
    const instanceID = props.instanceID;
    const [refDR] = useState({});
    let inputFolder = useRef();
    let inputMID = useRef();
    let inputUser = useRef();
    let inputProgram = useRef();
    let inputTerminal = useRef();
    let inputTransaction = useRef();
    const folder = Data.get("auditfolder");
    let refreshTimeout = 0;
    function cleanUp() {
        fn.closed.current = true;
        clearTimeout(refreshTimeout);
    }
    useEffect(() => { fn.closed.current = false; loadData(); return cleanUp; }, [instanceID]);
    Debugger.print("Folder1:" + folder);
    function loadData() {
        Data.set("auditfolder", "");
        Debugger.print("Load Data");
        if (fn.closed.current)
            return;
        Request.send({
            url: apiURL + "itemsettings",
            params: { op: "get",
                type: ItemType.INSTANCE,
                itemid: instanceID,
                key: "auditfolder"
            },
            caller: fn,
            success: (json) => {
                const dir = json.auditfolder;
                Data.set("auditfolder", dir);
                Utils.setState(fn, refresh, Utils.timeStamp());
                if (dir)
                    setTimeout(loadList, 100);
            }
        });
    }
    ;
    function loadList() {
        if (fn.closed.current)
            return;
        data.logs = [];
        Request.send({
            url: apiURL + "audit",
            params: {
                op: "listaudit",
                id: instanceID,
                folder: Data.get("auditfolder"),
                start: Number.MAX_SAFE_INTEGER,
                length: 500
            },
            caller: fn,
            listener: (json) => {
                Utils.setState(fn, setDivDetails, parse(json));
            }
        });
    }
    function logonType(value) {
        switch (value) {
            case "B": return "Background";
            case "D": return "Dialog";
        }
        return value;
    }
    function rowColor(row) {
        switch (row.s) {
            case 1: return null;
            case 2:
            case 3: return Colors.yellow;
            case 4:
            case 5: return Colors.orange;
            case 6:
            case 7: return Colors.red;
        }
        return Colors.gray;
    }
    function getMessage(m, p) {
        if (!p)
            return m;
        const parameters = p.split("&");
        if (parameters.length < 1)
            return m;
        m = m.replace("&A", parameters[0]);
        if (parameters.length > 1) {
            m = m.replace("&B", parameters[1]);
        }
        if (parameters.length > 2) {
            m = m.replace("&C", parameters[2]);
        }
        return m;
    }
    function loadTooltip(e, data) {
        Request.send({
            url: apiURL + "audit",
            params: { op: "definition", mid: data.m },
            success: (json) => {
                if (json.success && json.rows.length > 0) {
                    TT.show(Utils.nl2br(json.rows[0].description));
                }
            }
        });
    }
    TT.loader = loadTooltip;
    function parse(json) {
        if (!json.success)
            return Utils.error(json.error);
        for (let i = 0; i < json.logs.length; i++) {
            const log = json.logs[i];
            data.logs.push(log);
        }
        const logs = data.logs;
        for (let i = 0; i < logs.length; i++) {
            const log = logs[i];
            const key = log.m;
            const line = AuditErrors[key];
            log.mid = log.m;
            if (line) {
                log.mt = getMessage(line.m, log.r);
                log.s = line.s;
            }
            else {
                log.mt = key;
                log.s = 0;
            }
        }
        const tableData = {
            defaultSortField: "d",
            direction: "descending",
            id: "audittable",
            headers: [
                { name: "#", field: "index", number: true, noSort: true },
                { name: "Date", field: "d", width: "160px", format: Utils.timeSAP },
                { name: "ID", field: "m", colorRule: rowColor, tooltipLoader: loadTooltip },
                { name: "Message", field: "mt", noCrop: true },
                { name: "User", field: "u" },
                { name: "Program", field: "p" },
                { name: "Client", field: "c" },
                { name: "Transaction", field: "f" },
                { name: "Terminal", field: "t" },
                { name: "Logon", field: "l", format: logonType }
            ],
            rows: logs
        };
        let status = null;
        if (!json.completed && json.read != undefined && json.total) {
            const progress = (json.read / json.total) * 100;
            status = React.createElement(ProgressBar, { key: "search_progress_bar", id: 'search_progress_bar', data: {
                    name: "",
                    suffix: Utils.bytesToUnit(json.read) + " / " + Utils.bytesToUnit(json.total),
                    title: Utils.bytesToUnit(json.read) + " / " + Utils.bytesToUnit(json.total),
                    value: progress,
                    color1: "#398ab3",
                    color2: "#2a759c"
                } });
        }
        else {
            status = React.createElement("div", { style: { height: "34px" } },
                " ",
                t("Displaying {{count}} records", { "count": logs.length }),
                "  ",
                json.duration,
                " ms ");
        }
        return React.createElement("div", null,
            status,
            React.createElement(Table, { key: "auditlogtable", data: tableData }));
    }
    function updateFolder() {
        if (fn.closed.current)
            return;
        Request.send({ url: apiURL + "instances", params: { op: "putsetting", id: instanceID, key: "auditfolder", value: inputFolder.current.value }, caller: fn,
            success: (json) => {
                const dir = json.auditfolder;
                Data.set("auditfolder", dir);
                Utils.setState(fn, refresh, Utils.timeStamp());
                if (dir)
                    setTimeout(loadList, 100);
            }
        });
    }
    function listFiles() {
        const data = { name: "Audit File List", title: "Audit File List",
            content: React.createElement(AuditFileList, { folder: Data.get("auditfolder"), instanceID: instanceID }),
            render: true };
        Dialog.show(data);
    }
    function listMessages() {
        const data = { name: "Audit Messages", title: "Audit Messages",
            content: React.createElement(AuditErrorList, null),
            render: true };
        Dialog.show(data);
    }
    function showAlarms() {
        const data = { name: "Audit Alarms", title: "Audit Alarms",
            content: React.createElement(AuditAlarmList, { instanceID: instanceID }),
            render: true };
        Dialog.show(data);
    }
    function showIDFilterList() {
        const data = { name: "Audit ID Filters", title: "Audit ID Filters",
            content: React.createElement(AuditIDFilterList, { instanceID: instanceID, listener: idFilterListSelected }),
            render: true };
        Dialog.show(data);
    }
    function idFilterListSelected(list) {
        document.getElementById("input_mid").value = list;
        Dialog.close();
    }
    function search() {
        if (fn.closed.current)
            return;
        data.logs = [];
        Utils.setState(fn, setDivDetails, "Searching...");
        Request.send({
            url: apiURL + "audit",
            params: {
                op: "auditfilter",
                id: instanceID,
                folder: Data.get("auditfolder"),
                mid: inputMID.current.value,
                user: inputUser.current.value,
                program: inputProgram.current.value,
                terminal: inputTerminal.current.value,
                transaction: inputTransaction.current.value,
                starttime: refDR.startSAPDate(),
                endtime: refDR.endSAPDate()
            },
            caller: fn,
            listener: (json) => {
                if (json.success) {
                    setTimeout(getSearchResult, 200);
                }
                else {
                    Utils.setState(fn, setDivDetails, Utils.error(json.error));
                }
            }
        });
    }
    function dateSelected(component) {
        const start = component.startSAPDate();
        console.log("Selected:" + start);
    }
    function getSearchResult() {
        if (fn.closed.current)
            return;
        Request.send({
            url: apiURL + "audit",
            params: {
                op: "auditfilterresult",
                id: instanceID,
                folder: Data.get("auditfolder")
            },
            caller: fn,
            listener: (json) => {
                Utils.setState(fn, setDivDetails, parse(json));
                if (!json.completed) {
                    refreshTimeout = setTimeout(getSearchResult, 1000);
                }
            }
        });
    }
    const dStart = new Date();
    const dEnd = new Date();
    dStart.setDate(dStart.getDate() - 1);
    dStart.setHours(0);
    dStart.setMinutes(0);
    dEnd.setHours(24);
    dEnd.setMinutes(0);
    return (React.createElement("div", { id: 'panel_audit' },
        t("Folder"),
        ":",
        React.createElement("input", { type: "text", ref: inputFolder, defaultValue: folder }),
        User.admin &&
            React.createElement("img", { className: "imagebutton", type: "svg", height: "28", style: { lineHeight: "28px", verticalAlign: "middle" }, src: "/images/icons/save1.svg", onClick: updateFolder, title: t("Save") }),
        React.createElement("img", { className: "imagebutton", type: "svg", style: { marginLeft: "10px" }, src: "/images/icons/logs.svg", onClick: listFiles, title: t("File list") }),
        React.createElement("img", { className: "imagebutton", type: "svg", style: { float: "right" }, src: "/images/icons/ic_info_outline_24px.svg", onClick: listMessages, title: t("Message List") }),
        React.createElement("img", { className: "imagebutton", type: "svg", style: { float: "right", marginRight: "10px" }, src: "/images/icons/ic_add_alert_24px.svg", onClick: showAlarms, title: t("Set Alarm") }),
        React.createElement("div", null,
            t("Date"),
            React.createElement(DateTimeRange, { start: dStart, end: dEnd, fn: refDR, listener: dateSelected }),
            React.createElement("br", null),
            "ID:",
            React.createElement("input", { ref: inputMID, type: 'text', id: "input_mid" }),
            React.createElement("img", { className: "imagebutton", type: "svg", src: "/images/icons/add2.svg", onClick: showIDFilterList, title: t("ID Filter List") }),
            t("User"),
            ":",
            React.createElement("input", { ref: inputUser, type: 'text' }),
            t("Program"),
            ":",
            React.createElement("input", { ref: inputProgram, type: 'text' }),
            t("Transaction"),
            ":",
            React.createElement("input", { ref: inputTransaction, type: 'text' }),
            t("Terminal"),
            ":",
            React.createElement("input", { ref: inputTerminal, type: 'text' }),
            React.createElement("button", { onClick: search }, t("Search"))),
        React.createElement("br", null),
        divDetails));
};
const InstanceAuditPage = (props) => {
    const instanceID = props.match.params.iid;
    function back(e) {
        e.preventDefault();
        Utils.goBack(props.history, "/#instance/" + instanceID);
    }
    return (React.createElement("div", { id: 'page' },
        React.createElement(Header, { back: back, title: t("Instance security audit logs") }),
        React.createElement(Audit, { instanceID: instanceID })));
};
const AuditAlarms = {};
const AuditAlarmList = (props) => {
    const [r, refresh] = useState(false);
    const fn = { closed: useRef(false) };
    const instanceID = props.instanceID;
    function cleanUp() {
        fn.closed.current = true;
    }
    useEffect(() => { fn.closed.current = false; loadList(); return cleanUp; }, [instanceID]);
    function loadList() {
        if (fn.closed.current)
            return;
        AuditAlarms[instanceID] = {};
        Request.send({
            url: apiURL + "itemsettings",
            params: {
                op: "get",
                itemid: instanceID,
                type: ItemType.INSTANCE,
                key: "auditalarms"
            },
            caller: fn,
            listener: (json) => {
                parse(json);
            }
        });
    }
    function parse(json) {
        if (!json.success)
            return Info.error(json.error);
        const ids = json.auditalarms.split("-");
        for (let i = 0; i < ids.length; i++) {
            const mid = ids[i];
            if (mid.length < 3)
                continue;
            const alarm = { mid: mid, selected: true };
            AuditAlarms[instanceID][mid] = alarm;
        }
        Utils.setState(fn, refresh, Utils.timeStamp());
    }
    function severity(val) {
        return t(AuditErrorSeverity[val]);
    }
    function rowColor(row) {
        switch (row.s) {
            case 1: return Colors.green;
            case 2:
            case 3: return Colors.yellow;
            case 4:
            case 5: return Colors.orange;
            case 6:
            case 7: return Colors.red;
        }
        return Colors.gray;
    }
    function checkBoxClicked(e) {
        e.preventDefault();
        e.stopPropagation();
        const chk = e.currentTarget;
        const mid = chk.getAttribute('mid');
        if (chk.checked) {
            AuditAlarms[instanceID][mid] = { mid: mid };
        }
        else {
            delete AuditAlarms[instanceID][mid];
        }
        let list = "";
        const alarms = AuditAlarms[instanceID];
        for (var key in alarms) {
            if (!alarms.hasOwnProperty(key))
                continue;
            const alarm = alarms[key];
            if (!alarm || !alarm.mid || alarm.mid.length < 3)
                continue;
            list += alarm.mid + "-";
        }
        list = list.slice(0, -1);
        setAlarms(list);
        setTimeout(() => {
            Utils.setState(fn, refresh, Utils.timeStamp());
        }, 10);
    }
    function setAlarms(list) {
        if (fn.closed.current)
            return;
        Request.send({
            url: apiURL + "itemsettings",
            params: {
                op: "set",
                itemid: instanceID,
                type: ItemType.INSTANCE,
                key: "auditalarms",
                value: list
            },
            caller: fn,
            listener: (json) => {
                loadList();
            }
        });
    }
    function loadTooltip(e, data) {
        Request.send({
            url: apiURL + "audit",
            params: { op: "definition", mid: data.mid },
            success: (json) => {
                if (json.success && json.rows.length > 0) {
                    TT.show(Utils.nl2br(json.rows[0].description));
                }
            }
        });
    }
    TT.loader = loadTooltip;
    function getTable() {
        if (!AuditAlarms[instanceID])
            return;
        const messages = [];
        for (var mid in AuditErrors) {
            if (AuditErrors.hasOwnProperty(mid)) {
                if (mid == "ERR")
                    continue;
                const message = AuditErrors[mid];
                message.mid = mid;
                message.checked = AuditAlarms[instanceID][mid] ? 1 : 0;
                message.chk = React.createElement("input", { type: "checkbox", checked: message.checked, onChange: checkBoxClicked, mid: mid });
                message.selected = AuditAlarms[instanceID][mid] && AuditAlarms[instanceID][mid]["selected"] ? "Yes" : "";
                messages.push(message);
            }
        }
        messages.sort((a, b) => {
            const cmp = b.checked - a.checked;
            if (cmp != 0)
                return cmp;
            return (a.s == b.s) ? 0 : ((a.s < b.s) ? 1 : -1);
        });
        const tableData = {
            defaultSortField: "checked",
            direction: "descending",
            id: "table_audit_messages",
            nosorting: true,
            headers: [
                { name: "", field: "checked", html: "chk", width: "40px" },
                { name: "Selected", field: "selected", width: "40px" },
                { name: "ID", field: "mid", tooltipLoader: loadTooltip },
                { name: "Message", field: "m", noCrop: true },
                { name: "Severity", field: "s", format: severity, colorRule: rowColor }
            ],
            rows: messages
        };
        const table = React.createElement(Table, { data: tableData });
        return table;
    }
    return (React.createElement("div", { id: 'panel_audit_alarms' },
        React.createElement("div", null, "Please select audit log types from the following list if you want to get alerts."),
        getTable()));
};
const AuditErrorList = () => {
    function severity(val) {
        return t(AuditErrorSeverity[val]);
    }
    function rowColor(row) {
        switch (row.s) {
            case 1: return Colors.green;
            case 2:
            case 3: return Colors.yellow;
            case 4:
            case 5: return Colors.orange;
            case 6:
            case 7: return Colors.red;
        }
        return Colors.gray;
    }
    function loadTooltip(e, data) {
        if (!data || !data.mid)
            return;
        Request.send({
            url: apiURL + "audit",
            params: { op: "definition", mid: data.mid },
            success: (json) => {
                if (json.success && json.rows.length > 0) {
                    TT.show(Utils.nl2br(json.rows[0].description));
                }
            }
        });
    }
    TT.loader = loadTooltip;
    const messages = [];
    for (var mid in AuditErrors) {
        if (AuditErrors.hasOwnProperty(mid)) {
            if (mid == "ERR")
                continue;
            const message = AuditErrors[mid];
            message.mid = mid;
            messages.push(message);
        }
    }
    const tableData = {
        defaultSortField: "s",
        direction: "descending",
        id: "table_audit_messages",
        headers: [
            { name: "ID", field: "mid", tooltipLoader: loadTooltip },
            { name: "Message", field: "m", noCrop: true },
            { name: "Severity", field: "s", format: severity, colorRule: rowColor }
        ],
        rows: messages
    };
    const table = React.createElement(Table, { data: tableData });
    return (React.createElement("div", { id: 'panel_audit_messages' }, table));
};
const AuditErrorSeverity = {
    "1": "Non-Critical",
    "2": "Severe",
    "3": "Severe",
    "4": "Critical",
    "5": "Critical",
    "6": "Very Critical",
    "7": "Very Critical"
};
const AuditErrors = { AU1: { m: "Logon successful (type=&A, method=&C)", s: 2 },
    AU2: { m: "Logon failed (reason=&B, type=&A, method=&C)", s: 4 },
    AUC: { m: "User Logoff", s: 1 },
    AUM: { m: "User &B Locked in Client &A After Erroneous Password Checks", s: 5 },
    AUN: { m: "User &B in Client &A Unlocked After Being Locked Due to Inval.Password Entered", s: 4 },
    AUO: { m: "Logon Failed (Reason = &B, Type = &A)", s: 2 },
    BUD: { m: "WS: Delayed logon failed (type &B, WP &C). Refer to Web service log &A.", s: 4 },
    BUE: { m: "WS: Delayed logon successful (type &B, WP &C). Refer to Web service log &A.", s: 1 },
    BUI: { m: "SPNego replay attack detected (UPN=&A)", s: 4 },
    BUK: { m: "&A assertion used", s: 1 },
    BUL: { m: "&A: &B", s: 1 },
    BUM: { m: "Name ID of a subject", s: 1 },
    BUN: { m: "Attribute", s: 1 },
    BUO: { m: "Authentication assertion", s: 1 },
    BUP: { m: "&A", s: 1 },
    BUQ: { m: "Signed LogoutRequest accepted", s: 1 },
    BUR: { m: "Unsigned LogoutRequest accepted", s: 1 },
    CU2: { m: "OAuth 2.0: Invalid access token received (reason=&A)", s: 2 },
    CU3: { m: "OAuth 2.0: Insufficient OAuth 2.0 scope for requested resource (user=&A)", s: 2 },
    CU4: { m: "OAuth 2.0: Logged-on client user &A not same as parameter client ID &B", s: 4 },
    CU5: { m: "OAuth 2.0: Client &A requested invalid access grant type &B", s: 2 },
    CU6: { m: "OAuth 2.0: Client ID &A in SAML assertion not same as client ID &B in request", s: 4 },
    CU7: { m: "OAuth 2.0: Scope &B not permitted for client &C, user &D (cause=&A)", s: 2 },
    CU8: { m: "OAuth 2.0: Access token issued (client=&A, user=&B, grant type=&C)", s: 1 },
    CU9: { m: "OAuth 2.0: Valid access token received for user &A", s: 1 },
    CUA: { m: "Rejected Assertion", s: 2 },
    CUB: { m: "&A: &B", s: 2 },
    CUC: { m: "&A", s: 2 },
    CUD: { m: "Name ID of a subject", s: 2 },
    CUE: { m: "Attribute", s: 2 },
    CUF: { m: "Authentication Assertion", s: 2 },
    CUG: { m: "Signed LogoutRequest rejected", s: 2 },
    CUH: { m: "Unsigned LogoutRequest rejected", s: 2 },
    DU0: { m: "Invalid SAP GUI data", s: 5 },
    EUC: { m: "OAuth scope &A not assigned to the user", s: 4 },
    EUD: { m: "HTTP request not received from trustworthy cloud connector (reason &A)", s: 4 },
    AU5: { m: "RFC/CPIC logon successful (type=&A, method=&C)", s: 1 },
    AU6: { m: "RFC/CPIC logon failed, reason=&B, type=&A, method=&C", s: 4 },
    AUK: { m: "Successful RFC Call &C (Function Group = &A)", s: 1 },
    AUL: { m: "Failed RFC Call &C (Function Group = &A)", s: 4 },
    CUV: { m: "Successful WS Call (service = &A, operation &B)", s: 1 },
    CUW: { m: "Failed Web service call (service = &A, operation = &B, reason = &C)", s: 4 },
    CUZ: { m: "Generic table access by RFC to &A with activity &B", s: 4 },
    DU1: { m: "FTP server whitelist is empty", s: 2 },
    DU2: { m: "FTP server whitelist is non-secure due to use of placeholders", s: 2 },
    DU3: { m: "Server &A is not contained in the whitelist", s: 4 },
    DU4: { m: "Connection to server &A failed", s: 4 },
    DU5: { m: "There is no logical file name for path &A", s: 4 },
    DU6: { m: "Validation for &A successful", s: 1 },
    DU7: { m: "Validation for &A failed", s: 5 },
    DU8: { m: "FTP connection request for server &A successful", s: 1 },
    DUI: { m: "RFC callback performed (destination &A, called &B, callback &C)", s: 1 },
    DUJ: { m: "RFC callback rejected (destination &A, called &B, callback &C)", s: 4 },
    DUK: { m: "RFC callback in simulation mode (destination &A, called &B, callback &C)", s: 4 },
    DUR: { m: "JSON RPC call of function module &A succeeded", s: 1 },
    DUS: { m: "JSON RPC call of function module &A failed", s: 1 },
    DUT: { m: "Critical JSON RPC call of function module &A (S_RFC * authorization)", s: 4 },
    EUE: { m: "RFC function module &A called successfully", s: 1 },
    EUF: { m: "Could not call RFC function module &A", s: 1 },
    EUG: { m: "User does not have authorization to run RFC function module &A", s: 1 },
    EUI: { m: "Setup of UCON HTTP whitelist changed", s: 2 },
    EUJ: { m: "Phase of UCON HTTP whitelist of context type &A changed", s: 2 },
    EUK: { m: "Access to UCON HTTP whitelist of context type &A was refused", s: 4 },
    EUL: { m: "Setting of content security policy whitelist for type &A changed", s: 2 },
    EUM: { m: "Content security policy whitelist of context type &A changed", s: 2 },
    EUN: { m: "Content security policy of CSP type &A violated", s: 4 },
    EUO: { m: "UCON HTTP whitelist of context type &A was changed", s: 2 },
    FU1: { m: "RFC function &B with dynamic destination &C was called in program &A", s: 1 },
    AU3: { m: "Transaction &A Started", s: 1 },
    AU4: { m: "Start of transaction &A failed (Reason=&B)", s: 4 },
    AUP: { m: "Transaction &A Locked", s: 2 },
    AUQ: { m: "Transaction &A Unlocked", s: 2 },
    BUX: { m: "Test message", s: 2 },
    CUI: { m: "Application &A started", s: 1 },
    CUJ: { m: "Failed to start application &A (reason =&B)", s: 4 },
    DU9: { m: "Generic table access call to &A with activity &B (auth. check: &C )", s: 1 },
    EUA: { m: "S/2 Cloud SDK ABAP component called", s: 1 },
    AUW: { m: "Report &A Started", s: 1 },
    AUX: { m: "Start Report &A Failed (Reason = &B)", s: 2 },
    EUP: { m: "Virtual user client=&A type=&B action=&C &D", s: 4 },
    EUQ: { m: "Analysis program &A &B was started in simulation mode", s: 2 },
    EUR: { m: "Analysis program &A &B was started in production mode", s: 4 },
    AU7: { m: "User &A Created", s: 4 },
    AU8: { m: "User &A Deleted", s: 2 },
    AU9: { m: "User &A Locked", s: 2 },
    AUA: { m: "User &A Unlocked", s: 2 },
    AUB: { m: "Authorizations for User &A Changed", s: 2 },
    AUD: { m: "User Master Record &A Changed", s: 2 },
    AUR: { m: "&A &B Created", s: 2 },
    AUS: { m: "&A &B Deleted", s: 2 },
    AUT: { m: "&A &B Changed", s: 2 },
    AUU: { m: "&A &B Activated", s: 4 },
    BU2: { m: "Password changed for user &B in client &A", s: 1 },
    BUV: { m: "Invalid hash value &A. The context contains &B.", s: 4 },
    BUW: { m: "A refresh token issued to client &A was used by client &B.", s: 4 },
    DUH: { m: "OAuth 2.0: Token declared invalid (OAuth client=&A, user=&B, token type=&C)", s: 3 },
    EUH: { m: "Authorizations of user &A for authorization object &B detected", s: 1 },
    FU8: { m: "Lock entry deleted for user &A", s: 2 },
    AU0: { m: "Audit � Test. Text: &A", s: 1 },
    AUV: { m: "Digital Signature Error (Reason = &A, ID = &B)", s: 4 },
    AUY: { m: "Download &A Bytes to File &C", s: 2 },
    AUZ: { m: "Digital Signature (Reason = &A, ID = &B)", s: 2 },
    BU0: { m: "RAL configuration access: Action: &A, type: &B, name &C", s: 5 },
    BU1: { m: "Password check failed for user &B in client &A", s: 5 },
    BU3: { m: "Security check changed in export: Old value &A, new value &B", s: 5 },
    BU4: { m: "Dynamic ABAP code: Event &A, event type &B, check total &C", s: 1 },
    BU5: { m: "ICF recorder entry executed for user &A (activity &B)", s: 2 },
    BU6: { m: "ICF recorder entry executed by user &A (&B, &C) (activity &D).", s: 2 },
    BU7: { m: "Administration setting was changed for ICF Recorder (Activity: &A)", s: 2 },
    BU8: { m: "Virus Scan Interface: Virus �&C� found by profile &A (step &B)", s: 4 },
    BU9: { m: "Virus Scan Interface: Error �&C� occurred in profile &A (step &B)", s: 2 },
    BUA: { m: "WS: Signature check error (reason &B, WP &C). Refer to Web service log &A.", s: 2 },
    BUB: { m: "WS: Signature insufficient (WP &C). Refer to Web service log &A.", s: 2 },
    BUC: { m: "WS: Time stamp is invalid. Refer to Web service log &A.", s: 2 },
    BUF: { m: "HTTP Security Session Management was activated for client &A.", s: 1 },
    BUG: { m: "HTTP Security Session Management was deactivated for client &A.", s: 5 },
    BUH: { m: "HTTP Security Session of user &A (client &B) was hard exited", s: 3 },
    BUJ: { m: "Non-encrypted &A communication (&B)", s: 2 },
    BUS: { m: "&A: Request without sufficient security characteristic of address &B.", s: 4 },
    BUT: { m: "CRL download failed with error code &A", s: 2 },
    BUU: { m: "Certificate check for subject �&A� with profile &B failed (status &C)", s: 4 },
    BUY: { m: "Field contents changed: &5&9&9&9&9&9", s: 4 },
    BUZ: { m: "> in program &A, line &B, event &C", s: 6 },
    CU0: { m: "RAL Log Access: Action: &A", s: 4 },
    CU1: { m: "CU Test Message", s: 2 },
    CUK: { m: "C debugging activated", s: 4 },
    CUL: { m: "Field content changed: &A", s: 6 },
    CU_M: { m: "Jump to ABAP Debugger: &A", s: 6 },
    CUM: { m: "Jump to ABAP Debugger: &A", s: 6 },
    CUN: { m: "A manually caught process was stopped from within the Debugger (&A)", s: 6 },
    CUO: { m: "Explicit database commit or rollback from debugger &A", s: 6 },
    CUP: { m: "Non-exclusive debugging session started", s: 6 },
    CUQ: { m: "Logical file name &A not configured. Physical file name &B not checked.", s: 2 },
    CUR: { m: "Physical file name &B does not fulfill requirements from logical file name &A", s: 2 },
    CUS: { m: "Logical file name &B is not a valid alias for logical file name &A", s: 2 },
    CUT: { m: "Validation for logical file name &A is not active", s: 2 },
    CUU: { m: "Payload of PI/WS message &A was read | &B", s: 1 },
    CUX: { m: "Payload of postprocessing request &A read", s: 1 },
    CUY: { m: "> &A", s: 1 },
    DUA: { m: "EHS-SADM: Service &A created on host &B", s: 2 },
    DUB: { m: "EHS-SADM: Service &A started on host &B", s: 2 },
    DUC: { m: "EHS-SADM: Service &A ended on host &B", s: 2 },
    DUD: { m: "EHS-SADM: Service &A deleted on host &B", s: 2 },
    DUE: { m: "EHS-SADM: Configuration of service &A changed on host &B", s: 1 },
    DUF: { m: "EHS-SADM: File &A transferred from host &B", s: 1 },
    DUG: { m: "EHS-SADM: File &A transferred to host &B", s: 1 },
    DUL: { m: "Check for &A in whitelist &B was successful", s: 1 },
    DUM: { m: "Check for &A in whitelist &B failed", s: 3 },
    DUN: { m: "Active whitelist &A changed ( &B )", s: 5 },
    DUO: { m: "Authorization check for object &A in scenario &B successful", s: 1 },
    DUP: { m: "Authorization check for object &A in scenario &B failed", s: 1 },
    DUQ: { m: "Active scenario &A for switchable authorization checks changed � &B", s: 5 },
    DUU: { m: "Authorization check for user &C on object &A in scenario &B successful", s: 1 },
    DUV: { m: "Authorization check for user &C on object &A in scenario &B failed", s: 1 },
    DUW: { m: "Data target accessed in BW &A", s: 1 },
    DUX: { m: "TEMP: Customer-specific event DUX &A &B &C &D", s: 1 },
    DUY: { m: "TEMP: Customer-specific event DUY &A &B &C &D", s: 1 },
    DUZ: { m: "TEMP: Customer-specific event DUZ &A &B &C &D", s: 1 },
    EU0: { m: "Test Message for Class EU", s: 1 },
    EU3: { m: "&A change documents deleted without archiving (&B)", s: 4 },
    EU4: { m: "Validation successful for logical file name &A (physical: &B)", s: 1 },
    EUB: { m: "Could not verify the digital signature: &A", s: 4 },
    EUS: { m: "Read access to DCT change log (&A)", s: 2 },
    EUT: { m: "DCT change log (&A) was reorganized", s: 2 },
    EUU: { m: "Suspect WHERE-Clause during generic table access to table &A (Clause &B)", s: 4 },
    EUV: { m: "CDS view &A (field &B) was published", s: 1 },
    EUW: { m: "Blocklist is activated (connection/table/field: &A &B &C)", s: 1 },
    EUX: { m: "Blocklist is deactivated (connection/table/field: &A &B &C)", s: 1 },
    EUY: { m: "Data blocking activated for &A", s: 1 },
    EUZ: { m: "Data blocking deactivated for &A", s: 1 },
    FU2: { m: "Parsing of an XML data stream canceled for security reasons (reason = &A)", s: 2 },
    FU3: { m: "Template &A (&B) loaded", s: 1 },
    FU4: { m: "Could not upload enhancement template &A", s: 2 },
    FUA: { m: "Audit alert: &A | &B &C &D", s: 4 },
    FUC: { m: "Attempted read on output document &A for object &B ( &C )", s: 1 },
    FUD: { m: "Successful read on output document &A for object &B ( &C )", s: 1 },
    FUE: { m: "Failed read on output document &A for object &B ( &C )", s: 4 },
    AUE: { m: "Audit Configuration Changed", s: 6 },
    AUF: { m: "Audit: Slot &A: Class &B, Severity &C, User &D, Client &E, &F", s: 6 },
    AUG: { m: "Application Server Started", s: 6 },
    AUH: { m: "Application Server Stopped", s: 6 },
    AUI: { m: "Audit: Slot &A Inactive", s: 6 },
    AUJ: { m: "Audit: Active Status Set to &1", s: 7 },
    EU1: { m: "System changeability changed (&A to &B)", s: 6 },
    EU2: { m: "Client setting for &A changed (&B)", s: 6 },
    EU5: { m: "Audit log data of &A was deleted (&B data records)", s: 1 },
    EU6: { m: "SAL log file &A passed to table &B (records: &C/reason: &D)", s: 1 },
    FU0: { m: "Exclusive security audit log medium changed (new status &1)", s: 6 },
    FUB: { m: "TEMP: Customer-specific event FUB &A &B &C &D", s: 4 },
    ERR: { m: "ERROR:&A", s: 7 }
};
const AuditFileList = (props) => {
    const [divDetails, setDivDetails] = useState(null);
    const [refreshing, setRefreshing] = useState(false);
    const fn = { closed: useRef(false) };
    const instanceID = props.instanceID;
    const folder = props.folder;
    let refreshTimeout = 0;
    function cleanUp() {
        fn.closed.current = true;
        clearTimeout(refreshTimeout);
    }
    useEffect(() => { fn.closed.current = false; loadList(); return cleanUp; }, [instanceID]);
    function loadList() {
        if (fn.closed.current)
            return;
        Utils.setState(fn, setRefreshing, true);
        Request.send({
            url: apiURL + "audit",
            params: {
                op: "listauditfiles",
                id: instanceID,
                folder: Data.get("auditfolder"),
                start: 10000,
                length: 100
            },
            caller: fn,
            listener: (json) => Utils.setState(fn, setDivDetails, parse(json)),
            then: () => {
                setTimeout(() => Utils.setState(fn, setRefreshing, false), 1000);
                refreshTimeout = setTimeout(loadList, 10000);
            }
        });
    }
    function parse(json) {
        if (!json.success)
            return Utils.error(json.error);
        const files = json.files;
        const tableData = {
            defaultSortField: "d",
            direction: "descending",
            id: "table_audit_files",
            headers: [
                { name: "Name", field: "n" },
                { name: "Date", field: "d", width: "160px", format: Utils.daySAP },
                { name: "Size", field: "s", format: Utils.bytesToUnit }
            ],
            rows: files
        };
        return React.createElement(Table, { data: tableData });
    }
    return (React.createElement("div", { id: 'panel_audit_files' },
        "Folder:",
        folder,
        " ",
        React.createElement("br", null),
        React.createElement("div", { className: "update_animation_box" }, refreshing && Utils.updating()),
        divDetails));
};
const AuditIDFilters = {};
const AuditIDFilterList = (props) => {
    const [r, refresh] = useState(false);
    const fn = { closed: useRef(false) };
    const instanceID = props.instanceID;
    function cleanUp() {
        fn.closed.current = true;
        console.log("AuditIDfilterList.cleanUp");
    }
    useEffect(() => { fn.closed.current = false; loadList(); return cleanUp; }, [instanceID]);
    function loadList() {
        if (fn.closed.current)
            return;
        AuditIDFilters[instanceID] = {};
        Request.send({
            url: apiURL + "itemsettings",
            params: {
                op: "get",
                itemid: instanceID,
                type: ItemType.INSTANCE,
                key: "auditidfilters"
            },
            caller: fn,
            listener: (json) => {
                parse(json);
            }
        });
    }
    function parse(json) {
        if (!json.success)
            return Info.error(json.error);
        const ids = json.auditidfilters.split("-");
        for (let i = 0; i < ids.length; i++) {
            const mid = ids[i];
            if (mid.length < 3)
                continue;
            const filter = { mid: mid, selected: true };
            AuditIDFilters[instanceID][mid] = filter;
        }
        Utils.setState(fn, refresh, Utils.timeStamp());
    }
    function severity(val) {
        return t(AuditErrorSeverity[val]);
    }
    function rowColor(row) {
        switch (row.s) {
            case 1: return Colors.green;
            case 2:
            case 3: return Colors.yellow;
            case 4:
            case 5: return Colors.orange;
            case 6:
            case 7: return Colors.red;
        }
        return Colors.gray;
    }
    function checkBoxClicked(e) {
        e.preventDefault();
        e.stopPropagation();
        const chk = e.currentTarget;
        const mid = chk.getAttribute('mid');
        if (chk.checked) {
            AuditIDFilters[instanceID][mid] = { mid: mid };
        }
        else {
            delete AuditIDFilters[instanceID][mid];
        }
        let list = "";
        const filters = AuditIDFilters[instanceID];
        for (var key in filters) {
            if (!filters.hasOwnProperty(key))
                continue;
            const filter = filters[key];
            if (!filter || !filter.mid || filter.mid.length < 3)
                continue;
            list += filter.mid + "-";
        }
        list = list.slice(0, -1);
        setFilters(list);
        setTimeout(() => {
            Utils.setState(fn, refresh, Utils.timeStamp());
        }, 10);
    }
    function select(e) {
        e.preventDefault();
        e.stopPropagation();
        let list = "";
        const filters = AuditIDFilters[instanceID];
        for (var key in filters) {
            if (!filters.hasOwnProperty(key))
                continue;
            const filter = filters[key];
            if (!filter || !filter.mid || filter.mid.length < 3)
                continue;
            list += filter.mid + ",";
        }
        list = list.slice(0, -1);
        props.listener(list);
    }
    function setFilters(list) {
        if (fn.closed.current)
            return;
        Request.send({
            url: apiURL + "itemsettings",
            params: {
                op: "set",
                itemid: instanceID,
                type: ItemType.INSTANCE,
                key: "auditidfilters",
                value: list
            },
            caller: fn,
            listener: (json) => {
                loadList();
            }
        });
    }
    function loadTooltip(e, data) {
        Request.send({
            url: apiURL + "audit",
            params: { op: "definition", mid: data.mid },
            success: (json) => {
                if (json.success && json.rows.length > 0) {
                    TT.show(Utils.nl2br(json.rows[0].description));
                }
            }
        });
    }
    TT.loader = loadTooltip;
    function getTable() {
        if (!AuditIDFilters[instanceID])
            return;
        const messages = [];
        for (var mid in AuditErrors) {
            if (AuditErrors.hasOwnProperty(mid)) {
                if (mid == "ERR")
                    continue;
                const message = AuditErrors[mid];
                message.mid = mid;
                message.checked = AuditIDFilters[instanceID][mid] ? 1 : 0;
                message.chk = React.createElement("input", { type: "checkbox", checked: message.checked, onChange: checkBoxClicked, mid: mid });
                message.selected = AuditIDFilters[instanceID][mid] && AuditIDFilters[instanceID][mid]["selected"] ? "Yes" : "";
                messages.push(message);
            }
        }
        messages.sort((a, b) => {
            const cmp = b.checked - a.checked;
            if (cmp != 0)
                return cmp;
            return (a.s == b.s) ? 0 : ((a.s < b.s) ? 1 : -1);
        });
        const tableData = {
            defaultSortField: "checked",
            direction: "descending",
            id: "table_audit_id_filters",
            nosorting: true,
            headers: [
                { name: "", field: "checked", html: "chk", width: "40px" },
                { name: "Selected", field: "selected", width: "40px" },
                { name: "ID", field: "mid", tooltipLoader: loadTooltip },
                { name: "Message", field: "m", noCrop: true },
                { name: "Severity", field: "s", format: severity, colorRule: rowColor }
            ],
            rows: messages
        };
        const table = React.createElement(Table, { data: tableData });
        const div = React.createElement("div", { style: { height: "100%", position: "absolute", width: "100%" } },
            React.createElement("div", { style: { height: "calc(100% - 100px)", overflow: "auto" } }, table),
            React.createElement("button", { onClick: select }, " Select "));
        return div;
    }
    return (React.createElement("div", { id: 'panel_audit_id_filters' }, getTable()));
};
const InstanceABAPWPTablePage = (props) => {
    const instanceID = props.match.params.id;
    const fn = { exited: false };
    function cleanUp() {
        fn.exited = true;
    }
    function back(e) {
        e.preventDefault();
        cleanUp();
        Utils.goBack(props.history);
    }
    return (React.createElement("div", { id: 'page' },
        React.createElement(Header, { back: back, title: t("Instance Work Processes") }),
        React.createElement(InstanceABAPWPTable, { instanceID: instanceID, data: { showTitle: true } }),
        React.createElement("div", { style: { height: "30px" } }),
        React.createElement(WPTableStats, { instanceid: instanceID })));
};
const InstanceABAPWPTable = (props) => {
    const [divDetails, setDivDetails] = useState(null);
    const [data, setData] = useState(null);
    const [refreshing, setRefreshing] = useState(false);
    const fn = { exited: false };
    let refreshTimeout = 0;
    const instanceID = props.instanceID;
    function cleanUp() {
        fn.exited = true;
        clearTimeout(refreshTimeout);
    }
    useEffect(() => { loadData(); return cleanUp; }, [props]);
    function loadData() {
        if (fn.exited)
            return;
        let pdo = Utils.postDataOptions({ op: "instanceABAPWPTable", id: instanceID });
        Utils.setState(fn, setRefreshing, true);
        fetch(apiURL + "instances", pdo).then(res => res.json()).then((result) => {
            Utils.setState(fn, setData, result);
            Utils.setState(fn, setDivDetails, parseData(result));
        }, (error) => {
            return Utils.setState(fn, setDivDetails, Utils.error(error.message));
        }).then(() => {
            if (fn.exited)
                return;
            setTimeout(() => Utils.setState(fn, setRefreshing, false), 1000);
            refreshTimeout = setTimeout(loadData, 10000);
        });
    }
    function parseData(json) {
        if (!json.success || !json.processes) {
            if (json.error == "Unauthorized") {
                return React.createElement(InstanceAuthorization, { instanceID: instanceID });
            }
            let msg = t(json.error);
            if (json.ip) {
                msg += " [" + json.ip + ":" + json.port + " - " + json.nr + "]";
            }
            return Utils.error(msg);
        }
        const data = {
            defaultSortField: "id",
            direction: "ascending",
            id: "iwpt",
            headers: [
                { name: "#", field: "id" },
                { name: "Type", field: "type" },
                { name: "PID", field: "pid" },
                { name: "Status", field: "status" },
                { name: "Reason", field: "reason" },
                { name: "Start", field: "start" },
                { name: "Err", field: "err" },
                { name: "Sem", field: "sem" },
                { name: "CPU", field: "cpu" },
                { name: "Time", field: "time" },
                { name: "Program", field: "program" },
                { name: "Client", field: "client" },
                { name: "User", field: "user" },
                { name: "Action", field: "action" },
                { name: "Table", field: "table" },
                { name: "TU", field: "tu", title: "Type Utilization" },
                { name: "Source", field: "from" },
            ],
            rows: json.processes
        };
        return React.createElement(Table, { data: data });
    }
    ;
    let title = null;
    if (props.data && props.data.showTitle && data && data.ip) {
        title = data.ip + " " + data.hostName + " [" + data.nr + "]";
    }
    const refreshAnimation = refreshing ? Utils.updating() : null;
    return (React.createElement("div", { id: 'panel_instance_abapwptable' },
        React.createElement("div", { className: "update_animation_box" }, refreshAnimation),
        title,
        divDetails));
};
const InstanceAccessPoints = (props) => {
    const [divDetails, setDivDetails] = useState(null);
    const [data, setData] = useState(null);
    const [refreshing, setRefreshing] = useState(false);
    const fn = { exited: false };
    let refreshTimeout = 0;
    const instanceID = props.instanceID;
    function cleanUp() {
        fn.exited = true;
        clearTimeout(refreshTimeout);
    }
    useEffect(() => { loadData(); return cleanUp; }, [props]);
    function loadData() {
        if (fn.exited)
            return;
        let pdo = Utils.postDataOptions({ op: "instanceaccesspoints", id: instanceID });
        Utils.setState(fn, setRefreshing, true);
        fetch(apiURL + "instances", pdo).then(res => res.json()).then((result) => {
            Utils.setState(fn, setData, result);
            Utils.setState(fn, setDivDetails, parseData(result));
        }, (error) => {
            return Utils.setState(fn, setDivDetails, Utils.error(error.message));
        }).then(() => {
            if (fn.exited)
                return;
            setTimeout(() => Utils.setState(fn, setRefreshing, false), 1000);
            refreshTimeout = setTimeout(loadData, 10000);
        });
    }
    function parseData(json) {
        if (!json.success || !json.ports) {
            if (json.error == "Unauthorized") {
                return React.createElement(InstanceAuthorization, { instanceID: instanceID, id: "il_" + Utils.timeStamp() });
            }
            let msg = t(json.error);
            if (json.ip) {
                msg += " [" + json.ip + ":" + json.port + "]";
            }
            return Utils.error(msg);
        }
        const data = {
            defaultSortField: "id",
            id: "ipt",
            headers: [
                { name: "Host", field: "address" },
                { name: "Port", field: "port" },
                { name: "Protocol", field: "protocol" },
                { name: "Process", field: "process" },
                { name: "Active", field: "active" }
            ],
            rows: json.ports
        };
        return React.createElement(Table, { data: data });
    }
    ;
    let title = null;
    if (props.data && props.data.showTitle && data && data.ip) {
        title = data.ip + " " + data.hostName + " [" + data.nr + "]";
    }
    const refreshAnimation = refreshing ? Utils.updating() : null;
    return (React.createElement("div", { id: 'panel_instance_accesspoints' },
        React.createElement("div", { className: "update_animation_box" }, refreshAnimation),
        title,
        divDetails));
};
const InstanceAccessPointsPage = (props) => {
    const instanceID = props.match.params.id;
    const fn = { exited: false };
    function cleanUp() {
        fn.exited = true;
    }
    function back(e) {
        e.preventDefault();
        cleanUp();
        Utils.goBack(props.history);
    }
    return (React.createElement("div", { id: 'page' },
        React.createElement(Header, { back: back, title: t("Instance access points") }),
        React.createElement(InstanceAccessPoints, { instanceID: instanceID, data: { showTitle: true } })));
};
const InstanceAlertDetails = function (data) {
    let dialog = Dialog.show({ content: t("Loading...") });
    const fn = { exited: false };
    loadData();
    function loadData() {
        if (fn.exited)
            return;
        let pdo = Utils.postDataOptions({ op: "instancealertdetails", id: data.instanceID, tid: data.tid });
        fetch(apiURL + "instances", pdo).then(res => res.json()).then((result) => {
            parseResult(result);
        }, (error) => {
            parseResult({ error: Utils.error(error.message) });
        });
    }
    function setContent(content) {
        dialog.innerHTML = content;
    }
    function parseResult(json) {
        if (!json.success) {
            return setContent(json.error);
        }
        const rows = [];
        for (let i = 0; i < json.alerts.length; i++) {
            const alert = json.alerts[i];
            const row = React.createElement("tr", null,
                React.createElement("td", null, alert.time),
                React.createElement("td", null, alert.object),
                React.createElement("td", null, alert.attribute),
                React.createElement("td", null, alert.description));
            rows.push(row);
        }
        const content = React.createElement("table", null,
            React.createElement("thead", null,
                React.createElement("td", null, "Time"),
                React.createElement("td", null, "Object"),
                React.createElement("td", null, "Attribute"),
                React.createElement("td", null, "Description")),
            React.createElement("tbody", null, rows));
        ReactDOM.render(content, dialog);
    }
};
const InstanceAlerts = (props) => {
    const [data, setData] = useState(null);
    const [refreshing, setRefreshing] = useState(false);
    const [error, setError] = useState(null);
    const [tab, setTab] = useState("table");
    const fn = { exited: false };
    let refreshTimeout = 0;
    const instanceID = props.instanceID;
    const colors = [null, null, Colors.warning, Colors.red];
    function cleanUp() {
        fn.exited = true;
        clearTimeout(refreshTimeout);
    }
    useEffect(() => { loadData(); return cleanUp; }, [props]);
    function loadData() {
        if (fn.exited)
            return;
        let pdo = Utils.postDataOptions({ op: "instancealerttree", id: instanceID });
        Utils.setState(fn, setRefreshing, true);
        fetch(apiURL + "instances", pdo).then(res => res.json()).then((result) => {
            Utils.setState(fn, setData, result);
        }, (error) => {
            return Utils.setState(fn, setError, Utils.error(error.message));
        }).then(() => {
            if (fn.exited)
                return;
            setTimeout(() => Utils.setState(fn, setRefreshing, false), 1000);
            refreshTimeout = setTimeout(loadData, 10000);
        });
    }
    function icon(item) {
        let image = "alert_gray.png";
        switch (item.sc) {
            case 1:
                image = "alert_green.png";
                break;
            case 2:
                image = "alert_yellow.png";
                break;
            case 3:
                image = "alert_red.png";
                break;
        }
        if (item.sc == 1 && item.ds.length > 0) {
            image = "alert_red.png";
        }
        return React.createElement("img", { key: "ti_" + item.n, src: "images/icons/png/" + image, width: "18", style: { marginBottom: "-2px", paddingRight: "8px" } });
    }
    function tableRowColor(row) {
        return colors[row.level];
    }
    function tooltip(item) {
        if (item.ds.length < 1)
            return null;
        return item.ds + " (" + item.at + ")";
    }
    function treeToTable(data, rows, path) {
        if (data.c && data.c.length) {
            for (let i = 0; i < data.c.length; i++) {
                const child = data.c[i];
                treeToTable(child, rows, path + "/" + child.n);
            }
            return;
        }
        let level = data.sc;
        if (data.at.length > 0) {
            level = 3;
        }
        if (level == 0)
            level = 1;
        const row = {
            id: data.id,
            path: path,
            n: data.n,
            ds: data.ds,
            sc: data.sc,
            at: data.at,
            time: data.time,
            tid: data.tid,
            parent: data.p,
            level: level
        };
        rows.push(row);
    }
    function onItemClick(item) {
        const data = { instanceID: instanceID, tid: item.tid };
        new InstanceAlertDetails(data);
    }
    function parseData(json) {
        if (!json) {
            return null;
        }
        if (!json.success || !json.alerts) {
            if (json.error == "Unauthorized") {
                return React.createElement(InstanceAuthorization, { instanceID: instanceID });
            }
            let msg = t(json.error);
            if (json.ip) {
                msg += " [" + json.ip + ":" + json.port + "]";
            }
            return Utils.error(msg);
        }
        if (tab == "tree") {
            const tree = {
                id: "iat",
                icon: icon,
                tooltip: tooltip,
                json: json.alerts.c,
                leafListener: onItemClick
            };
            return React.createElement(Tree, { data: tree });
        }
        const rows = [];
        treeToTable(json.alerts.c[0], rows, "");
        const table = {
            defaultSortField: "at",
            id: "iatable",
            headers: [
                { name: "id", field: "id", pale: true },
                { name: "", field: "sc", rowFormat: icon },
                { name: "Path", field: "path", showTooltip: true, noCrop: true, maxWidth: "400px", colorRule: tableRowColor, onClick: onItemClick },
                { name: "Description", field: "ds", showTooltip: true },
                { name: "Alert Time", field: "at", pale: true },
                { name: "Time", field: "time", pale: true }
            ],
            rows: rows
        };
        return React.createElement(Table, { data: table });
    }
    ;
    let title = null;
    if (props.data && props.data.showTitle && data) {
        title = data.ip + " " + data.hostName + " [" + data.nr + "]";
    }
    const div = error ? error : parseData(data);
    const refreshAnimation = refreshing ? Utils.updating() : null;
    return (React.createElement("div", { id: 'panel_instance_alerts' },
        React.createElement("div", { className: "update_animation_box" }, refreshAnimation),
        React.createElement("button", { onClick: () => setTab("table") }, t("Table")),
        React.createElement("button", { onClick: () => setTab("tree") }, t("Tree")),
        title,
        div));
};
const InstanceAlertsPage = (props) => {
    const instanceID = props.match.params.id;
    const fn = { exited: false };
    function cleanUp() {
        fn.exited = true;
    }
    function back(e) {
        e.preventDefault();
        cleanUp();
        Utils.goBack(props.history);
    }
    return (React.createElement("div", { id: 'page' },
        React.createElement(Header, { back: back, title: t("Instance alerts") }),
        React.createElement(InstanceAlerts, { instanceID: instanceID, data: { showTitle: true } })));
};
const InstanceAnalyseLogFiles = (props) => {
    const instanceID = props.match.params.id;
    const [div, setDiv] = useState(null);
    const [refreshing, setRefreshing] = useState(false);
    const fn = { exited: false };
    let refreshTimeout = 0;
    function cleanUp() {
        fn.exited = true;
    }
    useEffect(() => { loadData(); return cleanUp; }, [props]);
    function back(e) {
        e.preventDefault();
        cleanUp();
        Utils.goBack(props.history);
    }
    function loadData() {
        if (fn.exited)
            return;
        let pdo = Utils.postDataOptions({ op: "analyselogfiles", instanceID: instanceID, hours: 1 });
        Utils.setState(fn, setRefreshing, true);
        fetch(apiURL + "developertrace", pdo).then(res => res.json()).then((result) => {
            Utils.setState(fn, setDiv, parseData(result));
        }, (error) => {
            Utils.setState(fn, setDiv, Utils.error(error.message));
        }).then(() => {
            setTimeout(() => Utils.setState(fn, setRefreshing, false), 1000);
            refreshTimeout = setTimeout(loadData, 10000);
        });
    }
    function parseData(json) {
        if (!json.success) {
            if (json.error == "Unauthorized") {
                return React.createElement(InstanceAuthorization, { instanceID: instanceID });
            }
            let msg = t(json.error);
            if (json.ip) {
                msg += " [" + json.sid + "," + json.nr + "]";
            }
            return Utils.error(msg);
        }
        const headers = [];
        const fields = json.format.split("#");
        for (let i = 0; i < fields.length; i++) {
            const field = fields[i];
            const header = { name: field, field: field };
            headers.push(header);
        }
        Utils.merge(Utils.getObjectFromArray(headers, "name", "Severity"), { format: Utils.windowsEventType, width: "150px" });
        console.log(headers);
        const logs = [];
        for (let k = 0; k < json.lines.length; k++) {
            const line = json.lines[k].line;
            const id = json.lines[k].id;
            const items = line.split("\t");
            const row = { id: id };
            for (let p = 0; p < items.length; p++) {
                const item = items[p];
                const header = headers[p];
                row[header.field] = item;
            }
            logs.push(row);
        }
        Utils.switchArrayItems(headers, "name", "Time", "Severity");
        const data = {
            defaultSortField: "id",
            id: "ipt",
            headers: headers,
            rows: logs
        };
        return React.createElement("div", null,
            React.createElement(Table, { key: "tableLogs", data: data }));
    }
    ;
    const refreshAnimation = refreshing ? Utils.updating() : null;
    return (React.createElement("div", { id: 'page' },
        React.createElement(Header, { back: back, title: t("Analyse log files") }),
        React.createElement("div", { className: "update_animation_box" }, refreshAnimation),
        div));
};
const InstanceAuthorization = (props) => {
    const [fields, setFields] = useState({ user: "", password: "" });
    const [errors, setErrors] = useState({});
    const [error, setError] = useState(null);
    const [updating, setUpdating] = useState(false);
    const required = ["user", "password"];
    const instanceID = props.instanceID;
    const fn = { closed: useRef(false) };
    function cleanUp() {
        fn.closed.current = true;
    }
    useEffect(() => { fn.closed.current = false; loadData(); return cleanUp; }, [instanceID]);
    function loadData() {
        if (fn.closed.current)
            return;
        let pdo = Utils.postDataOptions({ op: "get", id: instanceID });
        fetch(apiURL + "instances", pdo).then(res => res.json()).then((result) => {
            if (result.success) {
                Utils.setState(fn, setFields, Object.assign(Object.assign({}, fields), { user: result.osuser }));
            }
        }, (error) => {
            Utils.setState(fn, setUpdating, false);
        }).then(() => {
            Utils.setState(fn, setUpdating, false);
        });
    }
    ;
    function handleValidation() {
        const errors = {};
        let formIsValid = true;
        for (let i = 0; i < required.length; i++) {
            const field = required[i];
            if (!fields[field] || fields[field].length < 1) {
                formIsValid = false;
                errors[field] = "Required field";
            }
        }
        setErrors(errors);
        return formIsValid;
    }
    function handleChange(e) {
        const field = e.currentTarget.getAttribute('field');
        const value = e.target.type === "checkbox" ? e.target.checked : e.target.value;
        setFields(Object.assign(Object.assign({}, fields), { [field]: value }));
    }
    function reload() {
        if (props.data && props.data.redirect) {
            Utils.go(props.history, "#instance/" + instanceID);
            return;
        }
        Utils.setState(fn, setUpdating, false);
        Call.refresh();
    }
    function submit() {
        if (fn.closed.current)
            return;
        if (!handleValidation())
            return;
        const options = Object.assign(Object.assign({}, fields), { op: "setinstanceuser", id: instanceID });
        const pdo = Utils.postDataOptions(options);
        Utils.setState(fn, setUpdating, true);
        fetch(apiURL + "instances", pdo).then(res => res.json()).then((result) => {
            if (result.success) {
                alert("OK");
                return reload();
            }
            else {
                if (result.field) {
                    setErrors({ [result.field]: result.error });
                }
                Utils.setState(fn, setError, Utils.error(result.error));
                Utils.setState(fn, setUpdating, false);
            }
        }, (error) => {
            Utils.setState(fn, setUpdating, false);
            return Utils.setState(fn, setError, Utils.error(error.message));
        });
    }
    function getForm() {
        const buttonsubmit = updating ? React.createElement("div", { className: "update_animation_box" }, Utils.updating())
            : React.createElement("button", { className: "btn btn-lg pro", id: "submit", value: "Submit", onClick: submit }, t("Login"));
        return React.createElement("div", { style: { paddingTop: "20px" } },
            React.createElement("div", { className: "col-md-6" },
                React.createElement("fieldset", null,
                    React.createElement("span", null,
                        t("Please provide operating system username and password to reach required data"),
                        " ",
                        "( <sid>adm )")),
                React.createElement("fieldset", null,
                    React.createElement("table", { className: "nobordertable" },
                        React.createElement("tbody", null,
                            React.createElement("tr", null,
                                React.createElement("td", null, t("User")),
                                React.createElement("td", null,
                                    React.createElement("input", { type: "text", size: "30", placeholder: "<sid>adm", field: "user", autoComplete: "new-password", onChange: handleChange, value: fields["user"] })),
                                React.createElement("td", { style: { color: "red" } }, t(errors["user"]))),
                            React.createElement("tr", null,
                                React.createElement("td", null, t("Password")),
                                React.createElement("td", null,
                                    React.createElement("input", { type: "password", size: "30", placeholder: t("Password"), field: "password", autoComplete: "new-password", onChange: handleChange, value: fields["password"] })),
                                React.createElement("td", { style: { color: "red" } }, t(errors["password"])))))),
                React.createElement("fieldset", null, buttonsubmit),
                React.createElement("div", null, status)));
    }
    let status = null;
    if (error) {
        status = React.createElement("div", { style: { color: "red" } }, t(error));
    }
    let form = getForm();
    return (React.createElement("div", { id: 'panel_instance_alerts' }, form));
};
const InstanceAuthorizationPage = (props) => {
    const [divDetails, setDivDetails] = useState(null);
    const instanceID = props.match.params.id;
    const fn = { exited: false };
    function cleanUp() {
        fn.exited = true;
    }
    useEffect(() => { loadData(); return cleanUp; }, []);
    function loadData() {
        if (fn.exited)
            return;
        let pdo = Utils.postDataOptions({ op: "get", id: instanceID });
        fetch(apiURL + "instances", pdo).then(res => res.json()).then((result) => {
            Utils.setState(fn, setDivDetails, parseData(result));
        }, (error) => {
            return Utils.setState(fn, setDivDetails, Utils.error(error.message));
        });
    }
    function parseData(data) {
        if (!data.success) {
            return Utils.error(data.error);
        }
        const div = React.createElement("div", null,
            data.hostName,
            " - ",
            data.ip,
            " / ",
            data.nr);
        return div;
    }
    ;
    function back(e) {
        e.preventDefault();
        cleanUp();
        Utils.goBack(props.history);
    }
    return (React.createElement("div", { id: 'page' },
        React.createElement(Header, { back: back, title: t("Set OS credentials") }),
        divDetails,
        React.createElement(InstanceAuthorization, { instanceID: instanceID, data: { showTitle: true, ts: Utils.timeStamp(), redirect: true } })));
};
const InstanceConfigFiles = (props) => {
    const [divPage, setDivPage] = useState(null);
    const [data, setData] = useState(null);
    const fn = { closed: useRef(false) };
    const instanceID = props.instanceID;
    const chkShowComments = useRef(false);
    function cleanUp() {
        fn.closed.current = true;
    }
    useEffect(() => { fn.closed.current = false; loadList(); return cleanUp; }, [instanceID]);
    function loadList() {
        if (fn.closed.current)
            return;
        Request.send({
            url: apiURL + "instances",
            params: {
                op: "listconfigfiles",
                id: instanceID
            },
            caller: fn,
            listener: (json) => {
                Utils.setState(fn, setData, json);
                Utils.setState(fn, setDivPage, parse(json));
            }
        });
    }
    function parse(json) {
        if (!json.success)
            return Info.error(json.error);
        const items = [];
        for (let i = 0; i < json.files.length; i++) {
            const file = json.files[i];
            items.push(React.createElement("h2", { key: "fn_" + i, style: { color: Colors.blue } }, file.n));
            const rows = [];
            for (let j = 0; j < file.lines.length; j++) {
                const line = file.lines[j];
                if (line.startsWith("#-------------"))
                    continue;
                if (line.startsWith("#")) {
                    if (!chkShowComments.current.checked)
                        continue;
                    rows.push(React.createElement("tr", { key: "line_" + i + "_" + j, style: { opacity: 0.5 } },
                        React.createElement("td", { colSpan: "2" }, line)));
                    continue;
                }
                const parts = line.split("=");
                if (parts.length < 2) {
                    rows.push(React.createElement("tr", { key: "line_" + i + "_" + j },
                        React.createElement("td", { colSpan: "2" }, line)));
                }
                else {
                    const first = parts[0];
                    rows.push(React.createElement("tr", { key: "row_" + i + "_" + j },
                        React.createElement("td", { style: { fontWeight: "bold" } }, first),
                        React.createElement("td", { style: { opacity: 0.6 } }, line.substring(first.length + 1))));
                }
            }
            items.push(React.createElement("table", { key: "table_" + i },
                React.createElement("tbody", null, rows)));
        }
        return React.createElement("div", null, items);
    }
    function checkboxClicked() {
        Utils.setState(fn, setDivPage, parse(data));
    }
    return (React.createElement("div", { id: 'panel_instance_config_files' },
        React.createElement(Checkbox2, { label: "Show Comments", ref: chkShowComments, onChange: checkboxClicked }),
        divPage));
};
const InstanceConfigFilesPage = (props) => {
    const fn = { closed: useRef(false) };
    const instanceID = props.match.params.id;
    function cleanUp() {
        fn.closed.current = true;
    }
    function back(e) {
        e.preventDefault();
        cleanUp();
        Utils.goBack(props.history);
    }
    return (React.createElement("div", { id: 'page' },
        React.createElement(Header, { back: back, title: t("Instance Configuration Files") }),
        React.createElement(InstanceConfigFiles, { instanceID: instanceID })));
};
const InstanceDetails = (props) => {
    const [divDetails, setDivDetails] = useState(null);
    const [data, setData] = useState(null);
    const [refreshing, setRefreshing] = useState();
    const fn = { exited: false };
    let refreshTimeout = 0;
    const instanceID = props.match.params.id;
    const refreshAnimation = refreshing ? Utils.updating() : null;
    function cleanUp() {
        fn.exited = true;
        clearTimeout(refreshTimeout);
    }
    useEffect(() => { loadData(); return cleanUp; }, [props]);
    function loadData() {
        if (fn.exited)
            return;
        let pdo = Utils.postDataOptions({ op: "get", id: instanceID });
        Utils.setState(fn, setRefreshing, true);
        fetch(apiURL + "instances", pdo).then(res => res.json()).then((result) => {
            Utils.setState(fn, setData, result);
            Utils.setState(fn, setDivDetails, parseData(result));
        }, (error) => {
            return Utils.setState(fn, setDivDetails, Utils.error(error.message));
        }).then(() => {
            if (fn.exited)
                return;
            setTimeout(() => Utils.setState(fn, setRefreshing, false), 1000);
            refreshTimeout = setTimeout(loadData, 10000);
        });
    }
    function parseData(data) {
        if (!data.success) {
            return Utils.error(data.error);
        }
        const div = React.createElement("table", { className: "informationtable" },
            React.createElement("tbody", null,
                React.createElement("tr", null,
                    React.createElement("td", { width: "140" }, t("Instance")),
                    React.createElement("td", null,
                        data.nr,
                        " (",
                        data.name,
                        ") "),
                    React.createElement("td", null,
                        React.createElement("div", null, refreshAnimation))),
                React.createElement("tr", null,
                    React.createElement("td", null, t("Host")),
                    React.createElement("td", null,
                        data.hostName,
                        " (",
                        data.ip,
                        ")")),
                React.createElement("tr", null,
                    React.createElement("td", null, "SID"),
                    React.createElement("td", null, data.scode)),
                React.createElement("tr", null,
                    React.createElement("td", null, t("Healthy")),
                    React.createElement("td", null,
                        React.createElement("a", { style: { color: Utils.onOffColor(data.ok) }, href: "#/availability-history/" + AvailabilityType.INSTANCE_STATUS + "/" + instanceID, title: t("Click to see history") }, Utils.yesno(data.ok)))),
                React.createElement("tr", null,
                    React.createElement("td", null,
                        " ",
                        t("Last activity")),
                    React.createElement("td", null,
                        Utils.toDate(data.lastActivity),
                        " "))));
        return div;
    }
    ;
    function tabClicked(tab) {
        Debugger.print("InstanceDetails.tabClicked:" + tab);
    }
    ;
    function back(e) {
        e.preventDefault();
        cleanUp();
        Utils.goBack(props.history);
    }
    let title = t("Instance details");
    if (data && data.ip) {
        title += " [" + data.ip + " / " + data.nr + "] - " + data.hostName;
    }
    return (React.createElement("div", { id: 'page' },
        React.createElement(Header, { back: back, title: title }),
        React.createElement("div", { className: "update_animation_box" }, refreshAnimation),
        divDetails,
        React.createElement("div", { className: "space20" }),
        React.createElement(Tabs, { default: "processes", key: 'tabs', listener: tabClicked },
            React.createElement(Tab, { key: 'processes', name: 'processes', label: 'Processes' },
                "        ",
                React.createElement(InstanceProcesses, { instanceID: instanceID }),
                "             "),
            React.createElement(Tab, { key: 'accesspoints', name: 'accesspoints', label: 'Access points' },
                "        ",
                React.createElement(InstanceAccessPoints, { instanceID: instanceID }),
                "             "),
            React.createElement(Tab, { key: 'traces', name: 'traces', label: 'Developer Traces' },
                "        ",
                React.createElement(InstanceDeveloperTraces, { instanceID: instanceID }),
                "             "),
            React.createElement(Tab, { key: 'logfiles', name: 'logfiles', label: 'Log files' },
                "        ",
                React.createElement(InstanceLogFileList, { instanceID: instanceID }),
                "             "),
            React.createElement(Tab, { key: 'options', name: 'options', label: 'Options' },
                "        ",
                React.createElement(InstanceOptions, { instanceID: instanceID }),
                "             "))));
};
const InstanceDeveloperTraces = (props) => {
    const instanceID = props.instanceID;
    const [div, setDiv] = useState(null);
    const [refreshing, setRefreshing] = useState(false);
    const fn = { exited: false };
    let refreshTimeout = 0;
    function cleanUp() {
        fn.exited = true;
        clearTimeout(refreshTimeout);
    }
    useEffect(() => { loadData(); return cleanUp; }, [props]);
    function loadData() {
        if (fn.exited)
            return;
        let pdo = Utils.postDataOptions({ op: "list", instanceID: instanceID });
        Utils.setState(fn, setRefreshing, true);
        fetch(apiURL + "instancelogs", pdo).then(res => res.json()).then((result) => {
            Utils.setState(fn, setDiv, parseData(result));
        }, (error) => {
            Utils.setState(fn, setDiv, Utils.error(error.message));
        }).then(() => {
            setTimeout(() => Utils.setState(fn, setRefreshing, false), 1000);
            refreshTimeout = setTimeout(loadData, 10000);
        });
    }
    function parseData(json) {
        if (!json.success) {
            if (json.error == "Unauthorized") {
                return React.createElement(InstanceAuthorization, { instanceID: instanceID });
            }
            let msg = t(json.error);
            if (json.ip) {
                msg += " [" + json.sid + "," + json.nr + "]";
            }
            return Utils.error(msg);
        }
        const tableTraces = {
            defaultSortField: "index",
            id: "itf",
            headers: [
                { name: "Name", field: "name" },
                { name: "Errors", field: "errorstatus" },
                { name: "Size", field: "size", format: Utils.bytesToUnit, right: true },
                { name: "Last Modification", field: "mod" },
                { name: "Fatals", field: "fatals" },
                { name: "Errors", field: "errors" },
                { name: "Warnings", field: "warnings" }
            ],
            rows: json.traces
        };
        const tableLogs = {
            defaultSortField: "index",
            id: "ilf",
            headers: [
                { name: "#", field: "index" },
                { name: "Name", field: "name", onClick: traceClicked },
                { name: "Errors", field: "errorstatus", onClick: traceErrorsClicked, format: Utils.stateImageCircle, center: true },
                { name: "Size", field: "size", format: Utils.bytesToUnit, right: true },
                { name: "Read",
                    valueFunction: (row) => {
                        if (row.size < 1)
                            return -999;
                        if (row.old)
                            return -999;
                        return Math.round((row.bytesread / row.size) * 100);
                    },
                    type: "progressbar",
                    tooltip: (row) => { return row.size + " / " + row.bytesread + " [" + row.readerror + "]"; }
                },
                { name: "Last Modification", field: "mod" },
                { name: "Fatals", field: "fatals", onClick: traceFatalsClicked, format: (value) => { return value ? "Fatals[" + value + "]" : ""; } },
                { name: "Errors", field: "errors", onClick: traceErrorsClicked, format: (value) => { return value ? "Errors[" + value + "]" : ""; } },
                { name: "Warnings", field: "warnings", onClick: traceErrorsClicked, format: (value) => { return value ? "Warnings[" + value + "]" : ""; } },
                { name: "Old", field: "old" }
            ],
            rows: json.logs
        };
        return React.createElement("div", null,
            React.createElement(Table, { key: "tableLogs", data: tableLogs }),
            React.createElement(Table, { key: "tableTraces", data: tableTraces }));
    }
    ;
    function traceClicked(row, json) {
        const options = { instanceID: instanceID, file: row.name, type: "readlog" };
        new LogReader(options);
    }
    function traceErrorsClicked(row, json) {
        const options = { instanceID: instanceID, file: row.name, type: "errors" };
        new LogReader(options);
    }
    function traceFatalsClicked(row, json) {
        const options = { instanceID: instanceID, file: row.name, type: "fatals" };
        new LogReader(options);
    }
    const refreshAnimation = refreshing ? Utils.updating() : null;
    return (React.createElement("div", { id: 'panel_developer_traces' },
        React.createElement("div", { className: "update_animation_box" }, refreshAnimation),
        div));
};
const InstanceDeveloperTracesPage = (props) => {
    const instanceID = props.match.params.id;
    function back(e) {
        e.preventDefault();
        cleanUp();
        Utils.goBack(props.history);
    }
    return (React.createElement("div", { id: 'page' },
        React.createElement(Header, { back: back, title: t("Developer Traces") }),
        React.createElement(InstanceDeveloperTraces, { instanceID: instanceID })));
};
const InstanceEnqueueStatisticPage = (props) => {
    const instanceID = props.match.params.id;
    const fn = { exited: false };
    function cleanUp() {
        fn.exited = true;
    }
    function back(e) {
        e.preventDefault();
        cleanUp();
        Utils.goBack(props.history);
    }
    return (React.createElement("div", { id: 'page' },
        React.createElement(Header, { back: back, title: t("Instance Enqueue Statistics") }),
        React.createElement(InstanceEnqueueStatistic, { instanceID: instanceID, data: { showTitle: true } })));
};
const InstanceEnqueueStatistic = (props) => {
    const [divDetails, setDivDetails] = useState(null);
    const [data, setData] = useState(null);
    const [refreshing, setRefreshing] = useState(false);
    const fn = { exited: false };
    let refreshTimeout = 0;
    const instanceID = props.instanceID;
    function cleanUp() {
        fn.exited = true;
        clearTimeout(refreshTimeout);
    }
    useEffect(() => { loadData(); return cleanUp; }, [props]);
    function loadData() {
        if (fn.exited)
            return;
        let pdo = Utils.postDataOptions({ op: "instanceenqueuestatistics", id: instanceID });
        Utils.setState(fn, setRefreshing, true);
        fetch(apiURL + "instances", pdo).then(res => res.json()).then((result) => {
            Utils.setState(fn, setData, result);
            Utils.setState(fn, setDivDetails, parseData(result));
        }, (error) => {
            return Utils.setState(fn, setDivDetails, Utils.error(error.message));
        }).then(() => {
            if (fn.exited)
                return;
            setTimeout(() => Utils.setState(fn, setRefreshing, false), 1000);
            refreshTimeout = setTimeout(loadData, 10000);
        });
    }
    function colorRule(row) {
        if (!row.state)
            return false;
        return Utils.stateColor(row.state);
    }
    function parseData(json) {
        if (!json.success || !json.statistics) {
            if (json.error == "Unauthorized") {
                return React.createElement(InstanceAuthorization, { instanceID: instanceID });
            }
            let msg = t(json.error);
            if (json.ip) {
                msg += " [" + json.ip + ":" + json.port + "]";
            }
            return Utils.error(msg);
        }
        const data = {
            defaultSortField: "id",
            id: "ipqs",
            headers: [
                { name: "Name", field: "name", colorRule: colorRule },
                { name: "Value", field: "value" },
                { name: "High", field: "high" },
                { name: "Max", field: "max" }
            ],
            rows: json.statistics
        };
        return React.createElement(Table, { data: data });
    }
    ;
    let title = null;
    if (props.data && props.data.showTitle && data) {
        title = data.ip + " " + data.hostName + " [" + data.nr + "]";
    }
    const refreshAnimation = refreshing ? Utils.updating() : null;
    return (React.createElement("div", { id: 'panel_instance_enqueuestatistics' },
        React.createElement("div", { className: "update_animation_box" }, refreshAnimation),
        title,
        divDetails));
};
const InstanceGatewayClientsPage = (props) => {
    const instanceID = props.match.params.id;
    const fn = { exited: false };
    function cleanUp() {
        fn.exited = true;
    }
    function back(e) {
        e.preventDefault();
        cleanUp();
        Utils.goBack(props.history);
    }
    return (React.createElement("div", { id: 'page' },
        React.createElement(Header, { back: back, title: t("Instance Gateway Clients") }),
        React.createElement(InstanceGatewayClients, { instanceID: instanceID, data: { showTitle: true } })));
};
const InstanceGatewayClients = (props) => {
    const [divDetails, setDivDetails] = useState(null);
    const [data, setData] = useState(null);
    const [refreshing, setRefreshing] = useState(false);
    const fn = { exited: false };
    let refreshTimeout = 0;
    const instanceID = props.instanceID;
    function cleanUp() {
        fn.exited = true;
        clearTimeout(refreshTimeout);
    }
    useEffect(() => { loadData(); return cleanUp; }, [props]);
    function loadData() {
        if (fn.exited)
            return;
        let pdo = Utils.postDataOptions({ op: "instancegatewayclients", id: instanceID });
        Utils.setState(fn, setRefreshing, true);
        fetch(apiURL + "instances", pdo).then(res => res.json()).then((result) => {
            Utils.setState(fn, setData, result);
            Utils.setState(fn, setDivDetails, parseData(result));
        }, (error) => {
            return Utils.setState(fn, setDivDetails, Utils.error(error.message));
        }).then(() => {
            if (fn.exited)
                return;
            setTimeout(() => Utils.setState(fn, setRefreshing, false), 1000);
            refreshTimeout = setTimeout(loadData, 10000);
        });
    }
    function parseData(json) {
        if (!json.success || !json.clients) {
            if (json.error == "Unauthorized") {
                return React.createElement(InstanceAuthorization, { instanceID: instanceID });
            }
            let msg = t(json.error);
            if (json.ip) {
                msg += " [" + json.ip + ":" + json.port + "]";
            }
            return Utils.error(msg);
        }
        const data = {
            defaultSortField: "id",
            id: "tableinstancegatewayclients",
            headers: [
                { name: "Index", field: "id" },
                { name: "LU", field: "LU" },
                { name: "TP", field: "TP" },
                { name: "Type", field: "type" },
                { name: "Address", field: "address" },
                { name: "Last request", field: "lastrequest" },
                { name: "State", field: "state" }
            ],
            rows: json.clients
        };
        return React.createElement("div", { style: { height: "calc(100vh - 150px)", overflowY: "hidden", paddingBottom: "20px" } },
            React.createElement(Table, { data: data }));
    }
    ;
    let title = null;
    if (props.data && props.data.showTitle && data) {
        title = data.ip + " " + data.hostName + " [" + data.nr + "]";
    }
    const refreshAnimation = refreshing ? Utils.updating() : null;
    return (React.createElement("div", { id: 'panel_instance_gateway_clients' },
        React.createElement("div", { className: "update_animation_box" }, refreshAnimation),
        title,
        divDetails));
};
const InstanceICM = (props) => {
    const instanceID = props.match.params.id;
    const [divDetails, setDivDetails] = useState(null);
    const fn = { closed: useRef(false) };
    function cleanUp() {
        fn.closed.current = true;
    }
    function back(e) {
        e.preventDefault();
        Utils.goBack(props.history, "/#instance/" + instanceID);
    }
    useEffect(() => { fn.closed.current = false; loadData(); return cleanUp; }, [props]);
    function loadData() {
        if (fn.closed.current)
            return;
        let pdo = Utils.postDataOptions({ op: "info", id: instanceID });
        fetch(apiURL + "javainstance", pdo).then(res => res.json()).then((result) => {
            Utils.setState(fn, setDivDetails, parseData(result));
        }, (error) => {
            return Utils.setState(fn, setDivDetails, Utils.error(error.message));
        });
    }
    function parseData(json) {
        if (json.error) {
            return Utils.error(json.error);
        }
        const url = json.icmurl;
        return React.createElement("div", null,
            React.createElement("a", { href: url, target: "_blank" }, " Open ICM Viewer "));
    }
    return (React.createElement("div", { id: 'page' },
        React.createElement(Header, { back: back, title: t("Instance ICM") }),
        divDetails));
};
const InstanceICMBrowser = (props) => {
    const instanceID = props.match.params.id;
    const [divDetails, setDivDetails] = useState(null);
    const fn = { closed: useRef(false) };
    function cleanUp() {
        fn.closed.current = true;
    }
    function back(e) {
        e.preventDefault();
        Utils.goBack(props.history, "/#instance/" + instanceID);
    }
    useEffect(() => { fn.closed.current = false; loadData(); return cleanUp; }, [props]);
    function loadData() {
        if (fn.closed.current)
            return;
        let pdo = Utils.postDataOptions({ op: "geticmurl", id: instanceID });
        fetch(apiURL + "javainstance", pdo).then(res => res.json()).then((result) => {
            Utils.setState(fn, setDivDetails, parseData(result));
        }, (error) => {
            return Utils.setState(fn, setDivDetails, Utils.error(error.message));
        });
    }
    function parseData(json) {
        if (json.error) {
            return Utils.error(json.error);
        }
        const url = json.url;
        return React.createElement("div", null,
            React.createElement("iframe", { src: url, width: "100%", height: "1000" }, " "));
    }
    return (React.createElement("div", { id: 'page' },
        React.createElement(Header, { back: back, title: t("Instance ICM Browser") }),
        divDetails));
};
const InstanceICMCache = (props) => {
    const [divDetails, setDivDetails] = useState(null);
    const [refreshing, setRefreshing] = useState(false);
    const fn = { closed: useRef(false) };
    let refreshTimeout = 0;
    const instanceID = props.instanceID;
    function cleanUp() {
        fn.closed.current = true;
        clearTimeout(refreshTimeout);
    }
    useEffect(() => { fn.closed.current = false; loadData(); return cleanUp; }, [props]);
    function loadData() {
        if (fn.closed.current)
            return;
        let pdo = Utils.postDataOptions({ op: "icmcache", id: instanceID });
        Utils.setState(fn, setRefreshing, true);
        fetch(apiURL + "javainstance", pdo).then(res => res.json()).then((result) => {
            Utils.setState(fn, setDivDetails, parseData(result));
        }, (error) => {
            return Utils.setState(fn, setDivDetails, Utils.error(error.message));
        }).then(() => {
            if (fn.exited)
                return;
            setTimeout(() => Utils.setState(fn, setRefreshing, false), 1000);
            refreshTimeout = setTimeout(loadData, 10000);
        });
    }
    function parseData(json) {
        if (!json.success) {
            if (json.error == "Unauthorized") {
                return React.createElement(InstanceAuthorization, { instanceID: instanceID });
            }
            let msg = t(json.error);
            if (json.ip) {
                msg += " [" + json.ip + ":" + json.port + "]";
            }
            return Utils.error(msg);
        }
        const data = {
            defaultSortField: "n",
            direction: "ascending",
            id: "ticmcache",
            pale: true,
            headers: [
                { name: "Name", field: "n" },
                { name: "Version", field: "v" },
                { name: "Size", field: "sz" },
                { name: "Valid", field: "va", format: Utils.yesno },
                { name: "Cache", field: "c" },
                { name: "Creation", field: "ct" },
                { name: "Last access", field: "lat" },
                { name: "Expiration", field: "et" },
                { name: "URL", field: "url" }
            ],
            rows: json.caches
        };
        data.information = React.createElement("span", null,
            Data.systemCode(json.sid),
            " - ",
            json.hostName,
            " - [",
            json.nr,
            "] ");
        return React.createElement("div", null,
            React.createElement(Table, { data: data }));
    }
    ;
    return (React.createElement("div", { id: 'panel_icm_threads' },
        React.createElement("div", { className: "update_animation_box" }, refreshing && Utils.updating()),
        divDetails));
};
const InstanceICMCachePage = (props) => {
    const instanceID = props.match.params.id;
    function back(e) {
        e.preventDefault();
        Utils.goBack(props.history, "/#instance/" + instanceID);
    }
    return (React.createElement("div", { id: 'page' },
        React.createElement(Header, { back: back, title: t("Instance ICM Cache") }),
        React.createElement(InstanceICMCache, { instanceID: instanceID })));
};
const InstanceICMConnections = (props) => {
    const [divDetails, setDivDetails] = useState(null);
    const [refreshing, setRefreshing] = useState(false);
    const fn = { exited: false };
    let refreshTimeout = 0;
    const instanceID = props.instanceID;
    function cleanUp() {
        fn.exited = true;
        clearTimeout(refreshTimeout);
    }
    useEffect(() => { loadData(); return cleanUp; }, [props]);
    function loadData() {
        if (fn.exited)
            return;
        let pdo = Utils.postDataOptions({ op: "icmconnections", id: instanceID });
        Utils.setState(fn, setRefreshing, true);
        fetch(apiURL + "javainstance", pdo).then(res => res.json()).then((result) => {
            Utils.setState(fn, setDivDetails, parseData(result));
        }, (error) => {
            return Utils.setState(fn, setDivDetails, Utils.error(error.message));
        }).then(() => {
            if (fn.exited)
                return;
            setTimeout(() => Utils.setState(fn, setRefreshing, false), 1000);
            refreshTimeout = setTimeout(loadData, 5000);
        });
    }
    function parseData(json) {
        if (!json.success) {
            if (json.error == "Unauthorized") {
                return React.createElement(InstanceAuthorization, { instanceID: instanceID });
            }
            let msg = t(json.error);
            if (json.ip) {
                msg += " [" + json.ip + ":" + json.port + "]";
            }
            return Utils.error(msg);
        }
        const data = {
            defaultSortField: "n",
            direction: "ascending",
            id: "tjicaches",
            pale: true,
            headers: [
                { name: "ID", field: "id" },
                { name: "Protocol", field: "pro" },
                { name: "Role", field: "role" },
                { name: "Request type", field: "rt" },
                { name: "Peer Address", field: "pa" },
                { name: "Peer Port", field: "pp" },
                { name: "Local Address", field: "la" },
                { name: "Local Port", field: "lp" },
                { name: "Proc Timeout", field: "pto" },
                { name: "Keepalive Timeout", field: "kat" },
                { name: "Connection Time", field: "ct" },
                { name: "NI Handle", field: "nihdl" }
            ],
            rows: json.connections
        };
        data.information = React.createElement("span", null,
            json.sid,
            " - ",
            json.hostName,
            " - [",
            json.nr,
            "] ");
        return React.createElement("div", null,
            React.createElement(Table, { data: data }));
    }
    ;
    return (React.createElement("div", { id: 'panel_jinstance_caches' },
        React.createElement("div", { className: "update_animation_box" }, refreshing && Utils.updating()),
        divDetails));
};
const InstanceICMConnectionsPage = (props) => {
    const instanceID = props.match.params.id;
    function back(e) {
        e.preventDefault();
        Utils.goBack(props.history, "/#instance/" + instanceID);
    }
    return (React.createElement("div", { id: 'page' },
        React.createElement(Header, { back: back, title: t("Instance ICM connections") }),
        React.createElement(InstanceICMConnections, { instanceID: instanceID })));
};
const InstanceICMProxyConnections = (props) => {
    const [divDetails, setDivDetails] = useState(null);
    const [refreshing, setRefreshing] = useState(false);
    const fn = { closed: useRef(false) };
    let refreshTimeout = 0;
    const instanceID = props.instanceID;
    function cleanUp() {
        fn.closed.current = true;
        clearTimeout(refreshTimeout);
    }
    useEffect(() => { fn.closed.current = false; loadData(); return cleanUp; }, [props]);
    function loadData() {
        if (fn.closed.current)
            return;
        let pdo = Utils.postDataOptions({ op: "icmproxyconnections", id: instanceID });
        Utils.setState(fn, setRefreshing, true);
        fetch(apiURL + "javainstance", pdo).then(res => res.json()).then((result) => {
            Utils.setState(fn, setDivDetails, parseData(result));
        }, (error) => {
            return Utils.setState(fn, setDivDetails, Utils.error(error.message));
        }).then(() => {
            if (fn.exited)
                return;
            setTimeout(() => Utils.setState(fn, setRefreshing, false), 1000);
            refreshTimeout = setTimeout(loadData, 10000);
        });
    }
    function parseData(json) {
        if (!json.success) {
            if (json.error == "Unauthorized") {
                return React.createElement(InstanceAuthorization, { instanceID: instanceID });
            }
            let msg = t(json.error);
            if (json.ip) {
                msg += " [" + json.ip + ":" + json.port + "]";
            }
            return Utils.error(msg);
        }
        const data = {
            defaultSortField: "n",
            direction: "ascending",
            id: "ticmcache",
            pale: true,
            headers: [
                { name: "ID", field: "id" },
                { name: "Role", field: "role" },
                { name: "Peer Address", field: "pa" },
                { name: "Peer Port", field: "pp" },
                { name: "Local Address", field: "la" },
                { name: "Local Port", field: "lp" },
                { name: "Status", field: "st" },
                { name: "NI Handle", field: "nihdl" },
                { name: "Socket", field: "sh" },
                { name: "Partner", field: "prt" },
                { name: "Int. Cnv.", field: "icnv" },
                { name: "Ext. Cnv.", field: "ecnv" },
                { name: "SNC Length", field: "snclen" },
                { name: "Failover", field: "fail" },
                { name: "Disconnection", field: "dist" },
                { name: "Object ID", field: "oid" },
                { name: "Tid/Uid/Mode", field: "tid" }
            ],
            rows: json.connections
        };
        data.information = React.createElement("span", null,
            json.sid,
            " - ",
            json.hostName,
            " - [",
            json.nr,
            "] ");
        return React.createElement("div", null,
            React.createElement(Table, { data: data }));
    }
    ;
    return (React.createElement("div", { id: 'panel_icm_threads' },
        React.createElement("div", { className: "update_animation_box" }, refreshing && Utils.updating()),
        divDetails));
};
const InstanceICMProxyConnectionsPage = (props) => {
    const instanceID = props.match.params.id;
    function back(e) {
        e.preventDefault();
        Utils.goBack(props.history, "/#instance/" + instanceID);
    }
    return (React.createElement("div", { id: 'page' },
        React.createElement(Header, { back: back, title: t("Instance ICM Proxy Connections") }),
        React.createElement(InstanceICMProxyConnections, { instanceID: instanceID })));
};
const InstanceICMThreads = (props) => {
    const [divDetails, setDivDetails] = useState(null);
    const [refreshing, setRefreshing] = useState(false);
    const fn = { exited: false };
    let refreshTimeout = 0;
    const instanceID = props.instanceID;
    function cleanUp() {
        fn.exited = true;
        clearTimeout(refreshTimeout);
    }
    useEffect(() => { loadData(); return cleanUp; }, [props]);
    function loadData() {
        if (fn.exited)
            return;
        let pdo = Utils.postDataOptions({ op: "icmthreads", id: instanceID });
        Utils.setState(fn, setRefreshing, true);
        fetch(apiURL + "javainstance", pdo).then(res => res.json()).then((result) => {
            Utils.setState(fn, setDivDetails, parseData(result));
        }, (error) => {
            return Utils.setState(fn, setDivDetails, Utils.error(error.message));
        }).then(() => {
            if (fn.exited)
                return;
            setTimeout(() => Utils.setState(fn, setRefreshing, false), 1000);
            refreshTimeout = setTimeout(loadData, 5000);
        });
    }
    function parseData(json) {
        if (!json.success) {
            if (json.error == "Unauthorized") {
                return React.createElement(InstanceAuthorization, { instanceID: instanceID });
            }
            let msg = t(json.error);
            if (json.ip) {
                msg += " [" + json.ip + ":" + json.port + "]";
            }
            return Utils.error(msg);
        }
        const data = {
            defaultSortField: "name",
            direction: "ascending",
            id: "ticmthreads",
            pale: true,
            headers: [
                { name: "Name", field: "name" },
                { name: "ID", field: "id" },
                { name: "Status", field: "st" },
                { name: "Requests", field: "reqs" },
                { name: "Request type", field: "reqtype" }
            ],
            rows: json.threads
        };
        data.information = React.createElement("span", null,
            json.sid,
            " - ",
            json.hostName,
            " - [",
            json.nr,
            "] ");
        return React.createElement("div", null,
            React.createElement(Table, { data: data }));
    }
    ;
    return (React.createElement("div", { id: 'panel_icm_threads' },
        React.createElement("div", { className: "update_animation_box" }, refreshing && Utils.updating()),
        divDetails));
};
const InstanceICMThreadsPage = (props) => {
    const instanceID = props.match.params.id;
    function back(e) {
        e.preventDefault();
        Utils.goBack(props.history, "/#instance/" + instanceID);
    }
    return (React.createElement("div", { id: 'page' },
        React.createElement(Header, { back: back, title: t("Instance ICM threads") }),
        React.createElement(InstanceICMThreads, { instanceID: instanceID })));
};
const InstanceList = (props) => {
    const [divDetails, setDivDetails] = useState(null);
    const [refreshing, setRefreshing] = useState(true);
    const fn = { closed: useRef(false) };
    let refreshTimeout = 0;
    function cleanUp() {
        fn.closed.current = true;
        clearTimeout(refreshTimeout);
    }
    useEffect(() => { fn.closed.current = false; loadData(); return cleanUp; }, [props]);
    function loadData() {
        if (fn.closed.current)
            return;
        Utils.setState(fn, setRefreshing, true);
        let pdo = Utils.postDataOptions({ "op": "all" });
        fetch(apiURL + "instances", pdo).then(res => res.json()).then((result) => {
            Utils.setState(fn, setDivDetails, parse(result));
        }, (error) => {
            Utils.setState(fn, setDivDetails, Utils.error(error.message));
        }).then(() => {
            if (fn.closed.current)
                return;
            setTimeout(() => Utils.setState(fn, setRefreshing, false), 1000);
            refreshTimeout = setTimeout(loadData, 10000);
        });
    }
    ;
    function remove(instance) {
        Utils.go(props.history, "/#removeinstance/" + instance.id);
    }
    function instanceClicked(instance) {
        Utils.go(props.history, "/#instance/" + instance.id);
    }
    ;
    function parse(json) {
        if (!json.success) {
            return Utils.error(json.error);
        }
        const tableData = {
            defaultSortField: "nr",
            direction: "ascending",
            id: "it",
            headers: [
                { name: "NR", field: "nr", onClick: instanceClicked, width: "50px", title: "SAP instance number" },
                { name: "Name", field: "n" },
                { name: "System", field: "scode" },
                { name: "Host Name", field: "hn" },
                { name: "Healthy", field: "ok", format: Utils.yesno },
                User.admin && { name: "Remove", field: "ip", width: "60px", value: t("Remove"), onClick: remove }
            ],
            rows: json.instances
        };
        return React.createElement(Table, { data: tableData });
    }
    return (React.createElement("div", { id: 'panel_instances' },
        React.createElement("div", { className: "update_animation_box" }, refreshing && Utils.updating()),
        divDetails));
};
const InstanceListPage = (props) => {
    function back(e) {
        e.preventDefault();
        Utils.goBack(props.history, "/#dashboard");
    }
    return (React.createElement("div", { id: 'page' },
        React.createElement(Header, { back: back, title: t("SAP Instances") }),
        React.createElement(InstanceList, null)));
};
const InstanceLogFileList = (props) => {
    const [divDetails, setDivDetails] = useState(null);
    const [data, setData] = useState(null);
    const [refreshing, setRefreshing] = useState(false);
    const fn = { exited: false };
    let refreshTimeout = 0;
    const instanceID = props.instanceID;
    function cleanUp() {
        fn.exited = true;
        clearTimeout(refreshTimeout);
    }
    useEffect(() => { loadData(); return cleanUp; }, [props]);
    function loadData() {
        if (fn.exited)
            return;
        let pdo = Utils.postDataOptions({ op: "instancesystemlogfilelist", id: instanceID });
        Utils.setState(fn, setRefreshing, true);
        fetch(apiURL + "instances", pdo).then(res => res.json()).then((result) => {
            Utils.setState(fn, setData, result);
            Utils.setState(fn, setDivDetails, parseData(result));
        }, (error) => {
            return Utils.setState(fn, setDivDetails, Utils.error(error.message));
        }).then(() => {
            if (fn.exited)
                return;
            setTimeout(() => Utils.setState(fn, setRefreshing, false), 1000);
            refreshTimeout = setTimeout(loadData, 10000);
        });
    }
    function parseData(json) {
        if (!json.success || !json.files) {
            if (json.error == "Unauthorized") {
                return React.createElement(InstanceAuthorization, { instanceID: instanceID });
            }
            let msg = t(json.error);
            if (json.ip) {
                msg += " [" + json.ip + ":" + json.port + "]";
            }
            return Utils.error(msg);
        }
        const data = {
            defaultSortField: "id",
            id: "ipt",
            headers: [
                { name: "Name", field: "name" },
                { name: "Format", field: "format" },
                { name: "Size", field: "size" },
                { name: "Modified", field: "lm" }
            ],
            rows: json.files
        };
        return React.createElement(Table, { data: data });
    }
    ;
    const refreshAnimation = refreshing ? Utils.updating() : null;
    return (React.createElement("div", { id: 'panel_instance_log_file_list' },
        React.createElement("div", { className: "update_animation_box" }, refreshAnimation),
        data && data.ip + " " + data.hostName + " [" + data.nr + "]",
        divDetails));
};
const InstanceOptions = (props) => {
    const [instance, setInstance] = useState(null);
    const [error, setError] = useState(null);
    const fn = { exited: false };
    const instanceID = props.instanceID;
    let inputInstanceName = createRef();
    function cleanUp() {
        fn.exited = true;
    }
    useEffect(() => { loadData(); return cleanUp; }, []);
    function loadData() {
        if (fn.exited)
            return;
        let pdo = Utils.postDataOptions({ op: "get", id: instanceID });
        fetch(apiURL + "instances", pdo).then(res => res.json()).then((result) => {
            if (result.success) {
                Utils.setState(fn, setInstance, result);
            }
            else {
                Utils.setState(fn, setError, result.error);
            }
        }, (error) => {
            return Utils.setState(fn, setError, error.message);
        });
    }
    function updateInstanceName() {
        if (fn.exited)
            return;
        const name = inputInstanceName.current.value;
        let pdo = Utils.postDataOptions({ op: "updateinstancename", id: instanceID, name: name });
        fetch(apiURL + "instances", pdo).then(res => res.json()).then((result) => {
            if (result.success) {
                Info.success("Successfull");
            }
            else {
                Info.error(result.error);
            }
        }, (error) => {
            Info.error(error.message);
        });
    }
    const status = error ? error : null;
    const instanceName = instance ? instance.name : null;
    return (React.createElement("div", { id: 'panel_instance_options' },
        React.createElement("br", null),
        React.createElement("a", { href: "#instancelogin/" + instanceID }, t("Set OS credentials")),
        React.createElement("br", null),
        React.createElement("br", null),
        t("Instance name"),
        ":",
        React.createElement("input", { type: "text", ref: inputInstanceName, id: "inputInstanceName", defaultValue: instanceName }),
        React.createElement("button", { onClick: updateInstanceName }, t("Update")),
        React.createElement("br", null),
        React.createElement("br", null),
        React.createElement("a", { href: "#removeinstance/" + instanceID },
            " ",
            t("Remove instance")),
        React.createElement("br", null),
        React.createElement("br", null),
        React.createElement("a", { href: "#instance_set_sid/" + instanceID }, t("Set SID")),
        React.createElement("br", null),
        React.createElement("a", { href: "#instanceaudit/" + instanceID }, "SAP Security Audit Configuration from Probe"),
        React.createElement("br", null),
        Data.super && React.createElement("a", { href: "#saprfcbrowser/" + instanceID }, "RFC Browser (Experimental - Only for supervisors)"),
        React.createElement("div", { id: 'status_instance_options' }, status)));
};
const InstancePorts = (props) => {
    const [divDetails, setDivDetails] = useState(null);
    const [refreshing, setRefreshing] = useState(false);
    const fn = { exited: false };
    let refreshTimeout = 0;
    const instanceID = props.instanceID;
    function cleanUp() {
        fn.exited = true;
        clearTimeout(refreshTimeout);
    }
    useEffect(() => { loadData(); return cleanUp; }, []);
    function loadData() {
        if (fn.exited)
            return;
        let pdo = Utils.postDataOptions({ op: "instanceports", id: instanceID });
        Utils.setState(fn, setRefreshing, true);
        fetch(apiURL + "instances", pdo).then(res => res.json()).then((result) => {
            Utils.setState(fn, setDivDetails, parseData(result));
        }, (error) => {
            return Utils.setState(fn, setDivDetails, Utils.error(error.message));
        }).then(() => {
            if (fn.exited)
                return;
            setTimeout(() => Utils.setState(fn, setRefreshing, false), 1000);
            refreshTimeout = setTimeout(loadData, 10000);
        });
    }
    function parseData(json) {
        if (!json.success || !json.ports) {
            return Utils.error(json.error);
        }
        let title = null;
        if (props.data && props.data.showTitle && data) {
            title = React.createElement("div", { key: "iptitle" },
                data.ip + " " + data.hostName + " [" + data.nr + "]",
                " ");
        }
        const data = {
            defaultSortField: "open",
            id: "ipt",
            headers: [
                { name: "Port", field: "port", rowFormat: Utils.emphasizeAsterix },
                { name: "Active", field: "open", format: Utils.activeOrEmpty },
                { name: "Last activity", field: "as", format: Utils.minutesPast },
                { name: "Name", field: "description", maxWidth: "600px", noCrop: true }
            ],
            rows: json.ports
        };
        return [title, React.createElement(Table, { key: 'iptable', data: data })];
    }
    ;
    const refreshAnimation = refreshing ? Utils.updating() : null;
    return (React.createElement("div", { id: 'panel_instance_ports' },
        React.createElement("div", { className: "update_animation_box" }, refreshAnimation),
        divDetails));
};
const InstancePortsPage = (props) => {
    const instanceID = props.match.params.id;
    const fn = { exited: false };
    function cleanUp() {
        fn.exited = true;
    }
    function back(e) {
        e.preventDefault();
        cleanUp();
        Utils.goBack(props.history);
    }
    return (React.createElement("div", { id: 'page' },
        React.createElement(Header, { back: back, title: t("Instance ports") }),
        React.createElement(InstancePorts, { instanceID: instanceID, data: { showTitle: true } })));
};
const InstanceProcesses = (props) => {
    const [divDetails, setDivDetails] = useState(null);
    const [data, setData] = useState(null);
    const [refreshing, setRefreshing] = useState(false);
    const fn = { exited: false };
    let refreshTimeout = 0;
    const instanceID = props.instanceID;
    function cleanUp() {
        fn.exited = true;
        clearTimeout(refreshTimeout);
    }
    useEffect(() => { Utils.setState(fn, setDivDetails, null); loadData(); return cleanUp; }, [instanceID]);
    function loadData() {
        if (fn.exited)
            return;
        let pdo = Utils.postDataOptions({ op: "instanceprocesses", id: instanceID });
        Utils.setState(fn, setRefreshing, true);
        fetch(apiURL + "instances", pdo).then(res => res.json()).then((result) => {
            Utils.setState(fn, setData, result);
            Utils.setState(fn, setDivDetails, parseData(result));
        }, (error) => {
            return Utils.setState(fn, setDivDetails, Utils.error(error.message));
        }).then(() => {
            if (fn.exited)
                return;
            setTimeout(() => Utils.setState(fn, setRefreshing, false), 1000);
            refreshTimeout = setTimeout(loadData, 3000);
        });
    }
    function parseData(json) {
        if (!json.success || !json.processes) {
            if (json.error == "Unauthorized") {
                return React.createElement(InstanceAuthorization, { instanceID: instanceID });
            }
            let msg = t(json.error);
            if (json.ip) {
                msg += " [" + json.ip + ":" + json.port + "]";
            }
            return Utils.error(msg);
        }
        const data = {
            defaultSortField: "id",
            id: "ipt",
            update: Utils.timeStamp(),
            headers: [
                { name: "", field: "ds", format: Utils.stateImage },
                { name: "Name", field: "name" },
                { name: "Description", field: "description" },
                { name: "PID", field: "pid" },
                { name: "Status", field: "status" },
                { name: "Start Time", field: "start" },
                { name: "Elapsed", field: "elapsed" }
            ],
            rows: json.processes
        };
        if (props.data && props.data.showTitle && json.ip) {
            data.information = json.ip + " " + json.hostName + " [" + json.nr + "]";
        }
        return React.createElement(Table, { key: "ipt_" + instanceID, data: data });
    }
    ;
    const refreshAnimation = refreshing ? Utils.updating() : null;
    return (React.createElement("div", { id: 'panel_instance_processes' },
        React.createElement("div", { className: "update_animation_box" }, refreshAnimation),
        divDetails));
};
const InstanceProcessesPage = (props) => {
    const instanceID = props.match.params.id;
    const fn = { exited: false };
    function cleanUp() {
        fn.exited = true;
    }
    function back(e) {
        e.preventDefault();
        cleanUp();
        Utils.goBack(props.history);
    }
    return (React.createElement("div", { id: 'page' },
        React.createElement(Header, { back: back, title: t("Instance processes") }),
        React.createElement(InstanceProcesses, { instanceID: instanceID, data: { showTitle: true } })));
};
const InstancePropertiesPage = (props) => {
    const instanceID = props.match.params.id;
    const fn = { exited: false };
    function cleanUp() {
        fn.exited = true;
    }
    function back(e) {
        e.preventDefault();
        cleanUp();
        Utils.goBack(props.history);
    }
    return (React.createElement("div", { id: 'page' },
        React.createElement(Header, { back: back, title: t("Instance Properties") }),
        React.createElement(InstanceProperties, { instanceID: instanceID })));
};
const InstanceProperties = (props) => {
    const [divProperties, setDivProperties] = useState(null);
    const fn = { exited: false };
    const instanceID = props.instanceID;
    function cleanUp() {
        fn.exited = true;
    }
    useEffect(() => { loadProperties(); return cleanUp; }, [props]);
    function loadProperties() {
        if (fn.exited)
            return;
        let pdo = Utils.postDataOptions({ op: "instanceproperties", id: instanceID });
        fetch(apiURL + "instances", pdo).then(res => res.json()).then((result) => {
            if (!result.success) {
                if (!result.ip) {
                    return Utils.setState(fn, setDivProperties, Utils.error(result.error));
                }
                else {
                    const divError = React.createElement("div", null,
                        Utils.error(result.error),
                        React.createElement("br", null),
                        "IP:",
                        result.ip,
                        React.createElement("br", null),
                        "Host:",
                        result.hostName,
                        React.createElement("br", null),
                        "Number:",
                        result.nr,
                        React.createElement("br", null),
                        "Port:",
                        result.port,
                        React.createElement("br", null),
                        "URL:",
                        result.url,
                        React.createElement("br", null));
                    return Utils.setState(fn, setDivProperties, divError);
                }
            }
            const data = {
                defaultSortField: "type",
                direction: "ascending",
                id: "ipp",
                headers: [
                    { name: "Type", field: "type" },
                    { name: "Name", field: "name" },
                    { name: "Value", field: "value", width: "1000px", maxWidth: "1000px", noCrop: true }
                ],
                rows: result.properties
            };
            const dver = {
                defaultSortField: "file",
                direction: "ascending",
                id: "insvertable",
                headers: [
                    { name: "File", field: "file" },
                    { name: "Time", field: "time" },
                    { name: "Version", field: "v", noCrop: true }
                ],
                rows: result.versions
            };
            const dcon = {
                defaultSortField: "n",
                direction: "ascending",
                id: "insconftable",
                headers: [
                    { name: "File", field: "n", noCrop: true }
                ],
                rows: result.configfiles
            };
            const div = React.createElement("div", null,
                "IP:",
                result.ip,
                React.createElement("br", null),
                t("Host"),
                ":",
                result.hostName,
                React.createElement("br", null),
                t("Instance number"),
                ":",
                result.nr,
                React.createElement("br", null),
                React.createElement(Table, { data: data }),
                React.createElement("br", null),
                React.createElement(Table, { data: dver }),
                React.createElement("br", null),
                React.createElement("h2", null, t("Configuration Files")),
                React.createElement("br", null),
                React.createElement(Table, { data: dcon }));
            Utils.setState(fn, setDivProperties, div);
        }, (error) => {
            return Utils.setState(fn, setDivProperties, Utils.error(error.message));
        });
    }
    return (React.createElement("div", { id: 'panel_instance_properties' }, divProperties));
};
const InstanceQueueStatisticPage = (props) => {
    const instanceID = props.match.params.id;
    const fn = { exited: false };
    function cleanUp() {
        fn.exited = true;
    }
    function back(e) {
        e.preventDefault();
        cleanUp();
        Utils.goBack(props.history);
    }
    return (React.createElement("div", { id: 'page' },
        React.createElement(Header, { back: back, title: t("Instance Queue Statistics") }),
        React.createElement(InstanceQueueStatistic, { instanceID: instanceID, data: { showTitle: true } })));
};
const InstanceQueueStatistic = (props) => {
    const [divDetails, setDivDetails] = useState(null);
    const [data, setData] = useState(null);
    const [refreshing, setRefreshing] = useState(false);
    const fn = { exited: false };
    let refreshTimeout = 0;
    const instanceID = props.instanceID;
    function cleanUp() {
        fn.exited = true;
        clearTimeout(refreshTimeout);
    }
    useEffect(() => { loadData(); return cleanUp; }, [props]);
    function loadData() {
        if (fn.exited)
            return;
        let pdo = Utils.postDataOptions({ op: "instancequeuestatistic", id: instanceID });
        Utils.setState(fn, setRefreshing, true);
        fetch(apiURL + "instances", pdo).then(res => res.json()).then((result) => {
            Utils.setState(fn, setData, result);
            Utils.setState(fn, setDivDetails, parseData(result));
        }, (error) => {
            return Utils.setState(fn, setDivDetails, Utils.error(error.message));
        }).then(() => {
            if (fn.exited)
                return;
            setTimeout(() => Utils.setState(fn, setRefreshing, false), 1000);
            refreshTimeout = setTimeout(loadData, 10000);
        });
    }
    function parseData(json) {
        if (!json.success || !json.statistics) {
            if (json.error == "Unauthorized") {
                return React.createElement(InstanceAuthorization, { instanceID: instanceID });
            }
            let msg = t(json.error);
            if (json.ip) {
                msg += " [" + json.ip + ":" + json.port + "]";
            }
            return Utils.error(msg);
        }
        const data = {
            defaultSortField: "id",
            id: "ipqs",
            headers: [
                { name: "Type", field: "type" },
                { name: "Now", field: "now" },
                { name: "High", field: "high" },
                { name: "Max", field: "max" },
                { name: "Writes", field: "writes" },
                { name: "Reads", field: "reads" }
            ],
            rows: json.statistics
        };
        return React.createElement("div", { style: { height: "calc(100vh - 150px)", overflowY: "hidden", paddingBottom: "20px" } },
            React.createElement(Table, { data: data }));
    }
    ;
    let title = null;
    if (props.data && props.data.showTitle && data) {
        title = data.ip + " " + data.hostName + " [" + data.nr + "]";
    }
    const refreshAnimation = refreshing ? Utils.updating() : null;
    return (React.createElement("div", { id: 'panel_instance_logs' },
        React.createElement("div", { className: "update_animation_box" }, refreshAnimation),
        title,
        divDetails));
};
const InstanceSetSIDPage = (props) => {
    const instanceID = props.match.params.id;
    function back(e) {
        e.preventDefault();
        Utils.goBack(props.history);
    }
    return (React.createElement("div", { id: 'page' },
        React.createElement(Header, { back: back, title: t("Instance set SID") }),
        React.createElement(InstanceSetSID, { instanceID: instanceID, history: props.history })));
};
const InstanceSetSID = (props) => {
    const [div, setDiv] = useState(null);
    const [error, setError] = useState(null);
    const fn = { exited: false };
    const instanceID = props.instanceID;
    const refSystemSelect = useRef();
    function cleanUp() {
        fn.exited = true;
    }
    useEffect(() => { loadInstance(); return cleanUp; }, [props]);
    function loadInstance() {
        if (fn.exited)
            return;
        let pdo = Utils.postDataOptions({ op: "get", id: instanceID });
        fetch(apiURL + "instances", pdo).then(res => res.json()).then((result) => {
            if (result.success) {
                loadSystems(result);
            }
            else {
                return Utils.setState(fn, setDiv, Utils.error(result.error));
            }
        }, (error) => {
            return Utils.setState(fn, setDiv, Utils.error(error.message));
        });
    }
    ;
    function loadSystems(instance) {
        if (fn.exited)
            return;
        let pdo = Utils.postDataOptions({ op: "getSystemsForInstance", id: instanceID });
        fetch(apiURL + "instances", pdo).then(res => res.json()).then((result) => {
            Utils.setState(fn, setDiv, createForm(result, instance));
        }, (error) => {
            return Utils.setState(fn, setDiv, Utils.error(error.message));
        });
    }
    ;
    function createForm(json, instance) {
        if (!json.success) {
            return Utils.setState(fn, setDiv, Utils.error(json.error));
        }
        const currentSID = instance.SID;
        const selectOptions = [];
        for (var i = 0; i < json.systems.length; i++) {
            const system = json.systems[i];
            const option = React.createElement("option", { key: "ss_" + system.code, value: system.id }, system.code);
            selectOptions.push(option);
        }
        const selectSystem = React.createElement("select", { ref: refSystemSelect, defaultValue: currentSID }, selectOptions);
        return React.createElement("div", null,
            "System:",
            instance.scode,
            " ",
            React.createElement("br", null),
            "Name:",
            instance.name,
            React.createElement("br", null),
            "Number:",
            instance.nr,
            React.createElement("br", null),
            "Host:",
            instance.hostAlias,
            React.createElement("br", null),
            React.createElement("br", null),
            "New System:",
            selectSystem,
            React.createElement("br", null),
            React.createElement("br", null),
            React.createElement("button", { onClick: submit }, "Update"));
    }
    function submit(e) {
        e.preventDefault();
        const selected = refSystemSelect.current.value;
        const options = { op: "setInstanceSID", "id": instanceID, sid: selected };
        const pdo = Utils.postDataOptions(options);
        fetch(apiURL + "instances", pdo)
            .then(response => response.json())
            .then((result) => {
            if (result.success) {
                alert(t("Operation completed"));
                Call.refresh();
                return Utils.goBack(props.history, "#instance/" + instanceID);
            }
            else {
                Utils.setState(fn, setError, result.error);
            }
        }, (error) => {
            Utils.setState(fn, setError, error.message);
        });
    }
    return (React.createElement("div", { id: 'panel_instance_set_sid' },
        div,
        error));
};
const InstanceSystemLogs = (props) => {
    const [divDetails, setDivDetails] = useState(null);
    const [data, setData] = useState(null);
    const [refreshing, setRefreshing] = useState(false);
    const fn = { exited: false };
    let refreshTimeout = 0;
    const instanceID = props.instanceID;
    function cleanUp() {
        fn.exited = true;
        clearTimeout(refreshTimeout);
    }
    useEffect(() => { loadData(); return cleanUp; }, [props]);
    function loadData() {
        if (fn.exited)
            return;
        let pdo = Utils.postDataOptions({ op: "instancesystemlogs", id: instanceID });
        Utils.setState(fn, setRefreshing, true);
        fetch(apiURL + "instances", pdo).then(res => res.json()).then((result) => {
            Utils.setState(fn, setData, result);
            Utils.setState(fn, setDivDetails, parseData(result));
        }, (error) => {
            return Utils.setState(fn, setDivDetails, Utils.error(error.message));
        }).then(() => {
            if (fn.exited)
                return;
            setTimeout(() => Utils.setState(fn, setRefreshing, false), 1000);
            refreshTimeout = setTimeout(loadData, 10000);
        });
    }
    function parseData(json) {
        if (!json.success || !json.logs) {
            if (json.error == "Unauthorized") {
                return React.createElement(InstanceAuthorization, { instanceID: instanceID });
            }
            let msg = t(json.error);
            if (json.ip) {
                msg += " [" + json.ip + ":" + json.port + "]";
            }
            return Utils.error(msg);
        }
        const headers = [];
        const fields = json.format.split("#");
        for (let i = 0; i < fields.length; i++) {
            const field = fields[i];
            const header = { name: field, field: field };
            headers.push(header);
        }
        Utils.merge(Utils.getObjectFromArray(headers, "name", "Severity"), { format: Utils.windowsEventType, width: "150px" });
        Utils.merge(Utils.getObjectFromArray(headers, "name", "Type"), { onClick: rowClicked });
        const logs = [];
        for (let k = 0; k < json.logs.length; k++) {
            const log = json.logs[k].field;
            const id = json.logs[k].id;
            const items = log.split("\t");
            const row = { id: id };
            for (let p = 0; p < items.length; p++) {
                const item = items[p];
                const header = headers[p];
                row[header.field] = item;
            }
            logs.push(row);
        }
        Utils.switchArrayItems(headers, "name", "Text", "Client");
        Utils.switchArrayItems(headers, "name", "DSRTransaction", "Client");
        const data = {
            defaultSortField: "id",
            id: "ipt",
            rowHeight: "24px",
            headers: headers,
            rows: logs
        };
        return React.createElement("div", { style: { height: "calc(100vh - 150px)", overflowY: "hidden", paddingBottom: "20px" } },
            React.createElement(Table, { data: data }));
    }
    ;
    function rowClicked(row, json) {
        Debugger.print("InstanceSystemLogs.rowClicked");
        console.log(row);
        const type = row.Type;
        const options = { instanceID: instanceID, type: type, file: "", op: "readtrace" };
        new LogReader(options);
    }
    let title = null;
    if (props.data && props.data.showTitle && data) {
        title = data.ip + " " + data.hostName + " [" + data.nr + "]";
    }
    const refreshAnimation = refreshing ? Utils.updating() : null;
    return (React.createElement("div", { id: 'panel_instance_logs' },
        React.createElement("div", { className: "update_animation_box" }, refreshAnimation),
        title,
        divDetails));
};
const InstanceSystemLogsPage = (props) => {
    const instanceID = props.match.params.id;
    const fn = { exited: false };
    function cleanUp() {
        fn.exited = true;
    }
    function back(e) {
        e.preventDefault();
        cleanUp();
        Utils.goBack(props.history);
    }
    return (React.createElement("div", { id: 'page' },
        React.createElement(Header, { back: back, title: t("Instance logs") }),
        React.createElement(InstanceSystemLogs, { instanceID: instanceID, data: { showTitle: true } })));
};
const JInstanceCaches = (props) => {
    const [divDetails, setDivDetails] = useState(null);
    const [refreshing, setRefreshing] = useState(false);
    const fn = { exited: false };
    let refreshTimeout = 0;
    const instanceID = props.instanceID;
    function cleanUp() {
        fn.exited = true;
        clearTimeout(refreshTimeout);
    }
    useEffect(() => { loadData(); return cleanUp; }, [props]);
    function loadData() {
        if (fn.exited)
            return;
        let pdo = Utils.postDataOptions({ op: "caches", id: instanceID });
        Utils.setState(fn, setRefreshing, true);
        fetch(apiURL + "javainstance", pdo).then(res => res.json()).then((result) => {
            Utils.setState(fn, setDivDetails, parseData(result));
        }, (error) => {
            return Utils.setState(fn, setDivDetails, Utils.error(error.message));
        }).then(() => {
            if (fn.exited)
                return;
            setTimeout(() => Utils.setState(fn, setRefreshing, false), 1000);
            refreshTimeout = setTimeout(loadData, 5000);
        });
    }
    function parseData(json) {
        if (!json.success) {
            if (json.error == "Unauthorized") {
                return React.createElement(InstanceAuthorization, { instanceID: instanceID });
            }
            let msg = t(json.error);
            if (json.ip) {
                msg += " [" + json.ip + ":" + json.port + "]";
            }
            return Utils.error(msg);
        }
        const data = {
            defaultSortField: "hr",
            direction: "ascending",
            id: "tjicaches",
            pale: true,
            headers: [
                { name: "", field: "ds", format: Utils.stateImageCircle, width: "16px", emphasize: true },
                { name: "Description", field: "desc", width: "300px", emphasize: true },
                { name: "Owner", field: "ow" },
                { name: "Process", field: "pn" },
                { name: "Type", field: "t" },
                { name: "Size", field: "sz", format: Utils.bytesToUnit, width: "80px", right: true },
                { name: "Attr Size", field: "as", format: Utils.bytesToUnit, right: true },
                { name: "Keys Size", field: "ks", format: Utils.bytesToUnit, width: "80px", right: true },
                { name: "Cached Objects", field: "co", right: true },
                { name: "Used Objects", field: "uo", right: true },
                { name: "Puts", field: "pt", right: true },
                { name: "Gets", field: "gt", right: true },
                { name: "Hits", field: "ht", right: true },
                { name: "Hit ratio", field: "hr", format: Utils.percentage, right: true, width: "80px", emphasize: true },
                { name: "Changes", field: "ch", right: true },
                { name: "Removes", field: "re", right: true },
                { name: "Evictions", field: "ev", right: true },
                { name: "II", field: "ii", title: "Instance invalidations", right: true },
                { name: "CI", field: "ci", title: "Cluster invalidations", right: true },
                { name: "Updated", field: "ut", width: "160px" }
            ],
            rows: json.caches
        };
        data.information = React.createElement("span", null,
            json.sid,
            " - ",
            json.hostName,
            " - [",
            json.nr,
            "] ");
        return React.createElement("div", null,
            React.createElement(Table, { data: data }));
    }
    ;
    return (React.createElement("div", { id: 'panel_jinstance_caches' },
        React.createElement("div", { className: "update_animation_box" }, refreshing && Utils.updating()),
        divDetails));
};
const JInstanceCachesPage = (props) => {
    const instanceID = props.match.params.id;
    function back(e) {
        e.preventDefault();
        Utils.goBack(props.history, "/#instance/" + instanceID);
    }
    return (React.createElement("div", { id: 'page' },
        React.createElement(Header, { back: back, title: t("Instance Java caches") }),
        React.createElement(JInstanceCaches, { instanceID: instanceID })));
};
const JInstanceComponents = (props) => {
    const [divDetails, setDivDetails] = useState(null);
    const [refreshing, setRefreshing] = useState(false);
    const fn = { exited: false };
    let refreshTimeout = 0;
    const instanceID = props.instanceID;
    function cleanUp() {
        fn.exited = true;
        clearTimeout(refreshTimeout);
    }
    useEffect(() => { loadData(); return cleanUp; }, [props]);
    function loadData() {
        if (fn.exited)
            return;
        let pdo = Utils.postDataOptions({ op: "components", id: instanceID, start: 0, length: 10000 });
        Utils.setState(fn, setRefreshing, true);
        fetch(apiURL + "javainstance", pdo).then(res => res.json()).then((result) => {
            Utils.setState(fn, setDivDetails, parseData(result));
        }, (error) => {
            return Utils.setState(fn, setDivDetails, Utils.error(error.message));
        }).then(() => {
            if (fn.exited)
                return;
            setTimeout(() => Utils.setState(fn, setRefreshing, false), 1000);
            refreshTimeout = setTimeout(loadData, 10000);
        });
    }
    function parseData(json) {
        if (!json.success) {
            if (json.error == "Unauthorized") {
                return React.createElement(InstanceAuthorization, { instanceID: instanceID });
            }
            let msg = t(json.error);
            if (json.ip) {
                msg += " [" + json.ip + ":" + json.port + "]";
            }
            return Utils.error(msg);
        }
        const data = {
            defaultSortField: "ds",
            id: "jic",
            rowContextMenu: contextMenu,
            headers: [
                { name: "", field: "ds", format: Utils.stateImage },
                { name: "Name", field: "n" },
                { name: "Type", field: "t" },
                { name: "Mode", field: "sm" },
                { name: "Status", field: "st" },
                { name: "Expected status", field: "es" },
                { name: "Details", field: "det" }
            ],
            rows: json.components
        };
        data.information = React.createElement("span", null,
            json.sid,
            " - ",
            json.hostName,
            " - [",
            json.nr,
            "]   - ",
            Utils.toDate(json.time));
        return React.createElement("div", null,
            React.createElement(Table, { data: data }));
    }
    ;
    function contextMenu(e, row, data) {
        const content = React.createElement("ul", null,
            React.createElement("li", null, "Start"),
            React.createElement("li", null, "Stop"),
            React.createElement("li", null, "Restart"));
        ContextMenu.show({ event: e, content: content });
    }
    const refreshAnimation = refreshing ? Utils.updating() : null;
    return (React.createElement("div", { id: 'panel_jinstance_compontns' },
        React.createElement("div", { className: "update_animation_box" }, refreshAnimation),
        divDetails));
};
const JInstanceComponentsPage = (props) => {
    const instanceID = props.match.params.id;
    function back(e) {
        e.preventDefault();
        Utils.goBack(props.history, "/#instance/" + instanceID);
    }
    return (React.createElement("div", { id: 'page' },
        React.createElement(Header, { back: back, title: t("Instance Java Components") }),
        React.createElement(JInstanceComponents, { instanceID: instanceID })));
};
const JInstanceHeapInformation = (props) => {
    const [divDetails, setDivDetails] = useState(null);
    const [refreshing, setRefreshing] = useState(false);
    const fn = { exited: false };
    let refreshTimeout = 0;
    const instanceID = props.instanceID;
    function cleanUp() {
        fn.exited = true;
        clearTimeout(refreshTimeout);
    }
    useEffect(() => { loadData(); return cleanUp; }, [props]);
    function loadData() {
        if (fn.exited)
            return;
        let pdo = Utils.postDataOptions({ op: "heap", id: instanceID });
        Utils.setState(fn, setRefreshing, true);
        fetch(apiURL + "javainstance", pdo).then(res => res.json()).then((result) => {
            Utils.setState(fn, setDivDetails, parseData(result));
        }, (error) => {
            return Utils.setState(fn, setDivDetails, Utils.error(error.message));
        }).then(() => {
            if (fn.exited)
                return;
            setTimeout(() => Utils.setState(fn, setRefreshing, false), 1000);
            refreshTimeout = setTimeout(loadData, 5000);
        });
    }
    function parseData(json) {
        if (!json.success) {
            if (json.error == "Unauthorized") {
                return React.createElement(InstanceAuthorization, { instanceID: instanceID });
            }
            let msg = t(json.error);
            if (json.ip) {
                msg += " [" + json.ip + ":" + json.port + "]";
            }
            return Utils.error(msg);
        }
        const data = {
            defaultSortField: "name",
            id: "tjih",
            headers: [
                { name: "", field: "ds", format: Utils.stateImageCircle, width: "16px" },
                { name: "Name", field: "name" },
                { name: "Type", field: "type" },
                { name: "Size", field: "size", format: Utils.bytesToUnit },
                { name: "Commit size", field: "commitSize", format: Utils.bytesToUnit },
                { name: "Max used size", field: "maxUsedSize", format: Utils.bytesToUnit },
                { name: "Initial size", field: "initialSize", format: Utils.bytesToUnit },
                { name: "Max size", field: "maxSize", format: Utils.bytesToUnit },
            ],
            rows: json.heaps
        };
        data.information = React.createElement("span", null,
            json.sid,
            " - ",
            json.hostName,
            " - [",
            json.nr,
            "] ");
        return React.createElement("div", null,
            React.createElement(Table, { data: data }));
    }
    ;
    return (React.createElement("div", { id: 'panel_jinstance_heap' },
        React.createElement("div", { className: "update_animation_box" }, refreshing && Utils.updating()),
        divDetails));
};
const JInstanceHeapInformationPage = (props) => {
    const instanceID = props.match.params.id;
    function back(e) {
        e.preventDefault();
        Utils.goBack(props.history, "/#instance/" + instanceID);
    }
    return (React.createElement("div", { id: 'page' },
        React.createElement(Header, { back: back, title: t("Instance Java heap memory") }),
        React.createElement(JInstanceHeapInformation, { instanceID: instanceID })));
};
const JInstanceProcesses = (props) => {
    const [divDetails, setDivDetails] = useState(null);
    const [refreshing, setRefreshing] = useState(false);
    const fn = { exited: false };
    let refreshTimeout = 0;
    const instanceID = props.instanceID;
    function cleanUp() {
        fn.exited = true;
        clearTimeout(refreshTimeout);
    }
    useEffect(() => { loadData(); return cleanUp; }, [props]);
    function loadData() {
        if (fn.exited)
            return;
        let pdo = Utils.postDataOptions({ op: "processes", id: instanceID });
        Utils.setState(fn, setRefreshing, true);
        fetch(apiURL + "javainstance", pdo).then(res => res.json()).then((result) => {
            Utils.setState(fn, setDivDetails, parseData(result));
        }, (error) => {
            return Utils.setState(fn, setDivDetails, Utils.error(error.message));
        }).then(() => {
            if (fn.exited)
                return;
            setTimeout(() => Utils.setState(fn, setRefreshing, false), 1000);
            refreshTimeout = setTimeout(loadData, 5000);
        });
    }
    function parseData(json) {
        if (!json.success) {
            if (json.error == "Unauthorized") {
                return React.createElement(InstanceAuthorization, { instanceID: instanceID });
            }
            let msg = t(json.error);
            if (json.ip) {
                msg += " [" + json.ip + ":" + json.port + "]";
            }
            return Utils.error(msg);
        }
        const data = {
            defaultSortField: "name",
            id: "jip",
            headers: [
                { name: "", field: "state", format: JInstanceProcessState.getColor },
                { name: "Name", field: "name" },
                { name: "Type", field: "type" },
                { name: "Pid", field: "pid" },
                { name: "Port", field: "telnetPort" },
                { name: "Restart", field: "restart" },
                { name: "Exit code", field: "exitCode" },
                { name: "State", field: "statetext" },
                { name: "Started", field: "startTime" },
                { name: "Elapsed", field: "elapsedTime" },
                { name: "Restart", field: "restartCount" },
                { name: "Error", field: "errorCount" },
                { name: "CPU", field: "cpu" },
                { name: "Debug", field: "debug" },
                { name: "Cluster", field: "clusterId" }
            ],
            rows: json.processes
        };
        data.information = React.createElement("span", null,
            json.sid,
            " - ",
            json.hostName,
            " - [",
            json.nr,
            "] ");
        return React.createElement("div", null,
            React.createElement(Table, { data: data }));
    }
    ;
    return (React.createElement("div", { id: 'panel_jinstance_processes' },
        React.createElement("div", { className: "update_animation_box" }, refreshing && Utils.updating()),
        divDetails));
};
const JInstanceProcessesPage = (props) => {
    const instanceID = props.match.params.id;
    function back(e) {
        e.preventDefault();
        Utils.goBack(props.history, "/#instance/" + instanceID);
    }
    return (React.createElement("div", { id: 'page' },
        React.createElement(Header, { back: back, title: t("Instance Java processes") }),
        React.createElement(JInstanceProcesses, { instanceID: instanceID })));
};
const JInstanceProcessState = {
    getColor: function (val) {
        let image = "circle_red.png";
        switch (val) {
            case "SAPControl-J2EE-STOPPED":
                image = "circle_red.png";
                break;
            case "SAPControl-J2EE-STARTING":
                image = "circle_yellow.png";
                break;
            case "SAPControl-J2EE-CORE-RUNNING":
                image = "circle_yellow.png";
                break;
            case "SAPControl-J2EE-RUNNING":
                image = "circle_green.png";
                break;
            case "SAPControl-J2EE-STOPPING":
                image = "circle_yellow.png";
                break;
            case "SAPControl-J2EE-MAINTENANCE":
                image = "circle_red.png";
                break;
            case "SAPControl-J2EE-UNKNOWN":
                image = "circle_gray.png";
                break;
            default: image = "circle_gray.png";
        }
        return React.createElement("img", { src: "/images/icons/png/" + image, width: "24" });
    }
};
const JInstanceThreads = (props) => {
    const [divDetails, setDivDetails] = useState(null);
    const [refreshing, setRefreshing] = useState(false);
    const fn = { exited: false };
    let refreshTimeout = 0;
    const instanceID = props.instanceID;
    function cleanUp() {
        fn.exited = true;
        clearTimeout(refreshTimeout);
    }
    useEffect(() => { loadData(); return cleanUp; }, [props]);
    function loadData() {
        if (fn.exited)
            return;
        let pdo = Utils.postDataOptions({ op: "threads", id: instanceID });
        Utils.setState(fn, setRefreshing, true);
        fetch(apiURL + "javainstance", pdo).then(res => res.json()).then((result) => {
            Utils.setState(fn, setDivDetails, parseData(result));
        }, (error) => {
            return Utils.setState(fn, setDivDetails, Utils.error(error.message));
        }).then(() => {
            if (fn.exited)
                return;
            setTimeout(() => Utils.setState(fn, setRefreshing, false), 1000);
            refreshTimeout = setTimeout(loadData, 5000);
        });
    }
    function parseData(json) {
        if (!json.success) {
            if (json.error == "Unauthorized") {
                return React.createElement(InstanceAuthorization, { instanceID: instanceID });
            }
            let msg = t(json.error);
            if (json.ip) {
                msg += " [" + json.ip + ":" + json.port + "]";
            }
            return Utils.error(msg);
        }
        const data = {
            defaultSortField: "n",
            direction: "ascending",
            id: "ticmconnections",
            pale: true,
            headers: [
                { name: "", field: "ds", format: Utils.stateImageCircle, width: "16px", emphasize: true },
                { name: "Name", field: "n", emphasize: true },
                { name: "Process", field: "pn" },
                { name: "Start", field: "sti" },
                { name: "State", field: "st" },
                { name: "Pool", field: "po" },
                { name: "User", field: "us" },
                { name: "Task", field: "ts" },
                { name: "Task updated", field: "tut" },
                { name: "Subtask", field: "sbt" },
                { name: "Subtask updated", field: "stut" },
                { name: "Class", field: "cls" },
                { name: "Index", field: "in" }
            ],
            rows: json.threads
        };
        data.information = React.createElement("span", null,
            json.sid,
            " - ",
            json.hostName,
            " - [",
            json.nr,
            "] ");
        return React.createElement("div", null,
            React.createElement(Table, { data: data }));
    }
    ;
    return (React.createElement("div", { id: 'panel_jinstance_caches' },
        React.createElement("div", { className: "update_animation_box" }, refreshing && Utils.updating()),
        divDetails));
};
const JInstanceThreadsPage = (props) => {
    const instanceID = props.match.params.id;
    function back(e) {
        e.preventDefault();
        Utils.goBack(props.history, "/#instance/" + instanceID);
    }
    return (React.createElement("div", { id: 'page' },
        React.createElement(Header, { back: back, title: t("Instance Java threads") }),
        React.createElement(JInstanceThreads, { instanceID: instanceID })));
};
const LogReader = function (data) {
    const dialog = create();
    const url = apiURL + "instancelogs";
    const type = data.type;
    let lastBytes = "";
    function create() {
        const content = React.createElement("div", { style: { height: "100%" } },
            React.createElement("div", null,
                React.createElement("div", { id: "div_log_reader", style: { textAlign: "left", whiteSpace: "nowrap" } },
                    data.file,
                    React.createElement("br", null),
                    React.createElement("br", null))),
            React.createElement("a", { id: "log_reader_next_page", onClick: nextPage, style: { display: "none" } }, "More"));
        const dialog = Dialog.show({ content: content, render: true });
        return dialog;
    }
    function nextPage() {
        if (lastBytes === "0") {
            return console.log("End of file");
        }
        console.log("Next Page:" + lastBytes);
        read();
    }
    read();
    function read() {
        if (!data.op)
            data.op = type;
        data.start = lastBytes;
        let pdo = Utils.postDataOptions(data);
        fetch(url, pdo).then(res => res.json()).then((result) => {
            print(result);
        }, (error) => {
            console.log(error.message);
        });
    }
    ;
    function print(json) {
        if (!json)
            return;
        let text = json.text;
        if (!json.success) {
            text = json.error;
        }
        const page = document.createElement("div");
        var divDeveloperTrace = document.getElementById("div_log_reader");
        page.innerHTML = text;
        divDeveloperTrace.appendChild(page);
        if (json["startcookie"]) {
            lastBytes = json["startcookie"];
            showNextButton(lastBytes !== "0");
        }
        console.log(json);
    }
    function showNextButton(show) {
        const element = document.getElementById("log_reader_next_page");
        if (show) {
            element.style.display = 'block';
        }
        else {
            element.style.display = 'none';
        }
    }
};
const RemoveInstance = (props) => {
    const [divSystem, setDivSystem] = useState(null);
    const fn = { exited: false };
    const instanceID = props.match.params.id;
    function cleanUp() { fn.exited = true; }
    function back(e) { e.preventDefault(); cleanUp(); Utils.goBack(props.history); }
    useEffect(() => { getData(); return cleanUp; }, [props]);
    function getData() {
        const options = { op: "get", id: instanceID };
        const pdo = Utils.postDataOptions(options);
        fetch(apiURL + "instances", pdo)
            .then(response => response.json())
            .then((result) => {
            Utils.setState(fn, setDivSystem, parseSystem(result));
        }, (error) => {
            Utils.setState(fn, setDivSystem, Utils.error(error.message));
        });
    }
    ;
    function parseSystem(data) {
        if (!data.success) {
            return Utils.setState(fn, setDivSystem, Utils.error(data.error));
        }
        const div = React.createElement("div", null,
            "Host:",
            data.hostName,
            " ",
            React.createElement("br", null),
            "IP:",
            data.ip,
            React.createElement("br", null),
            "Number:",
            data.nr,
            " ",
            React.createElement("br", null),
            "Alive:",
            data.alive + "",
            " ",
            React.createElement("br", null),
            "Last Activity : ",
            Utils.toDate(data.lastActivity),
            "  ",
            React.createElement("br", null),
            t("Are you sure you want to remove ?"),
            React.createElement("br", null),
            React.createElement("br", null),
            React.createElement("button", { className: "critical", onClick: remove },
                " ",
                t("Remove")),
            React.createElement("button", { className: "btn btn-lg pro", onClick: back },
                " ",
                t("Cancel")));
        return div;
    }
    function remove(e) {
        e.preventDefault();
        const message = t("Are you sure you want to remove ?");
        if (!confirm(message)) {
            return;
        }
        const options = { op: "remove", id: instanceID };
        const pdo = Utils.postDataOptions(options);
        fetch(apiURL + "instances", pdo)
            .then(response => response.json())
            .then((result) => {
            console.log(result);
            if (result.success) {
                Call.refresh();
                return Utils.go(props.history, "/#home");
            }
            if (result.error) {
                Utils.setState(fn, setDivSystem, Utils.error(result.error));
            }
        }, (error) => {
            Utils.setState(fn, setDivSystem, Utils.error(error.message));
        });
    }
    ;
    return (React.createElement("div", { id: "page" },
        React.createElement(Header, { back: back, title: t("Remove Instance"), critical: true }),
        React.createElement("div", null, divSystem)));
};
const RFCBrowser = (props) => {
    const [r, refreshComponent] = useState(0);
    const [stats, setStats] = useState({ user: "", connected: false, connectionMessage: "", destination: "", client: "", checked: false });
    const fn = { closed: useRef(false) };
    const instanceID = props.instanceID;
    const inputUser = useRef();
    const inputPassword = useRef();
    const inputClient = useRef();
    const inputFunctionSearch = useRef();
    const inputTableName = useRef();
    const [divFunctions, setDivFunctions] = useState(null);
    const [divFunctionDetails, setDivFunctionDetails] = useState(null);
    const [divExecute, setDivExecute] = useState(null);
    const [divReadTable, setDivReadTable] = useState(null);
    const limitRef = useRef(10);
    function cleanUp() {
        fn.closed.current = true;
    }
    function refresh() {
        Utils.setState(fn, refreshComponent, Utils.timeStamp());
    }
    useEffect(() => { checkConnection(); return cleanUp; }, [props]);
    function checkConnection() {
        if (fn.closed.current)
            return;
        Request.send({ caller: fn,
            url: apiURL + "saprfc",
            params: { id: instanceID, op: "isconnected" },
            listener: (json) => {
                stats.connected = json.success;
                stats.user = json.user;
                stats.destination = json.destination;
                stats.client = json.client;
                stats.checked = true;
                if (json.success) {
                    stats.connectionMessage = json.user + " is connected on client " + json.client + " with destination " + json.destination;
                }
                else {
                    stats.connectionMessage = json.error;
                }
                refresh();
            }
        });
    }
    ;
    function connect() {
        stats.connectionMessage = "Connecting...";
        refresh();
        Request.send({ caller: fn,
            url: apiURL + "saprfc",
            params: { id: instanceID,
                op: "connect",
                user: inputUser.current.value,
                password: inputPassword.current.value,
                client: inputClient.current.value
            },
            listener: (json) => {
                stats.connected = json.success;
                if (json.success) {
                    stats.user = json.user;
                    stats.connectionMessage = json.user + " is connected on client " + json.client + " with destination " + json.destination;
                }
                else {
                    stats.connectionMessage = json.error;
                }
                refresh();
            }
        });
    }
    ;
    function searchFunctions() {
        Utils.setState(fn, setDivFunctions, "Searching functions...");
        refresh();
        Request.send({ caller: fn,
            url: apiURL + "saprfc",
            params: { id: instanceID,
                op: "searchfunctions",
                search: inputFunctionSearch.current.value
            },
            listener: (json) => {
                Utils.setState(fn, setDivFunctions, parseFunctions(json));
            }
        });
    }
    ;
    function knownFunctions() {
        Utils.setState(fn, setDivFunctions, "Listing functions...");
        refresh();
        Request.send({ caller: fn,
            url: apiURL + "saprfc",
            params: { id: instanceID, op: "knownfunctions" },
            listener: (json) => {
                Utils.setState(fn, setDivFunctions, parseFunctions(json));
            }
        });
    }
    ;
    function parseFunctions(json) {
        if (!json.success)
            return Utils.error(json.error);
        const divs = [];
        const len = json.functions.length;
        for (let i = 0; i < len; i++) {
            const f = json.functions[i];
            const title = f.nm + "\n" + f.gr + "\n" + f.ds;
            const div = React.createElement("div", { key: "rfcfunction_" + i, title: title, name: f.nm, onClick: getFunctionDetails, style: { cursor: "pointer" } }, f.nm);
            divs.push(div);
        }
        ;
        return (React.createElement("div", null,
            "Displaying ",
            len,
            " of ",
            json.total,
            " functions",
            divs));
    }
    ;
    function getFunctionDetails(evt) {
        evt.preventDefault();
        const name = evt.currentTarget.getAttribute("name");
        Utils.setState(fn, setDivFunctionDetails, "Getting function details...");
        refresh();
        Request.send({ caller: fn,
            url: apiURL + "saprfc",
            params: {
                op: "functiondetails",
                id: instanceID,
                name: name
            },
            listener: (json) => {
                Utils.setState(fn, setDivFunctionDetails, parseFunctionDetails(json));
            }
        });
    }
    function parseFunctionDetails(json) {
        if (!json.success)
            return Utils.error(json.error);
        const divs = [];
        const jStr = JSON.stringify(json, null, 2);
        const ta = React.createElement("pre", { key: "functiondetailsjsonpretty" }, jStr);
        divs.push(ta);
        const keys = Object.keys(json.imports);
        const boxes = [];
        for (let i = 0; i < keys.length; i++) {
            const key = keys[i];
            const value = json.imports[key];
            if (typeof value === 'object') {
                for (const [skey, svalue] of Object.entries(value)) {
                    boxes.push({ key: key + "." + skey, value: svalue });
                }
            }
            else {
                boxes.push({ key: key, value: value });
            }
        }
        for (let i = 0; i < boxes.length; i++) {
            const box = boxes[i];
            const div = React.createElement("div", { key: "import_" + i },
                React.createElement("span", { style: { display: "inline-block", width: "300px" } }, box.key),
                React.createElement("input", { className: "imports", type: "text", field: box.key, defaultValue: box.value, style: { width: "100px" } }));
            divs.push(div);
        }
        const buttonExecute = React.createElement("button", { key: "buttonexecute", name: json.name, style: { marginTop: "20px", marginBottom: "30px" }, onClick: execute }, "Execute");
        divs.push(buttonExecute);
        return (React.createElement("div", null,
            React.createElement("div", { key: "detail_title" },
                json.name,
                " details"),
            divs));
    }
    ;
    function execute(evt) {
        evt.preventDefault();
        const name = evt.currentTarget.getAttribute("name");
        Utils.setState(fn, setDivExecute, "Executing " + name + " ...");
        refresh();
        const inputs = document.getElementsByClassName('imports');
        const params = { op: "execute",
            id: instanceID,
            name: name };
        for (let i = 0; i < inputs.length; i++) {
            const input = inputs[i];
            const field = input.getAttribute("field");
            params[field] = input.value;
        }
        params.limit = parseInt(limitRef.current.value);
        Request.send({ caller: fn,
            url: apiURL + "saprfc",
            params: params,
            listener: (json) => {
                Utils.setState(fn, setDivExecute, parseExecute(json));
                Utils.setState(fn, setDivReadTable, parseFunctionResultTables(json));
            }
        });
    }
    ;
    function parseExecute(json) {
        if (!json.success)
            return Utils.error(json.error);
        const divs = [];
        const jStr = JSON.stringify(json, null, 2);
        const ta = React.createElement("pre", { key: "functionexecutejsonpretty" }, jStr);
        divs.push(ta);
        return (React.createElement("div", null,
            React.createElement("div", { key: "execute_title" },
                json.name,
                " results"),
            divs));
    }
    ;
    function parseFunctionResultTables(json) {
        const tables = json.tables;
        if (!tables)
            return "";
        const divs = [];
        for (const [tableName, rows] of Object.entries(tables)) {
            divs.push(React.createElement("div", { key: "fert_title_" + tableName, style: { color: "#1898b8" } }, tableName));
            if (rows.length < 1)
                continue;
            const ths = [];
            const trs = [];
            let row = rows[0];
            Object.keys(row).forEach(key => {
                const th = React.createElement("th", { key: tableName + "_" + key }, key);
                ths.push(th);
            });
            for (let i = 0; i < rows.length; i++) {
                row = rows[i];
                const tds = [];
                Object.entries(row).forEach(([colname, value]) => {
                    const td = React.createElement("td", { key: tableName + "_" + i + "_" + colname },
                        value,
                        " ");
                    tds.push(td);
                });
                const tr = React.createElement("tr", { key: tableName + "_row_" + i }, tds);
                trs.push(tr);
            }
            const table = React.createElement("table", { key: "fert_" + tableName },
                React.createElement("thead", null,
                    React.createElement("tr", null, ths)),
                React.createElement("tbody", null, trs));
            divs.push(table);
        }
        return divs;
    }
    ;
    function readTable() {
        const tableName = inputTableName.current.value;
        Utils.setState(fn, setDivReadTable, "Reading table " + tableName);
        refresh();
        Request.send({ caller: fn,
            url: apiURL + "saprfc",
            params: { id: instanceID,
                op: "readtable",
                table: tableName
            },
            listener: (json) => {
                Utils.setState(fn, setDivReadTable, parseTable(json));
            }
        });
    }
    ;
    function parseTable(json) {
        if (!json.success)
            return Utils.error(json.error);
        const headers = [];
        const rows = [];
        for (let c = 0; c < json.columns.length; c++) {
            const column = json.columns[c];
            const th = React.createElement("th", { key: "th_" + c, title: column.description }, column.name);
            headers.push(th);
        }
        for (let r = 0; r < json.rows.length; r++) {
            const row = json.rows[r];
            const tds = [];
            for (let c = 0; c < row.length; c++) {
                const value = row[c];
                const td = React.createElement("td", { key: "col_" + r + "_" + c }, value);
                tds.push(td);
            }
            const tr = React.createElement("tr", { key: "row_" + r }, tds);
            rows.push(tr);
        }
        const table = React.createElement("table", null,
            React.createElement("thead", null,
                React.createElement("tr", null, headers)),
            React.createElement("tbody", null, rows));
        return table;
    }
    function connectionForm() {
        return React.createElement("div", null,
            React.createElement("div", { style: { width: "200px", float: "left" } },
                React.createElement("div", { style: { paddingLeft: "5px", width: "200px" } }, "User"),
                React.createElement("input", { ref: inputUser, type: "text", name: "rfcnm", autoComplete: "new-password", placeholder: t("User"), defaultValue: stats.user })),
            React.createElement("div", { style: { width: "200px", float: "left" } },
                React.createElement("div", { style: { paddingLeft: "5px" } }, "Password"),
                React.createElement("input", { ref: inputPassword, type: "password", autoComplete: "new-password", placeholder: t("Password") })),
            React.createElement("div", { style: { width: "200px", float: "left" } },
                React.createElement("div", { style: { paddingLeft: "5px" } }, "Client"),
                React.createElement("input", { ref: inputClient, type: "text", placeholder: t("Client") + " (Ex:000)", defaultValue: stats.client })),
            React.createElement("div", { style: { width: "200px", float: "left" } },
                React.createElement("div", { style: { paddingLeft: "5px", height: "25px" } }),
                React.createElement("button", { onClick: connect }, "Connect")),
            React.createElement("div", { style: { clear: "both" } }));
    }
    return (React.createElement("div", { id: 'panel_sap_rfc' },
        stats.connectionMessage,
        React.createElement("br", null),
        React.createElement("br", null),
        stats.checked && connectionForm(),
        React.createElement("select", { style: { marginLeft: "20px" }, ref: limitRef, defaultValue: "10" },
            React.createElement("option", { val: "0" }, "-"),
            React.createElement("option", { val: "10" }, "10"),
            React.createElement("option", { val: "20" }, "20"),
            React.createElement("option", { val: "50" }, "50"),
            React.createElement("option", { val: "100" }, "100")),
        stats.connected &&
            React.createElement("div", null,
                React.createElement("input", { ref: inputFunctionSearch, type: "text", placeholder: t("Function search ex:RFC*"), defaultValue: "RFC*" }),
                React.createElement("button", { onClick: searchFunctions }, "List Functions"),
                React.createElement("button", { onClick: knownFunctions }, "Test Functions")),
        React.createElement("div", { style: { width: "300px", height: "400px", overflow: "auto", float: "left" } }, divFunctions),
        React.createElement("div", { style: { width: "500px", height: "400px", overflow: "auto", float: "left", marginLeft: "20px" } }, divFunctionDetails),
        React.createElement("div", { style: { width: "500px", height: "400px", overflow: "auto", float: "left", marginLeft: "20px" } }, divExecute),
        React.createElement("div", { style: { clear: "both" } }, " "),
        "Table:",
        React.createElement("input", { ref: inputTableName, type: "text", defaultValue: "TBTCO" }),
        React.createElement("button", { onClick: readTable }, "Read Table"),
        React.createElement("div", { stlye: { height: "400px", overflow: "auto" } }, divReadTable)));
};
const RFCBrowserPage = (props) => {
    const instanceID = props.match.params.id;
    const fn = { closed: useRef(false) };
    function cleanUp() {
        fn.closed.current = true;
    }
    function back(e) {
        e.preventDefault();
        cleanUp();
        Utils.goBack(props.history);
    }
    return (React.createElement("div", { id: 'page' },
        React.createElement(Header, { back: back, title: t("Instance RFC Browser") }),
        React.createElement(RFCBrowser, { instanceID: instanceID })));
};
const RFCStatus = (props) => {
    const instanceID = props.id;
    const fn = { closed: useRef(false) };
    const [divPage, setDivPage] = useState(null);
    function cleanUp() {
        fn.closed.current = true;
    }
    useEffect(() => { fn.closed.current = false; getData(); return cleanUp; }, [props.refresh]);
    function getData() {
        Request.send({
            caller: fn,
            url: apiURL + "saprfc",
            params: { op: "isconnected", id: instanceID },
            listener: (json) => {
                Utils.setState(fn, setDivPage, parse(json));
            }
        });
    }
    ;
    function parse(json) {
        if (!json.success) {
            return json.error;
        }
        return json.user + " is connected on client " + json.client + " with destination " + json.destination;
    }
    return (React.createElement("div", null, divPage));
};
const SAPHostAgentConnectionStatus = (props) => {
    const instanceID = props.id;
    const fn = { closed: useRef(false) };
    const [divPage, setDivPage] = useState(null);
    function cleanUp() {
        fn.closed.current = true;
    }
    useEffect(() => { fn.closed.current = false; getData(); return cleanUp; }, [props.refresh]);
    function getData() {
        Request.send({
            caller: fn,
            url: apiURL + "instances",
            params: { op: "saphostagentconnectionstatus", id: instanceID },
            listener: (json) => {
                Utils.setState(fn, setDivPage, parse(json));
            }
        });
    }
    ;
    function parse(json) {
        if (!json.success) {
            return json.error;
        }
        return json.user + " is connected to endpoint " + json.endpoint;
    }
    return (React.createElement("div", null, divPage));
};
const WPTableStats = (props) => {
    const fn = { closed: useRef(false) };
    const timeoutID = "instancewpstats";
    const instanceID = props.instanceid;
    const [stats, setStats] = useState({ time: 0, groups: {
            DIA: [],
            BTC: [],
            UPD: [],
            UP2: [],
            SP0: [],
            ENQ: []
        }, render: 0 });
    const [render, setRender] = useState(0);
    function cleanUp() {
        fn.closed.current = true;
        Timeouts.clearAll(timeoutID);
    }
    useEffect(() => { loadData(); return cleanUp; }, [props]);
    function loadData() {
        Timeouts.clearAll(timeoutID);
        Request.send({
            caller: fn,
            url: apiURL + "instances",
            params: { op: "wptablestats", id: instanceID, start: stats.time },
            listener: (json) => parse(json),
            then: () => Timeouts.add(timeoutID, setTimeout(loadData, 10000))
        });
    }
    function parse(json) {
        if (!json.success) {
            return;
        }
        const st = stats;
        for (let i = json.history.length - 1; i >= 0; --i) {
            const stat = json.history[i];
            const parts = stat.u.split("-");
            st.groups.DIA.push(parts[0]);
            st.groups.BTC.push(parts[1]);
            st.groups.UPD.push(parts[2]);
            st.groups.UP2.push(parts[3]);
            st.groups.SP0.push(parts[4]);
            st.groups.ENQ.push(parts[5]);
        }
        if (st.groups.DIA.length > 200) {
            const len = st.groups.DIA.length - 200;
            st.groups.DIA.splice(0, len);
            st.groups.BTC.splice(0, len);
            st.groups.UPD.splice(0, len);
            st.groups.UP2.splice(0, len);
            st.groups.SP0.splice(0, len);
            st.groups.ENQ.splice(0, len);
        }
        st.time = json.last;
        st.render = Utils.timeStamp();
        Utils.setState(fn, setStats, st);
        Utils.setState(fn, setRender, Utils.timeStamp());
    }
    ;
    return (React.createElement("div", { id: 'panel_instance_wpstats' },
        React.createElement("div", { className: "panel flexmargin", style: { width: "600px" } },
            React.createElement("div", { className: "paneltitle" }, " Dialog Process Utilization "),
            React.createElement(LineGraph, { data: { width: 600, height: 200, values: stats.groups.DIA } })),
        React.createElement("div", { className: "panel flexmargin", style: { width: "600px" } },
            React.createElement("div", { className: "paneltitle" }, " Background Process Utilization "),
            React.createElement(LineGraph, { data: { width: 600, height: 200, values: stats.groups.BTC } })),
        React.createElement("div", { className: "panel flexmargin", style: { width: "600px" } },
            React.createElement("div", { className: "paneltitle" }, " Update Process Utilization"),
            React.createElement(LineGraph, { data: { width: 600, height: 200,
                    groups: [
                        { values: stats.groups.UPD, color: Colors.graphBlue, name: "UPD", title: "Update process for making V1 (time-critical) database changes" },
                        { values: stats.groups.UP2, color: Colors.orange, name: "UP2", title: "Update process for executing V2 (not time-critical) database changes" }
                    ] } })),
        React.createElement("div", { className: "panel flexmargin", style: { width: "600px" } },
            React.createElement("div", { className: "paneltitle" }, " Spool&Enqueue Process Utilization"),
            React.createElement(LineGraph, { data: { width: 600, height: 200,
                    groups: [
                        { values: stats.groups.SP0, color: Colors.graphBlue, name: "SP0",
                            title: "Print formatting (to printer, file or database)" },
                        { values: stats.groups.ENQ, color: Colors.orange, name: "ENQ",
                            title: "The enqueue work process administers a lock table in the shared memory area." }
                    ] } }))));
};
const Inventory = (props) => {
    const [divPage, setDivPage] = useState(null);
    const [refreshing, setRefreshing] = useState(true);
    const [r, reload] = useState(0);
    const [data, setData] = useState(null);
    const inputSearch = useRef();
    const refTextSearchMethod = useRef();
    const [filters, setFilters] = useState({
        multiline: { show: false, name: "Multiline" },
        ip: { show: true, name: "IP" },
        type: { show: true, name: "Type" },
        os: { show: false, name: "OS" },
        cpu: { show: false, name: "CPU" },
        memory: { show: false, name: "Memory" },
        swap: { show: false, name: "Swap" },
        uptime: { show: false, name: "Uptime" },
        disks: { show: true, name: "Disks" },
        apps: { show: false, name: "Apps" },
        programs: { show: true, name: "Programs",
            search: ""
        }
    });
    const fn = { closed: useRef(false) };
    let refreshTimeout = 0;
    console.log(data);
    function cleanUp() {
        fn.closed.current = true;
        clearTimeout(refreshTimeout);
    }
    useEffect(() => { fn.closed.current = false; loadData(); return cleanUp; }, [props]);
    function loadData() {
        if (fn.closed.current)
            return;
        Utils.setState(fn, setRefreshing, true);
        let pdo = Utils.postDataOptions({ op: "list" });
        fetch(apiURL + "inventory", pdo).then(res => res.json()).then((result) => {
            Utils.setState(fn, setData, result);
            setTimeout(() => Utils.setState(fn, setRefreshing, false), 1000);
        }, (error) => {
            return Utils.setState(fn, setDivPage, Utils.error(error.message));
        });
    }
    function refresh() {
        if (fn.closed.current)
            return;
        let pdo = Utils.postDataOptions({ op: "refresh" });
        fetch(apiURL + "inventory", pdo).then(res => res.json()).then(() => {
            clearTimeout(refreshTimeout);
            loadData();
        });
    }
    ;
    function showApps(e) {
        const hostID = e.target.getAttribute("data-id");
        const content = React.createElement(HostApplications, { hostID: hostID });
        const data = { title: "Host Applications", content: content, render: true, width: "90%", height: "90%" };
        Dialog.show(data);
    }
    function showServices(e) {
        const hostID = e.target.getAttribute("data-id");
        const content = React.createElement(HostServices, { hostID: hostID });
        const data = { title: "Host Services", content: content, render: true, width: "90%", height: "90%" };
        Dialog.show(data);
    }
    function showProcesses(e) {
        const hostID = e.target.getAttribute("data-id");
        const content = React.createElement(HostProcesses, { hostID: hostID });
        const data = { title: "Host Processes", content: content, render: true, width: "90%", height: "90%" };
        Dialog.show(data);
    }
    function parseData(json) {
        if (fn.closed.current)
            return;
        if (!json)
            return;
        if (!json.success) {
            return Utils.error(json.error);
        }
        const hosts = json.hosts;
        const trs = [];
        const search = filters.search;
        console.log("Search:" + filters.search);
        for (var i = 0; i < hosts.length; i++) {
            const host = hosts[i];
            var diskTitle = "";
            var diskStr = [];
            var appsStr = [];
            var programStr = [];
            var appsTitle = "";
            var programsTitle = "";
            for (var d = 0; host.disks && d < host.disks.length; d++) {
                const disk = host.disks[d];
                let name = disk.nm;
                name = name.replace("PHYSICALDRIVE", "D");
                name = name.replaceAll("\\", "");
                if (d > 0)
                    diskStr.push(React.createElement("br", { key: "br_d_" + host.id + "_" + d }));
                const sid = "disk_" + host.id + "_" + d;
                diskStr.push(React.createElement("span", { key: sid, id: sid }, Utils.bytesToUnit(disk.sz) + " " + disk.md + " " + name));
                diskTitle += Utils.bytesToUnit(disk.sz) + " " + disk.md + " " + disk.nm + "\n";
            }
            const valign = "top";
            const isHost = String(host.id).startsWith("h") ? 1 : 0;
            let hostID = "";
            if (isHost) {
                hostID = host.id.replace("h", "");
            }
            if (host.apps && host.apps.length > 0) {
                host.apps.sort();
                for (var a = 0; host.apps && a < host.apps.length; a++) {
                    const app = host.apps[a];
                    if (a > 0)
                        appsStr.push(React.createElement("br", { key: "br_app_" + host.id + "_" + a }));
                    const apid = "app_" + host.id + "_" + a;
                    appsStr.push(React.createElement("span", { key: apid, id: apid }, app));
                    appsTitle += app + "\n";
                }
            }
            if (host.programs && host.programs.length > 0) {
                host.programs.sort();
                for (var a = 0; a < host.programs.length; a++) {
                    const app = host.programs[a];
                    if (a > 0)
                        programStr.push(React.createElement("br", { key: "br_program_" + host.id + "_" + a }));
                    const apid = "program_" + host.id + "_" + a;
                    programStr.push(React.createElement("span", { key: apid, id: apid }, app));
                    programsTitle += app + "\n";
                }
            }
            if (filters.search) {
                const method = refTextSearchMethod.current.value;
                if (method == "including" && !Utils.containsCIS(programsTitle, filters.search))
                    continue;
                if (method == "excluding" && Utils.containsCIS(programsTitle, filters.search))
                    continue;
            }
            if (!filters.multiline.show) {
                diskStr = React.createElement("div", { key: "hd_" + host.id, id: "hd_" + host.id, style: { height: "20px", overflow: "hidden" } }, diskStr);
                appsStr = React.createElement("div", { key: "ha_" + host.id, id: "ha_" + host.id, style: { height: "20px", overflow: "hidden" } }, appsStr);
                programStr = React.createElement("div", { key: "hp_" + host.id, id: "hp_" + host.id, style: { height: "20px", overflow: "hidden" } }, programStr);
            }
            const title = host.nm + "\n" + host.ip + "\n" + host.al;
            const tr = React.createElement("tr", { key: "inv_tr_" + i, title: title },
                React.createElement("td", { valign: valign }, hostID ? React.createElement("a", { href: "#unit-details/" + hostID },
                    " ",
                    host.nm) : host.nm),
                React.createElement("td", { valign: valign }, host.al),
                filters.ip.show && React.createElement("td", { valign: valign }, host.ip),
                filters.type.show && React.createElement("td", { valign: valign }, Utils.machineType(host.mc)),
                filters.os.show && React.createElement("td", { valign: valign }, host["os.all"]),
                filters.cpu.show && React.createElement("td", { valign: valign }, host["cpu"]),
                filters.cpu.show && React.createElement("td", { valign: valign, align: "right" },
                    host["cpua"],
                    " %"),
                filters.memory.show && React.createElement("td", { valign: valign, align: "right" }, Utils.bytesToUnit(host["mep"])),
                filters.memory.show && React.createElement("td", { valign: valign, align: "right" },
                    host["mepa"],
                    " %"),
                filters.swap.show && React.createElement("td", { valign: valign, align: "right" }, Utils.bytesToUnit(host["mes"])),
                filters.swap.show && React.createElement("td", { valign: valign, align: "right" },
                    host["mesa"],
                    " %"),
                filters.uptime.show && React.createElement("td", { valign: valign, align: "right" }, Utils.timePast(host.tmu)),
                filters.disks.show && React.createElement("td", { valign: valign, height: filters.multiline.show ? undefined : "20", title: diskTitle }, diskStr),
                filters.apps.show && React.createElement("td", { valign: valign, height: filters.multiline.show ? undefined : "20", title: appsTitle }, appsStr),
                filters.programs.show && React.createElement("td", { valign: valign, height: filters.multiline.show ? undefined : "20", title: programsTitle }, programStr),
                React.createElement("td", { valign: valign, style: { color: host.la > Time.day ? Colors.red : "inherit" }, align: "right" }, Utils.timePast(host.la / 1000)),
                React.createElement("td", { className: "noexport" }, hostID &&
                    React.createElement("div", { style: { float: "right" } },
                        host.app == 1 &&
                            React.createElement("img", { className: "imagebutton", type: "svg", style: { width: "24px" }, src: "/images/icons/apps.svg", onClick: showApps, "data-id": hostID, title: "Apps\n______________\n" + title }),
                        React.createElement("img", { className: "imagebutton", type: "svg", style: { width: "24px" }, src: "/images/icons/developer_board_black_24dp.svg", onClick: showServices, "data-id": hostID, title: "Services\n______________\n" + title }),
                        React.createElement("img", { className: "imagebutton", type: "svg", style: { width: "24px" }, src: "/images/icons/processes.svg", onClick: showProcesses, "data-id": hostID, title: "Processes\n______________\n" + title }))));
            trs.push(tr);
        }
        const div = React.createElement("div", { style: { width: "100%", height: "calc(100vh - 250px)", overflow: "auto" }, key: "inventory_data" },
            React.createElement("table", { id: "table_inventory", className: "table-autosize table-bordered", border: '2px' },
                React.createElement("thead", null,
                    React.createElement("tr", { bgcolor: '#87AFC6' },
                        React.createElement("th", { width: "200" }, "Host"),
                        React.createElement("th", { width: "200" }, "Description"),
                        filters.ip.show && React.createElement("th", { width: "120" }, "IP"),
                        filters.type.show && React.createElement("th", { width: "100" }, "Type"),
                        filters.os.show && React.createElement("th", null, "OS"),
                        filters.cpu.show && React.createElement("th", null, "CPU"),
                        filters.cpu.show && React.createElement("th", { width: "60", title: "CPU usage" },
                            "CPU",
                            React.createElement("br", null),
                            "Usage"),
                        filters.memory.show && React.createElement("th", { width: "80", title: "Physical Memory" }, "Memory"),
                        filters.memory.show && React.createElement("th", { width: "60", title: "Physical Memory Usage" },
                            "Memory",
                            React.createElement("br", null),
                            "Usage"),
                        filters.swap.show && React.createElement("th", { width: "80" }, "Swap"),
                        filters.swap.show && React.createElement("th", { width: "60", title: "Swap Memory Usage" },
                            "Swap",
                            React.createElement("br", null),
                            "Usage"),
                        filters.uptime.show && React.createElement("th", { width: "100" }, "Uptime"),
                        filters.disks.show && React.createElement("th", null, "Disks"),
                        filters.apps.show && React.createElement("th", null, "Apps"),
                        filters.programs.show && React.createElement("th", null, "Programs"),
                        React.createElement("th", { width: "100" }, "Scanned"),
                        React.createElement("th", { width: "80", className: "noexport" }, "Properties"))),
                React.createElement("tbody", null, trs)),
            React.createElement("div", { style: { height: "30px" } }));
        return div;
    }
    ;
    function back(e) { e.preventDefault(); Utils.goBack(props.history, "#dashboard"); }
    function toExcel() {
        const data = { id: "table_inventory", name: "inventory", multiline: filters.multiline.show };
        new ExcelExport(data);
    }
    function openSubnetsForm(e) {
        e.preventDefault();
        const content = React.createElement(InventorySubnets, null);
        const data = { title: "Inventory Subnets", content: content, render: true, width: "500", height: "250" };
        Dialog.show(data);
    }
    function subnetList() {
        if (!data || !data.subnets)
            return null;
        let list = [];
        list.push(React.createElement("a", { key: "subnet_link_form", style: { float: "left", marginRight: "10px" }, onClick: openSubnetsForm }, " Subnets"));
        for (var i = 0; i < data.subnets.length; i++) {
            const div = React.createElement("div", { key: "subnet_" + i, className: "bordered", style: { float: "left", paddingLeft: "6px", paddingRight: "6px" } },
                React.createElement("span", null, data.subnets[i]));
            list.push(div);
        }
        return React.createElement("div", { style: { marginTop: "10px" } }, list);
    }
    function filterBoxes() {
        Debugger.print("FilterBoxes:" + Utils.timeStamp());
        const boxes = [];
        for (var key in filters) {
            if (!filters.hasOwnProperty(key))
                continue;
            if (key == "search")
                continue;
            const filter = filters[key];
            const chk = React.createElement("label", { key: "filter_label_" + key },
                React.createElement("input", { type: "checkbox", checked: filter.show, filter: key, onChange: filterClicked }),
                filter.name);
            boxes.push(chk);
        }
        return React.createElement("div", { key: "fb_" + Utils.timeStamp() }, boxes);
    }
    function searchText(e) {
        const str = e.currentTarget.value;
        filters["search"] = str;
        reload(Utils.timeStamp());
    }
    ;
    function searchMethodChanged() {
        reload(Utils.timeStamp());
    }
    function filterClicked(e) {
        e.preventDefault();
        e.stopPropagation();
        const chk = e.currentTarget;
        const filter = chk.getAttribute('filter');
        filters[filter].show = chk.checked;
        reload(Utils.timeStamp());
    }
    ;
    const page = parseData(data);
    console.log(filters);
    const txtSearch = React.createElement("input", { key: "inputsearch", type: "text", ref: inputSearch, onChange: searchText });
    return (React.createElement("div", { id: "page" },
        React.createElement(Header, { back: back, title: t("Inventory"), updating: refreshing }),
        React.createElement("div", null,
            React.createElement("div", { key: "inventory_top_bar" },
                React.createElement("button", { key: "inventory_button_excel", onClick: toExcel }, "Export to Excel"),
                React.createElement("button", { key: "inventory_button_refresh", onClick: refresh, style: { float: "right" } }, t("Refresh"))),
            React.createElement("div", { style: { marginTop: "10px", marginBottom: "10px" } }, filterBoxes()),
            React.createElement("div", { style: { marginBottom: "10px" } },
                "Search:",
                React.createElement("select", { key: "textsearchmethod", onChange: searchMethodChanged, ref: refTextSearchMethod },
                    React.createElement("option", { val: "including" }, "including"),
                    React.createElement("option", { val: "excluding" }, "excluding")),
                txtSearch,
                data && React.createElement("div", { key: "inventory_scan_status", style: { float: "right", opacity: "0.7" } },
                    "Last Scan: ",
                    data.lastscannedip,
                    " /  ",
                    Utils.toDate(data.lastscantime),
                    " ")),
            page,
            subnetList())));
};
const InventorySubnets = (props) => {
    const [divPage, setDivPage] = useState(null);
    const [status, setStatus] = useState(null);
    const fn = { closed: useRef(false) };
    const inputIP = useRef("");
    function cleanUp() {
        fn.closed.current = true;
    }
    useEffect(() => { fn.closed.current = false; loadData(); return cleanUp; }, [props]);
    function loadData() {
        if (fn.closed.current)
            return;
        let pdo = Utils.postDataOptions({ op: "subnetlist" });
        fetch(apiURL + "inventory", pdo).then(res => res.json()).then((result) => {
            Utils.setState(fn, setDivPage, parseData(result));
        }, (error) => {
            return Utils.setState(fn, setDivPage, Utils.error(error.message));
        });
    }
    function parseData(json) {
        if (fn.closed.current)
            return;
        if (!json.success) {
            return Utils.error(json.error);
        }
        const subnets = json.subnets;
        const list = [];
        for (var i = 0; i < subnets.length; i++) {
            const subnet = subnets[i];
            const ip = subnet.ip;
            const div = React.createElement("div", { key: "subnet_" + ip, style: { float: "left", marginRight: "10px", paddingRight: "10px" } },
                React.createElement("span", { style: { float: "left" } }, ip),
                User.admin && !subnet.own &&
                    React.createElement("img", { className: "imagebutton", type: "svg", src: "/images/icons/ic_delete_forever_24px.svg", style: { float: "right", marginLeft: "10px" }, width: "16", height: "16", title: t("Remove"), "data-ip": ip, onClick: remove }));
            list.push(div);
        }
        return React.createElement("div", null, list);
    }
    ;
    function add() {
        if (fn.closed.current)
            return;
        let pdo = Utils.postDataOptions({ op: "addsubnet", ip: inputIP.current.value });
        fetch(apiURL + "inventory", pdo).then(res => res.json()).then((result) => {
            if (result.success) {
                Utils.setState(fn, setStatus, { success: "New subnet is added" });
                return loadData();
            }
            Utils.setState(fn, setStatus, { error: result.error });
        }, (error) => {
            return Utils.setState(fn, setStatus, { error: error.message });
        });
    }
    function remove(e) {
        if (fn.closed.current)
            return;
        const ip = e.target.getAttribute("data-ip");
        if (!confirm(t("Are you sure you want to remove ?") + "\n" + ip)) {
            return;
        }
        let pdo = Utils.postDataOptions({ op: "removesubnet", ip: ip });
        fetch(apiURL + "inventory", pdo).then(res => res.json()).then((result) => {
            if (result.success) {
                Utils.setState(fn, setStatus, { success: "Subnet is removed" });
                return loadData();
            }
            Utils.setState(fn, setStatus, { error: result.error });
        }, (error) => {
            return Utils.setState(fn, setStatus, { error: error.message });
        });
    }
    return (React.createElement("div", { id: "panel_inventory_subnets", style: { textAlign: "left" } },
        divPage,
        React.createElement("div", { className: "clear" }),
        React.createElement("br", null),
        User.admin &&
            React.createElement("div", null,
                React.createElement("div", { key: "isubnets_add_form" },
                    React.createElement("input", { type: "text", ref: inputIP, placeholder: "***.***.****" }),
                    React.createElement("button", { onClick: add }, "Add")),
                React.createElement("div", { className: "clear" }),
                React.createElement(Status, { data: status }),
                React.createElement("br", null),
                React.createElement("br", null),
                React.createElement("br", null),
                React.createElement("span", null, " Please add a subnet in format ***.***.***  (e.g. 192.168.1)"),
                React.createElement("br", null),
                React.createElement("span", null, " App will scan all the ips from x.x.x.1 to x.x.x.255 on the subnet"))));
};
const License = {
    valid: true,
    expiration: 7258107600,
    remaining: 1000,
    check: function () {
        Request.send({
            url: apiURL + "licensemanager",
            params: { op: "infobasic" },
            success: (json) => {
                License.expiration = json.expiration;
                License.valid = json.valid;
                License.remaining = Math.floor(json.remaining / Time.SC_DAY);
                License.demo = json.demo;
            },
            then: () => {
                setTimeout(License.check, 60000);
            }
        });
    }
};
const LogViewer = (props) => {
    const fn = { closed: useRef(false) };
    const [divLogs, setDivLogs] = useState(null);
    const [refreshing, setRefreshing] = useState(true);
    const [data, setData] = useState({ start: 0, type: 0, min: 0, max: 0, direction: 0, limit: UserSettings.get("logviewer_limit", 20) });
    const timeoutID = "logviewer_" + props.id;
    function cleanUp() {
        fn.closed.current = true;
        Timeouts.clearAll(timeoutID);
    }
    console.log(data);
    useEffect(() => { fn.closed.current = false; loadData(); return cleanUp; }, [props]);
    function loadData() {
        Timeouts.clearAll(timeoutID);
        if (fn.closed.current)
            return;
        Utils.setState(fn, setRefreshing, true);
        const params = props.data.params;
        params.op = "logs";
        params.start = data.start;
        params.type = data.type;
        params.direction = data.direction;
        params.limit = data.limit;
        params.min = data.min;
        params.max = data.max;
        let pdo = Utils.postDataOptions(params);
        fetch(props.data.url, pdo).then(res => res.json()).then((result) => {
            Utils.setState(fn, setDivLogs, parse(result));
        }, (error) => {
            Utils.setState(fn, setDivLogs, Utils.error(error.message));
        });
    }
    ;
    function reload(ms) {
        Timeouts.clearAll(timeoutID);
        if (fn.closed.current)
            return;
        Timeouts.add(timeoutID, setTimeout(loadData, ms));
    }
    function parse(json) {
        if (!json.success) {
            return Utils.error(json.error);
        }
        data.hasnext = json.hasnext;
        data.hasprevious = json.hasprevious;
        const logs = json.logs;
        let min = Number.MAX_SAFE_INTEGER;
        let max = 0;
        for (let i = 0; i < logs.length; i++) {
            const log = logs[i];
            if (log.d > max)
                max = log.d;
            if (log.d < min)
                min = log.d;
        }
        data.min = min;
        data.max = max;
        if (!data.hasnext) {
            data.start = Number.MAX_SAFE_INTEGER;
            data.direction = 0;
            reload(5000);
        }
        const tableData = {
            defaultSortField: "d",
            direction: "descending",
            id: "alw",
            headers: [
                { name: "Time", field: "d", format: Utils.toDate, width: 180, colorRule: (row) => { return row.t || data.type ? Colors.red : Colors.tex; } },
                { name: "Message", field: "m", colorRule: (row) => { return row.t || data.type ? Colors.red : Colors.tex; }, noCrop: true }
            ],
            rows: logs
        };
        setTimeout(() => Utils.setState(fn, setRefreshing, false), 1000);
        return React.createElement(Table, { data: tableData });
    }
    function checked(e) {
        e.preventDefault();
        e.stopPropagation();
        const chk = e.currentTarget;
        data.type = chk.checked ? 1 : 0;
        data.start = Number.MAX_SAFE_INTEGER;
        data.hasnext = false;
        data.hasprevious = false;
        reload(10);
    }
    function previous() {
        data.direction = 0;
        data.start = data.min;
        reload(10);
    }
    function next() {
        data.direction = 1;
        data.start = data.max;
        reload(10);
    }
    function changeLimit(e) {
        data.limit = e.target.value;
        UserSettings.set("logviewer_limit", data.limit);
        reload(10);
    }
    return (React.createElement("div", { id: 'panel_log_viewer' },
        React.createElement("button", { disabled: !data.hasprevious, onClick: previous }, " Previous "),
        React.createElement("button", { disabled: !data.hasnext, onClick: next }, " Next "),
        React.createElement("select", { style: { marginLeft: "20px" }, onChange: changeLimit, value: data.limit },
            React.createElement("option", { val: "20" }, "20"),
            React.createElement("option", { val: "50" }, "50"),
            React.createElement("option", { val: "100" }, "100"),
            React.createElement("option", { val: "500" }, "500")),
        React.createElement("div", { style: { display: "inline-block" } },
            React.createElement("div", { className: "update_animation_box" }, refreshing && Utils.updating())),
        React.createElement(Checkbox, { css: { float: "right" }, label: "Show only errors", checked: data.type, onChange: checked }),
        divLogs));
};
const Mails = (props) => {
    const [receiverConfigured, setReceiverConfigured] = useState(null);
    const fn = { closed: useRef(false) };
    const [refreshed, refresh] = useState(0);
    function cleanUp() {
        fn.closed.current = true;
    }
    useEffect(() => { fn.closed.current = false; loadData(); return cleanUp; }, []);
    function loadData() {
        Request.send({ caller: fn, url: apiURL + "smtpsettings", params: { op: "getalertreceiver" },
            success: (json) => loaded(json)
        });
    }
    function loaded(json) {
        const mailConfigured = json.alertreceiver ? null :
            React.createElement("div", { key: "nodefaultmail" },
                React.createElement("h2", { style: { color: Colors.red } }, t("Mail address is not defined.")),
                React.createElement("br", null),
                t("You need to set a default mail address in order to receive alert mails."),
                React.createElement("br", null),
                React.createElement("br", null),
                React.createElement("a", { className: "linkbutton", href: "#alertsreceiver" }, t("Define mail address")));
        if (mailConfigured)
            Utils.setState(fn, setReceiverConfigured, mailConfigured);
    }
    ;
    function showAlerts(row, data) {
        const nid = row.id;
        const div = React.createElement(NotificationAlerts, { type: "mail", nid: nid });
        Dialog.show({ content: div, render: true });
    }
    const data = {
        defaultSortField: "id",
        direction: "descenting",
        id: "mails",
        update: refresh,
        loader: {
            refresh: 10000,
            url: apiURL + "mails",
            variables: { op: "list" },
            array: "mails"
        },
        headers: [
            { name: "ID", field: "id", pale: true, width: "40px" },
            { name: "From", field: "mail_from", showTooltip: true, pale: true },
            { name: "To", field: "mail_to", showTooltip: true, pale: true },
            { name: "Message", field: "msg", showTooltip: true, showBox: true, noCrop: true },
            { name: "Sent", field: "sent_date", format: Utils.toDate, width: "160px", pale: true },
            { name: "SMTP", field: "smtp_host", pale: true },
            { name: "Alerts", field: "alerts", onClick: showAlerts, icon: "logs.svg" },
        ]
    };
    const table = React.createElement("div", null,
        receiverConfigured,
        React.createElement(Table, { key: "mail_Table", data: data }));
    return (React.createElement("div", { id: 'mails_panel' }, table));
};
const MailsPage = (props) => {
    const fn = { closed: useRef(false) };
    function cleanUp() {
        fn.closed.current = true;
    }
    function back(e) {
        e.preventDefault();
        cleanUp();
        Utils.goBack(props.history);
    }
    return (React.createElement("div", { id: 'page' },
        React.createElement(Header, { back: back, title: t("Mails") }),
        React.createElement(Tabs, { default: null, id: "tabs_mails", key: "tabs_mails" },
            React.createElement(Tab, { key: 'mails', name: 'mails', label: 'Mails' },
                "   ",
                React.createElement(Mails, null),
                " "),
            React.createElement(Tab, { key: 'mailerrors', name: 'mailerrors', label: 'Errors' },
                "   ",
                React.createElement(MailErrors, null),
                " "))));
};
const Menu = (props) => {
    const [systems, setSystems] = useState(null);
    const [r, refresh] = useState(0);
    const fn = { exited: false };
    const timeoutID = "menu";
    function cleanUp() {
        fn.exited = true;
        Timeouts.clearAll(timeoutID);
    }
    useEffect(() => { getInstanceMethods(); getSystems(); return cleanUp; }, [props]);
    Menu.refresh = function () {
        Debugger.print("Menu.refresh");
        getSystems();
    };
    function getSystems() {
        Timeouts.clearAll(timeoutID);
        if (fn.exited)
            return;
        let pdo = Utils.postDataOptions({ op: "systemtree", summary: Data.hideMenu });
        fetch(apiURL + "systems", pdo).then(res => res.json()).then((result) => {
            parseSystems(result);
            if (Dialog.name == "connection_lost")
                Dialog.close();
        }, (error) => {
            console.log(error.message);
            Dialog.error({ message: "SysRanger server is not running.", width: 400, height: 200, modal: true, name: "connection_lost" });
        }).then(() => {
            if (fn.exited)
                return;
            Timeouts.add(timeoutID, setTimeout(getSystems, 5000));
        });
    }
    function getInstanceMethods() {
        let pdo = Utils.postDataOptions({ op: "allinstancemethods" });
        fetch(apiURL + "instances", pdo).then(res => res.json()).then((result) => {
            parseInstanceMethods(result);
        }, (error) => {
            console.log(error.message);
        });
    }
    function parseInstanceMethods(json) {
        if (!json.success || !json.instances)
            return;
        const list = {};
        let methodReceived = false;
        for (let i = 0; i < json.instances.length; i++) {
            const instance = json.instances[i];
            list[instance.id] = instance.methods;
            if (instance.methods.length > 0) {
                methodReceived = true;
            }
        }
        Data.methods = list;
        if (!methodReceived) {
            setTimeout(getInstanceMethods, 5000);
        }
        else {
            setTimeout(getInstanceMethods, 60000);
        }
    }
    function getAlerts() {
        const style = { width: "31px", height: "25px", textAlign: "center", color: "#ffffff", fontWeight: "800", paddingTop: "5px", marginLeft: "5px", borderRadius: "2px" };
        const alertCount = (systems && systems.alertCount) ? systems.alertCount : 0;
        if (alertCount > 0) {
            style.background = "#990000";
        }
        else {
            style.background = "#008800";
        }
        return React.createElement("div", { style: style, title: t("Alerts") },
            "   ",
            alertCount,
            "  ");
    }
    function copyItem(source, target) {
        for (const key in source) {
            target[key] = source[key];
            target["n"] = source.n + ".";
            if (!source.c)
                continue;
            target.c = [];
            for (var i = 0; i < source.c.length; i++) {
                const cs = source.c[i];
                if (cs.admin)
                    continue;
                const ct = {};
                copyItem(cs, ct);
                target.c.push(ct);
            }
        }
    }
    function getTree() {
        const menuItems = [];
        if (SysRanger.remote && SysRanger.companyCount > 1) {
            menuItems.push({ n: t("Companies"), i: "network.svg", link: "#/companies" });
        }
        const hosts = [];
        hosts.push({ n: t("Operating Systems"), i: "os_unknown.svg", link: "#oslist" });
        for (const key in Data.hosts) {
            const host = Data.hosts[key];
            const item = {};
            copyItem(host, item);
            hosts.push(item);
        }
        menuItems.push({ n: t("Servers"), i: "computer.svg", link: "#/units", c: hosts }, { n: t("Reports"), i: "chart1.svg",
            c: [
                { n: t("Alerts"), i: "alert1.svg", link: "#alertreport" },
                { n: t("SAP"), i: "icon4.svg", link: "#sapreport" },
            ]
        });
        if (User.admin) {
            menuItems.push({ n: t("Groups"), i: "group.svg", link: "#/groups" }, { n: t("Systems"), i: "neural.svg", link: "#/systems" }, { n: t("Settings"), i: "settings.svg", link: "#/settings" });
            if (User.allowed("ALERT_SETTINGS")) {
                menuItems.push({ n: t("Alert Settings"), i: "maintenance.svg",
                    c: [
                        { n: t("Alert Receiver"), i: "ic_phone_in_talk_24px.svg", link: "#alertsreceiver" },
                        { n: t("Thresholds"), i: "timeline_black_24dp.svg", link: "#alertthresholds" },
                        { n: t("Host Alert Settings"), i: "assessment_black_24dp.svg", link: "#hostalertsettings" },
                        { n: t("SMS/Calls"), i: "ic_ring_volume_24px.svg", link: "#smslist" },
                    ]
                });
            }
        }
        if (User.super) {
            menuItems.push({ n: t("Inventory"), i: "devices.svg", link: "#/inventory" }, { n: t("SAP Instances"), i: "three_dots.svg", link: "#/instances" }, { n: t("Databases"), i: "database1.svg", link: "#/databases" }, { n: t("Mails"), i: "mail1.svg", link: "#/mails" }, { n: t("Topology"), i: "neural.svg", link: "#/topology" }, { n: t("Utilities"), i: "apps.svg",
                c: [
                    { n: t("Port Scan"), i: "network-switch.svg", link: "#portscanner" },
                    { n: t("Network Scan"), i: "devices.svg", link: "#networkscanner" }
                ]
            }, { n: t("Logs"), i: "logs.svg", link: "#applicationlogs" });
        }
        const menu = [
            { n: t("Dashboard"), i: "dashboard.svg", link: "#/home" },
            { n: t("Status"), i: "dashboard.svg", link: "#/status" },
            { n: t("Menu"), i: "menu.svg", c: menuItems }
        ];
        if (systems && systems.groups) {
            for (let i = 0; i < systems.groups.length; i++) {
                menu.push(systems.groups[i]);
            }
        }
        if (systems && systems.systems) {
            for (let i = 0; i < systems.systems.length; i++) {
                const system = systems.systems[i];
                menu.push(system);
            }
        }
        const data = {
            json: menu,
            showCount: 10
        };
        return React.createElement(Tree, { data: data, history: props.history });
    }
    function parseSystems(data) {
        if (!data || !data.systems) {
            return;
        }
        Data.maintenance = data.mm;
        Data.version = data.ver;
        const paleOpacity = 0.5;
        const systems = [];
        const groups = [];
        const groupMap = {};
        for (let i = 0; i < data.groups.length; i++) {
            const group = data.groups[i];
            group.link = "#group/" + group.id;
            group.label = React.createElement("div", { style: { display: "inline-block", height: "12px" } },
                React.createElement("strong", null, group.cd),
                React.createElement("span", { className: "paletext", style: { paddingLeft: "10px" } }, "(" + group.nm + ")"));
            group.n = group.cd + group.id;
            group.tooltip = (group) => { return group.cd + "\n" + group.nm; };
            if (Utils.toInt(group.aa) > 0) {
                if (!group.items)
                    group.items = [];
                const item = React.createElement("a", { key: "si_" + group.id + "_" + group.n + group.items.length, style: { color: "#bb0000" }, title: "Alerts", href: "#/alerts/?gid=" + group.id }, "(" + group.aa + ")");
                group.items.push(item);
            }
            group.i = "group.svg?v=2";
            group.imageClass = Utils.alertSVGClass(group.mat);
            groupMap[group.id] = group;
            group.c = [];
            groups.push(group);
            Data.groups[group.id] = { code: group.cd, name: group.nm };
        }
        for (let i = 0; i < data.systems.length; i++) {
            const system = data.systems[i];
            Data.systems[system.id] = { cd: system.cd, id: system.id, gid: system.gid, nm: system.nm, sap: system.sap };
            system.tooltip = (item) => item.name;
            if (system.id > 0) {
                system.link = "#system/" + system.id;
            }
            else {
                system.link = "#/units";
            }
            system.label = React.createElement("div", { style: { display: "inline-block", height: "12px" } },
                React.createElement("strong", null, system.cd),
                React.createElement("span", { className: "paletext", style: { paddingLeft: "10px" } }, "(" + system.nm + ")"));
            system.n = system.cd + system.id;
            if (Utils.toInt(system.aa) > 0) {
                if (!system.items)
                    system.items = [];
                const item = React.createElement("a", { key: "si_" + system.id + "_" + system.n + system.items.length, style: { color: "#bb0000" }, title: "Alerts", href: "#/alerts/?sid=" + system.id }, "(" + system.aa + ")");
                system.items.push(item);
            }
            if (system.mm) {
                if (!system.items)
                    system.items = [];
                let mmlink = "";
                if (User.admin)
                    mmlink = "#/systems";
                const item = React.createElement("a", { key: "sim_" + system.id + system.items.length, style: { color: "#bb0000" }, title: "Systems", href: mmlink },
                    React.createElement("img", { className: "blink svg_yellow", src: "images/icons/maintenance.svg", width: "16", title: t("This system is in maintenance mode !") }));
                system.items.push(item);
            }
            system.i = "icon" + system.ic + ".svg";
            system.imageClass = Utils.alertSVGClass(system.mat);
            const hosts = [];
            for (let h = 0; h < system.hosts.length; h++) {
                const host = system.hosts[h];
                host.n = host.name;
                Data.hosts[host.n] = host;
                host.label = (host.mt == UnitType.DEVICE ? host.alias : host.name) + " (" + host.ip + ")";
                if (Utils.toInt(host.aa) > 0) {
                    if (!host.items)
                        host.items = [];
                    const item = React.createElement("a", { key: "si_" + host.name + host.items.length, style: { color: "#bb0000" }, title: "Alerts", href: "#/alerts/?hid=" + host.id }, "(" + host.aa + ")");
                    host.items.push(item);
                }
                if (host.mm) {
                    if (!host.items)
                        host.items = [];
                    let mmlink = "";
                    if (User.admin)
                        mmlink = "#/hostalertsettings";
                    const item = React.createElement("a", { key: "hmi_" + host.name + host.items.length, style: { color: "#bb0000" }, title: "Alerts", href: mmlink },
                        React.createElement("img", { className: "blink svg_yellow", src: "images/icons/maintenance.svg", width: "16", title: t("This host is in maintenance mode !") }));
                    host.items.push(item);
                }
                host.i = "host.svg";
                host.imageClass = Utils.alertSVGClass(host.mat);
                host.tooltip = (host) => { return host.name + "\n" + host.ip + "\n" + host.alias; };
                host.link = "#unit-details/" + host.id;
                const instances = [];
                if (host.il && host.il.length) {
                    for (let k = 0; k < host.il.length; k++) {
                        const instance = host.il[k];
                        instance.n = instance.nr + " (" + instance.n + ")";
                        instance.host = host;
                        if (Utils.toInt(instance.aa) > 0) {
                            if (!instance.items)
                                instance.items = [];
                            const item = React.createElement("a", { key: "inaa_" + instance.id + instance.items.length, style: { color: "#bb0000" }, title: "Alerts", href: "#/alerts/?inid=" + instance.id }, "(" + instance.aa + ")");
                            instance.items.push(item);
                        }
                        instance.i = "instance.svg";
                        instance.imageClass = Utils.alertSVGClass(instance.mat);
                        instance.link = "#instance/" + instance.id;
                        if (User.super) {
                            instance.contextMenu = contextMenuInstance;
                        }
                        instance.c = [];
                        if (instance.ab) {
                            instance.c.push({ n: t("Dashboard"), i: "dashboard.svg", link: "#abapdashboard/" + instance.id });
                        }
                        const processes = { n: t("Processes"), i: "png/processes_green.png", link: "#instanceprocesses/" + instance.id };
                        if (!instance.pr) {
                            processes.i = "png/processes_error.png";
                        }
                        instance.c.push(processes);
                        if (Data.methods) {
                            setMethodList(instance);
                        }
                        instance.c.push({ n: t("Traces"), i: "info.svg", link: "#instancedevelopertraces/" + instance.id });
                        instance.c.push({ n: t("Properties"), i: "info.svg", link: "#instanceproperties/" + instance.id });
                        if (instance.ab) {
                            instance.c.push({ n: t("Security Audit Logs"), i: "security.svg", link: "#systemauditrfc/" + system.id });
                        }
                        instance.c.push({ n: t("Configurations"), i: "ic_format_list_bulleted_24px.svg", link: "#instanceconfigfiles/" + instance.id });
                        instances.push(instance);
                    }
                }
                for (let d = 0; d < host.databases.length; d++) {
                    const database = host.databases[d];
                    database.tooltipText = "Name:" + database.n + "\nType:" + database.tn + "\nDescription:" + database.alias;
                    database.label = database.n + " (" + database.tn + ")";
                    database.n = database.n + database.tn + database.alias;
                    if (Utils.toInt(database.aa) > 0) {
                        if (!database.items)
                            database.items = [];
                        const item = React.createElement("a", { key: "dbaa_" + database.id + database.items.length, style: { color: "#bb0000" }, title: "Alerts", href: "#/alerts/?dbid=" + database.id }, "(" + database.aa + ")");
                        database.items.push(item);
                    }
                    database.i = "database1.svg";
                    database.imageClass = Utils.alertSVGClass(database.mat);
                    database.link = "#database/" + database.id;
                    const components = { n: t("Components"), i: "processes.svg", link: "#database-components/" + database.id };
                    database.c = [components];
                    if (database.t == DBType.HANA) {
                        database.c.push({ n: t("Dashboard"), i: "dashboard.svg", link: "#hanadashboard/" + database.id + "/" + host.id });
                        const details = [];
                        details.push({ n: t("Backups"), i: "database2.svg", link: "#hanabackups/" + database.id });
                        details.push({ n: t("Configuration Parameters"), i: "logs.svg", link: "#database-configuration-parameters/" + database.id });
                        details.push({ n: t("Services"), i: "apps.svg", link: "#hana-services/" + database.id + "/" + database.label });
                        details.push({ n: t("Active Statements"), i: "apps.svg", link: "#hana-active-statements/" + database.id + "/" + database.label });
                        details.push({ n: t("System Overview"), i: "apps.svg", link: "#hana-system-overview/" + database.id + "/" + database.label });
                        details.push({ n: t("Backup Summary"), i: "apps.svg", link: "#hana-backup-summary/" + database.id + "/" + database.label });
                        details.push({ n: t("Licenses"), i: "apps.svg", link: "#hana-licenses/" + database.id + "/" + database.label });
                        details.push({ n: t("Connections"), i: "apps.svg", link: "#hana-connections/" + database.id + "/" + database.label });
                        details.push({ n: t("Transactions"), i: "apps.svg", link: "#hana-transactions/" + database.id + "/" + database.label });
                        details.push({ n: t("Tasks"), i: "apps.svg", link: "#hana-tasks/" + database.id + "/" + database.label });
                        details.push({ n: t("Table Locks"), i: "apps.svg", link: "#hana-table-locks/" + database.id + "/" + database.label });
                        details.push({ n: t("Alerts"), i: "apps.svg", link: "#hana-current-alerts/" + database.id + "/" + database.label });
                        details.push({ n: t("Alert History"), i: "apps.svg", link: "#hana-alert-history/" + database.id + "/" + database.label });
                        details.push({ n: t("Alert Checks"), i: "apps.svg", link: "#hana-alert-checks/" + database.id + "/" + database.label });
                        database.c.push({ n: t("Details"), i: "apps.svg", c: details });
                    }
                    instances.push(database);
                }
                instances.push({ n: t("Dashboard"), i: "dashboard.svg", link: "#hostdashboard/" + host.id + "/" + system.id });
                if (host.mt == UnitType.VCENTER) {
                    instances.push({ n: t("VMware vCenter"), i: "icon10.svg", link: "#vcenter/" + host.id });
                }
                if (User.admin) {
                    instances.push({ n: t("Add instance") + " [" + host.name + "]", i: "instance.svg", link: "#addinstance/" + host.id + "/" + system.id + "/" + host.name, opacity: paleOpacity, admin: true });
                }
                if (User.admin) {
                    instances.push({ n: t("Add database") + " [" + host.name + "]", i: "database1.svg", link: "#add-new-database/" + system.id + "/" + host.id + "/" + host.name, opacity: paleOpacity, admin: true });
                }
                host.c = instances;
                hosts.push(host);
            }
            if (User.admin && system.id > 0) {
                hosts.push({ n: t("Add host") + " [" + system.cd + "]", i: "host.svg", link: "#add-host-to-system/" + system.id, opacity: paleOpacity, admin: true });
            }
            system.c = hosts;
            if (groupMap[system.gid]) {
                groupMap[system.gid].c.push(system);
            }
            else {
                systems.push(system);
            }
        }
        if (User.allowed("ADD_SYSTEM")) {
            for (var i = 0; i < groups.length; i++) {
                const group = groups[i];
                group.c.push({ n: t("Add system"), i: "system.svg", link: "#add-new-system-to-group/" + group.id, opacity: paleOpacity, admin: true });
            }
        }
        if (User.admin && User.allowed("ADD_SYSTEM")) {
            systems.push({ n: t("Add system"), i: "system.svg", link: "#add-new-system", opacity: paleOpacity, admin: true });
        }
        if (User.admin && User.allowed("ADD_GROUP")) {
            systems.push({ n: t("Add group"), i: "group.svg", link: "#add-new-group", opacity: paleOpacity, admin: true });
        }
        Utils.setState(fn, setSystems, { systems: systems, groups: groups, alertCount: data.totalalerts });
    }
    ;
    function contextMenuInstance(data) {
        const content = React.createElement("ul", null,
            React.createElement("li", { onClick: () => { data.op = "start"; instanceStartStop(data); ContextMenu.close(); } }, "Start"),
            React.createElement("li", { onClick: () => { data.op = "stop"; instanceStartStop(data); ContextMenu.close(); } }, "Stop"),
            React.createElement("li", { onClick: () => { data.op = "restart"; instanceStartStop(data); ContextMenu.close(); } }, "Restart"),
            React.createElement("div", { className: "contextheader noselect" },
                data.item.n,
                " - ",
                data.item.host.n));
        ContextMenu.show({ event: data.e, content: content, closeListener: data.closeListener });
    }
    function instanceStartStop(data) {
        Debugger.print("Menu.instanceStartStop Op:" + data.op);
        if (!confirm("Are you sure you want to " + data.op + " system instance ?")) {
            return;
        }
        let pdo = Utils.postDataOptions({ op: "start", type: data.op, id: data.item.id });
        fetch(apiURL + "instances", pdo).then(res => res.json()).then((result) => {
            if (!result.success) {
                alert(result.error);
                return;
            }
            Utils.go(props.history, "/#/instanceprocesses/" + result.id);
        }, (error) => {
            alert(error.message);
        });
    }
    function setMethodList(instance) {
        const list = Data.methods[instance.id];
        if (!list)
            return;
        for (let i = 0; i < list.length; i++) {
            const method = list[i];
            switch (method) {
                case "GetAccessPointList":
                    instance.c.push({ n: t("Access points"), i: "network-switch.svg", link: "#instanceaccesspoints/" + instance.id });
                    break;
                case "ABAPReadSyslog":
                    instance.c.push({ n: t("Syslog"), i: "logs.svg", link: "#instancesystemlogs/" + instance.id });
                    break;
                case "GetQueueStatistic":
                    instance.c.push({ n: t("Queue statistic"), i: "columns.svg", link: "#instancequeuestatistic/" + instance.id });
                    break;
                case "GetAlertTree":
                    instance.c.push({ n: t("Alerts"), i: "exclamation1.svg", link: "#instancealerts/" + instance.id });
                    break;
                case "GWGetClientList":
                    instance.c.push({ n: t("Gateway clients"), i: "network-switch.svg", link: "#instancegatewayclients/" + instance.id });
                    break;
                case "ABAPGetWPTable":
                    instance.c.push({ n: t("WP table"), i: "apps.svg", link: "#instanceworkprocesses/" + instance.id });
                    break;
                case "EnqGetStatistic":
                    instance.c.push({ n: t("Enqueue Statistics"), i: "columns.svg", link: "#instanceenqueuestatistic/" + instance.id });
                    break;
                case "J2EEGetComponentList":
                    instance.c.push({ n: t("AS Java Components"), i: "eye.svg", link: "#instancejavacomponents/" + instance.id });
                    break;
                case "J2EEGetProcessList2":
                    instance.c.push({ n: t("AS Java Processes"), i: "eye.svg", link: "#instancejavaprocesses/" + instance.id });
                    break;
                case "J2EEGetCacheStatistic2":
                    instance.c.push({ n: t("AS Java Caches"), i: "eye.svg", link: "#instancejavacaches/" + instance.id });
                    break;
                case "J2EEGetThreadList2":
                    instance.c.push({ n: t("AS Java Threads"), i: "eye.svg", link: "#instancejavathreads/" + instance.id });
                    break;
                case "J2EEGetVMHeapInfo":
                    instance.c.push({ n: t("AS Java Heap Memory"), i: "eye.svg", link: "#instancejavaheap/" + instance.id });
                    break;
                case "ICMGetConnectionList":
                    insertICMMethod(instance, method);
                    break;
                case "ICMGetThreadList":
                    insertICMMethod(instance, method);
                    break;
                case "ICMGetCacheEntries":
                    insertICMMethod(instance, method);
                    break;
                case "ICMGetProxyConnectionList":
                    insertICMMethod(instance, method);
                    break;
            }
        }
    }
    function insertICMMethod(instance, method) {
        let parent = null;
        for (let i = 0; i < instance.c.length; i++) {
            if (instance.c[i].id == "icm") {
                parent = instance.c[i];
                break;
            }
        }
        if (!parent) {
            parent = { n: "ICM", id: "icm", c: [], i: "network.svg", link: "#instance-icm/" + instance.id };
            instance.c.push(parent);
        }
        switch (method) {
            case "ICMGetConnectionList":
                parent.c.push({ n: t("Connections"), i: "network.svg", link: "#instance-icm-connections/" + instance.id });
                break;
            case "ICMGetThreadList":
                parent.c.push({ n: t("Threads"), i: "network.svg", link: "#instance-icm-threads/" + instance.id });
                break;
            case "ICMGetCacheEntries":
                parent.c.push({ n: t("Cache"), i: "network.svg", link: "#instance-icm-cache/" + instance.id });
                break;
            case "ICMGetProxyConnectionList":
                parent.c.push({ n: t("Proxy Connections"), i: "network.svg", link: "#instance-icm-proxy-connections/" + instance.id });
                break;
        }
    }
    function hide() {
        Data.hideMenu = !Data.hideMenu;
        Call.refresh();
    }
    const tree = !Data.hideMenu && getTree();
    const alerts = getAlerts();
    const logoFile = "logo_small_white_30.png";
    let w = 348;
    if (Data.hideMenu) {
        w = 48;
    }
    let userColorClass = "";
    switch (User.type) {
        case 1:
            userColorClass = "svg_bronze";
            break;
        case 20:
            userColorClass = "svg_gray";
            break;
        case 99:
            userColorClass = "svg_yellow";
            break;
    }
    const userIcon = React.createElement("a", { href: "#user" },
        React.createElement("img", { type: "svg", className: userColorClass, src: "images/icons/user2.svg", width: "28", title: User.name }));
    return (React.createElement("div", { id: 'main_menu', style: { width: (w + 2) + "px" }, className: "noprint" },
        React.createElement("div", { id: 'main_menu_fixed', style: { position: "fixed", overflow: "auto", height: "100%", width: w + "px" } },
            React.createElement("div", { style: { marginLeft: "4px", paddingBottom: "14px", paddingTop: "15px", marginBottom: "20px", height: "30px", textAlign: "center" } },
                React.createElement("div", { className: "topmenuicon" },
                    React.createElement("a", { href: "#", title: "SysRanger " + Data.version },
                        "         ",
                        React.createElement("img", { width: "30", src: "images/" + logoFile, style: { borderRadius: "2px" } }),
                        " ")),
                React.createElement("div", { className: "topmenuicon" },
                    React.createElement("a", { href: "#alerts" },
                        " ",
                        alerts,
                        "  ")),
                Data.maintenance &&
                    React.createElement("div", { className: "topmenuicon" },
                        React.createElement("img", { className: "blink svg_yellow", src: "images/icons/maintenance.svg", width: "28", title: t("Maintenance mode") })),
                !SysRanger.demo &&
                    React.createElement("div", { className: "topmenuicon" }, userIcon),
                React.createElement("div", { className: "topmenuicon", style: { float: Data.hideMenu ? "left" : "right" } }, Data.hideMenu ?
                    React.createElement("img", { className: "imagebutton", type: "svg", style: { width: "24px" }, src: "/images/icons/eye.svg", onClick: hide, title: t("Show Menu") }) :
                    React.createElement("img", { className: "imagebutton", type: "svg", style: { width: "24px" }, src: "/images/icons/hide.svg", onClick: hide, title: t("Hide Menu") }))),
            React.createElement("div", { style: { paddingLeft: "2px" } }, tree))));
};
class About extends Component {
    render() {
        return (React.createElement("div", { id: 'page' },
            React.createElement("h1", null, "About")));
    }
}
const AddSmtp = (props) => {
    const [fields, setFields] = useState({ host: "", port: "", user: "", password: "", from: "", ssl: false, startTLS: true });
    const [errors, setErrors] = useState({});
    const [success, setSuccess] = useState(null);
    const [error, setError] = useState(null);
    const required = ["host", "port", "user", "password", "from"];
    function cleanUp() {
    }
    function back(e) {
        e.preventDefault();
        cleanUp();
        Utils.goBack(props.history);
    }
    function handleValidation() {
        const errors = {};
        let formIsValid = true;
        for (let i = 0; i < required.length; i++) {
            const field = required[i];
            if (!fields[field] || fields[field].length < 1) {
                formIsValid = false;
                errors[field] = "Required field";
            }
        }
        setErrors(errors);
        return formIsValid;
    }
    function handleChange(e) {
        const field = e.currentTarget.getAttribute('field');
        const value = e.target.type === "checkbox" ? e.target.checked : e.target.value;
        setFields(Object.assign(Object.assign({}, fields), { [field]: value }));
    }
    function submit(e) {
        e.preventDefault();
        if (!handleValidation())
            return;
        const options = Object.assign(Object.assign({}, fields), { op: "add" });
        const pdo = Utils.postDataOptions(options);
        fetch(apiURL + "smtpsettings", pdo)
            .then(response => response.json())
            .then((result) => {
            console.log(result);
            if (result.success) {
                console.log("Returning previous page...");
                props.history.push("mailsettings");
                return;
            }
            else {
                Info.error(result.error);
                setError(result.error);
                if (result.field) {
                    setErrors({ [result.field]: result.error });
                }
            }
        }, (error) => {
            Info.error(error.message);
            setError(error.message);
        });
    }
    function test(e) {
        e.preventDefault();
        if (!handleValidation())
            return;
        const options = Object.assign(Object.assign({}, fields), { op: "test" });
        const pdo = Utils.postDataOptions(options);
        fetch(apiURL + "smtpsettings", pdo)
            .then(response => response.json())
            .then((result) => {
            console.log(result);
            if (result.success) {
                setError(null);
                setSuccess(true);
                Info.success("Test mail is sent");
            }
            else {
                Info.error(result.error);
                setError(result.error);
                if (result.field) {
                    setErrors({ [result.field]: result.error });
                }
            }
        }, (error) => {
            Info.error(error.message);
            setError(error.message);
        });
    }
    let status = null;
    if (error) {
        status = React.createElement("div", { style: { color: "red" } }, t("Connection is not succesfull") + " - " + t(error));
    }
    if (success) {
        status = React.createElement("div", null, t("Test is succesfull"));
    }
    console.log(errors);
    return (React.createElement("div", { id: 'page' },
        React.createElement(Header, { back: back, title: t("Add new SMTP server") }),
        React.createElement("div", { className: "box" },
            React.createElement("br", null),
            React.createElement("table", { className: "nobordertable nohover" },
                React.createElement("tbody", null,
                    React.createElement("tr", null,
                        React.createElement("td", null, t("Host")),
                        React.createElement("td", null,
                            "  ",
                            React.createElement("input", { type: "text", size: "30", field: "host", placeholder: "smtp.domain.com", onChange: handleChange, value: fields["host"] }),
                            "        "),
                        React.createElement("td", { style: { color: "red" } },
                            t(errors["host"]),
                            " ")),
                    React.createElement("tr", null,
                        React.createElement("td", null, t("Port")),
                        React.createElement("td", null,
                            "  ",
                            React.createElement("input", { type: "text", size: "30", field: "port", placeholder: "587", onChange: handleChange, value: fields["port"] }),
                            "        "),
                        React.createElement("td", { style: { color: "red" } },
                            t(errors["port"]),
                            " ")),
                    React.createElement("tr", null,
                        React.createElement("td", null, t("Mail from")),
                        React.createElement("td", null,
                            "  ",
                            React.createElement("input", { type: "text", size: "30", field: "from", placeholder: "alert@sysranger.com", onChange: handleChange, value: fields["from"] }),
                            "        "),
                        React.createElement("td", { style: { color: "red" } },
                            t(errors["from"]),
                            " ")),
                    React.createElement("tr", null,
                        React.createElement("td", null, t("User")),
                        React.createElement("td", null,
                            "  ",
                            React.createElement("input", { type: "text", size: "30", field: "user", placeholder: "alert@domain.com", onChange: handleChange, value: fields["user"] }),
                            "        "),
                        React.createElement("td", { style: { color: "red" } },
                            t(errors["user"]),
                            " ")),
                    React.createElement("tr", null,
                        React.createElement("td", null, t("Password")),
                        React.createElement("td", null,
                            "  ",
                            React.createElement("input", { type: "password", size: "30", field: "password", placeholder: "password", onChange: handleChange, value: fields["password"] }),
                            "        "),
                        React.createElement("td", { style: { color: "red" } },
                            t(errors["password"]),
                            " ")),
                    React.createElement("tr", null,
                        React.createElement("td", null, "SSL"),
                        React.createElement("td", null,
                            "  ",
                            React.createElement("input", { type: "checkbox", size: "30", field: "ssl", onChange: handleChange, checked: fields["ssl"] }),
                            "        "),
                        React.createElement("td", { style: { color: "red" } },
                            t(errors["ssl"]),
                            " ")),
                    React.createElement("tr", null,
                        React.createElement("td", null, "startTLS"),
                        React.createElement("td", null,
                            "  ",
                            React.createElement("input", { type: "checkbox", size: "30", field: "startTLS", onChange: handleChange, checked: fields["startTLS"] }),
                            "        "),
                        React.createElement("td", { style: { color: "red" } },
                            t(errors["startTLS"]),
                            " ")))),
            React.createElement("fieldset", null,
                React.createElement("button", { className: "btn btn-lg pro", onClick: test },
                    " ",
                    t("Test Connection")),
                React.createElement("button", { className: "btn btn-lg pro", onClick: submit }, t("Add")),
                React.createElement("button", { className: "btn btn-lg pro", onClick: back }, t("Cancel"))),
            React.createElement("div", { id: 'status' },
                status,
                "   "))));
};
const AppParameters = {
    "param-timeout-sap-ws-connection": { type: "long", min: "1000", max: "1000000", multiply: 1000, name: "SAP Web Service Connection Timeout (s)" },
    "param-timeout-sap-ws-read": { type: "long", min: "1000", max: "1000000", multiply: 1000, name: "SAP Web Service Read Timeout (s)" },
    "param-timeout-probe-request": { type: "long", min: "1000", max: "1000000", multiply: 1000, name: "Probe Request Timeout (s)",
        description: "Maximum time to wait response from probe"
    },
    "param-timeout-database-port-check": { type: "long", min: "1000", max: "1000000", multiply: 1000, name: "Database Port Check Timeout (s)" },
    "param-timeout-alert-autoremove": { type: "long", min: "3600000", max: "172800000", multiply: 3600000, name: "Alarm auto-remove timeout (hour)" }
};
const ApplicationParameters = (props) => {
    const [divDetails, setDivDetails] = useState(null);
    const fn = { closed: useRef(false) };
    const [refreshing, setRefreshing] = useState(1);
    function cleanUp() {
        fn.closed.current = true;
    }
    function back(e) { e.preventDefault(); cleanUp(); Utils.goBack(props.history, "/#settings"); }
    useEffect(() => { fn.closed.current = false; loadData(); return cleanUp; }, [refreshing]);
    function loadData() {
        if (fn.closed.current)
            return;
        console.log("load Data");
        const pdo = Utils.postDataOptions({ op: "startswith", key: "param-timeout" });
        fetch(apiURL + "settings", pdo).then(res => res.json()).then((result) => {
            Utils.setState(fn, setDivDetails, parse(result));
        }, (error) => {
            Utils.setState(fn, setDivDetails, Utils.error(error.message));
        });
    }
    ;
    function update(params) {
        if (fn.closed.current)
            return;
        const key = params.skey;
        const input = document.getElementById("input-" + key);
        let value = input.value;
        const min = params.min;
        const max = params.max;
        const type = params.datatype;
        if (params.multiply && value > 0) {
            value = value * params.multiply;
        }
        const pdo = Utils.postDataOptions({ op: "set", name: key, value: value, type: type, min: min, max: max });
        let ks = key.replace("param-", "");
        fetch(apiURL + "settings", pdo).then(res => res.json()).then((result) => {
            if (result.success) {
                Info.success(ks + " is set to:" + input.value);
                setTimeout(loadData, 100);
            }
            else {
                Info.error(result.error);
                loadData();
                Utils.setState(fn, setRefreshing, Utils.timeStamp());
            }
        }, (error) => {
            Info.error(error.message);
        });
    }
    ;
    function parse(json) {
        if (!json.success) {
            return Utils.error(json.error);
        }
        const trs = [];
        for (let i = 0; i < json.rows.length; i++) {
            const row = json.rows[i];
            if (row.ingroup)
                continue;
            const param = AppParameters[row.key] || {};
            const params = { title: "" };
            let value = row.value;
            params.type = param.type || "long";
            params.min = param.min || 0;
            params.max = param.max || 100000000;
            if (param.name) {
                params.title = param.name + " Min:" + (param.multiply ? params.min / param.multiply : params.min) + " Max:" + (param.multiply ? params.max / param.multiply : params.max);
            }
            if (param.multiply) {
                alert.value = value / param.multiply;
            }
            let key = row.key.replace("param-", "");
            const tr = React.createElement("tr", { key: "appp_" + i },
                React.createElement("td", { title: params.title }, param.name || key),
                React.createElement("td", null, alert.value),
                React.createElement("td", null,
                    React.createElement("input", { type: 'text', id: "input-" + row.key, defaultValue: alert.value, style: { width: "50px" } }),
                    React.createElement(IconButton, { type: "update", size: "30", skey: row.key, datatype: params.type, min: params.min, max: params.max, multiply: param.multiply, onClick: update, title: t("Update") })));
            trs.push(tr);
        }
        const div = React.createElement("table", { className: "nobordertable" },
            React.createElement("thead", null,
                React.createElement("tr", { style: { fontWeight: "bold" } },
                    React.createElement("td", { width: "400" }, "Parameter"),
                    React.createElement("td", { width: "130" }, "Value"),
                    React.createElement("td", null, "Update"))),
            React.createElement("tbody", null, trs));
        return div;
    }
    return (React.createElement("div", { id: 'panel_app_parameters' },
        divDetails,
        React.createElement("br", null)));
};
const ApplicationSettings = (props) => {
    const [divDetails, setDivDetails] = useState(null);
    const [refreshing, setRefreshing] = useState(true);
    const [updateStatus, setUpdateStatus] = useState(null);
    const [probeDownloadStatus, setprobeDownloadStatus] = useState(null);
    let refreshTimeout = 0;
    const fn = { closed: useRef(false) };
    function cleanUp() {
        fn.closed.current = true;
        clearTimeout(refreshTimeout);
    }
    function back(e) { e.preventDefault(); Utils.goBack(props.history, "/#"); }
    useEffect(() => { fn.closed.current = false; loadData(); return cleanUp; }, []);
    function loadData() {
        if (fn.closed.current)
            return;
        Utils.setState(fn, setRefreshing, true);
        let pdo = Utils.postDataOptions({ op: "info" });
        fetch(apiURL + "application", pdo).then(res => res.json()).then((result) => {
            Utils.setState(fn, setDivDetails, parse(result));
        }, (error) => {
            Utils.setState(fn, setDivDetails, Utils.error(error.message));
        }).then(() => {
            if (fn.closed.current)
                return;
            setTimeout(() => Utils.setState(fn, setRefreshing, false), 1000);
            refreshTimeout = setTimeout(loadData, 10000);
        });
    }
    ;
    function update() {
        const message = t("This process will update SysRanger Server. The server will be closed. Are you sure ?");
        if (!confirm(message)) {
            return;
        }
        if (fn.closed.current)
            return;
        let pdo = Utils.postDataOptions({ op: "update" });
        fetch(apiURL + "application", pdo).then(res => res.json()).then((result) => {
            if (result.success) {
                Utils.setState(fn, setUpdateStatus, "Update started");
            }
            else {
                Utils.setState(fn, setUpdateStatus, result.error);
            }
        }, (error) => {
            Utils.setState(fn, setUpdateStatus, Utils.error(error.message));
        });
    }
    ;
    function downloadProbe() {
        if (fn.closed.current)
            return;
        Utils.setState(fn, setprobeDownloadStatus, "Download started");
        let pdo = Utils.postDataOptions({ op: "downloadprobe" });
        fetch(apiURL + "application", pdo).then(res => res.json()).then((result) => {
            if (result.success) {
                Utils.setState(fn, setprobeDownloadStatus, "Download Completed");
            }
            else {
                Utils.setState(fn, setprobeDownloadStatus, result.error);
            }
        }, (error) => {
            Utils.setState(fn, setprobeDownloadStatus, Utils.error(error.message));
        });
    }
    ;
    function parse(json) {
        if (!json.success) {
            return Utils.error(json.error);
        }
        const div = React.createElement("table", null,
            React.createElement("tbody", null,
                React.createElement("tr", null,
                    React.createElement("td", null, "Name"),
                    React.createElement("td", null, json.name)),
                React.createElement("tr", null,
                    React.createElement("td", null, "Version"),
                    React.createElement("td", null, json.version)),
                React.createElement("tr", null,
                    React.createElement("td", null, "Timestamp"),
                    React.createElement("td", null, Utils.toDate(json.timestampms))),
                React.createElement("tr", null,
                    React.createElement("td", null, "Time"),
                    React.createElement("td", null, json.time)),
                React.createElement("tr", null,
                    React.createElement("td", null, "Web port"),
                    React.createElement("td", null, json.webport)),
                React.createElement("tr", null,
                    React.createElement("td", null, "Agent port"),
                    React.createElement("td", null, json.probeport)),
                React.createElement("tr", null,
                    React.createElement("td", null, "Remote connected"),
                    React.createElement("td", null, Utils.yesno(json.remoteconnected))),
                React.createElement("tr", null,
                    React.createElement("td", null, "Active agents"),
                    React.createElement("td", null, json.activeprobes))));
        return div;
    }
    return (React.createElement("div", { id: 'page' },
        React.createElement(Header, { back: back, title: t("Application") }),
        React.createElement("div", { className: "update_animation_box" }, refreshing && Utils.updating()),
        React.createElement("a", { href: "#/applicationlogs" }, "Logs"),
        divDetails,
        React.createElement("br", null),
        Data.debug && React.createElement("div", null,
            React.createElement("button", { key: 'button_update', onClick: update }, t("Update Application")),
            React.createElement("div", { key: 'div_update_status' },
                " ",
                updateStatus,
                " ")),
        User.admin && React.createElement("div", null,
            React.createElement("button", { key: 'button_download_probe', onClick: downloadProbe }, t("Download latest probe")),
            React.createElement("div", { key: 'div_probe_download_status' },
                " ",
                probeDownloadStatus,
                " "))));
};
const ApplicationStatus = (props) => {
    const [info, setInfo] = useState(null);
    const [refreshing, setRefreshing] = useState(true);
    const [smsStatus, setSmsStatus] = useState({ message: "", status: 0 });
    let refreshTimeout = 0;
    const fn = { closed: useRef(false) };
    function cleanUp() {
        fn.closed.current = true;
        clearTimeout(refreshTimeout);
    }
    function back(e) { e.preventDefault(); Utils.goBack(props.history, "/#"); }
    useEffect(() => { fn.closed.current = false; loadData(); return cleanUp; }, []);
    function loadData() {
        if (fn.closed.current)
            return;
        Request.send({
            caller: fn,
            url: apiURL + "sms",
            params: { op: "serviceavailable" },
            listener: (json) => {
                smsStatus.status = json.success ? 1 : 2;
                smsStatus.message = json.error;
            }
        });
        Utils.setState(fn, setRefreshing, true);
        let pdo = Utils.postDataOptions({ op: "info" });
        fetch(apiURL + "application", pdo).then(res => res.json()).then((result) => {
            Utils.setState(fn, setInfo, result);
        }, (error) => {
            Utils.setState(fn, setInfo, { error: error.message });
        }).then(() => {
            if (fn.closed.current)
                return;
            setTimeout(() => Utils.setState(fn, setRefreshing, false), 1000);
            refreshTimeout = setTimeout(loadData, 10000);
        });
    }
    ;
    function page() {
        const json = info;
        if (!json)
            return "";
        if (!json.success) {
            return Utils.error(json.error);
        }
        let sv = json.version;
        let pv = json.latestprobeversion;
        if (json.latestserverversion) {
            if (json.version != json.latestserverversion) {
                sv = React.createElement("div", null,
                    React.createElement("span", { style: { color: "red" } }, json.version),
                    "  ",
                    React.createElement("span", null,
                        "There is a newer version v",
                        json.latestserverversion,
                        " "));
            }
            else {
                sv = React.createElement("div", null,
                    React.createElement("span", { style: { color: "green" } }, json.version),
                    "  ",
                    React.createElement("span", null, " Latest version "));
            }
        }
        else {
            sv = React.createElement("div", null,
                React.createElement("span", { style: { color: "gray" } }, json.version),
                "  ",
                React.createElement("span", null, "Cannot check new version"));
        }
        const div = React.createElement("table", null,
            React.createElement("tbody", null,
                React.createElement("tr", null,
                    React.createElement("td", null, "Server version"),
                    React.createElement("td", null, sv)),
                React.createElement("tr", null,
                    React.createElement("td", null, "Probe Version"),
                    React.createElement("td", null, pv)),
                React.createElement("tr", null,
                    React.createElement("td", null, "Time"),
                    React.createElement("td", null,
                        Utils.toDate(json.timestampms),
                        " / ",
                        json.time,
                        " ")),
                React.createElement("tr", null,
                    React.createElement("td", null, "Web port"),
                    React.createElement("td", null, json.webport)),
                React.createElement("tr", null,
                    React.createElement("td", null, "Agent port"),
                    React.createElement("td", null, json.probeport)),
                React.createElement("tr", null,
                    React.createElement("td", null, "Remote connected"),
                    React.createElement("td", null, Utils.yesno(json.remoteconnected))),
                React.createElement("tr", null,
                    React.createElement("td", null, "Active agents"),
                    React.createElement("td", null, json.activeprobes)),
                React.createElement("tr", null,
                    React.createElement("td", null, "SMS/Call Service"),
                    React.createElement("td", null,
                        " ",
                        Utils.onOffEmpty(smsStatus.status),
                        "  ",
                        smsStatus.message,
                        "  ")),
                React.createElement("tr", null,
                    React.createElement("td", null, "Valid License"),
                    React.createElement("td", null,
                        " ",
                        Utils.yesno(json["license.valid"]),
                        "  ",
                        json["license.error"],
                        " ")),
                json["license.demo"] &&
                    React.createElement("tr", null,
                        React.createElement("td", null, "Demo"),
                        React.createElement("td", null, " You are using demo.Please contact Sysranger team to activate a license. ")),
                React.createElement("tr", null,
                    React.createElement("td", null, "Expiration"),
                    React.createElement("td", null,
                        " ",
                        Utils.toDate(json["license.expiration"] * 1000),
                        "  ")),
                React.createElement("tr", null,
                    React.createElement("td", null, "Remaining"),
                    React.createElement("td", null,
                        " ",
                        Utils.secondToDay(json["license.remaining"]),
                        "  "))));
        return (React.createElement("div", null,
            React.createElement("div", null, div),
            React.createElement(Gauge2, { data: { size: 150,
                    value: json["cpu.percentage"],
                    text: Utils.toInt(json["cpu.percentage"]) + " %",
                    limits: { warning: json["cpu.warning"],
                        critical: json["cpu.critical"],
                        fatal: json["cpu.fatal"],
                        total: 100
                    }
                } })));
    }
    return (React.createElement("div", { id: 'page' },
        React.createElement(Header, { back: back, title: t("Application Status") }),
        React.createElement("div", { className: "update_animation_box" }, refreshing && Utils.updating()),
        page()));
};
const Company = function () {
    const [company, setCompany] = useState({ name: "", code: "", updated: 0 });
    const [a, refresh] = useState(0);
    const fn = { closed: useRef(false) };
    const inputName = useRef("");
    const inputCode = useRef("");
    function cleanUp() {
        fn.closed.current = true;
    }
    useEffect(() => { fn.closed.current = false; load(); return cleanUp; }, []);
    function back(e) { e.preventDefault(); cleanUp(); Utils.goBack(props.history, "#alerts"); }
    function load() {
        if (fn.closed.current)
            return;
        let pdo = Utils.postDataOptions({ op: "info" });
        fetch(apiURL + "company", pdo).then(res => res.json()).then((result) => {
            if (result.success) {
                company.name = result.name;
                company.code = result.code;
                Utils.setState(fn, setCompany, company);
                Utils.setState(fn, refresh, Utils.timeStamp());
            }
            else {
                Info.error(result.error);
            }
        }, (error) => {
            Info.error(error.message);
        });
    }
    function update() {
        if (fn.closed.current)
            return;
        let pdo = Utils.postDataOptions({ op: "set", name: inputName.current.value, code: inputCode.current.value });
        fetch(apiURL + "company", pdo).then(res => res.json()).then((result) => {
            if (result.success) {
                Info.success("Setting is saved");
            }
            else {
                Info.error(result.error);
            }
        }, (error) => {
            Info.error(error.message);
        });
    }
    return (React.createElement("div", { id: "page" },
        React.createElement(Header, { back: back, title: t("Company") }),
        React.createElement("div", null,
            t("Name"),
            React.createElement("br", null),
            React.createElement("input", { type: "text", ref: inputName, defaultValue: company.name }),
            React.createElement("br", null),
            t("Code"),
            React.createElement("br", null),
            React.createElement("input", { type: "text", ref: inputCode, defaultValue: company.code }),
            React.createElement("br", null),
            User.admin && React.createElement("button", { onClick: update }, t("Update")))));
};
const DashboardSettings = (props) => {
    const url = apiURL + "settings";
    const fn = { exited: false };
    const [panel, setPanel] = useState(null);
    function cleanUp() {
        fn.exited = true;
    }
    useEffect(() => { loadData(); return cleanUp; }, [props]);
    function loadData() {
        if (fn.exited)
            return;
        let pdo = Utils.postDataOptions({ op: "getall" });
        fetch(url, pdo).then(res => res.json()).then((result) => {
            Utils.setState(fn, setPanel, getPanel(result));
        }, (error) => {
            console.log(error);
            initCompleted(false, "Error while loading settings");
        });
    }
    ;
    function getPanel(json) {
        const rows = json.rows;
        const data = { "dashboard_showhosts": false };
        for (var key in rows) {
            const setting = rows[key];
            settings[setting.name] = setting.value;
        }
    }
    function handleChange(e) {
        const field = e.currentTarget.getAttribute('field');
        const value = e.target.type === "checkbox" ? e.target.checked : e.target.value;
        Utils.setState(fn, setFields, Object.assign(Object.assign({}, fields), { [field]: value }));
    }
    function back(e) {
        e.preventDefault();
        cleanUp();
        Utils.goBack(props.history);
    }
    return (React.createElement("div", { id: 'page' },
        React.createElement(Header, { back: back, title: t("Dashboard Settings") }),
        panel));
};
const Definitions = (props) => {
    function back(e) {
        e.preventDefault();
        Utils.goBack(props.history, "/#settings");
    }
    return (React.createElement("div", { id: 'page' },
        React.createElement(Header, { back: back, title: t("Definitions") }),
        React.createElement("h2", null, "Operating System Lifecycle List"),
        React.createElement(OSLifeCycles, null)));
};
const LicenseManager = (props) => {
    const [div, setDiv] = useState(null);
    const [status, setStatus] = useState(null);
    const fn = { closed: useRef(false) };
    function cleanUp() { fn.closed.current = true; }
    function back(e) { e.preventDefault(); cleanUp(); Utils.goBack(props.history, "/#"); }
    useEffect(() => { fn.closed.current = false; loadData(); return cleanUp; }, []);
    function loadData() {
        if (fn.exited)
            return;
        let pdo = Utils.postDataOptions({ op: "info" });
        fetch(apiURL + "licensemanager", pdo).then(res => res.json()).then((result) => {
            Utils.setState(fn, setDiv, parse(result));
        }, (error) => {
            Utils.setState(fn, setDiv, Utils.error(error.message));
        });
    }
    ;
    function activate(e) {
        e.preventDefault();
        let pdo = Utils.postDataOptions({ op: "activate" });
        fetch(apiURL + "licensemanager", pdo).then(res => res.json()).then((result) => {
            if (result.success) {
                alert("Activation completed");
                Utils.reload();
            }
            else {
                alert(result.error);
            }
        }, (error) => {
            alert(error.message);
        });
    }
    function parse(json) {
        if (!json.success) {
            return Utils.error(json.error);
        }
        return React.createElement("div", null,
            React.createElement("table", { key: "table_license_info" },
                React.createElement("tbody", null,
                    React.createElement("tr", null,
                        React.createElement("td", null, "Valid"),
                        React.createElement("td", null,
                            " ",
                            Utils.yesno(json.valid),
                            "  ",
                            json.error,
                            " ")),
                    json.demo &&
                        React.createElement("tr", null,
                            React.createElement("td", null, "Demo"),
                            React.createElement("td", null, " You are using demo.Please contact Sysranger team to activate a license. ")),
                    React.createElement("tr", null,
                        React.createElement("td", null, "Expiration"),
                        React.createElement("td", null,
                            " ",
                            Utils.toDate(json.expiration * 1000),
                            "  ")),
                    React.createElement("tr", null,
                        React.createElement("td", null, "Remaining"),
                        React.createElement("td", null,
                            " ",
                            Utils.secondToDay(json.remaining),
                            "  ")),
                    React.createElement("tr", null,
                        React.createElement("td", null, "HWKey"),
                        React.createElement("td", null,
                            " ",
                            json.hwkey,
                            "  ")))),
            React.createElement("button", { key: "button_activate", onClick: activate }, t("Activate")));
    }
    return (React.createElement("div", { id: 'page' },
        React.createElement(Header, { back: back, title: t("License") }),
        div));
};
const MailSettings = (props) => {
    const url = apiURL + "smtpsettings";
    const [state, setState] = useState({ error: null, isLoaded: false, data: [] });
    useEffect(() => { loadData(); return cleanUp; }, []);
    const fn = { exited: false };
    function loadData() {
        if (fn.exited)
            return;
        let pdo = Utils.postDataOptions({ op: "list" });
        fetch(url, pdo).then(res => res.json()).then((result) => {
            if (result.success) {
                Utils.setState(fn, setState, { isLoaded: true, data: result.rows });
            }
            else {
                Utils.setState(fn, setState, { isLoaded: true, error: result.error });
            }
        }, (error) => {
            Utils.setState(fn, setState, { isLoaded: true, error });
        });
    }
    ;
    function cleanUp() {
        fn.exited = true;
    }
    function back(e) {
        e.preventDefault();
        cleanUp();
        Utils.goBack(props.history);
    }
    function getTable(rows) {
        const divs = [];
        for (let i = 0; i < rows.length; i++) {
            const smtp = rows[i];
            const settings = React.createElement(SmtpSetting, { history: props.history, smtp: smtp, key: "ss_" + smtp.id });
            divs.push(settings);
        }
        return divs;
    }
    ;
    let status = null;
    let table = null;
    if (state.error) {
        status = state.error;
        console.log(state.error);
    }
    else if (state.data) {
        table = getTable(state.data);
    }
    return (React.createElement("div", { id: 'page' },
        React.createElement(Header, { back: back, title: t("Mail Settings") }),
        React.createElement("span", null, t("smtpdescription")),
        React.createElement("br", null),
        React.createElement("br", null),
        React.createElement("br", null),
        React.createElement("br", null),
        table,
        React.createElement("div", { className: "clear" }),
        React.createElement("br", null),
        React.createElement("br", null),
        React.createElement("div", { className: "error" }, t(status)),
        React.createElement("br", null),
        React.createElement("a", { href: "#/addsmtp", className: "linkbutton" }, t("Add new SMTP server"))));
};
const NetworkScanner = (props) => {
    const url = apiURL + "scannetwork";
    const [error, setError] = useState(null);
    let inputIP = createRef();
    let inputTimeout = createRef();
    const fn = { exited: false };
    function cleanUp() {
        fn.exited = true;
    }
    useEffect(() => { loadData(); return cleanUp; }, []);
    function loadData() {
        const options = { op: "getmynetwork" };
        const pdo = Utils.postDataOptions(options);
        fetch(url, pdo)
            .then(response => response.json())
            .then((result) => {
            inputIP.current.value = result.ip;
        }, (error) => {
            Utils.setState(fn, setDivSystem, Utils.error(error.message));
        });
    }
    function start() {
        const divScanResults = document.getElementById("networkscanresults");
        divScanResults.innerHTML = "";
        document.getElementById("networkscancurrent").innerHTML = t("Started");
        let ip = inputIP.current.value;
        const timeOut = inputTimeout.current.value;
        let options = { ip: ip, timeout: timeOut, op: "start" };
        let pdo = Utils.postDataOptions(options);
        fetch(url, pdo).then(res => res.json()).then((result) => {
            if (result.success) {
                readResults();
            }
            else {
                Utils.setState(fn, setError, result.error);
            }
        }, (error) => {
            Utils.setState(fn, setError, error.message);
        });
    }
    ;
    function readResults() {
        let options = { op: "result" };
        let pdo = Utils.postDataOptions(options);
        fetch(url, pdo).then(res => res.json()).then((result) => {
            if (result.success) {
                showResults(result);
                if (!result.completed) {
                    setTimeout(readResults, 1000);
                }
            }
            else {
                Utils.setState(fn, setError, result.error);
            }
        }, (error) => {
            Utils.setState(fn, setError, error.message);
        });
    }
    ;
    function showResults(data) {
        if (fn.exited)
            return;
        if (!data || !data.ports)
            return;
        const theDiv = document.getElementById("networkscanresults");
        for (let i = 0; i < data.ports.length; i++) {
            const port = data.ports[i];
            const line = port.id + " " + port.n + "<br/>";
            theDiv.innerHTML += line;
        }
        if (data.completed) {
            theDiv.innerHTML += t("completed");
        }
        const completed = data.completed ? " [" + t("completed") + "]" : "";
        const divCurrent = document.getElementById("networkscancurrent");
        divCurrent.innerHTML = t("Scanning") + ":" + data.current + " " + completed;
    }
    function back(e) { e.preventDefault(); cleanUp(); Utils.goBack(props.history); }
    let result = "";
    let status = null;
    if (error) {
        status = Utils.error(error);
    }
    return (React.createElement("div", { id: 'page' },
        React.createElement(Header, { back: back, title: t("Network Scanner") + " [PING]" }),
        t("Start"),
        " : 192.168.1   : ",
        t("Scans from 192.168.1.0 to 192.168.1.255"),
        "   ",
        React.createElement("br", null),
        t("Timeout"),
        " : ",
        t("Maximum response time from a host"),
        "  (",
        t("milisecond"),
        ") ",
        React.createElement("br", null),
        React.createElement("br", null),
        t("Start"),
        ":",
        React.createElement("input", { ref: inputIP, type: 'text', defaultValue: '192.168.1' }),
        t("Timeout"),
        ":",
        React.createElement("input", { ref: inputTimeout, type: 'text', defaultValue: '5000' }),
        React.createElement("button", { onClick: start },
            "\u00A0",
            t("Start")),
        React.createElement("br", null),
        status,
        React.createElement("div", { id: 'networkscancurrent' }),
        React.createElement("br", null),
        React.createElement("div", { id: 'networkscanresults', style: { overflow: "auto", height: "200px" } }),
        result));
};
const OSLifeCycles = (props) => {
    const fn = { closed: useRef(false) };
    const [content, setContent] = useState(null);
    function cleanUp() {
        fn.closed.current = true;
    }
    useEffect(() => { fn.closed.current = false; loadData(); return cleanUp; }, [props]);
    function loadData() {
        if (fn.closed.current)
            return;
        Request.send({ caller: fn, url: apiURL + "hosts", params: { op: "oslifecycles" },
            listener: (json) => Utils.setState(fn, setContent, parse(json))
        });
    }
    ;
    function parse(json) {
        if (!json.success) {
            return Utils.error(json.error);
        }
        const data = {
            defaultSortField: "nm",
            id: "tableoslifecycles",
            headers: [
                { name: "Name", field: "nm" },
                { name: "Support End", field: "se", format: Utils.toDaySec },
                { name: "Extended Support End", field: "le", format: Utils.toDaySec }
            ],
            rows: json.cycles
        };
        return React.createElement(Table, { data: data });
    }
    return (React.createElement("div", { id: 'panel_os_lifecycles' },
        React.createElement("span", null, t("Following list shows operating system support end dates. You'll receive an alert when one of the hosts you monitor exceeds its extended support end date.")),
        content));
};
const OSLifeCyclesPage = (props) => {
    function back(e) {
        e.preventDefault();
        Utils.goBack(props.history, "/#settings");
    }
    return (React.createElement("div", { id: 'page' },
        React.createElement(Header, { back: back, title: t("Operating System Lifecycle List") }),
        React.createElement(OSLifeCycles, null)));
};
const OSList = (props) => {
    const fn = { closed: useRef(false) };
    const [content, setContent] = useState(null);
    const timeoutID = "oslist";
    function cleanUp() {
        fn.closed.current = true;
        Timeouts.clearAll(timeoutID);
    }
    useEffect(() => { fn.closed.current = false; loadData(); return cleanUp; }, [props]);
    function loadData() {
        Timeouts.clearAll(timeoutID);
        if (fn.closed.current)
            return;
        Request.send({ caller: fn, url: apiURL + "hosts", params: { op: "oslist" },
            listener: (json) => Utils.setState(fn, setContent, parse(json)),
            then: () => Timeouts.add(timeoutID, setTimeout(loadData, 10000))
        });
    }
    ;
    function longColor(row, data) {
        if (row.lem < data.fatal)
            return Colors.red;
        if (row.lem < data.critical)
            return Colors.orange;
        if (row.lem < data.warning)
            return Colors.yellow;
        if (row.lem < data.info)
            return Colors.blue;
        return Colors.text;
    }
    function shortColor(row) {
        const time = Utils.timeStamp();
        if (time > row.se) {
            return Colors.yellow;
        }
        return Colors.text;
    }
    function parse(json) {
        if (!json.success) {
            return Utils.error(json.error);
        }
        const data = {
            defaultSortField: "nm",
            id: "tableoslist",
            headers: [
                { name: "Name", field: "nm", tooltip: (row) => row.ost },
                { name: "IP", field: "ip" },
                { name: "Manufacturer", field: "man" },
                { name: "Family", field: "fam" },
                { name: "Version", field: "ver2" },
                { name: "Build", field: "bui" },
                { name: "Support End", field: "se", format: Utils.toDay, colorRule: shortColor },
                { name: "Extended Support End", field: "le", format: Utils.toDay, colorRule: (row) => longColor(row, json) },
                { name: "Remaining Months", field: "lem", colorRule: (row) => longColor(row, json) },
            ],
            rows: json.hosts
        };
        return React.createElement(Table, { data: data });
    }
    return (React.createElement("div", { id: 'panel_os_list' }, content));
};
const OSListPage = (props) => {
    function back(e) {
        e.preventDefault();
        Utils.goBack(props.history, "/#dashboard");
    }
    function openLifeCycleList() {
        Dialog.show({ content: React.createElement(OSLifeCycles, null), render: true });
    }
    return (React.createElement("div", { id: 'page' },
        React.createElement(Header, { back: back, title: t("Operating Systems") }),
        React.createElement("div", { style: { float: "right" } },
            React.createElement(IconButton, { icon: "ic_info_outline_24px.svg", title: "Operating System Lifecycle List", onClick: openLifeCycleList })),
        React.createElement(OSList, null)));
};
const Passwords = (props) => {
    const [divPage, setDivPage] = useState(null);
    const fn = { exited: false, closed: useRef(false) };
    let inputPassword = createRef();
    function cleanUp() {
        fn.closed.current = true;
    }
    useEffect(() => { fn.closed.current = false; return cleanUp; }, []);
    function getPage() {
        if (fn.closed.current)
            return;
        let pdo = Utils.postDataOptions({ "op": "passwords", "password": inputPassword.current.value });
        fetch(apiURL + "application", pdo).then(res => res.json()).then((result) => {
            if (!result.success) {
                Info.error(result.error);
                return;
            }
            Utils.setState(fn, setDivPage, parse(result));
        }, (error) => {
            Info.error(error.message);
        });
    }
    ;
    function parse(json) {
        if (fn.closed.current)
            return;
        const dataHosts = {
            defaultSortField: "n",
            id: "pswhosts",
            headers: [
                { name: "Name", field: "n" },
                { name: "Description", field: "a" },
                { name: "IP", field: "ip" },
                { name: "User", field: "u" },
                { name: "Password", field: "p" }
            ],
            rows: json.hosts
        };
        const tableHosts = React.createElement(Table, { data: dataHosts });
        const dataInstances = {
            defaultSortField: "s",
            id: "pswinstances",
            headers: [
                { name: "System", field: "s", valueFunction: (row) => { return row.s + " (" + row.sn + ")"; } },
                { name: "Host", field: "hn", valueFunction: (row) => { return row.hn + " (" + row.ha + ") [" + row.ip + "]"; } },
                { name: "Name", field: "n", valueFunction: (row) => { return row.n + " " + row.a; } },
                { name: "User", field: "u" },
                { name: "Password", field: "p" }
            ],
            rows: json.instances
        };
        const tableInstances = React.createElement(Table, { data: dataInstances });
        const dataDatabases = {
            defaultSortField: "n",
            id: "pswdtabases",
            headers: [
                { name: "System", field: "s", valueFunction: (row) => { return row.s + " (" + row.sn + ")"; } },
                { name: "Host", field: "hn", valueFunction: (row) => { return row.hn + " (" + row.ha + ") [" + row.ip + "]"; } },
                { name: "Name", field: "n", valueFunction: (row) => { return row.n + " " + row.a; } },
                { name: "User", field: "u" },
                { name: "Password", field: "p" },
                { name: "OS User", field: "osu" },
                { name: "OS Password", field: "osp" },
                { name: "SCH User", field: "scu" },
                { name: "SCH Password", field: "scp" },
            ],
            rows: json.databases
        };
        const tableDatabases = React.createElement(Table, { data: dataDatabases });
        return React.createElement("div", null,
            React.createElement("h2", null, "Hosts"),
            tableHosts,
            React.createElement("h2", null, "Instances"),
            tableInstances,
            React.createElement("h2", null, "Databases"),
            tableDatabases);
    }
    function back(e) {
        e.preventDefault();
        cleanUp();
        Utils.goBack(props.history, "/#dashboard");
    }
    return (React.createElement("div", { id: 'page' },
        React.createElement(Header, { back: back, title: t("Passwords") }),
        React.createElement("input", { type: "password", ref: inputPassword, autoComplete: "off" }),
        React.createElement("button", { onClick: getPage }, t("Get")),
        React.createElement("br", null),
        divPage));
};
const PortScanner = (props) => {
    const url = apiURL + "scanports";
    const [nmapAvailable, setNMapAvailable] = useState(false);
    const [inputs, setInputs] = useState({ usenmap: false });
    const [error, setError] = useState(null);
    const [data, setData] = useState(null);
    let inputIP = createRef();
    let inputPort = createRef();
    let inputTimeout = createRef();
    const fn = { exited: false };
    function cleanUp() {
        fn.exited = true;
        stop();
    }
    useEffect(() => { checkIfNMapAvailable(); return cleanUp; }, []);
    function start() {
        const divScanResults = document.getElementById("portscanresults");
        divScanResults.innerHTML = "";
        let ip = inputIP.current.value;
        const rules = inputPort.current.value;
        const timeOut = inputTimeout.current.value;
        let options = { ip: ip, rules: rules, timeout: timeOut, usenmap: inputs.usenmap, op: "start" };
        let pdo = Utils.postDataOptions(options);
        fetch(url, pdo).then(res => res.json()).then((result) => {
            if (result.success) {
                if (result.nmap) {
                    divScanResults.style.display = 'none';
                    Utils.setState(fn, setData, result);
                }
                else {
                    divScanResults.style.display = "block";
                    Utils.setState(fn, setData, { started: true, timeOut: result.timeout });
                    readResults();
                }
            }
            else {
                Utils.setState(fn, setError, result.error);
            }
        }, (error) => {
            Utils.setState(fn, setError, error.message);
        });
    }
    ;
    function readResults() {
        if (fn.exited)
            return;
        let options = { op: "result" };
        let pdo = Utils.postDataOptions(options);
        fetch(url, pdo).then(res => res.json()).then((result) => {
            if (result.success) {
                showResults(result);
                if (!result.completed) {
                    setTimeout(readResults, 1000);
                }
            }
            else {
                Utils.setState(fn, setError, result.error);
            }
        }, (error) => {
            Utils.setState(fn, setError, error.message);
        });
    }
    ;
    function showResults(data) {
        if (!data || !data.ports)
            return;
        if (fn.exited)
            return;
        const theDiv = document.getElementById("portscanresults");
        if (theDiv == null)
            return;
        for (let i = 0; i < data.ports.length; i++) {
            const port = data.ports[i];
            const div = document.createElement("div");
            let line = port.ip + ":" + port.id + "";
            if (port.sid) {
                line += " SID:" + port.sid + " Instance:" + port.instance;
            }
            if (port.instanceurl) {
                line += " > " + port.instanceurl;
            }
            div.innerHTML = line;
            theDiv.appendChild(div);
        }
        const completed = data.completed ? t("completed") : "";
        const divCurrent = document.getElementById("portscancurrent");
        if (divCurrent == null)
            return;
        divCurrent.innerHTML = t("Scanning") + " > " + data.currentIP + " : " + data.currentPort + " " + completed;
    }
    function checkIfNMapAvailable() {
        let pdo = Utils.postDataOptions({ op: "checknmap" });
        fetch(url, pdo).then(res => res.json()).then((result) => {
            if (result.success) {
                if (result.nmap) {
                    Utils.setState(fn, setNMapAvailable, true);
                }
                else {
                    Utils.setState(fn, setNMapAvailable, false);
                }
                if (result.localip) {
                    const element = document.getElementById("inputIP");
                    element.value = result.localip;
                }
            }
        }, (error) => {
            console.log(error);
        });
    }
    function stop() {
        let options = { op: "stop" };
        let pdo = Utils.postDataOptions(options);
        fetch(url, pdo).then(res => res.json()).then((result) => {
            console.log("PortScanner.STOP");
            console.log(result);
        }, (error) => {
            console.log("PortScanner.STOP");
            console.log(error);
        });
    }
    ;
    function createTable(data) {
        var rows = [];
        for (var key in data.ports) {
            let port = data.ports[key];
            let row = React.createElement("tr", { key: "port_" + port.id, style: { padding: "10px" } },
                React.createElement("td", null, port.id),
                React.createElement("td", null, port.protocol),
                React.createElement("td", null, port.service));
            rows.push(row);
        }
        const table = React.createElement("table", null,
            React.createElement("thead", null,
                React.createElement("tr", null,
                    React.createElement("th", null, "Port"),
                    React.createElement("th", null, t("Protocol")),
                    React.createElement("th", null, t("Service")))),
            React.createElement("tbody", null, rows));
        return table;
    }
    function checkboxClicked(event) {
        console.log(event);
        const target = event.target;
        let checked = target.checked;
        const name = target.name;
        setInputs(Object.assign(Object.assign({}, inputs), { [name]: checked }));
    }
    function back(e) { e.preventDefault(); cleanUp(); Utils.goBack(props.history); }
    let result = "";
    let NMapCheckBox = "";
    let status = null;
    if (error) {
        status = Utils.error(error);
    }
    if (data && data.ports) {
        result = createTable(data);
    }
    if (nmapAvailable) {
        NMapCheckBox = React.createElement("label", null,
            t("use", { tool: 'NMap' }),
            React.createElement("input", { type: 'checkbox', name: 'usenmap', id: 'chkUseNMap', onChange: checkboxClicked, checked: inputs.usenmap }));
    }
    return (React.createElement("div", { id: 'page' },
        React.createElement(Header, { back: back, title: t("Port Scan") }),
        t("Port"),
        " ; [1-5000] : ",
        t("Scan from 1 to 5000"),
        React.createElement("br", null),
        t("Port"),
        " ; [5**13] : ",
        t("Scan from 50013 to 59913"),
        React.createElement("br", null),
        t("Timeout"),
        " : ",
        t("Maximum response time from a port"),
        "  (",
        t("milisecond"),
        ") ",
        React.createElement("br", null),
        React.createElement("br", null),
        t("Host"),
        ":",
        React.createElement("input", { ref: inputIP, id: "inputIP", type: 'text', defaultValue: 'localhost' }),
        t("Port"),
        ":",
        React.createElement("input", { ref: inputPort, type: 'text', defaultValue: '5**13' }),
        t("Timeout"),
        ":",
        React.createElement("input", { ref: inputTimeout, type: 'text', defaultValue: '2000' }),
        React.createElement("button", { onClick: start },
            "\u00A0",
            t("Start")),
        NMapCheckBox,
        React.createElement("br", null),
        status,
        React.createElement("div", { id: 'portscancurrent' }),
        React.createElement("br", null),
        React.createElement("div", { id: 'portscanresults', style: { overflow: "auto", height: "200px" } }),
        result));
};
const RecycleBin = (props) => {
    const [showTable, setShowTable] = useState(null);
    const [error, setError] = useState(null);
    const fn = { exited: false };
    const url = apiURL + "recyclebin";
    const tables = [
        { name: "Mail Settings", table: "mon_smtp" },
        { name: "Databases", table: "databases" }
    ];
    function cleanUp() { fn.exited = true; }
    ;
    function back(e) { e.preventDefault(); cleanUp(); Utils.goBack(props.history); }
    function tableClicked(e) {
        e.preventDefault();
        const table = e.currentTarget.getAttribute('table');
        show(table);
    }
    ;
    function show(table) {
        let pdo = Utils.postDataOptions({ table: table, op: "gettable" });
        fetch(url, pdo).then(res => res.json()).then((result) => {
            console.log(result);
            Utils.setState(fn, setShowTable, result);
        }, (error) => {
            console.log(error);
            Utils.setState(fn, setError, { error: error });
        });
    }
    ;
    function restore(row, data) {
        Debugger.print("Restore ID:" + row.id + " Table:" + data.name);
        const table = data.name;
        const id = row.id;
        let pdo = Utils.postDataOptions({ table: table, id: id, op: "restore" });
        fetch(url, pdo).then(res => res.json()).then((result) => {
            if (result.success) {
                alert(t("Restored"));
                show(data.name);
            }
            else {
                Utils.setState(fn, setError, { error: result.error });
            }
        }, (error) => {
            console.log(error);
            Utils.setState(fn, setError, { error: error });
        });
    }
    ;
    const links = [];
    for (var i = 0; i < tables.length; i++) {
        const table = tables[i];
        const link = React.createElement("a", { href: "#", style: { marginRight: "10px" }, table: table.table, key: "link_" + i, onClick: tableClicked }, t(table.name));
        links.push(link);
    }
    function getTable(table) {
        const headers = [
            { type: "button", "label": "Restore", field: "removed", name: "Restore", onClick: restore, width: "100px" }, ...table.columns
        ];
        const data = {
            defaultSortField: "id",
            id: "table_" + table.name,
            headers: headers,
            rows: table.rows,
            name: table.name
        };
        console.log(data);
        return React.createElement(Table, { data: data });
    }
    ;
    let table = null;
    let status = null;
    if (showTable && showTable.rows) {
        table = getTable(showTable);
    }
    if (error) {
        status = React.createElement("div", { className: "status", style: { background: Colors.red } }, error.error);
    }
    return (React.createElement("div", { id: 'page' },
        React.createElement(Header, { back: back, title: t("Recycle Bin") }),
        React.createElement("br", null),
        links,
        React.createElement("br", null),
        React.createElement("hr", null),
        React.createElement("div", null, status),
        React.createElement("br", null),
        table));
};
const RouteNotFound = (props) => {
    function back(e) {
        e.preventDefault();
        Utils.goBack(props.history, "#");
    }
    return (React.createElement("div", { id: "page" },
        React.createElement(Header, { back: back, title: t("Page not found") })));
};
const ServerLogs = (props) => {
    function back(e) {
        e.preventDefault();
        Utils.goBack(props.history);
    }
    return (React.createElement("div", { id: 'page' },
        React.createElement(Header, { back: back, title: t("Application Logs") }),
        React.createElement(LogViewer, { id: "serverlogs", data: { url: apiURL + "application", params: { limit: 20 } } })));
};
const SettingsPage = (props) => {
    const fn = { exited: false };
    function cleanUp() {
        fn.exited = true;
    }
    useEffect(() => { load(); return cleanUp; }, []);
    function load() {
    }
    function back(e) { e.preventDefault(); cleanUp(); Utils.goBack(props.history); }
    function setStyle(event) {
        const style = event.target.value;
        if (style == "style_dark.css") {
            Theme.set("dark");
        }
        else {
            Theme.set("light");
        }
        if (SysRanger.remote) {
            RemoteSettings.save("stylesheet", style);
        }
        UserSettings.set("stylesheet", style);
        Settings.save("stylesheet", style, function () {
            window.location.reload(true);
        });
    }
    function setMaintenanceMode(e) {
        Data.maintenance = e.target.checked;
        Call.refresh();
        Settings.save("maintenance", Data.maintenance, function (json) {
            if (json && json.success) {
                Info.success("Setting is saved.");
            }
            else {
                Info.error("Error:" + json.error);
            }
        });
    }
    return (React.createElement("div", { id: 'page' },
        React.createElement(Header, { back: back, title: t("Settings") }),
        React.createElement("div", { style: { lineHeight: "24px" } },
            React.createElement("a", { href: "#/mailsettings" }, t("SMTP Settings")),
            "  ",
            React.createElement("br", null),
            React.createElement("a", { href: "#alertsreceiver" }, t("Set alert receiver")),
            " ",
            React.createElement("br", null),
            Data.super &&
                React.createElement("div", null,
                    React.createElement("a", { href: "#/remotemonitoring" },
                        t("Remote Monitoring"),
                        " (sysranger.com)"),
                    " ",
                    React.createElement("br", null),
                    React.createElement("a", { href: "#/users" }, t("Users")),
                    " ",
                    React.createElement("br", null),
                    React.createElement("a", { href: "#/applicationsettings" }, t("Application Settings")),
                    " ",
                    React.createElement("br", null),
                    React.createElement("a", { href: "#/licensemanager" }, t("License Manager")),
                    " ",
                    React.createElement("br", null),
                    React.createElement("a", { href: "#/company" }, t("Company")),
                    " ",
                    React.createElement("br", null),
                    React.createElement("a", { href: "#/definitions" }, t("Definitions")),
                    " ",
                    React.createElement("br", null),
                    React.createElement("a", { href: "#/sapreportsettings" }, t("SAP Report Settings")),
                    " ",
                    React.createElement("br", null))),
        React.createElement("br", null),
        React.createElement("input", { type: "checkbox", id: "chk_maintenance_mode", defaultChecked: Data.maintenance, onChange: setMaintenanceMode }),
        React.createElement("label", { htmlFor: "chk_maintenance_mode" }, t("Maintenance mode")),
        " ",
        React.createElement("br", null),
        React.createElement("br", null),
        React.createElement("br", null),
        React.createElement("table", { className: "nobordertable" },
            React.createElement("tbody", null,
                React.createElement("tr", null,
                    React.createElement("td", { width: "200" }, t("language")),
                    React.createElement("td", null,
                        React.createElement(LanguageSelector, null))),
                React.createElement("tr", null,
                    React.createElement("td", null, t("Style")),
                    React.createElement("td", null,
                        React.createElement("select", { onChange: setStyle, value: settings["stylesheet"] },
                            React.createElement("option", { value: "style_light.css" }, "Light Theme"),
                            React.createElement("option", { value: "style_dark.css" }, "Dark Theme")))),
                React.createElement("tr", null,
                    React.createElement("td", null, t("Font")),
                    React.createElement("td", null,
                        " ",
                        React.createElement(FontSelector, null),
                        " "))))));
};
const SMSSettings = (props) => {
    const [error, setError] = useState(null);
    const [numbers, setNumbers] = useState("");
    const fn = { closed: useRef(false) };
    let inputNumbers = createRef(0);
    useEffect(() => { loadData(); return cleanUp; }, [props]);
    function loadData() {
        if (fn.closed.current)
            return;
        let pdo = Utils.postDataOptions({ op: "info" });
        fetch(apiURL + "sms", pdo).then(res => res.json()).then((result) => {
            if (result.success) {
                Utils.setState(fn, setNumbers, result.numbers);
            }
            else {
                Info.error(result.error);
                Utils.setState(fn, setError, result.error);
            }
        }, (error) => {
            Info.error(error.message);
            Utils.setState(fn, setError, error.message);
        });
    }
    ;
    function updateSMS() {
        if (fn.closed.current)
            return;
        const options = { op: "setnumbers", numbers: inputNumbers.current.value };
        const pdo = Utils.postDataOptions(options);
        fetch(apiURL + "sms", pdo)
            .then(response => response.json())
            .then((result) => {
            console.log(result);
            if (result.success) {
                Info.success("Updated");
            }
            else {
                Info.error(result.error);
            }
        }, (error) => { Info.error(error.message); });
    }
    ;
    function testSMS() {
        if (fn.closed.current)
            return;
        const options = { op: "test" };
        const pdo = Utils.postDataOptions(options);
        fetch(apiURL + "sms", pdo)
            .then(response => response.json())
            .then((result) => {
            parseSMSTestResult(result);
        }, (error) => { Info.error(error.message); });
    }
    function parseSMSTestResult(json) {
        if (!json.success) {
            return Info.error(json.error);
        }
        for (var i = 0; i < json.sms.length; i++) {
            const sms = json.sms[i];
            if (sms.error) {
                Info.error(sms.number + ":" + sms.error);
            }
            else {
                Info.success(sms.number + " SMS OK");
            }
        }
    }
    function testCall() {
        if (fn.closed.current)
            return;
        const options = { op: "calltest" };
        const pdo = Utils.postDataOptions(options);
        fetch(apiURL + "sms", pdo)
            .then(response => response.json())
            .then((result) => {
            parseCallTestResult(result);
        }, (error) => { Info.error(error.message); });
    }
    function parseCallTestResult(json) {
        if (!json.success) {
            return Info.error(json.error);
        }
        for (var i = 0; i < json.calls.length; i++) {
            const call = json.calls[i];
            if (call.error) {
                Info.error(call.number + ":" + call.error);
            }
            else {
                Info.success(call.number + " Call OK");
            }
        }
    }
    function cleanUp() {
        fn.closed.current = true;
    }
    function back(e) {
        e.preventDefault();
        cleanUp();
        Utils.goBack(props.history, "/#alerts");
    }
    return (React.createElement("div", { id: 'page' },
        React.createElement(Header, { back: back, title: t("SMS settings") }),
        React.createElement("span", null, t("Please enter phone numbers for receiving alert messages.")),
        " ",
        React.createElement("br", null),
        React.createElement("span", null, t("You can define multiple numbers using comma(,) between.")),
        React.createElement("br", null),
        React.createElement("br", null),
        React.createElement("table", { className: "nobordertable" },
            React.createElement("tbody", null,
                React.createElement("tr", null,
                    React.createElement("td", null, t("Phone numbers")),
                    React.createElement("td", null,
                        React.createElement("input", { type: "text", size: "30", ref: inputNumbers, field: "numbers", placeholder: t("Phone numbers"), defaultValue: numbers })),
                    React.createElement("td", null,
                        React.createElement("button", { id: "submit", onClick: updateSMS }, t("Update")))))),
        React.createElement("br", null),
        React.createElement("button", { id: "submit", onClick: testSMS }, t("SMS Test")),
        React.createElement("button", { id: "submit", onClick: testCall }, t("Call Test")),
        React.createElement("div", null,
            " ",
            error && React.createElement("div", { style: { color: "red" } }, t(error)))));
};
const SmtpEdit = (props) => {
    const smtp = props.location.state;
    if (!smtp) {
        return noDataReceived();
    }
    const [fields, setFields] = useState({ host: smtp.host, port: smtp.port, user: smtp.user, password: "", from: smtp.mail_from, ssl: smtp.ssl == "true", startTLS: smtp.tls == "true" });
    const [errors, setErrors] = useState({});
    const [success, setSuccess] = useState(null);
    const [error, setError] = useState(null);
    const required = ["host", "port", "user", "password", "from"];
    function cleanUp() {
    }
    function back(e) { e.preventDefault(); cleanUp(); Utils.goBack(props.history); }
    function handleValidation() {
        const errors = {};
        let formIsValid = true;
        for (let i = 0; i < required.length; i++) {
            const field = required[i];
            if (!fields[field] || fields[field].length < 1) {
                formIsValid = false;
                errors[field] = "Required field";
            }
        }
        setErrors(errors);
        return formIsValid;
    }
    function noDataReceived() {
        return React.createElement("div", null,
            React.createElement("div", null, "No data received"),
            React.createElement("button", { className: "btn btn-lg pro", onClick: back }, t("Back")));
    }
    ;
    function handleChange(e) {
        const field = e.currentTarget.getAttribute('field');
        const value = e.target.type === "checkbox" ? e.target.checked : e.target.value;
        setFields(Object.assign(Object.assign({}, fields), { [field]: value }));
    }
    function submit(e) {
        e.preventDefault();
        if (!handleValidation())
            return;
        const options = Object.assign(Object.assign({}, fields), { op: "update", smtpid: smtp.id });
        const pdo = Utils.postDataOptions(options);
        fetch(apiURL + "smtpsettings", pdo)
            .then(response => response.json())
            .then((result) => {
            console.log(result);
            if (result.success) {
                console.log("Returning previous page...");
                props.history.push("mailsettings");
                return;
            }
            if (result.error) {
                setError(result.error);
                if (result.field) {
                    setErrors({ [result.field]: result.error });
                }
            }
        }, (error) => {
            setError(error);
        });
    }
    function test(e) {
        e.preventDefault();
        if (!handleValidation())
            return;
        const options = Object.assign(Object.assign({}, fields), { op: "test" });
        const pdo = Utils.postDataOptions(options);
        fetch(apiURL + "smtpsettings", pdo)
            .then(response => response.json())
            .then((result) => {
            console.log(result);
            if (result.success) {
                setError(null);
                setSuccess(true);
            }
            else {
                setError(result.error);
                setSuccess(false);
                if (result.field) {
                    setErrors({ [result.field]: result.error });
                }
            }
        }, (error) => {
            console.log(error);
            setError(error);
        });
    }
    ;
    function remove(e) {
        const message = smtp.host + "\n" + t("Are you sure you want to remove ?");
        if (!window.confirm(message))
            return;
        const options = { smtpid: smtp.id, op: "remove" };
        const pdo = Utils.postDataOptions(options);
        fetch(apiURL + "smtpsettings", pdo)
            .then(response => response.json())
            .then((result) => {
            console.log(result);
            if (result.success) {
                props.history.push("mailsettings");
            }
            else {
                setError(result.error);
                setSuccess(false);
            }
        }, (error) => {
            console.log(error);
            setError(error);
        });
    }
    ;
    let status = null;
    if (error) {
        status = React.createElement("div", { style: { color: "red" } }, t("Connection is not succesfull") + " - " + t(error));
    }
    if (success) {
        status = React.createElement("div", null, t("Test is succesfull"));
    }
    console.log(errors);
    return (React.createElement("div", { id: 'page' },
        React.createElement(Header, { back: back, title: t("Edit SMTP Settings") }),
        React.createElement("table", { className: "nobordertable nohover" },
            React.createElement("tbody", null,
                React.createElement("tr", null,
                    React.createElement("td", null, t("Host")),
                    React.createElement("td", null,
                        "  ",
                        React.createElement("input", { type: "text", size: "30", field: "host", placeholder: "smtp.domain.com", onChange: handleChange, value: fields["host"] }),
                        "        "),
                    React.createElement("td", { style: { color: "red" } },
                        t(errors["host"]),
                        " ")),
                React.createElement("tr", null,
                    React.createElement("td", null, t("Port")),
                    React.createElement("td", null,
                        "  ",
                        React.createElement("input", { type: "text", size: "30", field: "port", placeholder: "587", onChange: handleChange, value: fields["port"] }),
                        "        "),
                    React.createElement("td", { style: { color: "red" } },
                        t(errors["port"]),
                        " ")),
                React.createElement("tr", null,
                    React.createElement("td", null, t("Mail from")),
                    React.createElement("td", null,
                        "  ",
                        React.createElement("input", { type: "text", size: "30", field: "from", placeholder: "alert@domain.com", onChange: handleChange, value: fields["from"] }),
                        "        "),
                    React.createElement("td", { style: { color: "red" } },
                        t(errors["from"]),
                        " ")),
                React.createElement("tr", null,
                    React.createElement("td", null, t("User")),
                    React.createElement("td", null,
                        "  ",
                        React.createElement("input", { type: "text", size: "30", field: "user", placeholder: "alert@domain.com", onChange: handleChange, value: fields["user"] }),
                        "        "),
                    React.createElement("td", { style: { color: "red" } },
                        t(errors["user"]),
                        " ")),
                React.createElement("tr", null,
                    React.createElement("td", null, t("Password")),
                    React.createElement("td", null,
                        "  ",
                        React.createElement("input", { type: "password", size: "30", field: "password", placeholder: "password", onChange: handleChange, value: fields["password"] }),
                        "        "),
                    React.createElement("td", { style: { color: "red" } },
                        t(errors["password"]),
                        " ")),
                React.createElement("tr", null,
                    React.createElement("td", null, "SSL"),
                    React.createElement("td", null,
                        "  ",
                        React.createElement("input", { type: "checkbox", size: "30", field: "ssl", onChange: handleChange, checked: fields["ssl"] }),
                        "        "),
                    React.createElement("td", { style: { color: "red" } },
                        t(errors["ssl"]),
                        " ")),
                React.createElement("tr", null,
                    React.createElement("td", null, "startTLS"),
                    React.createElement("td", null,
                        "  ",
                        React.createElement("input", { type: "checkbox", size: "30", field: "startTLS", onChange: handleChange, checked: fields["startTLS"] }),
                        "        "),
                    React.createElement("td", { style: { color: "red" } },
                        t(errors["startTLS"]),
                        " ")))),
        React.createElement("fieldset", null,
            React.createElement("button", { className: "btn btn-lg pro", onClick: test },
                " ",
                t("Test Connection")),
            React.createElement("button", { className: "btn btn-lg pro", onClick: submit }, t("Update")),
            React.createElement("button", { className: "btn btn-lg pro", onClick: back }, t("Cancel")),
            React.createElement("button", { className: "btn btn-lg pro", style: { float: "right" }, onClick: remove }, t("Remove"))),
        React.createElement("div", { id: 'status' },
            status,
            "   ")));
};
const SmtpSetting = (props) => {
    const [test, setTest] = useState({ error: null, success: false });
    const url = apiURL + "smtpsettings";
    const fn = { exited: false };
    function cleanUp() {
        fn.exited = true;
    }
    ;
    function testConnection(e) {
        const id = e.currentTarget.getAttribute('smtpid');
        let pdo = Utils.postDataOptions({ op: "testfromdb", smtpid: id });
        fetch(url, pdo).then(res => res.json()).then((result) => {
            Utils.setState(fn, setTest, result);
        }, (error) => {
            Utils.setState(fn, setTest, { error: error, success: false });
        });
    }
    ;
    function edit(e) {
        e.preventDefault();
        console.log(props);
        props.history.push({
            pathname: '/editsmtp',
            state: props.smtp
        });
    }
    const smtp = props.smtp;
    let status = null;
    if (test.error) {
        status = React.createElement("div", { style: { color: Colors.red } }, t(test.error));
    }
    else if (test.success) {
        status = React.createElement("div", { style: { color: Colors.green } },
            " ",
            t("Test is succesfull"));
    }
    return (React.createElement("div", { className: "box", style: { maxWidth: "50%" }, key: "smtp_" + smtp.id },
        React.createElement("table", { className: "informationtable " },
            React.createElement("tbody", null,
                React.createElement("tr", null,
                    React.createElement("td", null, t("Host")),
                    React.createElement("td", null, smtp.host)),
                React.createElement("tr", null,
                    React.createElement("td", null, t("Port")),
                    React.createElement("td", null, smtp.port)),
                React.createElement("tr", null,
                    React.createElement("td", null, t("User")),
                    React.createElement("td", null, smtp.user)),
                React.createElement("tr", null,
                    React.createElement("td", null, t("Mail from")),
                    React.createElement("td", null, smtp.mail_from)),
                React.createElement("tr", null,
                    React.createElement("td", null, t("SSL")),
                    React.createElement("td", null, t(smtp.ssl))),
                React.createElement("tr", null,
                    React.createElement("td", null, t("TLS")),
                    React.createElement("td", null, t(smtp.tls))))),
        React.createElement("div", { style: { padding: "10px", height: "10px" } }, status),
        React.createElement("div", { style: { padding: "10px" } },
            React.createElement("button", { smtpid: smtp.id, onClick: testConnection }, t("Test Connection")),
            React.createElement("button", { smtpid: smtp.id, onClick: edit }, t("Edit")))));
};
const UtilityPage = (props) => {
    function back(e) { e.preventDefault(); cleanUp(); Utils.goBack(props.history); }
    return (React.createElement("div", { id: 'page' },
        React.createElement(Header, { back: back, title: t("Utilities") }),
        React.createElement("br", null),
        React.createElement("h2", null, t("Network Utilities")),
        React.createElement("br", null),
        React.createElement("div", { className: "utilitylist" },
            React.createElement("div", null,
                React.createElement("img", { src: 'images/icons/graph.svg', width: "30" }),
                React.createElement("br", null),
                " Ping"),
            React.createElement("a", { href: '#portscanner' },
                " ",
                React.createElement("div", null,
                    React.createElement("img", { src: 'images/icons/computer.svg', width: "30" }),
                    React.createElement("br", null),
                    t("Port Scan"))),
            React.createElement("div", null,
                React.createElement("img", { src: 'images/icons/network-switch.svg', width: "30" }),
                React.createElement("br", null),
                "  ",
                t("Network Scan"),
                " ")),
        React.createElement("div", { className: "clear" }),
        React.createElement("br", null),
        React.createElement("br", null),
        React.createElement("h2", null, t("SAP Utilities")),
        React.createElement("br", null),
        React.createElement("div", { className: "utilitylist" },
            React.createElement("div", null,
                React.createElement("img", { src: 'images/icons/network.svg', width: "30" }),
                React.createElement("br", null),
                " ",
                t("SAP Connection")),
            React.createElement("div", null,
                React.createElement("img", { src: 'images/icons/database.svg', width: "30" }),
                React.createElement("br", null),
                " ",
                t("Database Connection")))));
};
const ProbeAlerts = (props) => {
    const [divDetails, setDivDetails] = useState(null);
    const timeoutID = "probealerts";
    const hostID = props.hostid;
    const fn = { closed: useRef(false) };
    function cleanUp() {
        fn.closed.current = true;
        Timeouts.clearAll(timeoutID);
    }
    useEffect(() => { fn.closed.current = false; loadData(); return cleanUp; }, [hostID]);
    function loadData() {
        Timeouts.clearAll(timeoutID);
        if (fn.closed.current)
            return;
        Request.send({
            url: apiURL + "alerts",
            params: { op: "probealerts", id: hostID },
            listener: (json) => Utils.setState(fn, setDivDetails, parse(json)),
            then: () => {
                Timeouts.clearAll(timeoutID);
                Timeouts.add(timeoutID, setTimeout(loadData, 5000));
            }
        });
    }
    ;
    function parse(json) {
        if (!json.success) {
            return Utils.error(json.error);
        }
        const data = {
            defaultSortField: "lad",
            direction: "ascending",
            id: "table_probealerts",
            headers: [
                { name: "Type", field: "t" },
                { name: "Message", field: "m" },
                { name: "Details", field: "d" },
                { name: "Code", field: "c" },
                { name: "Last Activity", field: "lad", format: Utils.timePastShortMS },
                { name: "Active", field: "ac" },
                { name: "Hash", field: "h" }
            ],
            rows: json.alerts
        };
        return React.createElement(Table, { data: data });
    }
    return (React.createElement("div", { id: 'panel_probe_alerts' }, divDetails));
};
const ProbeDetails = (props) => {
    const [probe, setProbe] = useState({ name: "" });
    const hostID = props.match.params.id;
    const fn = { closed: useRef(false) };
    function cleanUp() {
        fn.closed.current = true;
    }
    function back(e) {
        e.preventDefault();
        cleanUp();
        Utils.goBack(props.history);
    }
    useEffect(() => { fn.closed.current = false; loadData(); return cleanUp; }, [hostID]);
    function loadData() {
        Request.send({
            url: apiURL + "probe",
            params: { id: hostID, op: "info" },
            success: (json) => Utils.setState(fn, setProbe, json)
        });
    }
    ;
    return (React.createElement("div", { id: 'page' },
        React.createElement(Header, { back: back, title: t("Probe Details") + " " + probe.name }),
        React.createElement(Tabs, { default: null, id: "tabs_probe_details", key: 'tabs_probe_details_' + hostID },
            React.createElement(Tab, { key: 'logfiles', name: 'logfiles', label: 'Log Files' },
                React.createElement(ProbeLogFiles, { id: "probelogfiles", hostid: hostID })),
            React.createElement(Tab, { key: 'logs', name: 'logs', label: 'Logs' },
                React.createElement(LogViewer, { id: "probelogs", data: { url: apiURL + "hosts", params: { hostid: hostID, limit: 20 } } })),
            React.createElement(Tab, { key: 'stats', name: 'stats', label: 'Stats' },
                React.createElement(ProbeStats, { id: "probestats", hostid: hostID })),
            React.createElement(Tab, { key: 'alerts', name: 'alerts', label: 'Alerts' },
                React.createElement(ProbeAlerts, { id: "probealerts", hostid: hostID })))));
};
const ProbeLogFiles = (props) => {
    const [content, setContent] = useState("Loading...");
    const hostID = props.hostid;
    const fn = { closed: useRef(false) };
    function cleanUp() {
        fn.closed.current = true;
    }
    useEffect(() => { fn.closed.current = false; loadData(); return cleanUp; }, [hostID]);
    function loadData() {
        Request.send({
            url: apiURL + "probe",
            params: { id: hostID, op: "logfiles" },
            listener: (json) => Utils.setState(fn, setContent, parse(json))
        });
    }
    ;
    function parse(json) {
        if (!json.success)
            return Utils.error(json.error);
        const data = {
            defaultSortField: "nm",
            id: "probelogfiles",
            headers: [
                { name: "Name", field: "nm", onClick: openViewer },
                { name: "Size", field: "sz", format: Utils.bytesToUnit },
                { name: "Last Modified", field: "lm", format: Utils.toDate },
            ],
            rows: json.files
        };
        return React.createElement(Table, { data: data });
    }
    function openViewer(row, table) {
        const data = {
            url: apiURL + "probe",
            params: { op: "readfile", direction: 1, name: row.nm, id: hostID }
        };
        const div = React.createElement(TextFileReader, { data: data });
        Dialog.show({ content: div, render: true });
    }
    return (React.createElement("div", { id: 'panel_probe_log_files' }, content));
};
const ProbeStats = (props) => {
    const [content, setContent] = useState("Loading...");
    const hostID = props.hostid;
    const fn = { closed: useRef(false) };
    const timeoutID = "probestats_" + hostID;
    function cleanUp() {
        fn.closed.current = true;
        Timeouts.clearAll(timeoutID);
    }
    useEffect(() => { fn.closed.current = false; loadData(); return cleanUp; }, [hostID]);
    function loadData() {
        Timeouts.clearAll(timeoutID);
        Request.send({
            url: apiURL + "probe",
            params: { id: hostID, op: "stats" },
            listener: (json) => Utils.setState(fn, setContent, parse(json))
        });
    }
    ;
    function parse(json) {
        if (!json.success)
            return Utils.error(json.error);
        const divs = React.createElement("div", null,
            "Version:",
            json.version,
            " ",
            React.createElement("br", null),
            "Uptime:",
            Utils.minutesPast(json.uptime),
            React.createElement("br", null),
            "Queue:",
            json.queue.requestcount,
            " / ",
            json.queue.waitingcount,
            " / ",
            json.queue.interruptedcount,
            " ",
            React.createElement("br", null),
            getTable("Requests", json.queue.requests),
            getTable("Waiting", json.queue.waiting),
            getTable("Interrupted", json.queue.interrupted));
        Timeouts.add(timeoutID, setTimeout(loadData, 2000));
        return divs;
    }
    function getTable(name, requests) {
        if (!requests || requests.length < 1)
            return "";
        requests.sort((a, b) => {
            return a.t - b.t;
        });
        const trs = [];
        for (let i = 0; i < requests.length; i++) {
            const request = requests[i];
            const tr = React.createElement("tr", { key: "tr_" + name + "_" + i },
                React.createElement("td", null, request.c),
                React.createElement("td", null,
                    Utils.toDate(request.t),
                    "  "),
                React.createElement("td", null,
                    request.d,
                    "  "));
            trs.push(tr);
        }
        return (React.createElement("div", null,
            React.createElement("h2", { key: "h_" + name },
                name,
                " "),
            React.createElement("table", { key: "t_" + name },
                React.createElement("thead", null,
                    React.createElement("tr", null,
                        React.createElement("th", null, "Command"),
                        React.createElement("th", null, "Time"),
                        React.createElement("th", null, "Data"))),
                React.createElement("tbody", null, trs))));
    }
    return (React.createElement("div", { id: 'panel_probe_stats' }, content));
};
const CompanyList = (props) => {
    const [error, setError] = useState(null);
    const [data, setData] = useState(null);
    const fn = { exited: false };
    function cleanUp() { fn.exited = true; }
    useEffect(() => { getData("companylist"); return cleanUp; }, []);
    function getData(op) {
        if (fn.exited)
            return;
        const options = { op: op };
        const pdo = Utils.postDataOptions(options);
        fetch(apiURL + "remotelogin", pdo)
            .then(response => response.json())
            .then((result) => {
            console.log(result);
            if (result.success) {
                result.updateTime = Utils.date();
                Utils.setState(fn, setData, result);
            }
            else {
                Utils.setState(fn, setError, result.error);
            }
        }, (error) => {
            Utils.setState(fn, setError, error.message);
        }).then(() => {
            if (op == "companylist") {
                setTimeout(getData, 10, "companystatus");
            }
            else {
                setTimeout(getData, 5000, "companystatus");
            }
        });
    }
    ;
    function switchCompany(e) {
        const companyID = e.currentTarget.getAttribute('companyid');
        SysRanger.companyID = companyID;
        console.log("Company SET:" + companyID);
        saveSession();
        alert("Company Switched");
    }
    function saveSession() {
        const options = { op: "savesession", companyCount: SysRanger.companyCount };
        const pdo = Utils.postDataOptions(options);
        fetch(SysRanger.baseURL + "/index.php", pdo)
            .then(response => response.json())
            .then((result) => {
            console.log(result);
        }, (error) => {
            console.log(error);
        }).then(() => { Call.refresh(); });
    }
    ;
    function getList(data) {
        const rows = data.rows;
        const list = [];
        for (let i = 0; i < rows.length; i++) {
            const company = rows[i];
            let connected = null;
            let ping = null;
            let lastActivity = React.createElement("div", { title: t("Last activity") },
                Utils.toDate(company.lastActivityTime),
                " ");
            let switchLink = React.createElement("div", { className: "bold" }, company.name);
            let systemList = null;
            let alerts = null;
            let border = "1px solid red";
            if (company.connected) {
                connected = React.createElement("div", { className: "success" }, t("connected"));
                ping = React.createElement("div", { title: "Ping" }, company.ping + " ms");
                if (company.id != SysRanger.companyID) {
                    switchLink = React.createElement("a", { companyid: company.id, onClick: switchCompany, className: "bold" },
                        " ",
                        company.name,
                        "   ");
                }
                systemList = getSystems(company);
                border = "1px solid green";
                alerts = React.createElement("div", { title: t("Alerts (Active/Total)"), style: { color: company.activealerts > 0 ? Colors.red : Colors.text } },
                    " ",
                    t("Alerts"),
                    ":",
                    company.activealerts,
                    " / ",
                    company.alerts,
                    " ");
            }
            else {
                connected = React.createElement("div", { className: "error" }, t("disconnected"));
            }
            const div = React.createElement("div", { key: "company_" + company.id, style: { border: border, width: "180px", float: "left", padding: "10px", margin: "10px 10px 10px 10px", textAlign: "center", lineHeight: "26px" } },
                switchLink,
                connected,
                lastActivity,
                alerts,
                ping,
                React.createElement("br", null),
                systemList);
            list.push(div);
        }
        return list;
    }
    function getSystems(company) {
        if (!company.systems && company.systems.length < 1)
            return null;
        const divs = [];
        for (let s = 0; s < company.systems.length; s++) {
            const system = company.systems[s];
            const color = system.ok ? Colors.green : Colors.red;
            const div = React.createElement("div", { style: { background: color, color: "#000", float: "left", width: "40px", marginRight: "5px" } }, system.c);
            divs.push(div);
        }
        return React.createElement("div", null, divs);
    }
    let list = "Loading...";
    if (data && data.rows) {
        list = React.createElement("div", null,
            React.createElement("div", { className: "smallInfo", style: { float: "right" } }, Utils.time()),
            React.createElement("br", null),
            getList(data));
    }
    return (React.createElement("div", null, list));
};
const RemoteDashboard = (pr) => {
    const props = pr.props;
    const fn = { exited: false };
    function cleanUp() {
        fn.exited = true;
    }
    function back(e) { e.preventDefault(); cleanUp(); Utils.goBack(props.history); }
    return (React.createElement("div", { id: 'page' },
        React.createElement(Header, { back: back, title: t("home") }),
        React.createElement(CompanyList, null)));
};
const RemoteMonitoringSettings = (props) => {
    const [fields, setFields] = useState({ apiKey: "" });
    const [data, setData] = useState({ apiKey: "", connected: false });
    const [error, setError] = useState(null);
    const required = ["apiKey"];
    const fn = { exited: false };
    function cleanUp() { fn.exited = true; }
    ;
    useEffect(() => { loadData(); return cleanUp; }, []);
    function loadData() {
        if (fn.exited)
            return;
        let pdo = Utils.postDataOptions({ op: "isApiKeySet" });
        fetch(apiURL + "settings", pdo).then(res => res.json()).then((result) => {
            if (result.success) {
                Utils.setState(fn, setData, result);
            }
            else {
                Utils.setState(fn, setError, result.error);
            }
        }, (error) => {
            Utils.setState(fn, setData, { success: false, error: error.message });
        });
    }
    function handleValidation() {
        let formIsValid = true;
        for (let i = 0; i < required.length; i++) {
            const field = required[i];
            if (!fields[field] || fields[field].length < 1) {
                formIsValid = false;
                setError(t(field) + " " + t("required"));
            }
        }
        return formIsValid;
    }
    function back(e) { e.preventDefault(); cleanUp(); Utils.goBack(props.history); }
    function submit(e) {
        e.preventDefault();
        if (!handleValidation())
            return;
        const options = { op: "set", name: "apiKey", value: fields["apiKey"] };
        const pdo = Utils.postDataOptions(options);
        fetch(apiURL + "settings", pdo)
            .then(response => response.json())
            .then((result) => {
            console.log(result);
            if (result.success) {
                console.log("Returning previous page...");
                Utils.goBack(props.history);
                return;
            }
            if (result.error) {
                setError(result.error);
                if (result.field) {
                    setErrors({ [result.field]: result.error });
                }
            }
        }, (error) => {
            setError(error);
        });
    }
    function handleChange(e) {
        const field = e.currentTarget.getAttribute('field');
        const value = e.target.value;
        setFields(Object.assign(Object.assign({}, fields), { [field]: value }));
    }
    let status = null;
    if (error) {
        status = React.createElement("div", { style: { color: "red" } }, t(error));
    }
    let statusConnection = null;
    if (data && data.apiKey) {
        const divConnectionStatus = data.connected ? React.createElement("span", { className: "success" }, t("connected")) : React.createElement("span", { className: "error" }, t("disconnected"));
        statusConnection = React.createElement("div", null,
            t("API key already set"),
            ":",
            data.apiKey,
            "******  ",
            React.createElement("br", null),
            t("Connection status"),
            " : ",
            divConnectionStatus);
    }
    return (React.createElement("div", { id: "page" },
        React.createElement(Header, { back: back, title: t("Remove Monitoring") }),
        React.createElement("br", null),
        React.createElement("div", null,
            t("remotemonitoringdescription"),
            " (",
            React.createElement("a", { href: "https://sysranger.com", target: "_blank" }, "sysranger.com"),
            ") "),
        React.createElement("br", null),
        React.createElement("br", null),
        statusConnection,
        " ",
        React.createElement("br", null),
        React.createElement("br", null),
        t("API Key"),
        React.createElement("br", null),
        React.createElement("input", { type: "text", size: "30", field: "apiKey", onChange: handleChange, value: fields["apiKey"] }),
        React.createElement("br", null),
        React.createElement("br", null),
        React.createElement("button", { onClick: submit }, t("Update")),
        React.createElement("button", { onClick: back }, t("Cancel")),
        React.createElement("div", null, status)));
};
const RemoteForgotPassword = (props) => {
    let inputEmail = createRef();
    const [status, setStatus] = useState(null);
    const [buttonActive, setButtonActive] = useState(true);
    function reset() {
        setButtonActive(false);
        const email = inputEmail.current.value;
        const options = { email: email, op: "reset" };
        const pdo = Utils.postDataOptions(options);
        fetch(apiURL + "remotelogin", pdo)
            .then(response => response.json())
            .then((result) => {
            console.log(result);
            if (result.success) {
                const message = "Password reset mail is sent to " + result.email + ". Please check your mailbox for instructions.";
                alert(message);
                Utils.redirect("https://sysranger.com/monitor/#/");
            }
            else {
                setStatus(Utils.error(result.error));
                setButtonActive(true);
            }
        }, (error) => {
            setStatus(Utils.error(error.message));
            setButtonActive(true);
        });
    }
    ;
    return (React.createElement("div", { className: "fullpage", style: { textAlign: "center" } },
        React.createElement("a", { href: 'https://sysranger.com' },
            React.createElement("img", { src: "images/logo.svg", width: "300" })),
        React.createElement("br", null),
        React.createElement("br", null),
        React.createElement("br", null),
        React.createElement("div", { className: "box", style: { height: "350px", width: "400px", float: "none", margin: "auto" } },
            React.createElement("h1", { style: { background: "none" } }, t("Reset Password")),
            React.createElement("table", { className: "nobordertable nohover nopad" },
                React.createElement("tbody", null,
                    React.createElement("tr", null,
                        React.createElement("td", null, t("Email"))),
                    React.createElement("tr", null,
                        React.createElement("td", null,
                            React.createElement("input", { type: "text", ref: inputEmail }))))),
            React.createElement("br", null),
            React.createElement("button", { disabled: !buttonActive, className: "nomargin", style: { width: "240px" }, onClick: reset }, t("Send Reset Mail")),
            React.createElement("br", null),
            React.createElement("div", null, status),
            React.createElement("br", null),
            React.createElement("br", null),
            React.createElement("a", { href: "#/register" },
                " ",
                t("Create an account"),
                " "),
            React.createElement("br", null),
            React.createElement("br", null),
            React.createElement("a", { href: "#/login" },
                t("Already have an account"),
                " "))));
};
const RemoteLogin = (props) => {
    const [fields, setFields] = useState({ user: "", password: "" });
    const [error, setError] = useState(null);
    const required = ["user", "password"];
    function handleValidation() {
        let formIsValid = true;
        for (let i = 0; i < required.length; i++) {
            const field = required[i];
            if (!fields[field] || fields[field].length < 1) {
                formIsValid = false;
                setError(t(field) + " " + t("required"));
                return false;
            }
        }
        return formIsValid;
    }
    function saveSession() {
        const options = { op: "savesession", companyCount: SysRanger.companyCount };
        const pdo = Utils.postDataOptions(options);
        fetch(SysRanger.baseURL + "/index.php", pdo)
            .then(response => response.json())
            .then((result) => {
            console.log(result);
        }, (error) => {
            console.log(error);
        }).then(() => { Call.refresh(); });
    }
    ;
    function submit(e) {
        e.preventDefault();
        if (!handleValidation())
            return;
        const options = Object.assign(Object.assign({}, fields), { op: "login" });
        const pdo = Utils.postDataOptions(options);
        fetch(apiURL + "remotelogin", pdo)
            .then(response => response.json())
            .then((result) => {
            console.log(result);
            if (result.success) {
                SysRanger.token = result.token;
                SysRanger.userID = result.userID;
                SysRanger.companyID = result.companyID;
                SysRanger.companyCount = result.companyCount;
                saveSession();
                return;
            }
            if (result.error) {
                setError(result.error);
            }
        }, (error) => {
            setError(error.message);
        });
    }
    function handleChange(e) {
        const field = e.currentTarget.getAttribute('field');
        const value = e.target.type === "checkbox" ? e.target.checked : e.target.value;
        setFields(Object.assign(Object.assign({}, fields), { [field]: value }));
    }
    let status = React.createElement("br", null);
    if (error) {
        status = React.createElement("div", { style: { color: "red" } }, t(error));
    }
    return (React.createElement("div", { className: "fullpage", style: { textAlign: "center" } },
        React.createElement("a", { href: 'https://sysranger.com' },
            React.createElement("img", { src: "images/logo.svg", width: "300" })),
        React.createElement("br", null),
        React.createElement("span", null, "Cloud"),
        React.createElement("br", null),
        React.createElement("br", null),
        React.createElement("div", { className: "box", style: { height: "350px", width: "260px", margin: "auto", float: "none" } },
            React.createElement("h1", { style: { background: "none" } }, t("Login")),
            React.createElement("table", { className: "nobordertable nohover", style: { width: "100%" } },
                React.createElement("tbody", null,
                    React.createElement("tr", null,
                        React.createElement("td", null,
                            React.createElement("input", { type: "text", placeholder: t("User"), field: "user", onChange: handleChange, value: fields["user"] }))),
                    React.createElement("tr", null,
                        React.createElement("td", null,
                            React.createElement("input", { type: "password", placeholder: t("Password"), field: "password", onChange: handleChange, value: fields["password"] }))))),
            React.createElement("br", null),
            React.createElement("button", { className: "nomargin", style: { width: "244px", marginLeft: "10px" }, onClick: submit }, t("Login")),
            React.createElement("br", null),
            status,
            React.createElement("br", null),
            React.createElement("a", { href: "#/forgotpassword" },
                " ",
                t("Forgot your password ?"),
                " "),
            React.createElement("br", null),
            React.createElement("br", null),
            React.createElement("a", { href: "#/register" },
                t("Create an account"),
                " "))));
};
const LoginChecker = () => {
    const options = { op: "getsession" };
    const pdo = Utils.postDataOptions(options);
    fetch(SysRanger.baseURL + "/index.php", pdo)
        .then(response => response.json())
        .then((result) => {
        console.log(result);
        if (result.success) {
            SysRanger.token = result.token;
            SysRanger.userID = result.userID;
            SysRanger.companyID = result.companyID;
        }
    }, (error) => {
    }).then(() => {
        SysRanger.loginChecked = true;
        Call.refresh();
    });
    return null;
};
const RemoteLoginSystem = (props) => {
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { style: { position: "fixed", bottom: "2px", left: "4px", width: "200px" } },
            React.createElement(LanguageSelector, null)),
        React.createElement(HashRouter, null,
            React.createElement(ReactRouterDOM.Switch, null,
                React.createElement(Route, { path: "/", exact: true, component: RemoteLogin }),
                React.createElement(Route, { path: "/login", component: RemoteLogin }),
                React.createElement(Route, { path: "/register", component: RemoteRegister }),
                React.createElement(Route, { path: "/forgotpassword", component: RemoteForgotPassword }),
                React.createElement(Route, { path: "/resetpassword/:hash", component: RemotePasswordReset }),
                React.createElement(Route, { component: RemoteLogin })))));
};
const RemoteLogout = (props) => {
    const [error, setError] = useState(null);
    function logout(e) {
        e.preventDefault();
        const options = { op: "logout" };
        const pdo = Utils.postDataOptions(options);
        fetch(SysRanger.baseURL + "/index.php", pdo)
            .then(response => response.json())
            .then((result) => {
            console.log(result);
            if (result.success) {
                SysRanger.token = "";
                SysRanger.userID = 0;
                SysRanger.companyID = 0;
                window.location.href = SysRanger.baseURL;
                window.location.reload();
                return;
            }
            if (result.error) {
                setError(result.error);
            }
        }, (error) => {
            setError(error);
        });
    }
    let status = React.createElement("br", null);
    if (error) {
        status = React.createElement("div", { style: { color: "red" } }, t(error));
    }
    return (React.createElement("div", null,
        React.createElement("img", { className: "imagebutton", type: "svg", style: { width: "24px" }, src: "/images/icons/logout1.svg", onClick: logout, title: t("Logout") })));
};
const RemotePasswordReset = (props) => {
    let inputPassword = createRef();
    let inputPasswordConfirm = createRef();
    const [status, setStatus] = useState(null);
    const [buttonActive, setButtonActive] = useState(true);
    const hash = props.match.params.hash;
    function setNewPassword() {
        setButtonActive(false);
        const options = { hash: hash,
            op: "setnewpassword",
            password: inputPassword.current.value,
            passwordconfirm: inputPasswordConfirm.current.value
        };
        const pdo = Utils.postDataOptions(options);
        fetch(apiURL + "remotelogin", pdo)
            .then(response => response.json())
            .then((result) => {
            console.log(result);
            if (result.success) {
                alert("Your password has been changed. Please login.");
                Utils.redirect("https://sysranger.com/monitor/#/");
            }
            else {
                setStatus(Utils.error(result.error));
                setButtonActive(true);
            }
        }, (error) => {
            setStatus(Utils.error(error.message));
            setButtonActive(true);
        });
    }
    ;
    return (React.createElement("div", { className: "fullpage", style: { textAlign: "center" } },
        React.createElement("a", { href: 'https://sysranger.com' },
            React.createElement("img", { src: "images/logo.svg", width: "300" })),
        React.createElement("br", null),
        React.createElement("br", null),
        React.createElement("br", null),
        React.createElement("div", { className: "box", style: { height: "400px", width: "400px", float: "none", margin: "auto" } },
            React.createElement("h1", { style: { background: "none" } }, t("Reset Password")),
            React.createElement("table", { className: "nobordertable nohover nopad" },
                React.createElement("tbody", null,
                    React.createElement("tr", null,
                        React.createElement("td", null, t("Password"))),
                    React.createElement("tr", null,
                        React.createElement("td", null,
                            React.createElement("input", { type: "password", ref: inputPassword }))),
                    React.createElement("tr", null,
                        React.createElement("td", null, t("Password confirm"))),
                    React.createElement("tr", null,
                        React.createElement("td", null,
                            React.createElement("input", { type: "password", ref: inputPasswordConfirm }))))),
            React.createElement("br", null),
            React.createElement("button", { disabled: !buttonActive, className: "nomargin", style: { width: "240px" }, onClick: setNewPassword }, t("Change password")),
            React.createElement("br", null),
            React.createElement("div", null, status),
            React.createElement("br", null),
            React.createElement("br", null),
            React.createElement("a", { href: "#/register" },
                " ",
                t("Create an account"),
                " "),
            React.createElement("br", null),
            React.createElement("br", null),
            React.createElement("a", { href: "#/login" },
                t("Already have an account"),
                " "))));
};
const RemoteRegister = (props) => {
    const [fields, setFields] = useState({ user: "", email: "", password: "", passwordconfirm: "", company: "" });
    const [error, setError] = useState(null);
    const required = ["user", "email", "password", "passwordconfirm", "company"];
    function handleValidation() {
        const errors = {};
        let formIsValid = true;
        for (let i = 0; i < required.length; i++) {
            const field = required[i];
            if (!fields[field] || fields[field].length < 1) {
                formIsValid = false;
                setError(t(field) + " " + t("required"));
                return false;
            }
        }
        return formIsValid;
    }
    function submit(e) {
        e.preventDefault();
        if (!handleValidation())
            return;
        const options = Object.assign(Object.assign({}, fields), { op: "register" });
        const pdo = Utils.postDataOptions(options);
        fetch(apiURL + "remotelogin", pdo)
            .then(response => response.json())
            .then((result) => {
            console.log(result);
            if (result.success) {
                SysRanger.token = result.token;
                SysRanger.userID = result.userID;
                SysRanger.companyID = result.company;
                SysRanger.companyCount = 1;
                window.location.href = "#";
                window.location.reload();
                return;
            }
            if (result.error) {
                setError(result.error);
            }
        }, (error) => {
            setError(error.message);
        });
    }
    function handleChange(e) {
        const field = e.currentTarget.getAttribute('field');
        const value = e.target.type === "checkbox" ? e.target.checked : e.target.value;
        setFields(Object.assign(Object.assign({}, fields), { [field]: value }));
    }
    let status = React.createElement("br", null);
    if (error) {
        status = React.createElement("div", { style: { color: "red" } }, t(error));
    }
    return (React.createElement("div", { className: "fullpage", style: { textAlign: "center" } },
        React.createElement("a", { href: 'https://sysranger.com' },
            React.createElement("img", { src: "images/logo.svg", width: "300" })),
        React.createElement("br", null),
        React.createElement("br", null),
        React.createElement("br", null),
        React.createElement("div", { className: "box", style: { height: "500px", width: "400px", float: "none", margin: "auto" } },
            React.createElement("h1", { style: { background: "none" } }, t("Create an account")),
            React.createElement("table", { className: "nobordertable nohover" },
                React.createElement("tbody", null,
                    React.createElement("tr", null,
                        React.createElement("td", null, t("User")),
                        React.createElement("td", null,
                            React.createElement("input", { type: "text", field: "user", onChange: handleChange, value: fields["user"] }))),
                    React.createElement("tr", null,
                        React.createElement("td", null, t("Email")),
                        React.createElement("td", null,
                            React.createElement("input", { type: "text", field: "email", onChange: handleChange, value: fields["email"] }))),
                    React.createElement("tr", null,
                        React.createElement("td", null, t("Company name")),
                        React.createElement("td", null,
                            React.createElement("input", { type: "text", field: "company", onChange: handleChange, value: fields["company"] }))),
                    React.createElement("tr", null,
                        React.createElement("td", null, t("Password")),
                        React.createElement("td", null,
                            React.createElement("input", { type: "password", field: "password", onChange: handleChange, value: fields["password"] }))),
                    React.createElement("tr", null,
                        React.createElement("td", { style: { width: "150px" } }, t("Password Confirm")),
                        React.createElement("td", null,
                            React.createElement("input", { type: "password", field: "passwordconfirm", onChange: handleChange, value: fields["passwordconfirm"] }))))),
            React.createElement("br", null),
            status,
            React.createElement("br", null),
            React.createElement("button", { style: { width: "200px" }, onClick: submit }, t("Create Account")),
            React.createElement("br", null),
            React.createElement("br", null),
            React.createElement("br", null),
            React.createElement("a", { href: "#/forgotpassword" },
                " ",
                t("Forgot your password ?"),
                " "),
            React.createElement("br", null),
            React.createElement("br", null),
            React.createElement("a", { href: "#/login" },
                t("Already have an account"),
                " "))));
};
const RemoteSettings = {
    save: function (name, value) {
        Debugger.print("RemoteSettings.save " + name + " = " + value);
        const options = {
            op: "savesettings",
            token: SysRanger.token,
            userID: SysRanger.userID,
            name: name,
            value: value
        };
        const pdo = Utils.postDataOptions(options);
        fetch(SysRanger.baseURL + "/index.php", pdo)
            .then(response => response.json())
            .then((result) => {
            console.log(result);
        }, (error) => {
            console.log(error.message);
        });
    }
};
const RemoveSystem = (props) => {
    const [divSystem, setDivSystem] = useState(null);
    const fn = { exited: false };
    const SID = props.match.params.id;
    const [scode, setscode] = useState(null);
    function cleanUp() { fn.exited = true; }
    function back(e) { e.preventDefault(); cleanUp(); Utils.goBack(props.history); }
    useEffect(() => { getData(); return cleanUp; }, [props]);
    function getData() {
        const options = { op: "getsystem", sid: SID };
        const pdo = Utils.postDataOptions(options);
        fetch(apiURL + "systems", pdo)
            .then(response => response.json())
            .then((result) => {
            Utils.setState(fn, setDivSystem, parseSystem(result));
        }, (error) => {
            Utils.setState(fn, setDivSystem, Utils.error(error.message));
        });
    }
    ;
    function parseSystem(data) {
        if (!data.success) {
            return Utils.setState(fn, setDivSystem, Utils.error(data.error));
        }
        Utils.setState(fn, setscode, data.code);
        const div = React.createElement("div", null,
            "SID: ",
            data.code,
            "        ",
            React.createElement("br", null),
            t("Name"),
            ": ",
            data.n,
            "         ",
            React.createElement("br", null),
            t("Created"),
            ":",
            Utils.toDate(data.created),
            "      ",
            React.createElement("br", null),
            t("Hosts"),
            ":",
            data.hostCount,
            " ",
            React.createElement("br", null),
            "       ",
            React.createElement("br", null),
            t("Are you sure you want to remove ?"),
            React.createElement("br", null),
            React.createElement("br", null),
            React.createElement("button", { className: "critical", onClick: remove },
                " ",
                t("Remove")),
            React.createElement("button", { className: "btn btn-lg pro", onClick: back },
                " ",
                t("Cancel")));
        return div;
    }
    function remove(e) {
        e.preventDefault();
        const message = t("Are you sure you want to remove ?") + " : " + SID;
        if (!confirm(message)) {
            return;
        }
        const options = { op: "remove", sid: SID };
        const pdo = Utils.postDataOptions(options);
        fetch(apiURL + "systems", pdo)
            .then(response => response.json())
            .then((result) => {
            console.log(result);
            if (result.success) {
                props.history.push("/systems");
                return;
            }
            if (result.error) {
                Utils.setState(fn, setDivSystem, Utils.error(result.error));
            }
        }, (error) => {
            Utils.setState(fn, setDivSystem, Utils.error(error.message));
        });
    }
    ;
    return (React.createElement("div", { id: "page" },
        React.createElement(Header, { back: back, title: t("Remove system") + " " + (scode && "[" + scode + "]"), critical: true }),
        React.createElement("div", null, divSystem)));
};
const AlertReport = function () {
    const [divPage, setDivPage] = useState(null);
    const fn = { closed: useRef(false) };
    const [refreshing, setRefreshing] = useState(false);
    const [r, refresh] = useState(0);
    const inputStart = useRef("");
    const inputFinish = useRef("");
    const [options, setOptions] = useState({ limit: UserSettings.get("alertreports_limit", 200) });
    let chkInfo = useRef(null);
    let chkWarning = useRef(null);
    let chkCritical = useRef(null);
    let chkFatal = useRef(null);
    function cleanUp() {
        fn.closed.current = true;
    }
    function back(e) { e.preventDefault(); Utils.goBack(props.history, "#alerts"); }
    function get() {
        if (fn.closed.current)
            return;
        Utils.setState(fn, setRefreshing, true);
        const start = (new Date(inputStart.current.value)).getTime();
        const finish = (new Date(inputFinish.current.value + "T23:59:58Z")).getTime();
        let pdo = Utils.postDataOptions({ op: "report",
            start: start,
            finish: finish,
            limit: options.limit,
            info: chkInfo.current.checked,
            warning: chkWarning.current.checked,
            critical: chkCritical.current.checked,
            fatal: chkFatal.current.checked
        });
        fetch(apiURL + "alerts", pdo).then(res => res.json()).then((result) => {
            Utils.setState(fn, setRefreshing, false);
            Utils.setState(fn, setDivPage, parse(result));
        }, (error) => {
            Utils.setState(fn, setRefreshing, false);
            Utils.setState(fn, setDivPage, Utils.error(error.message));
        });
    }
    function parse(json) {
        if (!json.success) {
            return Utils.error(json.error);
        }
        const alerts = json.alerts;
        const data = {
            defaultSortField: "id",
            id: "art",
            class: "printable",
            nopadding: true,
            noCrop: true,
            multiline: true,
            headers: [
                { name: "Type", field: "tn" },
                { name: "Created", field: "ct", format: Utils.toDate, width: "80px" },
                { name: "L.Activity", field: "la", format: Utils.toDate, width: "80px" },
                { name: "Host", field: "hn" },
                { name: "Message", field: "m" },
                { name: "Details", field: "dt", rowFormat: (row) => row.dt + " " + row.info },
                { name: "Removed", field: "rm", format: Utils.toDate, width: "80px" },
            ],
            rows: alerts
        };
        return React.createElement(Table, { data: data });
    }
    function print() {
        window.print();
    }
    function changeLimit(e) {
        options.limit = e.target.value;
        UserSettings.set("alertreports_limit", options.limit);
        refresh(Utils.timeStamp());
    }
    var df = new Date();
    var today = df.getFullYear() + "-" + ("0" + (df.getMonth() + 1)).slice(-2) + "-" + ("0" + df.getDate()).slice(-2);
    var ds = new Date();
    var dsm = ds.getMonth();
    ds.setMonth(ds.getMonth() - 1);
    if (ds.getMonth() == dsm)
        ds.setDate(0);
    ds.setHours(0, 0, 0, 0);
    var oneMonthBefore = ds.getFullYear() + "-" + ("0" + (ds.getMonth() + 1)).slice(-2) + "-" + ("0" + ds.getDate()).slice(-2);
    console.log("Today:" + today + " One Month Ago:" + ds);
    console.log("Limit:" + options.limit);
    return (React.createElement("div", { id: "page" },
        React.createElement(Header, { back: back, title: t("Alert List") }),
        React.createElement("div", { className: "noprint" },
            React.createElement("input", { type: "date", ref: inputStart, id: "date_start", defaultValue: oneMonthBefore }),
            React.createElement("input", { type: "date", ref: inputFinish, id: "date_finish", defaultValue: today }),
            React.createElement("label", { title: "Info" },
                React.createElement("input", { type: "checkbox", ref: chkInfo, defaultChecked: false }),
                React.createElement("span", { style: { marginRight: "10px" } }, t("Info"))),
            React.createElement("label", { title: "Warning" },
                React.createElement("input", { type: "checkbox", ref: chkWarning, defaultChecked: false }),
                React.createElement("span", { style: { marginRight: "10px" } }, t("Warning"))),
            React.createElement("label", { title: "Critical" },
                React.createElement("input", { type: "checkbox", ref: chkCritical, defaultChecked: true }),
                React.createElement("span", { style: { marginRight: "10px" } }, t("Critical"))),
            React.createElement("label", { title: "Fatal" },
                React.createElement("input", { type: "checkbox", ref: chkFatal, defaultChecked: true }),
                React.createElement("span", { style: { marginRight: "10px" } }, t("Fatal"))),
            React.createElement("select", { style: { marginLeft: "20px" }, onChange: changeLimit, value: options.limit },
                React.createElement("option", { val: "100" }, "50"),
                React.createElement("option", { val: "200" }, "100"),
                React.createElement("option", { val: "500" }, "500"),
                React.createElement("option", { val: "1000" }, "1000")),
            React.createElement("button", { onClick: get }, t("Get")),
            React.createElement("button", { onClick: print }, t("Print"))),
        React.createElement("div", { className: "update_animation_box" }, refreshing && Utils.updating()),
        React.createElement("div", { className: "print", id: "pr", style: {} }, divPage)));
};
const SAPReport = (props) => {
    const [divPage, setDivPage] = useState(null);
    const [refDR] = useState({});
    const fn = { closed: useRef(false) };
    const SID = props.sid;
    const [options, setOptions] = useState({ limit: 10 });
    const limitRef = useRef(10);
    function cleanUp() {
        fn.closed.current = true;
        Timeouts.clearAll(timeoutID);
    }
    function back(e) { e.preventDefault(); cleanUp(); Utils.goBack(props.history); }
    function create() {
        if (fn.closed.current)
            return;
        Debugger.print("LimitRef:");
        let limit = parseInt(limitRef.current.value);
        if (!limit)
            limit = 10;
        const start = refDR.startSAPDate() + "000000";
        const end = refDR.endSAPDate() + "240000";
        Utils.setState(fn, setDivPage, "Creating the report...");
        Request.send({
            url: apiURL + "sap",
            params: { sid: SID, start: start, end: end, limit: limit, op: "jobreport" },
            listener: (json) => {
                Utils.setState(fn, setDivPage, parse(json));
            }
        });
    }
    function parse(json) {
        if (!json.success) {
            return Utils.error(json.error);
        }
        const tableDataCancelled = {
            defaultSortField: "sch",
            id: "tablecancelledjobs",
            headers: [
                { name: "System", field: "scd" },
                { name: "Host", field: "hst" },
                { name: "Instance", field: "inr" },
                { name: "Job", field: "nam" },
                { name: "Scheduled", field: "sch", format: Utils.timeSAP },
                { name: "Started", field: "str", format: Utils.timeSAP },
                { name: "End", field: "end", format: Utils.timeSAP },
                { name: "User", field: "usr" },
                { name: "Duration", field: "dur" },
            ],
            rows: json.cancelledjobs
        };
        const tableDataLong = {
            defaultSortField: "dur",
            id: "tablelongrunningjobs",
            direction: "descending",
            headers: [
                { name: "System", field: "scd" },
                { name: "Host", field: "hst" },
                { name: "Instance", field: "inr" },
                { name: "Job", field: "nam" },
                { name: "Scheduled", field: "sch", format: Utils.timeSAP },
                { name: "Started", field: "str", format: Utils.timeSAP },
                { name: "End", field: "end", format: Utils.timeSAP },
                { name: "User", field: "usr" },
                { name: "Duration", field: "dur" },
            ],
            rows: json.topdurations
        };
        const tableDataOverlapped = {
            defaultSortField: "dur",
            id: "tableoverlappedjobs",
            direction: "descending",
            headers: [
                { name: "System", field: "scd" },
                { name: "Host", field: "hst" },
                { name: "Instance", field: "inr" },
                { name: "Job", field: "nam" },
                { name: "Scheduled", field: "sch", format: Utils.timeSAP },
                { name: "Started", field: "str", format: Utils.timeSAP },
                { name: "End", field: "end", format: Utils.timeSAP },
                { name: "User", field: "usr" },
                { name: "Duration", field: "dur" },
                { name: "Status", field: "stt" },
            ],
            rows: json.overlapped
        };
        const tableDataOverlappedDB = {
            defaultSortField: "dur",
            id: "tableoverlappedjobsdb",
            direction: "descending",
            headers: [
                { name: "System", field: "scd" },
                { name: "Host", field: "hst" },
                { name: "Instance", field: "inr" },
                { name: "Job", field: "nam" },
                { name: "Scheduled", field: "sch", format: Utils.timeSAP },
                { name: "Started", field: "str", format: Utils.timeSAP },
                { name: "End", field: "end", format: Utils.timeSAP },
                { name: "User", field: "usr" },
                { name: "Duration", field: "dur" },
                { name: "Status", field: "stt" },
            ],
            rows: json.overlappeddb
        };
        const tableDataFrequencies = {
            defaultSortField: "cnt",
            id: "tablejobfrequencies",
            direction: "descending",
            headers: [
                { name: "Count", field: "cnt" },
                { name: "Job", field: "nam" },
                { name: "User", field: "usr" },
            ],
            rows: json.frequencies
        };
        const tableDataDailyCancelledJobs = {
            defaultSortField: "cnt",
            id: "tablejobfrequencies",
            direction: "descending",
            headers: [
                { name: "Count", field: "cnt" },
                { name: "Job", field: "nam" },
                { name: "End", field: "end" },
                { name: "Period", field: "prd" },
            ],
            rows: json.dailycancelledjobs
        };
        const tableDataDailyRuntimeErrors = {
            defaultSortField: "cnt",
            id: "tablejobfrequencies",
            direction: "descending",
            headers: [
                { name: "Count", field: "cnt" },
                { name: "Date", field: "date" },
            ],
            rows: json.runtimeerrors
        };
        const tableDataDailyMailErrors = {
            defaultSortField: "cnt",
            id: "tablejobfrequencies",
            direction: "descending",
            headers: [
                { name: "Count", field: "cnt" },
                { name: "Date", field: "date" },
            ],
            rows: json.mailerrors
        };
        return React.createElement("div", null,
            React.createElement("h1", null, "Cancelled jobs"),
            React.createElement(Table, { data: tableDataCancelled }),
            React.createElement("h1", null, "Long running jobs"),
            React.createElement(Table, { data: tableDataLong }),
            React.createElement("h1", null,
                "Overlapped jobs  ( ",
                json.overlapped.length,
                " ) "),
            React.createElement("div", { style: { height: "400px", overflow: "auto" } },
                React.createElement(Table, { data: tableDataOverlapped })),
            React.createElement("h1", null,
                "Overlapped jobs DB ( ",
                json.overlappeddb.length,
                " )"),
            React.createElement("div", { style: { height: "400px", overflow: "auto" } },
                React.createElement(Table, { data: tableDataOverlappedDB })),
            React.createElement("h1", null, "Most executed jobs"),
            React.createElement(Table, { data: tableDataFrequencies }),
            React.createElement("h1", null, "Cancelled periodic jobs(daily)"),
            React.createElement(Table, { data: tableDataDailyCancelledJobs }),
            React.createElement("h1", null, "Runtime Errors(daily)"),
            React.createElement(Table, { data: tableDataDailyRuntimeErrors }),
            React.createElement("h1", null, "Mail Errors(daily)"),
            React.createElement(Table, { data: tableDataDailyMailErrors }));
    }
    function dateSelected(component) {
    }
    return (React.createElement("div", { id: 'page' },
        React.createElement(Header, { back: back, title: t("Systems") }),
        React.createElement(DateRange, { listener: dateSelected, fn: refDR, start: new Date().getTime() - Time.month }),
        React.createElement("select", { style: { marginLeft: "20px" }, ref: limitRef },
            React.createElement("option", { val: "10" }, "10"),
            React.createElement("option", { val: "20" }, "20"),
            React.createElement("option", { val: "50" }, "50"),
            React.createElement("option", { val: "100" }, "100"),
            React.createElement("option", { val: "250" }, "250"),
            React.createElement("option", { val: "500" }, "500"),
            React.createElement("option", { val: "1000" }, "1000")),
        React.createElement("button", { onClick: create },
            " ",
            t("Get Report")),
        divPage));
};
const SAPReportList = (props) => {
    const [divPage, setDivPage] = useState(null);
    const fn = { closed: useRef(false) };
    const timeoutID = "sapreports";
    function cleanUp() {
        fn.closed.current = true;
        Timeouts.clearAll(timeoutID);
    }
    useEffect(() => { fn.closed.current = false; loadData(); return cleanUp; }, [props]);
    function loadData() {
        Timeouts.clearAll(timeoutID);
        if (fn.closed.current)
            return;
        let pdo = Utils.postDataOptions({ op: "getall", sid: props.sid });
        fetch(apiURL + "sapreport", pdo).then(res => res.json()).then((result) => {
            Utils.setState(fn, setDivPage, parse(result));
        }, (error) => {
            Utils.setState(fn, setDivPage, Utils.error(error.message));
        }).then(() => {
            Timeouts.add(timeoutID, setTimeout(loadData, 5000));
        });
    }
    ;
    function resendLink(row) {
        if (!row.fileexist)
            return "";
        return React.createElement("button", { onClick: () => resend(row.id) }, " Re-send ");
    }
    function resend(rid) {
        Request.send({
            url: apiURL + "sapreport",
            params: { op: "resend", rid: rid },
            success: (json) => {
                Info.success(json.filename + " is successfully sent to " + json.addresses);
            }
        });
    }
    function errorCount(row) {
        if (row.errorcount < 1)
            return "";
        return React.createElement("a", { rid: row.id, onClick: showErrors },
            row.errorcount + " errors",
            " ");
    }
    function showErrors(e) {
        const anchor = e.currentTarget;
        const rid = anchor.getAttribute('rid');
        const div = React.createElement(SAPReportErrorList, { rid: rid });
        Dialog.show({ content: div, render: true });
    }
    function status(val) {
        let color = Colors.red;
        switch (val) {
            case "completed":
                color = Colors.green;
                break;
        }
        return React.createElement("span", { style: { color: color } },
            val,
            " ");
    }
    function fileName(row) {
        if (row.fileexist) {
            return React.createElement("a", { target: "_blank", href: "/files/reports/" + row.filename }, row.filename);
        }
        return React.createElement("span", { style: { color: Colors.red } }, row.filename);
    }
    function parse(json) {
        if (!json.success) {
            return Utils.error(json.error);
        }
        const data = {
            defaultSortField: "period",
            id: "tableasapsystemreports",
            direction: "descending",
            headers: [
                { name: "SID", field: "scode" },
                { name: "Name", field: "sname" },
                { name: "Period", field: "period" },
                { name: "Status", field: "status", format: status },
                { name: "Filename", field: "filename", rowFormat: fileName },
                { name: "Mails", field: "mails" },
                { name: "Created", field: "created", format: Utils.toDate },
                { name: "Errors", field: "errorcount", rowFormat: errorCount },
                { name: "Mail Errors", field: "mailsenderrors" },
                { name: "Re-send", field: "fileexist", rowFormat: resendLink }
            ],
            rows: json.reports
        };
        return React.createElement(Table, { data: data });
    }
    return (React.createElement("div", { id: 'panel_sap_report_list' }, divPage));
};
const SAPReportSettings = (props) => {
    const [divPage, setDivPage] = useState(null);
    const [divCheckResult, setDivCheckResult] = useState(null);
    const fn = { closed: useRef(false) };
    const [disabled, setDisabled] = useState({});
    const inputEmails = useRef();
    function cleanUp() {
        fn.closed.current = true;
    }
    useEffect(() => { fn.closed.current = false; init(); return cleanUp; }, []);
    function init() {
        if (fn.closed.current)
            return;
    }
    ;
    function updateEmails() {
        Settings.checkAndSet({ key: "sap_report_receivers", value: inputEmails.current.value, type: "email" }, (result) => {
            if (result.success) {
                Info.success("Email addresses are saved.");
            }
        });
    }
    function checkNewReports() {
        disabled.buttonCheckNewReports = true;
        Request.send({
            url: apiURL + "sapreport",
            params: { op: "checkall" },
            listener: (json) => {
                disabled.buttonCheckNewReports = false;
                Utils.setState(fn, setDivCheckResult, parseCheckResult(json));
            }
        });
    }
    function parseCheckResult(json) {
        if (!json.success) {
            return Utils.error(json.error);
        }
        const messages = [React.createElement("div", { key: "srlr_start" },
                "Checking completed  ",
                Utils.date())];
        for (let i = 0; i < json.mails.length; i++) {
            const mail = json.mails[i];
            const style = {};
            if (!mail.success)
                style.color = Colors.red;
            const div = React.createElement("div", { key: "srlm_" + i, style: style },
                "Mail - " + mail.message,
                " ");
            messages.push(div);
        }
        for (let i = 0; i < json.pdfs.length; i++) {
            const pdf = json.pdfs[i];
            const style = {};
            if (!pdf.success)
                style.color = Colors.red;
            const div = React.createElement("div", { key: "srlp_" + i, style: style },
                "PDF - " + pdf.message,
                " ");
            messages.push(div);
        }
        return messages;
    }
    return (React.createElement("div", { id: 'panel_sap_report_settings' },
        "For each SAP system a monthly report is created. You can define receiver mail addresses that will automatically receiver system reports monthly.",
        React.createElement("br", null),
        "SAP Report is automatically created on 3rd day of each month. The report contains statistical information of previous month.",
        React.createElement("br", null),
        "You can define multiple mail addresses by using comma (,) as seperator.",
        React.createElement("br", null),
        React.createElement("br", null),
        React.createElement("br", null),
        "SAP report receiver e-mail addresses:",
        React.createElement("input", { type: "text", defaultValue: Settings.get("sap_report_receivers"), ref: inputEmails }),
        React.createElement("button", { onClick: updateEmails }, " Update"),
        React.createElement("br", null),
        React.createElement("br", null),
        React.createElement("br", null),
        React.createElement("button", { onClick: checkNewReports, disabled: disabled.buttonCheckNewReports == true }, " Check New Reports "),
        divCheckResult));
};
const SAPReportSettingsPage = (props) => {
    const fn = { closed: useRef(false) };
    function cleanUp() {
        fn.closed.current = true;
    }
    function back(e) { e.preventDefault(); cleanUp(); Utils.goBack(props.history); }
    return (React.createElement("div", { id: 'page' },
        React.createElement(Header, { back: back, title: t("SAP Report Settings") }),
        React.createElement(SAPReportSettings, null),
        React.createElement("br", null),
        React.createElement(SAPReportList, null)));
};
const Request = {
    send: function (data) {
        if (data.caller && data.caller.closed.current)
            return;
        if (!data.url)
            return Info.error("Incorrect Post URL");
        let pdo = Utils.postDataOptions(data.params);
        const f = fetch(data.url, pdo).then(res => res.json()).then((json) => {
            if (data.caller && data.caller.closed.current)
                return;
            if (json.success) {
                if (data.refresh)
                    Call.refresh();
                if (data.message)
                    Info.success(data.message);
                if (data.success) {
                    data.success(json);
                }
            }
            else if (!data.listener) {
                Info.error(json.error);
            }
            if (data.listener) {
                data.listener(json);
            }
        }, (error) => {
            if (data.caller && data.caller.closed.current)
                return;
            if (data.listener) {
                data.listener({ success: false, error: error.message });
            }
            else {
                Info.error(error.message);
            }
        });
        if (data.then) {
            if (!(data.caller && data.caller.closed.current)) {
                f.then(data.then);
            }
        }
        ;
    }
};
const SAPScannerPage = (props) => {
    const [host, setHost] = useState(null);
    let inputIP = createRef();
    let inputUser = createRef();
    let inputPassword = createRef();
    function start() {
        let ip = inputIP.current.value;
        console.log("SAPScannerPage.start:" + ip);
        setHost({ ip: inputIP.current.value, user: inputUser.current.value, password: inputPassword.current.value });
    }
    ;
    function back(e) { e.preventDefault(); cleanUp(); Utils.goBack(props.history); }
    let scanner = null;
    if (host) {
        scanner = React.createElement(SAPScanner, { data: { host: host.ip, user: host.user, password: host.password } });
    }
    return (React.createElement("div", { id: 'page' },
        React.createElement("h1", null,
            React.createElement("a", { className: "back", onClick: back, title: t("Return Back") }, "  "),
            " ",
            t("SAP Instance Scanner")),
        React.createElement("br", null),
        React.createElement("table", null,
            React.createElement("tbody", null,
                React.createElement("tr", null,
                    React.createElement("td", null, t("Host")),
                    React.createElement("td", null,
                        React.createElement("input", { ref: inputIP, id: "inputIP", type: 'text' }))),
                React.createElement("tr", null,
                    React.createElement("td", null, t("User")),
                    React.createElement("td", null,
                        React.createElement("input", { ref: inputUser, id: "inputUser", type: 'text' }))),
                React.createElement("tr", null,
                    React.createElement("td", null, t("Password")),
                    React.createElement("td", null,
                        React.createElement("input", { ref: inputPassword, id: "inputPassword", type: 'password' }))))),
        React.createElement("button", { onClick: start },
            "\u00A0",
            t("Start")),
        React.createElement("br", null),
        scanner));
};
const SAPScannerPanel = (props) => {
    const hostID = props.hostID;
    const [div, setDiv] = useState(null);
    const fn = { exited: false };
    function cleanUp() { fn.exited = true; }
    useEffect(() => { start(); return cleanUp; }, []);
    function start() {
        const scanner = React.createElement(SAPScanner, { data: { hostID: hostID } });
        Utils.setState(fn, setDiv, scanner);
    }
    return (React.createElement("div", null, div));
};
const SAPScanner = (props) => {
    const data = props.data;
    const url = apiURL + "sapscanner";
    const [content, setContent] = useState(null);
    const fn = { exited: false };
    function cleanUp() { fn.exited = true; }
    useEffect(() => { start(); return cleanUp; }, [props]);
    function start() {
        Utils.setState(fn, setContent, Utils.loading());
        let options = { ip: data.host, op: "start", user: data.user, password: data.password, hostid: data.hostID };
        let pdo = Utils.postDataOptions(options);
        fetch(url, pdo).then(res => res.json()).then((result) => {
            Utils.setState(fn, setContent, parseData(result));
        }, (error) => {
            Utils.setState(fn, setContent, error.message);
        });
    }
    ;
    function parseData(json) {
        if (!json) {
            return Utils.error("Incorrect parameters");
        }
        if (!json.success) {
            let error = t(json.error);
            if (json.url)
                error += " : " + json.url;
            return Utils.error(error);
        }
        const tableInstances = {
            defaultSortField: "id",
            id: "ipt",
            headers: [
                { name: "SID", field: "sid" },
                { name: "Number", field: "nr" },
                { name: "Host", field: "host" },
                { name: "SAP Version", field: "sapversion", width: "100%" }
            ],
            rows: json.instances
        };
        const tableDatabases = {
            defaultSortField: "id",
            id: "ipt",
            headers: [
                { name: "Status", field: "status", height: "100px" },
                { name: "Properties", field: "properties", width: "400px", noCrop: true, height: "100%" },
                { name: "Components", field: "components" }
            ],
            rows: json.databases
        };
        const div = React.createElement("div", null,
            React.createElement("h4", null, "Instances"),
            React.createElement(Table, { data: tableInstances }),
            React.createElement("h4", null, "Databases"),
            React.createElement(Table, { data: tableDatabases }));
        return div;
    }
    return (React.createElement("div", { id: 'panel_sap_scanner' }, content));
};
const SAP = {
    periodType: (type) => {
        switch (type) {
            case "D": return "Daily";
            case "W": return "Weekly";
            case "M": return "Monthly";
        }
        return "-";
    },
    taskType: (type) => {
        switch (type) {
            case "01": return "DIALOG";
            case "02": return "UPDATE";
            case "03": return "SPOOL";
            case "04": return "BACKGROUND";
            case "05": return "ENQUEUE";
            case "06": return "BUFFER SYNC";
            case "07": return "AUTOABAP";
            case "08": return "UPDATE2";
            case "0A": return "EXT. PLUGIN";
            case "0B": return "AUTOTH";
            case "0C": return "RPC TH";
            case "0D": return "RFC MVC";
            case "0E": return "DDLOG CLEANUP";
            case "0F": return "DELAYED T.H. CALL";
            case "10": return "AUTOJAVA";
            case "11": return "LICENSE SRV";
            case "12": return "AUTOCCMS";
            case "13": return "MSADM";
            case "14": return "SYS STARTUP";
            case "21": return "OTHERS";
            case "22": return "DINOGUI";
            case "23": return "B.INPUT";
            case "65": return "HTTP";
            case "66": return "HTTPs";
            case "67": return "NNTP";
            case "68": return "SMTP";
            case "69": return "FTP";
            case "6C": return "LCOM";
            case "75": return "HTTP/JSP";
            case "76": return "HTTPS/JSP";
            case "F7": return "LR.RFC";
            case "F8": return "NBR. BUFFER";
            case "F9": return "AUTORFC";
            case "FA": return "WSRFC";
            case "FC": return "ESI";
            case "FD": return "ALE";
            case "FE": return "RFC";
            case "FF": return "CPIC";
        }
        return type;
    }
};
const Settings = {};
Settings.settings = { 0: {} };
Settings.put = function (data) {
    const probeID = Utils.toInt(data.probeid);
    let value = data.value;
    if (typeof value == "boolean") {
        value = value ? "true" : "false";
    }
    if (!Settings.settings[probeID]) {
        Settings.settings[probeID] = {};
    }
    Settings.settings[probeID][data.key] = value;
    if (probeID == 0) {
        settings[data.key] = value;
    }
};
Settings.set = function (data, callback) {
    const probeID = Utils.toInt(data.probeid);
    const options = { op: "set", probeid: probeID, name: data.key, value: data.value };
    if (data.type)
        options.type = data.type;
    const pdo = Utils.postDataOptions(options);
    Settings.put(data);
    fetch(apiURL + "settings", pdo)
        .then(response => response.json())
        .then((result) => {
        if (!result.success) {
            Info.error(result.error);
        }
        if (callback) {
            callback(result);
        }
    }, (error) => {
        Info.error(error.message);
        if (callback) {
            callback({ success: false, error: error.message });
        }
    });
};
Settings.checkAndSet = function (data, callback) {
    const probeID = Utils.toInt(data.probeid);
    const options = { op: "set", probeid: probeID, name: data.key, value: data.value, type: data.type };
    const pdo = Utils.postDataOptions(options);
    fetch(apiURL + "settings", pdo)
        .then(response => response.json())
        .then((result) => {
        if (!result.success) {
            Info.error(result.error);
        }
        else {
            Settings.put(data);
        }
        if (callback) {
            callback(result);
        }
    }, (error) => {
        Info.error(error.message);
        if (callback) {
            callback({ success: false, error: error.message });
        }
    });
};
Settings.save = function (name, value, callback) {
    const data = { key: name, value: value, propbeid: 0 };
    Settings.set(data, callback);
};
Settings.get = function (data, defaultValue) {
    const probeID = Utils.toInt(data.probeid);
    const key = data.key || data;
    const map = Settings.settings[probeID];
    let value = undefined;
    if (map) {
        value = map[key];
    }
    if (!value) {
        if (defaultValue != undefined) {
            value = defaultValue;
        }
        else {
            value = "";
        }
    }
    return value;
};
Settings.getBoolean = function (data) {
    const strVal = Settings.get(data);
    return strVal === "true";
};
Settings.getInt = function (data) {
    const strVal = Settings.get(data);
    return Utils.toInt(strVal);
};
const SOAPTest = (props) => {
    const [divDetails, setDivDetails] = useState(null);
    const [data, setData] = useState(null);
    const [refreshing, setRefreshing] = useState(false);
    const fn = { exited: false };
    let refreshTimeout = 0;
    const instanceID = props.instanceID;
    function cleanUp() {
        fn.exited = true;
        clearTimeout(refreshTimeout);
    }
    useEffect(() => { loadData(); return cleanUp; }, []);
    function loadData() {
        if (fn.exited)
            return;
        let pdo = Utils.postDataOptions({ op: "soaptest", id: instanceID });
        Utils.setState(fn, setRefreshing, true);
        fetch(apiURL + "instances", pdo).then(res => res.json()).then((result) => {
            console.log(result);
            Utils.setState(fn, setData, result);
            Utils.setState(fn, setDivDetails, parseData(result));
        }, (error) => {
            return Utils.setState(fn, setDivDetails, Utils.error(error.message));
        }).then(() => {
            if (fn.exited)
                return;
            setTimeout(() => Utils.setState(fn, setRefreshing, false), 1000);
            refreshTimeout = setTimeout(loadData, 10000);
        });
    }
    function parseData(json) {
        if (!json.success || !json.processes) {
            return Utils.error(json.error);
        }
        const data = {
            defaultSortField: "id",
            id: "ipt",
            headers: [
                { name: "ID", field: "id" },
                { name: "Name", field: "name" },
                { name: "Description", field: "description" },
                { name: "Status", field: "status" },
                { name: "Start", field: "start" },
                { name: "Elapsed", field: "elapsed" }
            ],
            rows: json.processes
        };
        return React.createElement(Table, { data: data });
    }
    ;
    return (React.createElement("div", { id: 'page' }, divDetails));
};
const FileType = {
    DIRECTORY: 1,
    FILE: 2
};
const DBType = {
    HANA: "hdb",
    ASE: "syb",
    ORACLE: "ora",
    MSSQL: "mss",
    DB2: "db6",
    MAXDB: "ada",
    SQLITE: "sqlite",
    MYSQL: "mysql"
};
const OSType = {
    Unknown: 0,
    Windows: 1,
    Linux: 2
};
const UnitType = {
    UNKNOWN: 0,
    PHYSICAL: 1,
    VIRTUAL: 2,
    DEVICE: 3,
    VCENTER: 4
};
const SAPJobStatusCodes = {
    R: "Running",
    Z: "Running",
    F: "Finished",
    A: "Cancelled",
    P: "Scheduled",
    S: "Released",
    Y: "Ready"
};
const DatabaseNames = {};
DatabaseNames[DBType.HANA] = { name: "Hana" };
DatabaseNames[DBType.ORACLE] = { name: "Oracle" };
DatabaseNames[DBType.ASE] = { name: "Sybase" };
DatabaseNames[DBType.MSSQL] = { name: "MsSQL" };
DatabaseNames[DBType.DB2] = { name: "DB2" };
DatabaseNames[DBType.MYSQL] = { name: "MySQL" };
DatabaseNames[DBType.MAXDB] = { name: "MaxDB" };
DatabaseNames[DBType.SQLITE] = { name: "SQLite" };
DatabaseNames.sorted = [
    DBType.HANA,
    DBType.ASE,
    DBType.ORACLE,
    DBType.MSSQL,
    DBType.DB2,
    DBType.MAXDB,
    DBType.MYSQL,
    DBType.SQLITE
];
const DatabaseStatuses = {
    SAP_HOST_CONTROL_DB_UNKNOWN: "Unknown",
    SAP_HOST_CONTROL_DB_STOPPED: "Stopped",
    SAP_HOST_CONTROL_DB_STOPPING: "Stopping",
    SAP_HOST_CONTROL_DB_RUNNING: "Running",
    SAP_HOST_CONTROL_DB_STARTING: "Starting",
    SAP_HOST_CONTROL_DB_WARNING: "Warning",
    SAP_HOST_CONTROL_DB_INSERVICE: "In Service",
    SAP_HOST_CONTROL_DB_ERROR: "Error",
    SAP_HOST_CONTROL_DB_LAST: "Last"
};
const DB = {
    getNameByType: function (type) { return DatabaseNames[type].name; }
};
const Database = {
    getStatus: function (key) {
        if (DatabaseStatuses[key])
            return DatabaseStatuses[key];
        return key;
    }
};
const Time = {
    minute: 60000,
    hour: 3600000,
    day: 86400000,
    month: 30 * 24 * 60 * 60 * 1000,
    year: 31556952000,
    SC_DAY: 86400,
    SC_HOUR: 3600,
    SC_MINUTE: 60
};
const ItemType = {
    UNKNOWN: 0,
    SYSTEM: 1,
    HOST: 2,
    INSTANCE: 3,
    DATABASE: 4
};
const Statics = {};
const ABAPRuntimeErrors = (props) => {
    const [divPage, setDivPage] = useState(null);
    const [refreshing, setRefreshing] = useState(true);
    const fn = { closed: useRef(false) };
    const SID = props.sid;
    const [refDR] = useState({});
    function cleanUp() {
        fn.closed.current = true;
    }
    useEffect(() => { fn.closed.current = false; loadData(); return cleanUp; }, [SID]);
    function loadData() {
        if (fn.closed.current)
            return;
        Utils.setState(fn, setRefreshing, true);
        let pdo = Utils.postDataOptions({
            op: "abapruntimeerrors",
            sid: SID,
            start: refDR.startSAPDate(),
            end: refDR.endSAPDate(),
            limit: 200
        });
        fetch(apiURL + "sap", pdo).then(res => res.json()).then((result) => {
            Utils.setState(fn, setRefreshing, false);
            Utils.setState(fn, setDivPage, parse(result));
        }, (error) => {
            Utils.setState(fn, setRefreshing, false);
            Utils.setState(fn, setDivPage, Utils.error(error.message));
        });
    }
    ;
    function dateFormat(val) {
        if (!val)
            return val;
        if (val.length < 14)
            return val;
        return val.substr(0, 4) + "-" + val.substr(4, 2) + "-" + val.substr(6, 2) + " " +
            val.substr(8, 2) + ":" + val.substr(10, 2) + ":" + val.substr(12, 2);
    }
    function parse(json) {
        if (!json.success) {
            return Utils.error(json.error);
        }
        if (!json.runtimeerrors || !json.runtimeerrors.length) {
            return "Empty";
        }
        const data = {
            defaultSortField: "d",
            id: "tableabapruntimeerrors",
            headers: [
                { name: "Date", field: "d", format: dateFormat },
                { name: "Code", field: "c" },
                { name: "Program", field: "p" },
                { name: "Source", field: "s" },
                { name: "User", field: "u" }
            ],
            rows: json.runtimeerrors
        };
        return React.createElement(Table, { data: data });
    }
    function search() {
        loadData();
    }
    return (React.createElement("div", { id: 'panel_abap_runtime_errors' },
        React.createElement("div", { className: "update_animation_box" }, refreshing && Utils.updating()),
        React.createElement("h3", null, " SAP-ABAP Runtime Errors (ST22) "),
        React.createElement(DateRange, { fn: refDR }),
        React.createElement("button", { onClick: search },
            " ",
            t("Search")),
        React.createElement("br", null),
        divPage));
};
const AddNewSystem = (props) => {
    const fn = { closed: useRef(false) };
    const inputCode = useRef();
    const inputName = useRef();
    const GID = props.match.params.gid;
    function back(e) { e.preventDefault(); cleanUp(); Utils.goBack(props.history); }
    function cleanUp() {
        fn.closed.current = true;
    }
    function add() {
        const code = inputCode.current.value;
        Request.send({
            caller: fn,
            url: apiURL + "systems",
            params: { op: "addsystem", sid: code, name: inputName.current.value, gid: GID },
            message: code + " is added",
            success: (json) => {
                Utils.go(props.history, "/system/" + json.id);
            }
        });
    }
    let title = t("Create new system");
    console.log("GID:" + GID);
    if (Data.groups[GID]) {
        const group = Data.groups[GID];
        title += " [" + group.code + "]";
    }
    return (React.createElement("div", { id: "page" },
        React.createElement(Header, { back: back, title: title }),
        React.createElement("div", { className: "panel" },
            t("SID"),
            ":",
            React.createElement("input", { type: "text", ref: inputCode }),
            t("Description"),
            ":",
            React.createElement("input", { type: "text", ref: inputName }),
            React.createElement("button", { onClick: add }, t("Add")))));
};
const SAPAuditAlertRules = (props) => {
    const [divPage, setDivPage] = useState(null);
    const [refreshing, setRefreshing] = useState(false);
    const fn = { closed: useRef(false) };
    const SID = props.sid;
    let inputMID = useRef();
    let inputUser = useRef();
    let inputProgram = useRef();
    let inputTransaction = useRef();
    let inputMIDException = useRef();
    let inputUserException = useRef();
    let inputProgramException = useRef();
    let inputTransactionException = useRef();
    let inputDescription = useRef();
    let refSelectAlertType = useRef();
    const timeoutID = "sapauditalertrules_" + SID;
    function cleanUp() {
        fn.closed.current = true;
    }
    useEffect(() => { fn.closed.current = false; init(); return cleanUp; }, [SID]);
    function init() {
        if (fn.closed.current)
            return;
        loadData();
    }
    ;
    function loadData() {
        Timeouts.clearAll(timeoutID);
        if (fn.closed.current)
            return;
        Utils.setState(fn, setRefreshing, true);
        Request.send({
            caller: fn,
            url: apiURL + "audit",
            params: { op: "alert-rules", sid: SID },
            listener: (json) => {
                Utils.setState(fn, setRefreshing, false);
                Utils.setState(fn, setDivPage, parse(json));
            }
        });
    }
    function alertType(type) {
        return React.createElement("span", { style: { color: Utils.alertColor(type) } },
            " ",
            Utils.alertTypeName(type),
            " ");
    }
    function remove(row) {
        if (fn.closed.current)
            return;
        const message = t("Are you sure you want to remove ?");
        if (!confirm(message))
            return;
        if (fn.closed.current)
            return;
        Request.send({
            caller: fn,
            url: apiURL + "audit",
            params: { op: "remove-alert-rule", arid: row.id, sid: SID },
            listener: (json) => {
                if (json.success) {
                    Info.success("Removed");
                }
                else {
                    Info.error(json.error);
                }
                reload();
            }
        });
    }
    function parse(json) {
        if (!json.success) {
            return Utils.error(json.error);
        }
        const data = {
            id: "tableasapauditalertrules",
            headers: [
                { name: "#", number: true },
                { name: "Severity", field: "alerttype", format: alertType },
                { name: "MID", field: "mid", width: "60px", filter: {} },
                { name: "MIDEx", field: "midex", width: "60px", filter: {} },
                { name: "User", field: "uname", width: "60px", filter: {} },
                { name: "UserEx", field: "unameex", width: "60px", filter: {} },
                { name: "Transaction", field: "tran", width: "60px", filter: {} },
                { name: "TransactionEx", field: "tranex", filter: {} },
                { name: "Program", field: "program", filter: {} },
                { name: "ProgramEx", field: "programex", filter: {} },
                { name: "Description", field: "description", filter: {}, width: "200px" },
                (User.admin) && { name: "Remove", field: "id", onClick: remove, width: "40px", icon: "remove.svg" },
            ],
            rows: json.rules
        };
        return React.createElement(React.Fragment, null,
            React.createElement(Table, { data: data }));
    }
    function reload() {
        Timeouts.clearAll(timeoutID);
        Timeouts.add(timeoutID, setTimeout(loadData, 10));
    }
    function add() {
        if (fn.closed.current)
            return;
        Request.send({
            caller: fn,
            url: apiURL + "audit",
            params: { op: "add-alert-rule",
                sid: SID,
                description: inputDescription.current.value,
                user: inputUser.current.value,
                userex: inputUserException.current.value,
                mid: inputMID.current.value,
                midex: inputMIDException.current.value,
                transaction: inputTransaction.current.value,
                transactionex: inputTransactionException.current.value,
                program: inputProgram.current.value,
                programex: inputProgramException.current.value,
                alerttype: refSelectAlertType.current.value
            },
            listener: (json) => {
                if (json.success) {
                    Info.success("New sap audit alert rule added.");
                }
                else {
                    Info.error(json.error);
                }
                reload();
            }
        });
    }
    return (React.createElement("div", { id: 'panel_sap_audit_alert_rules' },
        React.createElement("div", { className: "update_animation_box" }, refreshing && Utils.updating()),
        divPage,
        React.createElement("div", { className: "panel" },
            React.createElement("div", null, "Use the following input fields to create alert rules. Use comma between values. Leave empty if no selection criteria is necessary."),
            React.createElement("br", null),
            React.createElement("button", null, "Alert Rule Templates "),
            React.createElement("br", null),
            React.createElement("br", null),
            React.createElement("table", null,
                React.createElement("thead", null,
                    React.createElement("tr", null,
                        React.createElement("td", null, "Rule"),
                        React.createElement("td", null, "User"),
                        React.createElement("td", null, "Message ID"),
                        React.createElement("td", null, "Program"),
                        React.createElement("td", null, "Transaction"),
                        React.createElement("td", null, "Severity"))),
                React.createElement("tbody", null,
                    React.createElement("tr", null,
                        React.createElement("td", null, " Select "),
                        React.createElement("td", null,
                            React.createElement("input", { ref: inputUser, type: 'text' }),
                            " "),
                        React.createElement("td", null,
                            React.createElement("input", { ref: inputMID, type: 'text', spaplaceholder: "AU1,AUC,.." })),
                        React.createElement("td", null,
                            React.createElement("input", { ref: inputProgram, type: 'text' })),
                        React.createElement("td", null,
                            React.createElement("input", { ref: inputTransaction, type: 'text' })),
                        React.createElement("td", null,
                            React.createElement("select", { ref: refSelectAlertType },
                                React.createElement("option", { value: "1" }, " Info "),
                                React.createElement("option", { value: "2" }, " Warning "),
                                React.createElement("option", { value: "3" }, " Critical "),
                                React.createElement("option", { value: "4" }, " Fatal ")))),
                    React.createElement("tr", null,
                        React.createElement("td", null, " Exceptions "),
                        React.createElement("td", null,
                            React.createElement("input", { ref: inputUserException, type: 'text' }),
                            " "),
                        React.createElement("td", null,
                            React.createElement("input", { ref: inputMIDException, type: 'text', spaplaceholder: "AU1,AUC,.." })),
                        React.createElement("td", null,
                            React.createElement("input", { ref: inputProgramException, type: 'text' })),
                        React.createElement("td", null,
                            React.createElement("input", { ref: inputTransactionException, type: 'text' })),
                        React.createElement("td", null)))),
            React.createElement("br", null),
            "Description: ",
            React.createElement("input", { ref: inputDescription, type: "text" }),
            React.createElement("br", null),
            React.createElement("button", { onClick: add }, t("Add Rule")))));
};
const SAPAuditAlertRulesPage = (props) => {
    const SID = props.match.params.sid;
    function back(e) {
        e.preventDefault();
        Utils.goBack(props.history, "/#system/" + SID);
    }
    return (React.createElement("div", { id: 'page' },
        React.createElement(Header, { back: back, title: t("System security audit log alert rules") }),
        React.createElement(SAPAuditAlertRules, { sid: SID })));
};
const SAPAuditRFC = (props) => {
    const [divPage, setDivPage] = useState(null);
    const [refreshing, setRefreshing] = useState(false);
    const [audit, setAudit] = useState({ loaded: false });
    const fn = { closed: useRef(false) };
    const SID = props.sid;
    const [r, refresh] = useState(0);
    const [refDR] = useState({});
    let inputMID = useRef();
    let inputUser = useRef();
    let inputProgram = useRef();
    let inputTransaction = useRef();
    function cleanUp() {
        fn.closed.current = true;
    }
    useEffect(() => { fn.closed.current = false; loadData(); return cleanUp; }, [SID]);
    function loadData() {
        if (fn.closed.current)
            return;
        Utils.setState(fn, setRefreshing, true);
        Request.send({
            caller: fn,
            url: apiURL + "audit",
            params: { op: "info", sid: SID },
            listener: (json) => {
                Utils.setState(fn, setRefreshing, false);
                if (!json.success) {
                    Utils.setState(fn, setPage, Utils.error(json.error));
                    return;
                }
                if (json.functionerror) {
                    Utils.setState(fn, setPage, Utils.error(json.functionerror));
                    return;
                }
                audit.loaded = true;
                audit.newFunction = json.new;
                audit.oldFunction = json.new;
                Utils.setState(fn, setAudit, audit);
                Utils.setState(fn, refresh, Utils.timeStamp());
            },
        });
    }
    ;
    function search() {
        if (fn.closed.current)
            return;
        Utils.setState(fn, setRefreshing, true);
        const options = {
            op: "rfc-logs",
            sid: SID,
            users: inputUser.current.value,
            mids: inputMID.current.value,
            transactions: inputTransaction.current.value,
            programs: inputProgram.current.value,
            starttime: refDR.startSAPDate(),
            endtime: refDR.endSAPDate()
        };
        let pdo = Utils.postDataOptions(options);
        fetch(apiURL + "audit", pdo).then(res => res.json()).then((result) => {
            Utils.setState(fn, setRefreshing, false);
            Utils.setState(fn, setDivPage, parse(result));
        }, (error) => {
            Utils.setState(fn, setRefreshing, false);
            Utils.setState(fn, setDivPage, Utils.error(error.message));
        });
    }
    function parse(json) {
        if (!json.success) {
            return Utils.error(json.error);
        }
        const data = {
            defaultSortField: "h",
            id: "tableasapauditrfc",
            headers: [
                { name: "#", field: "ind" },
                { name: "SID", field: "sid" },
                { name: "Date", field: "dtm", width: "160px", filter: {} },
                { name: "ID", field: "id", filter: {} },
                { name: "User", field: "usr", filter: {} },
                { name: "Severity", field: "svt", filter: {} },
                { name: "Message", field: "txt", filter: {}, width: "100px" },
                { name: "Program", field: "prg", filter: {} },
                { name: "Tcode", field: "tc", filter: {} },
                { name: "Parameters", field: "prm", filter: {} },
                { name: "Class", field: "sc", filter: {} },
                { name: "Subclass", field: "sub", filter: {} },
                { name: "Terminal", field: "trm", filter: {} },
            ],
            rows: json.logs
        };
        const messages = [];
        for (let i = 0; i < json.messages.length; i++) {
            const message = json.messages[i];
            const div = React.createElement("div", { key: "rm_" + i }, message.msg);
            messages.push(div);
        }
        return React.createElement(React.Fragment, null,
            messages,
            React.createElement(Table, { data: data }));
    }
    function showAuditFiles() {
        const data = { name: "Audit File List", title: "Audit File List",
            content: React.createElement(SAPRFCAuditFileList, { sid: SID }),
            render: true };
        Dialog.show(data);
    }
    ;
    function listMessages() {
        const data = { name: "Audit Messages", title: "Audit Messages",
            content: React.createElement(AuditErrorList, null),
            render: true };
        Dialog.show(data);
    }
    function dateSelected(component) {
        const start = component.startSAPDate();
        console.log("Selected:" + start);
    }
    const dStart = new Date();
    const dEnd = new Date();
    dStart.setMinutes(dStart.getMinutes() - 10);
    let form = null;
    if (audit.loaded) {
        let description = "";
        if (audit.newFunction) {
            description = "Use the following input fields to create selection criteria. Use comma between values. Leave empty if no selection criteria is necessary.";
        }
        else {
            description = "Use the following input fields to create selection criteria. Leave empty if no selection criteria is necessary.";
        }
        form =
            React.createElement("div", null,
                React.createElement("div", null, description),
                t("Date"),
                React.createElement(DateTimeRange, { start: dStart, end: dEnd, fn: refDR, listener: dateSelected }),
                React.createElement("br", null),
                t("Users"),
                ":",
                React.createElement("input", { ref: inputUser, type: 'text', defaultValue: "", title: "Use comma between users" }),
                t("Message IDs"),
                ":",
                React.createElement("input", { ref: inputMID, type: 'text', defaultValue: "", spaplaceholder: "AU1,AUC,..", title: "Use comma between message ids (AU1,AUC)" }),
                t("Programs"),
                ":",
                React.createElement("input", { ref: inputProgram, type: 'text', title: "Use comma between program names" }),
                t("Transactions"),
                ":",
                React.createElement("input", { ref: inputTransaction, type: 'text', title: "Use comma between transactions" }),
                React.createElement("button", { onClick: search }, t("Search")));
    }
    return (React.createElement("div", { id: 'panel_sap_audit_rfc' },
        React.createElement("div", { className: "update_animation_box" }, refreshing && Utils.updating()),
        React.createElement("a", { href: "/#sapauditalertrules/" + SID }, "Alert Rules"),
        React.createElement("br", null),
        React.createElement("button", { onClick: showAuditFiles }, t("Show Audit Files")),
        React.createElement("br", null),
        React.createElement("img", { className: "imagebutton", type: "svg", style: { float: "right" }, src: "/images/icons/ic_info_outline_24px.svg", onClick: listMessages, title: t("Message List") }),
        React.createElement("div", null, form),
        divPage));
};
const SystemAuditRFCPage = (props) => {
    const SID = props.match.params.sid;
    function back(e) {
        e.preventDefault();
        Utils.goBack(props.history, "/#system/" + SID);
    }
    return (React.createElement("div", { id: 'page' },
        React.createElement(Header, { back: back, title: t("System security audit logs") }),
        React.createElement(SAPAuditRFC, { sid: SID })));
};
const SAPRFCAuditFileList = (props) => {
    const [divPage, setDivPage] = useState(null);
    const [refreshing, setRefreshing] = useState(false);
    const fn = { closed: useRef(false) };
    const SID = props.sid;
    function cleanUp() {
        fn.closed.current = true;
    }
    useEffect(() => { fn.closed.current = false; loadData(); return cleanUp; }, [SID]);
    function loadData() {
        if (fn.closed.current)
            return;
        Utils.setState(fn, setRefreshing, true);
        const options = {
            op: "rfc-list-files",
            sid: SID,
            limit: 100
        };
        let pdo = Utils.postDataOptions(options);
        fetch(apiURL + "audit", pdo).then(res => res.json()).then((result) => {
            Utils.setState(fn, setRefreshing, false);
            Utils.setState(fn, setDivPage, parse(result));
        }, (error) => {
            Utils.setState(fn, setRefreshing, false);
            Utils.setState(fn, setDivPage, Utils.error(error.message));
        });
    }
    function parse(json) {
        if (!json.success) {
            return Utils.error(json.error);
        }
        const data = {
            id: "tableasaprfcauditfilelist",
            headers: [
                { name: "Name", field: "nm", filter: {} },
                { name: "Length", field: "sz", format: Utils.bytesToUnit },
                { name: "Date", field: "dt", width: "160px" },
                { name: "Directory", field: "dir", filter: {} }
            ],
            rows: json.files
        };
        return React.createElement(Table, { data: data });
    }
    return (React.createElement("div", { id: 'panel_sap_rfc_audit_file_list' },
        React.createElement("div", { className: "update_animation_box" }, refreshing && Utils.updating()),
        divPage));
};
const SAPMonthlyReport = (props) => {
    const [divSelect, setDivSelect] = useState("Loading...");
    const [refreshing, setRefreshing] = useState(true);
    const [report, setReport] = useState({ start: null });
    const [rr, reset] = useState(0);
    const fn = { closed: useRef(false) };
    const SID = props.sid;
    function cleanUp() {
        fn.closed.current = true;
    }
    useEffect(() => { fn.closed.current = false; loadDirectory(); return cleanUp; }, [SID]);
    function loadDirectory() {
        if (fn.closed.current)
            return;
        Utils.setState(fn, setRefreshing, true);
        let pdo = Utils.postDataOptions({
            op: "workloaddirectory",
            sid: SID
        });
        fetch(apiURL + "sapperformance", pdo).then(res => res.json()).then((result) => {
            Utils.setState(fn, setRefreshing, false);
            Utils.setState(fn, setDivSelect, parseDirectory(result));
        }, (error) => {
            Utils.setState(fn, setRefreshing, false);
            Utils.setState(fn, setDivSelect, Utils.error(error.message));
        });
    }
    ;
    function parseDirectory(json) {
        if (!json.success) {
            return Utils.error(json.error);
        }
        if (!json.tables || !json.tables.DIRECTORY_SHORT) {
            return "Workload Directory is emtpy. Check if this RFC connection can execute SWNC* functions and check if SAP_COLLECTOR_FOR_PERFMONITOR job is running";
        }
        const rows = json.tables.DIRECTORY_SHORT;
        if (rows.length < 1) {
            return "Workload Directory is emtpy. Check if this RFC connection can execute SWNC* functions and check if SAP_COLLECTOR_FOR_PERFMONITOR job is running.";
        }
        const options = [React.createElement("option", { key: "combo_start_empty", value: "" }, "Select Period")];
        const months = [];
        for (let i = 0; i < rows.length; i++) {
            const row = rows[i];
            const start = row.PERIODSTRT;
            if (row.COMPONENT != "TOTAL" || row.PERIODTYPE != 'M')
                continue;
            months.push(start);
        }
        if (months.length < 1)
            return "No montly performance statistics found";
        for (let i = 0; i < months.length; i++) {
            const month = months[i];
            const option = React.createElement("option", { key: "opt_" + i, value: month },
                " ",
                month,
                " ");
            options.push(option);
        }
        let selectedPeriod = months[0];
        if (months.length > 1)
            selectedPeriod = months[months.length - 2];
        report.start = selectedPeriod;
        return React.createElement("select", { onChange: directorySelected, defaultValue: selectedPeriod }, options);
    }
    function directorySelected(e) {
        const start = e.target.value;
        report.start = start;
        Utils.setState(fn, reset, Utils.timeStamp());
    }
    let divs = null;
    if (report.start) {
        const data = { sid: SID, component: "TOTAL", start: report.start, period: "M" };
        data.key = SID + "TOTALM" + report.start;
        divs = React.createElement("div", null,
            React.createElement(SAPReportPDF, { sid: SID, start: report.start }));
    }
    return (React.createElement("div", { id: 'panel_sap_system_monthly_report' },
        React.createElement("h2", null, "SAP System Monthly Statistics"),
        React.createElement("div", null,
            React.createElement("span", null,
                "You can get sap system reports automaticaly to your e-mail address. Please ",
                React.createElement("a", { href: '#sapreportsettings' }, " click here for automatic sap system report settings."))),
        React.createElement("br", null),
        React.createElement(SAPReportList, { sid: SID }),
        React.createElement("br", null),
        divSelect,
        divs,
        React.createElement("br", null),
        React.createElement("br", null)));
};
const SAPReportErrorList = (props) => {
    const [divPage, setDivPage] = useState(null);
    const fn = { closed: useRef(false) };
    const RID = props.rid;
    function cleanUp() {
        fn.closed.current = true;
    }
    useEffect(() => { fn.closed.current = false; loadData(); return cleanUp; }, [props]);
    function loadData() {
        if (fn.closed.current)
            return;
        let pdo = Utils.postDataOptions({ op: "errors", rid: RID });
        fetch(apiURL + "sapreport", pdo).then(res => res.json()).then((result) => {
            Utils.setState(fn, setDivPage, parse(result));
        }, (error) => {
            Utils.setState(fn, setDivPage, Utils.error(error.message));
        });
    }
    ;
    function parse(json) {
        if (!json.success) {
            return Utils.error(json.error);
        }
        const data = {
            defaultSortField: "created",
            id: "tableasapsystemreporterrors",
            direction: "descending",
            headers: [
                { name: "step", field: "step" },
                { name: "message", field: "message" },
                { name: "Time", field: "created", format: Utils.toDate }
            ],
            rows: json.errors
        };
        return React.createElement(Table, { data: data });
    }
    return (React.createElement("div", { id: 'panel_sap_report_list' },
        React.createElement("h2", null, " SAP Monthly System Report Errors "),
        divPage));
};
const SAPReportPDF = (props) => {
    const [divPage, setPage] = useState("Checking...");
    const [divProgress, setProgress] = useState("");
    const [refreshing, setRefreshing] = useState(true);
    const [started, setStarted] = useState(false);
    const fn = { closed: useRef(false) };
    const SID = props.sid;
    const START = props.start;
    const key = SID + START;
    const timeoutID = "sap_report_pdf";
    function cleanUp() {
        fn.closed.current = true;
        Timeouts.clearAll(timeoutID);
    }
    useEffect(() => { fn.closed.current = false; load(); return cleanUp; }, [key]);
    function load() {
        if (fn.closed.current)
            return;
        Utils.setState(fn, setRefreshing, true);
        let pdo = Utils.postDataOptions({
            op: "check",
            sid: SID,
            start: START
        });
        fetch(apiURL + "sapreport", pdo).then(res => res.json()).then((result) => {
            Utils.setState(fn, setRefreshing, false);
            Utils.setState(fn, setPage, parse(result));
        }, (error) => {
            Utils.setState(fn, setRefreshing, false);
            Utils.setState(fn, setPage, Utils.error(error.message));
        });
    }
    ;
    function parse(json) {
        if (!json.success) {
            return Utils.error(json.error);
        }
    }
    function create() {
        if (fn.closed.current)
            return;
        Utils.setState(fn, setRefreshing, true);
        let pdo = Utils.postDataOptions({
            op: "create",
            sid: SID,
            start: START
        });
        fetch(apiURL + "sapreport", pdo).then(res => res.json()).then((result) => {
            Utils.setState(fn, setRefreshing, false);
            Utils.setState(fn, setProgress, parseCreate(result));
        }, (error) => {
            Utils.setState(fn, setRefreshing, false);
            Utils.setState(fn, setProgress, Utils.error(error.message));
        });
    }
    function parseCreate(json) {
        if (!json.success) {
            return Utils.error(json.error);
        }
        Utils.setState(fn, setStarted, true);
        Timeouts.add(timeoutID, setTimeout(progress, 100));
    }
    function progress() {
        Timeouts.clearAll(timeoutID);
        if (fn.closed.current)
            return;
        Request.send({
            caller: fn,
            url: apiURL + "sapreport",
            params: { op: "progress", sid: SID, start: START },
            listener: (json) => Utils.setState(fn, setProgress, parseProgress(json)),
            then: () => Timeouts.add(timeoutID, setTimeout(progress, 1000))
        });
    }
    function parseProgress(json) {
        if (!json.success) {
            return Utils.error(json.error);
        }
        const rows = [];
        for (let i = 0; i < json.steps.length; i++) {
            const step = json.steps[i];
            const row = React.createElement("tr", { key: "row_step_" + i },
                React.createElement("td", null,
                    step.step,
                    " "),
                React.createElement("td", null,
                    step.text,
                    " "),
                React.createElement("td", null,
                    step.val,
                    " % "));
            rows.push(row);
        }
        let download = null;
        const table = React.createElement("table", null,
            React.createElement("tbody", null, rows));
        if (json.completed) {
            download = React.createElement("a", { href: "files/reports/" + json.filename + "?v=" + Utils.timeStamp(), target: "_blank" },
                " ",
                json.filename,
                " ");
        }
        return React.createElement(React.Fragment, null,
            table,
            React.createElement("br", null),
            download);
    }
    return (React.createElement("div", { id: 'panel_sap_system_monthly_report_pdf' },
        React.createElement("h3", null, "Download Report As PDF File"),
        React.createElement("div", { className: "update_animation_box" }, refreshing && Utils.updating()),
        divPage,
        React.createElement("button", { onClick: create, disabled: started },
            "Create PDF File for ",
            START),
        divProgress));
};
const SAPUsersWithAdminProfile = (props) => {
    const [divPanel, setDivPanel] = useState(null);
    const [refreshing, setRefreshing] = useState(true);
    const fn = { closed: useRef(false) };
    const SID = props.sid;
    function cleanUp() {
        fn.closed.current = true;
    }
    useEffect(() => { fn.closed.current = false; loadData(); return cleanUp; }, [SID]);
    function loadData() {
        if (fn.closed.current)
            return;
        Utils.setState(fn, setRefreshing, true);
        let pdo = Utils.postDataOptions({
            op: "usersbyprofile",
            sid: SID
        });
        fetch(apiURL + "sapusers", pdo).then(res => res.json()).then((result) => {
            Utils.setState(fn, setRefreshing, false);
            Utils.setState(fn, setDivPanel, parse(result));
        }, (error) => {
            Utils.setState(fn, setRefreshing, false);
            Utils.setState(fn, setDivPanel, Utils.error(error.message));
        });
    }
    ;
    function parse(json) {
        if (!json.success) {
            return Utils.error(json.error);
        }
        const rows = json.users;
        const users = {};
        for (let i = 0; i < rows.length; i++) {
            const row = rows[i];
            const name = row.us;
            let user = users[name];
            if (!user) {
                user = users[name] = { name: name, profiles: [] };
            }
            user.profiles.push(row.pr);
        }
        const list = [];
        const ordered = Object.values(users);
        Utils.sort(ordered, "name");
        for (let user of ordered) {
            const title = user.profiles.join();
            const item = React.createElement("span", { key: user.name, title: title },
                " ",
                user.name,
                " ");
            list.push(item);
            list.push(React.createElement("span", { key: "seperator_" + user.name }, " , "));
        }
        return (React.createElement("div", null, list));
    }
    return (React.createElement("div", { id: 'panel_sap_users_with_admin_profile' },
        React.createElement("div", { className: "update_animation_box" }, refreshing && Utils.updating()),
        React.createElement("h2", null, " Users assigned to SAP_ALL, SAP_NEW profiles"),
        React.createElement("br", null),
        divPanel));
};
const SAPClients = (props) => {
    const [divPage, setDivPage] = useState(null);
    const [refreshing, setRefreshing] = useState(true);
    const fn = { closed: useRef(false) };
    const SID = props.sid;
    function cleanUp() {
        fn.closed.current = true;
    }
    useEffect(() => { fn.closed.current = false; loadData(); return cleanUp; }, [SID]);
    function loadData() {
        if (fn.closed.current)
            return;
        Utils.setState(fn, setRefreshing, true);
        let pdo = Utils.postDataOptions({ op: "clients", sid: SID });
        fetch(apiURL + "sap", pdo).then(res => res.json()).then((result) => {
            Utils.setState(fn, setRefreshing, false);
            Utils.setState(fn, setDivPage, parse(result));
        }, (error) => {
            Utils.setState(fn, setRefreshing, false);
            Utils.setState(fn, setDivPage, Utils.error(error.message));
        });
    }
    ;
    function role(t) {
        switch (t) {
            case "P": return "Production";
            case "T": return "Test";
            case "C": return "Customizing";
            case "D": return "Demo";
            case "E": return "Training/Education";
            case "S": return "SAP reference";
        }
        return t;
    }
    function changed(date) {
        if (date == "00000000")
            return "";
        return date;
    }
    function parse(json) {
        if (!json.success) {
            return Utils.error(json.error);
        }
        const data = {
            defaultSortField: "no",
            id: "tablesapclients",
            headers: [
                { name: "Client", field: "no" },
                { name: "Name", field: "nm" },
                { name: "Role", field: "CCCATEGORY", format: role },
                { name: "User", field: "chu" },
                { name: "Changed", field: "chd", format: changed },
                { name: "CCCORACTIV", field: "CCCORACTIV" },
                { name: "CCNOCLIIND", field: "CCNOCLIIND" },
                { name: "CCCOPYLOCK", field: "CCCOPYLOCK" },
                { name: "CCNOCASCAD", field: "CCNOCASCAD" },
                { name: "CCSOFTLOCK", field: "CCSOFTLOCK" },
                { name: "CCORIGCONT", field: "CCORIGCONT" },
                { name: "CCIMAILDIS", field: "CCIMAILDIS" },
                { name: "CCTEMPLOCK", field: "CCTEMPLOCK" },
                { name: "LOGSYS", field: "crtd" }
            ],
            rows: json.clients
        };
        return React.createElement(React.Fragment, null,
            React.createElement(Table, { data: data }),
            detailed(json));
    }
    function CCCORACTIV(val) {
        switch (val) {
            case "": return "No automatic recording of changes for transport";
            case "1": return "Changes are recorded in transport request";
            case "2": return "Customizing in this client cannot be changed";
            case "3": return "Customizing: Can be changed as req., but cannot be transp";
        }
        return val;
    }
    function CCNOCLIIND(val) {
        switch (val) {
            case "": return "Changes to Repository and cross-client Customizing allowed";
            case "1": return "No changes to cross-client Customizing objects";
            case "2": return "No changes to Repository objects";
            case "3": return "No changes to Repository and cross-client Customizing objects";
        }
        return val;
    }
    function CCCOPYLOCK(val) {
        switch (val) {
            case "": return "Protection level 0: No restriction";
            case "1": return "Protection level 1: No overwriting";
            case "2": return "Protection level 2: No overwriting, no external availability";
        }
        return val;
    }
    function eCatt(val) {
        switch (val) {
            case "": return "eCATT and CATT Not Allowed";
            case "X": return "eCATT and CATT Allowed";
            case "T": return "eCATT and CATT Only Allowed for 'Trusted RFC'";
            case "E": return "eCATT Allowed, but FUN/ABAP and CATT not Allowed";
            case "F": return "eCATT allowed, but FUN/ABAP and CATT only for 'Trusted RFC'";
        }
        return val;
    }
    function detailed(json) {
        const divs = [];
        for (let i = 0; i < json.clients.length; i++) {
            const client = json.clients[i];
            const table = React.createElement("table", null,
                React.createElement("tbody", null,
                    React.createElement("tr", null,
                        React.createElement("td", null, "Client"),
                        React.createElement("td", { style: { fontWeight: "bold" } },
                            client.no,
                            " ",
                            client.nm)),
                    React.createElement("tr", null,
                        React.createElement("td", null, "Role"),
                        React.createElement("td", null, role(client.CCCATEGORY))),
                    React.createElement("tr", null,
                        React.createElement("td", null, "Changed"),
                        React.createElement("td", null, client.chd)),
                    React.createElement("tr", null,
                        React.createElement("td", null, "Changes and transports for client-specific objects"),
                        React.createElement("td", null, CCCORACTIV(client.CCCORACTIV))),
                    React.createElement("tr", null,
                        React.createElement("td", null, "Cross-client object changes"),
                        React.createElement("td", null, CCNOCLIIND(client.CCNOCLIIND))),
                    React.createElement("tr", null,
                        React.createElement("td", null, "Client copy and comparison tool protection"),
                        React.createElement("td", null, CCCOPYLOCK(client.CCCOPYLOCK))),
                    React.createElement("tr", null,
                        React.createElement("td", null, "CATT and eCATT restrictions"),
                        React.createElement("td", null, eCatt(client.CCIMAILDIS))),
                    client.CCNOCASCAD ? React.createElement("tr", null,
                        React.createElement("td", null),
                        React.createElement("td", null, "Client control: No client cascade for upgrade import")) : null,
                    client.CCSOFTLOCK ? React.createElement("tr", null,
                        React.createElement("td", null),
                        React.createElement("td", null, "Client control: Soft Lock Required (Planned for 4.0)")) : null,
                    client.CCORIGCONT ? React.createElement("tr", null,
                        React.createElement("td", null, "Recording Client for Switch BC Sets"),
                        React.createElement("td", null, client.CCORIGCONT)) : null,
                    client.CCTEMPLOCK ? React.createElement("tr", null,
                        React.createElement("td", null),
                        React.createElement("td", { style: { color: "red" } }, "Client is temporarily locked")) : null));
            const div = React.createElement("div", { key: "sap_client_div_" + i, style: { marginTop: "20px" } },
                " ",
                table,
                " ");
            divs.push(div);
        }
        return React.createElement("div", null,
            " ",
            divs,
            " ");
    }
    return (React.createElement("div", { id: 'panel_sap_clients' },
        React.createElement("div", { className: "update_animation_box" }, refreshing && Utils.updating()),
        divPage));
};
const SAPDetails = (props) => {
    const fn = { closed: useRef(false) };
    const [divPage, setDivPage] = useState(null);
    const SID = props.sid;
    function cleanUp() {
        fn.closed.current = true;
    }
    useEffect(() => { fn.closed.current = false; return cleanUp; }, [SID]);
    function selected(e) {
        e.preventDefault();
        let comp = null;
        switch (e.target.value) {
            case "sost":
                comp = React.createElement(SAPMailErrors, { sid: SID });
                break;
            case "runtimeerrors":
                comp = React.createElement(ABAPRuntimeErrors, { sid: SID });
                break;
            case "updateerrors":
                comp = React.createElement(SAPUpdateErrors, { sid: SID });
                break;
            case "tablelocks":
                comp = React.createElement(SAPTableLocks, { sid: SID });
                break;
            case "jobs":
                comp = React.createElement(SAPJobs, { sid: SID });
                break;
            case "workload":
                comp = React.createElement(SAPWorkloadAnalysis, { sid: SID });
                break;
            case "usertcodesyearly":
                comp = React.createElement(SAPWorkloadUserTCodeMatrixYearly, { sid: SID });
                break;
            case "systemmessages":
                comp = React.createElement(SAPSystemMessages, { sid: SID });
                break;
            case "users":
                comp = React.createElement(SAPSuim, { sid: SID });
                break;
            case "clients":
                comp = React.createElement(SAPClients, { sid: SID });
                break;
            case "auditlogs":
                comp = React.createElement(SAPAuditRFC, { sid: SID });
                break;
            case "general":
                comp = React.createElement(SAPSystemGeneral, { sid: SID });
                break;
            case "icmstatus":
                comp = React.createElement(SAPSystemICMStatus, { sid: SID });
                break;
            case "wptable":
                comp = React.createElement(SAPSystemWPTable, { sid: SID });
                break;
            case "rfc_checker":
                comp = React.createElement(SAPSystemRFCFunctionChecker, { sid: SID });
                break;
            case "rfc_destinations":
                comp = React.createElement(SAPRFCDestinations, { sid: SID });
                break;
            case "trustmanager":
                comp = React.createElement(SAPTrustManager, { sid: SID });
                break;
            case "trustedsystems":
                comp = React.createElement(SAPTrustedSystems, { sid: SID });
                break;
            case "tune":
                comp = React.createElement(SAPTune, { sid: SID });
                break;
            case "rfc_logs":
                comp = React.createElement(SAPRFCLogs, { sid: SID });
                break;
            case "globalmodifiability":
                comp = React.createElement(SAPGlobalModifiabilitySettings, { sid: SID });
                break;
        }
        Utils.setState(fn, setDivPage, comp);
    }
    return (React.createElement("div", { id: 'panel_sap_details' },
        React.createElement("select", { onChange: selected },
            React.createElement("option", { value: "none" }, "Please select detail page"),
            React.createElement("option", { value: "sost" }, "Mail Errors (SOST) "),
            React.createElement("option", { value: "runtimeerrors" }, "Runtime Errors (ST22) "),
            React.createElement("option", { value: "updateerrors" }, "Update Errors (SM13) "),
            React.createElement("option", { value: "tablelocks" }, "Table Locks (SM12) "),
            React.createElement("option", { value: "jobs" }, " Jobs (SM37) "),
            React.createElement("option", { value: "tune" }, " SAP Tune - Buffer and Memory Statistics (ST02) "),
            React.createElement("option", { value: "workload" }, " Workload Overview (ST03N) "),
            React.createElement("option", { value: "usertcodesyearly" }, " User Transactions (ST03N-Annual) "),
            React.createElement("option", { value: "systemmessages" }, " System Messages (SM02) "),
            React.createElement("option", { value: "users" }, " Users (SUIM) "),
            React.createElement("option", { value: "clients" }, " Clients (SCC4) "),
            React.createElement("option", { value: "globalmodifiability" }, " Global Modifiability Settings (SE06) "),
            React.createElement("option", { value: "auditlogs" }, " Audit Logs (SM20) "),
            React.createElement("option", { value: "icmstatus" }, " ICM Status (SMICM) "),
            React.createElement("option", { value: "wptable" }, " Work Processes (SM50) "),
            React.createElement("option", { value: "rfc_destinations" }, " RFC Destinations (SM59) "),
            React.createElement("option", { value: "trustmanager" }, " Trust Manager (STRUST) "),
            React.createElement("option", { value: "trustedsystems" }, " Trusted and Trusting Systems (SMT1) "),
            React.createElement("option", { value: "general" }, " General Information "),
            React.createElement("option", { value: "rfc_checker" }, " RFC function check "),
            React.createElement("option", { value: "rfc_logs" }, " SysRamger RFC Logs ")),
        React.createElement("br", null),
        React.createElement("br", null),
        divPage));
};
const SAPGlobalModifiabilitySettings = (props) => {
    const [divPage, setDivPage] = useState(null);
    const [refreshing, setRefreshing] = useState(true);
    const fn = { closed: useRef(false) };
    const SID = props.sid;
    function cleanUp() {
        fn.closed.current = true;
    }
    useEffect(() => { fn.closed.current = false; loadData(); return cleanUp; }, [SID]);
    function loadData() {
        if (fn.closed.current)
            return;
        Utils.setState(fn, setRefreshing, true);
        let pdo = Utils.postDataOptions({ op: "globalsettings", sid: SID });
        fetch(apiURL + "sap", pdo).then(res => res.json()).then((result) => {
            Utils.setState(fn, setRefreshing, false);
            Utils.setState(fn, setDivPage, parse(result));
        }, (error) => {
            Utils.setState(fn, setRefreshing, false);
            Utils.setState(fn, setDivPage, Utils.error(error.message));
        });
    }
    ;
    function status(row) {
        let color = Colors.green;
        switch (row.c) {
            case 3:
                color = Colors.red;
                break;
            case 2:
                color = Colors.orange;
                break;
            case 1:
                color = Colors.yellow;
                break;
        }
        return React.createElement("span", { style: { color: color } },
            row.status,
            " ");
    }
    function parse(json) {
        if (!json.success) {
            return Utils.error(json.error);
        }
        const dataC = {
            defaultSortField: "code",
            id: "tablesapcomponentmodifiability",
            headers: [
                { name: "Code", field: "code", width: "140px" },
                { name: "Status", field: "status", rowFormat: status, width: "250px" },
                { name: "Description", field: "name" }
            ],
            rows: json.components
        };
        const dataN = {
            defaultSortField: "code",
            id: "tablesapnamespacemodifiability",
            headers: [
                { name: "Code", field: "code", width: "140px" },
                { name: "Status", field: "status", rowFormat: status, width: "250px" },
                { name: "Description", field: "name" }
            ],
            rows: json.namespaces
        };
        let globalColor = json.globalopen ? Colors.red : Colors.green;
        return React.createElement(React.Fragment, null,
            React.createElement("h3", null, "Global modifiability"),
            React.createElement("h3", { style: { color: globalColor } },
                " ",
                json.globalsetting,
                " "),
            React.createElement("h3", null, " Software Component Modifiability "),
            React.createElement(Table, { data: dataC, key: "tbk_components" }),
            React.createElement("h3", null, " Namespace Modifiability "),
            React.createElement(Table, { data: dataN, key: "tbk_namespaces" }));
    }
    return (React.createElement("div", { id: 'panel_sap_global_modifiability' },
        React.createElement("div", { className: "update_animation_box" }, refreshing && Utils.updating()),
        divPage));
};
const SAPInstanceConfiguration = (props) => {
    const instance = props.instance;
    const instanceID = instance.id;
    const inputRFCUser = useRef();
    const inputRFCPassword = useRef();
    const inputRFCClient = useRef();
    const inputSIDUser = useRef();
    const inputSIDPassword = useRef();
    const [r, refreshComponent] = useState(0);
    const fn = { closed: useRef(false) };
    function refresh() {
        Utils.setState(fn, refreshComponent, Utils.timeStamp());
    }
    function cleanUp() {
        fn.closed.current = true;
    }
    useEffect(() => { return cleanUp; }, [props]);
    function setRFC() {
        Request.send({ caller: fn,
            url: apiURL + "saprfc",
            params: {
                id: instanceID,
                op: "connect",
                user: inputRFCUser.current.value,
                password: inputRFCPassword.current.value,
                client: inputRFCClient.current.value
            },
            listener: (json) => {
                if (!json.success) {
                    Info.error(json.error);
                }
                else {
                    Info.success(json.user + " is connected");
                }
                refresh();
            }
        });
    }
    function setSIDADM() {
        Request.send({ caller: fn,
            url: apiURL + "instances",
            params: {
                id: instanceID,
                op: "setinstanceuser",
                user: inputSIDUser.current.value,
                password: inputSIDPassword.current.value
            },
            listener: (json) => {
                if (!json.success) {
                    Info.error(json.error);
                }
                else {
                    Info.success(json.user + " is connected");
                }
                refresh();
            }
        });
    }
    return (React.createElement("div", null,
        React.createElement("span", { className: "bold", style: { width: "100px", display: "inline-block" } }, "SIDADM"),
        "User: ",
        React.createElement("input", { ref: inputSIDUser, type: "text", defaultValue: instance.sidadmuser, autoComplete: "new-password" }),
        "Password: ",
        React.createElement("input", { ref: inputSIDPassword, type: "password", autoComplete: "new-password" }),
        React.createElement("button", { onClick: setSIDADM }, "Update"),
        React.createElement(SAPHostAgentConnectionStatus, { id: instance.id, refresh: r }),
        React.createElement("br", null),
        React.createElement("span", { className: "bold", style: { width: "100px", display: "inline-block" } }, "RFC"),
        "User: ",
        React.createElement("input", { ref: inputRFCUser, type: "text", defaultValue: instance.rfcuser, autoComplete: "new-password" }),
        "Password: ",
        React.createElement("input", { ref: inputRFCPassword, type: "password", autoComplete: "new-password" }),
        "Client: ",
        React.createElement("input", { ref: inputRFCClient, type: "text", placeholder: t("Client") + " (Ex:000)", defaultValue: instance.rfcclient, title: "Client number (e.g. 100)" }),
        React.createElement("button", { onClick: setRFC }, "Update"),
        React.createElement("br", null),
        React.createElement(RFCStatus, { id: instance.id, refresh: r })));
};
const SAPJobs = (props) => {
    const [divPage, setDivPage] = useState(null);
    const [refreshing, setRefreshing] = useState(true);
    const [refDR] = useState({});
    const fn = { closed: useRef(false) };
    const SID = props.sid;
    let chkActive = useRef(null);
    let chkFinished = useRef(null);
    let chkCancelled = useRef(null);
    let chkScheduled = useRef(null);
    let chkReleased = useRef(null);
    let chkReady = useRef(null);
    let refName = useRef("");
    const timeoutID = "sapjobs" + SID;
    function cleanUp() {
        fn.closed.current = true;
        Timeouts.clearAll(timeoutID);
    }
    useEffect(() => { fn.closed.current = false; setOptions(); loadData(); return cleanUp; }, [SID]);
    function setOptions() {
        let options = Options["sapjobs"];
        if (!options) {
            options = { status: { RZ: true, F: false, A: true, P: true, S: true, Y: true } };
            Options["sapjobs"] = options;
        }
        options.status.RZ = chkActive.current ? chkActive.current.checked : options.status.RZ;
        options.status.F = chkFinished.current ? chkFinished.current.checked : options.status.F;
        options.status.A = chkCancelled.current ? chkCancelled.current.checked : options.status.A;
        options.status.P = chkScheduled.current ? chkScheduled.current.checked : options.status.P;
        options.status.S = chkReleased.current ? chkReleased.current.checked : options.status.S;
        options.status.Y = chkReady.current ? chkReady.current.checked : options.status.Y;
        return options;
    }
    function getOptions() {
        setOptions();
        const options = { status: "" };
        options.status += chkActive.current.checked ? "RZ" : "";
        options.status += chkFinished.current.checked ? "F" : "";
        options.status += chkCancelled.current.checked ? "A" : "";
        options.status += chkScheduled.current.checked ? "P" : "";
        options.status += chkReleased.current.checked ? "S" : "";
        options.status += chkReady.current.checked ? "Y" : "";
        options.start = refDR.startSAPDate();
        options.end = refDR.endSAPDate();
        options.name = refName.current.value;
        return options;
    }
    function loadData() {
        Timeouts.clearAll(timeoutID);
        if (fn.closed.current)
            return;
        Utils.setState(fn, setRefreshing, true);
        const options = getOptions();
        let pdo = Utils.postDataOptions(Object.assign({ op: "jobs", sid: SID }, options));
        fetch(apiURL + "sap", pdo).then(res => res.json()).then((result) => {
            Utils.setState(fn, setRefreshing, false);
            Utils.setState(fn, setDivPage, parse(result));
        }, (error) => {
            Utils.setState(fn, setRefreshing, false);
            Utils.setState(fn, setDivPage, Utils.error(error.message));
        }).then(() => {
            if (fn.closed.current)
                return;
            setTimeout(() => Utils.setState(fn, setRefreshing, false), 1000);
            Timeouts.add(timeoutID, setTimeout(loadData, 10000));
        });
    }
    ;
    function duration(stm, row) {
        const ds = Utils.dateSAP(row.sr);
        let de = Utils.dateSAP(row.ed);
        if (ds == null)
            return "";
        const start = ds.getTime();
        const end = de == null ? stm : de.getTime();
        const seconds = Math.floor((end - start) / 1000);
        if (seconds < 0) {
            Debugger.print("Zero:" + end + " " + start);
            Debugger.print(ds);
            Debugger.print(de);
        }
        return seconds;
    }
    function delay(row) {
        const start = Utils.dateSAP(row.sc);
        let end = Utils.dateSAP(row.sr);
        if (start == null || end == null)
            return "";
        const seconds = (end.getTime() - start.getTime()) / 1000;
        return seconds;
    }
    function parse(json) {
        if (!json.success) {
            return Utils.error(json.error);
        }
        const destinationTime = json.dst;
        for (let i = 0; i < json.jobs.length; i++) {
            const job = json.jobs[i];
            job.duration = duration(destinationTime, job);
            job.delay = delay(job);
        }
        const data = {
            defaultSortField: "end",
            id: "tablesapjobs",
            headers: [
                { name: "ID", field: "id" },
                { name: "Name", field: "nm" },
                { name: "Status", field: "st", format: Utils.SAPJobStatus },
                { name: "Scheduled Time", field: "sc", format: Utils.timeSAP },
                { name: "Start Time", field: "sr", format: Utils.timeSAP },
                { name: "Duration", field: "duration" },
                { name: "Delay", field: "delay" },
                { name: "User", field: "us" },
                { name: "Instance", field: "in" }
            ],
            rows: json.jobs
        };
        return React.createElement(Table, { data: data });
    }
    function chkClicked() {
        execute();
    }
    function execute() {
        loadData();
    }
    function dateSelected(component) {
        const start = component.startSAPDate();
        loadData();
    }
    let options = Options["sapjobs"] || setOptions();
    return (React.createElement("div", { id: 'panel_sap_jobs' },
        React.createElement("div", { className: "update_animation_box" }, refreshing && Utils.updating()),
        React.createElement("label", { title: "Scheduled" },
            React.createElement("input", { type: "checkbox", ref: chkScheduled, defaultChecked: options.status.P, onChange: chkClicked }),
            React.createElement("span", { style: { marginRight: "10px" } }, t("Scheduled"))),
        React.createElement("label", { title: "Released" },
            React.createElement("input", { type: "checkbox", ref: chkReleased, defaultChecked: options.status.S, onChange: chkClicked }),
            React.createElement("span", { style: { marginRight: "10px" } }, t("Released"))),
        React.createElement("label", { title: "Ready" },
            React.createElement("input", { type: "checkbox", ref: chkReady, defaultChecked: options.status.Y, onChange: chkClicked }),
            React.createElement("span", { style: { marginRight: "10px" } }, t("Ready"))),
        React.createElement("label", { title: "Active" },
            React.createElement("input", { type: "checkbox", ref: chkActive, defaultChecked: options.status.RZ, onChange: chkClicked }),
            React.createElement("span", { style: { marginRight: "10px" } }, t("Active"))),
        React.createElement("label", { title: "Finished" },
            React.createElement("input", { type: "checkbox", ref: chkFinished, defaultChecked: options.status.F, onChange: chkClicked }),
            React.createElement("span", { style: { marginRight: "10px" } }, t("Finished"))),
        React.createElement("label", { title: "Cancelled" },
            React.createElement("input", { type: "checkbox", ref: chkCancelled, defaultChecked: options.status.A, onChange: chkClicked }),
            React.createElement("span", { style: { marginRight: "10px" } }, t("Cancelled"))),
        React.createElement(DateRange, { listener: dateSelected, fn: refDR }),
        React.createElement("span", { style: { marginRight: "10px" } },
            t("Name"),
            ":"),
        "    \t",
        React.createElement("input", { type: "text", ref: refName }),
        React.createElement("button", { onClick: execute },
            " ",
            t("Execute")),
        divPage));
};
const SAPMailErrors = (props) => {
    const [divPage, setDivPage] = useState(null);
    const [refreshing, setRefreshing] = useState(true);
    const fn = { closed: useRef(false) };
    const SID = props.sid;
    const [refDR] = useState({});
    function cleanUp() {
        fn.closed.current = true;
    }
    useEffect(() => { fn.closed.current = false; loadData(); return cleanUp; }, [SID]);
    function loadData() {
        if (fn.closed.current)
            return;
        Utils.setState(fn, setRefreshing, true);
        let pdo = Utils.postDataOptions({
            op: "mailerrors",
            sid: SID,
            start: refDR.startSAPDate(),
            end: refDR.endSAPDate(),
            limit: 200
        });
        fetch(apiURL + "sap", pdo).then(res => res.json()).then((result) => {
            Utils.setState(fn, setRefreshing, false);
            Utils.setState(fn, setDivPage, parse(result));
        }, (error) => {
            Utils.setState(fn, setRefreshing, false);
            Utils.setState(fn, setDivPage, Utils.error(error.message));
        });
    }
    ;
    function parse(json) {
        if (!json.success) {
            return Utils.error(json.error);
        }
        if (!json.mails || !json.mails.length) {
            return "Empty";
        }
        const data = {
            defaultSortField: "dtm",
            id: "tablesapmailerrors",
            direction: "descenting",
            headers: [
                { name: "Status", field: "stt" },
                { name: "Date", field: "dtm", format: Utils.timeSAP, width: "200px" },
                { name: "Host", field: "hst" },
                { name: "Source", field: "frm" },
                { name: "key", title: "Client-YearID-ReceiverID-AdddressNumber", field: "key" },
                { name: "Saved", field: "crt", format: Utils.toDate, width: "200px" },
                { name: "Query", field: "qry", width: "200px" },
            ],
            rows: json.mails
        };
        return React.createElement(Table, { data: data });
    }
    function search() {
        loadData();
    }
    return (React.createElement("div", { id: 'panel_mail_errors' },
        React.createElement("div", { className: "update_animation_box" }, refreshing && Utils.updating()),
        React.createElement("h3", null, " SAP Mail Errors (SOST) "),
        React.createElement(DateRange, { fn: refDR }),
        React.createElement("button", { onClick: search },
            " ",
            t("Search")),
        React.createElement("br", null),
        divPage));
};
const SAPRFCCalls = (props) => {
    const [divPage, setDivPage] = useState(null);
    const fn = { closed: useRef(false) };
    const SID = props.sid;
    let refreshTimeout = 0;
    function cleanUp() {
        fn.closed.current = true;
    }
    useEffect(() => { fn.closed.current = false; loadData(); return cleanUp; }, [SID]);
    function loadData() {
        if (fn.closed.current)
            return;
        let pdo = Utils.postDataOptions({ op: "rfccalls", sid: SID });
        fetch(apiURL + "sap", pdo).then(res => res.json()).then((result) => {
            Utils.setState(fn, setDivPage, parse(result));
        }, (error) => {
            Utils.setState(fn, setDivPage, Utils.error(error.message));
        });
    }
    ;
    function parse(json) {
        if (!json.success) {
            return Utils.error(json.error);
        }
        const calls = json.calls;
        const data = {
            defaultSortField: "dt",
            id: "tablesaprfccalls",
            direction: "descenting",
            headers: [
                { name: "Status", field: "st" },
                { name: "Date", field: "dt", format: Utils.timeSAP },
                { name: "User", field: "us" },
                { name: "Message", field: "ms" },
                { name: "Destination", field: "de" },
                { name: "Name", field: "nm" },
                { name: "Transaction", field: "tc" }
            ],
            rows: calls
        };
        return React.createElement(Table, { data: data });
    }
    return (React.createElement("div", { id: 'panel_rfc_calls' }, divPage));
};
const SAPRFCDestinationInfo = (props) => {
    const [refreshing, setRefreshing] = useState(true);
    const fn = { closed: useRef(false) };
    const SID = props.sid;
    const DEST = props.destination;
    const [divPage, setDivPage] = useState("Getting Information of RFC destination " + DEST);
    function cleanUp() {
        fn.closed.current = true;
    }
    useEffect(() => { fn.closed.current = false; loadData(); return cleanUp; }, [SID]);
    function loadData() {
        if (fn.closed.current)
            return;
        Utils.setState(fn, setRefreshing, true);
        Request.send({
            url: apiURL + "sap",
            params: { op: "rfc_destination_info", sid: SID, destination: DEST },
            listener: (json) => {
                Utils.setState(fn, setRefreshing, false);
                Utils.setState(fn, setDivPage, parse(json));
            }
        });
    }
    ;
    function parse(json) {
        if (!json.success) {
            return Utils.error(json.error);
        }
        const table = React.createElement("table", null,
            React.createElement("tbody", null,
                React.createElement("tr", null,
                    React.createElement("td", null, "Destination "),
                    React.createElement("td", null,
                        json.destination,
                        " ")),
                React.createElement("tr", null,
                    React.createElement("td", null, " "),
                    React.createElement("td", { style: { color: Colors.red } },
                        json.communicationmessage + json.systemmessage,
                        " ")),
                React.createElement("tr", null,
                    React.createElement("td", null, "Component "),
                    React.createElement("td", null,
                        json.component,
                        " ")),
                React.createElement("tr", null,
                    React.createElement("td", null, "Host "),
                    React.createElement("td", null,
                        json.host,
                        " ")),
                React.createElement("tr", null,
                    React.createElement("td", null, "IP "),
                    React.createElement("td", null,
                        json.ip,
                        " ")),
                React.createElement("tr", null,
                    React.createElement("td", null, "SID "),
                    React.createElement("td", null,
                        json.scode,
                        " ")),
                React.createElement("tr", null,
                    React.createElement("td", null, "Database "),
                    React.createElement("td", null,
                        json.database,
                        " ")),
                React.createElement("tr", null,
                    React.createElement("td", null, "DB Host "),
                    React.createElement("td", null,
                        json.dbhost,
                        " ")),
                React.createElement("tr", null,
                    React.createElement("td", null, "DB Type "),
                    React.createElement("td", null,
                        json.dbtype,
                        " ")),
                React.createElement("tr", null,
                    React.createElement("td", null, "SAP release "),
                    React.createElement("td", null,
                        json.saprelease,
                        " ")),
                React.createElement("tr", null,
                    React.createElement("td", null, "Mach "),
                    React.createElement("td", null,
                        json.mach,
                        " ")),
                React.createElement("tr", null,
                    React.createElement("td", null, "Kernel "),
                    React.createElement("td", null,
                        json.kernel,
                        " ")),
                React.createElement("tr", null,
                    React.createElement("td", null, "O.S. "),
                    React.createElement("td", null,
                        json.os,
                        " ")),
                React.createElement("tr", null,
                    React.createElement("td", null, "Host2 "),
                    React.createElement("td", null,
                        json.host2,
                        " "))));
        return table;
    }
    return (React.createElement("div", { id: 'panel_rfc_destination_info' },
        React.createElement("div", { className: "update_animation_box" }, refreshing && Utils.updating()),
        React.createElement("h3", null,
            " RFC Destination Info ",
            DEST,
            " "),
        divPage));
};
const SAPRFCDestinations = (props) => {
    const [refreshing, setRefreshing] = useState(true);
    const [page, setPage] = useState(0);
    const [lastUpdate, setLastUpdate] = useState(null);
    const destinationCount = useRef(0);
    const fn = { closed: useRef(false) };
    const SID = props.sid;
    const timeoutID = "rfc_destinations";
    function cleanUp() {
        fn.closed.current = true;
        Timeouts.clearAll(timeoutID);
    }
    useEffect(() => { fn.closed.current = false; loadData(); return cleanUp; }, [SID]);
    function loadData() {
        if (fn.closed.current)
            return;
        Timeouts.clearAll(timeoutID);
        Debugger.print("SAPRFCDestinations loadData:" + (Utils.timeStamp() - (Data.previousTime || 1)));
        Data.previousTime = Utils.timeStamp();
        Utils.setState(fn, setRefreshing, true);
        Request.send({
            url: apiURL + "sap",
            params: { op: "rfc_destinations", sid: SID },
            listener: (json) => {
                Utils.setState(fn, setRefreshing, false);
                Utils.setState(fn, setPage, parse(json));
                const divLU = React.createElement("span", { className: "pale" },
                    "Last Update:" + Utils.time(),
                    " ");
                Utils.setState(fn, setLastUpdate, divLU);
                Timeouts.add(timeoutID, setTimeout(loadData, 5000));
            },
        });
    }
    ;
    function typeName(val) {
        switch (val) {
            case "T": return "TCP/IP";
            case "L": return "Logical";
            case "2": return "R/2";
            case "3": return "ABAP";
            case "I": return "Internal";
            case "X": return "ABAP Driver";
        }
        return val;
    }
    function info(row, td) {
        if (fn.exited)
            return;
        const div = React.createElement(SAPRFCDestinationInfo, { sid: SID, destination: row.nm });
        Dialog.show({ content: div, render: true });
    }
    function pingTime(row) {
        const color = row.ps ? Colors.green : Colors.red;
        return React.createElement("span", { style: { color: color } }, Utils.toDate(row.lpt));
    }
    function loginTime(row) {
        const color = row.ls ? Colors.green : Colors.red;
        return React.createElement("span", { style: { color: color } }, Utils.toDate(row.llt));
    }
    function pingStatus(row) {
        let color = row.ps ? Colors.green : Colors.red;
        if (row.pst == "Checking...")
            color = Colors.yellow;
        return React.createElement("span", { style: { color: color } }, row.pst);
    }
    function logonStatus(row) {
        let color = row.ls ? Colors.green : Colors.red;
        if (row.lst == "Checking...")
            color = Colors.yellow;
        return React.createElement("span", { style: { color: color } }, row.lst);
    }
    function ping(row) {
        if (fn.closed.current)
            return;
        Request.send({
            url: apiURL + "sap",
            params: { op: "rfc_destination_ping", sid: SID, destination: row.nm, hash: row.hash },
            listener: (json) => {
                if (!json.success) {
                    Info.error(json.error);
                }
                Timeouts.add(timeoutID, setTimeout(loadData, 100));
            },
        });
    }
    function logon(row) {
        if (fn.closed.current)
            return;
        Request.send({
            url: apiURL + "sap",
            params: { op: "rfc_destination_logon", sid: SID, destination: row.nm, hash: row.hash },
            listener: (json) => {
                if (!json.success) {
                    Info.error(json.error);
                }
                Timeouts.add(timeoutID, setTimeout(loadData, 100));
            },
        });
    }
    function pingCheckBox(row) {
        return React.createElement("label", null,
            React.createElement("input", { type: "checkbox", defaultChecked: row.chp, onChange: pingChecked, op: "ping", destination: row.nm, hash: row.hash }),
            React.createElement("span", null, "Ping"));
    }
    function logonCheckBox(row) {
        return React.createElement("label", null,
            React.createElement("input", { type: "checkbox", defaultChecked: row.chl, onChange: pingChecked, op: "logon", destination: row.nm, hash: row.hash }),
            "Ping");
    }
    function pingChecked(e) {
        const chk = e.currentTarget;
        const destination = chk.getAttribute('destination');
        const hash = chk.getAttribute('hash');
        const op = chk.getAttribute('op');
        if (fn.closed.current)
            return;
        Request.send({
            url: apiURL + "sap",
            params: { op: "rfc_destination_check_" + op, sid: SID, destination: destination, hash: hash, enable: chk.checked },
            listener: (json) => {
                if (json.success) {
                    Info.success(json.message);
                }
                else {
                    Info.error(json.error);
                }
            },
        });
    }
    function checkAll() {
        if (fn.closed.current)
            return;
        let duration = "This may take several minutes.";
        if (destinationCount.current > 0) {
            duration = "This may take " + Math.round(destinationCount.current / 4) + " minutes.";
        }
        if (!confirm("Are you sure you want to start ping and login check for all destinations ?\n" + duration))
            return;
        if (fn.closed.current)
            return;
        Request.send({
            url: apiURL + "sap",
            params: { op: "rfc_destination_check_all", sid: SID },
            listener: (json) => {
                if (json.success) {
                    Info.success(json.message);
                }
                else {
                    Info.error(json.error);
                }
            },
        });
    }
    function parse(json) {
        if (!json.success) {
            return Utils.error(json.error);
        }
        destinationCount.current = json.destinations.length;
        const td = {
            defaultSortField: "tp",
            id: "tableasaprfcdestinations",
            headers: [
                { name: "Type", field: "tp", format: typeName, width: "90px", filter: {} },
                { name: "Name", field: "nm", width: "260px", onClick: info, filter: {} },
                { name: "Description", field: "ds", width: "100px", filter: {}, pale: true },
                { name: "C.P.", field: "chp", width: "30px", rowFormat: pingCheckBox, title: "Check ping periodically." },
                { name: "C.L.", field: "chl", width: "30px", rowFormat: logonCheckBox, title: "Check logon periodically" },
                { name: "P.T.", field: "pt", width: "60px", title: "Ping Test", type: "button", onClick: ping, label: "Ping", tooltipText: "Start a ping test" },
                { name: "L.T.", field: "lt", width: "60px", title: "Logon Test", type: "button", onClick: logon, label: "Logon", tooltipText: "Start a logon test" },
                { name: "P.L.", field: "pla", width: "60px", title: "Ping latency", pale: true },
                { name: "L.L.", field: "lla", width: "60px", title: "Logon latency", pale: true },
                { name: "Ping Status", field: "pst", rowFormat: pingStatus, title: "Ping Status", pale: true },
                { name: "Logon Status", field: "lst", rowFormat: logonStatus, title: "Logon Status", pale: true },
            ],
            rows: json.destinations
        };
        return React.createElement(Table, { data: td });
    }
    return (React.createElement("div", { id: 'panel_sap_rfc_destinations' },
        React.createElement("div", { className: "update_animation_box" }, refreshing && Utils.updating()),
        React.createElement("h2", null, "RFC Destinations "),
        "Following list shows the RFC destinations of the SAP system. Checkboxes in the list are for performing continiuos ping or logon tests on the destinations. When ping or logon test is clicked, SysRanger will continuously perform checks on this destination and incase error an alert will be created accordingly.",
        React.createElement("br", null),
        React.createElement("br", null),
        React.createElement("button", { onClick: checkAll }, "Check All "),
        React.createElement("br", null),
        lastUpdate,
        page));
};
const SAPRFCLogs = (props) => {
    const [divPage, setDivPage] = useState(null);
    const fn = { closed: useRef(false) };
    const SID = props.sid;
    const [refDR] = useState({});
    const refMethod = useRef("summary");
    function cleanUp() {
        fn.closed.current = true;
    }
    useEffect(() => { fn.closed.current = false; search(); return cleanUp; }, [SID]);
    function search() {
        if (fn.closed.current)
            return;
        Utils.setState(fn, setDivPage, "Loading...");
        if (refMethod.current.value == "details") {
            load();
        }
        else {
            loadSummary();
        }
    }
    ;
    function load() {
        let pdo = Utils.postDataOptions({
            op: "rfc_logs",
            sid: SID,
            start: refDR.startMS(),
            end: refDR.endMS()
        });
        fetch(apiURL + "sap", pdo).then(res => res.json()).then((result) => {
            Utils.setState(fn, setDivPage, parse(result));
        }, (error) => {
            Utils.setState(fn, setDivPage, Utils.error(error.message));
        });
    }
    function parse(json) {
        if (!json.success) {
            return Utils.error(json.error);
        }
        const data = {
            defaultSortField: "tm",
            id: "tablesaprfclogs",
            direction: "descenting",
            headers: [
                { name: "Date", field: "tm", format: Utils.toDate },
                { name: "Function", field: "fnc", filter: {} },
                { name: "Duration", field: "duration" },
                { name: "Error", field: "statustext", color: Colors.red },
                { name: "Table", field: "tbl" },
                { name: "Params", field: "params" }
            ],
            rows: json.rows
        };
        return React.createElement(Table, { data: data });
    }
    function loadSummary() {
        Request.send({
            caller: fn,
            url: apiURL + "sap",
            params: {
                op: "rfc_log_summary",
                sid: SID,
                start: refDR.startMS(),
                end: refDR.endMS()
            },
            listener: (json) => {
                Utils.setState(fn, setDivPage, parseSummary(json));
            }
        });
    }
    function parseSummary(json) {
        if (!json.success) {
            return Utils.error(json.error);
        }
        const data = {
            id: "tablesaprfclogssummary",
            headers: [
                { name: "Function", field: "fnc", filter: {} },
                { name: "Table", field: "tbl" },
                { name: "Count", field: "cnt" },
                { name: "Max", field: "md", title: "Maximum duration (ms)" },
                { name: "Total", field: "sd", title: "Total duration (ms)" },
                { name: "Average", field: "ad", title: "Average duration (ms)" },
            ],
            rows: json.rows
        };
        return React.createElement(Table, { data: data });
    }
    return (React.createElement("div", { id: 'panel_rfc_logs' },
        "This panel shows rfc calls from SysRanger to SAP system. ",
        React.createElement("br", null),
        React.createElement(DateTimeRange, { fn: refDR }),
        React.createElement("select", { ref: refMethod },
            React.createElement("option", { value: "summary" }, "Summary"),
            React.createElement("option", { value: "details" }, "Details")),
        React.createElement("button", { onClick: search },
            " ",
            t("Search")),
        React.createElement("div", null),
        divPage));
};
const SAPSystemConfiguration = (props) => {
    const SID = props.sid;
    const fn = { closed: useRef(false) };
    const [system, setSystem] = useState({ code: "", type: 0, id: SID, loaded: false });
    function cleanUp() {
        fn.closed.current = true;
    }
    useEffect(() => { fn.closed.current = false; getData(); return cleanUp; }, [SID]);
    function getData() {
        Post({ url: apiURL + "sap", data: { op: "systemconfiguration", sid: SID }, fn: fn,
            success: (json) => {
                json.loaded = true;
                Utils.setState(fn, setSystem, json);
            }
        });
    }
    ;
    function page() {
        if (!system.loaded)
            return "Loading...";
        if (system.instances.length < 1)
            return "This SAP System doesn't have any instance. Please add an instance first.";
        const divs = [];
        for (let i = 0; i < system.instances.length; i++) {
            const instance = system.instances[i];
            const div = React.createElement("div", { className: "panel", key: "ins_" + instance.id, style: { border: "1px solid #444", marginTop: "10px", padding: "10px", textAlign: "left" } },
                React.createElement("span", { style: { fontWeight: "bold" } },
                    instance.nr,
                    " - ",
                    instance.nm,
                    "  ( ",
                    instance.hn,
                    " )"),
                React.createElement(SAPInstanceConfiguration, { instance: instance }));
            divs.push(div);
        }
        return React.createElement("div", null,
            "SAP Instances are listed below. SIDAdm user is required to collect monitoring data from SAPHostAgent web service running on port ",
            "5<nn>13",
            " where nn is instance number.",
            React.createElement("br", null),
            "RFC user is required to collect monitoring data from SAP ABAP instance using remote function modules. RFC uses port ",
            "33<nn>",
            ".",
            React.createElement("br", null),
            "Please make sure these ports (5nn13 and 33nn) are accessible by SysRanger Server.",
            divs,
            React.createElement("br", null),
            "Database : ",
            system.database);
    }
    return (React.createElement("div", { id: 'panel_sap_system_dashboard' }, page()));
};
const SAPSystemDashboard = (props) => {
    const SID = props.sid;
    const fn = { closed: useRef(false) };
    const [system, setSystem] = useState({ code: "", type: 0, id: SID, loaded: false });
    function cleanUp() {
        fn.closed.current = true;
    }
    useEffect(() => { fn.closed.current = false; getData(); return cleanUp; }, [SID]);
    function getData() {
        Post({ url: apiURL + "sapsystemdashboard", data: { op: "overview", sid: SID }, fn: fn,
            success: (json) => {
                json.loaded = true;
                Utils.setState(fn, setSystem, json);
            }
        });
    }
    ;
    function page() {
        if (!system.loaded)
            return "Loading...";
        return React.createElement("div", null, "SAP System Dashboard");
    }
    return (React.createElement("div", { id: 'panel_sap_system_dashboard' }, page()));
};
const SAPSystemGeneral = (props) => {
    const SID = props.sid;
    const fn = { closed: useRef(false) };
    function cleanUp() {
        fn.closed.current = true;
    }
    useEffect(() => { fn.closed.current = false; init(); return cleanUp; }, [SID]);
    function init() {
    }
    return (React.createElement("div", { id: 'panel_system_general' },
        React.createElement(SAPSystemTime, { sid: SID })));
};
const SAPSystemICMStatus = (props) => {
    const [divPage, setDivPage] = useState(null);
    const [refreshing, setRefreshing] = useState(true);
    const fn = { closed: useRef(false) };
    const SID = props.sid;
    const timeoutID = "systemicmstatus";
    function cleanUp() {
        fn.closed.current = true;
        Timeouts.clearAll(timeoutID);
    }
    useEffect(() => { fn.closed.current = false; loadData(); return cleanUp; }, [SID]);
    function loadData() {
        Timeouts.clearAll(timeoutID);
        if (fn.closed.current)
            return;
        Utils.setState(fn, setRefreshing, true);
        let pdo = Utils.postDataOptions({
            op: "icmstatus",
            sid: SID
        });
        fetch(apiURL + "sap", pdo).then(res => res.json()).then((result) => {
            Utils.setState(fn, setRefreshing, false);
            Utils.setState(fn, setDivPage, parse(result));
        }, (error) => {
            Utils.setState(fn, setRefreshing, false);
            Utils.setState(fn, setDivPage, Utils.error(error.message));
        }).then(() => {
            Timeouts.add(timeoutID, setTimeout(loadData, 5000));
        });
    }
    ;
    function threadStatus(val) {
        const valInt = parseInt(val);
        switch (valInt) {
            case 1: return "Waiting";
            case 2: return "Running";
        }
        return val;
    }
    function requestType(val) {
        const valInt = parseInt(val);
        switch (valInt) {
            case 0: return "";
            case 42: return "Administration";
        }
        return val;
    }
    function protocol(val) {
        const valInt = parseInt(val);
        switch (valInt) {
            case 1: return "HTTP";
            case 2: return "SMTP";
            case 4: return "HTTPS";
        }
        return val;
    }
    function status(val) {
        switch (val) {
            case 2: return React.createElement("span", { style: { color: "#5af542" } }, " Running");
            case 5: return React.createElement("span", { style: { color: "red" } }, " Maintenance");
        }
        return React.createElement("span", { style: { color: "red" } },
            " Status:",
            val);
    }
    function parse(json) {
        if (!json.success) {
            return Utils.error(json.error);
        }
        if (!json.exports || !json.tables) {
            return Utils.error("Cannot parse Json data");
        }
        const info = json.exports.INFO_DATA;
        const infoDiv = React.createElement("div", { key: "info" },
            "ICM Status : ",
            status(info.STATUS),
            " ",
            React.createElement("br", null),
            "Trace Level (0-3) : ",
            info.TRACE_LVL,
            " ",
            React.createElement("br", null),
            React.createElement("table", { className: "informationtable" },
                React.createElement("thead", null,
                    React.createElement("tr", null,
                        React.createElement("td", null),
                        React.createElement("td", { width: "80" }, "Current"),
                        React.createElement("td", { width: "80" }, "Peak"),
                        React.createElement("td", { width: "80" }, "Maximum"))),
                React.createElement("tbody", null,
                    React.createElement("tr", null,
                        React.createElement("td", { width: "200" }, "Created Worker Threads"),
                        React.createElement("td", null, info.CUR_THR),
                        React.createElement("td", null, info.PEEK_THR),
                        React.createElement("td", null, info.MAX_THR)),
                    React.createElement("tr", null,
                        React.createElement("td", null, "Connections Used"),
                        React.createElement("td", null, info.CUR_CONN),
                        React.createElement("td", null, info.PEEK_CONN),
                        React.createElement("td", null, info.MAX_CONN)),
                    React.createElement("tr", null,
                        React.createElement("td", null, "Queue Entries Used"),
                        React.createElement("td", null, info.CUR_QUEUE),
                        React.createElement("td", null, info.PEEK_QUEUE),
                        React.createElement("td", null, info.MAX_QUEUE)))));
        const threads = json.tables.THRLIST;
        const dataThreads = {
            id: "threads",
            headers: [
                { name: "#", field: "#", number: true },
                { name: "ID", field: "THR_ID" },
                { name: "Number", field: "REQ_COUNT", title: "Request Count" },
                { name: "Status", field: "THR_STAT", format: threadStatus },
                { name: "Request Type", field: "REQ_TYPE", format: requestType }
            ],
            rows: threads
        };
        const services = json.tables.SERVLIST;
        const dataServices = {
            id: "services",
            headers: [
                { name: "Active", field: "ACTIVE" },
                { name: "Protocol", field: "PROTOCOL", format: protocol },
                { name: "Service", field: "SERVICE" },
                { name: "Host", field: "HOSTNAME" },
                { name: "Keep Alive", field: "KEEPALIVE" },
                { name: "Timeout", field: "PROC_TIMEOUT" },
                { name: "External Bind", field: "EXTBIND" },
            ],
            rows: services
        };
        return React.createElement(React.Fragment, null,
            info && infoDiv,
            React.createElement("h3", null, "Worker Threads"),
            threads && React.createElement(Table, { key: "threads", data: dataThreads }),
            React.createElement("h3", null, "Services"),
            services && React.createElement(Table, { key: "services", data: dataServices }));
    }
    return (React.createElement("div", { id: 'panel_sap_system_icm_status' },
        React.createElement("div", { className: "update_animation_box" }, refreshing && Utils.updating()),
        React.createElement("h3", null, " ICM Status (SMICM) "),
        divPage));
};
const SAPSystemMessages = (props) => {
    const [divPage, setDivPage] = useState(null);
    const [refreshing, setRefreshing] = useState(true);
    const fn = { closed: useRef(false) };
    const SID = props.sid;
    function cleanUp() {
        fn.closed.current = true;
    }
    useEffect(() => { fn.closed.current = false; loadData(); return cleanUp; }, [SID]);
    function loadData() {
        if (fn.closed.current)
            return;
        Utils.setState(fn, setRefreshing, true);
        let pdo = Utils.postDataOptions({
            op: "systemmessages",
            sid: SID,
            limit: 200
        });
        fetch(apiURL + "sap", pdo).then(res => res.json()).then((result) => {
            Utils.setState(fn, setRefreshing, false);
            Utils.setState(fn, setDivPage, parse(result));
        }, (error) => {
            Utils.setState(fn, setRefreshing, false);
            Utils.setState(fn, setDivPage, Utils.error(error.message));
        });
    }
    ;
    function parse(json) {
        if (!json.success) {
            return Utils.error(json.error);
        }
        const data = {
            defaultSortField: "id",
            direction: "descendent",
            id: "systemmessages",
            headers: [
                { name: "ID", field: "id" },
                { name: "User", field: "usr" },
                { name: "Message", field: "txt" },
                { name: "Cr.Date", field: "crd", title: "Creation date" },
                { name: "Rem.Date", field: "red", title: "Remove date" },
                { name: "Server", field: "srv" },
                { name: "Client", field: "cli" },
            ],
            rows: json.messages
        };
        return React.createElement(Table, { data: data });
    }
    return (React.createElement("div", { id: 'panel_system_messages' },
        React.createElement("div", { className: "update_animation_box" }, refreshing && Utils.updating()),
        React.createElement("h3", null, " System Messages (SM02) "),
        divPage));
};
const SAPSystemRFCFunctionChecker = (props) => {
    const [divPage, setDivPage] = useState(null);
    const [divStart, setDivStart] = useState(null);
    const [refreshing, setRefreshing] = useState(true);
    const [r, refresh] = useState(false);
    const [enabled, setEnabled] = useState({ buttonStart: true });
    const fn = { closed: useRef(false) };
    const SID = props.sid;
    const timeoutID = "rfc_function_checker_" + SID;
    function cleanUp() {
        fn.closed.current = true;
        Timeouts.clearAll(timeoutID);
    }
    useEffect(() => { fn.closed.current = false; loadData(); return cleanUp; }, [SID]);
    function loadData() {
        Timeouts.clearAll(timeoutID);
        if (fn.closed.current)
            return;
        Utils.setState(fn, setRefreshing, true);
        Request.send({
            caller: fn,
            url: apiURL + "sap",
            params: { op: "check_rfc_functions_status", sid: SID },
            listener: (json) => {
                Utils.setState(fn, setRefreshing, false);
                Utils.setState(fn, setDivPage, parse(json));
            },
            then: () => Timeouts.add(timeoutID, setTimeout(loadData, 5000))
        });
    }
    ;
    function start() {
        enabled.buttonStart = false;
        Utils.setState(fn, refresh, Utils.timeStamp());
        Request.send({
            caller: fn,
            url: apiURL + "sap",
            params: { op: "check_rfc_functions_start", sid: SID },
            listener: (json) => {
                enabled.buttonStart = true;
                Utils.setState(fn, setDivPage, parseStart(json));
                Utils.setState(fn, refresh, Utils.timeStamp());
                Timeouts.add(timeoutID, setTimeout(loadData, 50));
            }
        });
    }
    function parseStart(json) {
        if (!json.success) {
            return Utils.error(json.error);
        }
        return json.message;
    }
    ;
    function status(row) {
        const valInt = parseInt(row.st);
        let color = Colors.text;
        switch (valInt) {
            case 1:
                color = Colors.yellow;
                break;
            case 2:
                color = Colors.green;
                break;
            case 3:
                color = Colors.red;
                break;
        }
        return React.createElement("span", { style: { color: color } },
            " ",
            row.stt,
            " ");
    }
    function parse(json) {
        if (!json.success) {
            return Utils.error(json.error);
        }
        const functions = json.functions;
        const data = {
            id: "rfc-functions_table",
            headers: [
                { name: "Function", field: "nm" },
                { name: "Description", field: "ds" },
                { name: "Status", field: "st", rowFormat: status },
                { name: "Duration(ms)", field: "dur" },
                { name: "Length", field: "len", title: "Response length" },
                { name: "Time", field: "end", format: Utils.toDate },
            ],
            rows: functions
        };
        return React.createElement(Table, { data: data });
    }
    return (React.createElement("div", { id: 'panel_sap_system_rfc_function_checker' },
        React.createElement("span", null, "Following list shows the remote function modules SysRanger use for monitoring. "),
        React.createElement("div", { className: "update_animation_box" }, refreshing && Utils.updating()),
        React.createElement("button", { onClick: start, disabled: !enabled.buttonStart }, "Check"),
        divStart,
        divPage));
};
const SAPSystemTime = (props) => {
    const [divPage, setDivPage] = useState(null);
    const [refreshing, setRefreshing] = useState(true);
    const fn = { closed: useRef(false) };
    const SID = props.sid;
    const timeoutID = "sapsystemtime" + SID;
    function cleanUp() {
        fn.closed.current = true;
        Timeouts.clearAll(timeoutID);
    }
    useEffect(() => { fn.closed.current = false; loadData(); return cleanUp; }, [SID]);
    function loadData() {
        if (fn.closed.current)
            return;
        Utils.setState(fn, setRefreshing, true);
        let pdo = Utils.postDataOptions({
            op: "systemtime",
            sid: SID
        });
        fetch(apiURL + "sap", pdo).then(res => res.json()).then((result) => {
            Utils.setState(fn, setRefreshing, false);
            Utils.setState(fn, setDivPage, parse(result));
        }, (error) => {
            Utils.setState(fn, setRefreshing, false);
            Utils.setState(fn, setDivPage, Utils.error(error.message));
        }).then(() => {
            if (fn.closed.current)
                return;
            setTimeout(() => Utils.setState(fn, setRefreshing, false), 1000);
            Timeouts.add(timeoutID, setTimeout(loadData, 5000));
        });
    }
    ;
    function parse(json) {
        if (!json.success) {
            return Utils.error(json.error);
        }
        return React.createElement("table", null,
            React.createElement("tbody", null,
                React.createElement("tr", null,
                    React.createElement("td", null, "SAP System Time: "),
                    React.createElement("td", null,
                        " ",
                        json.systemtime,
                        " ")),
                React.createElement("tr", null,
                    React.createElement("td", null, "SysRanger Local Time: "),
                    React.createElement("td", null,
                        " ",
                        json.localtime,
                        " "))));
    }
    return (React.createElement("div", { id: 'panel_system_time' },
        React.createElement("div", { className: "update_animation_box" }, refreshing && Utils.updating()),
        React.createElement("h3", null, " SAP System Time "),
        divPage));
};
const SAPSystemWPTable = (props) => {
    const [divGraph, setDivGraph] = useState(null);
    const [refreshing, setRefreshing] = useState(true);
    const fn = { closed: useRef(false) };
    const SID = props.sid;
    const timeoutID = "systemwptable";
    function cleanUp() {
        fn.closed.current = true;
        Timeouts.clearAll(timeoutID);
    }
    useEffect(() => { fn.closed.current = false; loadData(); return cleanUp; }, [SID]);
    function loadData() {
        Timeouts.clearAll(timeoutID);
        if (fn.closed.current)
            return;
        Utils.setState(fn, setRefreshing, true);
        let pdo = Utils.postDataOptions({
            op: "wptable",
            sid: SID,
        });
        fetch(apiURL + "sap", pdo).then(res => res.json()).then((result) => {
            Utils.setState(fn, setRefreshing, false);
            Utils.setState(fn, setDivGraph, parse(result));
        }, (error) => {
            Utils.setState(fn, setRefreshing, false);
            Utils.setState(fn, setDivGraph, Utils.error(error.message));
        }).then(() => {
            Timeouts.add(timeoutID, setTimeout(loadData, 2000));
        });
    }
    ;
    function parse(json) {
        if (!json.success) {
            return Utils.error(json.error);
        }
        if (!json.tables || !json.tables.WPLIST)
            return Utils.error("Cannot get workprocess table");
        const rows = json.tables.WPLIST;
        const data = {
            defaultSortField: "id",
            direction: "ascending",
            id: "iwpt",
            headers: [
                { name: "#", field: "WP_NO" },
                { name: "Type", field: "WP_TYP" },
                { name: "PID", field: "WP_PID" },
                { name: "Status", field: "WP_STATUS" },
                { name: "Reason", field: "WP_WAITING" },
                { name: "Start", field: "WP_WAITTIM" },
                { name: "Err", field: "WP_DUMPS" },
                { name: "Sem", field: "WP_SEM" },
                { name: "CPU", field: "WP_CPU" },
                { name: "Time", field: "WP_ELTIME" },
                { name: "Program", field: "WP_REPORT" },
                { name: "Client", field: "WP_MANDT" },
                { name: "User", field: "WP_BNAME" },
                { name: "Action", field: "WP_ACTION" },
                { name: "Table", field: "WP_TABLE" }
            ],
            rows: rows
        };
        return (React.createElement("div", null,
            React.createElement(Table, { key: "system_wp_table", data: data })));
    }
    return (React.createElement("div", { id: 'panel_sap_system_wp' },
        React.createElement("div", { className: "update_animation_box" }, refreshing && Utils.updating()),
        React.createElement("h2", null, " Work Process Table"),
        React.createElement("br", null),
        divGraph));
};
const SAPTableLocks = (props) => {
    const [divPage, setDivPage] = useState(null);
    const [data, setData] = useState({ lastUpdate: Utils.date() });
    const [refreshing, setRefreshing] = useState(true);
    const fn = { closed: useRef(false) };
    const SID = props.sid;
    const [refDR] = useState({});
    const timeoutID = "saptablelocks" + SID;
    function cleanUp() {
        fn.closed.current = true;
        Timeouts.clearAll(timeoutID);
    }
    useEffect(() => { fn.closed.current = false; loadData(); return cleanUp; }, [SID]);
    function loadData() {
        if (fn.closed.current)
            return;
        Utils.setState(fn, setRefreshing, true);
        let pdo = Utils.postDataOptions({
            op: "tablelocks",
            sid: SID,
            limit: 200
        });
        fetch(apiURL + "sap", pdo).then(res => res.json()).then((result) => {
            Utils.setState(fn, setRefreshing, false);
            Utils.setState(fn, setDivPage, parse(result));
            data.lastUpdate = Utils.date();
        }, (error) => {
            Utils.setState(fn, setRefreshing, false);
            Utils.setState(fn, setDivPage, Utils.error(error.message));
        }).then(() => {
            if (fn.closed.current)
                return;
            setTimeout(() => Utils.setState(fn, setRefreshing, false), 1000);
            Timeouts.add(timeoutID, setTimeout(loadData, 10000));
        });
    }
    ;
    function parse(json) {
        if (!json.success) {
            return Utils.error(json.error);
        }
        const data = {
            defaultSortField: "dt",
            direction: "descendent",
            id: "tablelocks",
            headers: [
                { name: "Client", field: "cl" },
                { name: "Instance", field: "in" },
                { name: "User", field: "us" },
                { name: "Date", field: "dt" },
                { name: "Mode", field: "md" },
                { name: "Table", field: "tb" },
                { name: "Lock argument", field: "ar" },
                { name: "Object", field: "ob" }
            ],
            rows: json.locks
        };
        return React.createElement(Table, { data: data });
    }
    return (React.createElement("div", { id: 'panel_table_locks' },
        React.createElement("div", { className: "update_animation_box" }, refreshing && Utils.updating()),
        React.createElement("h3", null, " Table Locks (SM12) "),
        React.createElement("span", { className: "pale" },
            t("Last Update Time"),
            " :  ",
            data.lastUpdate),
        divPage));
};
const SAPTrustedSystems = (props) => {
    const [refreshing, setRefreshing] = useState(true);
    const [page, setPage] = useState(0);
    const fn = { closed: useRef(false) };
    const SID = props.sid;
    const timeoutID = "saptrustedsystems";
    function cleanUp() {
        fn.closed.current = true;
        Timeouts.clearAll(timeoutID);
    }
    useEffect(() => { fn.closed.current = false; loadData(); return cleanUp; }, [SID]);
    function loadData() {
        if (fn.closed.current)
            return;
        Utils.setState(fn, setRefreshing, true);
        Request.send({
            url: apiURL + "sap",
            params: { op: "trustedsystems", sid: SID },
            listener: (json) => {
                Utils.setState(fn, setRefreshing, false);
                Utils.setState(fn, setPage, parse(json));
                if (!json.success)
                    Timeouts.add(timeoutID, setTimeout(loadData, 10000));
            },
        });
    }
    ;
    function status(val) {
        if (!val)
            return React.createElement("span", { style: { color: Colors.green } }, " OK ");
        return React.createElement("span", { style: { color: Colors.red } },
            " ",
            val,
            " ");
    }
    function parse(json) {
        if (!json.success) {
            return Utils.error(json.error);
        }
        const headers = [
            { name: "System", field: "scode" },
            { name: "Destination", field: "destination", width: "300px" },
            { name: "Status", field: "statuserror", format: status },
            { name: "Last Check", field: "checked" },
            { name: "User", field: "user" },
            { name: "Created", field: "date", width: "100px" },
            { name: "Host", field: "host" },
            { name: "Trusted License", field: "tlicense" },
            { name: "Local License", field: "llicense" }
        ];
        const dataTrusted = {
            id: "tableasaptrustedsystems",
            headers: headers,
            rows: json.trusted
        };
        const dataTrusting = {
            id: "tableasaptrustingsystems",
            headers: headers,
            rows: json.trusting
        };
        return React.createElement("div", null,
            React.createElement("h3", null, "Trusted Systems"),
            React.createElement("span", null, "The systems whose calls are trusted"),
            React.createElement("br", null),
            React.createElement("br", null),
            React.createElement(Table, { data: dataTrusted }),
            React.createElement("h3", null, "Trusting Systems"),
            React.createElement("span", null, "The systems that trust this system"),
            React.createElement("br", null),
            React.createElement("br", null),
            React.createElement(Table, { data: dataTrusting }));
    }
    return (React.createElement("div", { id: 'panel_sap_trusted_systems' },
        React.createElement("div", { className: "update_animation_box" }, refreshing && Utils.updating()),
        page));
};
const SAPTrustManager = (props) => {
    const [refreshing, setRefreshing] = useState(true);
    const [page, setPage] = useState(0);
    const fn = { closed: useRef(false) };
    const SID = props.sid;
    const timeoutID = "saptrustmanager";
    function cleanUp() {
        fn.closed.current = true;
        Timeouts.clearAll(timeoutID);
    }
    useEffect(() => { fn.closed.current = false; loadData(); return cleanUp; }, [SID]);
    function loadData() {
        if (fn.closed.current)
            return;
        Utils.setState(fn, setRefreshing, true);
        Request.send({
            url: apiURL + "sap",
            params: { op: "trustmanager", sid: SID },
            listener: (json) => {
                Utils.setState(fn, setRefreshing, false);
                Utils.setState(fn, setPage, parse(json));
                if (!json.success)
                    Timeouts.add(timeoutID, setTimeout(loadData, 5000));
            },
        });
    }
    ;
    function remainingDays(row) {
        const color = Utils.alertColor2(row.atp);
        return React.createElement("span", { style: { color: color } }, row.days);
    }
    function parse(json) {
        if (!json.success) {
            return Utils.error(json.error);
        }
        const td = {
            defaultSortField: "ctx",
            id: "tableasaptrustmanager",
            headers: [
                { name: "Context", field: "ctx" },
                { name: "App", field: "app" },
                { name: "PSE", field: "des", width: "200px" },
                { name: "Common Name", field: "cn" },
                { name: "Algorithm", field: "alg" },
                { name: "Issuer", field: "iss", width: "100px" },
                { name: "Subject", field: "sub", width: "100px" },
                { name: "Remaining", field: "days", rowFormat: remainingDays }
            ],
            rows: json.certificates
        };
        return React.createElement(Table, { data: td });
    }
    return (React.createElement("div", { id: 'panel_sap_rfc_destinations' },
        React.createElement("div", { className: "update_animation_box" }, refreshing && Utils.updating()),
        React.createElement("h2", null, "SAP Trust Manager Certificates "),
        page));
};
const SAPTune = (props) => {
    const [divPage, setDivPage] = useState(null);
    const [refreshing, setRefreshing] = useState(true);
    const fn = { closed: useRef(false) };
    const SID = props.sid;
    const timeoutID = "saptune" + SID;
    function cleanUp() {
        fn.closed.current = true;
        Timeouts.clearAll(timeoutID);
    }
    useEffect(() => { fn.closed.current = false; loadData(); return cleanUp; }, [SID]);
    function loadData() {
        Timeouts.clearAll(timeoutID);
        if (fn.closed.current)
            return;
        Utils.setState(fn, setRefreshing, true);
        Request.send({
            caller: fn,
            url: apiURL + "saptune",
            params: { op: "summary", sid: SID },
            listener: (json) => {
                Utils.setState(fn, setRefreshing, false);
                Utils.setState(fn, setDivPage, parse(json));
            },
            then: () => Timeouts.add(timeoutID, setTimeout(loadData, 5000))
        });
    }
    ;
    function parse(json) {
        if (!json.success) {
            return Utils.error(json.error);
        }
        const bt = bufferStatisticsTable(json);
        const ct = callStatisticsTable(json);
        const mt = memoryTable(json);
        function get(akey, vkey) {
            if (!json || !json.exports)
                return "--";
            const array = json.exports[akey];
            if (!array || array.length < 1)
                return "";
            const obj = array[0];
            const value = obj[vkey];
            return value;
        }
        const content = React.createElement("div", null,
            React.createElement("table", null,
                React.createElement("tbody", null,
                    React.createElement("tr", null,
                        React.createElement("td", null, "Analysis Date"),
                        React.createElement("td", null,
                            " ",
                            get("ANALYSIS_DATE", "ANALYSIS_DATE") + " " + get("ANALYSIS_TIME", "ANALYSIS_TIME"),
                            " ")),
                    React.createElement("tr", null,
                        React.createElement("td", null, "Table Count"),
                        React.createElement("td", null,
                            " ",
                            get("NUMBER_OF_TABLES", "NUMBER_OF_TABLES"))),
                    React.createElement("tr", null,
                        React.createElement("td", null, "Startup Date"),
                        React.createElement("td", null, get("STARTUP_DATE", "STARTUP_DATE") + " " + get("STARTUP_TIME", "STARTUP_TIME"))))),
            React.createElement("h3", null, "Buffer Statistics"),
            bt,
            React.createElement("h3", null, "Memory Statistics"),
            mt,
            React.createElement("h3", null, "Call Statistics"),
            ct);
        return content;
    }
    function callStatisticsTable(json) {
        function get(akey, vkey, nn) {
            if (!json || !json.exports)
                return "--";
            const array = json.exports[akey];
            if (!array || array.length < 1)
                return "";
            const obj = array[0];
            const value = obj[vkey];
            return nn ? value : Utils.numberFixed0(value);
        }
        const table = React.createElement("table", null,
            React.createElement("thead", null,
                React.createElement("tr", null,
                    React.createElement("th", null),
                    React.createElement("th", null, "Hit Ratio %"),
                    React.createElement("th", null, "ABAP Requests"),
                    React.createElement("th", null, "ABAP Fails"),
                    React.createElement("th", null, "DB Total Calls"),
                    React.createElement("th", null, "Average Time (ms)"),
                    React.createElement("th", null, "Database Rows Affected"))),
            React.createElement("tbody", null,
                React.createElement("tr", null,
                    React.createElement("td", null, "Select Single"),
                    React.createElement("td", { align: "right" },
                        " ",
                        get("TOTAL_HITRATIO", "DIRECT", true)),
                    React.createElement("td", { align: "right" },
                        " ",
                        get("LOGIC_ACCESSES", "DIRCNT")),
                    React.createElement("td", { align: "right" },
                        " ",
                        get("LOGIC_ACCESSES", "DIRFAIL")),
                    React.createElement("td", { align: "right" },
                        " ",
                        get("DB_ACCESSES", "DIRECT")),
                    React.createElement("td", { align: "right" },
                        " ",
                        get("TOTAL_DURATIONS", "DIRECT")),
                    React.createElement("td", { align: "right" },
                        " ",
                        get("TOTAL_ROWS", "DIRECT"))),
                React.createElement("tr", null,
                    React.createElement("td", null, "Select"),
                    React.createElement("td", { align: "right" },
                        " ",
                        get("TOTAL_HITRATIO", "SEQUENTIAL", true)),
                    React.createElement("td", { align: "right" },
                        " ",
                        get("LOGIC_ACCESSES", "SEQCNT")),
                    React.createElement("td", { align: "right" }, " 0 "),
                    React.createElement("td", { align: "right" },
                        " ",
                        get("DB_ACCESSES", "SEQUENTIAL")),
                    React.createElement("td", { align: "right" },
                        " ",
                        get("TOTAL_DURATIONS", "SEQUENTIAL")),
                    React.createElement("td", { align: "right" },
                        " ",
                        get("TOTAL_ROWS", "SEQUENTIAL"))),
                React.createElement("tr", null,
                    React.createElement("td", null, "Insert"),
                    React.createElement("td", { align: "right" },
                        " ",
                        get("TOTAL_HITRATIO", "INSERT", true)),
                    React.createElement("td", { align: "right" },
                        " ",
                        get("LOGIC_ACCESSES", "INSCNT")),
                    React.createElement("td", { align: "right" },
                        " ",
                        get("LOGIC_ACCESSES", "INSFAIL")),
                    React.createElement("td", { align: "right" },
                        " ",
                        get("DB_ACCESSES", "INSERT")),
                    React.createElement("td", { align: "right" },
                        " ",
                        get("TOTAL_DURATIONS", "INSERT")),
                    React.createElement("td", { align: "right" },
                        " ",
                        get("TOTAL_ROWS", "INSERT"))),
                React.createElement("tr", null,
                    React.createElement("td", null, "Update"),
                    React.createElement("td", { align: "right" },
                        " ",
                        get("TOTAL_HITRATIO", "UPDATE", true)),
                    React.createElement("td", { align: "right" },
                        " ",
                        get("LOGIC_ACCESSES", "UPDCNT")),
                    React.createElement("td", { align: "right" },
                        " ",
                        get("LOGIC_ACCESSES", "UPDFAIL")),
                    React.createElement("td", { align: "right" },
                        " ",
                        get("DB_ACCESSES", "UPDATE")),
                    React.createElement("td", { align: "right" },
                        " ",
                        get("TOTAL_DURATIONS", "UPDATE")),
                    React.createElement("td", { align: "right" },
                        " ",
                        get("TOTAL_ROWS", "UPDATE"))),
                React.createElement("tr", null,
                    React.createElement("td", null, "Delete"),
                    React.createElement("td", { align: "right" },
                        " ",
                        get("TOTAL_HITRATIO", "DELETE", true)),
                    React.createElement("td", { align: "right" },
                        " ",
                        get("LOGIC_ACCESSES", "DELCNT")),
                    React.createElement("td", { align: "right" },
                        " ",
                        get("LOGIC_ACCESSES", "DELFAIL")),
                    React.createElement("td", { align: "right" },
                        " ",
                        get("DB_ACCESSES", "DELETE")),
                    React.createElement("td", { align: "right" },
                        " ",
                        get("TOTAL_DURATIONS", "DELETE")),
                    React.createElement("td", { align: "right" },
                        " ",
                        get("TOTAL_ROWS", "DELETE"))),
                React.createElement("tr", null,
                    React.createElement("td", null, "Total"),
                    React.createElement("td", { align: "right" },
                        " ",
                        get("TOTAL_HITRATIO", "AVERAGE", true)),
                    React.createElement("td", { align: "right" },
                        " ",
                        get("TOTAL_OPERATIONS", "REQUESTS")),
                    React.createElement("td", { align: "right" },
                        " ",
                        get("TOTAL_OPERATIONS", "FAILS")),
                    React.createElement("td", { align: "right" },
                        " ",
                        get("TOTAL_OPERATIONS", "CALLS")),
                    React.createElement("td", { align: "right" }, " 0"),
                    React.createElement("td", { align: "right" },
                        " ",
                        get("TOTAL_OPERATIONS", "ROWS")))));
        return table;
    }
    function memoryTable(json) {
        function get(akey, vkey) {
            if (!json || !json.exports)
                return "--";
            const array = json.exports[akey];
            if (!array || array.length < 1)
                return "";
            const obj = array[0];
            const value = obj[vkey];
            return Utils.numberFixed0(value);
        }
        function getNum(akey, vkey) {
            if (!json || !json.exports)
                return 0;
            const array = json.exports[akey];
            if (!array || array.length < 1)
                return 0;
            const obj = array[0];
            const value = Number(obj[vkey]);
            if (isNaN(value))
                value = 0;
            return value;
        }
        const pageTotal = getNum("PAGING_AREA", "AREA_SIZE");
        const pageUse = (getNum("PAGING_AREA", "CURR_USED") / pageTotal) * 100;
        const extendedUse = getNum("EXTENDED_MEMORY_USAGE", "ALLOCATED") * 1024;
        const extendedTotal = getNum("EXTENDED_MEMORY_USAGE", "TOTAL") * 1024;
        const extendedUsePercentage = (extendedUse / extendedTotal) * 100;
        const extendedGlobalUse = getNum("EX_GLOB_MEM_USAGE", "USED");
        const extendedGlobalTotal = getNum("EX_GLOB_MEM_USAGE", "TOTAL");
        const extendedGlobalUsePercentage = (extendedGlobalUse / extendedGlobalTotal) * 100;
        const sharedUsePercentage = (getNum("SHR_OBJ_MEM_USAGE", "ALLOC") / getNum("SHR_OBJ_MEM_USAGE", "FREE")) * 100;
        const bst = json.tables.BUFFER_STATISTIC;
        let tbrow = null;
        if (bst) {
            for (let i = 0; i < bst.length; i++) {
                const bs = bst[i];
                if (bs["NAME"] == "TABL" || bs["NAME"] == "TABLP") {
                    let total = Number(bs["AVAIL_SIZE"]);
                    let used = Number(bs["USED_SPACE"]);
                    let usedPercentage = (used / total) * 100;
                    tbrow =
                        React.createElement("tr", null,
                            React.createElement("td", null, "Table Buffer"),
                            React.createElement("td", { align: "right" },
                                " ",
                                usedPercentage.toFixed(2)),
                            React.createElement("td", { align: "right" },
                                " ",
                                used.fixed0()),
                            React.createElement("td", { align: "right" }, " 0"),
                            React.createElement("td", { align: "right" },
                                " ",
                                total.fixed0()),
                            React.createElement("td", { align: "right" }, " "));
                    break;
                }
            }
        }
        const table = React.createElement("table", null,
            React.createElement("thead", null,
                React.createElement("tr", null,
                    React.createElement("th", null),
                    React.createElement("th", null, "Cur Use %"),
                    React.createElement("th", null, "Cur Use KB"),
                    React.createElement("th", null, "Max Use KB"),
                    React.createElement("th", null, "In Mem KB"),
                    React.createElement("th", null, "On Disk KB"))),
            React.createElement("tbody", null,
                React.createElement("tr", null,
                    React.createElement("td", null, "Page Area"),
                    React.createElement("td", { align: "right" },
                        " ",
                        pageUse.toFixed(2),
                        " "),
                    React.createElement("td", { align: "right" },
                        " ",
                        get("PAGING_AREA", "CURR_USED")),
                    React.createElement("td", { align: "right" },
                        " ",
                        get("PAGING_AREA", "MAX_USED")),
                    React.createElement("td", { align: "right" },
                        " ",
                        get("PAGING_AREA", "AREA_SHM")),
                    React.createElement("td", { align: "right" },
                        " ",
                        get("PAGING_AREA", "FILE_SIZE"))),
                React.createElement("tr", null,
                    React.createElement("td", null, "Extended Memory"),
                    React.createElement("td", { align: "right" },
                        " ",
                        extendedUsePercentage.toFixed(2)),
                    React.createElement("td", { align: "right" },
                        " ",
                        Utils.numberFixed0(extendedUse)),
                    React.createElement("td", { align: "right" },
                        " ",
                        (getNum("EXTENDED_MEMORY_USAGE", "USED") * 1024).fixed0(),
                        " "),
                    React.createElement("td", { align: "right" },
                        " ",
                        (getNum("EXTENDED_MEMORY_USAGE", "TOTAL") * 1024).fixed0()),
                    React.createElement("td", { align: "right" }, " ")),
                React.createElement("tr", null,
                    React.createElement("td", null, "Extended Global Memory"),
                    React.createElement("td", { align: "right" },
                        " ",
                        extendedGlobalUsePercentage.toFixed(2)),
                    React.createElement("td", { align: "right" },
                        " ",
                        extendedGlobalUse.fixed0()),
                    React.createElement("td", { align: "right" },
                        " ",
                        get("EX_GLOB_MEM_USAGE", "PEAK")),
                    React.createElement("td", { align: "right" },
                        " ",
                        extendedGlobalTotal.fixed0()),
                    React.createElement("td", null)),
                React.createElement("tr", null,
                    React.createElement("td", null, "Shared Objects"),
                    React.createElement("td", { align: "right" },
                        " ",
                        sharedUsePercentage.toFixed(2)),
                    React.createElement("td", { align: "right" },
                        " ",
                        get("SHR_OBJ_MEM_USAGE", "ALLOC")),
                    React.createElement("td", { align: "right" }, " 0"),
                    React.createElement("td", { align: "right" },
                        " ",
                        get("SHR_OBJ_MEM_USAGE", "FREE")),
                    React.createElement("td", { align: "right" })),
                tbrow,
                React.createElement("tr", null,
                    React.createElement("td", null, "Heap Memory"),
                    React.createElement("td", { align: "right" }),
                    React.createElement("td", { align: "right" },
                        " ",
                        get("HEAP_MEMORY_USAGE", "USED")),
                    React.createElement("td", { align: "right" },
                        " ",
                        get("HEAP_MEMORY_USAGE", "TOTAL_NDIA")),
                    React.createElement("td", { align: "right" },
                        " ",
                        get("HEAP_MEMORY_USAGE", "TOTAL")),
                    React.createElement("td", { align: "right" }, " "))));
        return table;
    }
    function bufferName(val) {
        switch (val) {
            case "TTAB": return "Table Definition (TTAB)";
            case "FTAB": return "Field Definition (FTAB)";
            case "SNTAB": return "Short NTAB (SNTAB)";
            case "IRBD": return "Initial Records (IRBD)";
            case "EIBUF": return "Export/Import (EIBUF)";
            case "TABL": return "Tables Buffer(TABL)";
            case "TABLP": return "Tables Buffer(TABLP)";
            case "ESM": return "Export/Import SHM (ESM)";
            case "CALE": return "Calendar (CALE)";
            case "PXA": return "Program (PXA)";
            case "PRES": return "Screen (PRES)";
        }
        return val;
    }
    function freeSize(row) {
        let free = row.AVAIL_SIZE - row.USED_SPACE;
        return Utils.numberFixed0(free);
    }
    function freePercentage(row) {
        let free = 100 - ((row.USED_SPACE / row.AVAIL_SIZE) * 100);
        return free.toFixed(2);
    }
    function freeDirSize(row) {
        let free = row.MAX_OBJCTS - row.ACT_OBJCTS;
        return Utils.numberFixed0(free);
    }
    function freeDirPercentage(row) {
        let free = 100 - ((row.ACT_OBJCTS / row.MAX_OBJCTS) * 100);
        return free.toFixed(2);
    }
    function bufferStatisticsTable(json) {
        if (!json.tables)
            return "No table";
        const rows = json.tables.BUFFER_STATISTIC;
        if (!rows)
            return "No data for buffer statistics";
        const data = {
            id: "bufferstatistics",
            pale: true,
            headers: [
                { name: "Name", field: "NAME", format: bufferName, width: "180px", emphasize: true },
                { name: "HitRatio", field: "HITRATIO", format: Utils.cellPercentage, right: true, emphasize: true },
                { name: "Allocated", field: "ALLOC_SIZE", format: Utils.numberFixed0, right: true },
                { name: "Free KB", rowFormat: freeSize, right: true },
                { name: "Free %", rowFormat: freePercentage, right: true, emphasize: true },
                { name: "Dir. Size", field: "MAX_OBJCTS", format: Utils.numberFixed0, right: true },
                { name: "FreeDirEnt", rowFormat: freeDirSize, right: true },
                { name: "FreeDir%", rowFormat: freeDirPercentage, right: true, emphasize: true },
                { name: "Swaps", field: "SWAP", format: Utils.numberFixed0, right: true },
                { name: "DB-Access", field: "DB_ACCESS", format: Utils.numberFixed0, right: true },
                { name: "Available", field: "AVAIL_SIZE", format: Utils.numberFixed0, right: true },
                { name: "Used", field: "USED_SPACE", format: Utils.numberFixed0, right: true },
                { name: "HIT", field: "HIT", format: Utils.numberFixed0, right: true },
                { name: "REQUEST", field: "REQUEST", format: Utils.numberFixed0, right: true },
                { name: "DB_QUALITY", field: "DB_QUALITY", format: Utils.cellPercentage, right: true },
                { name: "MAX_SIZE", field: "MAX_SIZE", format: Utils.numberFixed0, right: true },
                { name: "SUM_SIZE", field: "SUM_SIZE", format: Utils.numberFixed0, right: true },
                { name: "ALLOC", field: "ALLOC", right: true },
                { name: "MIN_SIZE", field: "MIN_SIZE", format: Utils.numberFixed0, right: true },
                { name: "RESERVE", field: "RESERVE", format: Utils.numberFixed0, right: true },
                { name: "INSERT", field: "INSERT", format: Utils.numberFixed0, right: true },
                { name: "UPDATE", field: "UPDATE", format: Utils.numberFixed0, right: true },
                { name: "DELETE", field: "DELETE", format: Utils.numberFixed0, right: true },
                { name: "SUM_SIZE2", field: "SUM_SIZE2", format: Utils.numberFixed0, right: true },
                { name: "ACT_OBJCTS", field: "ACT_OBJCTS", format: Utils.numberFixed0, right: true },
                { name: "REFRESH", field: "REFRESH", format: Utils.numberFixed0, right: true },
                { name: "ALLOC_FRMS", field: "ALLOC_FRMS", format: Utils.numberFixed0, right: true },
                { name: "REORG", field: "REORG", format: Utils.numberFixed0, right: true },
                { name: "FREE_OBJCT", field: "FREE_OBJCT", format: Utils.numberFixed0, right: true },
                { name: "SEARCH", field: "SEARCH", format: Utils.numberFixed0, right: true },
                { name: "REQ_DELETE", field: "REQ_DELETE", format: Utils.numberFixed0, right: true },
                { name: "SWAP_FRAME", field: "SWAP_FRAME", format: Utils.numberFixed0, right: true },
                { name: "MAX_FRMES", field: "MAX_FRMES", format: Utils.numberFixed0, right: true },
                { name: "CON_OBJCTS", field: "CON_OBJCTS", format: Utils.numberFixed0, right: true },
                { name: "DB_ACC_SVD", field: "DB_ACC_SVD", format: Utils.numberFixed0, right: true },
                { name: "FRAME_SIZE", field: "FRAME_SIZE", format: Utils.numberFixed0, right: true },
                { name: "UP_TIME", field: "UP_TIME" },
                { name: "LAST_REFR", field: "LAST_REFR" },
                { name: "SIZE_UNIT", field: "SIZE_UNIT" },
                { name: "SMODE", field: "SMODE" },
            ],
            rows: rows
        };
        return React.createElement(Table, { data: data });
    }
    return (React.createElement("div", { id: 'panel_saptune' },
        React.createElement("div", { className: "update_animation_box" }, refreshing && Utils.updating()),
        React.createElement("h3", null, " SAP Tune Statistics (ST02) "),
        divPage,
        React.createElement("h3", null, " Cursor Cache Statistics "),
        React.createElement(SAPTuneCursorCacheStatistics, { sid: SID })));
};
const SAPTuneCursorCacheStatistics = (props) => {
    const [divPage, setDivPage] = useState(null);
    const [refreshing, setRefreshing] = useState(true);
    const fn = { closed: useRef(false) };
    const SID = props.sid;
    const timeoutID = "saptuneccs" + SID;
    function cleanUp() {
        fn.closed.current = true;
        Timeouts.clearAll(timeoutID);
    }
    useEffect(() => { fn.closed.current = false; loadData(); return cleanUp; }, [SID]);
    function loadData() {
        Timeouts.clearAll(timeoutID);
        if (fn.closed.current)
            return;
        Utils.setState(fn, setRefreshing, true);
        Request.send({
            caller: fn,
            url: apiURL + "saptune",
            params: { op: "cursorcachestatistics", sid: SID },
            listener: (json) => {
                Utils.setState(fn, setRefreshing, false);
                Utils.setState(fn, setDivPage, parse(json));
            },
            then: () => Timeouts.add(timeoutID, setTimeout(loadData, 5000))
        });
    }
    ;
    function parse(json) {
        if (!json.success) {
            return Utils.error(json.error);
        }
        const data = {
            id: "saptunecursorcachestatistics_table",
            headers: [
                { name: "WP Type", field: "WPTC" },
                { name: "Hits", field: "SI_FOUNDS", format: Utils.numberFixed0, right: true },
                { name: "Requests", field: "SI_REQUEST", format: Utils.numberFixed0, right: true },
                { name: "HitRatio", field: "HTR", format: Utils.percentage, right: true },
                { name: "Used", field: "USED", format: Utils.numberFixed0, right: true },
                { name: "Inserts", field: "SI_INSERTS", format: Utils.numberFixed0, right: true },
                { name: "Deletes", field: "SI_DELETES", format: Utils.numberFixed0, right: true },
                { name: "ID 0 Requests", field: "SI0_REQ", format: Utils.numberFixed0, right: true },
            ],
            rows: json.statistics
        };
        return React.createElement("div", null,
            React.createElement("table", null,
                React.createElement("tbody", null,
                    React.createElement("tr", null,
                        React.createElement("td", null, "Hit Ratio"),
                        React.createElement("td", null,
                            json.totalhitratio.toFixed(2),
                            " ")),
                    React.createElement("tr", null,
                        React.createElement("td", null, "Hits"),
                        React.createElement("td", null,
                            Utils.numberFixed0(json.totalhits),
                            "  ")),
                    React.createElement("tr", null,
                        React.createElement("td", null, "Requests"),
                        React.createElement("td", null,
                            Utils.numberFixed0(json.totalrequests),
                            " ")),
                    React.createElement("tr", null,
                        React.createElement("td", null, "Available"),
                        React.createElement("td", null,
                            Utils.numberFixed0(json.availabletotal),
                            "  ")),
                    React.createElement("tr", null,
                        React.createElement("td", null, "Per WP"),
                        React.createElement("td", null,
                            Utils.numberFixed0(json.perwp),
                            "  ")),
                    React.createElement("tr", null,
                        React.createElement("td", null, "Used"),
                        React.createElement("td", null,
                            Utils.numberFixed0(json.used),
                            "  ")))),
            React.createElement("br", null),
            React.createElement("br", null),
            React.createElement(Table, { data: data }));
    }
    return (React.createElement("div", { id: 'panel_saptuneccs' },
        React.createElement("div", { className: "update_animation_box" }, refreshing && Utils.updating()),
        divPage));
};
const SAPUpdateErrors = (props) => {
    const [divPage, setDivPage] = useState(null);
    const [refreshing, setRefreshing] = useState(true);
    const fn = { closed: useRef(false) };
    const SID = props.sid;
    const [refDR] = useState({});
    function cleanUp() {
        fn.closed.current = true;
    }
    useEffect(() => { fn.closed.current = false; loadData(); return cleanUp; }, [SID]);
    function loadData() {
        if (fn.closed.current)
            return;
        Utils.setState(fn, setRefreshing, true);
        let pdo = Utils.postDataOptions({
            op: "updateerors",
            sid: SID,
            start: refDR.startSAPDate(),
            end: refDR.endSAPDate(),
            limit: 200
        });
        fetch(apiURL + "sap", pdo).then(res => res.json()).then((result) => {
            Utils.setState(fn, setRefreshing, false);
            Utils.setState(fn, setDivPage, parse(result));
        }, (error) => {
            Utils.setState(fn, setRefreshing, false);
            Utils.setState(fn, setDivPage, Utils.error(error.message));
        });
    }
    ;
    function parse(json) {
        if (!json.success) {
            return Utils.error(json.error);
        }
        if (!json.rows || !json.rows.length) {
            return "Empty";
        }
        sql = "select updkey key,datetime dtt,user usr,tcode tcd,program prg,readfrom frm "
            + " ,returncode rtc, status st, host hst, clientnumber cli, description dsc "
            + " from srsap_update_errors"
            + " where sid=" + sid + " and date>=" + start + " and date<=" + end
            + " order by datetime desc";
        const data = {
            defaultSortField: "dtt",
            id: "tablesapupdateerrors",
            direction: "descenting",
            headers: [
                { name: "Date", field: "dtt", format: Utils.timeSAP, width: "200px" },
                { name: "Status", field: "st" },
                { name: "RC", title: "Return Code", field: "rtc" },
                { name: "Key", field: "key" },
                { name: "Host", field: "hst" },
                { name: "User", field: "usr" },
                { name: "TCode", field: "tcd" },
                { name: "Program", field: "prg" },
                { name: "Client", field: "cli" },
                { name: "Description", field: "dsc" },
            ],
            rows: json.rows
        };
        return React.createElement(Table, { data: data });
    }
    function search() {
        loadData();
    }
    return (React.createElement("div", { id: 'panel_mail_errors' },
        React.createElement("div", { className: "update_animation_box" }, refreshing && Utils.updating()),
        React.createElement("h3", null, " SAP Update Errors (SM13) "),
        React.createElement(DateRange, { fn: refDR }),
        React.createElement("button", { onClick: search },
            " ",
            t("Search")),
        React.createElement("br", null),
        divPage));
};
const SAPUserTCodeMatrix = (props) => {
    const [divGraph, setDivGraph] = useState(null);
    const [refreshing, setRefreshing] = useState(true);
    const fn = { closed: useRef(false) };
    const SID = props.data.sid;
    const key = props.data.key;
    function cleanUp() {
        fn.closed.current = true;
    }
    useEffect(() => { fn.closed.current = false; loadData(); return cleanUp; }, [key]);
    function loadData() {
        if (fn.closed.current)
            return;
        Utils.setState(fn, setRefreshing, true);
        let pdo = Utils.postDataOptions({
            op: "usertcodes",
            sid: SID,
            base: props.base,
            component: props.data.component,
            period: props.data.period,
            start: props.data.start
        });
        fetch(apiURL + "sapperformance", pdo).then(res => res.json()).then((result) => {
            Utils.setState(fn, setRefreshing, false);
            Utils.setState(fn, setDivGraph, parse(result));
        }, (error) => {
            Utils.setState(fn, setRefreshing, false);
            Utils.setState(fn, setDivGraph, Utils.error(error.message));
        });
    }
    ;
    function parse(json) {
        if (!json.success) {
            return Utils.error(json.error);
        }
        const rows = json.rows;
        rows.sort((a, b) => {
            if (a.item > b.item)
                return 1;
            if (a.item < b.item)
                return -1;
            return 0;
        });
        const divs = [];
        for (let i = 0; i < rows.length; i++) {
            const row = rows[i];
            const label = row.item;
            const cols = [React.createElement("div", { key: "first_column_label_" + label, style: { width: "150px", display: "inline-block", overflow: "hidden", fontWeight: "bold", backgroundColor: Colors.background } },
                    label,
                    " ")];
            for (let t = 0; t < row.values.length; t++) {
                const item = row.values[t];
                const key = label + item.va + item.st + Utils.random();
                const average = item.rt / item.st;
                const title = item.va + "\nTotal Resp. Time : " + Utils.numberFixed0(item.rt) + "\nSteps : " + Utils.numberFixed0(item.st) + "\nAverage:" + Utils.numberFixed1(average);
                cols.push(React.createElement("div", { key: "tc_" + key, style: { width: "150px", display: "inline-block", overflow: "hidden", marginRight: "10px", paddingLeft: "10px", opacity: 0.7 }, title: title },
                    item.va,
                    " "));
                cols.push(React.createElement("div", { key: "cn_" + key, style: { width: "60px", display: "inline-block", overflow: "hidden", textAlign: "right", paddingRight: "10px", background: "#111" }, title: title },
                    Utils.numberFixed0(item.rt / 1000),
                    " "));
            }
            const div = React.createElement("div", { key: "tcmr_" + label, style: { boxSizing: "border-box", whiteSpace: "nowrap", height: "24px" } },
                " ",
                cols);
            divs.push(div);
        }
        divs.push(React.createElement("div", { key: "tcm_bottom_space", style: { height: "20px" } }));
        return React.createElement("div", { style: { overflow: "auto" } },
            " ",
            divs,
            "  ");
    }
    const title = props.base == "user" ? "User-Transaction Total Response Times" : "Transaction-User Total Response Times";
    return (React.createElement("div", { id: 'panel_sap_user_tcode_matrix_' + props.base },
        React.createElement("div", { className: "update_animation_box" }, refreshing && Utils.updating()),
        React.createElement("h2", null,
            " ",
            title),
        React.createElement("br", null),
        React.createElement("div", { key: "sapusertcodelistcontainer_" + props.base, style: { maxHeight: "300px", overflow: "auto" } }, divGraph)));
};
const SAPWorkloadAnalysis = (props) => {
    const [graphs, setGraph] = useState(null);
    const [directory, setDirectory] = useState({ list: [], period: "D", reset: true, start: "", error: "" });
    const [tasks, setTasks] = useState(null);
    const [userTransactions, setUserTransactions] = useState(null);
    const [transactionUsers, setTransactionUsers] = useState(null);
    const [times, setTimes] = useState(null);
    const [memory, setMemory] = useState(null);
    const [transactions, setTransactions] = useState(null);
    const [users, setUsers] = useState(null);
    const [refreshing, setRefreshing] = useState(true);
    const [rr, reset] = useState(0);
    const fn = { closed: useRef(false) };
    const SID = props.sid;
    function cleanUp() {
        fn.closed.current = true;
    }
    useEffect(() => { fn.closed.current = false; loadDirectory(); return cleanUp; }, [SID]);
    function loadDirectory() {
        if (fn.closed.current)
            return;
        Utils.setState(fn, setRefreshing, true);
        let pdo = Utils.postDataOptions({
            op: "workloaddirectory",
            sid: SID
        });
        fetch(apiURL + "sapperformance", pdo).then(res => res.json()).then((result) => {
            Utils.setState(fn, setRefreshing, false);
            const error = parseDirectory(result);
            if (error)
                directory.error = error;
            Utils.setState(fn, reset, Utils.timeStamp());
        }, (error) => {
            Utils.setState(fn, setRefreshing, false);
            directory.error = error.message;
            Utils.setState(fn, reset, Utils.timeStamp());
        });
    }
    ;
    function parseDirectory(json) {
        if (!json.success) {
            return json.error;
        }
        if (!json.tables || !json.tables.DIRECTORY_SHORT) {
            return "No result";
        }
        const rows = json.tables.DIRECTORY_SHORT;
        directory.list = rows;
        if (rows.length > 0) {
            const row = rows[0];
            directory.component = row.COMPONENT;
        }
        Utils.setState(fn, setDirectory, directory);
        if (rows.length < 1) {
            return "Workload Directory is emtpy. Check if this RFC connection can execute SWNC* functions and check if SAP_COLLECTOR_FOR_PERFMONITOR job is running.";
        }
        return "";
    }
    function directoryItemSelected(row, tabledata) {
        if (fn.closed.current)
            return;
        Utils.setState(fn, setTasks, null);
        Utils.setState(fn, setGraph, null);
        Utils.setState(fn, setUserTransactions, null);
        if (!row.PERIODSTRT) {
            return;
        }
        const data = { sid: SID, component: row.COMPONENT, start: row.PERIODSTRT, period: row.PERIODTYPE };
        data.key = SID + row.COMPONENT + row.PERIODTYPE + row.PERIODSTRT;
        Utils.setState(fn, setTasks, React.createElement(SAPWorkloadTasks, { key: "tasks_" + data.key, data: data }));
        Utils.setState(fn, setGraph, React.createElement(SAPWorkloadGraphs, { key: "wl_graph_" + SID + row.COMPONENT + row.PERIODTYPE, sid: SID, component: row.COMPONENT, period: row.PERIODTYPE }));
        Utils.setState(fn, setUserTransactions, React.createElement(SAPUserTCodeMatrix, { key: "ut_" + data.key, data: data, base: "user" }));
        Utils.setState(fn, setTransactionUsers, React.createElement(SAPUserTCodeMatrix, { key: "tu_" + data.key, data: data, base: "transaction" }));
        Utils.setState(fn, setTimes, React.createElement(SAPWorkloadTaskTimes, { key: "times_" + data.key, data: data }));
        Utils.setState(fn, setMemory, React.createElement(SAPWorkloadMemory, { key: "memory_" + data.key, data: data }));
        Utils.setState(fn, setTransactions, React.createElement(SAPWorkloadTransactions, { key: "transactions_" + data.key, data: data }));
        Utils.setState(fn, setUsers, React.createElement(SAPWorkloadUsers, { key: "users_" + data.key, data: data }));
    }
    function componentSelected(e) {
        directory.component = e.target.value;
        directory.start = "";
        reset(Utils.timeStamp());
    }
    function periodSelected(e) {
        directory.period = e.target.value;
        directory.start = "";
        reset(Utils.timeStamp());
    }
    function startSelected(e) {
        directory.start = e.target.value;
        reset(Utils.timeStamp());
        const row = { COMPONENT: directory.component, PERIODTYPE: directory.period, PERIODSTRT: directory.start };
        directoryItemSelected(row);
    }
    function directorySelect() {
        if (directory.list.length < 1) {
            if (directory.error) {
                return Utils.error(directory.error);
            }
            return "Loading workload directory...";
        }
        const data = {};
        const cos = [];
        const pos = [];
        const sts = [React.createElement("option", { key: "combo_start_empty", value: "" })];
        const starts = [];
        for (let i = 0; i < directory.list.length; i++) {
            const item = directory.list[i];
            const component = item.COMPONENT;
            const period = item.PERIODTYPE;
            const start = item.PERIODSTRT;
            if (!data[component]) {
                data[component] = { D: [], W: [], M: [] };
            }
            data[component][period].push(item);
            if (directory.period == period && directory.component == component) {
                starts.push(start);
            }
        }
        starts.reverse();
        for (let i = 0; i < starts.length; i++) {
            const start = starts[i];
            sts.push(React.createElement("option", { key: "combo_start_" + start, value: start }, start));
        }
        for (const [key, value] of Object.entries(data)) {
            cos.push(React.createElement("option", { key: "combo_component_" + key, value: key }, key));
        }
        const periods = ["D", "W", "M"];
        for (let i = 0; i < periods.length; i++) {
            const period = periods[i];
            pos.push(React.createElement("option", { key: "combo_period_" + period, value: period }, SAP.periodType(period)));
        }
        const div = React.createElement("div", null,
            React.createElement("select", { onChange: componentSelected }, cos),
            React.createElement("select", { onChange: periodSelected }, pos),
            React.createElement("select", { value: directory.start, onChange: startSelected }, sts));
        return div;
    }
    return (React.createElement("div", { id: 'panel_sap_workload_analysis' },
        React.createElement("div", { className: "update_animation_box" }, refreshing && Utils.updating()),
        React.createElement("h3", null, " SAP Workload Overview (ST03N) "),
        React.createElement("br", null),
        React.createElement("div", { style: { height: "50px" } }, directorySelect()),
        tasks,
        graphs,
        React.createElement("div", { style: { clear: "both" } }),
        userTransactions,
        transactionUsers,
        times,
        memory,
        transactions,
        users));
};
const SAPWorkloadGraphs = (props) => {
    const [divGraph, setDivGraph] = useState(null);
    const [refreshing, setRefreshing] = useState(true);
    const fn = { closed: useRef(false) };
    const SID = props.sid;
    const component = props.component;
    const period = props.period;
    function cleanUp() {
        fn.closed.current = true;
    }
    useEffect(() => { fn.closed.current = false; loadData(); return cleanUp; }, [SID]);
    function loadData() {
        if (fn.closed.current)
            return;
        Utils.setState(fn, setRefreshing, true);
        let pdo = Utils.postDataOptions({
            op: "workloadgraph",
            sid: SID,
            component: component,
            period: period
        });
        fetch(apiURL + "sapperformance", pdo).then(res => res.json()).then((result) => {
            Utils.setState(fn, setRefreshing, false);
            Utils.setState(fn, setDivGraph, parse(result));
        }, (error) => {
            Utils.setState(fn, setRefreshing, false);
            Utils.setState(fn, setDivGraph, Utils.error(error.message));
        });
    }
    ;
    function parse(json) {
        if (!json.success) {
            return Utils.error(json.error);
        }
        const rows = json.rows;
        const graphs = {
            "01": { items: [], title: "Dialog Response Time" },
            "04": { items: [], title: "Background Response Time" },
            "02": { items: [], title: "Update Response Time" },
            "07": { items: [], title: "AutoAbap Response Time" },
            "FE": { items: [], title: "RFC Response Time" },
        };
        for (let i = 0; i < rows.length; i++) {
            const row = rows[i];
            const graph = graphs[row.TASKTYPE];
            if (!graph)
                continue;
            const item = {};
            item.value = row.RESPTI / row.COUNT;
            item.label = row.PERIODSTRT;
            item.tt = "Value:" + Math.floor(item.value) + "<br/>Date:" + item.label;
            graph.items.push(item);
        }
        const divs = [];
        for (const [task, graph] of Object.entries(graphs)) {
            const div = React.createElement("div", { key: "div_response_time_" + task, style: { float: "left", marginRight: "20px" } },
                React.createElement(VerticalBarGraph, { data: graph }));
            divs.push(div);
        }
        return divs;
    }
    return (React.createElement("div", { id: 'panel_sap_workload_graph' },
        React.createElement("div", { className: "update_animation_box" }, refreshing && Utils.updating()),
        React.createElement("h2", null, " SAP Workload Graphs"),
        React.createElement("br", null),
        divGraph));
};
const SAPWorkloadMemory = (props) => {
    const [divGraph, setDivGraph] = useState(null);
    const [refreshing, setRefreshing] = useState(true);
    const fn = { closed: useRef(false) };
    const SID = props.data.sid;
    const key = props.data.key;
    function cleanUp() {
        fn.closed.current = true;
    }
    useEffect(() => { fn.closed.current = false; loadData(); return cleanUp; }, [key]);
    function loadData() {
        if (fn.closed.current)
            return;
        Utils.setState(fn, setRefreshing, true);
        let pdo = Utils.postDataOptions({
            op: "memory",
            sid: SID,
            component: props.data.component,
            period: props.data.period,
            start: props.data.start
        });
        fetch(apiURL + "sapperformance", pdo).then(res => res.json()).then((result) => {
            Utils.setState(fn, setRefreshing, false);
            Utils.setState(fn, setDivGraph, parse(result));
        }, (error) => {
            Utils.setState(fn, setRefreshing, false);
            Utils.setState(fn, setDivGraph, Utils.error(error.message));
        });
    }
    ;
    function parse(json) {
        if (!json.success) {
            return Utils.error(json.error);
        }
        const dataT = {
            defaultSortField: "avgtot",
            id: "sap_wl_memory_table_transaction",
            direction: "descenting",
            headers: [
                { name: "Transaction", field: "name" },
                { name: "Job", field: "job" },
                { name: "Steps", field: "stp", format: Utils.numberFixed0, right: true },
                { name: "Avg. Total", field: "avgtot", format: (val) => Utils.numberFixed0(val / 1024), right: true },
                { name: "Avg. Extended", field: "avgext", format: (val) => Utils.numberFixed0(val / 1024), right: true },
                { name: "Max. Extended", field: "max", format: (val) => Utils.numberFixed0(val / 1024), right: true },
            ],
            rows: json.transactions
        };
        const dataU = {
            defaultSortField: "avgtot",
            id: "sap_wl_memory_table_user",
            direction: "descenting",
            headers: [
                { name: "User", field: "name" },
                { name: "Steps", field: "stp", format: Utils.numberFixed0, right: true },
                { name: "Avg. Total", field: "avgtot", format: (val) => Utils.numberFixed0(val / 1024), right: true },
                { name: "Avg. Extended", field: "avgext", format: (val) => Utils.numberFixed0(val / 1024), right: true },
                { name: "Max. Extended", field: "max", format: (val) => Utils.numberFixed0(val / 1024), right: true },
            ],
            rows: json.users
        };
        return React.createElement("div", null,
            React.createElement("h2", null, " Transaction-Memory usage"),
            React.createElement("div", { style: { maxHeight: "400px", overflow: "auto" } },
                React.createElement(Table, { data: dataT })),
            React.createElement("h2", null, "User-Memory usage"),
            React.createElement("div", { style: { maxHeight: "400px", overflow: "auto" } },
                React.createElement(Table, { data: dataU })));
    }
    return (React.createElement("div", { id: 'panel_sap_workload_task_times' },
        React.createElement("div", { className: "update_animation_box" }, refreshing && Utils.updating()),
        React.createElement("br", null),
        divGraph));
};
const SAPWorkloadTasks = (props) => {
    const [divGraph, setDivGraph] = useState(null);
    const [refreshing, setRefreshing] = useState(true);
    const fn = { closed: useRef(false) };
    const SID = props.data.sid;
    const key = props.data.key;
    function cleanUp() {
        fn.closed.current = true;
    }
    useEffect(() => { fn.closed.current = false; loadData(); return cleanUp; }, [key]);
    function loadData() {
        if (fn.closed.current)
            return;
        Utils.setState(fn, setRefreshing, true);
        let pdo = Utils.postDataOptions({
            op: "workload",
            sid: SID,
            component: props.data.component,
            period: props.data.period,
            start: props.data.start
        });
        fetch(apiURL + "sapperformance", pdo).then(res => res.json()).then((result) => {
            Utils.setState(fn, setRefreshing, false);
            Utils.setState(fn, setDivGraph, parse(result));
        }, (error) => {
            Utils.setState(fn, setRefreshing, false);
            Utils.setState(fn, setDivGraph, Utils.error(error.message));
        });
    }
    ;
    function parse(json) {
        if (!json.success) {
            return Utils.error(json.error);
        }
        const data = {
            defaultSortField: "RESPAVG",
            id: "tablesaptasks",
            direction: "descending",
            headers: [
                { name: "Task", field: "TASKTYPE", format: SAP.taskType },
                { name: "Steps", field: "COUNT", format: Utils.numberFixed0, right: true },
                { name: "Avg.Resp.T.", field: "RESPAVG", tooltip: (row) => "Total:" + row.RESPTI, format: Utils.numberFixed0, title: "Average response time per dialog steps", right: true },
                { name: "Avg.CPU.T.", field: "CPUAVG", valueFunction: (row) => row.CPUTI / row.COUNT, format: Utils.numberFixed0, title: "Average CPU time(ms)", right: true },
                { name: "Avg.Proc.T.", field: "PROCAVG", valueFunction: (row) => row.PROCTI / row.COUNT, format: Utils.numberFixed0, title: "Average Processing time(ms)", right: true },
                { name: "Avg.DB.T.", field: "DBACVG", valueFunction: (row) => row.DBTI / row.COUNT, format: Utils.numberFixed0, title: "Average DB time(ms)", right: true },
                { name: "Avg.Wait.T.", field: "QUEUEAVG", valueFunction: (row) => row.QUEUETI / row.COUNT, format: Utils.numberFixed0, title: "Average Wait time(ms)", right: true },
                { name: "Avg.RFC.T.", field: "CPICAVG", valueFunction: (row) => row.CPICTI / row.COUNT, format: Utils.numberFixed0, title: "Average RFC Interface time(ms)", right: true },
                { name: "Bytes", field: "BYTES", valueFunction: (row) => Number(row.BYTES), format: Utils.bytesToUnit, right: true },
            ],
            rows: json.rows
        };
        return React.createElement(Table, { data: data });
    }
    return (React.createElement("div", { id: 'panel_sap_workload_tasks' },
        React.createElement("div", { className: "update_animation_box" }, refreshing && Utils.updating()),
        React.createElement("h2", null, " Tasks"),
        props.data.start,
        divGraph));
};
const SAPWorkloadTaskTimes = (props) => {
    const [divGraph, setDivGraph] = useState(null);
    const [refreshing, setRefreshing] = useState(true);
    const fn = { closed: useRef(false) };
    const SID = props.data.sid;
    const key = props.data.key;
    function cleanUp() {
        fn.closed.current = true;
    }
    useEffect(() => { fn.closed.current = false; loadData(); return cleanUp; }, [key]);
    function loadData() {
        if (fn.closed.current)
            return;
        Utils.setState(fn, setRefreshing, true);
        let pdo = Utils.postDataOptions({
            op: "tasktimes",
            sid: SID,
            component: props.data.component,
            period: props.data.period,
            start: props.data.start
        });
        fetch(apiURL + "sapperformance", pdo).then(res => res.json()).then((result) => {
            Utils.setState(fn, setRefreshing, false);
            Utils.setState(fn, setDivGraph, parse(result));
        }, (error) => {
            Utils.setState(fn, setRefreshing, false);
            Utils.setState(fn, setDivGraph, Utils.error(error.message));
        });
    }
    ;
    function parse(json) {
        if (!json.success) {
            return Utils.error(json.error);
        }
        const rows = json.rows;
        const data = {
            defaultSortField: "dtt",
            id: "tablesapupdateerrors",
            direction: "descenting",
            headers: [
                { name: "Time", field: "time" },
                { name: "CPU Time", field: "cpu", format: Utils.numberFixed0, right: true },
                { name: "Steps", field: "stp", format: Utils.numberFixed0, right: true },
                { name: "Processing Time", field: "pro", format: Utils.numberFixed0, right: true },
                { name: "Response Time", field: "res", format: Utils.numberFixed0, right: true },
            ],
            rows: rows
        };
        const graphs = {
            steps: { items: [], title: "Transaction steps time distribution", width: "500" },
            response: { items: [], title: "Transaction average response time distribution" }
        };
        for (let i = 0; i < rows.length; i++) {
            const row = rows[i];
            const avgResponseTime = Math.floor(row.res / row.stp);
            graphs.steps.items.push({ value: row.stp, label: row.time });
            graphs.response.items.push({ value: avgResponseTime, label: row.time });
        }
        return (React.createElement("div", null,
            React.createElement(Table, { key: "time_table", data: data }),
            React.createElement(VerticalBarGraph, { key: key + "_vbg_steps", data: graphs.steps }),
            React.createElement(VerticalBarGraph, { key: key + "_vbg_response", data: graphs.response })));
    }
    return (React.createElement("div", { id: 'panel_sap_workload_task_times' },
        React.createElement("div", { className: "update_animation_box" }, refreshing && Utils.updating()),
        React.createElement("h2", null, " Workload time distribution"),
        React.createElement("br", null),
        divGraph));
};
const SAPWorkloadTransactions = (props) => {
    const [divGraph, setDivGraph] = useState(null);
    const [refreshing, setRefreshing] = useState(true);
    const fn = { closed: useRef(false) };
    const SID = props.data.sid;
    const key = props.data.key;
    function cleanUp() {
        fn.closed.current = true;
    }
    useEffect(() => { fn.closed.current = false; loadData(); return cleanUp; }, [key]);
    function loadData() {
        if (fn.closed.current)
            return;
        Utils.setState(fn, setRefreshing, true);
        let pdo = Utils.postDataOptions({
            op: "transactions",
            sid: SID,
            component: props.data.component,
            period: props.data.period,
            start: props.data.start
        });
        fetch(apiURL + "sapperformance", pdo).then(res => res.json()).then((result) => {
            Utils.setState(fn, setRefreshing, false);
            Utils.setState(fn, setDivGraph, parse(result));
        }, (error) => {
            Utils.setState(fn, setRefreshing, false);
            Utils.setState(fn, setDivGraph, Utils.error(error.message));
        });
    }
    ;
    function parse(json) {
        if (!json.success) {
            return Utils.error(json.error);
        }
        const rows = json.rows;
        const data = {
            defaultSortField: "dtt",
            id: "tablesapupdateerrors",
            direction: "descenting",
            headers: [
                { name: "Transaction", field: "tc" },
                { name: "Program", field: "pr" },
                { name: "Steps", field: "st", format: Utils.numberFixed0, right: true },
                { name: "Resp.T.", field: "rt", rowFormat: (row) => Utils.numberFixed0(row.rt / 1000), right: true },
                { name: "Avg.Resp.T.", field: "RESPAVG", valueFunction: (row) => row.rt / row.st, format: Utils.numberFixed0, right: true },
                { name: "Proc. Time", field: "pt", rowFormat: (row) => Utils.numberFixed0(row.pt / 1000), right: true },
                { name: "Cpu Time", field: "ct", rowFormat: (row) => Utils.numberFixed0(row.ct / 1000), right: true },
            ],
            rows: rows
        };
        return (React.createElement("div", null,
            React.createElement(Table, { key: "transactions_table", data: data })));
    }
    return (React.createElement("div", { id: 'panel_sap_workload_transactions' },
        React.createElement("div", { className: "update_animation_box" }, refreshing && Utils.updating()),
        React.createElement("h2", null, " Transaction Times"),
        React.createElement("br", null),
        React.createElement("div", { style: { height: "400px", overflow: "auto" } }, divGraph)));
};
const SAPWorkloadUsers = (props) => {
    const [divGraph, setDivGraph] = useState(null);
    const [refreshing, setRefreshing] = useState(true);
    const fn = { closed: useRef(false) };
    const SID = props.data.sid;
    const key = props.data.key;
    function cleanUp() {
        fn.closed.current = true;
    }
    useEffect(() => { fn.closed.current = false; loadData(); return cleanUp; }, [key]);
    function loadData() {
        if (fn.closed.current)
            return;
        Utils.setState(fn, setRefreshing, true);
        let pdo = Utils.postDataOptions({
            op: "userworkload",
            sid: SID,
            component: props.data.component,
            period: props.data.period,
            start: props.data.start
        });
        fetch(apiURL + "sapperformance", pdo).then(res => res.json()).then((result) => {
            Utils.setState(fn, setRefreshing, false);
            Utils.setState(fn, setDivGraph, parse(result));
        }, (error) => {
            Utils.setState(fn, setRefreshing, false);
            Utils.setState(fn, setDivGraph, Utils.error(error.message));
        });
    }
    ;
    function parse(json) {
        if (!json.success) {
            return Utils.error(json.error);
        }
        const rows = json.rows;
        const data = {
            defaultSortField: "art",
            id: "tableuserworkloads",
            direction: "descending",
            headers: [
                { name: "User", field: "nm" },
                { name: "Steps", field: "st", format: Utils.numberFixed0 },
                { name: "Resp.T.", field: "rt", rowFormat: (row) => Utils.numberFixed0(row.rt / 1000) },
                { name: "Proc. Time", field: "pt", rowFormat: (row) => Utils.numberFixed0(row.pt / 1000) },
                { name: "Avg.Resp.T.", field: "art", format: Utils.numberFixed0 },
                { name: "Cpu Time", field: "ct", rowFormat: (row) => Utils.numberFixed0(row.ct / 1000) },
                { name: "DB Time", field: "dt", rowFormat: (row) => Utils.numberFixed0(row.dt / 1000) },
            ],
            rows: rows
        };
        return (React.createElement("div", null,
            React.createElement(Table, { key: "user_workload_table", data: data })));
    }
    return (React.createElement("div", { id: 'panel_sap_workload_users' },
        React.createElement("div", { className: "update_animation_box" }, refreshing && Utils.updating()),
        React.createElement("h2", null, " User Workload"),
        React.createElement("br", null),
        divGraph));
};
const SAPWorkloadUserTCodeMatrixYearlyPanel = (props) => {
    const [divGraph, setDivGraph] = useState(null);
    const [refreshing, setRefreshing] = useState(true);
    const fn = { closed: useRef(false) };
    const SID = props.sid;
    const key = props.rkey;
    function cleanUp() {
        fn.closed.current = true;
    }
    useEffect(() => { fn.closed.current = false; loadData(); return cleanUp; }, [key]);
    function loadData() {
        console.log("SAPWORKLOADUSERTCODEMATRIXYearly Key:" + key);
        if (fn.closed.current)
            return;
        Utils.setState(fn, setRefreshing, true);
        let pdo = Utils.postDataOptions({
            op: "usertcodesyearly",
            order: props.order,
            sid: SID
        });
        fetch(apiURL + "sapperformance", pdo).then(res => res.json()).then((result) => {
            Utils.setState(fn, setRefreshing, false);
            Utils.setState(fn, setDivGraph, parse(result));
        }, (error) => {
            Utils.setState(fn, setRefreshing, false);
            Utils.setState(fn, setDivGraph, Utils.error(error.message));
        });
    }
    ;
    function userClicked(e) {
        const user = e.currentTarget.getAttribute('user');
        const component = React.createElement(SAPWorkloadSingleUserTcodes, { sid: SID, user: user });
        Dialog.show({ content: component, render: true });
    }
    ;
    function parse(json) {
        if (!json.success) {
            return Utils.error(json.error);
        }
        const rows = json.rows;
        const divs = [];
        for (let i = 0; i < rows.length; i++) {
            const row = rows[i];
            const user = row.user;
            const cols = [
                React.createElement("div", { className: "clickable", key: "first_column_user_" + user, user: user, onClick: userClicked, style: { width: "120px", display: "inline-block", overflow: "hidden", fontWeight: "bold", position: "absolute", backgroundColor: Colors.background, zIndex: 4 } }, user)
            ];
            cols.push(React.createElement("div", { key: "first_column_blank_" + user, style: { width: "120px", display: "inline-block" } }));
            for (let t = 0; t < row.transactions.length; t++) {
                const transaction = row.transactions[t];
                const key = user + transaction.tc + transaction.cn + Utils.random();
                cols.push(React.createElement("div", { key: "tc_" + key, style: { width: "150px", display: "inline-block", overflow: "hidden", marginRight: "10px", paddingLeft: "10px" } },
                    transaction.tc,
                    " "));
                if (props.order != "steps") {
                    cols.push(React.createElement("div", { key: "rt_" + key, style: { width: "80px", display: "inline-block", overflow: "hidden", textAlign: "right", paddingRight: "10px", background: "#111", opacity: 0.7 } },
                        Math.round(transaction.rt / 1000),
                        " "));
                }
                else {
                    cols.push(React.createElement("div", { key: "cn_" + key, style: { width: "80px", display: "inline-block", overflow: "hidden", textAlign: "right", paddingRight: "10px", background: "#111", opacity: 0.7 } },
                        transaction.cn,
                        " "));
                }
            }
            const div = React.createElement("div", { key: "tcmr_" + user, style: { boxSizing: "border-box", whiteSpace: "nowrap", height: "24px" } },
                " ",
                cols);
            divs.push(div);
        }
        divs.push(React.createElement("div", { key: "tcm_bottom_space", style: { height: "20px" } }));
        return React.createElement("div", null,
            React.createElement("span", null,
                "Range : ",
                Utils.daySAP(json.minstart + ""),
                " - ",
                Utils.daySAP(json.maxend + "")),
            React.createElement("br", null),
            React.createElement("br", null),
            React.createElement("br", null),
            React.createElement("div", { style: { maxHeight: "400px", overflow: "auto" } },
                " ",
                divs,
                "  "));
    }
    return (React.createElement("div", { id: 'sapworkloadusertcodematrixyearly_panel' },
        React.createElement("div", { className: "update_animation_box" }, refreshing && Utils.updating()),
        divGraph));
};
const SAPWorkloadUserListYearly = (props) => {
    const [divUserList, setDivUserList] = useState(null);
    const [refreshing, setRefreshing] = useState(true);
    const fn = { closed: useRef(false) };
    const SID = props.sid;
    const key = props.rkey;
    function cleanUp() {
        fn.closed.current = true;
    }
    useEffect(() => { fn.closed.current = false; loadData(); return cleanUp; }, [key]);
    function loadData() {
        if (fn.closed.current)
            return;
        Utils.setState(fn, setRefreshing, true);
        let pdo = Utils.postDataOptions({
            op: "userlistyearly",
            sid: SID
        });
        fetch(apiURL + "sapperformance", pdo).then(res => res.json()).then((result) => {
            Utils.setState(fn, setRefreshing, false);
            Utils.setState(fn, setDivUserList, parse(result));
        }, (error) => {
            Utils.setState(fn, setRefreshing, false);
            Utils.setState(fn, setDivUserList, Utils.error(error.message));
        });
    }
    ;
    function userClicked(row) {
        const component = React.createElement(SAPWorkloadSingleUserTcodes, { sid: SID, user: row.us });
        Dialog.show({ content: component, render: true });
    }
    ;
    function parse(json) {
        if (!json.success) {
            return Utils.error(json.error);
        }
        const rows = json.rows;
        const data = {
            defaultSortField: "us",
            id: "tableworkloaduserlist",
            direction: "ascending",
            headers: [
                { name: "User", field: "us", onClick: userClicked },
                { name: "Steps", field: "st" },
                { name: "Response Time", field: "rt", format: (val) => Math.round(val / 1000).toLocaleString() },
                { name: "Min", field: "ms", format: Utils.daySAP },
                { name: "Max", field: "me", format: Utils.daySAP },
            ],
            rows: rows
        };
        return React.createElement(Table, { data: data });
    }
    return (React.createElement("div", { id: 'sapworkload_user_list_panel' },
        React.createElement("div", { className: "update_animation_box" }, refreshing && Utils.updating()),
        divUserList));
};
const SAPWorkloadSingleUserTcodes = (props) => {
    const [divList, setDivList] = useState(null);
    const [refreshing, setRefreshing] = useState(true);
    const fn = { closed: useRef(false) };
    const SID = props.sid;
    const key = props.rkey;
    function cleanUp() {
        fn.closed.current = true;
    }
    useEffect(() => { fn.closed.current = false; loadData(); return cleanUp; }, [key]);
    function loadData() {
        if (fn.closed.current)
            return;
        Utils.setState(fn, setRefreshing, true);
        let pdo = Utils.postDataOptions({
            op: "singleusertcodesyearly",
            user: props.user,
            sid: SID
        });
        fetch(apiURL + "sapperformance", pdo).then(res => res.json()).then((result) => {
            Utils.setState(fn, setRefreshing, false);
            Utils.setState(fn, setDivList, parse(result));
        }, (error) => {
            Utils.setState(fn, setRefreshing, false);
            Utils.setState(fn, setDivList, Utils.error(error.message));
        });
    }
    ;
    function parse(json) {
        if (!json.success) {
            return Utils.error(json.error);
        }
        const rows = json.rows;
        const data = {
            defaultSortField: "st",
            id: "tableworkloadsignleuseryearly",
            direction: "descending",
            headers: [
                { name: "Transaction", field: "tc" },
                { name: "Steps", field: "st" },
                { name: "Response Time", field: "rt", format: (val) => Math.round(val / 1000).toLocaleString() },
                { name: "Min", field: "ms", format: Utils.daySAP },
                { name: "Max", field: "me", format: Utils.daySAP },
            ],
            rows: rows
        };
        return React.createElement("div", null,
            React.createElement("span", null,
                "Date Range : ",
                Utils.daySAP(json.minstart),
                "   /   ",
                Utils.daySAP(json.maxend),
                " "),
            React.createElement(Table, { data: data }));
    }
    return (React.createElement("div", { id: 'sapworkload_user_tcodes_yearly' },
        React.createElement("div", { className: "update_animation_box" }, refreshing && Utils.updating()),
        React.createElement("h2", null,
            "Transactions used by ",
            props.user,
            " "),
        divList));
};
const SAPWorkloadUserTCodeMatrixYearly = (props) => {
    const SID = props.sid;
    return (React.createElement("div", { id: 'sapworkloadusertcodematrixyearly' },
        React.createElement("h2", null, " User-transaction execution statistics (Yearly)"),
        React.createElement("h3", null, " Ordered by transaction step count"),
        React.createElement(SAPWorkloadUserTCodeMatrixYearlyPanel, { key: SID + "wutmy_steps", rkey: SID + "wutmy_steps", sid: props.sid, order: "steps" }),
        React.createElement("h3", null, " Ordered by transaction response time"),
        React.createElement(SAPWorkloadUserTCodeMatrixYearlyPanel, { key: SID + "wutmy_responsetime", rkey: SID + "wutmy_responsetime", sid: props.sid, order: "responsetime" }),
        React.createElement("h3", null, " Users"),
        React.createElement(SAPWorkloadUserListYearly, { key: SID + "wusers", rkey: SID + "wusers", sid: props.sid })));
};
const SAPLoggedUsersRFC = (props) => {
    const [divPage, setDivPage] = useState(null);
    const [refreshing, setRefreshing] = useState(true);
    const fn = { closed: useRef(false) };
    const SID = props.sid;
    let refreshTimeout = 0;
    function cleanUp() {
        fn.closed.current = true;
        clearTimeout(refreshTimeout);
    }
    useEffect(() => { fn.closed.current = false; loadData(); return cleanUp; }, [SID]);
    function loadData() {
        if (fn.closed.current)
            return;
        Utils.setState(fn, setRefreshing, true);
        let pdo = Utils.postDataOptions({ op: "loggedusers", sid: SID });
        fetch(apiURL + "sapusers", pdo).then(res => res.json()).then((result) => {
            Utils.setState(fn, setRefreshing, false);
            Utils.setState(fn, setDivPage, parse(result));
        }, (error) => {
            Utils.setState(fn, setRefreshing, false);
            Utils.setState(fn, setDivPage, Utils.error(error.message));
        }).then(() => {
            if (fn.closed.current)
                return;
            setTimeout(() => Utils.setState(fn, setRefreshing, false), 1000);
            refreshTimeout = setTimeout(loadData, 10000);
        });
    }
    ;
    function parse(json) {
        if (!json.success) {
            return Utils.error(json.error);
        }
        const data = {
            defaultSortField: "tm",
            id: "tableasaploggedusersrfc",
            direction: "descending",
            headers: [
                { name: "Client", field: "cl" },
                { name: "Name", field: "us" },
                { name: "Login", field: "tm", format: Utils.timeSAP },
                { name: "Server", field: "sr" },
                { name: "Terminal", field: "tr" }
            ],
            rows: json.users
        };
        return React.createElement(Table, { data: data });
    }
    return (React.createElement("div", { id: 'panel_sap_logged_users_rfc' },
        React.createElement("div", { className: "update_animation_box" }, refreshing && Utils.updating()),
        React.createElement("h2", null, "Logged Dialog Users"),
        divPage));
};
const SAPSuim = (props) => {
    const SID = props.sid;
    const [component, setComponent] = useState("inactive");
    const fn = { closed: useRef(false) };
    function cleanUp() {
        fn.closed.current = true;
    }
    useEffect(() => { fn.closed.current = false; return cleanUp; }, [SID]);
    function selected(e) {
        e.preventDefault();
        Utils.setState(fn, setComponent, e.target.value);
    }
    const list = React.createElement("div", { id: 'div_sap_users_list' },
        React.createElement("select", { onChange: selected },
            React.createElement("option", { value: "inactive" }, "Inactive Users "),
            React.createElement("option", { value: "custom" }, "Custom Filter"),
            React.createElement("option", { value: "logged" }, "Logged Users ")));
    let panel = null;
    switch (component) {
        case "custom":
            panel = React.createElement(SAPSuimCustomFilter, { sid: SID });
            break;
        case "logged":
            panel = React.createElement(SAPLoggedUsersRFC, { sid: SID });
            break;
        case "inactive":
            panel = React.createElement(SAPSuimInactiveUsers, { sid: SID });
            break;
    }
    return (React.createElement("div", { id: 'panel_sap_users' },
        React.createElement("h2", null, "Users"),
        list,
        panel));
};
const SAPSuimAllUsers = (props) => {
    const [divPage, setDivPage] = useState(null);
    const [refreshing, setRefreshing] = useState(true);
    const fn = { closed: useRef(false) };
    const SID = props.sid;
    function cleanUp() {
        fn.closed.current = true;
    }
    useEffect(() => { fn.closed.current = false; loadData(); return cleanUp; }, [SID]);
    function loadData() {
        if (fn.closed.current)
            return;
        Utils.setState(fn, setRefreshing, true);
        let pdo = Utils.postDataOptions({ op: "logonandpasswordchange", sid: SID, limit: 400 });
        fetch(apiURL + "sapusers", pdo).then(res => res.json()).then((result) => {
            Utils.setState(fn, setRefreshing, false);
            Utils.setState(fn, setDivPage, parse(result));
        }, (error) => {
            Utils.setState(fn, setRefreshing, false);
            Utils.setState(fn, setDivPage, Utils.error(error.message));
        });
    }
    ;
    function userType(t) {
        switch (t) {
            case "A": return "Dialog";
            case "S": return "Service";
            case "B": return "System";
            case "L": return "Reference";
            case "C": return "Communication";
        }
        return t;
    }
    function locked(date) {
        if (date == "0000-00-00")
            return "";
        return date;
    }
    function days(val) {
        if (val == 0)
            return "Today";
        return val + " days ago";
    }
    function parse(json) {
        if (!json.success) {
            return Utils.error(json.error);
        }
        const data = {
            defaultSortField: "h",
            id: "tableRSUSR200",
            headers: [
                { name: "User", field: "usr" },
                { name: "Owner", field: "crtu" },
                { name: "Class", field: "cls" },
                { name: "Type", field: "utp", format: userType },
                { name: "Created", field: "crtd" },
                { name: "Login", field: "logd" },
                { name: "Login", field: "days", format: days },
                { name: "Password Changed", field: "pcd", format: locked },
                { name: "Locked", field: "pld", format: locked },
                { name: "Lock Reason", field: "lckr" },
            ],
            rows: json.users
        };
        return React.createElement(Table, { data: data });
    }
    return (React.createElement("div", { id: 'panel_sap_all_users' },
        React.createElement("div", { className: "update_animation_box" }, refreshing && Utils.updating()),
        divPage));
};
const SAPSuimCustomFilter = (props) => {
    const [divPage, setDivPage] = useState(null);
    const [refreshing, setRefreshing] = useState(true);
    const [r, refreshstate] = useState(0);
    const fn = { closed: useRef(false) };
    const SID = props.sid;
    const radioLocked = useRef();
    const radioUnlocked = useRef();
    const [filters, setFilters] = useState({
        flags: {
            "IV_VALID": { value: "X", group: "validty", description: "Valid" },
            "IV_NOTVALID": { value: "X", group: "validty", description: "Not valid" },
            "IV_DIAGUSER": { value: "X", group: "type", description: "Dialog User" },
            "IV_COMMUSER": { value: "X", group: "type", description: "Communication User" },
            "IV_SYSUSER": { value: "X", group: "type", description: "System User" },
            "IV_SERVUSER": { value: "X", group: "type", description: "Service User" },
            "IV_REFUSER": { value: "X", group: "type", description: "Reference User" },
            "IV_DEFPASS": { value: "X", group: "pass", description: "Default Password" },
            "IV_INITPASS": { value: "X", group: "pass", description: "Initial Password" },
            "IV_NOPASS": { value: "X", group: "pass", description: "No Password" },
            "IV_FAILLOG": { value: "X", group: "logon", description: "Failed Logon" },
            "IV_SUCCLOG": { value: "X", group: "logon", description: "Successfull Logon" },
            "IV_UNUSED": { value: "X", group: "logon", description: "Unused" },
        }
    });
    function refresh() {
        Utils.setState(fn, refreshstate, Utils.timeStamp());
    }
    function cleanUp() {
        fn.closed.current = true;
    }
    useEffect(() => { fn.closed.current = false; loadData(); return cleanUp; }, [SID]);
    function loadData() {
        if (fn.closed.current)
            return;
        Utils.setState(fn, setRefreshing, true);
        const data = { op: "customfilter", sid: SID, limit: 400 };
        for (var key in filters.flags) {
            if (!filters.flags.hasOwnProperty(key))
                continue;
            const flag = filters.flags[key];
            data[key] = flag.value;
        }
        data["IV_LOCKED"] = radioLocked.current.checked ? "X" : "";
        data["IV_UNLOCKED"] = radioUnlocked.current.checked ? "X" : "";
        let pdo = Utils.postDataOptions(data);
        fetch(apiURL + "sapusers", pdo).then(res => res.json()).then((result) => {
            Utils.setState(fn, setRefreshing, false);
            Utils.setState(fn, setDivPage, parse(result));
        }, (error) => {
            Utils.setState(fn, setRefreshing, false);
            Utils.setState(fn, setDivPage, Utils.error(error.message));
        });
    }
    ;
    function userType(t) {
        switch (t) {
            case "A": return "Dialog";
            case "S": return "Service";
            case "B": return "System";
            case "L": return "Reference";
            case "C": return "Communication";
        }
        return t;
    }
    function created(date) {
        if (date == "0000-00-00")
            return "";
        return date;
    }
    function lastLogin(date) {
        if (date == "0000-00-00 00:00:00")
            return "";
        return date;
    }
    function userName(row) {
        if (row.lck || !row.vld) {
            return React.createElement("span", { style: { color: Colors.red } },
                " ",
                row.usr,
                " ");
        }
        return row.usr;
    }
    function validTo(row) {
        if (!row.vld)
            return React.createElement("span", { style: { color: Colors.red } },
                " ",
                row.vldt,
                " ");
        if (!row.vldt)
            return "";
        if (row.vldt.startsWith("000"))
            return "";
        return row.vldt;
    }
    function lock(row) {
        if (row.lck)
            return React.createElement("span", { style: { color: Colors.red } },
                " ",
                row.lckr,
                " ");
        return row.lckr;
    }
    function parse(json) {
        if (!json.success) {
            if (json.error.startsWith("WRONG_PARAMETER_SET"))
                return Utils.error("Wrong Parameter Set.");
            return Utils.error(json.error);
        }
        const data = {
            defaultSortField: "days",
            direction: "descending",
            id: "tableRSUSR200_inactive",
            headers: [
                { name: "User", field: "usr", rowFormat: userName },
                { name: "Days Inactive", field: "days" },
                { name: "Last Login", field: "logd", format: lastLogin },
                { name: "Created", field: "crtd", format: created },
                { name: "Lock", field: "lckr", rowFormat: lock },
                { name: "Validity", field: "vldt", rowFormat: validTo },
                { name: "Class", field: "cls" },
                { name: "Type", field: "utp", format: userType },
                { name: "Owner", field: "crtu" },
            ],
            rows: json.users
        };
        return React.createElement("div", null,
            React.createElement("br", null),
            React.createElement("br", null),
            json.users.length,
            " users found.",
            React.createElement("br", null),
            React.createElement("br", null),
            React.createElement(Table, { data: data }));
    }
    function checkBoxClicked(e) {
        e.preventDefault();
        e.stopPropagation();
        const chk = e.currentTarget;
        const flag = chk.getAttribute('flag');
        filters.flags[flag].value = chk.checked ? "X" : "";
        setFilters(filters);
        refresh();
        loadData();
    }
    function radioClicked() {
        loadData();
    }
    const container = [];
    const groups = {};
    for (var key in filters.flags) {
        if (!filters.flags.hasOwnProperty(key))
            continue;
        const flag = filters.flags[key];
        const group = flag.group;
        const div = React.createElement("div", { style: { width: "200px", display: "inline-block" }, key: "chkdiv_" + key },
            React.createElement("label", { key: "filter_label_" + key },
                React.createElement("input", { type: "checkbox", checked: flag.value === "X", onChange: checkBoxClicked, name: group, flag: key, key: "chk_" + key }),
                flag.description));
        if (!groups[group]) {
            groups[group] = [];
        }
        groups[group].push(div);
    }
    groups["lock"] = [];
    groups["lock"].push(React.createElement("div", { style: { width: "200px", display: "inline-block" }, key: "chkdiv_locked" },
        React.createElement("label", null,
            React.createElement("input", { type: "radio", name: "lock", ref: radioLocked, onClick: radioClicked }),
            "Locked\t")));
    groups["lock"].push(React.createElement("div", { style: { width: "200px", display: "inline-block" }, key: "chkdiv_unlocked" },
        React.createElement("label", null,
            React.createElement("input", { type: "radio", name: "lock", ref: radioUnlocked, onClick: radioClicked }),
            "Without Lock\t")));
    groups["lock"].push(React.createElement("div", { style: { width: "200px", display: "inline-block" }, key: "chkdiv_lock_all" },
        React.createElement("label", null,
            React.createElement("input", { type: "radio", name: "lock", onClick: radioClicked }),
            "All\t")));
    for (var key in groups) {
        if (!groups.hasOwnProperty(key))
            continue;
        const group = groups[key];
        const div = React.createElement("div", { style: { border: "1px solid #666", marginTop: "10px", padding: "5px" }, key: "gr_" + key },
            " ",
            group,
            " ");
        container.push(div);
    }
    return (React.createElement("div", { id: 'panel_sap_suim_custom_filter' },
        React.createElement("div", { className: "update_animation_box" }, refreshing && Utils.updating()),
        React.createElement("h2", null, "User list with custom selection criteria"),
        "Please select at least one flag in each group.",
        React.createElement("br", null),
        React.createElement("div", null, container),
        React.createElement("br", null),
        divPage));
};
const SAPSuimInactiveUsers = (props) => {
    const [divPage, setDivPage] = useState(null);
    const [refreshing, setRefreshing] = useState(true);
    const fn = { closed: useRef(false) };
    const SID = props.sid;
    const refDays = useRef("90");
    function cleanUp() {
        fn.closed.current = true;
    }
    useEffect(() => { fn.closed.current = false; loadData(); return cleanUp; }, [SID]);
    function loadData() {
        if (fn.closed.current)
            return;
        Utils.setState(fn, setRefreshing, true);
        let pdo = Utils.postDataOptions({ op: "inactiveusers", sid: SID, limit: 500, days: refDays.current.value });
        fetch(apiURL + "sapusers", pdo).then(res => res.json()).then((result) => {
            Utils.setState(fn, setRefreshing, false);
            Utils.setState(fn, setDivPage, parse(result));
        }, (error) => {
            Utils.setState(fn, setRefreshing, false);
            Utils.setState(fn, setDivPage, Utils.error(error.message));
        });
    }
    ;
    function userType(t) {
        switch (t) {
            case "A": return "Dialog";
            case "S": return "Service";
            case "B": return "System";
            case "L": return "Reference";
            case "C": return "Communication";
        }
        return t;
    }
    function created(date) {
        if (date == "0000-00-00")
            return "";
        return date;
    }
    function lastLogin(date) {
        if (date == "0000-00-00 00:00:00")
            return "";
        return date;
    }
    function parse(json) {
        if (!json.success) {
            return Utils.error(json.error);
        }
        const data = {
            defaultSortField: "days",
            direction: "descending",
            id: "tableRSUSR200_inactive",
            headers: [
                { name: "User", field: "usr" },
                { name: "Days Inactive", field: "days" },
                { name: "Last Login", field: "logd", format: lastLogin },
                { name: "Created", field: "crtd", format: created },
                { name: "Class", field: "cls" },
                { name: "Type", field: "utp", format: userType },
                { name: "Owner", field: "crtu" },
            ],
            rows: json.users
        };
        return React.createElement("div", null,
            "Displaying ",
            json.users.length,
            " users inactive for ",
            json.days,
            " days.",
            React.createElement("br", null),
            React.createElement(Table, { data: data }));
    }
    function daySelected() {
        loadData();
    }
    return (React.createElement("div", { id: 'panel_sap_inactive_users' },
        React.createElement("div", { className: "update_animation_box" }, refreshing && Utils.updating()),
        React.createElement("h2", null, "Inactive Users"),
        "Select users not logged for",
        React.createElement("select", { ref: refDays, onChange: daySelected, defaultValue: "90" },
            React.createElement("option", { value: "30" }, "1 Month "),
            React.createElement("option", { value: "60" }, "2 Months "),
            React.createElement("option", { value: "90" }, "3 Months "),
            React.createElement("option", { value: "180" }, "6 Months "),
            React.createElement("option", { value: "365" }, "1 Year ")),
        React.createElement("br", null),
        React.createElement("br", null),
        divPage));
};
const System = (props) => {
    const SID = props.match.params.sid;
    const [system, setSystem] = useState({ code: "", type: 0, id: SID, loaded: false, sap: false });
    const fn = { closed: useRef(false) };
    function back(e) { e.preventDefault(); Utils.goBack(props.history); }
    function cleanUp() {
        fn.closed.current = true;
    }
    useEffect(() => { fn.closed.current = false; getData(); return cleanUp; }, [SID]);
    function getData() {
        Post({ url: apiURL + "systems", data: { op: "getsystem", sid: SID }, fn: fn,
            success: (json) => {
                json.loaded = true;
                Utils.setState(fn, setSystem, json);
            }
        });
    }
    ;
    function optionChanged() {
        setTimeout(getData, 100);
    }
    function sapPage() {
        return React.createElement(Tabs, { default: "dashboard", id: "tabs_system", key: 'tabs_system_' + SID },
            React.createElement(Tab, { key: 'dashboard', name: 'dashboard', label: 'Dashboard' },
                React.createElement(SAPSystemDashboard, { sid: SID }),
                " "),
            React.createElement(Tab, { key: 'hosts', name: 'hosts', label: 'Hosts' },
                React.createElement(SystemHosts, { sid: SID }),
                " "),
            React.createElement(Tab, { key: 'report', name: 'report', label: 'Report' },
                React.createElement(SAPMonthlyReport, { sid: SID }),
                " "),
            React.createElement(Tab, { key: 'details', name: 'details', label: 'Details' },
                React.createElement(SAPDetails, { sid: SID }),
                " "),
            User.admin && React.createElement(Tab, { key: 'configuration', name: 'configuration', label: 'Configuration' },
                React.createElement(SAPSystemConfiguration, { sid: SID }),
                " "),
            User.admin && React.createElement(Tab, { key: 'options', name: 'options', label: 'Options' },
                React.createElement(SystemOptions, { sid: SID, listener: optionChanged }),
                " "));
    }
    function page() {
        if (!system.loaded)
            return "Loading...";
        if (system.sap)
            return sapPage();
        return React.createElement(Tabs, { default: "hosts", id: "tabs_system", key: 'tabs_system_' + SID },
            React.createElement(Tab, { key: 'hosts', name: 'hosts', label: 'Hosts' },
                React.createElement(SystemHosts, { sid: SID }),
                " "),
            User.admin && React.createElement(Tab, { key: 'options', name: 'options', label: 'Options' },
                React.createElement(SystemOptions, { sid: SID, listener: optionChanged }),
                " "));
    }
    return (React.createElement("div", { id: 'page' },
        React.createElement(Header, { back: back, title: t("System") + " " + system.code }),
        page()));
};
const SystemDatabases = (props) => {
    const SID = props.sid;
    function hostClicked(item) {
        props.history.push("/unit-details/" + item.hostid);
    }
    function statusColor(row) {
        return Utils.contains(row.status, "RUNNING") ? Colors.green : Colors.red;
    }
    ;
    const tableData = {
        defaultSortField: "name",
        id: "sht_" + SID,
        update: Utils.timeStamp(),
        showLastUpdate: true,
        loader: {
            refresh: 5000,
            url: apiURL + "databases",
            variables: { op: "list", sid: SID },
            array: "databases"
        },
        headers: [
            { name: "Name", field: "name" },
            { name: "Description", field: "alias" },
            { name: "Type", field: "typename" },
            { name: "Host", field: "hostname", onClick: hostClicked },
            { name: "Port", field: "port", colorRule: (row) => Utils.onOffColor(row.reachable) },
            { name: "Healthy", field: "healthy", format: Utils.yesno },
            { name: "Status", field: "status", showTooltip: true, format: Database.getStatus, colorRule: statusColor },
            { name: "Data", field: "dpc", bar: { width: 100, name: "" },
                tooltip: (row) => {
                    return row.dpc + " % \n" + Utils.bytesToUnit(row.dau) + " / " + Utils.bytesToUnit(row.das);
                }
            },
            { name: "Log", field: "lpc", bar: { width: 100, name: "" },
                tooltip: (row) => {
                    return row.lpc + " % \n" + Utils.bytesToUnit(row.lou) + " / " + Utils.bytesToUnit(row.los);
                }
            },
            { name: "User", field: "user" },
            { name: "OS User", field: "osuser", title: t("Operating system user") }
        ]
    };
    return (React.createElement("div", { id: 'panel_system_databases' },
        React.createElement(Table, { data: tableData })));
};
const SystemHosts = (props) => {
    const SID = props.sid;
    function pingCell(row) {
        let image = "/images/icons/png/circle_red.png";
        const ping = row.ping;
        if (ping >= 0) {
            image = "/images/icons/png/circle_green.png";
        }
        return [React.createElement("img", { key: "img_ping_" + row.id, src: image, width: "14", style: { marginRight: "5px" } }), React.createElement("span", { key: "ping_" + row.id }, " " + ping > -1 ? ping : "")];
    }
    ;
    function formatOS(row) {
        return React.createElement("div", null,
            Utils.OSIconSVG(row.os),
            React.createElement("span", { style: { marginLeft: "5px" } }, row.osn));
    }
    function hostClicked(host) {
        Utils.go(props.history, "#unit-details/" + host.id);
    }
    function hostRemoveLink(value) {
        return React.createElement("a", { href: "#remove-host-from-system/" + value + "/" + SID }, "Remove");
    }
    const tableData = {
        defaultSortField: "name",
        id: "sht_" + SID,
        update: Utils.timeStamp(),
        showLastUpdate: true,
        loader: {
            refresh: 5000,
            url: apiURL + "systems",
            variables: { op: "getsystem", sid: SID },
            array: "hosts"
        },
        headers: [
            { name: "Name", field: "n" },
            { name: "Description", field: "a" },
            { name: "IP", field: "ip", onClick: hostClicked },
            { name: "OS", field: "osn", rowFormat: formatOS },
            { name: "Healthy", field: "ok", format: Utils.yesno },
            { name: "Ping", field: "ping", rowFormat: pingCell, width: "40px" },
            { name: "Agent", field: "pc", format: Utils.onOff, center: true, width: "40px" },
            { name: "Last activity", field: "las", format: Utils.minutesPast, tooltip: (host) => Utils.toDate(host.lastActivity) },
            User.admin ? { name: "Remove", field: "id", format: hostRemoveLink } : null
        ]
    };
    return (React.createElement("div", { id: 'panel_system_options' },
        React.createElement(Table, { data: tableData })));
};
const SystemOptions = (props) => {
    const [data, setData] = useState(null);
    const SID = props.sid;
    let inputDescription = createRef();
    let inputCode = createRef();
    const fn = { closed: useRef(false) };
    const [config, setConfig] = useState({ sap: undefined, mm: undefined });
    const [r, refresh] = useState(0);
    function cleanUp() {
        fn.closed.current = true;
    }
    useEffect(() => { fn.closed.current = false; getData(); return cleanUp; }, [SID]);
    function getData() {
        if (fn.closed.current)
            return;
        let pdo = Utils.postDataOptions({ op: "getsystem", sid: SID });
        fetch(apiURL + "systems", pdo).then(res => res.json()).then((result) => {
            Utils.setState(fn, setData, result);
        }, (error) => {
            Utils.setState(fn, setData, { success: false, error: Utils.error(error.message) });
        });
    }
    ;
    function parse(data) {
        if (!data || !data.success) {
            return Utils.error(data.error);
        }
        console.log(data);
        if (config.sap == undefined) {
            config.sap = data.type == 1;
        }
        if (config.mm == undefined)
            config.mm = data.mm > 0;
        return React.createElement("div", null,
            React.createElement("table", null,
                React.createElement("tbody", null,
                    React.createElement("tr", null,
                        React.createElement("td", null, "SID"),
                        React.createElement("td", null,
                            React.createElement("input", { type: "text", ref: inputCode, id: "inputCode", defaultValue: data.code })),
                        React.createElement("td", null,
                            React.createElement("button", { onClick: updateCode }, t("Update")))),
                    React.createElement("tr", null,
                        React.createElement("td", null, t("Description")),
                        React.createElement("td", null,
                            React.createElement("input", { type: "text", ref: inputDescription, id: "inputDescription", defaultValue: data.n })),
                        React.createElement("td", null,
                            React.createElement("button", { onClick: updateDescription }, t("Update")))))),
            React.createElement(IconSelector, { data: { id: "icon_selector_system_" + data.code, value: data.ic, listener: iconSelected } }),
            React.createElement(Checkbox, { label: "SAP System", checked: config.sap, onChange: sapClicked, id: "chk_sap_system", key: "chk_sap_system" }),
            React.createElement("br", null),
            React.createElement(Checkbox, { label: "Maintenance Mode", checked: config.mm, onChange: mmClicked, id: "chk_mm", key: "chk_mm" }),
            React.createElement("br", null),
            React.createElement("br", null),
            React.createElement("a", { key: "remove_system", href: "#remove-system/" + data.id }, t("Remove system")),
            React.createElement("br", null));
    }
    function iconSelected(value) {
        Post({ url: apiURL + "systems", data: { op: "seticon", sid: SID, value: value }, fn: fn, refresh: true, message: "Icon updated" });
    }
    ;
    function updateDescription() {
        const description = inputDescription.current.value;
        Post({ url: apiURL + "systems", data: { op: "updatedescription", sid: SID, description: description }, fn: fn, refresh: true, message: "Description updated" });
    }
    function updateCode() {
        const code = inputCode.current.value;
        Post({ url: apiURL + "systems", data: { op: "updatecode", sid: SID, code: code }, fn: fn, refresh: true, message: "SID updated", success: () => props.listener() });
    }
    function sapClicked(e) {
        config.sap = e.target.checked;
        setConfig(config);
        refresh(Utils.timeStamp);
        Post({ url: apiURL + "systems", data: { op: "settype", sid: SID, value: config.sap ? 1 : 0 }, fn: fn, refresh: true, message: "Setting is saved",
            success: () => props.listener()
        });
    }
    function mmClicked(e) {
        config.mm = e.target.checked;
        setConfig(config);
        refresh(Utils.timeStamp);
        Post({ url: apiURL + "systems", data: { op: "maintenancemode", sid: SID, value: config.mm ? 1 : 0 }, fn: fn, refresh: true, message: "Setting is saved",
            success: () => props.listener()
        });
    }
    return (React.createElement("div", { id: 'panel_system_options' }, data && parse(data)));
};
const Systems = (props) => {
    const url = apiURL + "systems";
    const fn = { exited: false };
    function back(e) { e.preventDefault(); cleanUp(); Utils.goBack(props.history); }
    function cleanUp() {
        fn.exited = true;
    }
    useEffect(() => { getSystemList(); return cleanUp; }, []);
    function getSystemList() {
        if (fn.exited)
            return;
        setContent(Utils.loading());
        let pdo = Utils.postDataOptions({ op: "listsystems" });
        fetch(url, pdo).then(res => res.json()).then((result) => {
            parseSystemList(result);
        }, (error) => {
            console.log(error);
        });
    }
    ;
    function setContent(content) {
        const container = document.getElementById('systemlist');
        ReactDOM.render(content, container);
        return container;
    }
    function parseSystemList(json) {
        console.log(json);
        if (!json.success) {
            return setContent(Utils.error(json.error));
        }
        if (!json || !json.systems) {
            return setContent(React.createElement("div", null, "Error"));
        }
        const divs = [];
        for (let i = 0; i < json.systems.length; i++) {
            const system = json.systems[i];
            let mm = "";
            if (system.mm > 0) {
                const title = "This system is in maintenance mode since " + Utils.toDate(system.mm);
                mm = React.createElement("img", { style: { marginLeft: "10px" }, className: "blink svg_yellow", src: "images/icons/maintenance.svg", width: "16", title: title });
            }
            const div = React.createElement("div", { sid: system.id, key: "sd_" + i, className: "list-group-item", style: { width: "100px", minHeight: "60px", border: "1px solid #dedede", margin: "10px", marginLeft: "0", padding: "10px", float: "left" } },
                React.createElement("a", { key: "sa_" + i, href: "#system/" + system.id, sid: system.id }, system.code),
                mm,
                React.createElement("br", null),
                system.name,
                " ",
                React.createElement("br", null));
            divs.push(div);
        }
        const container = setContent(divs);
        var sortable = Sortable.create(container, { onEnd: dragEnd });
    }
    function dragEnd(evt) {
        const children = evt.to.children;
        let sortList = "";
        for (var i = 0; i < children.length; i++) {
            const child = children[i];
            const sid = child.getAttribute("sid");
            sortList += sid + "-";
        }
        console.log(sortList);
        const pdo = Utils.postDataOptions({ op: "systemdisplayorder", list: sortList });
        fetch(url, pdo).then(res => res.json()).then((result) => {
        }, (error) => {
            console.log(error);
            setContent(Utils.error(error.message));
        });
    }
    return (React.createElement("div", { id: 'page' },
        React.createElement(Header, { back: back, title: t("Systems") }),
        User.admin ? React.createElement("a", { className: "linkbutton", href: "#add-new-system" },
            " ",
            t("Add new system")) : null,
        React.createElement("br", null),
        t("Drag system boxes to change display order"),
        React.createElement("br", null),
        React.createElement("div", { id: 'systemlist' })));
};
const TextFileReader = (props) => {
    const [text, setText] = useState({ lines: [], start: Number.MAX_SAFE_INTEGER });
    const hostID = props.hostid;
    const fn = { closed: useRef(false) };
    const [refreshing, setRefreshing] = useState(true);
    const [r, refresh] = useState(0);
    const data = props.data;
    function cleanUp() {
        fn.closed.current = true;
    }
    useEffect(() => { fn.closed.current = false; readNext(); return cleanUp; }, [hostID]);
    function readNext() {
        data.params.start = text.start;
        Utils.setState(fn, setRefreshing, true);
        Request.send({
            url: data.url,
            params: data.params,
            listener: (json) => parse(json)
        });
    }
    ;
    function parse(json) {
        Utils.setState(fn, setRefreshing, false);
        const style = {};
        if (!json.success) {
            text.lines.push(React.createElement("div", { key: "error_" + Utils.timeStamp(), style: { color: Colors.red } }, json.error));
            refresh(Utils.timeStamp());
            return;
        }
        const prefix = "line_" + Utils.timeStamp() + "_";
        for (let i = 0; i < json.lines.length; i++) {
            let line = json.lines[i];
            const error = line.includes("ERROR");
            text.lines.push(React.createElement("div", { key: prefix + i, style: { color: error ? Colors.red : Colors.text } }, line));
        }
        text.start = json.lastposition;
        refresh(Utils.timeStamp());
    }
    return (React.createElement("div", { id: 'panel_probe_log_files' },
        React.createElement("div", null, text.lines),
        React.createElement("br", null),
        React.createElement("button", { onClick: readNext }, " Next"),
        React.createElement("div", { style: { height: "25px" } }, refreshing ? "Reading..." : "")));
};
const Theme = {
    set: function (style) {
        Data.theme = Data.style = style;
        if (style == "light") {
            Data.dark = Data.darkTheme = false;
            Colors.yellow = "#969c02";
            Colors.gray = "#aaaaaa";
            Colors.background = "#fdfdfd";
            Colors.cellBorder = "#e7e7e7";
        }
        else {
            Data.dark = Data.darkTheme = true;
            Colors.text = "#a8a9b5";
            Colors.background = "#111217";
            Colors.cellBorder = "#2e3136";
        }
    }
};
const UnitListTable = (props) => {
    const [data, setData] = useState(null);
    const [refreshing, setRefreshing] = useState(false);
    let error = null;
    let refreshTimeout = 0;
    const fn = { exited: false };
    function cleanUp() {
        fn.exited = true;
        clearTimeout(refreshTimeout);
    }
    useEffect(() => { loadData(); return cleanUp; }, []);
    function loadData() {
        if (fn.exited)
            return;
        let pdo = Utils.postDataOptions({ op: "list" });
        setRefreshing(true);
        fetch(apiURL + "hosts", pdo).then(res => res.json()).then((result) => {
            if (result.success) {
                error = null;
            }
            else {
                error = result.error;
            }
            Utils.setState(fn, setData, { lastUpdate: Utils.date(), json: result });
        }, (error) => {
            error = error.message;
        }).then(() => {
            refreshTimeout = setTimeout(loadData, 5000);
            setRefreshing(false);
        });
    }
    function pingCell(row) {
        let image = "/images/icons/png/circle_red.png";
        const ping = row.ping;
        if (ping > -1) {
            image = "/images/icons/png/circle_green.png";
        }
        return [React.createElement("img", { key: "img_ping_" + row.id, src: image, width: "14", style: { marginRight: "5px" } }), React.createElement("span", { key: "ping_" + row.id }, " " + ping > -1 ? ping : "")];
    }
    ;
    function formatOS(row) {
        return React.createElement("div", null,
            Utils.OSIconSVG(row.os),
            React.createElement("span", { style: { marginLeft: "5px" } }, row.osname));
    }
    function updateButton(host) {
        if (!host.connected)
            return "";
        return React.createElement(ProbeUpdaterIcon, { id: host.id, name: host.name });
    }
    function removeButton(host) {
        return React.createElement("img", { className: "imagebutton", type: "svg", style: { width: "18px" }, src: "/images/icons/error1.svg", onClick: () => remove(host, ""), title: t("Remove Host") });
    }
    function maintenanceIcon(host) {
        if (!host.mtm)
            return "";
        return React.createElement("img", { src: "/images/icons/maintenance.svg", className: "svg_yellow", width: "22", title: "Maintenance mode is active. This host will not create alerts." });
    }
    function groupNames(gids) {
        if (!gids)
            return "";
        let list = "";
        const parts = gids.split(",");
        for (let i = 0; i < parts.length; i++) {
            list += Data.groupCode(parts[i]) + ",";
        }
        return list;
    }
    function getTable(data) {
        if (!data || !data.json || !data.json.units) {
            return null;
        }
        const tableData = {
            defaultSortField: "id",
            id: "pt",
            headers: [
                { name: "OS", field: "osname", rowFormat: formatOS },
                { name: "IP", field: "ip", filter: {} },
                { name: "Name", field: "name", rowFormat: (host) => { return React.createElement("a", { href: "#unit-details/" + host.id },
                        " ",
                        host.name,
                        " "); }, filter: {} },
                { name: "Description", field: "alias", filter: {} },
                { name: "Ping", field: "ping", rowFormat: pingCell, width: "40px" },
                { name: "Probe", field: "connected", format: Utils.onOffEmpty, center: true, width: "40px" },
                { name: "PV", field: "pv", title: "Probe version", right: true },
                { name: "PU", field: "pu", width: "30px", title: "Probe Update", rowFormat: updateButton, tooltipText: "Probe Update" },
                { name: "M", field: "mtm", rowFormat: maintenanceIcon, width: "15px", title: "Maintenance Mode : If a host is in maintenance mode, it will not create any alerts" },
                { name: "Last Ping", field: "lastActiveSince", format: Utils.timePastShort, tooltip: (host) => Utils.toDate(host.lastActivity) },
                { name: "Uptime", field: "ut", format: Utils.timePastMinutesMS, right: true, title: "Time past from boot (Days:Hours:Minutes)" },
                { name: "SIDs", field: "scode", right: true },
                { name: "GIDs", field: "gids", right: true, rowFormat: (row) => groupNames(row.gids) },
                { name: "CC", field: "cc", title: "Core count", right: true, width: "60px" },
                { name: "CPU", field: "cpu", format: Utils.addPercentage, right: true, width: "60px" },
                { name: "MEM", field: "memory", format: Utils.addPercentage, right: true, width: "60px", title: "Physical Memory" },
                { name: "Swap", field: "swap", format: Utils.addPercentage, right: true, width: "60px" },
                { name: "Type", field: "machine", format: Utils.machineType, right: true, width: "60px" },
                { name: "Env", field: "env", format: Utils.environment, width: "60px", title: "Environment" },
                User.admin && { name: "R", field: "ip", width: "40px", rowFormat: removeButton, tooltipText: "Remove Host", title: "Remove Host" }
            ],
            rows: data.json.units
        };
        return React.createElement(Table, { data: tableData });
    }
    ;
    function back(e) { e.preventDefault(); cleanUp(); Utils.goBack(props.history); }
    function remove(row, data) {
        Utils.go(props.history, "/remove-unit-page/" + row.id);
    }
    let pingingAnimation = "";
    if (refreshing) {
        pingingAnimation = React.createElement("div", { className: "loading_animation" });
    }
    const table = getTable(data);
    const errorDiv = error ? Utils.error(error) : null;
    let lastUpdate = null;
    if (data && data.lastUpdate) {
        lastUpdate = data.lastUpdate;
    }
    return (React.createElement("div", { id: 'page' },
        React.createElement(Header, { back: back, title: t("Servers") }),
        React.createElement("div", { className: "clear" }),
        React.createElement("br", null),
        React.createElement("div", { style: { float: "left", "fontSize": "12px", "color": "#a5a5a5", height: "20px" } },
            t("Last Update Time"),
            ": ",
            lastUpdate,
            " "),
        pingingAnimation,
        React.createElement("div", { className: "clear" }),
        errorDiv,
        table,
        React.createElement("br", null),
        React.createElement("br", null),
        React.createElement("br", null)));
};
const AddUser = (props) => {
    const fn = { closed: useRef(false) };
    const inputName = useRef();
    const inputPassword = useRef();
    const inputFullName = useRef();
    function add() {
        if (fn.closed.current)
            return;
        Request.send({
            caller: fn,
            url: apiURL + "login",
            params: { op: "adduser",
                name: inputName.current.value,
                pass: inputPassword.current.value,
                fullname: inputFullName.current.value
            },
            success: (json) => Info.success("New user is added:" + json.user),
            listener: props.listener
        });
    }
    return (React.createElement("div", { id: 'panel_add_user' },
        React.createElement("table", { className: "informationtable" },
            React.createElement("tbody", null,
                React.createElement("tr", null,
                    React.createElement("td", null, "Full Name"),
                    React.createElement("td", null,
                        " ",
                        React.createElement("input", { type: "text", ref: inputFullName }),
                        " ")),
                React.createElement("tr", null,
                    React.createElement("td", null, "Username"),
                    React.createElement("td", null,
                        " ",
                        React.createElement("input", { type: "text", ref: inputName }),
                        " ")),
                React.createElement("tr", null,
                    React.createElement("td", null, "Password"),
                    React.createElement("td", null,
                        " ",
                        React.createElement("input", { type: "text", ref: inputPassword }),
                        " ")),
                React.createElement("tr", null,
                    React.createElement("td", null),
                    React.createElement("td", null,
                        React.createElement("button", { onClick: add }, "Add")))))));
};
const Login = (props) => {
    const [error, setError] = useState(null);
    const [checked, setChecked] = useState(false);
    const inputUser = createRef();
    const inputPassword = createRef();
    const fn = { closed: useRef(false) };
    function cleanUp() { fn.closed.current = true; }
    useEffect(() => { fn.closed.current = false; checkLogin(props.listener); return cleanUp; }, [props]);
    function checkLogin(listener) {
        let pdo = Utils.postDataOptions({ op: "check" });
        fetch(apiURL + "login", pdo).then(res => res.json()).then((result) => {
            if (result.success) {
                setUser(result);
                listener(true);
            }
            else {
                setChecked(true);
            }
        }, (error) => {
            Info.error("Login Check Error:" + error.message);
            setChecked(true);
        });
    }
    function setUser(json) {
        User.id = json.userid;
        User.name = json.username;
        User.admin = json.admin || json.super;
        User.type = json.type;
        User.super = json.super;
        if (User.super) {
            User.admin = true;
        }
        if (SysRanger.remote) {
            User.admin = User.super = false;
        }
        Data.admin = User.admin;
        Data.super = User.super;
        const permissions = json.permissions.split(",");
        for (let i = 0; i < permissions.length; i++) {
            let permission = permissions[i];
            if (!permission)
                continue;
            permission = permission.trim();
            User.permissions[permission] = true;
        }
    }
    function login() {
        if (fn.closed.current)
            return;
        Utils.setState(fn, setError, null);
        let pdo = Utils.postDataOptions({ op: "login", user: inputUser.current.value, pass: inputPassword.current.value });
        fetch(apiURL + "login", pdo).then(res => res.json()).then((result) => {
            if (result.success) {
                setUser(result);
                props.listener(true);
            }
            else {
                Utils.setState(fn, setError, result.error);
            }
        }, (error) => {
            Utils.setState(fn, setError, error.message);
        });
    }
    function logout(e) {
        e.preventDefault();
        const options = { op: "logout" };
        const pdo = Utils.postDataOptions(options);
        fetch(SysRanger.baseURL + "/index.php", pdo)
            .then(response => response.json())
            .then((result) => {
            console.log(result);
            if (result.success) {
                SysRanger.token = "";
                SysRanger.userID = 0;
                SysRanger.companyID = 0;
                window.location.href = SysRanger.baseURL;
                window.location.reload();
                return;
            }
            else {
                Info.error(result.error);
            }
        }, (error) => {
            Info.error(error.message);
        });
    }
    if (!checked) {
        return (React.createElement("div", null, "..."));
    }
    return (React.createElement("div", { id: 'login_page', style: { textAlign: "center" } },
        React.createElement("div", { style: { paddingTop: "30px" } },
            React.createElement("img", { src: "images/logo_white.png", width: "195" }),
            React.createElement("br", null),
            React.createElement("br", null),
            React.createElement("br", null),
            "Username\t",
            React.createElement("br", null),
            React.createElement("input", { type: 'text', ref: inputUser }),
            React.createElement("br", null),
            "Password",
            React.createElement("br", null),
            React.createElement("input", { type: 'password', ref: inputPassword }),
            React.createElement("br", null),
            React.createElement("br", null),
            React.createElement("button", { onClick: login }, "Login "),
            React.createElement("br", null),
            React.createElement("div", { style: { color: "#ff0000" } }, error && error),
            React.createElement("br", null),
            SysRanger.remote && React.createElement("a", { href: "#", onClick: logout }, "Logout"))));
};
const Logout = (props) => {
    const fn = { closed: useRef(false) };
    function logout() {
        if (!confirm(t("Are you sure you want to logout ?"))) {
            return;
        }
        Request.send({
            caller: fn,
            url: apiURL + "login",
            params: { op: "logout" },
            success: () => {
                Utils.reload();
            }
        });
    }
    return (React.createElement("div", null,
        React.createElement("button", { onClick: logout },
            " ",
            t("Logout") + " " + User.name,
            " ")));
};
const User = {
    id: 0,
    name: "",
    admin: false,
    super: false,
    type: 1,
    permissions: {},
    allowed: function (op) {
        if (User.super)
            return true;
        return User.permissions[op] ? true : false;
    }
};
const UserDetails = (props) => {
    const [page, setPage] = useState(null);
    const fn = { closed: useRef(false) };
    const UID = props.match.params.id;
    function cleanUp() {
        fn.closed.current = true;
    }
    function back(e) {
        e.preventDefault();
        Utils.goBack(props.history, "/#users");
    }
    useEffect(() => { fn.closed.current = false; loadData(); return cleanUp; }, [props]);
    function loadData() {
        if (fn.closed.current)
            return;
        Request.send({ caller: fn, url: apiURL + "login", params: { op: "details", id: UID },
            listener: (json) => Utils.setState(fn, setPage, parse(json))
        });
    }
    function userType(type) {
        if (type == 1)
            return "Guest";
        if (type == 20)
            return "Admin";
        if (type == 99)
            return "Super";
        return "Unknown";
    }
    function parse(json) {
        if (!json.success) {
            return Utils.error(json.error);
        }
        const div = React.createElement("div", null,
            React.createElement("table", null,
                React.createElement("tbody", null,
                    React.createElement("tr", null,
                        React.createElement("td", null, "User:"),
                        React.createElement("td", null,
                            " ",
                            json.name,
                            " ")),
                    React.createElement("tr", null,
                        React.createElement("td", null, "Name:"),
                        React.createElement("td", null,
                            " ",
                            json.fullname,
                            " ")),
                    React.createElement("tr", null,
                        React.createElement("td", null, "Type:"),
                        React.createElement("td", null,
                            " ",
                            userType(json.type),
                            " ")),
                    React.createElement("tr", null,
                        React.createElement("td", null, "Last Login:"),
                        React.createElement("td", null,
                            " ",
                            Utils.toDate(json.lastlogin),
                            " ")))));
        return div;
    }
    return (React.createElement("div", { id: 'page' },
        React.createElement(Header, { back: back, title: t("User Details") }),
        React.createElement("div", { className: "panel" }, page),
        React.createElement("div", { className: "panel" },
            React.createElement("div", { className: "panel_title" }, "Permissions"),
            React.createElement(UserPermissions, { userid: UID })),
        React.createElement("div", { className: "panel" },
            React.createElement("div", { className: "panel_title" }, "Groups"),
            React.createElement(UserGroups, { userid: UID }))));
};
const UserGroups = (props) => {
    const [page, setPage] = useState(null);
    const fn = { closed: useRef(false) };
    const UID = props.userid;
    function cleanUp() {
        fn.closed.current = true;
    }
    useEffect(() => { fn.closed.current = false; loadData(); return cleanUp; }, [props]);
    function loadData() {
        if (fn.closed.current)
            return;
        Request.send({ caller: fn, url: apiURL + "userrights", params: { op: "listgroups", userid: UID },
            listener: (json) => Utils.setState(fn, setPage, parse(json))
        });
    }
    function update() {
        setTimeout(loadData, 10);
    }
    function enable(e) {
        e.preventDefault();
        e.stopPropagation();
        const chk = e.currentTarget;
        const gid = chk.getAttribute('gid');
        Request.send({ caller: fn,
            url: apiURL + "userrights",
            params: { op: "setgroup", userid: UID, gid: gid, enabled: chk.checked ? 1 : 0 },
            success: (json) => Info.success(json.message),
            listener: update
        });
    }
    function parse(json) {
        if (!json.success) {
            return Utils.error(json.error);
        }
        const containers = [];
        const groups = json.groups;
        for (let i = 0; i < groups.length; i++) {
            const group = groups[i];
            const box = React.createElement("div", { key: "usergroup_" + i },
                React.createElement("input", { type: "checkbox", checked: group.en, onChange: enable, gid: group.id }),
                group.cd,
                " (",
                group.nm,
                ")");
            if (i % 5 == 0) {
                containers.push({ boxes: [] });
            }
            containers[containers.length - 1].boxes.push(box);
        }
        const divs = [];
        for (let i = 0; i < containers.length; i++) {
            const div = React.createElement("div", { key: "upg_" + i, style: { float: "left", textAlign: "left", padding: "10px" } }, containers[i].boxes);
            divs.push(div);
        }
        return divs;
    }
    return (React.createElement("div", { id: 'panel_user_groups' }, page));
};
const UserPage = (props) => {
    const [page, setPage] = useState(null);
    const fn = { closed: useRef(false) };
    const UID = props.match.params.id;
    function cleanUp() {
        fn.closed.current = true;
    }
    function back(e) {
        e.preventDefault();
        Utils.goBack(props.history, "/#dashboard");
    }
    useEffect(() => { fn.closed.current = false; loadData(); return cleanUp; }, [props]);
    function loadData() {
        if (fn.closed.current)
            return;
        Request.send({ caller: fn, url: apiURL + "login", params: { op: "self" },
            listener: (json) => Utils.setState(fn, setPage, parse(json))
        });
    }
    function userType(type) {
        if (type == 1)
            return "Guest";
        if (type == 20)
            return "Admin";
        if (type == 99)
            return "Super";
        return "Unknown";
    }
    function parse(json) {
        if (!json.success) {
            return Utils.error(json.error);
        }
        let logout = null;
        if (!SysRanger.demo) {
            if (SysRanger.remote) {
                logout = React.createElement(RemoteLogout, null);
            }
            else {
                logout = React.createElement(Logout, null);
            }
        }
        const div = React.createElement("div", null,
            React.createElement("table", null,
                React.createElement("tbody", null,
                    React.createElement("tr", null,
                        React.createElement("td", null, "User:"),
                        React.createElement("td", null,
                            " ",
                            json.name,
                            " ")),
                    React.createElement("tr", null,
                        React.createElement("td", null, "Name:"),
                        React.createElement("td", null,
                            " ",
                            json.fullname,
                            " ")),
                    React.createElement("tr", null,
                        React.createElement("td", null, "Type:"),
                        React.createElement("td", null,
                            " ",
                            userType(json.type),
                            " ")))),
            React.createElement("br", null),
            React.createElement("br", null),
            React.createElement("br", null),
            logout);
        return div;
    }
    return (React.createElement("div", { id: 'page' },
        React.createElement(Header, { back: back, title: t("User Details") }),
        React.createElement("div", { className: "panel" }, page)));
};
const UserPassword = (props) => {
    const inputPassword = useRef();
    const fn = { closed: useRef(false) };
    const user = props.user;
    const id = props.id;
    function cleanUp() { fn.closed.current = true; }
    useEffect(() => { fn.closed.current = false; return cleanUp; }, [props]);
    function change() {
        if (fn.closed.current)
            return;
        Request.send({
            caller: fn,
            url: apiURL + "login",
            params: { op: "setpassword", id: id, user: user, password: inputPassword.current.value },
            success: (json) => Info.success("Password is changed for user:" + json.user)
        });
    }
    return (React.createElement("div", null,
        React.createElement("input", { style: { width: "calc(100% - 80px)" }, type: 'password', id: "input_user_pass_" + id, ref: inputPassword }),
        React.createElement("button", { onClick: change, className: "cellbutton", style: { width: "40px" } }, "Set")));
};
const UserPermissions = (props) => {
    const [page, setPage] = useState(null);
    const fn = { closed: useRef(false) };
    const UID = props.userid;
    function cleanUp() {
        fn.closed.current = true;
    }
    useEffect(() => { fn.closed.current = false; loadData(); return cleanUp; }, [props]);
    function loadData() {
        if (fn.closed.current)
            return;
        Request.send({ caller: fn, url: apiURL + "userrights", params: { op: "list", userid: UID },
            listener: (json) => Utils.setState(fn, setPage, parse(json))
        });
    }
    function update() {
        setTimeout(loadData, 10);
    }
    function enable(e) {
        e.preventDefault();
        e.stopPropagation();
        const chk = e.currentTarget;
        const permission = chk.getAttribute('permission');
        Request.send({ caller: fn,
            url: apiURL + "userrights",
            params: { op: "set", userid: UID, permission: permission, enabled: chk.checked ? 1 : 0 },
            success: (json) => Info.success(json.message),
            listener: update
        });
    }
    function parse(json) {
        if (!json.success) {
            return Utils.error(json.error);
        }
        const groups = [];
        const permissions = json.permissions;
        for (let i = 0; i < permissions.length; i++) {
            const permission = permissions[i];
            const label = permission.nm.replaceAll("_", " ").toLowerCase();
            const box = React.createElement("div", { key: "userpermission_" + i, style: { textTransform: "capitalize" } },
                React.createElement("input", { type: "checkbox", checked: permission.en, onChange: enable, permission: permission.nm }),
                label);
            if (i % 5 == 0) {
                groups.push({ boxes: [] });
            }
            groups[groups.length - 1].boxes.push(box);
        }
        const divs = [];
        for (let i = 0; i < groups.length; i++) {
            const div = React.createElement("div", { key: "upg_" + i, style: { float: "left", textAlign: "left", padding: "10px" } }, groups[i].boxes);
            divs.push(div);
        }
        return divs;
    }
    return (React.createElement("div", { id: 'panel_user_permissons' }, page));
};
const Users = (props) => {
    const [page, setPage] = useState(null);
    const fn = { closed: useRef(false) };
    function cleanUp() {
        fn.closed.current = true;
    }
    function back(e) {
        e.preventDefault();
        Utils.goBack(props.history, "/#settings");
    }
    useEffect(() => { fn.closed.current = false; loadData(); return cleanUp; }, [props]);
    function loadData() {
        if (fn.closed.current)
            return;
        Request.send({ caller: fn, url: apiURL + "login", params: { op: "users" },
            listener: (json) => Utils.setState(fn, setPage, parse(json))
        });
    }
    function update() {
        setTimeout(loadData, 10);
    }
    function setPasswordButton(user) {
        return React.createElement(UserPassword, { id: user.id, user: user.user });
    }
    function remove(row) {
        if (fn.closed.current)
            return;
        if (!confirm("Are you sure you want to remove " + row.user + "?"))
            return;
        Request.send({
            caller: fn,
            url: apiURL + "login",
            params: { op: "removeuser",
                name: row.user,
                id: row.id
            },
            success: (json) => Info.success("User removed:" + json.name),
            listener: update
        });
    }
    function setAdmin(e) {
        e.preventDefault();
        e.stopPropagation();
        const chk = e.currentTarget;
        const id = chk.getAttribute('uid');
        const name = chk.getAttribute('uname');
        if (!confirm("Are you sure you want to set " + name + " as admin user ?"))
            return;
        Request.send({ caller: fn,
            url: apiURL + "login",
            params: { op: "setadmin", id: id, name: name, admin: chk.checked ? 1 : 0 },
            success: (json) => Info.success(json.name + " admin rights has changed"),
            listener: update
        });
    }
    function userType(type) {
        if (type == 1)
            return "Guest";
        if (type == 20)
            return "Admin";
        if (type == 99)
            return "Super";
        return "Unknown";
    }
    function parse(json) {
        if (!json.success) {
            return Utils.error(json.error);
        }
        const users = json.rows;
        for (let i = 0; i < users.length; i++) {
            const user = users[i];
            if (user.type == 99)
                continue;
            user.admin = user.type == 20;
            user.chk = React.createElement("input", { type: "checkbox", checked: user.admin, onChange: setAdmin, uid: user.id, uname: user.user });
        }
        const data = {
            defaultSortField: "user",
            id: "tableusers",
            headers: [
                { name: "User", field: "user", onClick: (row) => { Utils.go(null, "#userdetails/" + row.id); } },
                { name: "Full Name", field: "fullname" },
                { name: "Type", field: "type", format: userType },
                { name: "Last Login", field: "lastlogin", format: Utils.toDate },
                { name: "Password", field: "pc", rowFormat: setPasswordButton, width: "200px" },
                { name: "Admin", field: "admin", html: "chk", width: "40px", title: "Admin" },
                { name: "Remove", field: "id", onClick: remove, width: "40px", icon: "remove.svg", hide: (user) => user.type == 99 }
            ],
            rows: users
        };
        return React.createElement(Table, { data: data });
    }
    return (React.createElement("div", { id: 'page' },
        React.createElement(Header, { back: back, title: t("Users") }),
        React.createElement("div", { className: "panel" },
            React.createElement("div", { className: "panel_title" }, "Users"),
            page),
        React.createElement("div", { className: "clear", style: { height: "30px" } }),
        React.createElement("div", { className: "panel", style: { width: "280px", margin: "auto", float: "none" } },
            React.createElement("div", { className: "panel_title" }, "Add new user"),
            React.createElement(AddUser, { listener: update }))));
};
const UserSettings = {};
UserSettings.settings = {};
UserSettings.get = function (key) {
    const value = UserSettings.settings[key];
    if (value == undefined)
        return "";
    return value;
};
UserSettings.set = function (key, value) {
    if (typeof value == "boolean") {
        value = value ? "true" : "false";
    }
    UserSettings.settings[key] = value;
    if (SysRanger.demo)
        return;
    Request.send({
        url: apiURL + "usersettings",
        params: { op: "set", key: key, value: value }
    });
};
UserSettings.getBoolean = function (key) {
    const strVal = UserSettings.get(key);
    const value = strVal === "true";
    return value;
};
UserSettings.getInt = function (key) {
    const strVal = UserSettings.get(key);
    return Utils.toInt(strVal);
};
UserSettings.readAll = function (callback) {
    Request.send({
        url: apiURL + "usersettings",
        params: { op: "getall" },
        listener: (json) => {
            if (!json.success)
                return callback(false);
            for (let i = 0; i < json.rows.length; i++) {
                const setting = json.rows[i];
                UserSettings.settings[setting.key] = setting.value;
            }
            callback(true);
            console.log(UserSettings.settings);
        }
    });
};
const Utils = {
    nextID: 0,
    isInteger: function (value) {
        return !isNaN(value) &&
            parseInt(Number(value)) == value &&
            !isNaN(parseInt(value, 10));
    },
    toInt: function (value) {
        if (isNaN(value))
            return 0;
        const int = parseInt(Number(value));
        if (isNaN(int))
            return 0;
        return int;
    },
    contains(text, search) {
        return text.indexOf(search) !== -1;
    },
    containsCIS: function (text, search) {
        if (!search)
            return true;
        if (!text)
            return false;
        const textLower = text.toLowerCase();
        const searchLower = search.toLowerCase();
        return textLower.indexOf(searchLower) !== -1;
    },
    postDataOptions: function (params) {
        if (SysRanger.remote) {
            params.userID = SysRanger.userID;
            params.token = SysRanger.token;
            params.companyID = SysRanger.companyID;
        }
        let paramsConverted = new URLSearchParams(params);
        const requestOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
            },
            body: paramsConverted
        };
        return requestOptions;
    },
    timeStamp: function () {
        return Date.now();
    },
    id: function () {
        return Utils.nextID++;
    },
    sort: function (array, key) {
        array.sort(function (a, b) {
            const val1 = a[key];
            const val2 = b[key];
            if (val1 < val2)
                return -1;
            if (val1 > val2)
                return 1;
            return 0;
        });
    },
    BYTE_UNITS: [" B", "kB", "MB", "GB", "TB"],
    bytesToUnit: function (valueInBytes) {
        let value = Utils.toInt(valueInBytes);
        if (value <= 0) {
            return "-";
        }
        let unitsIndex = 0;
        while (value > 1024 && unitsIndex < Utils.BYTE_UNITS.length - 1) {
            value /= 1024;
            unitsIndex++;
        }
        return value.toFixed(unitsIndex < 1 ? 0 : 2) + " " + Utils.BYTE_UNITS[unitsIndex];
    },
    GB: function (bytes) {
        const gb = bytes / (1024 * 1024 * 1024);
        return gb.toFixed(2);
    },
    random: function () {
        return Math.floor(Math.random() * Number.MAX_SAFE_INTEGER);
    },
    key: function () {
        return Date.now() + "_" + Math.floor(Math.random() * Number.MAX_SAFE_INTEGER);
    },
    randomInt: function (min, max) {
        const range = max - min;
        return min + Math.floor(Math.random() * range);
    },
    percentage: function (value) {
        if (!value)
            return "-";
        if (typeof value !== 'number')
            return "-";
        return value.toFixed(2) + " %";
    },
    cellPercentage(value) {
        if (!value)
            return "-";
        value = Number(value);
        if (isNaN(value))
            return "-";
        if (value == 0)
            return "";
        return value.toFixed(2);
    },
    addPercentage: function (value) {
        return value + " %";
    },
    windowsEventType: function (type) {
        switch (type) {
            case 0:
            case "Error": return React.createElement("div", null,
                React.createElement("img", { src: 'images/icons/png/critical.png', width: "12" }),
                React.createElement("span", { style: { color: Colors.orange, paddingBottom: "5px" } },
                    " ",
                    t("Critical")));
            case 1:
            case "Error": return React.createElement("div", null,
                React.createElement("img", { src: 'images/icons/png/error.png', width: "12" }),
                React.createElement("span", { style: { color: Colors.red, paddingBottom: "5px" } },
                    " ",
                    t("Error")));
            case 2:
            case "Warning": return React.createElement("div", null,
                React.createElement("img", { src: 'images/icons/png/warning.png', width: "12" }),
                React.createElement("span", { style: { color: Colors.yellow } },
                    " ",
                    t("Warning")));
            case 8: return t("Audit Success");
            case 10: return "Audit Failure";
        }
        return React.createElement("div", null,
            React.createElement("img", { src: 'images/icons/png/info.png' }),
            React.createElement("span", { style: { color: "#909090" } },
                " ",
                t("Information")));
    },
    connected: function (value) {
        return value ? t("connected") : t("disconnected");
    },
    activeOrEmpty: function (value) {
        return value ? t("active") : "";
    },
    cellColor: function (value) {
        if (!value)
            return Colors.lightRed;
        return Colors.lightGreen;
    },
    yesno: function (value) {
        if (value) {
            return React.createElement("span", { style: { color: Colors.green } }, t("Yes"));
        }
        return React.createElement("span", { style: { color: Colors.red } }, t("No"));
    },
    available: function (value) {
        if (value) {
            return React.createElement("span", { style: { color: Colors.green } }, t("Available"));
        }
        return React.createElement("span", { style: { color: Colors.red } }, t("Not available"));
    },
    R3Status: function (value) {
        switch (value) {
            case 1: return React.createElement("span", { style: { color: Colors.green } }, t("Success"));
            case 2: return React.createElement("span", { style: { color: Colors.red } }, t("Error"));
        }
        return React.createElement("span", { style: { color: Colors.red } }, t("Unknown"));
    },
    status: function (value) {
        if (value)
            return t("Running");
        return "";
    },
    colored: function (value, text) {
        if (value) {
            return React.createElement("span", { style: { color: Colors.green } }, text);
        }
        return React.createElement("span", { style: { color: Colors.red } }, text);
    },
    SAPJobStatus: function (value) {
        return SAPJobStatusCodes[value] ? SAPJobStatusCodes[value] : value;
    },
    emphasizeAsterix: function (row) {
        const index = row["ai"];
        let port = row["port"] + "";
        if (index < 0)
            return port;
        let result = React.createElement("span", null,
            port.substring(0, index),
            React.createElement("strong", null, port.substring(index, index + 2)),
            port.substring(index + 2, port.length));
        return result;
    },
    toDateMS: function (timeStamp) {
        if (!timeStamp) {
            return "-";
        }
        timeStamp *= 1000;
        let date = new Date(timeStamp);
        let year = date.getFullYear();
        let month = date.getMonth() + 1;
        let day = date.getDate();
        let hours = date.getHours();
        let minutes = date.getMinutes();
        let seconds = date.getSeconds();
        if (month < 10)
            month = "0" + month;
        if (day < 10)
            day = "0" + day;
        if (hours < 10)
            hours = "0" + hours;
        if (minutes < 10)
            minutes = "0" + minutes;
        if (seconds < 10)
            seconds = "0" + seconds;
        return year + "." + month + "." + day + " - " + hours + ":" + minutes + ":" + seconds;
    },
    toDateNL: function (timeStamp) {
        if (!timeStamp) {
            return "-";
        }
        var date = new Date(timeStamp);
        var year = date.getFullYear();
        var month = date.getMonth() + 1;
        var day = date.getDate();
        var hours = date.getHours();
        var minutes = date.getMinutes();
        var seconds = date.getSeconds();
        if (month < 10)
            month = "0" + month;
        if (day < 10)
            day = "0" + day;
        if (hours < 10)
            hours = "0" + hours;
        if (minutes < 10)
            minutes = "0" + minutes;
        if (seconds < 10)
            seconds = "0" + seconds;
        return year + "." + month + "." + day + "\n" + hours + ":" + minutes + ":" + seconds;
    },
    toDate: function (timeStamp) {
        if (!timeStamp || timeStamp < 1) {
            return "-";
        }
        var date = new Date(timeStamp);
        var year = date.getFullYear();
        var month = date.getMonth() + 1;
        var day = date.getDate();
        var hours = date.getHours();
        var minutes = date.getMinutes();
        var seconds = date.getSeconds();
        if (month < 10)
            month = "0" + month;
        if (day < 10)
            day = "0" + day;
        if (hours < 10)
            hours = "0" + hours;
        if (minutes < 10)
            minutes = "0" + minutes;
        if (seconds < 10)
            seconds = "0" + seconds;
        return year + "." + month + "." + day + "-" + hours + ":" + minutes + ":" + seconds;
    },
    minutesPast: function (seconds) {
        if (seconds > 86400) {
            return Math.floor(seconds / 86400) + " " + t("days ago");
        }
        if (seconds > 3600) {
            return Math.floor(seconds / 3600) + " " + t("hours ago");
        }
        if (seconds > 60) {
            const minutes = Math.floor(seconds / 60);
            if (minutes > 1)
                return minutes + " " + t("minutes ago");
            return minutes + " " + t("minute ago");
        }
        return seconds + " seconds";
    },
    secondToDay: function (seconds) {
        if (!seconds || seconds < 0) {
            return "-";
        }
        return Math.floor(seconds / 86400) + " " + t("days");
    },
    timePast: function (seconds) {
        if (seconds > 86400) {
            return Math.floor(seconds / 86400) + " " + t("days");
        }
        if (seconds > 3600) {
            return Math.floor(seconds / 3600) + " " + t("hours");
        }
        if (seconds > 60) {
            return Math.floor(seconds / 60) + " " + t("minutes");
        }
        if (seconds > 0) {
            return Math.floor(seconds) + " " + t("seconds");
        }
        return "-";
    },
    timePastMS: function (miliseconds) {
        return Utils.timePast(miliseconds / 1000);
    },
    timePastWithDays: function (seconds) {
        if (seconds === 0 || seconds == "0")
            return "00:00:00";
        if (!seconds) {
            return "-";
        }
        let str = "";
        const days = Math.floor(seconds / Time.SC_DAY);
        seconds -= days * Time.SC_DAY;
        const h = Math.floor(seconds / Time.SC_HOUR);
        seconds -= h * Time.SC_HOUR;
        const m = Math.floor(seconds / Time.SC_MINUTE);
        seconds -= m * Time.SC_MINUTE;
        const s = seconds;
        if (days > 0)
            str = days + " " + t("days") + " ";
        str += (h < 10 ? '0' + h : h) + ":";
        str += (m < 10 ? '0' + m : m) + ":";
        str += (s < 10 ? '0' + s : s);
        return str;
    },
    timePastMinutesMS: function (ms) {
        if (ms === 0 || ms == "0")
            return "00:00:00";
        if (!ms)
            return "-";
        let seconds = Math.floor(ms / 1000);
        let str = "";
        const days = Math.floor(seconds / Time.SC_DAY);
        seconds -= days * Time.SC_DAY;
        const h = Math.floor(seconds / Time.SC_HOUR);
        seconds -= h * Time.SC_HOUR;
        const m = Math.floor(seconds / Time.SC_MINUTE);
        seconds -= m * Time.SC_MINUTE;
        const s = seconds;
        if (days > 0)
            str = days + ":";
        str += (h < 10 ? '0' + h : h) + ":";
        str += (m < 10 ? '0' + m : m);
        return str;
    },
    timePastShort(seconds) {
        if (!seconds)
            return "";
        if (seconds < 60)
            return (seconds < 10 ? "0" + seconds : seconds) + " s";
        if (seconds > 86400) {
            return Math.floor(seconds / 86400) + "d";
        }
        if (seconds > 3600) {
            return Math.floor(seconds / 3600) + "h";
        }
        return Math.floor(seconds / 60) + "m";
    },
    timePastShortMS(ms) {
        const seconds = Math.floor(ms / 1000);
        if (seconds < 60)
            return (seconds < 10 ? "0" + seconds : seconds) + " s";
        if (seconds > 86400) {
            return Math.floor(seconds / 86400) + " d";
        }
        if (seconds > 3600) {
            return Math.floor(seconds / 3600) + " h";
        }
        return Math.floor(seconds / 60) + " m";
    },
    toDay: function (timeStamp) {
        if (!timeStamp) {
            return "-";
        }
        var date = new Date(timeStamp);
        var year = date.getFullYear();
        var month = date.getMonth() + 1;
        var day = date.getDate();
        if (month < 10)
            month = "0" + month;
        if (day < 10)
            day = "0" + day;
        return year + "/" + month + "/" + day;
    },
    toDaySec: function (timeStamp) {
        if (!timeStamp) {
            return "-";
        }
        timeStamp *= 1000;
        var date = new Date(timeStamp);
        var year = date.getFullYear();
        var month = date.getMonth() + 1;
        var day = date.getDate();
        if (month < 10)
            month = "0" + month;
        if (day < 10)
            day = "0" + day;
        return year + "/" + month + "/" + day;
    },
    ISOFormatDay: function (date) {
        var year = date.getFullYear();
        var month = date.getMonth() + 1;
        var day = date.getDate();
        if (month < 10)
            month = "0" + month;
        if (day < 10)
            day = "0" + day;
        return year + "-" + month + "-" + day;
    },
    ISOFormatDateTime: function (date) {
        var year = date.getFullYear();
        var month = date.getMonth() + 1;
        var day = date.getDate();
        let hours = date.getHours();
        let minutes = date.getMinutes();
        if (month < 10)
            month = "0" + month;
        if (day < 10)
            day = "0" + day;
        if (hours < 10)
            hours = "0" + hours;
        if (minutes < 10)
            minutes = "0" + minutes;
        return year + "-" + month + "-" + day + "T" + hours + ":" + minutes;
    },
    date: function () {
        return new Date().toLocaleString();
    },
    time: function () {
        var date = new Date();
        var hours = date.getHours();
        var minutes = date.getMinutes();
        var seconds = date.getSeconds();
        if (hours < 10)
            hours = "0" + hours;
        if (minutes < 10)
            minutes = "0" + minutes;
        if (seconds < 10)
            seconds = "0" + seconds;
        return hours + ":" + minutes + ":" + seconds;
    },
    timeSAP: function (val) {
        if (!val)
            return val;
        val = val + "";
        if (val.length < 14)
            return val;
        return val.substr(0, 4) + "-" + val.substr(4, 2) + "-" + val.substr(6, 2) + " " +
            val.substr(8, 2) + ":" + val.substr(10, 2) + ":" + val.substr(12, 2);
    },
    daySAP: function (val) {
        if (!val)
            return val;
        if (typeof val !== 'string')
            val = val + "";
        if (val.length < 8)
            return val;
        return val.substr(0, 4) + "-" + val.substr(4, 2) + "-" + val.substr(6, 2);
    },
    dateSAP: function (val) {
        if (!val)
            return null;
        if (val.length < 14)
            return null;
        const str = val.substr(0, 4) + "-" + val.substr(4, 2) + "-" + val.substr(6, 2) + "T" +
            val.substr(8, 2) + ":" + val.substr(10, 2) + ":" + val.substr(12, 2) + "";
        return new Date(str);
    },
    number: function (val) {
        const num = Number(val);
        return num.toLocaleString();
    },
    numberFixed1: function (val) {
        const num = Number(val);
        return num.toLocaleString("tr-TR", { minimumFractionDigits: 1, maximumFractionDigits: 1 });
    },
    numberFixed0: function (val) {
        const num = Number(val);
        if (isNaN(num))
            return "0";
        return num.toLocaleString("tr-TR", { maximumFractionDigits: 0 });
    },
    error: function (message) {
        if (message == null)
            return React.createElement("div", { className: "errorbar" },
                " ",
                t("Unknown error"));
        return React.createElement("div", { className: "errorbar" },
            " ",
            t(message));
    },
    noOp: function (e) {
    },
    loading: function () {
        return React.createElement("div", null,
            React.createElement("div", { className: "loading_animation" }),
            React.createElement("span", { style: { marginLeft: "10px" } }, t("Loading...")));
    },
    updating: function () {
        return React.createElement("div", { className: "loading_animation" });
    },
    buttonUpdating: function () {
        return React.createElement("div", { className: "loading_animation" });
    },
    setState: function (caller, func, values) {
        if (caller.exited || (caller.closed && caller.closed.current))
            return false;
        func(values);
        return true;
    },
    removeZero: function (val) {
        return val ? val : "";
    },
    switchArrayItems: function (array, field, value1, value2) {
        let index1 = 0;
        let index2 = 0;
        for (let i = 0; i < array.length; i++) {
            const test = array[i][field];
            if (test == value1) {
                index1 = i;
            }
            if (test == value2) {
                index2 = i;
            }
        }
        if (index1 == index2)
            return;
        const temp = array[index1];
        array[index1] = array[index2];
        array[index2] = temp;
    },
    getObjectFromArray: function (array, key, value) {
        for (let i = 0; i < array.length; i++) {
            const item = array[i];
            if (item[key] == value) {
                return item;
            }
        }
        return null;
    },
    merge: function (obj1, obj2) {
        if (!obj1 || !obj2)
            return;
        for (var attrname in obj2) {
            obj1[attrname] = obj2[attrname];
        }
        return obj1;
    },
    endsWith: function (str, suffix) {
        return str.indexOf(suffix, str.length - suffix.length) !== -1;
    },
    nl2br: function (str) {
        str = str.replace(/\n/g, "<br/>");
        str.replace("<br/><br/>", "<br/>");
        return str;
    },
    nl2List: function (str, key) {
        const lines = str.split(/\r?\n/);
        const divs = [];
        if (!key)
            key = "multiline_div";
        for (let i = 0; i < lines.length; i++) {
            const line = lines[i];
            const div = React.createElement("div", { key: key + "_" + i }, line);
            divs.push(div);
        }
        return divs;
    },
    stateImage: function (val) {
        let image = "/images/icons/png/alert_gray.png";
        switch (val) {
            case 1:
                image = "/images/icons/png/alert_green.png";
                break;
            case 2:
                image = "/images/icons/png/alert_yellow.png";
                break;
            case 3:
                image = "/images/icons/png/alert_red.png";
                break;
        }
        return React.createElement("img", { src: image, width: "24" });
    },
    stateImageCircle: function (val) {
        let image = "/images/icons/png/circle_gray.png";
        switch (val) {
            case 1:
                image = "/images/icons/png/circle_green.png";
                break;
            case 2:
                image = "/images/icons/png/circle_yellow.png";
                break;
            case 3:
                image = "/images/icons/png/circle_red.png";
                break;
        }
        return React.createElement("img", { src: image });
    },
    onOff: function (val) {
        let image = "/images/icons/png/circle_red.png";
        if (val) {
            image = "/images/icons/png/circle_green.png";
        }
        return React.createElement("img", { src: image, width: "14" });
    },
    onOrEmpty: function (val) {
        if (val)
            return React.createElement("img", { src: "/images/icons/png/circle_green.png", width: "14" });
        return "";
    },
    VCStatus: function (val) {
        let image = "/images/icons/png/circle_gray.png";
        switch (val) {
            case "GREEN":
            case "green":
                image = "/images/icons/png/circle_green.png";
                break;
            case "YELLOW":
            case "yellow":
                image = "/images/icons/png/circle_yellow.png";
                break;
            case "RED":
            case "red":
                image = "/images/icons/png/circle_red.png";
                break;
        }
        return React.createElement("img", { src: image, width: "24" });
    },
    VCConnectionColor: function (val) {
        console.log("VCConnectionColor:" + val);
        switch (val) {
            case "CONNECTED":
            case "connected":
            case "running":
            case "RUNNING":
                return Colors.green;
        }
        return Colors.red;
    },
    VCPower: function (val) {
        let image = "/images/icons/png/circle_red.png";
        switch (val) {
            case "POWERED_ON":
                image = "/images/icons/png/circle_green.png";
                break;
        }
        return React.createElement("img", { src: image, width: "24" });
    },
    onOffEmpty: function (val) {
        if (val == 1)
            return React.createElement("img", { src: "/images/icons/png/circle_green.png", width: "14" });
        if (val == 2)
            return React.createElement("img", { src: "/images/icons/png/circle_red.png", width: "14" });
        return "";
    },
    OSIconSVG: function (val, style) {
        switch (val) {
            case 1: return React.createElement("img", { type: "svg", src: "images/icons/os_win.svg", width: "14", style: style });
            case 2: return React.createElement("img", { type: "svg", src: "images/icons/os_linux.svg", width: "14", style: style });
        }
        return React.createElement("img", { type: "svg", src: "images/icons/os_unknown.svg", width: "14" });
    },
    alertSVGClass: function (type) {
        switch (type) {
            case 1: return "svg_gray";
            case 2: return "svg_yellow";
            case 3: return "svg_orange";
            case 4: return "svg_red";
        }
        return "svg_green";
    },
    onOffColor: function (val) {
        return val ? Colors.green : Colors.red;
    },
    stateColor: function (val) {
        switch (val) {
            case 1: return Colors.green;
            case 2: return Colors.warning;
            case 3: return Colors.red;
        }
        return Colors.text;
    },
    reload: function () {
        location.reload();
    },
    goBack: function (history, redirect) {
        if (history && history.length > 2) {
            history.goBack();
        }
        else {
            if (!redirect) {
                redirect = "/";
            }
            location.href = redirect;
        }
    },
    go: function (history, url) {
        if (!url)
            url = "/#dashboard";
        if (history) {
            console.log("Utils.go History Push:" + url);
            history.push(url);
        }
        else {
            console.log("Utils.go Location Href:" + url);
            location.href = url;
        }
    },
    redirect: function (url) {
        location.href = url;
        location.reload();
    },
    urlContains: function (key) {
        const url = window.location.hash;
        return url.indexOf(key) !== -1;
    },
    required: function () {
        return React.createElement("span", { title: t("Required field") }, " (*)");
    },
    lastUpdated: function () {
        const time = new Date().toLocaleString();
        return React.createElement("span", null, "Last update:" + time);
    },
    machineType: function (type) {
        switch (type) {
            case 1: return t("Physical");
            case 2: return t("Virtual");
        }
        return "Unknown";
    },
    environment: function (env) {
        switch (env) {
            case 1: return "Dev";
            case 2: return "Prod";
            case 3: return "Demo";
            case 4: return "Sta";
            case 5: return "QA";
        }
        return "";
    },
    width: function () {
        return window.innerWidth
            || document.documentElement.clientWidth
            || document.body.clientWidth;
    },
    height: function () {
        return window.innerHeight
            || document.documentElement.clientHeight
            || document.body.clientHeight;
    },
    hash: function () {
        var hash = 0, i, chr;
        if (this.length === 0)
            return hash;
        for (i = 0; i < this.length; i++) {
            chr = this.charCodeAt(i);
            hash = ((hash << 5) - hash) + chr;
            hash |= 0;
        }
        return hash;
    },
    alertColor: function (type) {
        switch (type) {
            case 1: return Colors.gray;
            case 2: return Colors.yellow;
            case 3: return Colors.orange;
            case 4: return Colors.red;
        }
        return Colors.text;
    },
    statusColor: function (type) {
        switch (type) {
            case 1: return Colors.gray;
            case 2: return Colors.yellow;
            case 3: return Colors.orange;
            case 4: return Colors.red;
        }
        return Colors.text;
    },
    alertColor2: function (type) {
        switch (type) {
            case 0: return Colors.green;
            case 1: return Colors.gray;
            case 2: return Colors.yellow;
            case 3: return Colors.orange;
            case 4: return Colors.red;
        }
        return Colors.text;
    },
    alertColor3: function (type) {
        switch (type) {
            case 0: return "rgba(0, 255, 89, 0.7)";
            case 1: return "rgba(120, 120, 120, 0.7)";
            case 2: return "rgba(225, 230, 0, 0.7)";
            case 3: return "rgba(255, 204, 77, 0.7)";
            case 4: return "rgba(255, 0, 0, 0.6)";
        }
        return "rgba(0, 0, 0, 0.2)";
    },
    alertTypeName: function (type) {
        switch (type) {
            case 1: return "INFO";
            case 2: return "WARNING";
            case 3: return "CRITICAL";
            case 4: return "FATAL";
        }
        return "UNKNOWN";
    },
    thresholdColor: function (percentage, info, warning, critical, fatal) {
        if (percentage > fatal)
            return Colors.red;
        if (percentage > critical)
            return Colors.orange;
        if (percentage > warning)
            return Colors.yellow;
        if (percentage > info)
            return Colors.gray;
        return Colors.green;
    },
    isEmpty: function (object) {
        for (var i in object) {
            return false;
        }
        return true;
    }
};
const VCenterAlarms = (props) => {
    const fn = { closed: useRef(false) };
    const hostID = props.hostid;
    const [divDetails, setDivDetails] = useState(null);
    const [refreshing, setRefreshing] = useState(true);
    const timeoutID = "vcenter_alarms_" + hostID;
    function cleanUp() {
        fn.closed.current = true;
        Timeouts.clearAll(timeoutID);
    }
    useEffect(() => { fn.closed.current = false; loadData(); return cleanUp; }, [hostID]);
    function loadData() {
        if (fn.closed.current)
            return;
        Timeouts.clearAll(timeoutID);
        Utils.setState(fn, setRefreshing, true);
        let pdo = Utils.postDataOptions({ hostid: hostID, op: "alarms" });
        fetch(apiURL + "vcenter", pdo).then(res => res.json()).then((result) => {
            Utils.setState(fn, setDivDetails, parse(result));
        }, (error) => {
            Utils.setState(fn, setDivDetails, Utils.error(error.message));
        }).then(() => {
            if (fn.closed.current)
                return;
            Timeouts.add(timeoutID, setTimeout(loadData, 10000));
            setTimeout(() => Utils.setState(fn, setRefreshing, false), 1000);
        });
    }
    ;
    function parse(json) {
        if (fn.closed.current)
            return;
        if (!json.success) {
            return Utils.error(json.error);
        }
        const data = {
            defaultSortField: "nm",
            id: "st",
            headers: [
                { name: "#", number: true },
                { name: "Key", field: "key" },
                { name: "Name", field: "nm", filter: {} },
                { name: "State", field: "sts", format: Utils.VCStatus },
                { name: "Time", field: "tm", format: Utils.toDate, width: "160px" },
                { name: "Source T.", field: "srct" },
                { name: "Source", field: "src" },
                { name: "Description", field: "dsc" },
                { name: "Disabled", field: "dsb" },
                { name: "Acknowledged", field: "ack" },
                { name: "Action", field: "act" }
            ],
            rows: json.alarms
        };
        return React.createElement(Table, { data: data });
    }
    return (React.createElement("div", { id: 'panel_vcenter_alarms' }, divDetails));
};
const VCenterDatastores = (props) => {
    const fn = { closed: useRef(false) };
    const hostID = props.hostid;
    const [divDetails, setDivDetails] = useState(null);
    const [refreshing, setRefreshing] = useState(true);
    const timeoutID = "vcenter_datastores_" + hostID;
    function cleanUp() {
        fn.closed.current = true;
        Timeouts.clearAll(timeoutID);
    }
    useEffect(() => { fn.closed.current = false; loadData(); return cleanUp; }, [hostID]);
    function loadData() {
        if (fn.closed.current)
            return;
        Timeouts.clearAll(timeoutID);
        Utils.setState(fn, setRefreshing, true);
        let pdo = Utils.postDataOptions({ hostid: hostID, op: "datastores" });
        fetch(apiURL + "vcenter", pdo).then(res => res.json()).then((result) => {
            Utils.setState(fn, setDivDetails, parse(result));
        }, (error) => {
            Utils.setState(fn, setDivDetails, Utils.error(error.message));
        }).then(() => {
            if (fn.closed.current)
                return;
            Timeouts.add(timeoutID, setTimeout(loadData, 10000));
            setTimeout(() => Utils.setState(fn, setRefreshing, false), 1000);
        });
    }
    ;
    function parse(json) {
        if (fn.closed.current)
            return;
        if (!json.success) {
            return Utils.error(json.error);
        }
        const data = {
            defaultSortField: "nm",
            id: "vcenterdatastores",
            headers: [
                { name: "Name", field: "nm", filter: {} },
                { name: "Capacity", field: "cp", format: Utils.bytesToUnit },
                { name: "Free", field: "fs", format: Utils.bytesToUnit },
                { name: "Uncommitted", field: "uc", format: Utils.bytesToUnit },
                { name: "Type", field: "t" }
            ],
            rows: json.datastores
        };
        return React.createElement(Table, { data: data });
    }
    return (React.createElement("div", { id: 'panel_vcenter_datastores' }, divDetails));
};
const VCenterEmailEvents = (props) => {
    const fn = { closed: useRef(false) };
    const hostID = props.hostid;
    const [divDetails, setDivDetails] = useState(null);
    const [refreshing, setRefreshing] = useState(true);
    const timeoutID = "vcenter_mail_events_" + hostID;
    function cleanUp() {
        fn.closed.current = true;
        Timeouts.clearAll(timeoutID);
    }
    useEffect(() => { fn.closed.current = false; loadData(); return cleanUp; }, [hostID]);
    function loadData() {
        if (fn.closed.current)
            return;
        Timeouts.clearAll(timeoutID);
        Utils.setState(fn, setRefreshing, true);
        let pdo = Utils.postDataOptions({ hostid: hostID, op: "mailevents" });
        fetch(apiURL + "vcenter", pdo).then(res => res.json()).then((result) => {
            Utils.setState(fn, setDivDetails, parse(result));
        }, (error) => {
            Utils.setState(fn, setDivDetails, Utils.error(error.message));
        }).then(() => {
            if (fn.closed.current)
                return;
            Timeouts.add(timeoutID, setTimeout(loadData, 10000));
            setTimeout(() => Utils.setState(fn, setRefreshing, false), 1000);
        });
    }
    ;
    function parse(json) {
        if (fn.closed.current)
            return;
        if (!json.success) {
            return Utils.error(json.error);
        }
        const data = {
            defaultSortField: "nm",
            id: "st",
            headers: [
                { name: "Key", field: "key", noCrop: true },
                { name: "Time", field: "tm", format: Utils.toDate, width: "160px" },
                { name: "To", field: "to" },
                { name: "Message", field: "msg", noCrop: true },
                { name: "Source", field: "src" },
            ],
            rows: json.mails
        };
        return React.createElement(Table, { data: data });
    }
    return (React.createElement("div", { id: 'panel_vcenter_mail_events' }, divDetails));
};
const VCenterHosts = (props) => {
    const fn = { closed: useRef(false) };
    const hostID = props.hostid;
    const [divDetails, setDivDetails] = useState(null);
    const [refreshing, setRefreshing] = useState(true);
    const timeoutID = "vcenter_hosts_" + hostID;
    function cleanUp() {
        fn.closed.current = true;
        Timeouts.clearAll(timeoutID);
    }
    useEffect(() => { fn.closed.current = false; loadData(); return cleanUp; }, [hostID]);
    function loadData() {
        if (fn.closed.current)
            return;
        Timeouts.clearAll(timeoutID);
        Utils.setState(fn, setRefreshing, true);
        let pdo = Utils.postDataOptions({ hostid: hostID, op: "hosts" });
        fetch(apiURL + "vcenter", pdo).then(res => res.json()).then((result) => {
            Utils.setState(fn, setDivDetails, parse(result));
        }, (error) => {
            Utils.setState(fn, setDivDetails, Utils.error(error.message));
        }).then(() => {
            if (fn.closed.current)
                return;
            Timeouts.add(timeoutID, setTimeout(loadData, 10000));
            setTimeout(() => Utils.setState(fn, setRefreshing, false), 1000);
        });
    }
    ;
    function parse(json) {
        if (fn.closed.current)
            return;
        if (!json.success) {
            return Utils.error(json.error);
        }
        const data = {
            defaultSortField: "nm",
            id: "st",
            headers: [
                { name: "#", number: true },
                { name: "Key", field: "key" },
                { name: "Name", field: "nm", filter: {} },
                { name: "State", field: "st", format: Utils.VCStatus },
                { name: "Connection", field: "cs", colorFunction: Utils.VCConnectionColor },
                { name: "Uptime", field: "up", format: Utils.timePast },
                { name: "CPU", field: "cp" },
                { name: "Mem", field: "mp" },
                { name: "Memory", field: "mt", format: Utils.bytesToUnit },
                { name: "Cores", field: "cr" },
                { name: "MM", field: "mm" }
            ],
            rows: json.hosts
        };
        return React.createElement(Table, { data: data });
    }
    return (React.createElement("div", { id: 'panel_vcenter_hosts' }, divDetails));
};
const VCenterPage = (props) => {
    const fn = { closed: useRef(false) };
    const hostID = props.match.params.hostid;
    function back(e) {
        e.preventDefault();
        cleanUp();
        Utils.goBack(props.history, "#host/" + hostID);
    }
    function cleanUp() {
        fn.closed.current = true;
    }
    return (React.createElement("div", { id: "page" },
        React.createElement(Header, { back: back, title: t("VMware vCenter") }),
        React.createElement(Tabs, { default: null, id: "tabs_vcenter", key: 'tabs_vcenter_' + hostID },
            React.createElement(Tab, { key: 'system', name: 'system', label: 'System' },
                "   ",
                React.createElement(VCenterSystem, { hostid: hostID }),
                "     "),
            React.createElement(Tab, { key: 'hosts', name: 'hosts', label: 'Hosts' },
                "   ",
                React.createElement(VCenterHosts, { hostid: hostID }),
                "     "),
            React.createElement(Tab, { key: 'vms', name: 'vms', label: 'VMs' },
                "   ",
                React.createElement(VCenterHostVirtualMachines, { hostid: hostID }),
                "     "),
            React.createElement(Tab, { key: 'datastores', name: 'datastores', label: 'Datastores' },
                "   ",
                React.createElement(VCenterDatastores, { hostid: hostID }),
                "     "),
            React.createElement(Tab, { key: 'events', name: 'events', label: 'Events' },
                "   ",
                React.createElement(VCenterEvents, { hostid: hostID }),
                "     "),
            React.createElement(Tab, { key: 'alarms', name: 'alarms', label: 'Alarms' },
                "   ",
                React.createElement(VCenterAlarms, { hostid: hostID }),
                "     "),
            React.createElement(Tab, { key: 'mails', name: 'mails', label: 'Mails' },
                "   ",
                React.createElement(VCenterEmailEvents, { hostid: hostID }),
                "     "))));
};
const VCenterSystem = (props) => {
    const fn = { closed: useRef(false) };
    const hostID = props.hostid;
    const [divDetails, setDivDetails] = useState(null);
    const [refreshing, setRefreshing] = useState(true);
    const timeoutID = "vcenter_" + hostID;
    function cleanUp() {
        fn.closed.current = true;
        Timeouts.clearAll(timeoutID);
    }
    useEffect(() => { fn.closed.current = false; loadData(); return cleanUp; }, [hostID]);
    function loadData() {
        if (fn.closed.current)
            return;
        Timeouts.clearAll(timeoutID);
        Utils.setState(fn, setRefreshing, true);
        let pdo = Utils.postDataOptions({ hostid: hostID, op: "info" });
        fetch(apiURL + "vcenter", pdo).then(res => res.json()).then((result) => {
            Utils.setState(fn, setDivDetails, parse(result));
        }, (error) => {
            Utils.setState(fn, setDivDetails, Utils.error(error.message));
        }).then(() => {
            if (fn.closed.current)
                return;
            Timeouts.add(timeoutID, setTimeout(loadData, 10000));
            setTimeout(() => Utils.setState(fn, setRefreshing, false), 1000);
        });
    }
    ;
    function parse(json) {
        if (fn.closed.current)
            return;
        if (!json.success) {
            return Utils.error(json.error);
        }
        return React.createElement("table", null,
            React.createElement("tr", null,
                React.createElement("td", null, "Name"),
                "  ",
                React.createElement("td", null,
                    " ",
                    json.fullname,
                    "  "),
                " "),
            React.createElement("tr", null,
                React.createElement("td", null, "Host count"),
                " ",
                React.createElement("td", null, json.hostcount),
                "  "));
    }
    return (React.createElement("div", { id: 'panel_vcenter_system' }, divDetails));
};
const VCenterEvents = (props) => {
    const fn = { closed: useRef(false) };
    const hostID = props.hostid;
    const [divDetails, setDivDetails] = useState(null);
    const [refreshing, setRefreshing] = useState(true);
    const timeoutID = "vcenter_events_" + hostID;
    function cleanUp() {
        fn.closed.current = true;
        Timeouts.clearAll(timeoutID);
    }
    useEffect(() => { fn.closed.current = false; loadData(); return cleanUp; }, [hostID]);
    function loadData() {
        if (fn.closed.current)
            return;
        Timeouts.clearAll(timeoutID);
        Utils.setState(fn, setRefreshing, true);
        let pdo = Utils.postDataOptions({ hostid: hostID, op: "events" });
        fetch(apiURL + "vcenter", pdo).then(res => res.json()).then((result) => {
            Utils.setState(fn, setDivDetails, parse(result));
        }, (error) => {
            Utils.setState(fn, setDivDetails, Utils.error(error.message));
        }).then(() => {
            if (fn.closed.current)
                return;
            Timeouts.add(timeoutID, setTimeout(loadData, 10000));
            setTimeout(() => Utils.setState(fn, setRefreshing, false), 1000);
        });
    }
    ;
    function parse(json) {
        if (fn.closed.current)
            return;
        if (!json.success) {
            return Utils.error(json.error);
        }
        const data = {
            defaultSortField: "nm",
            id: "st",
            headers: [
                { name: "Key", field: "key", noCrop: true },
                { name: "Type", field: "et" },
                { name: "Time", field: "tm", format: Utils.toDate, width: "160px" },
                { name: "Message", field: "msg", noCrop: true },
                { name: "Source", field: "src" },
            ],
            rows: json.events
        };
        return React.createElement(Table, { data: data });
    }
    return (React.createElement("div", { id: 'panel_vcenter_events' }, divDetails));
};
const VCenterHostVirtualMachines = (props) => {
    const fn = { closed: useRef(false) };
    const hostID = props.hostid;
    const [divHosts, setDivHosts] = useState("Hosts");
    const [divVMs, setDivVMs] = useState("VMS");
    function cleanUp() {
        fn.closed.current = true;
    }
    useEffect(() => { fn.closed.current = false; loadHosts(); return cleanUp; }, [hostID]);
    function loadHosts() {
        if (fn.closed.current)
            return;
        let pdo = Utils.postDataOptions({ hostid: hostID, op: "hosts" });
        fetch(apiURL + "vcenter", pdo).then(res => res.json()).then((result) => {
            Utils.setState(fn, setDivHosts, parseHosts(result));
        }, (error) => {
            Utils.setState(fn, setDivHosts, Utils.error(error.message));
        });
    }
    ;
    function parseHosts(json) {
        if (fn.closed.current)
            return;
        if (!json.success) {
            return Utils.error(json.error);
        }
        const data = {
            defaultSortField: "nm",
            id: "vchosts",
            headers: [
                { name: "Name", field: "nm", filter: {}, onClick: onHostClick }
            ],
            rows: json.hosts
        };
        return React.createElement(Table, { data: data });
    }
    function onHostClick(host) {
        if (fn.closed.current)
            return;
        loadVMs(host.key);
    }
    function loadVMs(key) {
        if (fn.closed.current)
            return;
        let pdo = Utils.postDataOptions({ hostid: hostID, op: "vms", key: key });
        fetch(apiURL + "vcenter", pdo).then(res => res.json()).then((result) => {
            Utils.setState(fn, setDivVMs, parseVMs(result));
        }, (error) => {
            Utils.setState(fn, setDivVMs, Utils.error(error.message));
        });
    }
    ;
    function parseVMs(json) {
        if (fn.closed.current)
            return;
        if (!json.success) {
            return Utils.error(json.error);
        }
        const data = {
            defaultSortField: "nm",
            id: "vcvms",
            headers: [
                { name: "Name", field: "nm", filter: {} },
                { name: "Config", field: "cfs", format: Utils.VCStatus },
                { name: "Power", field: "pws", format: Utils.VCPower },
                { name: "Status", field: "ost", format: Utils.VCStatus },
                { name: "Connection", field: "cns", colorFunction: Utils.VCConnectionColor },
                { name: "Uptime", field: "up", format: Utils.timePast },
                { name: "Guest", field: "gfn" },
                { name: "G.Heartbeat", field: "ghs", format: Utils.VCStatus },
                { name: "G.Status", field: "gs", colorFunction: Utils.VCConnectionColor },
                { name: "G.Host", field: "ghn" },
                { name: "G.Ip", field: "gip" },
                { name: "Cores", field: "ncp" },
                { name: "Memory", field: "mem", format: (val) => Utils.bytesToUnit(val * 1024) },
                { name: "H.Mem.Usage", field: "hmu", format: (val) => Utils.bytesToUnit(val * 1024) },
                { name: "Shared", field: "hmu", format: (val) => Utils.bytesToUnit(val * 1024) },
                { name: "CPU", field: "ocu" },
                { name: "Storage", field: "stc", format: Utils.bytesToUnit },
            ],
            rows: json.vms
        };
        return React.createElement(Table, { data: data });
    }
    return (React.createElement("div", { id: 'panel_vcenter_host_vms', style: { height: "700px", width: "100%" } },
        React.createElement("div", { style: { float: "left", width: "200px", marginRight: "10px", height: "600px", overflowY: "auto", overflowX: "hidden" } }, divHosts),
        React.createElement("div", { style: { float: "left", width: "calc(100% - 220px)" } }, divVMs)));
};
ReactDOM.render(React.createElement(App, null), document.querySelector('#root'));
ContextMenu.init();
//# sourceMappingURL=App.js.map